import { jsx as E, jsxs as ue, Fragment as Ua } from "react/jsx-runtime";
import * as L from "react";
import ae, { useContext as Ve, createContext as tn, Component as f1, useCallback as pe, useState as ie, useRef as Ce, useReducer as Nv, useMemo as Lt, useEffect as le, useLayoutEffect as ri, memo as vs, forwardRef as fr, createElement as ee, Fragment as ms, createRef as vn } from "react";
import * as kv from "react-dom";
import ws, { createPortal as Bv } from "react-dom";
var lu = function(e, t) {
  return lu = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var a in r)
      Object.prototype.hasOwnProperty.call(r, a) && (n[a] = r[a]);
  }, lu(e, t);
};
function Bt(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  lu(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var oe = function() {
  return oe = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, oe.apply(this, arguments);
};
function Ov(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function Ie(e, t, n, r) {
  function a(i) {
    return i instanceof n ? i : new n(function(o) {
      o(i);
    });
  }
  return new (n || (n = Promise))(function(i, o) {
    function f(c) {
      try {
        u(r.next(c));
      } catch (d) {
        o(d);
      }
    }
    function s(c) {
      try {
        u(r.throw(c));
      } catch (d) {
        o(d);
      }
    }
    function u(c) {
      c.done ? i(c.value) : a(c.value).then(f, s);
    }
    u((r = r.apply(e, t || [])).next());
  });
}
function Se(e, t) {
  var n = { label: 0, sent: function() {
    if (i[0] & 1)
      throw i[1];
    return i[1];
  }, trys: [], ops: [] }, r, a, i, o;
  return o = { next: f(0), throw: f(1), return: f(2) }, typeof Symbol == "function" && (o[Symbol.iterator] = function() {
    return this;
  }), o;
  function f(u) {
    return function(c) {
      return s([u, c]);
    };
  }
  function s(u) {
    if (r)
      throw new TypeError("Generator is already executing.");
    for (; o && (o = 0, u[0] && (n = 0)), n; )
      try {
        if (r = 1, a && (i = u[0] & 2 ? a.return : u[0] ? a.throw || ((i = a.return) && i.call(a), 0) : a.next) && !(i = i.call(a, u[1])).done)
          return i;
        switch (a = 0, i && (u = [u[0] & 2, i.value]), u[0]) {
          case 0:
          case 1:
            i = u;
            break;
          case 4:
            return n.label++, { value: u[1], done: !1 };
          case 5:
            n.label++, a = u[1], u = [0];
            continue;
          case 7:
            u = n.ops.pop(), n.trys.pop();
            continue;
          default:
            if (i = n.trys, !(i = i.length > 0 && i[i.length - 1]) && (u[0] === 6 || u[0] === 2)) {
              n = 0;
              continue;
            }
            if (u[0] === 3 && (!i || u[1] > i[0] && u[1] < i[3])) {
              n.label = u[1];
              break;
            }
            if (u[0] === 6 && n.label < i[1]) {
              n.label = i[1], i = u;
              break;
            }
            if (i && n.label < i[2]) {
              n.label = i[2], n.ops.push(u);
              break;
            }
            i[2] && n.ops.pop(), n.trys.pop();
            continue;
        }
        u = t.call(e, n);
      } catch (c) {
        u = [6, c], a = 0;
      } finally {
        r = i = 0;
      }
    if (u[0] & 5)
      throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function ct(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function du(e, t, n) {
  t.split && (t = t.split("."));
  for (var r = 0, a = t.length, i = e, o, f; r < a && (f = t[r++], !(f === "__proto__" || f === "constructor" || f === "prototype")); )
    i = i[f] = r === a ? n : typeof (o = i[f]) == typeof t ? o : t[r] * 0 !== 0 || ~("" + t[r]).indexOf(".") ? {} : [];
}
var Pv = function(e, t) {
  return Object.keys(e).filter(function(n) {
    return t(n, e[n]);
  }).reduce(function(n, r) {
    return n[r] = e[r], n;
  }, {});
}, er = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r) {
      var a = e.call(this, "".concat(n, " ").concat(r)) || this;
      return a.field = n, a;
    }
    return t;
  }(Error)
);
function ur(e) {
  return typeof e == "string";
}
function gu(e) {
  return typeof e == "number";
}
function Tr(e) {
  return typeof e == "function";
}
function zv(e) {
  return e != null;
}
function Ut(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase() === "object";
}
var ys = "is not a string", bs = "is not an object", Rv = "is nil";
function Fv(e) {
  if (!zv(e))
    throw new er("Event", Rv);
  if (typeof e != "object")
    throw new er("Event", bs);
}
function Uv(e) {
  if (!ur(e.type))
    throw new er(".type", ys);
}
function Yv(e) {
  if (!ur(e.event))
    throw new er(".event", ys);
}
function Gv(e) {
  if (!Ut(e.properties))
    throw new er(".properties", bs);
}
function Hv(e) {
  if (!Ut(e.traits))
    throw new er(".traits", bs);
}
function Qv(e) {
  if (!ur(e.messageId))
    throw new er(".messageId", ys);
}
function Jv(e) {
  Fv(e), Uv(e), Qv(e), e.type === "track" && (Yv(e), Gv(e)), ["group", "identify"].includes(e.type) && Hv(e);
}
var Wv = (
  /** @class */
  function() {
    function e(t) {
      var n, r;
      this.settings = t, this.createMessageId = t.createMessageId, this.onEventMethodCall = (n = t.onEventMethodCall) !== null && n !== void 0 ? n : function() {
      }, this.onFinishedEvent = (r = t.onFinishedEvent) !== null && r !== void 0 ? r : function() {
      };
    }
    return e;
  }()
), _v = (
  /** @class */
  function() {
    function e(t) {
      this.settings = new Wv(t);
    }
    return e.prototype.track = function(t, n, r, a) {
      return this.settings.onEventMethodCall({ type: "track", options: r }), this.normalize(oe(oe({}, this.baseEvent()), { event: t, type: "track", properties: n ?? {}, options: oe({}, r), integrations: oe({}, a) }));
    }, e.prototype.page = function(t, n, r, a, i) {
      var o;
      this.settings.onEventMethodCall({ type: "page", options: a });
      var f = {
        type: "page",
        properties: oe({}, r),
        options: oe({}, a),
        integrations: oe({}, i)
      };
      return t !== null && (f.category = t, f.properties = (o = f.properties) !== null && o !== void 0 ? o : {}, f.properties.category = t), n !== null && (f.name = n), this.normalize(oe(oe({}, this.baseEvent()), f));
    }, e.prototype.screen = function(t, n, r, a, i) {
      this.settings.onEventMethodCall({ type: "screen", options: a });
      var o = {
        type: "screen",
        properties: oe({}, r),
        options: oe({}, a),
        integrations: oe({}, i)
      };
      return t !== null && (o.category = t), n !== null && (o.name = n), this.normalize(oe(oe({}, this.baseEvent()), o));
    }, e.prototype.identify = function(t, n, r, a) {
      return this.settings.onEventMethodCall({ type: "identify", options: r }), this.normalize(oe(oe({}, this.baseEvent()), { type: "identify", userId: t, traits: n ?? {}, options: oe({}, r), integrations: a }));
    }, e.prototype.group = function(t, n, r, a) {
      return this.settings.onEventMethodCall({ type: "group", options: r }), this.normalize(oe(oe({}, this.baseEvent()), {
        type: "group",
        traits: n ?? {},
        options: oe({}, r),
        integrations: oe({}, a),
        //
        groupId: t
      }));
    }, e.prototype.alias = function(t, n, r, a) {
      this.settings.onEventMethodCall({ type: "alias", options: r });
      var i = {
        userId: t,
        type: "alias",
        options: oe({}, r),
        integrations: oe({}, a)
      };
      return n !== null && (i.previousId = n), t === void 0 ? this.normalize(oe(oe({}, i), this.baseEvent())) : this.normalize(oe(oe({}, this.baseEvent()), i));
    }, e.prototype.baseEvent = function() {
      return {
        integrations: {},
        options: {}
      };
    }, e.prototype.context = function(t) {
      var n, r = [
        "userId",
        "anonymousId",
        "timestamp",
        "messageId"
      ];
      delete t.integrations;
      var a = Object.keys(t), i = (n = t.context) !== null && n !== void 0 ? n : {}, o = {};
      return a.forEach(function(f) {
        f !== "context" && (r.includes(f) ? du(o, f, t[f]) : du(i, f, t[f]));
      }), [i, o];
    }, e.prototype.normalize = function(t) {
      var n, r, a = Object.keys((n = t.integrations) !== null && n !== void 0 ? n : {}).reduce(function(g, p) {
        var h, l;
        return oe(oe({}, g), (h = {}, h[p] = !!(!((l = t.integrations) === null || l === void 0) && l[p]), h));
      }, {});
      t.options = Pv(t.options || {}, function(g, p) {
        return p !== void 0;
      });
      var i = oe(oe({}, a), (r = t.options) === null || r === void 0 ? void 0 : r.integrations), o = t.options ? this.context(t.options) : [], f = o[0], s = o[1], u = t.options, c = Ov(t, ["options"]), d = oe(oe(oe(oe({ timestamp: /* @__PURE__ */ new Date() }, c), { context: f, integrations: i }), s), { messageId: u.messageId || this.settings.createMessageId() });
      return this.settings.onFinishedEvent(d), Jv(d), d;
    }, e;
  }()
);
function Zv(e, t) {
  return new Promise(function(n, r) {
    var a = setTimeout(function() {
      r(Error("Promise timed out"));
    }, t);
    e.then(function(i) {
      return clearTimeout(a), n(i);
    }).catch(r);
  });
}
function $v(e) {
  return new Promise(function(t) {
    return setTimeout(t, e);
  });
}
function Vv(e, t, n) {
  var r = function() {
    try {
      return Promise.resolve(t(e));
    } catch (a) {
      return Promise.reject(a);
    }
  };
  return $v(n).then(function() {
    return Zv(r(), 1e3);
  }).catch(function(a) {
    e == null || e.log("warn", "Callback Error", { error: a }), e == null || e.stats.increment("callback_error");
  }).then(function() {
    return e;
  });
}
var To = (
  /** @class */
  function() {
    function e(t) {
      var n;
      this.callbacks = {}, this.warned = !1, this.maxListeners = (n = t == null ? void 0 : t.maxListeners) !== null && n !== void 0 ? n : 10;
    }
    return e.prototype.warnIfPossibleMemoryLeak = function(t) {
      this.warned || this.maxListeners && this.callbacks[t].length > this.maxListeners && (console.warn("Event Emitter: Possible memory leak detected; ".concat(String(t), " has exceeded ").concat(this.maxListeners, " listeners.")), this.warned = !0);
    }, e.prototype.on = function(t, n) {
      return this.callbacks[t] ? (this.callbacks[t].push(n), this.warnIfPossibleMemoryLeak(t)) : this.callbacks[t] = [n], this;
    }, e.prototype.once = function(t, n) {
      var r = this, a = function() {
        for (var i = [], o = 0; o < arguments.length; o++)
          i[o] = arguments[o];
        r.off(t, a), n.apply(r, i);
      };
      return this.on(t, a), this;
    }, e.prototype.off = function(t, n) {
      var r, a = (r = this.callbacks[t]) !== null && r !== void 0 ? r : [], i = a.filter(function(o) {
        return o !== n;
      });
      return this.callbacks[t] = i, this;
    }, e.prototype.emit = function(t) {
      for (var n = this, r, a = [], i = 1; i < arguments.length; i++)
        a[i - 1] = arguments[i];
      var o = (r = this.callbacks[t]) !== null && r !== void 0 ? r : [];
      return o.forEach(function(f) {
        f.apply(n, a);
      }), this;
    }, e;
  }()
);
function u1(e) {
  var t = Math.random() + 1, n = e.minTimeout, r = n === void 0 ? 500 : n, a = e.factor, i = a === void 0 ? 2 : a, o = e.attempt, f = e.maxTimeout, s = f === void 0 ? 1 / 0 : f;
  return Math.min(t * r * Math.pow(i, o), s);
}
var s1 = "onRemoveFromFuture", c1 = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r, a) {
      var i = e.call(this) || this;
      return i.future = [], i.maxAttempts = n, i.queue = r, i.seen = a ?? {}, i;
    }
    return t.prototype.push = function() {
      for (var n = this, r = [], a = 0; a < arguments.length; a++)
        r[a] = arguments[a];
      var i = r.map(function(o) {
        var f = n.updateAttempts(o);
        return f > n.maxAttempts || n.includes(o) ? !1 : (n.queue.push(o), !0);
      });
      return this.queue = this.queue.sort(function(o, f) {
        return n.getAttempts(o) - n.getAttempts(f);
      }), i;
    }, t.prototype.pushWithBackoff = function(n) {
      var r = this;
      if (this.getAttempts(n) === 0)
        return this.push(n)[0];
      var a = this.updateAttempts(n);
      if (a > this.maxAttempts || this.includes(n))
        return !1;
      var i = u1({ attempt: a - 1 });
      return setTimeout(function() {
        r.queue.push(n), r.future = r.future.filter(function(o) {
          return o.id !== n.id;
        }), r.emit(s1);
      }, i), this.future.push(n), !0;
    }, t.prototype.getAttempts = function(n) {
      var r;
      return (r = this.seen[n.id]) !== null && r !== void 0 ? r : 0;
    }, t.prototype.updateAttempts = function(n) {
      return this.seen[n.id] = this.getAttempts(n) + 1, this.getAttempts(n);
    }, t.prototype.includes = function(n) {
      return this.queue.includes(n) || this.future.includes(n) || !!this.queue.find(function(r) {
        return r.id === n.id;
      }) || !!this.future.find(function(r) {
        return r.id === n.id;
      });
    }, t.prototype.pop = function() {
      return this.queue.shift();
    }, Object.defineProperty(t.prototype, "length", {
      get: function() {
        return this.queue.length;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "todo", {
      get: function() {
        return this.queue.length + this.future.length;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(To)
), Wn = 256, Wi = [], Ci;
for (; Wn--; )
  Wi[Wn] = (Wn + 256).toString(16).substring(1);
function Cs() {
  var e = 0, t, n = "";
  if (!Ci || Wn + 16 > 256) {
    for (Ci = Array(e = 256); e--; )
      Ci[e] = 256 * Math.random() | 0;
    e = Wn = 0;
  }
  for (; e < 16; e++)
    t = Ci[Wn + e], e == 6 ? n += Wi[t & 15 | 64] : e == 8 ? n += Wi[t & 63 | 128] : n += Wi[t], e & 1 && e > 1 && e < 11 && (n += "-");
  return Wn++, n;
}
var Kv = (
  /** @class */
  function() {
    function e() {
      this._logs = [];
    }
    return e.prototype.log = function(t, n, r) {
      var a = /* @__PURE__ */ new Date();
      this._logs.push({
        level: t,
        message: n,
        time: a,
        extras: r
      });
    }, Object.defineProperty(e.prototype, "logs", {
      get: function() {
        return this._logs;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.flush = function() {
      if (this.logs.length > 1) {
        var t = this._logs.reduce(function(n, r) {
          var a, i, o, f = oe(oe({}, r), { json: JSON.stringify(r.extras, null, " "), extras: r.extras });
          delete f.time;
          var s = (o = (i = r.time) === null || i === void 0 ? void 0 : i.toISOString()) !== null && o !== void 0 ? o : "";
          return n[s] && (s = "".concat(s, "-").concat(Math.random())), oe(oe({}, n), (a = {}, a[s] = f, a));
        }, {});
        console.table ? console.table(t) : console.log(t);
      } else
        this.logs.forEach(function(n) {
          var r = n.level, a = n.message, i = n.extras;
          r === "info" || r === "debug" ? console.log(a, i ?? "") : console[r](a, i ?? "");
        });
      this._logs = [];
    }, e;
  }()
), qv = function(e) {
  var t = {
    gauge: "g",
    counter: "c"
  };
  return t[e];
}, l1 = (
  /** @class */
  function() {
    function e() {
      this.metrics = [];
    }
    return e.prototype.increment = function(t, n, r) {
      n === void 0 && (n = 1), this.metrics.push({
        metric: t,
        value: n,
        tags: r ?? [],
        type: "counter",
        timestamp: Date.now()
      });
    }, e.prototype.gauge = function(t, n, r) {
      this.metrics.push({
        metric: t,
        value: n,
        tags: r ?? [],
        type: "gauge",
        timestamp: Date.now()
      });
    }, e.prototype.flush = function() {
      var t = this.metrics.map(function(n) {
        return oe(oe({}, n), { tags: n.tags.join(",") });
      });
      console.table ? console.table(t) : console.log(t), this.metrics = [];
    }, e.prototype.serialize = function() {
      return this.metrics.map(function(t) {
        return {
          m: t.metric,
          v: t.value,
          t: t.tags,
          k: qv(t.type),
          e: t.timestamp
        };
      });
    }, e;
  }()
), Xv = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.gauge = function() {
    }, t.prototype.increment = function() {
    }, t.prototype.flush = function() {
    }, t.prototype.serialize = function() {
      return [];
    }, t;
  }(l1)
), Hr = (
  /** @class */
  function() {
    function e(t) {
      var n, r, a;
      this.retry = (n = t.retry) !== null && n !== void 0 ? n : !0, this.type = (r = t.type) !== null && r !== void 0 ? r : "plugin Error", this.reason = (a = t.reason) !== null && a !== void 0 ? a : "";
    }
    return e;
  }()
), so = (
  /** @class */
  function() {
    function e(t, n, r, a) {
      n === void 0 && (n = Cs()), r === void 0 && (r = new Xv()), a === void 0 && (a = new Kv()), this.attempts = 0, this.event = t, this._id = n, this.logger = a, this.stats = r;
    }
    return e.system = function() {
    }, e.prototype.isSame = function(t) {
      return t.id === this.id;
    }, e.prototype.cancel = function(t) {
      throw t || new Hr({ reason: "Context Cancel" });
    }, e.prototype.log = function(t, n, r) {
      this.logger.log(t, n, r);
    }, Object.defineProperty(e.prototype, "id", {
      get: function() {
        return this._id;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.updateEvent = function(t, n) {
      var r;
      if (t.split(".")[0] === "integrations") {
        var a = t.split(".")[1];
        if (((r = this.event.integrations) === null || r === void 0 ? void 0 : r[a]) === !1)
          return this.event;
      }
      return du(this.event, t, n), this.event;
    }, e.prototype.failedDelivery = function() {
      return this._failedDelivery;
    }, e.prototype.setFailedDelivery = function(t) {
      this._failedDelivery = t;
    }, e.prototype.logs = function() {
      return this.logger.logs;
    }, e.prototype.flush = function() {
      this.logger.flush(), this.stats.flush();
    }, e.prototype.toJSON = function() {
      return {
        id: this._id,
        event: this.event,
        logs: this.logger.logs,
        metrics: this.stats.metrics
      };
    }, e;
  }()
);
function em(e, t) {
  var n = {};
  return e.forEach(function(r) {
    var a, i = void 0;
    if (typeof t == "string") {
      var o = r[t];
      i = typeof o != "string" ? JSON.stringify(o) : o;
    } else
      t instanceof Function && (i = t(r));
    i !== void 0 && (n[i] = ct(ct([], (a = n[i]) !== null && a !== void 0 ? a : [], !0), [r], !1));
  }), n;
}
var tm = function(e) {
  return typeof e == "object" && e !== null && "then" in e && typeof e.then == "function";
}, nm = function() {
  var e, t, n = 0;
  return {
    done: function() {
      return e;
    },
    run: function(r) {
      var a = r();
      return tm(a) && (++n === 1 && (e = new Promise(function(i) {
        return t = i;
      })), a.finally(function() {
        return --n === 0 && t();
      })), a;
    }
  };
};
function rm(e) {
  return Ie(this, void 0, void 0, function() {
    var t;
    return Se(this, function(n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2, , 3]), [4, e()];
        case 1:
          return [2, n.sent()];
        case 2:
          return t = n.sent(), [2, Promise.reject(t)];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function _i(e, t) {
  e.log("debug", "plugin", { plugin: t.name });
  var n = (/* @__PURE__ */ new Date()).getTime(), r = t[e.event.type];
  if (r === void 0)
    return Promise.resolve(e);
  var a = rm(function() {
    return r.apply(t, [e]);
  }).then(function(i) {
    var o = (/* @__PURE__ */ new Date()).getTime() - n;
    return i.stats.gauge("plugin_time", o, ["plugin:".concat(t.name)]), i;
  }).catch(function(i) {
    if (i instanceof Hr && i.type === "middleware_cancellation")
      throw i;
    return i instanceof Hr ? (e.log("warn", i.type, {
      plugin: t.name,
      error: i
    }), i) : (e.log("error", "plugin Error", {
      plugin: t.name,
      error: i
    }), e.stats.increment("plugin_error", 1, ["plugin:".concat(t.name)]), i);
  });
  return a;
}
function am(e, t) {
  return _i(e, t).then(function(n) {
    if (n instanceof so)
      return n;
    e.log("debug", "Context canceled"), e.stats.increment("context_canceled"), e.cancel(n);
  });
}
var im = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.criticalTasks = nm(), r.plugins = [], r.failedInitializations = [], r.flushing = !1, r.queue = n, r.queue.on(s1, function() {
        r.scheduleFlush(0);
      }), r;
    }
    return t.prototype.register = function(n, r, a) {
      return Ie(this, void 0, void 0, function() {
        var i, o, f = this;
        return Se(this, function(s) {
          switch (s.label) {
            case 0:
              return this.plugins.push(r), i = function(u) {
                f.failedInitializations.push(r.name), f.emit("initialization_failure", r), console.warn(r.name, u), n.log("warn", "Failed to load destination", {
                  plugin: r.name,
                  error: u
                }), f.plugins = f.plugins.filter(function(c) {
                  return c !== r;
                });
              }, r.type === "destination" && r.name !== "Segment.io" ? (r.load(n, a).catch(i), [3, 4]) : [3, 1];
            case 1:
              return s.trys.push([1, 3, , 4]), [4, r.load(n, a)];
            case 2:
              return s.sent(), [3, 4];
            case 3:
              return o = s.sent(), i(o), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.deregister = function(n, r, a) {
      return Ie(this, void 0, void 0, function() {
        var i;
        return Se(this, function(o) {
          switch (o.label) {
            case 0:
              return o.trys.push([0, 3, , 4]), r.unload ? [4, Promise.resolve(r.unload(n, a))] : [3, 2];
            case 1:
              o.sent(), o.label = 2;
            case 2:
              return this.plugins = this.plugins.filter(function(f) {
                return f.name !== r.name;
              }), [3, 4];
            case 3:
              return i = o.sent(), n.log("warn", "Failed to unload destination", {
                plugin: r.name,
                error: i
              }), [3, 4];
            case 4:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.dispatch = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r;
        return Se(this, function(a) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.push(n), r = this.subscribeToDelivery(n), this.scheduleFlush(0), [2, r];
        });
      });
    }, t.prototype.subscribeToDelivery = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r = this;
        return Se(this, function(a) {
          return [2, new Promise(function(i) {
            var o = function(f, s) {
              f.isSame(n) && (r.off("flush", o), i(f));
            };
            r.on("flush", o);
          })];
        });
      });
    }, t.prototype.dispatchSingle = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r = this;
        return Se(this, function(a) {
          return n.log("debug", "Dispatching"), n.stats.increment("message_dispatched"), this.queue.updateAttempts(n), n.attempts = 1, [2, this.deliver(n).catch(function(i) {
            var o = r.enqueuRetry(i, n);
            return o ? r.subscribeToDelivery(n) : (n.setFailedDelivery({ reason: i }), n);
          })];
        });
      });
    }, t.prototype.isEmpty = function() {
      return this.queue.length === 0;
    }, t.prototype.scheduleFlush = function(n) {
      var r = this;
      n === void 0 && (n = 500), !this.flushing && (this.flushing = !0, setTimeout(function() {
        r.flush().then(function() {
          setTimeout(function() {
            r.flushing = !1, r.queue.length && r.scheduleFlush(0);
          }, 0);
        });
      }, n));
    }, t.prototype.deliver = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r, a, i, o;
        return Se(this, function(f) {
          switch (f.label) {
            case 0:
              return [4, this.criticalTasks.done()];
            case 1:
              f.sent(), r = Date.now(), f.label = 2;
            case 2:
              return f.trys.push([2, 4, , 5]), [4, this.flushOne(n)];
            case 3:
              return n = f.sent(), a = Date.now() - r, this.emit("delivery_success", n), n.stats.gauge("delivered", a), n.log("debug", "Delivered", n.event), [2, n];
            case 4:
              throw i = f.sent(), o = i, n.log("error", "Failed to deliver", o), this.emit("delivery_failure", n, o), n.stats.increment("delivery_failed"), i;
            case 5:
              return [
                2
                /*return*/
              ];
          }
        });
      });
    }, t.prototype.enqueuRetry = function(n, r) {
      var a = !(n instanceof Hr) || n.retry;
      return a ? this.queue.pushWithBackoff(r) : !1;
    }, t.prototype.flush = function() {
      return Ie(this, void 0, void 0, function() {
        var n, r, a;
        return Se(this, function(i) {
          switch (i.label) {
            case 0:
              if (this.queue.length === 0)
                return [2, []];
              if (n = this.queue.pop(), !n)
                return [2, []];
              n.attempts = this.queue.getAttempts(n), i.label = 1;
            case 1:
              return i.trys.push([1, 3, , 4]), [4, this.deliver(n)];
            case 2:
              return n = i.sent(), this.emit("flush", n, !0), [3, 4];
            case 3:
              return r = i.sent(), a = this.enqueuRetry(r, n), a || (n.setFailedDelivery({ reason: r }), this.emit("flush", n, !1)), [2, []];
            case 4:
              return [2, [n]];
          }
        });
      });
    }, t.prototype.isReady = function() {
      return !0;
    }, t.prototype.availableExtensions = function(n) {
      var r = this.plugins.filter(function(p) {
        var h, l, w;
        if (p.type !== "destination" && p.name !== "Segment.io")
          return !0;
        var m = void 0;
        return (h = p.alternativeNames) === null || h === void 0 || h.forEach(function(y) {
          n[y] !== void 0 && (m = n[y]);
        }), (w = (l = n[p.name]) !== null && l !== void 0 ? l : m) !== null && w !== void 0 ? w : (p.name === "Segment.io" ? !0 : n.All) !== !1;
      }), a = em(r, "type"), i = a.before, o = i === void 0 ? [] : i, f = a.enrichment, s = f === void 0 ? [] : f, u = a.destination, c = u === void 0 ? [] : u, d = a.after, g = d === void 0 ? [] : d;
      return {
        before: o,
        enrichment: s,
        destinations: c,
        after: g
      };
    }, t.prototype.flushOne = function(n) {
      var r, a;
      return Ie(this, void 0, void 0, function() {
        var i, o, f, s, u, c, h, d, g, p, h, l, w, m, y;
        return Se(this, function(b) {
          switch (b.label) {
            case 0:
              if (!this.isReady())
                throw new Error("Not ready");
              n.attempts > 1 && this.emit("delivery_retry", n), i = this.availableExtensions((r = n.event.integrations) !== null && r !== void 0 ? r : {}), o = i.before, f = i.enrichment, s = 0, u = o, b.label = 1;
            case 1:
              return s < u.length ? (c = u[s], [4, am(n, c)]) : [3, 4];
            case 2:
              h = b.sent(), h instanceof so && (n = h), this.emit("message_enriched", n, c), b.label = 3;
            case 3:
              return s++, [3, 1];
            case 4:
              d = 0, g = f, b.label = 5;
            case 5:
              return d < g.length ? (p = g[d], [4, _i(n, p)]) : [3, 8];
            case 6:
              h = b.sent(), h instanceof so && (n = h), this.emit("message_enriched", n, p), b.label = 7;
            case 7:
              return d++, [3, 5];
            case 8:
              return l = this.availableExtensions((a = n.event.integrations) !== null && a !== void 0 ? a : {}), w = l.destinations, m = l.after, [4, new Promise(function(C, M) {
                setTimeout(function() {
                  var S = w.map(function(I) {
                    return _i(n, I);
                  });
                  Promise.all(S).then(C).catch(M);
                }, 0);
              })];
            case 9:
              return b.sent(), n.stats.increment("message_delivered"), this.emit("message_delivered", n), y = m.map(function(C) {
                return _i(n, C);
              }), [4, Promise.all(y)];
            case 10:
              return b.sent(), [2, n];
          }
        });
      });
    }, t;
  }(To)
), om = function(e, t) {
  var n = Date.now() - e;
  return Math.max((t ?? 300) - n, 0);
};
function fm(e, t, n, r) {
  return Ie(this, void 0, void 0, function() {
    var a, i;
    return Se(this, function(o) {
      switch (o.label) {
        case 0:
          return n.emit("dispatch_start", e), a = Date.now(), t.isEmpty() ? [4, t.dispatchSingle(e)] : [3, 2];
        case 1:
          return i = o.sent(), [3, 4];
        case 2:
          return [4, t.dispatch(e)];
        case 3:
          i = o.sent(), o.label = 4;
        case 4:
          return r != null && r.callback ? [4, Vv(i, r.callback, om(a, r.timeout))] : [3, 6];
        case 5:
          i = o.sent(), o.label = 6;
        case 6:
          return r != null && r.debug && i.flush(), [2, i];
      }
    });
  });
}
function um(e, t, n, r) {
  var a, i = [e, t, n, r], o = Ut(e) ? e.event : e;
  if (!o || !ur(o))
    throw new Error("Event missing");
  var f = Ut(e) ? (a = e.properties) !== null && a !== void 0 ? a : {} : Ut(t) ? t : {}, s = {};
  Tr(n) || (s = n ?? {}), Ut(e) && !Tr(t) && (s = t ?? {});
  var u = i.find(Tr);
  return [o, f, s, u];
}
function nl(e, t, n, r, a) {
  var i, o, f = null, s = null, u = [e, t, n, r, a], c = u.filter(ur);
  c[0] !== void 0 && c[1] !== void 0 && (f = c[0], s = c[1]), c.length === 1 && (f = null, s = c[0]);
  var d = u.find(Tr), g = u.filter(function(l) {
    return s === null ? Ut(l) : Ut(l) || l === null;
  }), p = (i = g[0]) !== null && i !== void 0 ? i : {}, h = (o = g[1]) !== null && o !== void 0 ? o : {};
  return [
    f,
    s,
    p,
    h,
    d
  ];
}
var rl = function(e) {
  return function() {
    for (var t, n, r, a = [], i = 0; i < arguments.length; i++)
      a[i] = arguments[i];
    for (var o = {}, f = [
      "callback",
      "options",
      "traits",
      "id"
    ], s = 0, u = a; s < u.length; s++) {
      var c = u[s], d = f.pop();
      if (d === "id") {
        if (ur(c) || gu(c)) {
          o.id = c.toString();
          continue;
        }
        if (c == null)
          continue;
        d = f.pop();
      }
      if ((d === "traits" || d === "options") && (c == null || Ut(c)) && (o[d] = c), Tr(c)) {
        o.callback = c;
        break;
      }
    }
    return [
      (t = o.id) !== null && t !== void 0 ? t : e.id(),
      (n = o.traits) !== null && n !== void 0 ? n : {},
      (r = o.options) !== null && r !== void 0 ? r : {},
      o.callback
    ];
  };
};
function sm(e, t, n, r) {
  gu(e) && (e = e.toString()), gu(t) && (t = t.toString());
  var a = [e, t, n, r], i = a.filter(ur), o = i[0], f = o === void 0 ? e : o, s = i[1], u = s === void 0 ? null : s, c = a.filter(Ut)[0], d = c === void 0 ? {} : c, g = a.find(Tr);
  return [f, u, d, g];
}
function d1() {
  return typeof window < "u";
}
function cm() {
  return d1() ? window.navigator.onLine : !0;
}
function g1() {
  return !cm();
}
function lm(e, t) {
  return t = t || {}, new Promise(function(n, r) {
    var a = new XMLHttpRequest(), i = [], o = [], f = {}, s = function() {
      return { ok: (a.status / 100 | 0) == 2, statusText: a.statusText, status: a.status, url: a.responseURL, text: function() {
        return Promise.resolve(a.responseText);
      }, json: function() {
        return Promise.resolve(a.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([a.response]));
      }, clone: s, headers: { keys: function() {
        return i;
      }, entries: function() {
        return o;
      }, get: function(c) {
        return f[c.toLowerCase()];
      }, has: function(c) {
        return c.toLowerCase() in f;
      } } };
    };
    for (var u in a.open(t.method || "get", e, !0), a.onload = function() {
      a.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(c, d, g) {
        i.push(d = d.toLowerCase()), o.push([d, g]), f[d] = f[d] ? f[d] + "," + g : g;
      }), n(s());
    }, a.onerror = r, a.withCredentials = t.credentials == "include", t.headers)
      a.setRequestHeader(u, t.headers[u]);
    a.send(t.body || null);
  });
}
var p1 = function() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : null;
}, dm = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  var n = p1();
  return (n && n.fetch || lm).apply(void 0, e);
}, pu = "1.70.0", gm = "npm";
function pm() {
  return gm;
}
var hm = "api.segment.io/v1", vm = function(e, t, n) {
  var r = t.reduce(function(a, i) {
    var o = i.split(":"), f = o[0], s = o[1];
    return a[f] = s, a;
  }, {});
  return {
    type: "Counter",
    metric: e,
    value: 1,
    tags: oe(oe({}, r), { library: "analytics.js", library_version: n === "web" ? "next-".concat(pu) : "npm:next-".concat(pu) })
  };
};
function wf(e) {
  console.error("Error sending segment performance metrics", e);
}
var mm = (
  /** @class */
  function() {
    function e(t) {
      var n = this, r, a, i, o, f;
      if (this.host = (r = t == null ? void 0 : t.host) !== null && r !== void 0 ? r : hm, this.sampleRate = (a = t == null ? void 0 : t.sampleRate) !== null && a !== void 0 ? a : 1, this.flushTimer = (i = t == null ? void 0 : t.flushTimer) !== null && i !== void 0 ? i : 30 * 1e3, this.maxQueueSize = (o = t == null ? void 0 : t.maxQueueSize) !== null && o !== void 0 ? o : 20, this.protocol = (f = t == null ? void 0 : t.protocol) !== null && f !== void 0 ? f : "https", this.queue = [], this.sampleRate > 0) {
        var s = !1, u = function() {
          s || (s = !0, n.flush().catch(wf), s = !1, setTimeout(u, n.flushTimer));
        };
        u();
      }
    }
    return e.prototype.increment = function(t, n) {
      if (t.includes("analytics_js.") && n.length !== 0 && !(Math.random() > this.sampleRate) && !(this.queue.length >= this.maxQueueSize)) {
        var r = vm(t, n, pm());
        this.queue.push(r), t.includes("error") && this.flush().catch(wf);
      }
    }, e.prototype.flush = function() {
      return Ie(this, void 0, void 0, function() {
        var t = this;
        return Se(this, function(n) {
          switch (n.label) {
            case 0:
              return this.queue.length <= 0 ? [
                2
                /*return*/
              ] : [4, this.send().catch(function(r) {
                wf(r), t.sampleRate = 0;
              })];
            case 1:
              return n.sent(), [
                2
                /*return*/
              ];
          }
        });
      });
    }, e.prototype.send = function() {
      return Ie(this, void 0, void 0, function() {
        var t, n, r;
        return Se(this, function(a) {
          return t = { series: this.queue }, this.queue = [], n = { "Content-Type": "text/plain" }, r = "".concat(this.protocol, "://").concat(this.host, "/m"), [2, dm(r, {
            headers: n,
            body: JSON.stringify(t),
            method: "POST"
          })];
        });
      });
    }, e;
  }()
), Mi, wm = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.initRemoteMetrics = function(n) {
      Mi = new mm(n);
    }, t.prototype.increment = function(n, r, a) {
      e.prototype.increment.call(this, n, r, a), Mi == null || Mi.increment(n, a ?? []);
    }, t;
  }(l1)
), Nr = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r) {
      return e.call(this, n, r, new wm()) || this;
    }
    return t.system = function() {
      return new this({ type: "track", event: "system" });
    }, t;
  }(so)
), h1 = "bpc", v1 = function(e, t, n, r, a, i) {
  return {
    __t: h1,
    c: t,
    p: r,
    u: e,
    s: n,
    t: a,
    r: i
  };
}, ym = Object.keys(v1("", "", "", "", "", ""));
function bm(e) {
  if (!Ut(e) || e.__t !== h1)
    return !1;
  for (var t in e)
    if (!ym.includes(t))
      return !1;
  return !0;
}
var Cm = function(e, t) {
  return e.indexOf("?") > -1 ? e : e + t;
}, Mm = function(e) {
  var t = e.indexOf("#");
  return t === -1 ? e : e.slice(0, t);
}, Dm = function(e) {
  try {
    return new URL(e).pathname;
  } catch {
    return e[0] === "/" ? e : "/" + e;
  }
}, m1 = function(e) {
  var t = e.c, n = e.p, r = e.s, a = e.u, i = e.r, o = e.t, f = t ? Dm(t) : n, s = t ? Cm(t, r) : Mm(a);
  return {
    path: f,
    referrer: i,
    search: r,
    title: o,
    url: s
  };
}, w1 = function() {
  var e = document.querySelector("link[rel='canonical']");
  return v1(location.href, e && e.getAttribute("href") || void 0, location.search, location.pathname, document.title, document.referrer);
}, Lm = function() {
  return m1(w1());
};
function Am(e, t) {
  return Object.assign.apply(Object, ct([{}], t.map(function(n) {
    var r;
    if (e && Object.prototype.hasOwnProperty.call(e, n))
      return r = {}, r[n] = e[n], r;
  }), !1));
}
var br = function(e, t) {
  t === void 0 && (t = Lm());
  var n = e.context, r;
  e.type === "page" && (r = e.properties && Am(e.properties, Object.keys(t)), e.properties = oe(oe(oe({}, t), e.properties), e.name ? { name: e.name } : {})), n.page = oe(oe(oe({}, t), r), n.page);
}, Em = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n) {
      var r = e.call(this, {
        createMessageId: function() {
          return "ajs-next-".concat(Date.now(), "-").concat(Cs());
        },
        onEventMethodCall: function(a) {
          var i = a.options;
          r.maybeUpdateAnonId(i);
        },
        onFinishedEvent: function(a) {
          return r.addIdentity(a), a;
        }
      }) || this;
      return r.user = n, r;
    }
    return t.prototype.maybeUpdateAnonId = function(n) {
      n != null && n.anonymousId && this.user.anonymousId(n.anonymousId);
    }, t.prototype.addIdentity = function(n) {
      this.user.id() && (n.userId = this.user.id()), this.user.anonymousId() && (n.anonymousId = this.user.anonymousId());
    }, t.prototype.track = function(n, r, a, i, o) {
      var f = e.prototype.track.call(this, n, r, a, i);
      return br(f, o), f;
    }, t.prototype.page = function(n, r, a, i, o, f) {
      var s = e.prototype.page.call(this, n, r, a, i, o);
      return br(s, f), s;
    }, t.prototype.screen = function(n, r, a, i, o, f) {
      var s = e.prototype.screen.call(this, n, r, a, i, o);
      return br(s, f), s;
    }, t.prototype.identify = function(n, r, a, i, o) {
      var f = e.prototype.identify.call(this, n, r, a, i);
      return br(f, o), f;
    }, t.prototype.group = function(n, r, a, i, o) {
      var f = e.prototype.group.call(this, n, r, a, i);
      return br(f, o), f;
    }, t.prototype.alias = function(n, r, a, i, o) {
      var f = e.prototype.alias.call(this, n, r, a, i);
      return br(f, o), f;
    }, t;
  }(_v)
), jm = function(e) {
  return "addMiddleware" in e && e.type === "destination";
}, Vt = {
  getItem: function() {
  },
  setItem: function() {
  },
  removeItem: function() {
  }
};
try {
  Vt = d1() && window.localStorage ? window.localStorage : Vt;
} catch (e) {
  console.warn("Unable to access localStorage", e);
}
function y1(e) {
  var t = Vt.getItem(e);
  return (t ? JSON.parse(t) : []).map(function(n) {
    return new Nr(n.event, n.id);
  });
}
function Im(e, t) {
  var n = y1(e), r = ct(ct([], t, !0), n, !0), a = r.reduce(function(i, o) {
    var f;
    return oe(oe({}, i), (f = {}, f[o.id] = o, f));
  }, {});
  Vt.setItem(e, JSON.stringify(Object.values(a)));
}
function b1(e) {
  var t = Vt.getItem(e);
  return t ? JSON.parse(t) : {};
}
function Sm(e, t) {
  var n = b1(e);
  Vt.setItem(e, JSON.stringify(oe(oe({}, n), t)));
}
function al(e) {
  Vt.removeItem(e);
}
var xm = function() {
  return (/* @__PURE__ */ new Date()).getTime();
};
function hu(e, t, n) {
  n === void 0 && (n = 0);
  var r = 50, a = "persisted-queue:v1:".concat(e, ":lock"), i = function(u) {
    return (/* @__PURE__ */ new Date()).getTime() > u;
  }, o = Vt.getItem(a), f = o ? JSON.parse(o) : null, s = f === null || i(f);
  if (s) {
    Vt.setItem(a, JSON.stringify(xm() + r)), t(), Vt.removeItem(a);
    return;
  }
  !s && n < 3 ? setTimeout(function() {
    hu(e, t, n + 1);
  }, r) : console.error("Unable to retrieve lock");
}
var C1 = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r) {
      var a = e.call(this, n, []) || this, i = "persisted-queue:v1:".concat(r, ":items"), o = "persisted-queue:v1:".concat(r, ":seen"), f = [], s = {};
      return hu(r, function() {
        try {
          f = y1(i), s = b1(o), al(i), al(o), a.queue = ct(ct([], f, !0), a.queue, !0), a.seen = oe(oe({}, s), a.seen);
        } catch (u) {
          console.error(u);
        }
      }), window.addEventListener("pagehide", function() {
        if (a.todo > 0) {
          var u = ct(ct([], a.queue, !0), a.future, !0);
          try {
            hu(r, function() {
              Im(i, u), Sm(o, a.seen);
            });
          } catch (c) {
            console.error(c);
          }
        }
      }), a;
    }
    return t;
  }(c1)
), Tm = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n) {
      return e.call(this, typeof n == "string" ? new C1(4, n) : n) || this;
    }
    return t.prototype.flush = function() {
      return Ie(this, void 0, void 0, function() {
        return Se(this, function(n) {
          return g1() ? [2, []] : [2, e.prototype.flush.call(this)];
        });
      });
    }, t;
  }(im)
);
function Ms(e) {
  for (var t = e.constructor.prototype, n = 0, r = Object.getOwnPropertyNames(t); n < r.length; n++) {
    var a = r[n];
    if (a !== "constructor") {
      var i = Object.getOwnPropertyDescriptor(e.constructor.prototype, a);
      i && typeof i.value == "function" && (e[a] = e[a].bind(e));
    }
  }
  return e;
}
/*! js-cookie v3.0.1 | MIT */
function Di(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var Nm = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function vu(e, t) {
  function n(a, i, o) {
    if (!(typeof document > "u")) {
      o = Di({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var s in o)
        o[s] && (f += "; " + s, o[s] !== !0 && (f += "=" + o[s].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + f;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, f = 0; f < i.length; f++) {
        var s = i[f].split("="), u = s.slice(1).join("=");
        try {
          var c = decodeURIComponent(s[0]);
          if (o[c] = e.read(u, c), a === c)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, i) {
        n(
          a,
          "",
          Di({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return vu(this.converter, Di({}, this.attributes, a));
      },
      withConverter: function(a) {
        return vu(Di({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var In = vu(Nm, { path: "/" });
function km(e) {
  var t = e.hostname, n = t.split("."), r = n[n.length - 1], a = [];
  if (n.length === 4 && parseInt(r, 10) > 0 || n.length <= 1)
    return a;
  for (var i = n.length - 2; i >= 0; --i)
    a.push(n.slice(i).join("."));
  return a;
}
function Bm(e) {
  try {
    return new URL(e);
  } catch {
    return;
  }
}
function Om(e) {
  var t = Bm(e);
  if (t)
    for (var n = km(t), r = 0; r < n.length; ++r) {
      var a = "__tld__", i = n[r], o = { domain: "." + i };
      try {
        if (In.set(a, "1", o), In.get(a))
          return In.remove(a, o), i;
      } catch {
        return;
      }
    }
}
var Pm = 365, zm = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = e.defaults), this.options = oe(oe({}, e.defaults), t);
    }
    return Object.defineProperty(e, "defaults", {
      get: function() {
        return {
          maxage: Pm,
          domain: Om(window.location.href),
          path: "/",
          sameSite: "Lax"
        };
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.opts = function() {
      return {
        sameSite: this.options.sameSite,
        expires: this.options.maxage,
        domain: this.options.domain,
        path: this.options.path,
        secure: this.options.secure
      };
    }, e.prototype.get = function(t) {
      var n;
      try {
        var r = In.get(t);
        if (r == null)
          return null;
        try {
          return (n = JSON.parse(r)) !== null && n !== void 0 ? n : null;
        } catch {
          return r ?? null;
        }
      } catch {
        return null;
      }
    }, e.prototype.set = function(t, n) {
      typeof n == "string" ? In.set(t, n, this.opts()) : n === null ? In.remove(t, this.opts()) : In.set(t, JSON.stringify(n), this.opts());
    }, e.prototype.remove = function(t) {
      return In.remove(t, this.opts());
    }, e;
  }()
), Rm = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.localStorageWarning = function(t, n) {
      console.warn("Unable to access ".concat(t, ", localStorage may be ").concat(n));
    }, e.prototype.get = function(t) {
      var n;
      try {
        var r = localStorage.getItem(t);
        if (r === null)
          return null;
        try {
          return (n = JSON.parse(r)) !== null && n !== void 0 ? n : null;
        } catch {
          return r ?? null;
        }
      } catch {
        return this.localStorageWarning(t, "unavailable"), null;
      }
    }, e.prototype.set = function(t, n) {
      try {
        localStorage.setItem(t, JSON.stringify(n));
      } catch {
        this.localStorageWarning(t, "full");
      }
    }, e.prototype.remove = function(t) {
      try {
        return localStorage.removeItem(t);
      } catch {
        this.localStorageWarning(t, "unavailable");
      }
    }, e;
  }()
), Ds = (
  /** @class */
  function() {
    function e() {
      this.cache = {};
    }
    return e.prototype.get = function(t) {
      var n;
      return (n = this.cache[t]) !== null && n !== void 0 ? n : null;
    }, e.prototype.set = function(t, n) {
      this.cache[t] = n;
    }, e.prototype.remove = function(t) {
      delete this.cache[t];
    }, e;
  }()
), ht = {
  Cookie: "cookie",
  LocalStorage: "localStorage",
  Memory: "memory"
};
function M1(e) {
  return e && e.stores && Array.isArray(e.stores) && e.stores.every(function(t) {
    return Object.values(ht).includes(t);
  });
}
function Fm(e) {
  return typeof e == "object" && e.name !== void 0;
}
var yf = function(e, t, n, r) {
  console.warn("".concat(e.constructor.name, ": Can't ").concat(t, ' key "').concat(n, '" | Err: ').concat(r));
}, kr = (
  /** @class */
  function() {
    function e(t) {
      this.stores = t;
    }
    return e.prototype.get = function(t) {
      for (var n = null, r = 0, a = this.stores; r < a.length; r++) {
        var i = a[r];
        try {
          if (n = i.get(t), n != null)
            return n;
        } catch (o) {
          yf(i, "get", t, o);
        }
      }
      return null;
    }, e.prototype.set = function(t, n) {
      this.stores.forEach(function(r) {
        try {
          r.set(t, n);
        } catch (a) {
          yf(r, "set", t, a);
        }
      });
    }, e.prototype.clear = function(t) {
      this.stores.forEach(function(n) {
        try {
          n.remove(t);
        } catch (r) {
          yf(n, "remove", t, r);
        }
      });
    }, e.prototype.getAndSync = function(t) {
      var n = this.get(t), r = typeof n == "number" ? n.toString() : n;
      return this.set(t, r), r;
    }, e;
  }()
);
function mu(e) {
  var t = e.map(function(n) {
    var r, a;
    switch (Fm(n) ? (r = n.name, a = n.settings) : r = n, r) {
      case ht.Cookie:
        return new zm(a);
      case ht.LocalStorage:
        return new Rm();
      case ht.Memory:
        return new Ds();
      default:
        throw new Error("Unknown Store Type: ".concat(n));
    }
  });
  return t;
}
function D1(e, t) {
  return e.map(function(n) {
    return t && n === ht.Cookie ? {
      name: n,
      settings: t
    } : n;
  });
}
var Yn = {
  persist: !0,
  cookie: {
    key: "ajs_user_id",
    oldKey: "ajs_user"
  },
  localStorage: {
    key: "ajs_user_traits"
  }
}, L1 = (
  /** @class */
  function() {
    function e(t, n) {
      t === void 0 && (t = Yn);
      var r = this, a, i, o, f;
      this.options = {}, this.id = function(u) {
        if (r.options.disable)
          return null;
        var c = r.identityStore.getAndSync(r.idKey);
        if (u !== void 0) {
          r.identityStore.set(r.idKey, u);
          var d = u !== c && c !== null && u !== null;
          d && r.anonymousId(null);
        }
        var g = r.identityStore.getAndSync(r.idKey);
        if (g)
          return g;
        var p = r.legacyUserStore.get(Yn.cookie.oldKey);
        return p ? typeof p == "object" ? p.id : p : null;
      }, this.anonymousId = function(u) {
        var c, d;
        if (r.options.disable)
          return null;
        if (u === void 0) {
          var g = (c = r.identityStore.getAndSync(r.anonKey)) !== null && c !== void 0 ? c : (d = r.legacySIO()) === null || d === void 0 ? void 0 : d[0];
          if (g)
            return g;
        }
        return u === null ? (r.identityStore.set(r.anonKey, null), r.identityStore.getAndSync(r.anonKey)) : (r.identityStore.set(r.anonKey, u ?? Cs()), r.identityStore.getAndSync(r.anonKey));
      }, this.traits = function(u) {
        var c;
        if (!r.options.disable)
          return u === null && (u = {}), u && r.traitsStore.set(r.traitsKey, u ?? {}), (c = r.traitsStore.get(r.traitsKey)) !== null && c !== void 0 ? c : {};
      }, this.options = oe(oe({}, Yn), t), this.cookieOptions = n, this.idKey = (i = (a = t.cookie) === null || a === void 0 ? void 0 : a.key) !== null && i !== void 0 ? i : Yn.cookie.key, this.traitsKey = (f = (o = t.localStorage) === null || o === void 0 ? void 0 : o.key) !== null && f !== void 0 ? f : Yn.localStorage.key, this.anonKey = "ajs_anonymous_id", this.identityStore = this.createStorage(this.options, n), this.legacyUserStore = this.createStorage(this.options, n, function(u) {
        return u === ht.Cookie;
      }), this.traitsStore = this.createStorage(this.options, n, function(u) {
        return u !== ht.Cookie;
      });
      var s = this.legacyUserStore.get(Yn.cookie.oldKey);
      s && typeof s == "object" && (s.id && this.id(s.id), s.traits && this.traits(s.traits)), Ms(this);
    }
    return e.prototype.legacySIO = function() {
      var t = this.legacyUserStore.get("_sio");
      if (!t)
        return null;
      var n = t.split("----"), r = n[0], a = n[1];
      return [r, a];
    }, e.prototype.identify = function(t, n) {
      if (!this.options.disable) {
        n = n ?? {};
        var r = this.id();
        (r === null || r === t) && (n = oe(oe({}, this.traits()), n)), t && this.id(t), this.traits(n);
      }
    }, e.prototype.logout = function() {
      this.anonymousId(null), this.id(null), this.traits({});
    }, e.prototype.reset = function() {
      this.logout(), this.identityStore.clear(this.idKey), this.identityStore.clear(this.anonKey), this.traitsStore.clear(this.traitsKey);
    }, e.prototype.load = function() {
      return new e(this.options, this.cookieOptions);
    }, e.prototype.save = function() {
      return !0;
    }, e.prototype.createStorage = function(t, n, r) {
      var a = [
        ht.LocalStorage,
        ht.Cookie,
        ht.Memory
      ];
      return t.disable ? new kr([]) : t.persist ? (t.storage !== void 0 && t.storage !== null && M1(t.storage) && (a = t.storage.stores), t.localStorageFallbackDisabled && (a = a.filter(function(i) {
        return i !== ht.LocalStorage;
      })), r && (a = a.filter(r)), new kr(mu(D1(a, n)))) : new kr([new Ds()]);
    }, e.defaults = Yn, e;
  }()
), il = {
  persist: !0,
  cookie: {
    key: "ajs_group_id"
  },
  localStorage: {
    key: "ajs_group_properties"
  }
}, Um = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r) {
      n === void 0 && (n = il);
      var a = e.call(this, oe(oe({}, il), n), r) || this;
      return a.anonymousId = function(i) {
      }, Ms(a), a;
    }
    return t;
  }(L1)
), A1 = "analytics";
function Ym() {
  return window[A1];
}
function Gm(e) {
  window[A1] = e;
}
var Hm = function(e) {
  return typeof e == "object" && e !== null && "then" in e && typeof e.then == "function";
}, E1 = function(e, t, n) {
  n.getCalls(e).forEach(function(r) {
    Jm(t, r).catch(console.error);
  });
};
E1.bind(globalThis, "on");
E1.bind(globalThis, "setAnonymousId");
var Cr = function(e) {
  if (j1(e)) {
    var t = e.pop();
    return m1(t);
  }
}, j1 = function(e) {
  var t = e[e.length - 1];
  return bm(t);
}, Qm = (
  /** @class */
  function() {
    function e(t, n, r, a) {
      r === void 0 && (r = function() {
      }), a === void 0 && (a = console.error), this.method = t, this.resolve = r, this.reject = a, this.called = !1, this.args = n;
    }
    return e;
  }()
);
(function() {
  function e() {
    for (var t = [], n = 0; n < arguments.length; n++)
      t[n] = arguments[n];
    this._callMap = {}, this.push.apply(this, t);
  }
  return Object.defineProperty(e.prototype, "calls", {
    /**
     * Pull any buffered method calls from the window object, and use them to hydrate the instance buffer.
     */
    get: function() {
      return this._pushSnippetWindowBuffer(), this._callMap;
    },
    set: function(t) {
      this._callMap = t;
    },
    enumerable: !1,
    configurable: !0
  }), e.prototype.getCalls = function(t) {
    var n;
    return (n = this.calls[t]) !== null && n !== void 0 ? n : [];
  }, e.prototype.push = function() {
    for (var t = this, n = [], r = 0; r < arguments.length; r++)
      n[r] = arguments[r];
    n.forEach(function(a) {
      var i = [
        "track",
        "screen",
        "alias",
        "group",
        "page",
        "identify"
      ];
      i.includes(a.method) && !j1(a.args) && (a.args = ct(ct([], a.args, !0), [w1()], !1)), t.calls[a.method] ? t.calls[a.method].push(a) : t.calls[a.method] = [a];
    });
  }, e.prototype.clear = function() {
    this._pushSnippetWindowBuffer(), this.calls = {};
  }, e.prototype.toArray = function() {
    var t;
    return (t = []).concat.apply(t, Object.values(this.calls));
  }, e.prototype._pushSnippetWindowBuffer = function() {
    var t = Ym();
    if (Array.isArray(t)) {
      var n = t.splice(0, t.length), r = n.map(function(a) {
        var i = a[0], o = a.slice(1);
        return new Qm(i, o);
      });
      this.push.apply(this, r);
    }
  }, e;
})();
function Jm(e, t) {
  return Ie(this, void 0, void 0, function() {
    var n, r;
    return Se(this, function(a) {
      switch (a.label) {
        case 0:
          return a.trys.push([0, 3, , 4]), t.called ? [2, void 0] : (t.called = !0, n = e[t.method].apply(e, t.args), Hm(n) ? [4, n] : [3, 2]);
        case 1:
          a.sent(), a.label = 2;
        case 2:
          return t.resolve(n), [3, 4];
        case 3:
          return r = a.sent(), t.reject(r), [3, 4];
        case 4:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
var Ln = "This is being deprecated and will be not be available in future releases of Analytics JS", bf = p1(), Cf = bf == null ? void 0 : bf.analytics;
function Wm(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = t ? 10 : 1, a = n ? new c1(r, []) : new C1(r, e);
  return new Tm(a);
}
var _m = (
  /** @class */
  function() {
    function e(t) {
      var n;
      this.timeout = 300, this.writeKey = t.writeKey, this.cdnSettings = (n = t.cdnSettings) !== null && n !== void 0 ? n : { integrations: {} };
    }
    return e;
  }()
);
function _t() {
  console.warn(Ln);
}
var wu = (
  /** @class */
  function(e) {
    Bt(t, e);
    function t(n, r, a, i, o) {
      var f = this, s, u;
      f = e.call(this) || this, f._debug = !1, f.initialized = !1, f.user = function() {
        return f._user;
      }, f.init = f.initialize.bind(f), f.log = _t, f.addIntegrationMiddleware = _t, f.listeners = _t, f.addEventListener = _t, f.removeAllListeners = _t, f.removeListener = _t, f.removeEventListener = _t, f.hasListeners = _t, f.add = _t, f.addIntegration = _t;
      var c = r == null ? void 0 : r.cookie, d = (s = r == null ? void 0 : r.disableClientPersistence) !== null && s !== void 0 ? s : !1;
      f.settings = new _m(n), f.queue = a ?? Wm("".concat(n.writeKey, ":event-queue"), r == null ? void 0 : r.retryQueue, d);
      var g = r == null ? void 0 : r.storage;
      return f._universalStorage = f.createStore(d, g, c), f._user = i ?? new L1(oe({ persist: !d, storage: r == null ? void 0 : r.storage }, r == null ? void 0 : r.user), c).load(), f._group = o ?? new Um(oe({ persist: !d, storage: r == null ? void 0 : r.storage }, r == null ? void 0 : r.group), c).load(), f.eventFactory = new Em(f._user), f.integrations = (u = r == null ? void 0 : r.integrations) !== null && u !== void 0 ? u : {}, f.options = r ?? {}, Ms(f), f;
    }
    return t.prototype.createStore = function(n, r, a) {
      return n ? new kr([new Ds()]) : r && M1(r) ? new kr(mu(D1(r.stores, a))) : new kr(mu([
        ht.LocalStorage,
        {
          name: ht.Cookie,
          settings: a
        },
        ht.Memory
      ]));
    }, Object.defineProperty(t.prototype, "storage", {
      get: function() {
        return this._universalStorage;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.track = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o, f, s, u, c, d = this;
        return Se(this, function(g) {
          return a = Cr(n), i = um.apply(void 0, n), o = i[0], f = i[1], s = i[2], u = i[3], c = this.eventFactory.track(o, f, s, this.integrations, a), [2, this._dispatch(c, u).then(function(p) {
            return d.emit("track", o, p.event.properties, p.event.options), p;
          })];
        });
      });
    }, t.prototype.page = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o, f, s, u, c, d, g = this;
        return Se(this, function(p) {
          return a = Cr(n), i = nl.apply(void 0, n), o = i[0], f = i[1], s = i[2], u = i[3], c = i[4], d = this.eventFactory.page(o, f, s, u, this.integrations, a), [2, this._dispatch(d, c).then(function(h) {
            return g.emit("page", o, f, h.event.properties, h.event.options), h;
          })];
        });
      });
    }, t.prototype.identify = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o, f, s, u, c, d = this;
        return Se(this, function(g) {
          return a = Cr(n), i = rl(this._user).apply(void 0, n), o = i[0], f = i[1], s = i[2], u = i[3], this._user.identify(o, f), c = this.eventFactory.identify(this._user.id(), this._user.traits(), s, this.integrations, a), [2, this._dispatch(c, u).then(function(p) {
            return d.emit("identify", p.event.userId, p.event.traits, p.event.options), p;
          })];
        });
      });
    }, t.prototype.group = function() {
      for (var n = this, r = [], a = 0; a < arguments.length; a++)
        r[a] = arguments[a];
      var i = Cr(r);
      if (r.length === 0)
        return this._group;
      var o = rl(this._group).apply(void 0, r), f = o[0], s = o[1], u = o[2], c = o[3];
      this._group.identify(f, s);
      var d = this._group.id(), g = this._group.traits(), p = this.eventFactory.group(d, g, u, this.integrations, i);
      return this._dispatch(p, c).then(function(h) {
        return n.emit("group", h.event.groupId, h.event.traits, h.event.options), h;
      });
    }, t.prototype.alias = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o, f, s, u, c, d = this;
        return Se(this, function(g) {
          return a = Cr(n), i = sm.apply(void 0, n), o = i[0], f = i[1], s = i[2], u = i[3], c = this.eventFactory.alias(o, f, s, this.integrations, a), [2, this._dispatch(c, u).then(function(p) {
            return d.emit("alias", o, f, p.event.options), p;
          })];
        });
      });
    }, t.prototype.screen = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o, f, s, u, c, d, g = this;
        return Se(this, function(p) {
          return a = Cr(n), i = nl.apply(void 0, n), o = i[0], f = i[1], s = i[2], u = i[3], c = i[4], d = this.eventFactory.screen(o, f, s, u, this.integrations, a), [2, this._dispatch(d, c).then(function(h) {
            return g.emit("screen", o, f, h.event.properties, h.event.options), h;
          })];
        });
      });
    }, t.prototype.trackClick = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i;
        return Se(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-b88c07ab.js"
              )];
            case 1:
              return a = o.sent(), [2, (i = a.link).call.apply(i, ct([this], n, !1))];
          }
        });
      });
    }, t.prototype.trackLink = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i;
        return Se(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-b88c07ab.js"
              )];
            case 1:
              return a = o.sent(), [2, (i = a.link).call.apply(i, ct([this], n, !1))];
          }
        });
      });
    }, t.prototype.trackSubmit = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i;
        return Se(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-b88c07ab.js"
              )];
            case 1:
              return a = o.sent(), [2, (i = a.form).call.apply(i, ct([this], n, !1))];
          }
        });
      });
    }, t.prototype.trackForm = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i;
        return Se(this, function(o) {
          switch (o.label) {
            case 0:
              return [4, import(
                /* webpackChunkName: "auto-track" */
                "./auto-track-b88c07ab.js"
              )];
            case 1:
              return a = o.sent(), [2, (i = a.form).call.apply(i, ct([this], n, !1))];
          }
        });
      });
    }, t.prototype.register = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o = this;
        return Se(this, function(f) {
          switch (f.label) {
            case 0:
              return a = Nr.system(), i = n.map(function(s) {
                return o.queue.register(a, s, o);
              }), [4, Promise.all(i)];
            case 1:
              return f.sent(), [2, a];
          }
        });
      });
    }, t.prototype.deregister = function() {
      for (var n = [], r = 0; r < arguments.length; r++)
        n[r] = arguments[r];
      return Ie(this, void 0, void 0, function() {
        var a, i, o = this;
        return Se(this, function(f) {
          switch (f.label) {
            case 0:
              return a = Nr.system(), i = n.map(function(s) {
                var u = o.queue.plugins.find(function(c) {
                  return c.name === s;
                });
                if (u)
                  return o.queue.deregister(a, u, o);
                a.log("warn", "plugin ".concat(s, " not found"));
              }), [4, Promise.all(i)];
            case 1:
              return f.sent(), [2, a];
          }
        });
      });
    }, t.prototype.debug = function(n) {
      return n === !1 && localStorage.getItem("debug") && localStorage.removeItem("debug"), this._debug = n, this;
    }, t.prototype.reset = function() {
      this._user.reset(), this._group.reset(), this.emit("reset");
    }, t.prototype.timeout = function(n) {
      this.settings.timeout = n;
    }, t.prototype._dispatch = function(n, r) {
      return Ie(this, void 0, void 0, function() {
        var a;
        return Se(this, function(i) {
          return a = new Nr(n), g1() && !this.options.retryQueue ? [2, a] : [2, fm(a, this.queue, this, {
            callback: r,
            debug: this._debug,
            timeout: this.settings.timeout
          })];
        });
      });
    }, t.prototype.addSourceMiddleware = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r = this;
        return Se(this, function(a) {
          switch (a.label) {
            case 0:
              return [4, this.queue.criticalTasks.run(function() {
                return Ie(r, void 0, void 0, function() {
                  var i, o, f;
                  return Se(this, function(s) {
                    switch (s.label) {
                      case 0:
                        return [4, import(
                          /* webpackChunkName: "middleware" */
                          "./index-30ea51fc.js"
                        )];
                      case 1:
                        return i = s.sent().sourceMiddlewarePlugin, o = {}, this.queue.plugins.forEach(function(u) {
                          if (u.type === "destination")
                            return o[u.name] = !0;
                        }), f = i(n, o), [4, this.register(f)];
                      case 2:
                        return s.sent(), [
                          2
                          /*return*/
                        ];
                    }
                  });
                });
              })];
            case 1:
              return a.sent(), [2, this];
          }
        });
      });
    }, t.prototype.addDestinationMiddleware = function(n) {
      for (var r = [], a = 1; a < arguments.length; a++)
        r[a - 1] = arguments[a];
      return this.queue.plugins.filter(jm).forEach(function(i) {
        (n === "*" || i.name.toLowerCase() === n.toLowerCase()) && i.addMiddleware.apply(i, r);
      }), Promise.resolve(this);
    }, t.prototype.setAnonymousId = function(n) {
      return this._user.anonymousId(n);
    }, t.prototype.queryString = function(n) {
      return Ie(this, void 0, void 0, function() {
        var r;
        return Se(this, function(a) {
          switch (a.label) {
            case 0:
              return this.options.useQueryString === !1 ? [2, []] : [4, import(
                /* webpackChunkName: "queryString" */
                "./index-d8b411ca.js"
              )];
            case 1:
              return r = a.sent().queryString, [2, r(this, n)];
          }
        });
      });
    }, t.prototype.use = function(n) {
      return n(this), this;
    }, t.prototype.ready = function(n) {
      return n === void 0 && (n = function(r) {
        return r;
      }), Ie(this, void 0, void 0, function() {
        return Se(this, function(r) {
          return [2, Promise.all(this.queue.plugins.map(function(a) {
            return a.ready ? a.ready() : Promise.resolve();
          })).then(function(a) {
            return n(a), a;
          })];
        });
      });
    }, t.prototype.noConflict = function() {
      return console.warn(Ln), Gm(Cf ?? this), this;
    }, t.prototype.normalize = function(n) {
      return console.warn(Ln), this.eventFactory.normalize(n);
    }, Object.defineProperty(t.prototype, "failedInitializations", {
      get: function() {
        return console.warn(Ln), this.queue.failedInitializations;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "VERSION", {
      get: function() {
        return pu;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.initialize = function(n, r) {
      return Ie(this, void 0, void 0, function() {
        return Se(this, function(a) {
          return console.warn(Ln), [2, Promise.resolve(this)];
        });
      });
    }, t.prototype.pageview = function(n) {
      return Ie(this, void 0, void 0, function() {
        return Se(this, function(r) {
          switch (r.label) {
            case 0:
              return console.warn(Ln), [4, this.page({ path: n })];
            case 1:
              return r.sent(), [2, this];
          }
        });
      });
    }, Object.defineProperty(t.prototype, "plugins", {
      get: function() {
        var n;
        return console.warn(Ln), (n = this._plugins) !== null && n !== void 0 ? n : {};
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "Integrations", {
      get: function() {
        console.warn(Ln);
        var n = this.queue.plugins.filter(function(r) {
          return r.type === "destination";
        }).reduce(function(r, a) {
          var i = "".concat(a.name.toLowerCase().replace(".", "").split(" ").join("-"), "Integration"), o = window[i];
          if (!o)
            return r;
          var f = o.Integration;
          return f ? (r[a.name] = f, r) : (r[a.name] = o, r);
        }, {});
        return n;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.push = function(n) {
      var r = this, a = n.shift();
      a && !r[a] || r[a].apply(this, n);
    }, t;
  }(To)
);
(function(e) {
  Bt(t, e);
  function t() {
    var n = e.call(this, { writeKey: "" }, { disableClientPersistence: !0 }) || this;
    return n.initialized = !0, n;
  }
  return t;
})(wu);
var Pe = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function No(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Zm(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var An = {}, nn = {}, Ls = {}, I1 = { exports: {} };
(function(e) {
  e.exports = t(n), e.exports.find = e.exports, e.exports.replace = function(f, s, u, c) {
    return t(a).call(this, f, s, u, c), f;
  }, e.exports.del = function(f, s, u) {
    return t(r).call(this, f, s, null, u), f;
  };
  function t(f) {
    return function(s, u, c, d) {
      var g = d && o(d.normalizer) ? d.normalizer : i;
      u = g(u);
      for (var p, h = !1; !h; )
        l();
      function l() {
        for (p in s) {
          var w = g(p);
          if (u.indexOf(w) === 0) {
            var m = u.substr(w.length);
            if (m.charAt(0) === "." || m.length === 0) {
              u = m.substr(1);
              var y = s[p];
              if (y == null) {
                h = !0;
                return;
              }
              if (!u.length) {
                h = !0;
                return;
              }
              s = y;
              return;
            }
          }
        }
        p = void 0, h = !0;
      }
      if (p)
        return s == null ? s : f(s, p, c);
    };
  }
  function n(f, s) {
    if (f.hasOwnProperty(s))
      return f[s];
  }
  function r(f, s) {
    return f.hasOwnProperty(s) && delete f[s], f;
  }
  function a(f, s, u) {
    return f.hasOwnProperty(s) && (f[s] = u), f;
  }
  function i(f) {
    return f.replace(/[^a-zA-Z0-9\.]+/g, "").toLowerCase();
  }
  function o(f) {
    return typeof f == "function";
  }
})(I1);
var ko = I1.exports, $m = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Ls, "__esModule", { value: !0 });
var mn = $m(ko);
function Mr(e, t) {
  return function() {
    var n = this.traits(), r = this.properties ? this.properties() : {};
    return mn.default(n, "address." + e) || mn.default(n, e) || (t ? mn.default(n, "address." + t) : null) || (t ? mn.default(n, t) : null) || mn.default(r, "address." + e) || mn.default(r, e) || (t ? mn.default(r, "address." + t) : null) || (t ? mn.default(r, t) : null);
  };
}
function Vm(e) {
  e.zip = Mr("postalCode", "zip"), e.country = Mr("country"), e.street = Mr("street"), e.state = Mr("state"), e.city = Mr("city"), e.region = Mr("region");
}
Ls.default = Vm;
var Bo = {};
Object.defineProperty(Bo, "__esModule", { value: !0 });
Bo.clone = void 0;
function yu(e) {
  if (typeof e != "object")
    return e;
  if (Object.prototype.toString.call(e) === "[object Object]") {
    var t = {};
    for (var n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = yu(e[n]));
    return t;
  } else
    return Array.isArray(e) ? e.map(yu) : e;
}
Bo.clone = yu;
var As = {};
Object.defineProperty(As, "__esModule", { value: !0 });
var Km = {
  Salesforce: !0
};
function qm(e) {
  return !Km[e];
}
As.default = qm;
var Oo = {}, S1 = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
Oo.parse = function(e) {
  var t = [1, 5, 6, 7, 11, 12], n = S1.exec(e), r = 0;
  if (!n)
    return new Date(e);
  for (var a = 0, i; i = t[a]; a++)
    n[i] = parseInt(n[i], 10) || 0;
  n[2] = parseInt(n[2], 10) || 1, n[3] = parseInt(n[3], 10) || 1, n[2]--, n[8] = n[8] ? (n[8] + "00").substring(0, 3) : 0, n[4] === " " ? r = (/* @__PURE__ */ new Date()).getTimezoneOffset() : n[9] !== "Z" && n[10] && (r = n[11] * 60 + n[12], n[10] === "+" && (r = 0 - r));
  var o = Date.UTC(n[1], n[2], n[3], n[5], n[6] + r, n[7], n[8]);
  return new Date(o);
};
Oo.is = function(e, t) {
  return typeof e != "string" || t && /^\d{4}-\d{2}-\d{2}/.test(e) === !1 ? !1 : S1.test(e);
};
var Es = {}, Xm = /\d{13}/;
Es.is = function(e) {
  return Xm.test(e);
};
Es.parse = function(e) {
  return e = parseInt(e, 10), new Date(e);
};
var js = {}, e2 = /\d{10}/;
js.is = function(e) {
  return e2.test(e);
};
js.parse = function(e) {
  var t = parseInt(e, 10) * 1e3;
  return new Date(t);
};
var ol = Oo, fl = Es, ul = js, t2 = Object.prototype, x1 = t2.toString;
function n2(e) {
  return x1.call(e) === "[object Date]";
}
function r2(e) {
  return x1.call(e) === "[object Number]";
}
var Is = function(t) {
  return n2(t) ? t : r2(t) ? new Date(a2(t)) : ol.is(t) ? ol.parse(t) : fl.is(t) ? fl.parse(t) : ul.is(t) ? ul.parse(t) : new Date(t);
};
function a2(e) {
  return e < 315576e5 ? e * 1e3 : e;
}
var sl = Oo, i2 = Ss;
function Ss(e, t) {
  return t === void 0 && (t = !0), e && typeof e == "object" ? o2(e, t) : Array.isArray(e) ? f2(e, t) : sl.is(e, t) ? sl.parse(e) : e;
}
function o2(e, t) {
  return Object.keys(e).forEach(function(n) {
    e[n] = Ss(e[n], t);
  }), e;
}
function f2(e, t) {
  return e.forEach(function(n, r) {
    e[r] = Ss(n, t);
  }), e;
}
var ai = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(nn, "__esModule", { value: !0 });
nn.Facade = void 0;
var u2 = ai(Ls), Qr = Bo, s2 = ai(As), c2 = ai(Is), bu = ai(ko), l2 = ai(i2);
function St(e, t) {
  t = t || {}, this.raw = Qr.clone(e), "clone" in t || (t.clone = !0), t.clone && (e = Qr.clone(e)), "traverse" in t || (t.traverse = !0), "timestamp" in e ? e.timestamp = c2.default(e.timestamp) : e.timestamp = /* @__PURE__ */ new Date(), t.traverse && l2.default(e), this.opts = t, this.obj = e;
}
nn.Facade = St;
var ze = St.prototype;
ze.proxy = function(e) {
  var t = e.split(".");
  e = t.shift();
  var n = this[e] || this.obj[e];
  return n && (typeof n == "function" && (n = n.call(this) || {}), t.length === 0 ? this.opts.clone ? Cu(n) : n : (n = bu.default(n, t.join(".")), this.opts.clone ? Cu(n) : n));
};
ze.field = function(e) {
  var t = this.obj[e];
  return this.opts.clone ? Cu(t) : t;
};
St.proxy = function(e) {
  return function() {
    return this.proxy(e);
  };
};
St.field = function(e) {
  return function() {
    return this.field(e);
  };
};
St.multi = function(e) {
  return function() {
    var t = this.proxy(e + "s");
    if (Array.isArray(t))
      return t;
    var n = this.proxy(e);
    return n && (n = [this.opts.clone ? Qr.clone(n) : n]), n || [];
  };
};
St.one = function(e) {
  return function() {
    var t = this.proxy(e);
    if (t)
      return t;
    var n = this.proxy(e + "s");
    if (Array.isArray(n))
      return n[0];
  };
};
ze.json = function() {
  var e = this.opts.clone ? Qr.clone(this.obj) : this.obj;
  return this.type && (e.type = this.type()), e;
};
ze.rawEvent = function() {
  return this.raw;
};
ze.options = function(e) {
  var t = this.obj.options || this.obj.context || {}, n = this.opts.clone ? Qr.clone(t) : t;
  if (!e)
    return n;
  if (this.enabled(e)) {
    var r = this.integrations(), a = r[e] || bu.default(r, e);
    return typeof a != "object" && (a = bu.default(this.options(), e)), typeof a == "object" ? a : {};
  }
};
ze.context = ze.options;
ze.enabled = function(e) {
  var t = this.proxy("options.providers.all");
  typeof t != "boolean" && (t = this.proxy("options.all")), typeof t != "boolean" && (t = this.proxy("integrations.all")), typeof t != "boolean" && (t = !0);
  var n = t && s2.default(e), r = this.integrations();
  if (r.providers && r.providers.hasOwnProperty(e) && (n = r.providers[e]), r.hasOwnProperty(e)) {
    var a = r[e];
    typeof a == "boolean" ? n = a : n = !0;
  }
  return !!n;
};
ze.integrations = function() {
  return this.obj.integrations || this.proxy("options.providers") || this.options();
};
ze.active = function() {
  var e = this.proxy("options.active");
  return e == null && (e = !0), e;
};
ze.anonymousId = function() {
  return this.field("anonymousId") || this.field("sessionId");
};
ze.sessionId = ze.anonymousId;
ze.groupId = St.proxy("options.groupId");
ze.traits = function(e) {
  var t = this.proxy("options.traits") || {}, n = this.userId();
  e = e || {}, n && (t.id = n);
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var a = this[r] == null ? this.proxy("options.traits." + r) : this[r]();
      if (a == null)
        continue;
      t[e[r]] = a, delete t[r];
    }
  return t;
};
ze.library = function() {
  var e = this.proxy("options.library");
  return e ? typeof e == "string" ? { name: e, version: null } : e : { name: "unknown", version: null };
};
ze.device = function() {
  var e = this.proxy("context.device");
  (typeof e != "object" || e === null) && (e = {});
  var t = this.library().name;
  return e.type || (t.indexOf("ios") > -1 && (e.type = "ios"), t.indexOf("android") > -1 && (e.type = "android")), e;
};
ze.userAgent = St.proxy("context.userAgent");
ze.timezone = St.proxy("context.timezone");
ze.timestamp = St.field("timestamp");
ze.channel = St.field("channel");
ze.ip = St.proxy("context.ip");
ze.userId = St.field("userId");
u2.default(ze);
function Cu(e) {
  return Qr.clone(e);
}
var Po = {}, Mu = { exports: {} };
typeof Object.create == "function" ? Mu.exports = function(t, n) {
  n && (t.super_ = n, t.prototype = Object.create(n.prototype, {
    constructor: {
      value: t,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }));
} : Mu.exports = function(t, n) {
  if (n) {
    t.super_ = n;
    var r = function() {
    };
    r.prototype = n.prototype, t.prototype = new r(), t.prototype.constructor = t;
  }
};
var sr = Mu.exports, d2 = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Po, "__esModule", { value: !0 });
Po.Alias = void 0;
var g2 = d2(sr), T1 = nn;
function Ht(e, t) {
  T1.Facade.call(this, e, t);
}
Po.Alias = Ht;
g2.default(Ht, T1.Facade);
Ht.prototype.action = function() {
  return "alias";
};
Ht.prototype.type = Ht.prototype.action;
Ht.prototype.previousId = function() {
  return this.field("previousId") || this.field("from");
};
Ht.prototype.from = Ht.prototype.previousId;
Ht.prototype.userId = function() {
  return this.field("userId") || this.field("to");
};
Ht.prototype.to = Ht.prototype.userId;
var zo = {}, ra = {};
Object.defineProperty(ra, "__esModule", { value: !0 });
var p2 = /.+\@.+\..+/;
function h2(e) {
  return p2.test(e);
}
ra.default = h2;
var xs = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(zo, "__esModule", { value: !0 });
zo.Group = void 0;
var v2 = xs(sr), m2 = xs(ra), w2 = xs(Is), aa = nn;
function Ts(e, t) {
  aa.Facade.call(this, e, t);
}
zo.Group = Ts;
v2.default(Ts, aa.Facade);
var Qt = Ts.prototype;
Qt.action = function() {
  return "group";
};
Qt.type = Qt.action;
Qt.groupId = aa.Facade.field("groupId");
Qt.created = function() {
  var e = this.proxy("traits.createdAt") || this.proxy("traits.created") || this.proxy("properties.createdAt") || this.proxy("properties.created");
  if (e)
    return w2.default(e);
};
Qt.email = function() {
  var e = this.proxy("traits.email");
  if (e)
    return e;
  var t = this.groupId();
  if (m2.default(t))
    return t;
};
Qt.traits = function(e) {
  var t = this.properties(), n = this.groupId();
  e = e || {}, n && (t.id = n);
  for (var r in e)
    if (Object.prototype.hasOwnProperty.call(e, r)) {
      var a = this[r] == null ? this.proxy("traits." + r) : this[r]();
      if (a == null)
        continue;
      t[e[r]] = a, delete t[r];
    }
  return t;
};
Qt.name = aa.Facade.proxy("traits.name");
Qt.industry = aa.Facade.proxy("traits.industry");
Qt.employees = aa.Facade.proxy("traits.employees");
Qt.properties = function() {
  return this.field("traits") || this.field("properties") || {};
};
var ii = {}, Ro = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ii, "__esModule", { value: !0 });
ii.Identify = void 0;
var rn = nn, Br = Ro(ko), y2 = Ro(sr), b2 = Ro(ra), N1 = Ro(Is), Vn = function(e) {
  return e.trim();
};
function Ns(e, t) {
  rn.Facade.call(this, e, t);
}
ii.Identify = Ns;
y2.default(Ns, rn.Facade);
var Re = Ns.prototype;
Re.action = function() {
  return "identify";
};
Re.type = Re.action;
Re.traits = function(e) {
  var t = this.field("traits") || {}, n = this.userId();
  e = e || {}, n && (t.id = n);
  for (var r in e) {
    var a = this[r] == null ? this.proxy("traits." + r) : this[r]();
    a != null && (t[e[r]] = a, r !== e[r] && delete t[r]);
  }
  return t;
};
Re.email = function() {
  var e = this.proxy("traits.email");
  if (e)
    return e;
  var t = this.userId();
  if (b2.default(t))
    return t;
};
Re.created = function() {
  var e = this.proxy("traits.created") || this.proxy("traits.createdAt");
  if (e)
    return N1.default(e);
};
Re.companyCreated = function() {
  var e = this.proxy("traits.company.created") || this.proxy("traits.company.createdAt");
  if (e)
    return N1.default(e);
};
Re.companyName = function() {
  return this.proxy("traits.company.name");
};
Re.name = function() {
  var e = this.proxy("traits.name");
  if (typeof e == "string")
    return Vn(e);
  var t = this.firstName(), n = this.lastName();
  if (t && n)
    return Vn(t + " " + n);
};
Re.firstName = function() {
  var e = this.proxy("traits.firstName");
  if (typeof e == "string")
    return Vn(e);
  var t = this.proxy("traits.name");
  if (typeof t == "string")
    return Vn(t).split(" ")[0];
};
Re.lastName = function() {
  var e = this.proxy("traits.lastName");
  if (typeof e == "string")
    return Vn(e);
  var t = this.proxy("traits.name");
  if (typeof t == "string") {
    var n = Vn(t).indexOf(" ");
    if (n !== -1)
      return Vn(t.substr(n + 1));
  }
};
Re.uid = function() {
  return this.userId() || this.username() || this.email();
};
Re.description = function() {
  return this.proxy("traits.description") || this.proxy("traits.background");
};
Re.age = function() {
  var e = this.birthday(), t = Br.default(this.traits(), "age");
  if (t != null)
    return t;
  if (e instanceof Date) {
    var n = /* @__PURE__ */ new Date();
    return n.getFullYear() - e.getFullYear();
  }
};
Re.avatar = function() {
  var e = this.traits();
  return Br.default(e, "avatar") || Br.default(e, "photoUrl") || Br.default(e, "avatarUrl");
};
Re.position = function() {
  var e = this.traits();
  return Br.default(e, "position") || Br.default(e, "jobTitle");
};
Re.username = rn.Facade.proxy("traits.username");
Re.website = rn.Facade.one("traits.website");
Re.websites = rn.Facade.multi("traits.website");
Re.phone = rn.Facade.one("traits.phone");
Re.phones = rn.Facade.multi("traits.phone");
Re.address = rn.Facade.proxy("traits.address");
Re.gender = rn.Facade.proxy("traits.gender");
Re.birthday = rn.Facade.proxy("traits.birthday");
var ia = {}, ks = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(ia, "__esModule", { value: !0 });
ia.Track = void 0;
var C2 = ks(sr), Xe = nn, M2 = ii, D2 = ks(ra), k1 = ks(ko);
function Bs(e, t) {
  Xe.Facade.call(this, e, t);
}
ia.Track = Bs;
C2.default(Bs, Xe.Facade);
var we = Bs.prototype;
we.action = function() {
  return "track";
};
we.type = we.action;
we.event = Xe.Facade.field("event");
we.value = Xe.Facade.proxy("properties.value");
we.category = Xe.Facade.proxy("properties.category");
we.id = Xe.Facade.proxy("properties.id");
we.productId = function() {
  return this.proxy("properties.product_id") || this.proxy("properties.productId");
};
we.promotionId = function() {
  return this.proxy("properties.promotion_id") || this.proxy("properties.promotionId");
};
we.cartId = function() {
  return this.proxy("properties.cart_id") || this.proxy("properties.cartId");
};
we.checkoutId = function() {
  return this.proxy("properties.checkout_id") || this.proxy("properties.checkoutId");
};
we.paymentId = function() {
  return this.proxy("properties.payment_id") || this.proxy("properties.paymentId");
};
we.couponId = function() {
  return this.proxy("properties.coupon_id") || this.proxy("properties.couponId");
};
we.wishlistId = function() {
  return this.proxy("properties.wishlist_id") || this.proxy("properties.wishlistId");
};
we.reviewId = function() {
  return this.proxy("properties.review_id") || this.proxy("properties.reviewId");
};
we.orderId = function() {
  return this.proxy("properties.id") || this.proxy("properties.order_id") || this.proxy("properties.orderId");
};
we.sku = Xe.Facade.proxy("properties.sku");
we.tax = Xe.Facade.proxy("properties.tax");
we.name = Xe.Facade.proxy("properties.name");
we.price = Xe.Facade.proxy("properties.price");
we.total = Xe.Facade.proxy("properties.total");
we.repeat = Xe.Facade.proxy("properties.repeat");
we.coupon = Xe.Facade.proxy("properties.coupon");
we.shipping = Xe.Facade.proxy("properties.shipping");
we.discount = Xe.Facade.proxy("properties.discount");
we.shippingMethod = function() {
  return this.proxy("properties.shipping_method") || this.proxy("properties.shippingMethod");
};
we.paymentMethod = function() {
  return this.proxy("properties.payment_method") || this.proxy("properties.paymentMethod");
};
we.description = Xe.Facade.proxy("properties.description");
we.plan = Xe.Facade.proxy("properties.plan");
we.subtotal = function() {
  var e = k1.default(this.properties(), "subtotal"), t = this.total() || this.revenue();
  if (e)
    return e;
  if (!t)
    return 0;
  if (this.total()) {
    var n = this.tax();
    n && (t -= n), n = this.shipping(), n && (t -= n), n = this.discount(), n && (t += n);
  }
  return t;
};
we.products = function() {
  var e = this.properties(), t = k1.default(e, "products");
  return Array.isArray(t) ? t.filter(function(n) {
    return n !== null;
  }) : [];
};
we.quantity = function() {
  var e = this.obj.properties || {};
  return e.quantity || 1;
};
we.currency = function() {
  var e = this.obj.properties || {};
  return e.currency || "USD";
};
we.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
we.query = Xe.Facade.proxy("options.query");
we.properties = function(e) {
  var t = this.field("properties") || {};
  e = e || {};
  for (var n in e)
    if (Object.prototype.hasOwnProperty.call(e, n)) {
      var r = this[n] == null ? this.proxy("properties." + n) : this[n]();
      if (r == null)
        continue;
      t[e[n]] = r, delete t[n];
    }
  return t;
};
we.username = function() {
  return this.proxy("traits.username") || this.proxy("properties.username") || this.userId() || this.sessionId();
};
we.email = function() {
  var e = this.proxy("traits.email") || this.proxy("properties.email") || this.proxy("options.traits.email");
  if (e)
    return e;
  var t = this.userId();
  if (D2.default(t))
    return t;
};
we.revenue = function() {
  var e = this.proxy("properties.revenue"), t = this.event(), n = /^[ _]?completed[ _]?order[ _]?|^[ _]?order[ _]?completed[ _]?$/i;
  return !e && t && t.match(n) && (e = this.proxy("properties.total")), L2(e);
};
we.cents = function() {
  var e = this.revenue();
  return typeof e != "number" ? this.value() || 0 : e * 100;
};
we.identify = function() {
  var e = this.json();
  return e.traits = this.traits(), new M2.Identify(e, this.opts);
};
function L2(e) {
  if (e) {
    if (typeof e == "number")
      return e;
    if (typeof e == "string" && (e = e.replace(/\$/g, ""), e = parseFloat(e), !isNaN(e)))
      return e;
  }
}
var oi = {}, B1 = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(oi, "__esModule", { value: !0 });
oi.Page = void 0;
var A2 = B1(sr), cr = nn, E2 = ia, j2 = B1(ra);
function Os(e, t) {
  cr.Facade.call(this, e, t);
}
oi.Page = Os;
A2.default(Os, cr.Facade);
var wt = Os.prototype;
wt.action = function() {
  return "page";
};
wt.type = wt.action;
wt.category = cr.Facade.field("category");
wt.name = cr.Facade.field("name");
wt.title = cr.Facade.proxy("properties.title");
wt.path = cr.Facade.proxy("properties.path");
wt.url = cr.Facade.proxy("properties.url");
wt.referrer = function() {
  return this.proxy("context.referrer.url") || this.proxy("context.page.referrer") || this.proxy("properties.referrer");
};
wt.properties = function(e) {
  var t = this.field("properties") || {}, n = this.category(), r = this.name();
  e = e || {}, n && (t.category = n), r && (t.name = r);
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var i = this[a] == null ? this.proxy("properties." + a) : this[a]();
      if (i == null)
        continue;
      t[e[a]] = i, a !== e[a] && delete t[a];
    }
  return t;
};
wt.email = function() {
  var e = this.proxy("context.traits.email") || this.proxy("properties.email");
  if (e)
    return e;
  var t = this.userId();
  if (j2.default(t))
    return t;
};
wt.fullName = function() {
  var e = this.category(), t = this.name();
  return t && e ? e + " " + t : t;
};
wt.event = function(e) {
  return e ? "Viewed " + e + " Page" : "Loaded a Page";
};
wt.track = function(e) {
  var t = this.json();
  return t.event = this.event(e), t.timestamp = this.timestamp(), t.properties = this.properties(), new E2.Track(t, this.opts);
};
var Fo = {}, I2 = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Fo, "__esModule", { value: !0 });
Fo.Screen = void 0;
var S2 = I2(sr), O1 = oi, x2 = ia;
function tr(e, t) {
  O1.Page.call(this, e, t);
}
Fo.Screen = tr;
S2.default(tr, O1.Page);
tr.prototype.action = function() {
  return "screen";
};
tr.prototype.type = tr.prototype.action;
tr.prototype.event = function(e) {
  return e ? "Viewed " + e + " Screen" : "Loaded a Screen";
};
tr.prototype.track = function(e) {
  var t = this.json();
  return t.event = this.event(e), t.timestamp = this.timestamp(), t.properties = this.properties(), new x2.Track(t, this.opts);
};
var Uo = {}, T2 = Pe && Pe.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Uo, "__esModule", { value: !0 });
Uo.Delete = void 0;
var N2 = T2(sr), P1 = nn;
function Ps(e, t) {
  P1.Facade.call(this, e, t);
}
Uo.Delete = Ps;
N2.default(Ps, P1.Facade);
Ps.prototype.type = function() {
  return "delete";
};
(function(e) {
  var t = Pe && Pe.__assign || function() {
    return t = Object.assign || function(c) {
      for (var d, g = 1, p = arguments.length; g < p; g++) {
        d = arguments[g];
        for (var h in d)
          Object.prototype.hasOwnProperty.call(d, h) && (c[h] = d[h]);
      }
      return c;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Delete = e.Screen = e.Page = e.Track = e.Identify = e.Group = e.Alias = e.Facade = void 0;
  var n = nn;
  Object.defineProperty(e, "Facade", { enumerable: !0, get: function() {
    return n.Facade;
  } });
  var r = Po;
  Object.defineProperty(e, "Alias", { enumerable: !0, get: function() {
    return r.Alias;
  } });
  var a = zo;
  Object.defineProperty(e, "Group", { enumerable: !0, get: function() {
    return a.Group;
  } });
  var i = ii;
  Object.defineProperty(e, "Identify", { enumerable: !0, get: function() {
    return i.Identify;
  } });
  var o = ia;
  Object.defineProperty(e, "Track", { enumerable: !0, get: function() {
    return o.Track;
  } });
  var f = oi;
  Object.defineProperty(e, "Page", { enumerable: !0, get: function() {
    return f.Page;
  } });
  var s = Fo;
  Object.defineProperty(e, "Screen", { enumerable: !0, get: function() {
    return s.Screen;
  } });
  var u = Uo;
  Object.defineProperty(e, "Delete", { enumerable: !0, get: function() {
    return u.Delete;
  } }), e.default = t(t({}, n.Facade), {
    Alias: r.Alias,
    Group: a.Group,
    Identify: i.Identify,
    Track: o.Track,
    Page: f.Page,
    Screen: s.Screen,
    Delete: u.Delete
  });
})(An);
function k2() {
  return typeof window < "u";
}
const B2 = () => k2() ? window.navigator.onLine : !0, Du = () => !B2();
function Jr(e, t) {
  let n;
  return globalThis.Zone && typeof globalThis.Zone.__symbol__ == "function" && (n = e[globalThis.Zone.__symbol__(t)]), n || (n = e[t]), n;
}
function O2() {
  let e;
  if (window.Zone && (e = Jr(window, "MutationObserver"), window.MutationObserver && e === window.MutationObserver)) {
    const t = new window.MutationObserver(() => {
    }), n = Jr(
      t,
      "originalInstance"
    );
    e = n && n.constructor;
  }
  return e || (e = window.MutationObserver), e;
}
class P2 {
  constructor(t) {
    this.callbacks = [], t && this.callbacks.push(t);
    const n = O2();
    this._observer = new n(() => {
      this.callbacks.forEach((r) => r([]));
    });
  }
  addCallback(t) {
    this.callbacks.push(t);
  }
  observe(t, n) {
    this._observer.observe(t, n);
  }
  disconnect() {
    this._observer.disconnect();
  }
}
function qt(e, t, n, r) {
  return Jr(e, "addEventListener").call(e, t, n, r);
}
function cn(e, t, n, r) {
  return Jr(e, "removeEventListener").call(e, t, n, r);
}
const nr = (e, t) => Jr(globalThis, "setTimeout")(e, t), z2 = (e) => Jr(globalThis, "clearTimeout")(e), R2 = "onRemoveFromFuture";
class F2 extends To {
  constructor(t, n, r) {
    super(), this.future = [], this.maxAttempts = t, this.queue = n, this.seen = r ?? {};
  }
  push(...t) {
    const n = t.map((r) => this.updateAttempts(r) > this.maxAttempts || this.includes(r) ? !1 : (this.queue.push(r), !0));
    return this.queue = this.queue.sort(
      (r, a) => this.getAttempts(r) - this.getAttempts(a)
    ), n;
  }
  pushWithBackoff(t) {
    if (this.getAttempts(t) === 0)
      return this.push(t)[0];
    const n = this.updateAttempts(t);
    if (n > this.maxAttempts || this.includes(t))
      return !1;
    const r = u1({ attempt: n - 1 });
    return nr(() => {
      this.queue.push(t), this.future = this.future.filter((a) => a.id !== t.id), this.emit(R2);
    }, r), this.future.push(t), !0;
  }
  getAttempts(t) {
    return this.seen[t.id] ?? 0;
  }
  updateAttempts(t) {
    return this.seen[t.id] = this.getAttempts(t) + 1, this.getAttempts(t);
  }
  includes(t) {
    return this.queue.includes(t) || this.future.includes(t) || !!this.queue.find((n) => n.id === t.id) || !!this.future.find((n) => n.id === t.id);
  }
  pop() {
    return this.queue.shift();
  }
  get length() {
    return this.queue.length;
  }
  get todo() {
    return this.queue.length + this.future.length;
  }
}
function z1(e) {
  const t = localStorage.getItem(e);
  return (t ? JSON.parse(t) : []).map(
    (n) => new Nr(n.event, n.id)
  );
}
function U2(e, t) {
  const n = z1(e), a = [...t, ...n].reduce((i, o) => ({
    ...i,
    [o.id]: o
  }), {});
  localStorage.setItem(e, JSON.stringify(Object.values(a)));
}
function R1(e) {
  const t = localStorage.getItem(e);
  return t ? JSON.parse(t) : {};
}
function Y2(e, t) {
  const n = R1(e);
  localStorage.setItem(
    e,
    JSON.stringify({
      ...n,
      ...t
    })
  );
}
function cl(e) {
  localStorage.removeItem(e);
}
const G2 = () => (/* @__PURE__ */ new Date()).getTime();
function Lu(e, t, n = 0) {
  const a = `persisted-queue:v1:${e}:lock`, i = (u) => (/* @__PURE__ */ new Date()).getTime() > u, o = localStorage.getItem(a), f = o ? JSON.parse(o) : null, s = f === null || i(f);
  if (s) {
    localStorage.setItem(a, JSON.stringify(G2() + 50)), t(), localStorage.removeItem(a);
    return;
  }
  !s && n < 3 ? nr(() => {
    Lu(e, t, n + 1);
  }, 50) : console.error("Unable to retrieve lock");
}
class H2 extends F2 {
  constructor(t, n) {
    super(t, []);
    const r = `persisted-queue:v1:${n}:items`, a = `persisted-queue:v1:${n}:seen`;
    let i = [], o = {};
    Lu(n, () => {
      try {
        i = z1(r), o = R1(a), cl(r), cl(a), this.queue = [...i, ...this.queue], this.seen = { ...o, ...this.seen };
      } catch (f) {
        console.error(f);
      }
    }), qt(window, "pagehide", () => {
      if (this.todo > 0) {
        const f = [...this.queue, ...this.future];
        try {
          Lu(n, () => {
            U2(r, f), Y2(a, this.seen);
          });
        } catch (s) {
          console.error(s);
        }
      }
    });
  }
}
function Q2(e, t) {
  let n = new An.Facade(e, t);
  return e.type === "track" && (n = new An.Track(e, t)), e.type === "identify" && (n = new An.Identify(e, t)), e.type === "page" && (n = new An.Page(e, t)), e.type === "alias" && (n = new An.Alias(e, t)), e.type === "group" && (n = new An.Group(e, t)), e.type === "screen" && (n = new An.Screen(e, t)), Object.defineProperty(n, "obj", {
    value: e,
    writable: !0
  }), n;
}
/*! js-cookie v3.0.5 | MIT */
function Li(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var J2 = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Au(e, t) {
  function n(a, i, o) {
    if (!(typeof document > "u")) {
      o = Li({}, t, o), typeof o.expires == "number" && (o.expires = new Date(Date.now() + o.expires * 864e5)), o.expires && (o.expires = o.expires.toUTCString()), a = encodeURIComponent(a).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var s in o)
        o[s] && (f += "; " + s, o[s] !== !0 && (f += "=" + o[s].split(";")[0]));
      return document.cookie = a + "=" + e.write(i, a) + f;
    }
  }
  function r(a) {
    if (!(typeof document > "u" || arguments.length && !a)) {
      for (var i = document.cookie ? document.cookie.split("; ") : [], o = {}, f = 0; f < i.length; f++) {
        var s = i[f].split("="), u = s.slice(1).join("=");
        try {
          var c = decodeURIComponent(s[0]);
          if (o[c] = e.read(u, c), a === c)
            break;
        } catch {
        }
      }
      return a ? o[a] : o;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(a, i) {
        n(
          a,
          "",
          Li({}, i, {
            expires: -1
          })
        );
      },
      withAttributes: function(a) {
        return Au(this.converter, Li({}, this.attributes, a));
      },
      withConverter: function(a) {
        return Au(Li({}, this.converter, a), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var Or = Au(J2, { path: "/" });
function W2(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch {
    return e;
  }
}
const _2 = "fjs", Z2 = "test", Mf = `${_2}:cookies`, $2 = () => {
  const e = window.location.hostname.split(".");
  for (let t = e.length - 1; t >= 0; t--) {
    const n = e.slice(t).join("."), r = { domain: "." + n };
    try {
      if (Or.set(Mf, Z2, r), Or.get(Mf))
        return Or.remove(Mf, r), n;
    } catch {
      return;
    }
  }
}, V2 = "@flywheelapp/flywheel.js", K2 = "module", q2 = "./index.cjs", X2 = "./index.js", e4 = {
  ".": {
    import: "./index.js",
    require: "./index.cjs"
  },
  "./style.css": {
    import: "./style.css",
    require: "./style.css"
  }
}, t4 = "1.0.116", n4 = {
  "@flywheelapp/rrweb": "2.0.0-alpha.15",
  "@flywheelapp/ui": "^0.1.23",
  "@rrweb/packer": "^2.0.0-alpha.15",
  "@rrweb/rrweb-plugin-console-record": "^2.0.0-alpha.15",
  "@segment/analytics-core": "^1.3.2",
  "@segment/analytics-next": "^1.58.0",
  "@segment/facade": "^3.4.10",
  "@stdlib/number-float64-base-normalize": "0.0.8",
  "change-case": "^4.1.2",
  "js-cookie": "^3.0.5",
  react: "^18.2.0",
  "react-dom": "^18.2.0"
}, r4 = {
  "@rrweb/types": "^2.0.0-alpha.15"
}, a4 = {
  name: V2,
  type: K2,
  main: q2,
  module: X2,
  exports: e4,
  version: t4,
  dependencies: n4,
  devDependencies: r4
};
function i4(e) {
  return e.toLowerCase();
}
var o4 = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g], f4 = /[^A-Z0-9]+/gi;
function F1(e, t) {
  t === void 0 && (t = {});
  for (var n = t.splitRegexp, r = n === void 0 ? o4 : n, a = t.stripRegexp, i = a === void 0 ? f4 : a, o = t.transform, f = o === void 0 ? i4 : o, s = t.delimiter, u = s === void 0 ? " " : s, c = ll(ll(e, r, "$1\0$2"), i, "\0"), d = 0, g = c.length; c.charAt(d) === "\0"; )
    d++;
  for (; c.charAt(g - 1) === "\0"; )
    g--;
  return c.slice(d, g).split("\0").map(f).join(u);
}
function ll(e, t, n) {
  return t instanceof RegExp ? e.replace(t, n) : t.reduce(function(r, a) {
    return r.replace(a, n);
  }, e);
}
function U1(e, t) {
  var n = e.charAt(0), r = e.substr(1).toLowerCase();
  return t > 0 && n >= "0" && n <= "9" ? "_" + n + r : "" + n.toUpperCase() + r;
}
function u4(e, t) {
  return t === void 0 && (t = {}), F1(e, oe({ delimiter: "", transform: U1 }, t));
}
function s4(e, t) {
  return t === 0 ? e.toLowerCase() : U1(e, t);
}
function c4(e, t) {
  return t === void 0 && (t = {}), u4(e, oe({ transform: s4 }, t));
}
function l4(e) {
  return e.charAt(0).toUpperCase() + e.substr(1);
}
function d4(e, t) {
  var n = e.toLowerCase();
  return t === 0 ? l4(n) : n;
}
function Ya(e, t) {
  return t === void 0 && (t = {}), F1(e, oe({ delimiter: " ", transform: d4 }, t));
}
const g4 = {
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Caribbean Netherlands",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos Islands",
  CD: "Democratic Republic of the Congo",
  CF: "Central African Republic",
  CG: "Republic of the Congo",
  CH: "Switzerland",
  CI: "Ivory Coast",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cabo Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czechia",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Eswatini",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States of America",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands (UK)",
  VI: "Virgin Islands (US)",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe"
}, p4 = {
  "Africa/Abidjan": {
    countryCodes: [
      "CI",
      "BF",
      "GH",
      "GM",
      "GN",
      "IS",
      "ML",
      "MR",
      "SH",
      "SL",
      "SN",
      "TG"
    ]
  },
  "Africa/Accra": {
    countryCodes: ["GH"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Addis_Ababa": {
    countryCodes: ["ET"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Algiers": {
    countryCodes: ["DZ"]
  },
  "Africa/Asmara": {
    countryCodes: ["ER"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Asmera": {
    countryCodes: ["ER"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Bamako": {
    countryCodes: ["ML"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Bangui": {
    countryCodes: ["CF"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Banjul": {
    countryCodes: ["GM"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Bissau": {
    countryCodes: ["GW"]
  },
  "Africa/Blantyre": {
    countryCodes: ["MW"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Brazzaville": {
    countryCodes: ["CG"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Bujumbura": {
    countryCodes: ["BI"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Cairo": {
    countryCodes: ["EG"]
  },
  "Africa/Casablanca": {
    countryCodes: ["MA"]
  },
  "Africa/Ceuta": {
    countryCodes: ["ES"]
  },
  "Africa/Conakry": {
    countryCodes: ["GN"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Dakar": {
    countryCodes: ["SN"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Dar_es_Salaam": {
    countryCodes: ["TZ"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Djibouti": {
    countryCodes: ["DJ"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Douala": {
    countryCodes: ["CM"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/El_Aaiun": {
    countryCodes: ["EH"]
  },
  "Africa/Freetown": {
    countryCodes: ["SL"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Gaborone": {
    countryCodes: ["BW"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Harare": {
    countryCodes: ["ZW"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Johannesburg": {
    countryCodes: ["ZA", "LS", "SZ"]
  },
  "Africa/Juba": {
    countryCodes: ["SS"]
  },
  "Africa/Kampala": {
    countryCodes: ["UG"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Khartoum": {
    countryCodes: ["SD"]
  },
  "Africa/Kigali": {
    countryCodes: ["RW"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Kinshasa": {
    countryCodes: ["CD"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Lagos": {
    countryCodes: ["NG", "AO", "BJ", "CD", "CF", "CG", "CM", "GA", "GQ", "NE"]
  },
  "Africa/Libreville": {
    countryCodes: ["GA"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Lome": {
    countryCodes: ["TG"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Luanda": {
    countryCodes: ["AO"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Lubumbashi": {
    countryCodes: ["CD"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Lusaka": {
    countryCodes: ["ZM"],
    tzIdentifierRef: "Africa/Maputo"
  },
  "Africa/Malabo": {
    countryCodes: ["GQ"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Maputo": {
    countryCodes: ["MZ", "BI", "BW", "CD", "MW", "RW", "ZM", "ZW"]
  },
  "Africa/Maseru": {
    countryCodes: ["LS"],
    tzIdentifierRef: "Africa/Johannesburg"
  },
  "Africa/Mbabane": {
    countryCodes: ["SZ"],
    tzIdentifierRef: "Africa/Johannesburg"
  },
  "Africa/Mogadishu": {
    countryCodes: ["SO"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Africa/Monrovia": {
    countryCodes: ["LR"]
  },
  "Africa/Nairobi": {
    countryCodes: ["KE", "DJ", "ER", "ET", "KM", "MG", "SO", "TZ", "UG", "YT"]
  },
  "Africa/Ndjamena": {
    countryCodes: ["TD"]
  },
  "Africa/Niamey": {
    countryCodes: ["NE"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Nouakchott": {
    countryCodes: ["MR"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Ouagadougou": {
    countryCodes: ["BF"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Porto-Novo": {
    countryCodes: ["BJ"],
    tzIdentifierRef: "Africa/Lagos"
  },
  "Africa/Sao_Tome": {
    countryCodes: ["ST"]
  },
  "Africa/Timbuktu": {
    countryCodes: ["ML"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Africa/Tripoli": {
    countryCodes: ["LY"]
  },
  "Africa/Tunis": {
    countryCodes: ["TN"]
  },
  "Africa/Windhoek": {
    countryCodes: ["NA"]
  },
  "America/Adak": {
    countryCodes: ["US"]
  },
  "America/Anchorage": {
    countryCodes: ["US"]
  },
  "America/Anguilla": {
    countryCodes: ["AI"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Antigua": {
    countryCodes: ["AG"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Araguaina": {
    countryCodes: ["BR"]
  },
  "America/Argentina/Buenos_Aires": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Catamarca": {
    countryCodes: ["AR"]
  },
  "America/Argentina/ComodRivadavia": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Catamarca"
  },
  "America/Argentina/Cordoba": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Jujuy": {
    countryCodes: ["AR"]
  },
  "America/Argentina/La_Rioja": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Mendoza": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Rio_Gallegos": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Salta": {
    countryCodes: ["AR"]
  },
  "America/Argentina/San_Juan": {
    countryCodes: ["AR"]
  },
  "America/Argentina/San_Luis": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Tucuman": {
    countryCodes: ["AR"]
  },
  "America/Argentina/Ushuaia": {
    countryCodes: ["AR"]
  },
  "America/Aruba": {
    countryCodes: ["AW"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Asuncion": {
    countryCodes: ["PY"]
  },
  "America/Atikokan": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Panama"
  },
  "America/Atka": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Adak"
  },
  "America/Bahia": {
    countryCodes: ["BR"]
  },
  "America/Bahia_Banderas": {
    countryCodes: ["MX"]
  },
  "America/Barbados": {
    countryCodes: ["BB"]
  },
  "America/Belem": {
    countryCodes: ["BR"]
  },
  "America/Belize": {
    countryCodes: ["BZ"]
  },
  "America/Blanc-Sablon": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Boa_Vista": {
    countryCodes: ["BR"]
  },
  "America/Bogota": {
    countryCodes: ["CO"]
  },
  "America/Boise": {
    countryCodes: ["US"]
  },
  "America/Buenos_Aires": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Buenos_Aires"
  },
  "America/Cambridge_Bay": {
    countryCodes: ["CA"]
  },
  "America/Campo_Grande": {
    countryCodes: ["BR"]
  },
  "America/Cancun": {
    countryCodes: ["MX"]
  },
  "America/Caracas": {
    countryCodes: ["VE"]
  },
  "America/Catamarca": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Catamarca"
  },
  "America/Cayenne": {
    countryCodes: ["GF"]
  },
  "America/Cayman": {
    countryCodes: ["KY"],
    tzIdentifierRef: "America/Panama"
  },
  "America/Chicago": {
    countryCodes: ["US"]
  },
  "America/Chihuahua": {
    countryCodes: ["MX"]
  },
  "America/Ciudad_Juarez": {
    countryCodes: ["MX"]
  },
  "America/Coral_Harbour": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Panama"
  },
  "America/Cordoba": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Cordoba"
  },
  "America/Costa_Rica": {
    countryCodes: ["CR"]
  },
  "America/Creston": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Phoenix"
  },
  "America/Cuiaba": {
    countryCodes: ["BR"]
  },
  "America/Curacao": {
    countryCodes: ["CW"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Danmarkshavn": {
    countryCodes: ["GL"]
  },
  "America/Dawson": {
    countryCodes: ["CA"]
  },
  "America/Dawson_Creek": {
    countryCodes: ["CA"]
  },
  "America/Denver": {
    countryCodes: ["US"]
  },
  "America/Detroit": {
    countryCodes: ["US"]
  },
  "America/Dominica": {
    countryCodes: ["DM"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Edmonton": {
    countryCodes: ["CA"]
  },
  "America/Eirunepe": {
    countryCodes: ["BR"]
  },
  "America/El_Salvador": {
    countryCodes: ["SV"]
  },
  "America/Ensenada": {
    countryCodes: ["MX"],
    tzIdentifierRef: "America/Tijuana"
  },
  "America/Fort_Nelson": {
    countryCodes: ["CA"]
  },
  "America/Fort_Wayne": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Indiana/Indianapolis"
  },
  "America/Fortaleza": {
    countryCodes: ["BR"]
  },
  "America/Glace_Bay": {
    countryCodes: ["CA"]
  },
  "America/Godthab": {
    countryCodes: ["GL"],
    tzIdentifierRef: "America/Nuuk"
  },
  "America/Goose_Bay": {
    countryCodes: ["CA"]
  },
  "America/Grand_Turk": {
    countryCodes: ["TC"]
  },
  "America/Grenada": {
    countryCodes: ["GD"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Guadeloupe": {
    countryCodes: ["GP"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Guatemala": {
    countryCodes: ["GT"]
  },
  "America/Guayaquil": {
    countryCodes: ["EC"]
  },
  "America/Guyana": {
    countryCodes: ["GY"]
  },
  "America/Halifax": {
    countryCodes: ["CA"]
  },
  "America/Havana": {
    countryCodes: ["CU"]
  },
  "America/Hermosillo": {
    countryCodes: ["MX"]
  },
  "America/Indiana/Indianapolis": {
    countryCodes: ["US"]
  },
  "America/Indiana/Knox": {
    countryCodes: ["US"]
  },
  "America/Indiana/Marengo": {
    countryCodes: ["US"]
  },
  "America/Indiana/Petersburg": {
    countryCodes: ["US"]
  },
  "America/Indiana/Tell_City": {
    countryCodes: ["US"]
  },
  "America/Indiana/Vevay": {
    countryCodes: ["US"]
  },
  "America/Indiana/Vincennes": {
    countryCodes: ["US"]
  },
  "America/Indiana/Winamac": {
    countryCodes: ["US"]
  },
  "America/Indianapolis": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Indiana/Indianapolis"
  },
  "America/Inuvik": {
    countryCodes: ["CA"]
  },
  "America/Iqaluit": {
    countryCodes: ["CA"]
  },
  "America/Jamaica": {
    countryCodes: ["JM"]
  },
  "America/Jujuy": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Jujuy"
  },
  "America/Juneau": {
    countryCodes: ["US"]
  },
  "America/Kentucky/Louisville": {
    countryCodes: ["US"]
  },
  "America/Kentucky/Monticello": {
    countryCodes: ["US"]
  },
  "America/Knox_IN": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Indiana/Knox"
  },
  "America/Kralendijk": {
    countryCodes: ["BQ"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/La_Paz": {
    countryCodes: ["BO"]
  },
  "America/Lima": {
    countryCodes: ["PE"]
  },
  "America/Los_Angeles": {
    countryCodes: ["US"]
  },
  "America/Louisville": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Kentucky/Louisville"
  },
  "America/Lower_Princes": {
    countryCodes: ["SX"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Maceio": {
    countryCodes: ["BR"]
  },
  "America/Managua": {
    countryCodes: ["NI"]
  },
  "America/Manaus": {
    countryCodes: ["BR"]
  },
  "America/Marigot": {
    countryCodes: ["MF"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Martinique": {
    countryCodes: ["MQ"]
  },
  "America/Matamoros": {
    countryCodes: ["MX"]
  },
  "America/Mazatlan": {
    countryCodes: ["MX"]
  },
  "America/Mendoza": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Mendoza"
  },
  "America/Menominee": {
    countryCodes: ["US"]
  },
  "America/Merida": {
    countryCodes: ["MX"]
  },
  "America/Metlakatla": {
    countryCodes: ["US"]
  },
  "America/Mexico_City": {
    countryCodes: ["MX"]
  },
  "America/Miquelon": {
    countryCodes: ["PM"]
  },
  "America/Moncton": {
    countryCodes: ["CA"]
  },
  "America/Monterrey": {
    countryCodes: ["MX"]
  },
  "America/Montevideo": {
    countryCodes: ["UY"]
  },
  "America/Montreal": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Toronto"
  },
  "America/Montserrat": {
    countryCodes: ["MS"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Nassau": {
    countryCodes: ["BS"],
    tzIdentifierRef: "America/Toronto"
  },
  "America/New_York": {
    countryCodes: ["US"]
  },
  "America/Nipigon": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Toronto"
  },
  "America/Nome": {
    countryCodes: ["US"]
  },
  "America/Noronha": {
    countryCodes: ["BR"]
  },
  "America/North_Dakota/Beulah": {
    countryCodes: ["US"]
  },
  "America/North_Dakota/Center": {
    countryCodes: ["US"]
  },
  "America/North_Dakota/New_Salem": {
    countryCodes: ["US"]
  },
  "America/Nuuk": {
    countryCodes: ["GL"]
  },
  "America/Ojinaga": {
    countryCodes: ["MX"]
  },
  "America/Panama": {
    countryCodes: ["PA", "CA", "KY"]
  },
  "America/Pangnirtung": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Iqaluit"
  },
  "America/Paramaribo": {
    countryCodes: ["SR"]
  },
  "America/Phoenix": {
    countryCodes: ["US", "CA"]
  },
  "America/Port-au-Prince": {
    countryCodes: ["HT"]
  },
  "America/Port_of_Spain": {
    countryCodes: ["TT"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Porto_Acre": {
    countryCodes: ["BR"],
    tzIdentifierRef: "America/Rio_Branco"
  },
  "America/Porto_Velho": {
    countryCodes: ["BR"]
  },
  "America/Puerto_Rico": {
    countryCodes: [
      "PR",
      "AG",
      "CA",
      "AI",
      "AW",
      "BL",
      "BQ",
      "CW",
      "DM",
      "GD",
      "GP",
      "KN",
      "LC",
      "MF",
      "MS",
      "SX",
      "TT",
      "VC",
      "VG",
      "VI"
    ]
  },
  "America/Punta_Arenas": {
    countryCodes: ["CL"]
  },
  "America/Rainy_River": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Winnipeg"
  },
  "America/Rankin_Inlet": {
    countryCodes: ["CA"]
  },
  "America/Recife": {
    countryCodes: ["BR"]
  },
  "America/Regina": {
    countryCodes: ["CA"]
  },
  "America/Resolute": {
    countryCodes: ["CA"]
  },
  "America/Rio_Branco": {
    countryCodes: ["BR"]
  },
  "America/Rosario": {
    countryCodes: ["AR"],
    tzIdentifierRef: "America/Argentina/Cordoba"
  },
  "America/Santa_Isabel": {
    countryCodes: ["MX"],
    tzIdentifierRef: "America/Tijuana"
  },
  "America/Santarem": {
    countryCodes: ["BR"]
  },
  "America/Santiago": {
    countryCodes: ["CL"]
  },
  "America/Santo_Domingo": {
    countryCodes: ["DO"]
  },
  "America/Sao_Paulo": {
    countryCodes: ["BR"]
  },
  "America/Scoresbysund": {
    countryCodes: ["GL"]
  },
  "America/Shiprock": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Denver"
  },
  "America/Sitka": {
    countryCodes: ["US"]
  },
  "America/St_Barthelemy": {
    countryCodes: ["BL"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/St_Johns": {
    countryCodes: ["CA"]
  },
  "America/St_Kitts": {
    countryCodes: ["KN"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/St_Lucia": {
    countryCodes: ["LC"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/St_Thomas": {
    countryCodes: ["VI"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/St_Vincent": {
    countryCodes: ["VC"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Swift_Current": {
    countryCodes: ["CA"]
  },
  "America/Tegucigalpa": {
    countryCodes: ["HN"]
  },
  "America/Thule": {
    countryCodes: ["GL"]
  },
  "America/Thunder_Bay": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Toronto"
  },
  "America/Tijuana": {
    countryCodes: ["MX"]
  },
  "America/Toronto": {
    countryCodes: ["CA", "BS"]
  },
  "America/Tortola": {
    countryCodes: ["VG"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Vancouver": {
    countryCodes: ["CA"]
  },
  "America/Virgin": {
    countryCodes: ["VI"],
    tzIdentifierRef: "America/Puerto_Rico"
  },
  "America/Whitehorse": {
    countryCodes: ["CA"]
  },
  "America/Winnipeg": {
    countryCodes: ["CA"]
  },
  "America/Yakutat": {
    countryCodes: ["US"]
  },
  "America/Yellowknife": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Edmonton"
  },
  "Antarctica/Casey": {
    countryCodes: ["AQ"]
  },
  "Antarctica/Davis": {
    countryCodes: ["AQ"]
  },
  "Antarctica/DumontDUrville": {
    countryCodes: ["AQ"],
    tzIdentifierRef: "Pacific/Port_Moresby"
  },
  "Antarctica/Macquarie": {
    countryCodes: ["AU"]
  },
  "Antarctica/Mawson": {
    countryCodes: ["AQ"]
  },
  "Antarctica/McMurdo": {
    countryCodes: ["AQ"],
    tzIdentifierRef: "Pacific/Auckland"
  },
  "Antarctica/Palmer": {
    countryCodes: ["AQ"]
  },
  "Antarctica/Rothera": {
    countryCodes: ["AQ"]
  },
  "Antarctica/South_Pole": {
    countryCodes: ["AQ"],
    tzIdentifierRef: "Pacific/Auckland"
  },
  "Antarctica/Syowa": {
    countryCodes: ["AQ"],
    tzIdentifierRef: "Asia/Riyadh"
  },
  "Antarctica/Troll": {
    countryCodes: ["AQ"]
  },
  "Antarctica/Vostok": {
    countryCodes: ["AQ"],
    tzIdentifierRef: "Asia/Urumqi"
  },
  "Arctic/Longyearbyen": {
    countryCodes: ["SJ"],
    tzIdentifierRef: "Europe/Berlin"
  },
  "Asia/Aden": {
    countryCodes: ["YE"],
    tzIdentifierRef: "Asia/Riyadh"
  },
  "Asia/Almaty": {
    countryCodes: ["KZ"]
  },
  "Asia/Amman": {
    countryCodes: ["JO"]
  },
  "Asia/Anadyr": {
    countryCodes: ["RU"]
  },
  "Asia/Aqtau": {
    countryCodes: ["KZ"]
  },
  "Asia/Aqtobe": {
    countryCodes: ["KZ"]
  },
  "Asia/Ashgabat": {
    countryCodes: ["TM"]
  },
  "Asia/Ashkhabad": {
    countryCodes: ["TM"],
    tzIdentifierRef: "Asia/Ashgabat"
  },
  "Asia/Atyrau": {
    countryCodes: ["KZ"]
  },
  "Asia/Baghdad": {
    countryCodes: ["IQ"]
  },
  "Asia/Bahrain": {
    countryCodes: ["BH"],
    tzIdentifierRef: "Asia/Qatar"
  },
  "Asia/Baku": {
    countryCodes: ["AZ"]
  },
  "Asia/Bangkok": {
    countryCodes: ["TH", "CX", "KH", "LA", "VN"]
  },
  "Asia/Barnaul": {
    countryCodes: ["RU"]
  },
  "Asia/Beirut": {
    countryCodes: ["LB"]
  },
  "Asia/Bishkek": {
    countryCodes: ["KG"]
  },
  "Asia/Brunei": {
    countryCodes: ["BN"],
    tzIdentifierRef: "Asia/Kuching"
  },
  "Asia/Calcutta": {
    countryCodes: ["IN"],
    tzIdentifierRef: "Asia/Kolkata"
  },
  "Asia/Chita": {
    countryCodes: ["RU"]
  },
  "Asia/Choibalsan": {
    countryCodes: ["MN"]
  },
  "Asia/Chongqing": {
    countryCodes: ["CN"],
    tzIdentifierRef: "Asia/Shanghai"
  },
  "Asia/Chungking": {
    countryCodes: ["CN"],
    tzIdentifierRef: "Asia/Shanghai"
  },
  "Asia/Colombo": {
    countryCodes: ["LK"]
  },
  "Asia/Dacca": {
    countryCodes: ["BD"],
    tzIdentifierRef: "Asia/Dhaka"
  },
  "Asia/Damascus": {
    countryCodes: ["SY"]
  },
  "Asia/Dhaka": {
    countryCodes: ["BD"]
  },
  "Asia/Dili": {
    countryCodes: ["TL"]
  },
  "Asia/Dubai": {
    countryCodes: ["AE", "OM", "RE", "SC", "TF"]
  },
  "Asia/Dushanbe": {
    countryCodes: ["TJ"]
  },
  "Asia/Famagusta": {
    countryCodes: ["CY"]
  },
  "Asia/Gaza": {
    countryCodes: ["PS"]
  },
  "Asia/Harbin": {
    countryCodes: ["CN"],
    tzIdentifierRef: "Asia/Shanghai"
  },
  "Asia/Hebron": {
    countryCodes: ["PS"]
  },
  "Asia/Ho_Chi_Minh": {
    countryCodes: ["VN"]
  },
  "Asia/Hong_Kong": {
    countryCodes: ["HK"]
  },
  "Asia/Hovd": {
    countryCodes: ["MN"]
  },
  "Asia/Irkutsk": {
    countryCodes: ["RU"]
  },
  "Asia/Istanbul": {
    countryCodes: ["TR"],
    tzIdentifierRef: "Europe/Istanbul"
  },
  "Asia/Jakarta": {
    countryCodes: ["ID"]
  },
  "Asia/Jayapura": {
    countryCodes: ["ID"]
  },
  "Asia/Jerusalem": {
    countryCodes: ["IL"]
  },
  "Asia/Kabul": {
    countryCodes: ["AF"]
  },
  "Asia/Kamchatka": {
    countryCodes: ["RU"]
  },
  "Asia/Karachi": {
    countryCodes: ["PK"]
  },
  "Asia/Kashgar": {
    countryCodes: ["CN"],
    tzIdentifierRef: "Asia/Urumqi[note 1]"
  },
  "Asia/Kathmandu": {
    countryCodes: ["NP"]
  },
  "Asia/Katmandu": {
    countryCodes: ["NP"],
    tzIdentifierRef: "Asia/Kathmandu"
  },
  "Asia/Khandyga": {
    countryCodes: ["RU"]
  },
  "Asia/Kolkata": {
    countryCodes: ["IN"]
  },
  "Asia/Krasnoyarsk": {
    countryCodes: ["RU"]
  },
  "Asia/Kuala_Lumpur": {
    countryCodes: ["MY"],
    tzIdentifierRef: "Asia/Singapore"
  },
  "Asia/Kuching": {
    countryCodes: ["MY", "BN"]
  },
  "Asia/Kuwait": {
    countryCodes: ["KW"],
    tzIdentifierRef: "Asia/Riyadh"
  },
  "Asia/Macao": {
    countryCodes: ["MO"],
    tzIdentifierRef: "Asia/Macau"
  },
  "Asia/Macau": {
    countryCodes: ["MO"]
  },
  "Asia/Magadan": {
    countryCodes: ["RU"]
  },
  "Asia/Makassar": {
    countryCodes: ["ID"]
  },
  "Asia/Manila": {
    countryCodes: ["PH"]
  },
  "Asia/Muscat": {
    countryCodes: ["OM"],
    tzIdentifierRef: "Asia/Dubai"
  },
  "Asia/Nicosia": {
    countryCodes: ["CY"]
  },
  "Asia/Novokuznetsk": {
    countryCodes: ["RU"]
  },
  "Asia/Novosibirsk": {
    countryCodes: ["RU"]
  },
  "Asia/Omsk": {
    countryCodes: ["RU"]
  },
  "Asia/Oral": {
    countryCodes: ["KZ"]
  },
  "Asia/Phnom_Penh": {
    countryCodes: ["KH"],
    tzIdentifierRef: "Asia/Bangkok"
  },
  "Asia/Pontianak": {
    countryCodes: ["ID"]
  },
  "Asia/Pyongyang": {
    countryCodes: ["KP"]
  },
  "Asia/Qatar": {
    countryCodes: ["QA", "BH"]
  },
  "Asia/Qostanay": {
    countryCodes: ["KZ"]
  },
  "Asia/Qyzylorda": {
    countryCodes: ["KZ"]
  },
  "Asia/Rangoon": {
    countryCodes: ["MM"],
    tzIdentifierRef: "Asia/Yangon"
  },
  "Asia/Riyadh": {
    countryCodes: ["SA", "AQ", "KW", "YE"]
  },
  "Asia/Saigon": {
    countryCodes: ["VN"],
    tzIdentifierRef: "Asia/Ho_Chi_Minh"
  },
  "Asia/Sakhalin": {
    countryCodes: ["RU"]
  },
  "Asia/Samarkand": {
    countryCodes: ["UZ"]
  },
  "Asia/Seoul": {
    countryCodes: ["KR"]
  },
  "Asia/Shanghai": {
    countryCodes: ["CN"]
  },
  "Asia/Singapore": {
    countryCodes: ["SG", "MY"]
  },
  "Asia/Srednekolymsk": {
    countryCodes: ["RU"]
  },
  "Asia/Taipei": {
    countryCodes: ["TW"]
  },
  "Asia/Tashkent": {
    countryCodes: ["UZ"]
  },
  "Asia/Tbilisi": {
    countryCodes: ["GE"]
  },
  "Asia/Tehran": {
    countryCodes: ["IR"]
  },
  "Asia/Tel_Aviv": {
    countryCodes: ["IL"],
    tzIdentifierRef: "Asia/Jerusalem"
  },
  "Asia/Thimbu": {
    countryCodes: ["BT"],
    tzIdentifierRef: "Asia/Thimphu"
  },
  "Asia/Thimphu": {
    countryCodes: ["BT"]
  },
  "Asia/Tokyo": {
    countryCodes: ["JP"]
  },
  "Asia/Tomsk": {
    countryCodes: ["RU"]
  },
  "Asia/Ujung_Pandang": {
    countryCodes: ["ID"],
    tzIdentifierRef: "Asia/Makassar"
  },
  "Asia/Ulaanbaatar": {
    countryCodes: ["MN"]
  },
  "Asia/Ulan_Bator": {
    countryCodes: ["MN"],
    tzIdentifierRef: "Asia/Ulaanbaatar"
  },
  "Asia/Urumqi": {
    countryCodes: ["CN", "AQ"]
  },
  "Asia/Ust-Nera": {
    countryCodes: ["RU"]
  },
  "Asia/Vientiane": {
    countryCodes: ["LA"],
    tzIdentifierRef: "Asia/Bangkok"
  },
  "Asia/Vladivostok": {
    countryCodes: ["RU"]
  },
  "Asia/Yakutsk": {
    countryCodes: ["RU"]
  },
  "Asia/Yangon": {
    countryCodes: ["MM", "CC"]
  },
  "Asia/Yekaterinburg": {
    countryCodes: ["RU"]
  },
  "Asia/Yerevan": {
    countryCodes: ["AM"]
  },
  "Atlantic/Azores": {
    countryCodes: ["PT"]
  },
  "Atlantic/Bermuda": {
    countryCodes: ["BM"]
  },
  "Atlantic/Canary": {
    countryCodes: ["ES"]
  },
  "Atlantic/Cape_Verde": {
    countryCodes: ["CV"]
  },
  "Atlantic/Faeroe": {
    countryCodes: ["FO"],
    tzIdentifierRef: "Atlantic/Faroe"
  },
  "Atlantic/Faroe": {
    countryCodes: ["FO"]
  },
  "Atlantic/Jan_Mayen": {
    countryCodes: ["SJ"],
    tzIdentifierRef: "Europe/Berlin"
  },
  "Atlantic/Madeira": {
    countryCodes: ["PT"]
  },
  "Atlantic/Reykjavik": {
    countryCodes: ["IS"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Atlantic/South_Georgia": {
    countryCodes: ["GS"]
  },
  "Atlantic/St_Helena": {
    countryCodes: ["SH"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Atlantic/Stanley": {
    countryCodes: ["FK"]
  },
  "Australia/ACT": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Sydney"
  },
  "Australia/Adelaide": {
    countryCodes: ["AU"]
  },
  "Australia/Brisbane": {
    countryCodes: ["AU"]
  },
  "Australia/Broken_Hill": {
    countryCodes: ["AU"]
  },
  "Australia/Canberra": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Sydney"
  },
  "Australia/Currie": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Hobart"
  },
  "Australia/Darwin": {
    countryCodes: ["AU"]
  },
  "Australia/Eucla": {
    countryCodes: ["AU"]
  },
  "Australia/Hobart": {
    countryCodes: ["AU"]
  },
  "Australia/LHI": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Lord_Howe"
  },
  "Australia/Lindeman": {
    countryCodes: ["AU"]
  },
  "Australia/Lord_Howe": {
    countryCodes: ["AU"]
  },
  "Australia/Melbourne": {
    countryCodes: ["AU"]
  },
  "Australia/North": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Darwin"
  },
  "Australia/NSW": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Sydney"
  },
  "Australia/Perth": {
    countryCodes: ["AU"]
  },
  "Australia/Queensland": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Brisbane"
  },
  "Australia/South": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Adelaide"
  },
  "Australia/Sydney": {
    countryCodes: ["AU"]
  },
  "Australia/Tasmania": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Hobart"
  },
  "Australia/Victoria": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Melbourne"
  },
  "Australia/West": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Perth"
  },
  "Australia/Yancowinna": {
    countryCodes: ["AU"],
    tzIdentifierRef: "Australia/Broken_Hill"
  },
  "Brazil/Acre": {
    countryCodes: ["BR"],
    tzIdentifierRef: "America/Rio_Branco"
  },
  "Brazil/DeNoronha": {
    countryCodes: ["BR"],
    tzIdentifierRef: "America/Noronha"
  },
  "Brazil/East": {
    countryCodes: ["BR"],
    tzIdentifierRef: "America/Sao_Paulo"
  },
  "Brazil/West": {
    countryCodes: ["BR"],
    tzIdentifierRef: "America/Manaus"
  },
  "Canada/Atlantic": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Halifax"
  },
  "Canada/Central": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Winnipeg"
  },
  "Canada/Eastern": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Toronto"
  },
  "Canada/Mountain": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Edmonton"
  },
  "Canada/Newfoundland": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/St_Johns"
  },
  "Canada/Pacific": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Vancouver"
  },
  "Canada/Saskatchewan": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Regina"
  },
  "Canada/Yukon": {
    countryCodes: ["CA"],
    tzIdentifierRef: "America/Whitehorse"
  },
  CET: {
    countryCodes: null
  },
  "Chile/Continental": {
    countryCodes: ["CL"],
    tzIdentifierRef: "America/Santiago"
  },
  "Chile/EasterIsland": {
    countryCodes: ["CL"],
    tzIdentifierRef: "Pacific/Easter"
  },
  CST6CDT: {
    countryCodes: null
  },
  Cuba: {
    countryCodes: ["CU"],
    tzIdentifierRef: "America/Havana"
  },
  EET: {
    countryCodes: null
  },
  Egypt: {
    countryCodes: ["EG"],
    tzIdentifierRef: "Africa/Cairo"
  },
  Eire: {
    countryCodes: ["IE"],
    tzIdentifierRef: "Europe/Dublin"
  },
  EST: {
    countryCodes: null
  },
  EST5EDT: {
    countryCodes: null
  },
  "Etc/GMT": {
    countryCodes: null
  },
  "Etc/GMT+0": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "Etc/GMT+1": {
    countryCodes: null
  },
  "Etc/GMT+10": {
    countryCodes: null
  },
  "Etc/GMT+11": {
    countryCodes: null
  },
  "Etc/GMT+12": {
    countryCodes: null
  },
  "Etc/GMT+2": {
    countryCodes: null
  },
  "Etc/GMT+3": {
    countryCodes: null
  },
  "Etc/GMT+4": {
    countryCodes: null
  },
  "Etc/GMT+5": {
    countryCodes: null
  },
  "Etc/GMT+6": {
    countryCodes: null
  },
  "Etc/GMT+7": {
    countryCodes: null
  },
  "Etc/GMT+8": {
    countryCodes: null
  },
  "Etc/GMT+9": {
    countryCodes: null
  },
  "Etc/GMT-0": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "Etc/GMT-1": {
    countryCodes: null
  },
  "Etc/GMT-10": {
    countryCodes: null
  },
  "Etc/GMT-11": {
    countryCodes: null
  },
  "Etc/GMT-12": {
    countryCodes: null
  },
  "Etc/GMT-13": {
    countryCodes: null
  },
  "Etc/GMT-14": {
    countryCodes: null
  },
  "Etc/GMT-2": {
    countryCodes: null
  },
  "Etc/GMT-3": {
    countryCodes: null
  },
  "Etc/GMT-4": {
    countryCodes: null
  },
  "Etc/GMT-5": {
    countryCodes: null
  },
  "Etc/GMT-6": {
    countryCodes: null
  },
  "Etc/GMT-7": {
    countryCodes: null
  },
  "Etc/GMT-8": {
    countryCodes: null
  },
  "Etc/GMT-9": {
    countryCodes: null
  },
  "Etc/GMT0": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "Etc/Greenwich": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "Etc/UCT": {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  "Etc/Universal": {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  "Etc/UTC": {
    countryCodes: null
  },
  "Etc/Zulu": {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  "Europe/Amsterdam": {
    countryCodes: ["NL"],
    tzIdentifierRef: "Europe/Brussels"
  },
  "Europe/Andorra": {
    countryCodes: ["AD"]
  },
  "Europe/Astrakhan": {
    countryCodes: ["RU"]
  },
  "Europe/Athens": {
    countryCodes: ["GR"]
  },
  "Europe/Belfast": {
    countryCodes: ["GB"],
    tzIdentifierRef: "Europe/London"
  },
  "Europe/Belgrade": {
    countryCodes: ["RS", "BA", "HR", "ME", "MK", "SI"]
  },
  "Europe/Berlin": {
    countryCodes: ["DE", "DK", "NO", "SE", "SJ"]
  },
  "Europe/Bratislava": {
    countryCodes: ["SK"],
    tzIdentifierRef: "Europe/Prague"
  },
  "Europe/Brussels": {
    countryCodes: ["BE", "LU", "NL"]
  },
  "Europe/Bucharest": {
    countryCodes: ["RO"]
  },
  "Europe/Budapest": {
    countryCodes: ["HU"]
  },
  "Europe/Busingen": {
    countryCodes: ["DE"],
    tzIdentifierRef: "Europe/Zurich"
  },
  "Europe/Chisinau": {
    countryCodes: ["MD"]
  },
  "Europe/Copenhagen": {
    countryCodes: ["DK"],
    tzIdentifierRef: "Europe/Berlin"
  },
  "Europe/Dublin": {
    countryCodes: ["IE"]
  },
  "Europe/Gibraltar": {
    countryCodes: ["GI"]
  },
  "Europe/Guernsey": {
    countryCodes: ["GG"],
    tzIdentifierRef: "Europe/London"
  },
  "Europe/Helsinki": {
    countryCodes: ["FI", "AX"]
  },
  "Europe/Isle_of_Man": {
    countryCodes: ["IM"],
    tzIdentifierRef: "Europe/London"
  },
  "Europe/Istanbul": {
    countryCodes: ["TR"]
  },
  "Europe/Jersey": {
    countryCodes: ["JE"],
    tzIdentifierRef: "Europe/London"
  },
  "Europe/Kaliningrad": {
    countryCodes: ["RU"]
  },
  "Europe/Kiev": {
    countryCodes: ["UA"],
    tzIdentifierRef: "Europe/Kyiv"
  },
  "Europe/Kirov": {
    countryCodes: ["RU"]
  },
  "Europe/Kyiv": {
    countryCodes: ["UA"]
  },
  "Europe/Lisbon": {
    countryCodes: ["PT"]
  },
  "Europe/Ljubljana": {
    countryCodes: ["SI"],
    tzIdentifierRef: "Europe/Belgrade"
  },
  "Europe/London": {
    countryCodes: ["GB", "GG", "IM", "JE"]
  },
  "Europe/Luxembourg": {
    countryCodes: ["LU"],
    tzIdentifierRef: "Europe/Brussels"
  },
  "Europe/Madrid": {
    countryCodes: ["ES"]
  },
  "Europe/Malta": {
    countryCodes: ["MT"]
  },
  "Europe/Mariehamn": {
    countryCodes: ["AX"],
    tzIdentifierRef: "Europe/Helsinki"
  },
  "Europe/Minsk": {
    countryCodes: ["BY"]
  },
  "Europe/Monaco": {
    countryCodes: ["MC"],
    tzIdentifierRef: "Europe/Paris"
  },
  "Europe/Moscow": {
    countryCodes: ["RU"]
  },
  "Europe/Nicosia": {
    countryCodes: ["CY"],
    tzIdentifierRef: "Asia/Nicosia"
  },
  "Europe/Oslo": {
    countryCodes: ["NO"],
    tzIdentifierRef: "Europe/Berlin"
  },
  "Europe/Paris": {
    countryCodes: ["FR", "MC"]
  },
  "Europe/Podgorica": {
    countryCodes: ["ME"],
    tzIdentifierRef: "Europe/Belgrade"
  },
  "Europe/Prague": {
    countryCodes: ["CZ", "SK"]
  },
  "Europe/Riga": {
    countryCodes: ["LV"]
  },
  "Europe/Rome": {
    countryCodes: ["IT", "SM", "VA"]
  },
  "Europe/Samara": {
    countryCodes: ["RU"]
  },
  "Europe/San_Marino": {
    countryCodes: ["SM"],
    tzIdentifierRef: "Europe/Rome"
  },
  "Europe/Sarajevo": {
    countryCodes: ["BA"],
    tzIdentifierRef: "Europe/Belgrade"
  },
  "Europe/Saratov": {
    countryCodes: ["RU"]
  },
  "Europe/Simferopol": {
    countryCodes: ["RU", "UA"]
  },
  "Europe/Skopje": {
    countryCodes: ["MK"],
    tzIdentifierRef: "Europe/Belgrade"
  },
  "Europe/Sofia": {
    countryCodes: ["BG"]
  },
  "Europe/Stockholm": {
    countryCodes: ["SE"],
    tzIdentifierRef: "Europe/Berlin"
  },
  "Europe/Tallinn": {
    countryCodes: ["EE"]
  },
  "Europe/Tirane": {
    countryCodes: ["AL"]
  },
  "Europe/Tiraspol": {
    countryCodes: ["MD"],
    tzIdentifierRef: "Europe/Chisinau"
  },
  "Europe/Ulyanovsk": {
    countryCodes: ["RU"]
  },
  "Europe/Uzhgorod": {
    countryCodes: ["UA"],
    tzIdentifierRef: "Europe/Kyiv"
  },
  "Europe/Vaduz": {
    countryCodes: ["LI"],
    tzIdentifierRef: "Europe/Zurich"
  },
  "Europe/Vatican": {
    countryCodes: ["VA"],
    tzIdentifierRef: "Europe/Rome"
  },
  "Europe/Vienna": {
    countryCodes: ["AT"]
  },
  "Europe/Vilnius": {
    countryCodes: ["LT"]
  },
  "Europe/Volgograd": {
    countryCodes: ["RU"]
  },
  "Europe/Warsaw": {
    countryCodes: ["PL"]
  },
  "Europe/Zagreb": {
    countryCodes: ["HR"],
    tzIdentifierRef: "Europe/Belgrade"
  },
  "Europe/Zaporozhye": {
    countryCodes: ["UA"],
    tzIdentifierRef: "Europe/Kyiv"
  },
  "Europe/Zurich": {
    countryCodes: ["CH", "DE", "LI"]
  },
  Factory: {
    countryCodes: null
  },
  GB: {
    countryCodes: ["GB"],
    tzIdentifierRef: "Europe/London"
  },
  "GB-Eire": {
    countryCodes: ["GB"],
    tzIdentifierRef: "Europe/London"
  },
  GMT: {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "GMT+0": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  "GMT-0": {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  GMT0: {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  Greenwich: {
    countryCodes: null,
    tzIdentifierRef: "Etc/GMT"
  },
  Hongkong: {
    countryCodes: ["HK"],
    tzIdentifierRef: "Asia/Hong_Kong"
  },
  HST: {
    countryCodes: null
  },
  Iceland: {
    countryCodes: ["IS"],
    tzIdentifierRef: "Africa/Abidjan"
  },
  "Indian/Antananarivo": {
    countryCodes: ["MG"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Indian/Chagos": {
    countryCodes: ["IO"]
  },
  "Indian/Christmas": {
    countryCodes: ["CX"],
    tzIdentifierRef: "Asia/Bangkok"
  },
  "Indian/Cocos": {
    countryCodes: ["CC"],
    tzIdentifierRef: "Asia/Yangon"
  },
  "Indian/Comoro": {
    countryCodes: ["KM"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Indian/Kerguelen": {
    countryCodes: ["TF"],
    tzIdentifierRef: "Indian/Maldives"
  },
  "Indian/Mahe": {
    countryCodes: ["SC"],
    tzIdentifierRef: "Asia/Dubai"
  },
  "Indian/Maldives": {
    countryCodes: ["MV", "TF"]
  },
  "Indian/Mauritius": {
    countryCodes: ["MU"]
  },
  "Indian/Mayotte": {
    countryCodes: ["YT"],
    tzIdentifierRef: "Africa/Nairobi"
  },
  "Indian/Reunion": {
    countryCodes: ["RE"],
    tzIdentifierRef: "Asia/Dubai"
  },
  Iran: {
    countryCodes: ["IR"],
    tzIdentifierRef: "Asia/Tehran"
  },
  Israel: {
    countryCodes: ["IL"],
    tzIdentifierRef: "Asia/Jerusalem"
  },
  Jamaica: {
    countryCodes: ["JM"],
    tzIdentifierRef: "America/Jamaica"
  },
  Japan: {
    countryCodes: ["JP"],
    tzIdentifierRef: "Asia/Tokyo"
  },
  Kwajalein: {
    countryCodes: ["MH"],
    tzIdentifierRef: "Pacific/Kwajalein"
  },
  Libya: {
    countryCodes: ["LY"],
    tzIdentifierRef: "Africa/Tripoli"
  },
  MET: {
    countryCodes: null
  },
  "Mexico/BajaNorte": {
    countryCodes: ["MX"],
    tzIdentifierRef: "America/Tijuana"
  },
  "Mexico/BajaSur": {
    countryCodes: ["MX"],
    tzIdentifierRef: "America/Mazatlan"
  },
  "Mexico/General": {
    countryCodes: ["MX"],
    tzIdentifierRef: "America/Mexico_City"
  },
  MST: {
    countryCodes: null
  },
  MST7MDT: {
    countryCodes: null
  },
  Navajo: {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Denver"
  },
  NZ: {
    countryCodes: ["NZ"],
    tzIdentifierRef: "Pacific/Auckland"
  },
  "NZ-CHAT": {
    countryCodes: ["NZ"],
    tzIdentifierRef: "Pacific/Chatham"
  },
  "Pacific/Apia": {
    countryCodes: ["WS"]
  },
  "Pacific/Auckland": {
    countryCodes: ["NZ", "AQ"]
  },
  "Pacific/Bougainville": {
    countryCodes: ["PG"]
  },
  "Pacific/Chatham": {
    countryCodes: ["NZ"]
  },
  "Pacific/Chuuk": {
    countryCodes: ["FM"],
    tzIdentifierRef: "Pacific/Port_Moresby"
  },
  "Pacific/Easter": {
    countryCodes: ["CL"]
  },
  "Pacific/Efate": {
    countryCodes: ["VU"]
  },
  "Pacific/Enderbury": {
    countryCodes: ["KI"],
    tzIdentifierRef: "Pacific/Kanton"
  },
  "Pacific/Fakaofo": {
    countryCodes: ["TK"]
  },
  "Pacific/Fiji": {
    countryCodes: ["FJ"]
  },
  "Pacific/Funafuti": {
    countryCodes: ["TV"],
    tzIdentifierRef: "Pacific/Tarawa"
  },
  "Pacific/Galapagos": {
    countryCodes: ["EC"]
  },
  "Pacific/Gambier": {
    countryCodes: ["PF"]
  },
  "Pacific/Guadalcanal": {
    countryCodes: ["SB", "FM"]
  },
  "Pacific/Guam": {
    countryCodes: ["GU", "MP"]
  },
  "Pacific/Honolulu": {
    countryCodes: ["US"]
  },
  "Pacific/Johnston": {
    countryCodes: ["US"],
    tzIdentifierRef: "Pacific/Honolulu"
  },
  "Pacific/Kanton": {
    countryCodes: ["KI"]
  },
  "Pacific/Kiritimati": {
    countryCodes: ["KI"]
  },
  "Pacific/Kosrae": {
    countryCodes: ["FM"]
  },
  "Pacific/Kwajalein": {
    countryCodes: ["MH"]
  },
  "Pacific/Majuro": {
    countryCodes: ["MH"],
    tzIdentifierRef: "Pacific/Tarawa"
  },
  "Pacific/Marquesas": {
    countryCodes: ["PF"]
  },
  "Pacific/Midway": {
    countryCodes: ["UM"],
    tzIdentifierRef: "Pacific/Pago_Pago"
  },
  "Pacific/Nauru": {
    countryCodes: ["NR"]
  },
  "Pacific/Niue": {
    countryCodes: ["NU"]
  },
  "Pacific/Norfolk": {
    countryCodes: ["NF"]
  },
  "Pacific/Noumea": {
    countryCodes: ["NC"]
  },
  "Pacific/Pago_Pago": {
    countryCodes: ["AS", "UM"]
  },
  "Pacific/Palau": {
    countryCodes: ["PW"]
  },
  "Pacific/Pitcairn": {
    countryCodes: ["PN"]
  },
  "Pacific/Pohnpei": {
    countryCodes: ["FM"],
    tzIdentifierRef: "Pacific/Guadalcanal"
  },
  "Pacific/Ponape": {
    countryCodes: ["FM"],
    tzIdentifierRef: "Pacific/Guadalcanal"
  },
  "Pacific/Port_Moresby": {
    countryCodes: ["PG", "AQ", "FM"]
  },
  "Pacific/Rarotonga": {
    countryCodes: ["CK"]
  },
  "Pacific/Saipan": {
    countryCodes: ["MP"],
    tzIdentifierRef: "Pacific/Guam"
  },
  "Pacific/Samoa": {
    countryCodes: ["AS"],
    tzIdentifierRef: "Pacific/Pago_Pago"
  },
  "Pacific/Tahiti": {
    countryCodes: ["PF"]
  },
  "Pacific/Tarawa": {
    countryCodes: ["KI", "MH", "TV", "UM", "WF"]
  },
  "Pacific/Tongatapu": {
    countryCodes: ["TO"]
  },
  "Pacific/Truk": {
    countryCodes: ["FM"],
    tzIdentifierRef: "Pacific/Port_Moresby"
  },
  "Pacific/Wake": {
    countryCodes: ["UM"],
    tzIdentifierRef: "Pacific/Tarawa"
  },
  "Pacific/Wallis": {
    countryCodes: ["WF"],
    tzIdentifierRef: "Pacific/Tarawa"
  },
  "Pacific/Yap": {
    countryCodes: ["FM"],
    tzIdentifierRef: "Pacific/Port_Moresby"
  },
  Poland: {
    countryCodes: ["PL"],
    tzIdentifierRef: "Europe/Warsaw"
  },
  Portugal: {
    countryCodes: ["PT"],
    tzIdentifierRef: "Europe/Lisbon"
  },
  PRC: {
    countryCodes: ["CN"],
    tzIdentifierRef: "Asia/Shanghai"
  },
  PST8PDT: {
    countryCodes: null
  },
  ROC: {
    countryCodes: ["TW"],
    tzIdentifierRef: "Asia/Taipei"
  },
  ROK: {
    countryCodes: ["KR"],
    tzIdentifierRef: "Asia/Seoul"
  },
  Singapore: {
    countryCodes: ["SG"],
    tzIdentifierRef: "Asia/Singapore"
  },
  Turkey: {
    countryCodes: ["TR"],
    tzIdentifierRef: "Europe/Istanbul"
  },
  UCT: {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  Universal: {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  "US/Alaska": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Anchorage"
  },
  "US/Aleutian": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Adak"
  },
  "US/Arizona": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Phoenix"
  },
  "US/Central": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Chicago"
  },
  "US/East-Indiana": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Indiana/Indianapolis"
  },
  "US/Eastern": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/New_York"
  },
  "US/Hawaii": {
    countryCodes: ["US"],
    tzIdentifierRef: "Pacific/Honolulu"
  },
  "US/Indiana-Starke": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Indiana/Knox"
  },
  "US/Michigan": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Detroit"
  },
  "US/Mountain": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Denver"
  },
  "US/Pacific": {
    countryCodes: ["US"],
    tzIdentifierRef: "America/Los_Angeles"
  },
  "US/Samoa": {
    countryCodes: ["AS"],
    tzIdentifierRef: "Pacific/Pago_Pago"
  },
  UTC: {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  },
  "W-SU": {
    countryCodes: ["RU"],
    tzIdentifierRef: "Europe/Moscow"
  },
  WET: {
    countryCodes: null
  },
  Zulu: {
    countryCodes: null,
    tzIdentifierRef: "Etc/UTC"
  }
}, h4 = (e) => {
  var r;
  const n = (r = p4[e].countryCodes) == null ? void 0 : r[0];
  if (n)
    return {
      countryCode: n,
      country: g4[n]
    };
}, v4 = () => {
  const e = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (!e)
    return null;
  let t = {
    timezone: e
  };
  const n = h4(e);
  return n && (t = {
    ...t,
    ...n
  }), t;
};
function nx(e) {
  return (...t) => {
    try {
      return e(...t);
    } catch (n) {
      console.error("flywheel:", n);
    }
  };
}
function $t(e) {
  return async (...t) => {
    try {
      return await e(...t);
    } catch (n) {
      console.error("flywheel:", n);
    }
  };
}
const m4 = "ipv4", w4 = "ipv6", y4 = "timezone", Df = (e) => e.status === "fulfilled", dl = $t(async (e) => (await (await fetch(`https://ip${e}.geojs.io/v1/ip.json`)).json()).ip), gl = $t(async (e) => e ? await (await fetch(`https://get.geojs.io/v1/ip/geo/${e}.json`)).json() : void 0), pl = ({
  data: e,
  geolocation: t,
  strategy: n
}) => {
  var r;
  for (const a in e) {
    if (a === "area_code")
      continue;
    const i = c4(a), o = e[a];
    t[i] || (t[i] = {}), o && ((r = t[i])[o] || (r[o] = []), t[i][o].push(n));
  }
}, b4 = async () => {
  const e = { v4: void 0, v6: void 0 }, [t, n] = await Promise.allSettled([
    await dl("v4"),
    await dl("v6")
  ]);
  e.v4 = Df(t) ? t.value : void 0, e.v6 = Df(n) ? n.value : void 0;
  const r = {};
  (await Promise.allSettled([
    await gl(e.v4),
    await gl(e.v6)
  ])).forEach((o, f) => {
    const s = f === 0 ? m4 : w4, u = Df(o) ? o.value : void 0;
    u && pl({
      data: u,
      geolocation: r,
      strategy: s
    });
  });
  const i = v4();
  return i && pl({
    data: i,
    geolocation: r,
    strategy: y4
  }), {
    geolocation: r,
    ip: e
  };
}, hl = ["Google Chrome", "Microsoft Edge", "Opera"], C4 = async () => {
  var C, M, S;
  const { geolocation: e, ip: t } = await b4(), { width: n, height: r } = window.screen;
  let a = "", i = "", o, f, s;
  const { userAgent: u } = navigator;
  (f = u.indexOf("Opera")) !== -1 && (a = "Opera", i = u.substring(f + 6), (f = u.indexOf("Version")) !== -1 && (i = u.substring(f + 8))), (f = u.indexOf("OPR")) !== -1 ? (a = "Opera", i = u.substring(f + 4)) : (f = u.indexOf("Edge")) !== -1 ? (a = "Microsoft Legacy Edge", i = u.substring(f + 5)) : (f = u.indexOf("Edg")) !== -1 ? (a = "Microsoft Edge", i = u.substring(f + 4)) : (f = u.indexOf("MSIE")) !== -1 ? (a = "Microsoft Internet Explorer", i = u.substring(f + 5)) : (f = u.indexOf("Chrome")) !== -1 ? (a = "Google Chrome", i = u.substring(f + 7)) : (f = u.indexOf("Safari")) !== -1 ? (a = "Safari", i = u.substring(f + 7), (f = u.indexOf("Version")) !== -1 && (i = u.substring(f + 8))) : (f = u.indexOf("Firefox")) !== -1 ? (a = "Firefox", i = u.substring(f + 8)) : u.indexOf("Trident/") !== -1 ? (a = "Microsoft Internet Explorer", i = u.substring(u.indexOf("rv:") + 3)) : (o = u.lastIndexOf(" ") + 1) < (f = u.lastIndexOf("/")) && (a = u.substring(o, f), i = u.substring(f + 1)), (s = i.indexOf(";")) !== -1 && (i = i.substring(0, s)), (s = i.indexOf(" ")) !== -1 && (i = i.substring(0, s)), (s = i.indexOf(")")) !== -1 && (i = i.substring(0, s));
  const c = parseInt(i, 10).toString(), d = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
    u
  ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
    u.substr(0, 4)
  );
  let g = "";
  const p = [
    { string: "Windows 10", regex: /(Windows 10.0|Windows NT 10.0)/ },
    { string: "Windows 8.1", regex: /(Windows 8.1|Windows NT 6.3)/ },
    { string: "Windows 8", regex: /(Windows 8|Windows NT 6.2)/ },
    { string: "Windows 7", regex: /(Windows 7|Windows NT 6.1)/ },
    { string: "Windows Vista", regex: /Windows NT 6.0/ },
    { string: "Windows Server 2003", regex: /Windows NT 5.2/ },
    { string: "Windows XP", regex: /(Windows NT 5.1|Windows XP)/ },
    { string: "Windows 2000", regex: /(Windows NT 5.0|Windows 2000)/ },
    { string: "Windows ME", regex: /(Win 9x 4.90|Windows ME)/ },
    { string: "Windows 98", regex: /(Windows 98|Win98)/ },
    { string: "Windows 95", regex: /(Windows 95|Win95|Windows_95)/ },
    {
      string: "Windows NT 4.0",
      regex: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/
    },
    { string: "Windows CE", regex: /Windows CE/ },
    { string: "Windows 3.11", regex: /Win16/ },
    { string: "Android", regex: /Android/ },
    { string: "Open BSD", regex: /OpenBSD/ },
    { string: "Sun OS", regex: /SunOS/ },
    { string: "Chrome OS", regex: /CrOS/ },
    { string: "Linux", regex: /(Linux|X11(?!.*CrOS))/ },
    { string: "iOS", regex: /(iPhone|iPad|iPod)/ },
    {
      //  macOS has been standard mac os naming since 2016
      string: "macOS",
      regex: /(Mac OS X|Mac OS|MacPPC|MacIntel|Mac_PowerPC|Macintosh)/
    },
    { string: "QNX", regex: /QNX/ },
    { string: "UNIX", regex: /UNIX/ },
    { string: "BeOS", regex: /BeOS/ },
    { string: "OS/2", regex: /OS\/2/ },
    {
      string: "Search Bot",
      regex: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/
    }
  ];
  for (const { regex: I, string: N } of p)
    if (I.test(u)) {
      g = N;
      break;
    }
  let h = "";
  switch (/Windows/.test(g) && (h = ((C = /Windows (.*)/.exec(g)) == null ? void 0 : C[1]) ?? "", g = "Windows"), g) {
    case "macOS":
    case "Android":
      h = ((M = /(?:Android|Mac OS|Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh) ([._\d]+)/.exec(
        u
      )) == null ? void 0 : M[1]) ?? "";
      break;
    case "iOS":
      h = ((S = u.match(/OS (\d)?\d_\d(_\d)?/i)) == null ? void 0 : S[0].replace(/_/g, ".")) ?? "";
      break;
  }
  const l = /Windows Phone/i.test(u) || /WPDesktop/.test(u) ? "Windows Phone" : /iPad/.test(u) ? "iPad" : /iPod/.test(u) ? "iPod Touch" : /iPhone/.test(u) ? "iPhone" : /(BlackBerry|PlayBook|BB10)/i.test(u) ? "BlackBerry" : /Android/.test(u) && !/Mobile/.test(u) ? "Android Tablet" : /Android/.test(u) ? "Android" : "", w = ["iPad", "Android Tablet"].includes(l) ? "Tablet" : l ? "Mobile" : "Desktop", m = {
    name: a,
    version: i,
    majorVersion: c
  }, y = {
    name: l,
    type: w,
    mobile: d
  }, b = {
    // assertion is safe because we clean Windows OS names to just "Windows"
    name: g,
    // macs can give underscored version from userAgent; ex: transform 10_15_7 -> 10.15.7
    version: h.replaceAll("_", ".")
  };
  if (navigator.userAgentData)
    try {
      const {
        brands: I,
        fullVersionList: N,
        platform: O,
        platformVersion: F,
        mobile: Q,
        model: T
      } = await navigator.userAgentData.getHighEntropyValues([
        "model",
        "platformVersion",
        "fullVersionList"
      ]), x = (N == null ? void 0 : N.find(({ brand: A }) => hl.includes(A))) ?? (I == null ? void 0 : I.find(({ brand: A }) => hl.includes(A)));
      x && (m.name = x.brand, m.version = x.version, m.majorVersion = x.version.split(".")[0]), O && (b.name = O), F && (b.version = F, b.isVersionReliable = !0), Q && (y.type === "Desktop" && (y.type = "Mobile"), y.mobile = !0, T && (y.name = T));
    } catch {
    }
  return {
    browser: m,
    device: y,
    os: b,
    geolocation: e,
    ip: t,
    screen: {
      width: n,
      height: r
    }
  };
}, vl = "STATIC_CLIENT_PROPERTIES_KEY";
let Gn;
const M4 = async () => {
  if (Gn)
    return Gn;
  const e = sessionStorage.getItem(
    vl
  );
  return e ? (Gn = Promise.resolve(
    JSON.parse(e)
  ), Gn) : (Gn = C4(), sessionStorage.setItem(
    vl,
    JSON.stringify(await Gn)
  ), Gn);
}, D4 = async () => {
  const e = await M4(), { href: t, host: n, pathname: r } = window.location;
  return {
    viewport: {
      width: window.innerWidth,
      height: window.innerHeight
    },
    location: {
      href: t,
      host: n,
      pathname: r
    },
    cookieEnabled: navigator.cookieEnabled,
    // precomputed properties
    ...e
  };
}, L4 = "flywheel.js", A4 = a4.version;
let ha;
function E4() {
  if (ha)
    return ha;
  const e = $2();
  return ha = {
    expires: 1e3 * 60 * 60 * 24 * 365,
    // 1 year
    secure: !1,
    path: "/"
  }, e && (ha.domain = e), ha;
}
function j4() {
  const e = Or.get("_ga");
  if (e && e.startsWith("amp"))
    return e;
}
const I4 = /* @__PURE__ */ new Set([
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content"
]);
function S4(e) {
  return e.startsWith("?") && (e = e.substring(1)), e = e.replace(/\?/g, "&"), e.split("&").reduce((t, n) => {
    const [r, a = ""] = n.split("=");
    if (I4.has(r)) {
      let i = r.substring(4);
      i === "campaign" && (i = "name"), t[i] = W2(a);
    }
    return t;
  }, {});
}
function x4(e) {
  const t = {
    btid: "dataxu",
    urid: "millennial-media"
  };
  e.startsWith("?") && (e = e.substring(1)), e = e.replace(/\?/g, "&");
  const n = e.split("&");
  for (const r of n) {
    const [a, i] = r.split("=");
    if (t[a])
      return {
        id: i,
        type: t[a]
      };
  }
}
function T4(e, t, n) {
  const r = Or.get("s:context.referrer");
  let a = x4(e);
  a ?? (a = r ? JSON.parse(r) : void 0), a && (t && (t.referrer = { ...t.referrer, ...a }), n || Or.set("s:context.referrer", JSON.stringify(a), E4()));
}
async function Lf(e, t, n) {
  const r = e.user(), a = window.location.search;
  t.context = t.context ?? t.options ?? {};
  const i = t.context, o = t.anonymousId;
  delete t.options, t.writeKey = n == null ? void 0 : n.writeKey, i.userAgent = window.navigator.userAgent;
  const f = await D4();
  for (const [d, g] of Object.entries(f))
    i[d] = g;
  const s = navigator.language;
  typeof i.locale > "u" && typeof s < "u" && (i.locale = s), i.library || (i.library = {
    name: L4,
    version: A4
  }), a && !i.campaign && (i.campaign = S4(a)), T4(a, i, e.options.disableClientPersistence ?? !1), t.userId = t.userId || r.id(), t.anonymousId = r.anonymousId(o), t.sentAt = /* @__PURE__ */ new Date(), t.timestamp = /* @__PURE__ */ new Date();
  const u = e.queue.failedInitializations || [];
  u.length > 0 && (t._metadata = { failedInitializations: u });
  const c = j4();
  return c && (i.amp = { id: c }), t;
}
async function N4(e) {
  try {
    return await e();
  } catch (t) {
    return Promise.reject(t);
  }
}
function k4(e, t) {
  e.log("debug", "plugin", { plugin: t.name });
  const n = (/* @__PURE__ */ new Date()).getTime(), r = t[e.event.type];
  return r === void 0 ? Promise.resolve(e) : N4(() => r.apply(t, [e])).then((i) => {
    const o = (/* @__PURE__ */ new Date()).getTime() - n;
    return i.stats.gauge("plugin_time", o, [`plugin:${t.name}`]), i;
  }).catch((i) => {
    if (i instanceof Hr && i.type === "middleware_cancellation")
      throw i;
    if (i instanceof Hr) {
      e.log("warn", i.type, {
        plugin: t.name,
        error: i
      });
      return;
    }
    return e.log("error", "plugin Error", {
      plugin: t.name,
      error: i
    }), e.stats.increment("plugin_error", 1, [`plugin:${t.name}`]), i;
  });
}
const B4 = async (e, t) => {
  const n = async (r) => {
    if (e(r))
      return n(await t());
  };
  return n(void 0);
};
async function O4(e, t) {
  const n = [];
  return Du() || (await B4(
    () => t.length > 0 && !Du(),
    async () => {
      const r = t.pop();
      if (!r)
        return;
      await k4(r, e) instanceof Nr || n.push(r);
    }
  ), n.map((r) => t.pushWithBackoff(r))), t;
}
function Eu(e, t) {
  nr(async () => {
    const n = await O4(t, e);
    e.todo > 0 && Eu(n, t);
  }, 1e3);
}
const P4 = 5e3;
function Y1(e) {
  return new TextEncoder().encode(JSON.stringify(e)).length / 1024;
}
function z4(e, t = 250) {
  return Y1(e) >= t;
}
const ml = "text/plain";
function Af({
  path: e,
  settings: t,
  decorateBody: n = (i) => i,
  subdomain: r = "api",
  sizeLimit: a
}) {
  let i = [], o = !1;
  const f = $t(async function(g, p = 1) {
    if (!g.length)
      return;
    const h = n({
      batch: g,
      writeKey: t.writeKey
    }), l = JSON.stringify(h), w = `https://${r}.${t.apiHost}/${e}`;
    if (o && Y1(h) < 64) {
      const m = {
        type: ml
      }, y = new Blob([l], m);
      return navigator.sendBeacon(w, y);
    } else {
      const m = await fetch(w, {
        headers: {
          "Content-Type": ml
        },
        method: "post",
        body: l
      });
      if (m.ok)
        return m;
      p <= 10 ? (await new Promise(
        (y) => nr(y, 50 * p)
      ), f(g, p + 1)) : console.warn(
        "Failed to send Flywheel data",
        m.status,
        m.statusText,
        m.body
      );
    }
  }), s = $t(async function() {
    if (i.length) {
      const g = i;
      return i = [], f(g);
    }
  });
  let u;
  function c() {
    u || (u = nr(() => {
      u = void 0, s();
    }, P4));
  }
  qt(document, "visibilitychange", () => {
    document.visibilityState === "hidden" ? (o = !0, s()) : o = !1;
  });
  async function d(g) {
    return z4(
      // N.B. I'm intentionally not spreading buffer here to avoid copying it for performance reasons. Spreading doesn't matter since we're just trying to get a rough estimate of the size of the buffer
      // If we want to improve perf further, we could track the size of the buffer as we add to it
      [i, g],
      a
    ) && s(), i.push(g), o ? s() : c();
  }
  return {
    dispatch: d
  };
}
function R4(e, t) {
  const n = e.user();
  return t.previousId || (t.previousId = t.from ?? n.id() ?? n.anonymousId()), t.userId || (t.userId = t.to), delete t.from, delete t.to, t;
}
function F4(e, t) {
  const n = new H2(
    e.queue.queue.maxAttempts,
    "dest-Flywheel.app"
  ), r = Af({
    settings: t,
    path: "event-capture"
  }), a = Af({
    settings: t,
    path: "interactions",
    subdomain: "engage"
  }), i = Af({
    settings: t,
    // TODO: remove this once we've migrated all customers to the new endpoint
    path: "snapshot-capture-v2",
    sizeLimit: 990,
    // just under the 1MB limit of Kinesis
    decorateBody: ({ batch: s, writeKey: u }) => {
      const { anonymousId: c, context: d, messageId: g, sentAt: p, timestamp: h, userId: l } = s[0];
      return {
        anonymousId: c,
        userId: l,
        context: d,
        messageId: g,
        sentAt: p,
        timestamp: h,
        writeKey: u,
        sessionId: e.sessionManager.getSession().id,
        batch: s.map(
          ({ properties: { data: w, chunk: m, numChunks: y, time: b } = {} }) => ({
            data: w,
            chunk: m,
            numChunks: y,
            time: b
          })
        )
      };
    }
  });
  async function o(s) {
    var g;
    if (Du())
      return n.push(s), Eu(n, f), s;
    const { type: u } = s.event;
    e.handleEventNameEngagementTriggers(s.event);
    const c = (g = e.sessionManager.getSession().properties) == null ? void 0 : g.engagementIds;
    (u === "track" || u === "page") && c && (s.event.properties = {
      ...s.event.properties,
      engagementIds: Array.from(c)
    });
    let d = Q2(s.event).json();
    u === "track" && delete d.traits, u === "alias" && (d = R4(e, d));
    try {
      return s.event.event === "$snapshot" ? await i.dispatch(
        await Lf(e, d, t)
      ) : s.event.event === "$interaction" ? await a.dispatch(
        await Lf(e, d, t)
      ) : await r.dispatch(
        await Lf(e, d, t)
      ), s;
    } catch (p) {
      return (p.type === "error" || p.message === "Failed to fetch") && (n.push(s), Eu(n, f)), s;
    }
  }
  const f = {
    name: "Flywheel.app",
    type: "after",
    version: "0.0.1",
    isLoaded: () => !0,
    load: () => Promise.resolve(),
    track: o,
    identify: o,
    page: o,
    alias: o,
    group: o
  };
  return f;
}
function G1() {
  const e = document.getElementsByTagName("link");
  let t = "";
  return Array.prototype.slice.call(e).forEach((n) => {
    n.getAttribute("rel") === "canonical" && (t = n.getAttribute("href"));
  }), t;
}
function U4() {
  const e = G1();
  if (!e)
    return window.location.pathname;
  const t = document.createElement("a");
  return t.href = e, t.pathname.startsWith("/") ? t.pathname : "/" + t.pathname;
}
function Y4(e = "") {
  const t = G1();
  if (t)
    return t.includes("?") ? t : `${t}${e}`;
  const n = window.location.href, r = n.indexOf("#");
  return r === -1 ? n : n.slice(0, r);
}
function H1() {
  return {
    path: U4(),
    referrer: document.referrer,
    search: window.location.search,
    title: document.title,
    url: Y4(window.location.search)
  };
}
function va(e) {
  const t = e.event;
  t.context = t.context || {};
  let n = H1();
  const r = t.properties ?? {};
  return Object.keys(n).forEach((a) => {
    r[a] && (n[a] = r[a]);
  }), t.context.page && (n = Object.assign({}, n, t.context.page)), t.context = Object.assign({}, t.context, {
    page: n
  }), e.event = t, e;
}
const G4 = {
  name: "Page Enrichment",
  version: "0.1.0",
  isLoaded: () => !0,
  load: () => Promise.resolve(),
  type: "before",
  page: (e) => (e.event.properties = Object.assign(
    {},
    H1(),
    e.event.properties
  ), e.event.name && (e.event.properties.name = e.event.name), va(e)),
  alias: va,
  track: va,
  identify: va,
  group: va
};
function ju(e) {
  return typeof e == "string";
}
function H4(e) {
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase() === "object";
}
function Q4(e) {
  const t = e.userId ?? e.anonymousId ?? e.groupId ?? e.previousId;
  return ju(t);
}
class ma extends Error {
  constructor(t, n) {
    super(n), this.field = t;
  }
}
function Dr(e) {
  const t = e && e.event && e.event.type, n = e.event;
  if (n === void 0)
    throw new ma("event", "Event is missing");
  if (!ju(t))
    throw new ma("event", "Event is not a string");
  if (t === "track" && !ju(n.event))
    throw new ma("event", "Event is not a string");
  const r = n.properties ?? n.traits;
  if (t !== "alias" && !H4(r))
    throw new ma("properties", "properties is not an object");
  if (!Q4(n))
    throw new ma("userId", "Missing userId or anonymousId");
  return e;
}
const J4 = {
  name: "Event Validation",
  type: "before",
  version: "1.0.0",
  isLoaded: () => !0,
  load: () => Promise.resolve(),
  track: Dr,
  identify: Dr,
  page: Dr,
  alias: Dr,
  group: Dr,
  screen: Dr
}, Q1 = "flywheelSessionReplay", wl = "SET";
function W4() {
  try {
    const e = sessionStorage.getItem(Q1);
    if (e)
      return zs.parseJSON(e);
  } catch {
  }
}
function Iu(e, t, n = /* @__PURE__ */ new Date()) {
  const r = new Date(e);
  return new Date(r.getTime() + t) <= n;
}
function rx({ lastActivityTime: e }, { sessionPauseDuration: t }, n) {
  return Iu(e, t, n);
}
function _4({ startTime: e, lastActivityTime: t }, { sessionIdleDuration: n, sessionMaxLife: r }) {
  return Iu(e, r) || Iu(t, n);
}
function Su(e) {
  try {
    sessionStorage.setItem(Q1, zs.toJSON(e));
  } catch {
  }
}
function yl() {
  const e = (/* @__PURE__ */ new Date()).toISOString(), t = {
    id: crypto.randomUUID(),
    startTime: e,
    lastActivityTime: e
  };
  return Su(t), t;
}
class zs {
  // JSON.stringify no good w/ sets outta the box, so we use a replacer
  // to store sets as arrays with a special key (at 0th index)
  static toJSON(t) {
    return JSON.stringify(t, (n, r) => r instanceof Set ? {
      dataType: wl,
      value: [...r]
    } : r);
  }
  // Use reviver to convert engagementIds back to a set
  static parseJSON(t) {
    return JSON.parse(t, (n, r) => typeof r == "object" && r !== null && r.dataType === wl ? new Set(r.value) : r);
  }
  constructor() {
    this.session = W4() || yl();
  }
  getSession() {
    return this.session;
  }
  addEngagementId(t) {
    !this.session.properties || !this.session.properties.engagementIds ? this.session.properties = {
      engagementIds: /* @__PURE__ */ new Set([t])
    } : this.session.properties.engagementIds.add(t), Su(this.session);
  }
  updateSession(t, n, r) {
    _4(this.session, t) && (this.session = yl());
    const a = this.getSession();
    return r && (a.lastActivityTime = n.toISOString()), Su(this.session), a;
  }
}
const Z4 = ({
  type: e,
  event: t,
  name: n,
  context: r,
  properties: a
}) => {
  var i;
  switch (e) {
    case "page": {
      const o = n || ((i = r == null ? void 0 : r.page) == null ? void 0 : i.title) || (a == null ? void 0 : a.title);
      if (o)
        return o;
      break;
    }
    case "track": {
      if (t) {
        if (t === "$snapshot")
          return null;
        if (t === "$autocapture") {
          const { eventType: o, elements: f } = a || {};
          if (o && f)
            return $4(o, f);
        } else
          return t;
      }
      break;
    }
    default:
      return null;
  }
}, bl = (e) => {
  switch (e) {
    case "click":
      return "clicked";
    case "change":
      return "typed something into";
    case "submit":
      return "submitted";
    case "touch":
      return "pressed";
    default:
      return "interacted with";
  }
}, Cl = (e) => {
  const { tagName: t } = e || {};
  switch (t) {
    case "a":
      return "link";
    case "img":
      return "image";
    default:
      return t ?? "element";
  }
}, Ml = (e, t) => {
  const { text: n, attributes: r } = e || {}, a = r == null ? void 0 : r["attr__aria-label"];
  return n ? `${t ? "" : "with text "}"${n}"` : a ? `${t ? "" : "with aria label "}"${a}"` : null;
};
function $4(e, t = [], n = !1) {
  const r = t[0];
  return (n ? [bl(e), Ml(r, !0) ?? Cl(r)] : [bl(e), Cl(r), Ml(r, !1)]).filter(Boolean).join(" ");
}
function V4(e) {
  const { preLibInitBuffer: t } = window.flywheel || {};
  for (const [n, r] of Object.entries(
    t || {}
  ))
    for (const a of r)
      typeof e[n] == "function" && nr(() => {
        e[n](...a);
      }, 0);
}
async function K4({
  writeKey: e,
  apiHost: t,
  flywheel: n,
  disable: r
}) {
  if (r)
    return;
  const i = await (await fetch(`https://cdn.${t}/settings/${e}`)).json();
  n.flywheelSettings = i;
  const {
    autoCapture: o,
    autoIdentify: f,
    sessionReplay: s,
    privacy: {
      maskText: u,
      maskSessionReplayText: c,
      maskCanvas: d,
      maskInputs: g,
      maskMedia: p,
      maskElementAttributes: h
    },
    crossDomainTracking: l
  } = i, w = new P2();
  o && !n.runInIframe && $t(async () => {
    const { autoCapture: m } = await import("./autocapture-ca499e6e.js");
    m(n, {
      maskText: u,
      maskElementAttributes: h
    });
  })(), f && !n.runInIframe && $t(async () => {
    const { autoIdentify: m } = await import("./auto-identify-62560edb.js");
    m();
  })(), l != null && l.enabled && $t(async () => {
    const { crossDomainTracking: m } = await import("./cross-domain-tracking-c2c55d15.js");
    m({ flywheel: n, observer: w, crossDomainTracking: l });
  })(), s.enabled && $t(async () => {
    const { SessionRecording: m } = await import("./session-replay-acb240f5.js");
    new m(n, {
      timeouts: n.sessionReplayTimeouts,
      maskText: u || c,
      maskCanvas: d,
      maskInputs: g,
      maskMedia: p,
      inlineStylesheet: s.inlineStylesheet,
      errorsOnly: s.errorsOnly,
      recordCrossOriginIframes: s.recordCrossOriginIframes,
      recordConsoleOutput: s.recordConsoleOutput,
      recordNetworkEvents: s.recordNetworkEvents,
      apiHost: t
    });
  })(), n.runInIframe || $t(async () => {
    const { loadEngagements: m, renderEngagement: y } = await import("./index-0004c919.js");
    n.renderEngagement = (b) => y(b, n), await m({ apiHost: t, writeKey: e, flywheel: n, observer: w });
  })(), w.observe(document, { subtree: !0, childList: !0 });
}
const q4 = 30 * 1e3, X4 = 30 * 60 * 1e3, ew = 24 * 60 * 60 * 1e3;
class ax extends wu {
  constructor({
    writeKey: t,
    sessionReplayTimeouts: {
      sessionPauseDuration: n = q4,
      sessionIdleDuration: r = X4,
      sessionMaxLife: a = ew
    } = {},
    disable: i,
    runInIframe: o
  }) {
    super(
      {
        writeKey: t
      },
      {
        retryQueue: !0,
        disable: i || o === "true"
      }
    ), this.isDebugging = !1, this.initialized = !1, this.setDebugging = (f) => {
      this.isDebugging = f;
    }, this.originalMarginTop = parseInt(
      getComputedStyle(document.body).marginTop
    ), this.sessionManager = new zs(), this.sessionReplayTimeouts = {
      sessionPauseDuration: n,
      sessionIdleDuration: r,
      sessionMaxLife: a
    }, this.activeEngagements = {}, this.locallyDismissedEngagementIds = /* @__PURE__ */ new Set(), this.triggers = {
      timeOnPageTriggers: [],
      scrollDepthTriggers: [],
      eventNameTriggers: {}
    }, this.runInIframe = o === "true";
  }
  static load({
    writeKey: t,
    apiHost: n = "theflywheel.app",
    sessionReplayTimeouts: r,
    disable: a,
    runInIframe: i
  }) {
    const o = new this({
      writeKey: t,
      sessionReplayTimeouts: r,
      disable: a,
      runInIframe: i
    });
    $t(
      () => K4({ writeKey: t, apiHost: n, flywheel: o, disable: a })
    )();
    const { search: f, hash: s = "" } = window.location, u = f || s.replace(/(?=#).*(?=\?)/, "");
    return u.includes("ajs_") && o.queryString(u).catch(console.error), V4(o), o.register(
      J4,
      G4,
      F4(o, { writeKey: t, apiHost: n })
    ), o.initialized = !0, o;
  }
  /*
    whenever an event is sent, check the current triggers and invoke any handlers that match the eventName
  */
  handleEventNameEngagementTriggers(t) {
    const n = Z4(t);
    if (!n)
      return;
    const r = this.triggers.eventNameTriggers[n];
    r && r.forEach((a) => a());
  }
  clearEngagementTriggers() {
    this.triggers.timeOnPageTriggers.forEach(
      (t) => z2(t)
    ), this.triggers.timeOnPageTriggers = [], this.triggers.scrollDepthTriggers.forEach(
      (t) => cn(window, "scroll", t)
    ), this.triggers.scrollDepthTriggers = [], this.triggers.eventNameTriggers = {};
  }
  getSessionURL() {
    return `https://dashboard.theflywheel.app/sessions/replays/${this.sessionManager.getSession().id}`;
  }
  async identify(...t) {
    var r, a;
    const n = await wu.prototype.identify.call(this, ...t);
    if ((a = (r = this.flywheelSettings) == null ? void 0 : r.crossDomainTracking) != null && a.enabled) {
      const { identifyAnonymousIds: i } = await import("./cross-domain-tracking-c2c55d15.js");
      i({ flywheel: this });
    }
    return n;
  }
}
var tw = aw, J1 = "֑-߿יִ-﷽ﹰ-ﻼ", W1 = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", nw = new RegExp("^[^" + W1 + "]*[" + J1 + "]"), rw = new RegExp("^[^" + J1 + "]*[" + W1 + "]");
function aw(e) {
  return e = String(e || ""), nw.test(e) ? "rtl" : rw.test(e) ? "ltr" : "neutral";
}
const _1 = /* @__PURE__ */ No(tw);
function iw(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Rs = iw, ow = typeof Pe == "object" && Pe && Pe.Object === Object && Pe, fw = ow, uw = fw, sw = typeof self == "object" && self && self.Object === Object && self, cw = uw || sw || Function("return this")(), Z1 = cw, lw = Z1, dw = function() {
  return lw.Date.now();
}, gw = dw, pw = /\s/;
function hw(e) {
  for (var t = e.length; t-- && pw.test(e.charAt(t)); )
    ;
  return t;
}
var vw = hw, mw = vw, ww = /^\s+/;
function yw(e) {
  return e && e.slice(0, mw(e) + 1).replace(ww, "");
}
var bw = yw, Cw = Z1, Mw = Cw.Symbol, $1 = Mw, Dl = $1, V1 = Object.prototype, Dw = V1.hasOwnProperty, Lw = V1.toString, wa = Dl ? Dl.toStringTag : void 0;
function Aw(e) {
  var t = Dw.call(e, wa), n = e[wa];
  try {
    e[wa] = void 0;
    var r = !0;
  } catch {
  }
  var a = Lw.call(e);
  return r && (t ? e[wa] = n : delete e[wa]), a;
}
var Ew = Aw, jw = Object.prototype, Iw = jw.toString;
function Sw(e) {
  return Iw.call(e);
}
var xw = Sw, Ll = $1, Tw = Ew, Nw = xw, kw = "[object Null]", Bw = "[object Undefined]", Al = Ll ? Ll.toStringTag : void 0;
function Ow(e) {
  return e == null ? e === void 0 ? Bw : kw : Al && Al in Object(e) ? Tw(e) : Nw(e);
}
var Pw = Ow;
function zw(e) {
  return e != null && typeof e == "object";
}
var Rw = zw, Fw = Pw, Uw = Rw, Yw = "[object Symbol]";
function Gw(e) {
  return typeof e == "symbol" || Uw(e) && Fw(e) == Yw;
}
var Hw = Gw, Qw = bw, El = Rs, Jw = Hw, jl = 0 / 0, Ww = /^[-+]0x[0-9a-f]+$/i, _w = /^0b[01]+$/i, Zw = /^0o[0-7]+$/i, $w = parseInt;
function Vw(e) {
  if (typeof e == "number")
    return e;
  if (Jw(e))
    return jl;
  if (El(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = El(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Qw(e);
  var n = _w.test(e);
  return n || Zw.test(e) ? $w(e.slice(2), n ? 2 : 8) : Ww.test(e) ? jl : +e;
}
var Kw = Vw, qw = Rs, Ef = gw, Il = Kw, Xw = "Expected a function", e3 = Math.max, t3 = Math.min;
function n3(e, t, n) {
  var r, a, i, o, f, s, u = 0, c = !1, d = !1, g = !0;
  if (typeof e != "function")
    throw new TypeError(Xw);
  t = Il(t) || 0, qw(n) && (c = !!n.leading, d = "maxWait" in n, i = d ? e3(Il(n.maxWait) || 0, t) : i, g = "trailing" in n ? !!n.trailing : g);
  function p(S) {
    var I = r, N = a;
    return r = a = void 0, u = S, o = e.apply(N, I), o;
  }
  function h(S) {
    return u = S, f = setTimeout(m, t), c ? p(S) : o;
  }
  function l(S) {
    var I = S - s, N = S - u, O = t - I;
    return d ? t3(O, i - N) : O;
  }
  function w(S) {
    var I = S - s, N = S - u;
    return s === void 0 || I >= t || I < 0 || d && N >= i;
  }
  function m() {
    var S = Ef();
    if (w(S))
      return y(S);
    f = setTimeout(m, l(S));
  }
  function y(S) {
    return f = void 0, g && r ? p(S) : (r = a = void 0, o);
  }
  function b() {
    f !== void 0 && clearTimeout(f), u = 0, r = s = a = f = void 0;
  }
  function C() {
    return f === void 0 ? o : y(Ef());
  }
  function M() {
    var S = Ef(), I = w(S);
    if (r = arguments, a = this, s = S, I) {
      if (f === void 0)
        return h(s);
      if (d)
        return clearTimeout(f), f = setTimeout(m, t), p(s);
    }
    return f === void 0 && (f = setTimeout(m, t)), o;
  }
  return M.cancel = b, M.flush = C, M;
}
var K1 = n3;
const r3 = /* @__PURE__ */ No(K1);
var a3 = K1, i3 = Rs, o3 = "Expected a function";
function f3(e, t, n) {
  var r = !0, a = !0;
  if (typeof e != "function")
    throw new TypeError(o3);
  return i3(n) && (r = "leading" in n ? !!n.leading : r, a = "trailing" in n ? !!n.trailing : a), a3(e, t, {
    leading: r,
    maxWait: t,
    trailing: a
  });
}
var u3 = f3;
const s3 = /* @__PURE__ */ No(u3);
function Sl(e) {
  return typeof e == "object" && e != null && e.nodeType === 1;
}
function xl(e, t) {
  return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function jf(e, t) {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    var n = getComputedStyle(e, null);
    return xl(n.overflowY, t) || xl(n.overflowX, t) || function(r) {
      var a = function(i) {
        if (!i.ownerDocument || !i.ownerDocument.defaultView)
          return null;
        try {
          return i.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      }(r);
      return !!a && (a.clientHeight < r.scrollHeight || a.clientWidth < r.scrollWidth);
    }(e);
  }
  return !1;
}
function Ai(e, t, n, r, a, i, o, f) {
  return i < e && o > t || i > e && o < t ? 0 : i <= e && f <= n || o >= t && f >= n ? i - e - r : o > t && f < n || i < e && f > n ? o - t + a : 0;
}
var Tl = function(e, t) {
  var n = window, r = t.scrollMode, a = t.block, i = t.inline, o = t.boundary, f = t.skipOverflowHiddenElements, s = typeof o == "function" ? o : function(he) {
    return he !== o;
  };
  if (!Sl(e))
    throw new TypeError("Invalid target");
  for (var u, c, d = document.scrollingElement || document.documentElement, g = [], p = e; Sl(p) && s(p); ) {
    if ((p = (c = (u = p).parentElement) == null ? u.getRootNode().host || null : c) === d) {
      g.push(p);
      break;
    }
    p != null && p === document.body && jf(p) && !jf(document.documentElement) || p != null && jf(p, f) && g.push(p);
  }
  for (var h = n.visualViewport ? n.visualViewport.width : innerWidth, l = n.visualViewport ? n.visualViewport.height : innerHeight, w = window.scrollX || pageXOffset, m = window.scrollY || pageYOffset, y = e.getBoundingClientRect(), b = y.height, C = y.width, M = y.top, S = y.right, I = y.bottom, N = y.left, O = a === "start" || a === "nearest" ? M : a === "end" ? I : M + b / 2, F = i === "center" ? N + C / 2 : i === "end" ? S : N, Q = [], T = 0; T < g.length; T++) {
    var x = g[T], A = x.getBoundingClientRect(), B = A.height, J = A.width, $ = A.top, q = A.right, K = A.bottom, P = A.left;
    if (r === "if-needed" && M >= 0 && N >= 0 && I <= l && S <= h && M >= $ && I <= K && N >= P && S <= q)
      return Q;
    var R = getComputedStyle(x), W = parseInt(R.borderLeftWidth, 10), X = parseInt(R.borderTopWidth, 10), D = parseInt(R.borderRightWidth, 10), U = parseInt(R.borderBottomWidth, 10), k = 0, Y = 0, V = "offsetWidth" in x ? x.offsetWidth - x.clientWidth - W - D : 0, Z = "offsetHeight" in x ? x.offsetHeight - x.clientHeight - X - U : 0, re = "offsetWidth" in x ? x.offsetWidth === 0 ? 0 : J / x.offsetWidth : 0, ce = "offsetHeight" in x ? x.offsetHeight === 0 ? 0 : B / x.offsetHeight : 0;
    if (d === x)
      k = a === "start" ? O : a === "end" ? O - l : a === "nearest" ? Ai(m, m + l, l, X, U, m + O, m + O + b, b) : O - l / 2, Y = i === "start" ? F : i === "center" ? F - h / 2 : i === "end" ? F - h : Ai(w, w + h, h, W, D, w + F, w + F + C, C), k = Math.max(0, k + m), Y = Math.max(0, Y + w);
    else {
      k = a === "start" ? O - $ - X : a === "end" ? O - K + U + Z : a === "nearest" ? Ai($, K, B, X, U + Z, O, O + b, b) : O - ($ + B / 2) + Z / 2, Y = i === "start" ? F - P - W : i === "center" ? F - (P + J / 2) + V / 2 : i === "end" ? F - q + D + V : Ai(P, q, J, W, D + V, F, F + C, C);
      var _ = x.scrollLeft, Le = x.scrollTop;
      O += Le - (k = Math.max(0, Math.min(Le + k / ce, x.scrollHeight - B / ce + Z))), F += _ - (Y = Math.max(0, Math.min(_ + Y / re, x.scrollWidth - J / re + V)));
    }
    Q.push({ el: x, top: k, left: Y });
  }
  return Q;
};
function q1(e) {
  return e === Object(e) && Object.keys(e).length !== 0;
}
function c3(e, t) {
  t === void 0 && (t = "auto");
  var n = "scrollBehavior" in document.body.style;
  e.forEach(function(r) {
    var a = r.el, i = r.top, o = r.left;
    a.scroll && n ? a.scroll({
      top: i,
      left: o,
      behavior: t
    }) : (a.scrollTop = i, a.scrollLeft = o);
  });
}
function l3(e) {
  return e === !1 ? {
    block: "end",
    inline: "nearest"
  } : q1(e) ? e : {
    block: "start",
    inline: "nearest"
  };
}
function d3(e, t) {
  var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
  if (q1(t) && typeof t.behavior == "function")
    return t.behavior(n ? Tl(e, t) : []);
  if (n) {
    var r = l3(t);
    return c3(Tl(e, r), r.behavior);
  }
}
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */
function Nl(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function et(e) {
  var t, n;
  return Nl(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(Nl(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
function tt(e) {
  for (var t = arguments.length, n = Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  if (process.env.NODE_ENV !== "production") {
    var a = b3[e], i = a ? typeof a == "function" ? a.apply(null, n) : a : "unknown error nr: " + e;
    throw Error("[Immer] " + i);
  }
  throw Error("[Immer] minified error nr: " + e + (n.length ? " " + n.map(function(o) {
    return "'" + o + "'";
  }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function rr(e) {
  return !!e && !!e[jt];
}
function ar(e) {
  var t;
  return !!e && (function(n) {
    if (!n || typeof n != "object")
      return !1;
    var r = Object.getPrototypeOf(n);
    if (r === null)
      return !0;
    var a = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
    return a === Object || typeof a == "function" && Function.toString.call(a) === C3;
  }(e) || Array.isArray(e) || !!e[Ul] || !!(!((t = e.constructor) === null || t === void 0) && t[Ul]) || Fs(e) || Us(e));
}
function Ga(e, t, n) {
  n === void 0 && (n = !1), oa(e) === 0 ? (n ? Object.keys : Js)(e).forEach(function(r) {
    n && typeof r == "symbol" || t(r, e[r], e);
  }) : e.forEach(function(r, a) {
    return t(a, r, e);
  });
}
function oa(e) {
  var t = e[jt];
  return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : Fs(e) ? 2 : Us(e) ? 3 : 0;
}
function xu(e, t) {
  return oa(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function g3(e, t) {
  return oa(e) === 2 ? e.get(t) : e[t];
}
function X1(e, t, n) {
  var r = oa(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function p3(e, t) {
  return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function Fs(e) {
  return w3 && e instanceof Map;
}
function Us(e) {
  return y3 && e instanceof Set;
}
function Qn(e) {
  return e.o || e.t;
}
function Ys(e) {
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  var t = M3(e);
  delete t[jt];
  for (var n = Js(t), r = 0; r < n.length; r++) {
    var a = n[r], i = t[a];
    i.writable === !1 && (i.writable = !0, i.configurable = !0), (i.get || i.set) && (t[a] = { configurable: !0, writable: !0, enumerable: i.enumerable, value: e[a] });
  }
  return Object.create(Object.getPrototypeOf(e), t);
}
function Gs(e, t) {
  return t === void 0 && (t = !1), Hs(e) || rr(e) || !ar(e) || (oa(e) > 1 && (e.set = e.add = e.clear = e.delete = h3), Object.freeze(e), t && Ga(e, function(n, r) {
    return Gs(r, !0);
  }, !0)), e;
}
function h3() {
  tt(2);
}
function Hs(e) {
  return e == null || typeof e != "object" || Object.isFrozen(e);
}
function Kt(e) {
  var t = D3[e];
  return t || tt(18, e), t;
}
function kl() {
  return process.env.NODE_ENV === "production" || Wr || tt(0), Wr;
}
function If(e, t) {
  t && (Kt("Patches"), e.u = [], e.s = [], e.v = t);
}
function co(e) {
  Tu(e), e.p.forEach(v3), e.p = null;
}
function Tu(e) {
  e === Wr && (Wr = e.l);
}
function Bl(e) {
  return Wr = { p: [], l: Wr, h: e, m: !0, _: 0 };
}
function v3(e) {
  var t = e[jt];
  t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function Sf(e, t) {
  t._ = t.p.length;
  var n = t.p[0], r = e !== void 0 && e !== n;
  return t.h.O || Kt("ES5").S(t, e, r), r ? (n[jt].P && (co(t), tt(4)), ar(e) && (e = lo(t, e), t.l || go(t, e)), t.u && Kt("Patches").M(n[jt].t, e, t.u, t.s)) : e = lo(t, n, []), co(t), t.u && t.v(t.u, t.s), e !== eg ? e : void 0;
}
function lo(e, t, n) {
  if (Hs(t))
    return t;
  var r = t[jt];
  if (!r)
    return Ga(t, function(f, s) {
      return Ol(e, r, t, f, s, n);
    }, !0), t;
  if (r.A !== e)
    return t;
  if (!r.P)
    return go(e, r.t, !0), r.t;
  if (!r.I) {
    r.I = !0, r.A._--;
    var a = r.i === 4 || r.i === 5 ? r.o = Ys(r.k) : r.o, i = a, o = !1;
    r.i === 3 && (i = new Set(a), a.clear(), o = !0), Ga(i, function(f, s) {
      return Ol(e, r, a, f, s, n, o);
    }), go(e, a, !1), n && e.u && Kt("Patches").N(r, n, e.u, e.s);
  }
  return r.o;
}
function Ol(e, t, n, r, a, i, o) {
  if (process.env.NODE_ENV !== "production" && a === n && tt(5), rr(a)) {
    var f = lo(e, a, i && t && t.i !== 3 && !xu(t.R, r) ? i.concat(r) : void 0);
    if (X1(n, r, f), !rr(f))
      return;
    e.m = !1;
  } else
    o && n.add(a);
  if (ar(a) && !Hs(a)) {
    if (!e.h.D && e._ < 1)
      return;
    lo(e, a), t && t.A.l || go(e, a);
  }
}
function go(e, t, n) {
  n === void 0 && (n = !1), !e.l && e.h.D && e.m && Gs(t, n);
}
function xf(e, t) {
  var n = e[jt];
  return (n ? Qn(n) : e)[t];
}
function Pl(e, t) {
  if (t in e)
    for (var n = Object.getPrototypeOf(e); n; ) {
      var r = Object.getOwnPropertyDescriptor(n, t);
      if (r)
        return r;
      n = Object.getPrototypeOf(n);
    }
}
function Nu(e) {
  e.P || (e.P = !0, e.l && Nu(e.l));
}
function Tf(e) {
  e.o || (e.o = Ys(e.t));
}
function ku(e, t, n) {
  var r = Fs(t) ? Kt("MapSet").F(t, n) : Us(t) ? Kt("MapSet").T(t, n) : e.O ? function(a, i) {
    var o = Array.isArray(a), f = { i: o ? 1 : 0, A: i ? i.A : kl(), P: !1, I: !1, R: {}, l: i, t: a, k: null, o: null, j: null, C: !1 }, s = f, u = Bu;
    o && (s = [f], u = Ea);
    var c = Proxy.revocable(s, u), d = c.revoke, g = c.proxy;
    return f.k = g, f.j = d, g;
  }(t, n) : Kt("ES5").J(t, n);
  return (n ? n.A : kl()).p.push(r), r;
}
function m3(e) {
  return rr(e) || tt(22, e), function t(n) {
    if (!ar(n))
      return n;
    var r, a = n[jt], i = oa(n);
    if (a) {
      if (!a.P && (a.i < 4 || !Kt("ES5").K(a)))
        return a.t;
      a.I = !0, r = zl(n, i), a.I = !1;
    } else
      r = zl(n, i);
    return Ga(r, function(o, f) {
      a && g3(a.t, o) === f || X1(r, o, t(f));
    }), i === 3 ? new Set(r) : r;
  }(e);
}
function zl(e, t) {
  switch (t) {
    case 2:
      return new Map(e);
    case 3:
      return Array.from(e);
  }
  return Ys(e);
}
var Rl, Wr, Qs = typeof Symbol < "u" && typeof Symbol("x") == "symbol", w3 = typeof Map < "u", y3 = typeof Set < "u", Fl = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", eg = Qs ? Symbol.for("immer-nothing") : ((Rl = {})["immer-nothing"] = !0, Rl), Ul = Qs ? Symbol.for("immer-draftable") : "__$immer_draftable", jt = Qs ? Symbol.for("immer-state") : "__$immer_state", b3 = { 0: "Illegal state", 1: "Immer drafts cannot have computed properties", 2: "This object has been frozen and should not be mutated", 3: function(e) {
  return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
}, 4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.", 5: "Immer forbids circular references", 6: "The first or second argument to `produce` must be a function", 7: "The third argument to `produce` must be a function or undefined", 8: "First argument to `createDraft` must be a plain object, an array, or an immerable object", 9: "First argument to `finishDraft` must be a draft returned by `createDraft`", 10: "The given draft is already finalized", 11: "Object.defineProperty() cannot be used on an Immer draft", 12: "Object.setPrototypeOf() cannot be used on an Immer draft", 13: "Immer only supports deleting array indices", 14: "Immer only supports setting array indices and the 'length' property", 15: function(e) {
  return "Cannot apply patch, path doesn't resolve: " + e;
}, 16: 'Sets cannot have "replace" patches.', 17: function(e) {
  return "Unsupported patch operation: " + e;
}, 18: function(e) {
  return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
}, 20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available", 21: function(e) {
  return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
}, 22: function(e) {
  return "'current' expects a draft, got: " + e;
}, 23: function(e) {
  return "'original' expects a draft, got: " + e;
}, 24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed" }, C3 = "" + Object.prototype.constructor, Js = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols !== void 0 ? function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Object.getOwnPropertyNames, M3 = Object.getOwnPropertyDescriptors || function(e) {
  var t = {};
  return Js(e).forEach(function(n) {
    t[n] = Object.getOwnPropertyDescriptor(e, n);
  }), t;
}, D3 = {}, Bu = { get: function(e, t) {
  if (t === jt)
    return e;
  var n = Qn(e);
  if (!xu(n, t))
    return function(a, i, o) {
      var f, s = Pl(i, o);
      return s ? "value" in s ? s.value : (f = s.get) === null || f === void 0 ? void 0 : f.call(a.k) : void 0;
    }(e, n, t);
  var r = n[t];
  return e.I || !ar(r) ? r : r === xf(e.t, t) ? (Tf(e), e.o[t] = ku(e.A.h, r, e)) : r;
}, has: function(e, t) {
  return t in Qn(e);
}, ownKeys: function(e) {
  return Reflect.ownKeys(Qn(e));
}, set: function(e, t, n) {
  var r = Pl(Qn(e), t);
  if (r != null && r.set)
    return r.set.call(e.k, n), !0;
  if (!e.P) {
    var a = xf(Qn(e), t), i = a == null ? void 0 : a[jt];
    if (i && i.t === n)
      return e.o[t] = n, e.R[t] = !1, !0;
    if (p3(n, a) && (n !== void 0 || xu(e.t, t)))
      return !0;
    Tf(e), Nu(e);
  }
  return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
}, deleteProperty: function(e, t) {
  return xf(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, Tf(e), Nu(e)) : delete e.R[t], e.o && delete e.o[t], !0;
}, getOwnPropertyDescriptor: function(e, t) {
  var n = Qn(e), r = Reflect.getOwnPropertyDescriptor(n, t);
  return r && { writable: !0, configurable: e.i !== 1 || t !== "length", enumerable: r.enumerable, value: n[t] };
}, defineProperty: function() {
  tt(11);
}, getPrototypeOf: function(e) {
  return Object.getPrototypeOf(e.t);
}, setPrototypeOf: function() {
  tt(12);
} }, Ea = {};
Ga(Bu, function(e, t) {
  Ea[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
}), Ea.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && tt(13), Ea.set.call(this, e, t, void 0);
}, Ea.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && tt(14), Bu.set.call(this, e[0], t, n, e[0]);
};
var L3 = function() {
  function e(n) {
    var r = this;
    this.O = Fl, this.D = !0, this.produce = function(a, i, o) {
      if (typeof a == "function" && typeof i != "function") {
        var f = i;
        i = a;
        var s = r;
        return function(l) {
          var w = this;
          l === void 0 && (l = f);
          for (var m = arguments.length, y = Array(m > 1 ? m - 1 : 0), b = 1; b < m; b++)
            y[b - 1] = arguments[b];
          return s.produce(l, function(C) {
            var M;
            return (M = i).call.apply(M, [w, C].concat(y));
          });
        };
      }
      var u;
      if (typeof i != "function" && tt(6), o !== void 0 && typeof o != "function" && tt(7), ar(a)) {
        var c = Bl(r), d = ku(r, a, void 0), g = !0;
        try {
          u = i(d), g = !1;
        } finally {
          g ? co(c) : Tu(c);
        }
        return typeof Promise < "u" && u instanceof Promise ? u.then(function(l) {
          return If(c, o), Sf(l, c);
        }, function(l) {
          throw co(c), l;
        }) : (If(c, o), Sf(u, c));
      }
      if (!a || typeof a != "object") {
        if ((u = i(a)) === void 0 && (u = a), u === eg && (u = void 0), r.D && Gs(u, !0), o) {
          var p = [], h = [];
          Kt("Patches").M(a, u, p, h), o(p, h);
        }
        return u;
      }
      tt(21, a);
    }, this.produceWithPatches = function(a, i) {
      if (typeof a == "function")
        return function(u) {
          for (var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), g = 1; g < c; g++)
            d[g - 1] = arguments[g];
          return r.produceWithPatches(u, function(p) {
            return a.apply(void 0, [p].concat(d));
          });
        };
      var o, f, s = r.produce(a, i, function(u, c) {
        o = u, f = c;
      });
      return typeof Promise < "u" && s instanceof Promise ? s.then(function(u) {
        return [u, o, f];
      }) : [s, o, f];
    }, typeof (n == null ? void 0 : n.useProxies) == "boolean" && this.setUseProxies(n.useProxies), typeof (n == null ? void 0 : n.autoFreeze) == "boolean" && this.setAutoFreeze(n.autoFreeze);
  }
  var t = e.prototype;
  return t.createDraft = function(n) {
    ar(n) || tt(8), rr(n) && (n = m3(n));
    var r = Bl(this), a = ku(this, n, void 0);
    return a[jt].C = !0, Tu(r), a;
  }, t.finishDraft = function(n, r) {
    var a = n && n[jt];
    process.env.NODE_ENV !== "production" && (a && a.C || tt(9), a.I && tt(10));
    var i = a.A;
    return If(i, r), Sf(void 0, i);
  }, t.setAutoFreeze = function(n) {
    this.D = n;
  }, t.setUseProxies = function(n) {
    n && !Fl && tt(20), this.O = n;
  }, t.applyPatches = function(n, r) {
    var a;
    for (a = r.length - 1; a >= 0; a--) {
      var i = r[a];
      if (i.path.length === 0 && i.op === "replace") {
        n = i.value;
        break;
      }
    }
    a > -1 && (r = r.slice(a + 1));
    var o = Kt("Patches").$;
    return rr(n) ? o(n, r) : this.produce(n, function(f) {
      return o(f, r);
    });
  }, e;
}(), It = new L3(), Ws = It.produce;
It.produceWithPatches.bind(It);
It.setAutoFreeze.bind(It);
It.setUseProxies.bind(It);
It.applyPatches.bind(It);
var Yl = It.createDraft.bind(It), Gl = It.finishDraft.bind(It), A3 = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = j.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
}, E3 = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = be.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
}, j3 = {
  transform(e, t) {
    var {
      current: n,
      affinity: r
    } = e;
    if (n != null) {
      var a = z.transform(n, t, {
        affinity: r
      });
      e.current = a, a == null && e.unref();
    }
  }
}, po = /* @__PURE__ */ new WeakMap(), ho = /* @__PURE__ */ new WeakMap(), Sa = /* @__PURE__ */ new WeakMap(), tg = /* @__PURE__ */ new WeakMap(), Hl = /* @__PURE__ */ new WeakMap(), Ql = /* @__PURE__ */ new WeakMap(), Jl = /* @__PURE__ */ new WeakMap(), j = {
  ancestors(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = j.levels(e, t);
    return n ? r = r.slice(1) : r = r.slice(0, -1), r;
  },
  common(e, t) {
    for (var n = [], r = 0; r < e.length && r < t.length; r++) {
      var a = e[r], i = t[r];
      if (a !== i)
        break;
      n.push(a);
    }
    return n;
  },
  compare(e, t) {
    for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
      if (e[r] < t[r])
        return -1;
      if (e[r] > t[r])
        return 1;
    }
    return 0;
  },
  endsAfter(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), i = e[n], o = t[n];
    return j.equals(r, a) && i > o;
  },
  endsAt(e, t) {
    var n = e.length, r = e.slice(0, n), a = t.slice(0, n);
    return j.equals(r, a);
  },
  endsBefore(e, t) {
    var n = e.length - 1, r = e.slice(0, n), a = t.slice(0, n), i = e[n], o = t[n];
    return j.equals(r, a) && i < o;
  },
  equals(e, t) {
    return e.length === t.length && e.every((n, r) => n === t[r]);
  },
  hasPrevious(e) {
    return e[e.length - 1] > 0;
  },
  isAfter(e, t) {
    return j.compare(e, t) === 1;
  },
  isAncestor(e, t) {
    return e.length < t.length && j.compare(e, t) === 0;
  },
  isBefore(e, t) {
    return j.compare(e, t) === -1;
  },
  isChild(e, t) {
    return e.length === t.length + 1 && j.compare(e, t) === 0;
  },
  isCommon(e, t) {
    return e.length <= t.length && j.compare(e, t) === 0;
  },
  isDescendant(e, t) {
    return e.length > t.length && j.compare(e, t) === 0;
  },
  isParent(e, t) {
    return e.length + 1 === t.length && j.compare(e, t) === 0;
  },
  isPath(e) {
    return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
  },
  isSibling(e, t) {
    if (e.length !== t.length)
      return !1;
    var n = e.slice(0, -1), r = t.slice(0, -1), a = e[e.length - 1], i = t[t.length - 1];
    return a !== i && j.equals(n, r);
  },
  levels(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, r = [], a = 0; a <= e.length; a++)
      r.push(e.slice(0, a));
    return n && r.reverse(), r;
  },
  next(e) {
    if (e.length === 0)
      throw new Error("Cannot get the next path of a root path [".concat(e, "], because it has no next index."));
    var t = e[e.length - 1];
    return e.slice(0, -1).concat(t + 1);
  },
  operationCanTransformPath(e) {
    switch (e.type) {
      case "insert_node":
      case "remove_node":
      case "merge_node":
      case "split_node":
      case "move_node":
        return !0;
      default:
        return !1;
    }
  },
  parent(e) {
    if (e.length === 0)
      throw new Error("Cannot get the parent path of the root path [".concat(e, "]."));
    return e.slice(0, -1);
  },
  previous(e) {
    if (e.length === 0)
      throw new Error("Cannot get the previous path of a root path [".concat(e, "], because it has no previous index."));
    var t = e[e.length - 1];
    if (t <= 0)
      throw new Error("Cannot get the previous path of a first child path [".concat(e, "] because it would result in a negative index."));
    return e.slice(0, -1).concat(t - 1);
  },
  relative(e, t) {
    if (!j.isAncestor(t, e) && !j.equals(e, t))
      throw new Error("Cannot get the relative path of [".concat(e, "] inside ancestor [").concat(t, "], because it is not above or equal to the path."));
    return e.slice(t.length);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (!e)
      return null;
    var r = [...e], {
      affinity: a = "forward"
    } = n;
    if (e.length === 0)
      return r;
    switch (t.type) {
      case "insert_node": {
        var {
          path: i
        } = t;
        (j.equals(i, r) || j.endsBefore(i, r) || j.isAncestor(i, r)) && (r[i.length - 1] += 1);
        break;
      }
      case "remove_node": {
        var {
          path: o
        } = t;
        if (j.equals(o, r) || j.isAncestor(o, r))
          return null;
        j.endsBefore(o, r) && (r[o.length - 1] -= 1);
        break;
      }
      case "merge_node": {
        var {
          path: f,
          position: s
        } = t;
        j.equals(f, r) || j.endsBefore(f, r) ? r[f.length - 1] -= 1 : j.isAncestor(f, r) && (r[f.length - 1] -= 1, r[f.length] += s);
        break;
      }
      case "split_node": {
        var {
          path: u,
          position: c
        } = t;
        if (j.equals(u, r)) {
          if (a === "forward")
            r[r.length - 1] += 1;
          else if (a !== "backward")
            return null;
        } else
          j.endsBefore(u, r) ? r[u.length - 1] += 1 : j.isAncestor(u, r) && e[u.length] >= c && (r[u.length - 1] += 1, r[u.length] -= c);
        break;
      }
      case "move_node": {
        var {
          path: d,
          newPath: g
        } = t;
        if (j.equals(d, g))
          return r;
        if (j.isAncestor(d, r) || j.equals(d, r)) {
          var p = g.slice();
          return j.endsBefore(d, g) && d.length < g.length && (p[d.length - 1] -= 1), p.concat(r.slice(d.length));
        } else
          j.isSibling(d, g) && (j.isAncestor(g, r) || j.equals(g, r)) ? j.endsBefore(d, r) ? r[d.length - 1] -= 1 : r[d.length - 1] += 1 : j.endsBefore(g, r) || j.equals(g, r) || j.isAncestor(g, r) ? (j.endsBefore(d, r) && (r[d.length - 1] -= 1), r[g.length - 1] += 1) : j.endsBefore(d, r) && (j.equals(g, r) && (r[g.length - 1] += 1), r[d.length - 1] -= 1);
        break;
      }
    }
    return r;
  }
};
function dt(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function Wl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ya(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Wl(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Wl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var I3 = (e, t, n) => {
  switch (n.type) {
    case "insert_node": {
      var {
        path: r,
        node: a
      } = n, i = te.parent(e, r), o = r[r.length - 1];
      if (o > i.children.length)
        throw new Error('Cannot apply an "insert_node" operation at path ['.concat(r, "] because the destination is past the end of the node."));
      if (i.children.splice(o, 0, a), t)
        for (var [f, s] of z.points(t))
          t[s] = be.transform(f, n);
      break;
    }
    case "insert_text": {
      var {
        path: u,
        offset: c,
        text: d
      } = n;
      if (d.length === 0)
        break;
      var g = te.leaf(e, u), p = g.text.slice(0, c), h = g.text.slice(c);
      if (g.text = p + d + h, t)
        for (var [l, w] of z.points(t))
          t[w] = be.transform(l, n);
      break;
    }
    case "merge_node": {
      var {
        path: m
      } = n, y = te.get(e, m), b = j.previous(m), C = te.get(e, b), M = te.parent(e, m), S = m[m.length - 1];
      if (se.isText(y) && se.isText(C))
        C.text += y.text;
      else if (!se.isText(y) && !se.isText(C))
        C.children.push(...y.children);
      else
        throw new Error('Cannot apply a "merge_node" operation at path ['.concat(m, "] to nodes of different interfaces: ").concat(qe.stringify(y), " ").concat(qe.stringify(C)));
      if (M.children.splice(S, 1), t)
        for (var [I, N] of z.points(t))
          t[N] = be.transform(I, n);
      break;
    }
    case "move_node": {
      var {
        path: O,
        newPath: F
      } = n;
      if (j.isAncestor(O, F))
        throw new Error("Cannot move a path [".concat(O, "] to new path [").concat(F, "] because the destination is inside itself."));
      var Q = te.get(e, O), T = te.parent(e, O), x = O[O.length - 1];
      T.children.splice(x, 1);
      var A = j.transform(O, n), B = te.get(e, j.parent(A)), J = A[A.length - 1];
      if (B.children.splice(J, 0, Q), t)
        for (var [$, q] of z.points(t))
          t[q] = be.transform($, n);
      break;
    }
    case "remove_node": {
      var {
        path: K
      } = n, P = K[K.length - 1], R = te.parent(e, K);
      if (R.children.splice(P, 1), t)
        for (var [W, X] of z.points(t)) {
          var D = be.transform(W, n);
          if (t != null && D != null)
            t[X] = D;
          else {
            var U = void 0, k = void 0;
            for (var [Y, V] of te.texts(e))
              if (j.compare(V, K) === -1)
                U = [Y, V];
              else {
                k = [Y, V];
                break;
              }
            var Z = !1;
            U && k && (j.equals(k[1], K) ? Z = !j.hasPrevious(k[1]) : Z = j.common(U[1], K).length < j.common(k[1], K).length), U && !Z ? (W.path = U[1], W.offset = U[0].text.length) : k ? (W.path = k[1], W.offset = 0) : t = null;
          }
        }
      break;
    }
    case "remove_text": {
      var {
        path: re,
        offset: ce,
        text: _
      } = n;
      if (_.length === 0)
        break;
      var Le = te.leaf(e, re), he = Le.text.slice(0, ce), We = Le.text.slice(ce + _.length);
      if (Le.text = he + We, t)
        for (var [Ke, Ue] of z.points(t))
          t[Ue] = be.transform(Ke, n);
      break;
    }
    case "set_node": {
      var {
        path: bt,
        properties: ne,
        newProperties: de
      } = n;
      if (bt.length === 0)
        throw new Error("Cannot set properties on the root node!");
      var je = te.get(e, bt);
      for (var ve in de) {
        if (ve === "children" || ve === "text")
          throw new Error('Cannot set the "'.concat(ve, '" property of nodes!'));
        var Ye = de[ve];
        Ye == null ? delete je[ve] : je[ve] = Ye;
      }
      for (var Ze in ne)
        de.hasOwnProperty(Ze) || delete je[Ze];
      break;
    }
    case "set_selection": {
      var {
        newProperties: Ae
      } = n;
      if (Ae == null)
        t = Ae;
      else {
        if (t == null) {
          if (!z.isRange(Ae))
            throw new Error('Cannot apply an incomplete "set_selection" operation properties '.concat(qe.stringify(Ae), " when there is no current selection."));
          t = ya({}, Ae);
        }
        for (var Ct in Ae) {
          var yr = Ae[Ct];
          if (yr == null) {
            if (Ct === "anchor" || Ct === "focus")
              throw new Error('Cannot remove the "'.concat(Ct, '" selection property'));
            delete t[Ct];
          } else
            t[Ct] = yr;
        }
      }
      break;
    }
    case "split_node": {
      var {
        path: Mt,
        position: Fn,
        properties: bi
      } = n;
      if (Mt.length === 0)
        throw new Error('Cannot apply a "split_node" operation at path ['.concat(Mt, "] because the root node cannot be split."));
      var Un = te.get(e, Mt), Lv = te.parent(e, Mt), Av = Mt[Mt.length - 1], mf;
      if (se.isText(Un)) {
        var Ev = Un.text.slice(0, Fn), jv = Un.text.slice(Fn);
        Un.text = Ev, mf = ya(ya({}, bi), {}, {
          text: jv
        });
      } else {
        var Iv = Un.children.slice(0, Fn), Sv = Un.children.slice(Fn);
        Un.children = Iv, mf = ya(ya({}, bi), {}, {
          children: Sv
        });
      }
      if (Lv.children.splice(Av + 1, 0, mf), t)
        for (var [xv, Tv] of z.points(t))
          t[Tv] = be.transform(xv, n);
      break;
    }
  }
  return t;
}, S3 = {
  transform(e, t) {
    e.children = Yl(e.children);
    var n = e.selection && Yl(e.selection);
    try {
      n = I3(e, n, t);
    } finally {
      e.children = Gl(e.children), n ? e.selection = rr(n) ? Gl(n) : n : e.selection = null;
    }
  }
}, x3 = {
  insertNodes(e, t, n) {
    e.insertNodes(t, n);
  },
  liftNodes(e, t) {
    e.liftNodes(t);
  },
  mergeNodes(e, t) {
    e.mergeNodes(t);
  },
  moveNodes(e, t) {
    e.moveNodes(t);
  },
  removeNodes(e, t) {
    e.removeNodes(t);
  },
  setNodes(e, t, n) {
    e.setNodes(t, n);
  },
  splitNodes(e, t) {
    e.splitNodes(t);
  },
  unsetNodes(e, t, n) {
    e.unsetNodes(t, n);
  },
  unwrapNodes(e, t) {
    e.unwrapNodes(t);
  },
  wrapNodes(e, t, n) {
    e.wrapNodes(t, n);
  }
}, T3 = {
  collapse(e, t) {
    e.collapse(t);
  },
  deselect(e) {
    e.deselect();
  },
  move(e, t) {
    e.move(t);
  },
  select(e, t) {
    e.select(t);
  },
  setPoint(e, t, n) {
    e.setPoint(t, n);
  },
  setSelection(e, t) {
    e.setSelection(t);
  }
}, ng = (e, t) => {
  for (var n in e) {
    var r = e[n], a = t[n];
    if (et(r) && et(a)) {
      if (!ng(r, a))
        return !1;
    } else if (Array.isArray(r) && Array.isArray(a)) {
      if (r.length !== a.length)
        return !1;
      for (var i = 0; i < r.length; i++)
        if (r[i] !== a[i])
          return !1;
    } else if (r !== a)
      return !1;
  }
  for (var o in t)
    if (e[o] === void 0 && t[o] !== void 0)
      return !1;
  return !0;
};
function N3(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function ln(e, t) {
  if (e == null)
    return {};
  var n = N3(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var k3 = ["anchor", "focus"];
function _l(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function B3(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? _l(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : _l(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var z = {
  edges(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      reverse: n = !1
    } = t, {
      anchor: r,
      focus: a
    } = e;
    return z.isBackward(e) === n ? [r, a] : [a, r];
  },
  end(e) {
    var [, t] = z.edges(e);
    return t;
  },
  equals(e, t) {
    return be.equals(e.anchor, t.anchor) && be.equals(e.focus, t.focus);
  },
  includes(e, t) {
    if (z.isRange(t)) {
      if (z.includes(e, t.anchor) || z.includes(e, t.focus))
        return !0;
      var [n, r] = z.edges(e), [a, i] = z.edges(t);
      return be.isBefore(n, a) && be.isAfter(r, i);
    }
    var [o, f] = z.edges(e), s = !1, u = !1;
    return be.isPoint(t) ? (s = be.compare(t, o) >= 0, u = be.compare(t, f) <= 0) : (s = j.compare(t, o.path) >= 0, u = j.compare(t, f.path) <= 0), s && u;
  },
  intersection(e, t) {
    var n = ln(e, k3), [r, a] = z.edges(e), [i, o] = z.edges(t), f = be.isBefore(r, i) ? i : r, s = be.isBefore(a, o) ? a : o;
    return be.isBefore(s, f) ? null : B3({
      anchor: f,
      focus: s
    }, n);
  },
  isBackward(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return be.isAfter(t, n);
  },
  isCollapsed(e) {
    var {
      anchor: t,
      focus: n
    } = e;
    return be.equals(t, n);
  },
  isExpanded(e) {
    return !z.isCollapsed(e);
  },
  isForward(e) {
    return !z.isBackward(e);
  },
  isRange(e) {
    return et(e) && be.isPoint(e.anchor) && be.isPoint(e.focus);
  },
  *points(e) {
    yield [e.anchor, "anchor"], yield [e.focus, "focus"];
  },
  start(e) {
    var [t] = z.edges(e);
    return t;
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ws(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "inward"
      } = n, i, o;
      if (a === "inward") {
        var f = z.isCollapsed(r);
        z.isForward(r) ? (i = "forward", o = f ? i : "backward") : (i = "backward", o = f ? i : "forward");
      } else
        a === "outward" ? z.isForward(r) ? (i = "backward", o = "forward") : (i = "forward", o = "backward") : (i = a, o = a);
      var s = be.transform(r.anchor, t, {
        affinity: i
      }), u = be.transform(r.focus, t, {
        affinity: o
      });
      if (!s || !u)
        return null;
      r.anchor = s, r.focus = u;
    });
  }
}, Zl = (e) => et(e) && te.isNodeList(e.children) && !v.isEditor(e), fe = {
  isAncestor(e) {
    return et(e) && te.isNodeList(e.children);
  },
  isElement: Zl,
  isElementList(e) {
    return Array.isArray(e) && e.every((t) => fe.isElement(t));
  },
  isElementProps(e) {
    return e.children !== void 0;
  },
  isElementType: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
    return Zl(t) && t[r] === n;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "children" && e[n] !== t[n])
        return !1;
    return !0;
  }
}, O3 = ["children"], P3 = ["text"], $l = /* @__PURE__ */ new WeakMap(), te = {
  ancestor(e, t) {
    var n = te.get(e, t);
    if (se.isText(n))
      throw new Error("Cannot get the ancestor node at path [".concat(t, "] because it refers to a text node instead: ").concat(qe.stringify(n)));
    return n;
  },
  *ancestors(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of j.ancestors(t, n)) {
      var a = te.ancestor(e, r), i = [a, r];
      yield i;
    }
  },
  child(e, t) {
    if (se.isText(e))
      throw new Error("Cannot get the child of a text node: ".concat(qe.stringify(e)));
    var n = e.children[t];
    if (n == null)
      throw new Error("Cannot get child at index `".concat(t, "` in node: ").concat(qe.stringify(e)));
    return n;
  },
  *children(e, t) {
    for (var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      reverse: r = !1
    } = n, a = te.ancestor(e, t), {
      children: i
    } = a, o = r ? i.length - 1 : 0; r ? o >= 0 : o < i.length; ) {
      var f = te.child(a, o), s = t.concat(o);
      yield [f, s], o = r ? o - 1 : o + 1;
    }
  },
  common(e, t, n) {
    var r = j.common(t, n), a = te.get(e, r);
    return [a, r];
  },
  descendant(e, t) {
    var n = te.get(e, t);
    if (v.isEditor(n))
      throw new Error("Cannot get the descendant node at path [".concat(t, "] because it refers to the root editor node instead: ").concat(qe.stringify(n)));
    return n;
  },
  *descendants(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of te.nodes(e, t))
      r.length !== 0 && (yield [n, r]);
  },
  *elements(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of te.nodes(e, t))
      fe.isElement(n) && (yield [n, r]);
  },
  extractProps(e) {
    if (fe.isAncestor(e)) {
      var t = ln(e, O3);
      return t;
    } else {
      var t = ln(e, P3);
      return t;
    }
  },
  first(e, t) {
    for (var n = t.slice(), r = te.get(e, n); r && !(se.isText(r) || r.children.length === 0); )
      r = r.children[0], n.push(0);
    return [r, n];
  },
  fragment(e, t) {
    if (se.isText(e))
      throw new Error("Cannot get a fragment starting from a root text node: ".concat(qe.stringify(e)));
    var n = Ws({
      children: e.children
    }, (r) => {
      var [a, i] = z.edges(t), o = te.nodes(r, {
        reverse: !0,
        pass: (g) => {
          var [, p] = g;
          return !z.includes(t, p);
        }
      });
      for (var [, f] of o) {
        if (!z.includes(t, f)) {
          var s = te.parent(r, f), u = f[f.length - 1];
          s.children.splice(u, 1);
        }
        if (j.equals(f, i.path)) {
          var c = te.leaf(r, f);
          c.text = c.text.slice(0, i.offset);
        }
        if (j.equals(f, a.path)) {
          var d = te.leaf(r, f);
          d.text = d.text.slice(a.offset);
        }
      }
      v.isEditor(r) && (r.selection = null);
    });
    return n.children;
  },
  get(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (se.isText(n) || !n.children[a])
        throw new Error("Cannot find a descendant at path [".concat(t, "] in node: ").concat(qe.stringify(e)));
      n = n.children[a];
    }
    return n;
  },
  has(e, t) {
    for (var n = e, r = 0; r < t.length; r++) {
      var a = t[r];
      if (se.isText(n) || !n.children[a])
        return !1;
      n = n.children[a];
    }
    return !0;
  },
  isNode(e) {
    return se.isText(e) || fe.isElement(e) || v.isEditor(e);
  },
  isNodeList(e) {
    if (!Array.isArray(e))
      return !1;
    var t = $l.get(e);
    if (t !== void 0)
      return t;
    var n = e.every((r) => te.isNode(r));
    return $l.set(e, n), n;
  },
  last(e, t) {
    for (var n = t.slice(), r = te.get(e, n); r && !(se.isText(r) || r.children.length === 0); ) {
      var a = r.children.length - 1;
      r = r.children[a], n.push(a);
    }
    return [r, n];
  },
  leaf(e, t) {
    var n = te.get(e, t);
    if (!se.isText(n))
      throw new Error("Cannot get the leaf node at path [".concat(t, "] because it refers to a non-leaf node: ").concat(qe.stringify(n)));
    return n;
  },
  *levels(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    for (var r of j.levels(t, n)) {
      var a = te.get(e, r);
      yield [a, r];
    }
  },
  matches(e, t) {
    return fe.isElement(e) && fe.isElementProps(t) && fe.matches(e, t) || se.isText(e) && se.isTextProps(t) && se.matches(e, t);
  },
  *nodes(e) {
    for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      pass: n,
      reverse: r = !1
    } = t, {
      from: a = [],
      to: i
    } = t, o = /* @__PURE__ */ new Set(), f = [], s = e; !(i && (r ? j.isBefore(f, i) : j.isAfter(f, i))); ) {
      if (o.has(s) || (yield [s, f]), !o.has(s) && !se.isText(s) && s.children.length !== 0 && (n == null || n([s, f]) === !1)) {
        o.add(s);
        var u = r ? s.children.length - 1 : 0;
        j.isAncestor(f, a) && (u = a[f.length]), f = f.concat(u), s = te.get(e, f);
        continue;
      }
      if (f.length === 0)
        break;
      if (!r) {
        var c = j.next(f);
        if (te.has(e, c)) {
          f = c, s = te.get(e, f);
          continue;
        }
      }
      if (r && f[f.length - 1] !== 0) {
        var d = j.previous(f);
        f = d, s = te.get(e, f);
        continue;
      }
      f = j.parent(f), s = te.get(e, f), o.add(s);
    }
  },
  parent(e, t) {
    var n = j.parent(t), r = te.get(e, n);
    if (se.isText(r))
      throw new Error("Cannot get the parent of path [".concat(t, "] because it does not exist in the root."));
    return r;
  },
  string(e) {
    return se.isText(e) ? e.text : e.children.map(te.string).join("");
  },
  *texts(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    for (var [n, r] of te.nodes(e, t))
      se.isText(n) && (yield [n, r]);
  }
};
function Vl(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Be(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Vl(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Vl(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Sn = {
  isNodeOperation(e) {
    return Sn.isOperation(e) && e.type.endsWith("_node");
  },
  isOperation(e) {
    if (!et(e))
      return !1;
    switch (e.type) {
      case "insert_node":
        return j.isPath(e.path) && te.isNode(e.node);
      case "insert_text":
        return typeof e.offset == "number" && typeof e.text == "string" && j.isPath(e.path);
      case "merge_node":
        return typeof e.position == "number" && j.isPath(e.path) && et(e.properties);
      case "move_node":
        return j.isPath(e.path) && j.isPath(e.newPath);
      case "remove_node":
        return j.isPath(e.path) && te.isNode(e.node);
      case "remove_text":
        return typeof e.offset == "number" && typeof e.text == "string" && j.isPath(e.path);
      case "set_node":
        return j.isPath(e.path) && et(e.properties) && et(e.newProperties);
      case "set_selection":
        return e.properties === null && z.isRange(e.newProperties) || e.newProperties === null && z.isRange(e.properties) || et(e.properties) && et(e.newProperties);
      case "split_node":
        return j.isPath(e.path) && typeof e.position == "number" && et(e.properties);
      default:
        return !1;
    }
  },
  isOperationList(e) {
    return Array.isArray(e) && e.every((t) => Sn.isOperation(t));
  },
  isSelectionOperation(e) {
    return Sn.isOperation(e) && e.type.endsWith("_selection");
  },
  isTextOperation(e) {
    return Sn.isOperation(e) && e.type.endsWith("_text");
  },
  inverse(e) {
    switch (e.type) {
      case "insert_node":
        return Be(Be({}, e), {}, {
          type: "remove_node"
        });
      case "insert_text":
        return Be(Be({}, e), {}, {
          type: "remove_text"
        });
      case "merge_node":
        return Be(Be({}, e), {}, {
          type: "split_node",
          path: j.previous(e.path)
        });
      case "move_node": {
        var {
          newPath: t,
          path: n
        } = e;
        if (j.equals(t, n))
          return e;
        if (j.isSibling(n, t))
          return Be(Be({}, e), {}, {
            path: t,
            newPath: n
          });
        var r = j.transform(n, e), a = j.transform(j.next(n), e);
        return Be(Be({}, e), {}, {
          path: r,
          newPath: a
        });
      }
      case "remove_node":
        return Be(Be({}, e), {}, {
          type: "insert_node"
        });
      case "remove_text":
        return Be(Be({}, e), {}, {
          type: "insert_text"
        });
      case "set_node": {
        var {
          properties: i,
          newProperties: o
        } = e;
        return Be(Be({}, e), {}, {
          properties: o,
          newProperties: i
        });
      }
      case "set_selection": {
        var {
          properties: f,
          newProperties: s
        } = e;
        return f == null ? Be(Be({}, e), {}, {
          properties: s,
          newProperties: null
        }) : s == null ? Be(Be({}, e), {}, {
          properties: null,
          newProperties: f
        }) : Be(Be({}, e), {}, {
          properties: s,
          newProperties: f
        });
      }
      case "split_node":
        return Be(Be({}, e), {}, {
          type: "merge_node",
          path: j.next(e.path)
        });
    }
  }
}, Kl = /* @__PURE__ */ new WeakMap(), z3 = (e) => {
  var t = Kl.get(e);
  if (t !== void 0)
    return t;
  if (!et(e))
    return !1;
  var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isElementReadOnly == "function" && typeof e.isInline == "function" && typeof e.isSelectable == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || et(e.marks)) && (e.selection === null || z.isRange(e.selection)) && te.isNodeList(e.children) && Sn.isOperationList(e.operations);
  return Kl.set(e, n), n;
}, v = {
  above(e, t) {
    return e.above(t);
  },
  addMark(e, t, n) {
    e.addMark(t, n);
  },
  after(e, t, n) {
    return e.after(t, n);
  },
  before(e, t, n) {
    return e.before(t, n);
  },
  deleteBackward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteBackward(n);
  },
  deleteForward(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      unit: n = "character"
    } = t;
    e.deleteForward(n);
  },
  deleteFragment(e, t) {
    e.deleteFragment(t);
  },
  edges(e, t) {
    return e.edges(t);
  },
  elementReadOnly(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return e.elementReadOnly(t);
  },
  end(e, t) {
    return e.end(t);
  },
  first(e, t) {
    return e.first(t);
  },
  fragment(e, t) {
    return e.fragment(t);
  },
  hasBlocks(e, t) {
    return e.hasBlocks(t);
  },
  hasInlines(e, t) {
    return e.hasInlines(t);
  },
  hasPath(e, t) {
    return e.hasPath(t);
  },
  hasTexts(e, t) {
    return e.hasTexts(t);
  },
  insertBreak(e) {
    e.insertBreak();
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertNode(e, t) {
    e.insertNode(t);
  },
  insertSoftBreak(e) {
    e.insertSoftBreak();
  },
  insertText(e, t) {
    e.insertText(t);
  },
  isBlock(e, t) {
    return e.isBlock(t);
  },
  isEdge(e, t, n) {
    return e.isEdge(t, n);
  },
  isEditor(e) {
    return z3(e);
  },
  isElementReadOnly(e, t) {
    return e.isElementReadOnly(t);
  },
  isEmpty(e, t) {
    return e.isEmpty(t);
  },
  isEnd(e, t, n) {
    return e.isEnd(t, n);
  },
  isInline(e, t) {
    return e.isInline(t);
  },
  isNormalizing(e) {
    return e.isNormalizing();
  },
  isSelectable(e, t) {
    return e.isSelectable(t);
  },
  isStart(e, t, n) {
    return e.isStart(t, n);
  },
  isVoid(e, t) {
    return e.isVoid(t);
  },
  last(e, t) {
    return e.last(t);
  },
  leaf(e, t, n) {
    return e.leaf(t, n);
  },
  levels(e, t) {
    return e.levels(t);
  },
  marks(e) {
    return e.getMarks();
  },
  next(e, t) {
    return e.next(t);
  },
  node(e, t, n) {
    return e.node(t, n);
  },
  nodes(e, t) {
    return e.nodes(t);
  },
  normalize(e, t) {
    e.normalize(t);
  },
  parent(e, t, n) {
    return e.parent(t, n);
  },
  path(e, t, n) {
    return e.path(t, n);
  },
  pathRef(e, t, n) {
    return e.pathRef(t, n);
  },
  pathRefs(e) {
    return e.pathRefs();
  },
  point(e, t, n) {
    return e.point(t, n);
  },
  pointRef(e, t, n) {
    return e.pointRef(t, n);
  },
  pointRefs(e) {
    return e.pointRefs();
  },
  positions(e, t) {
    return e.positions(t);
  },
  previous(e, t) {
    return e.previous(t);
  },
  range(e, t, n) {
    return e.range(t, n);
  },
  rangeRef(e, t, n) {
    return e.rangeRef(t, n);
  },
  rangeRefs(e) {
    return e.rangeRefs();
  },
  removeMark(e, t) {
    e.removeMark(t);
  },
  setNormalizing(e, t) {
    e.setNormalizing(t);
  },
  start(e, t) {
    return e.start(t);
  },
  string(e, t, n) {
    return e.string(t, n);
  },
  unhangRange(e, t, n) {
    return e.unhangRange(t, n);
  },
  void(e, t) {
    return e.void(t);
  },
  withoutNormalizing(e, t) {
    e.withoutNormalizing(t);
  }
}, R3 = {
  isSpan(e) {
    return Array.isArray(e) && e.length === 2 && e.every(j.isPath);
  }
};
function ql(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xl(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ql(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ql(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var be = {
  compare(e, t) {
    var n = j.compare(e.path, t.path);
    return n === 0 ? e.offset < t.offset ? -1 : e.offset > t.offset ? 1 : 0 : n;
  },
  isAfter(e, t) {
    return be.compare(e, t) === 1;
  },
  isBefore(e, t) {
    return be.compare(e, t) === -1;
  },
  equals(e, t) {
    return e.offset === t.offset && j.equals(e.path, t.path);
  },
  isPoint(e) {
    return et(e) && typeof e.offset == "number" && j.isPath(e.path);
  },
  transform(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Ws(e, (r) => {
      if (r === null)
        return null;
      var {
        affinity: a = "forward"
      } = n, {
        path: i,
        offset: o
      } = r;
      switch (t.type) {
        case "insert_node":
        case "move_node": {
          r.path = j.transform(i, t, n);
          break;
        }
        case "insert_text": {
          j.equals(t.path, i) && (t.offset < o || t.offset === o && a === "forward") && (r.offset += t.text.length);
          break;
        }
        case "merge_node": {
          j.equals(t.path, i) && (r.offset += t.position), r.path = j.transform(i, t, n);
          break;
        }
        case "remove_text": {
          j.equals(t.path, i) && t.offset <= o && (r.offset -= Math.min(o - t.offset, t.text.length));
          break;
        }
        case "remove_node": {
          if (j.equals(t.path, i) || j.isAncestor(t.path, i))
            return null;
          r.path = j.transform(i, t, n);
          break;
        }
        case "split_node": {
          if (j.equals(t.path, i)) {
            if (t.position === o && a == null)
              return null;
            (t.position < o || t.position === o && a === "forward") && (r.offset -= t.position, r.path = j.transform(i, t, Xl(Xl({}, n), {}, {
              affinity: "forward"
            })));
          } else
            r.path = j.transform(i, t, n);
          break;
        }
      }
    });
  }
}, ed = void 0, qe = {
  setScrubber(e) {
    ed = e;
  },
  stringify(e) {
    return JSON.stringify(e, ed);
  }
}, F3 = ["text"], U3 = ["anchor", "focus"];
function td(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? td(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : td(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var se = {
  equals(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      loose: r = !1
    } = n;
    function a(i) {
      var o = ln(i, F3);
      return o;
    }
    return ng(r ? a(e) : e, r ? a(t) : t);
  },
  isText(e) {
    return et(e) && typeof e.text == "string";
  },
  isTextList(e) {
    return Array.isArray(e) && e.every((t) => se.isText(t));
  },
  isTextProps(e) {
    return e.text !== void 0;
  },
  matches(e, t) {
    for (var n in t)
      if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n]))
        return !1;
    return !0;
  },
  decorations(e, t) {
    var n = [fn({}, e)];
    for (var r of t) {
      var a = ln(r, U3), [i, o] = z.edges(r), f = [], s = 0, u = i.offset, c = o.offset;
      for (var d of n) {
        var {
          length: g
        } = d.text, p = s;
        if (s += g, u <= p && s <= c) {
          Object.assign(d, a), f.push(d);
          continue;
        }
        if (u !== c && (u === s || c === p) || u > s || c < p || c === p && p !== 0) {
          f.push(d);
          continue;
        }
        var h = d, l = void 0, w = void 0;
        if (c < s) {
          var m = c - p;
          w = fn(fn({}, h), {}, {
            text: h.text.slice(m)
          }), h = fn(fn({}, h), {}, {
            text: h.text.slice(0, m)
          });
        }
        if (u > p) {
          var y = u - p;
          l = fn(fn({}, h), {}, {
            text: h.text.slice(0, y)
          }), h = fn(fn({}, h), {}, {
            text: h.text.slice(y)
          });
        }
        Object.assign(h, a), l && f.push(l), f.push(h), w && f.push(w);
      }
      n = f;
    }
    return n;
  }
}, _s = (e) => e.selection ? e.selection : e.children.length > 0 ? v.end(e, []) : [0], fa = (e, t) => {
  var [n] = v.node(e, t);
  return (r) => r === n;
}, Zs = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = !n, a = n ? W3(t) : t, i = ge.None, o = ge.None, f = 0, s = null, u = null;
  for (var c of a) {
    var d = c.codePointAt(0);
    if (!d)
      break;
    var g = ay(c, d);
    if ([i, o] = r ? [o, g] : [g, i], Ir(i, ge.ZWJ) && Ir(o, ge.ExtPict) && (r ? s = nd(t.substring(0, f)) : s = nd(t.substring(0, t.length - f)), !s) || Ir(i, ge.RI) && Ir(o, ge.RI) && (u !== null ? u = !u : r ? u = !0 : u = sy(t.substring(0, t.length - f)), !u) || i !== ge.None && o !== ge.None && oy(i, o))
      break;
    f += c.length;
  }
  return f || 1;
}, Y3 = /\s/, G3 = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, H3 = /['\u2018\u2019]/, Q3 = function(t) {
  for (var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = 0, a = !1; t.length > 0; ) {
    var i = Zs(t, n), [o, f] = $s(t, i, n);
    if (J3(o, f, n))
      a = !0, r += i;
    else if (!a)
      r += i;
    else
      break;
    t = f;
  }
  return r;
}, $s = (e, t, n) => {
  if (n) {
    var r = e.length - t;
    return [e.slice(r, e.length), e.slice(0, r)];
  }
  return [e.slice(0, t), e.slice(t)];
}, J3 = function e(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  if (Y3.test(t))
    return !1;
  if (H3.test(t)) {
    var a = Zs(n, r), [i, o] = $s(n, a, r);
    if (e(i, o, r))
      return !0;
  }
  return !G3.test(t);
}, W3 = function* (t) {
  for (var n = t.length - 1, r = 0; r < t.length; r++) {
    var a = t.charAt(n - r);
    if (Z3(a.charCodeAt(0))) {
      var i = t.charAt(n - r - 1);
      if (_3(i.charCodeAt(0))) {
        yield i + a, r++;
        continue;
      }
    }
    yield a;
  }
}, _3 = (e) => e >= 55296 && e <= 56319, Z3 = (e) => e >= 56320 && e <= 57343, ge;
(function(e) {
  e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(ge || (ge = {}));
var $3 = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, V3 = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, K3 = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, q3 = /^[\u1100-\u115F\uA960-\uA97C]$/, X3 = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, ey = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, ty = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, ny = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, ry = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, ay = (e, t) => {
  var n = ge.Any;
  return e.search($3) !== -1 && (n |= ge.Extend), t === 8205 && (n |= ge.ZWJ), t >= 127462 && t <= 127487 && (n |= ge.RI), e.search(V3) !== -1 && (n |= ge.Prepend), e.search(K3) !== -1 && (n |= ge.SpacingMark), e.search(q3) !== -1 && (n |= ge.L), e.search(X3) !== -1 && (n |= ge.V), e.search(ey) !== -1 && (n |= ge.T), e.search(ty) !== -1 && (n |= ge.LV), e.search(ny) !== -1 && (n |= ge.LVT), e.search(ry) !== -1 && (n |= ge.ExtPict), n;
};
function Ir(e, t) {
  return (e & t) !== 0;
}
var iy = [
  // GB6
  [ge.L, ge.L | ge.V | ge.LV | ge.LVT],
  // GB7
  [ge.LV | ge.V, ge.V | ge.T],
  // GB8
  [ge.LVT | ge.T, ge.T],
  // GB9
  [ge.Any, ge.Extend | ge.ZWJ],
  // GB9a
  [ge.Any, ge.SpacingMark],
  // GB9b
  [ge.Prepend, ge.Any],
  // GB11
  [ge.ZWJ, ge.ExtPict],
  // GB12 and GB13
  [ge.RI, ge.RI]
];
function oy(e, t) {
  return iy.findIndex((n) => Ir(e, n[0]) && Ir(t, n[1])) === -1;
}
var fy = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, nd = (e) => e.search(fy) !== -1, uy = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, sy = (e) => {
  var t = e.match(uy);
  if (t === null)
    return !1;
  var n = t[0].length / 2;
  return n % 2 === 1;
}, cy = {
  delete(e, t) {
    e.delete(t);
  },
  insertFragment(e, t, n) {
    e.insertFragment(t, n);
  },
  insertText(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    v.withoutNormalizing(e, () => {
      var {
        voids: r = !1
      } = n, {
        at: a = _s(e)
      } = n;
      if (j.isPath(a) && (a = v.range(e, a)), z.isRange(a))
        if (z.isCollapsed(a))
          a = a.anchor;
        else {
          var i = z.end(a);
          if (!r && v.void(e, {
            at: i
          }))
            return;
          var o = z.start(a), f = v.pointRef(e, o), s = v.pointRef(e, i);
          H.delete(e, {
            at: a,
            voids: r
          });
          var u = f.unref(), c = s.unref();
          a = u || c, H.setSelection(e, {
            anchor: a,
            focus: a
          });
        }
      if (!(!r && v.void(e, {
        at: a
      }) || v.elementReadOnly(e, {
        at: a
      }))) {
        var {
          path: d,
          offset: g
        } = a;
        t.length > 0 && e.apply({
          type: "insert_text",
          path: d,
          offset: g,
          text: t
        });
      }
    });
  }
};
function rd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ei(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? rd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var H = Ei(Ei(Ei(Ei({}, S3), x3), T3), cy), ly = (e, t) => {
  for (var n of v.pathRefs(e))
    A3.transform(n, t);
  for (var r of v.pointRefs(e))
    E3.transform(r, t);
  for (var a of v.rangeRefs(e))
    j3.transform(a, t);
  var i = po.get(e) || [], o = ho.get(e) || /* @__PURE__ */ new Set(), f, s, u = (h) => {
    if (h) {
      var l = h.join(",");
      s.has(l) || (s.add(l), f.push(h));
    }
  };
  if (j.operationCanTransformPath(t)) {
    f = [], s = /* @__PURE__ */ new Set();
    for (var c of i) {
      var d = j.transform(c, t);
      u(d);
    }
  } else
    f = i, s = o;
  var g = e.getDirtyPaths(t);
  for (var p of g)
    u(p);
  po.set(e, f), ho.set(e, s), H.transform(e, t), e.operations.push(t), v.normalize(e, {
    operation: t
  }), t.type === "set_selection" && (e.marks = null), Sa.get(e) || (Sa.set(e, !0), Promise.resolve().then(() => {
    Sa.set(e, !1), e.onChange({
      operation: t
    }), e.operations = [];
  }));
}, dy = (e, t) => {
  switch (t.type) {
    case "insert_text":
    case "remove_text":
    case "set_node": {
      var {
        path: n
      } = t;
      return j.levels(n);
    }
    case "insert_node": {
      var {
        node: r,
        path: a
      } = t, i = j.levels(a), o = se.isText(r) ? [] : Array.from(te.nodes(r), (F) => {
        var [, Q] = F;
        return a.concat(Q);
      });
      return [...i, ...o];
    }
    case "merge_node": {
      var {
        path: f
      } = t, s = j.ancestors(f), u = j.previous(f);
      return [...s, u];
    }
    case "move_node": {
      var {
        path: c,
        newPath: d
      } = t;
      if (j.equals(c, d))
        return [];
      var g = [], p = [];
      for (var h of j.ancestors(c)) {
        var l = j.transform(h, t);
        g.push(l);
      }
      for (var w of j.ancestors(d)) {
        var m = j.transform(w, t);
        p.push(m);
      }
      var y = p[p.length - 1], b = d[d.length - 1], C = y.concat(b);
      return [...g, ...p, C];
    }
    case "remove_node": {
      var {
        path: M
      } = t, S = j.ancestors(M);
      return [...S];
    }
    case "split_node": {
      var {
        path: I
      } = t, N = j.levels(I), O = j.next(I);
      return [...N, O];
    }
    default:
      return [];
  }
}, gy = (e) => {
  var {
    selection: t
  } = e;
  return t ? te.fragment(e, t) : [];
}, py = (e, t) => {
  var [n, r] = t;
  if (!se.isText(n)) {
    if (fe.isElement(n) && n.children.length === 0) {
      var a = {
        text: ""
      };
      H.insertNodes(e, a, {
        at: r.concat(0),
        voids: !0
      });
      return;
    }
    for (var i = v.isEditor(n) ? !1 : fe.isElement(n) && (e.isInline(n) || n.children.length === 0 || se.isText(n.children[0]) || e.isInline(n.children[0])), o = 0, f = 0; f < n.children.length; f++, o++) {
      var s = te.get(e, r);
      if (!se.isText(s)) {
        var u = s.children[o], c = s.children[o - 1], d = f === n.children.length - 1, g = se.isText(u) || fe.isElement(u) && e.isInline(u);
        if (g !== i)
          H.removeNodes(e, {
            at: r.concat(o),
            voids: !0
          }), o--;
        else if (fe.isElement(u)) {
          if (e.isInline(u)) {
            if (c == null || !se.isText(c)) {
              var p = {
                text: ""
              };
              H.insertNodes(e, p, {
                at: r.concat(o),
                voids: !0
              }), o++;
            } else if (d) {
              var h = {
                text: ""
              };
              H.insertNodes(e, h, {
                at: r.concat(o + 1),
                voids: !0
              }), o++;
            }
          }
        } else
          c != null && se.isText(c) && (se.equals(u, c, {
            loose: !0
          }) ? (H.mergeNodes(e, {
            at: r.concat(o),
            voids: !0
          }), o--) : c.text === "" ? (H.removeNodes(e, {
            at: r.concat(o - 1),
            voids: !0
          }), o--) : u.text === "" && (H.removeNodes(e, {
            at: r.concat(o),
            voids: !0
          }), o--));
      }
    }
  }
}, hy = (e, t) => {
  var {
    iteration: n,
    initialDirtyPathsLength: r
  } = t, a = r * 42;
  if (n > a)
    throw new Error("Could not completely normalize the editor after ".concat(a, " iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state."));
  return !0;
}, vy = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    voids: r = !1,
    mode: a = "lowest",
    at: i = t.selection,
    match: o
  } = n;
  if (i) {
    var f = v.path(t, i), s = a === "lowest";
    for (var [u, c] of v.levels(t, {
      at: f,
      voids: r,
      match: o,
      reverse: s
    }))
      if (!se.isText(u)) {
        if (z.isRange(i)) {
          if (j.isAncestor(c, i.anchor.path) && j.isAncestor(c, i.focus.path))
            return [u, c];
        } else if (!j.equals(f, c))
          return [u, c];
      }
  }
};
function ad(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function id(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ad(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ad(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var my = (e, t, n) => {
  var {
    selection: r
  } = e;
  if (r) {
    var a = (d, g) => {
      if (!se.isText(d))
        return !1;
      var [p, h] = v.parent(e, g);
      return !e.isVoid(p) || e.markableVoid(p);
    }, i = z.isExpanded(r), o = !1;
    if (!i) {
      var [f, s] = v.node(e, r);
      if (f && a(f, s)) {
        var [u] = v.parent(e, s);
        o = u && e.markableVoid(u);
      }
    }
    if (i || o)
      H.setNodes(e, {
        [t]: n
      }, {
        match: a,
        split: !0,
        voids: !0
      });
    else {
      var c = id(id({}, v.marks(e) || {}), {}, {
        [t]: n
      });
      e.marks = c, Sa.get(e) || e.onChange();
    }
  }
};
function od(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function fd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? od(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : od(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var wy = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = v.point(t, n, {
    edge: "end"
  }), i = v.end(t, []), o = {
    anchor: a,
    focus: i
  }, {
    distance: f = 1
  } = r, s = 0, u;
  for (var c of v.positions(t, fd(fd({}, r), {}, {
    at: o
  }))) {
    if (s > f)
      break;
    s !== 0 && (u = c), s++;
  }
  return u;
};
function ud(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function sd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ud(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ud(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var yy = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = v.start(t, []), i = v.point(t, n, {
    edge: "start"
  }), o = {
    anchor: a,
    focus: i
  }, {
    distance: f = 1
  } = r, s = 0, u;
  for (var c of v.positions(t, sd(sd({}, r), {}, {
    at: o,
    reverse: !0
  }))) {
    if (s > f)
      break;
    s !== 0 && (u = c), s++;
  }
  return u;
}, by = (e, t) => {
  var {
    selection: n
  } = e;
  n && z.isCollapsed(n) && H.delete(e, {
    unit: t,
    reverse: !0
  });
}, Cy = (e, t) => {
  var {
    selection: n
  } = e;
  n && z.isCollapsed(n) && H.delete(e, {
    unit: t
  });
}, My = function(t) {
  var {
    direction: n = "forward"
  } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: r
  } = t;
  r && z.isExpanded(r) && H.delete(t, {
    reverse: n === "backward"
  });
}, Dy = (e, t) => [v.start(e, t), v.end(e, t)];
function cd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ld(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? cd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ly = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return v.above(t, ld(ld({}, n), {}, {
    match: (r) => fe.isElement(r) && v.isElementReadOnly(t, r)
  }));
}, Ay = (e, t) => v.point(e, t, {
  edge: "end"
}), Ey = (e, t) => {
  var n = v.path(e, t, {
    edge: "start"
  });
  return v.node(e, n);
}, jy = (e, t) => {
  var n = v.range(e, t);
  return te.fragment(e, n);
};
function dd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function gd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? dd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : dd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Iy = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return v.above(t, gd(gd({}, n), {}, {
    match: (r) => fe.isElement(r) && v.isVoid(t, r)
  }));
}, Sy = (e, t) => t.children.some((n) => fe.isElement(n) && v.isBlock(e, n)), xy = (e, t) => t.children.some((n) => se.isText(n) || v.isInline(e, n)), Ty = (e, t) => te.has(e, t), Ny = (e, t) => t.children.every((n) => se.isText(n)), ky = (e) => {
  H.splitNodes(e, {
    always: !0
  });
}, By = (e, t, n) => {
  H.insertNodes(e, t, n);
}, Oy = (e) => {
  H.splitNodes(e, {
    always: !0
  });
};
function pd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Py(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var zy = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: a,
    marks: i
  } = t;
  if (a) {
    if (i) {
      var o = Py({
        text: n
      }, i);
      H.insertNodes(t, o, {
        at: r.at,
        voids: r.voids
      });
    } else
      H.insertText(t, n, r);
    t.marks = null;
  }
}, Ry = (e, t) => !e.isInline(t), Fy = (e, t, n) => v.isStart(e, t, n) || v.isEnd(e, t, n), Uy = (e, t) => {
  var {
    children: n
  } = t, [r] = n;
  return n.length === 0 || n.length === 1 && se.isText(r) && r.text === "" && !e.isVoid(t);
}, Yy = (e, t, n) => {
  var r = v.end(e, n);
  return be.equals(t, r);
}, Gy = (e) => {
  var t = tg.get(e);
  return t === void 0 ? !0 : t;
}, Hy = (e, t, n) => {
  if (t.offset !== 0)
    return !1;
  var r = v.start(e, n);
  return be.equals(t, r);
}, Qy = (e, t) => {
  var n = v.path(e, t, {
    edge: "end"
  });
  return v.node(e, n);
}, Jy = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = v.path(t, n, r), i = te.leaf(t, a);
  return [i, a];
};
function* Wy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: n = e.selection,
    reverse: r = !1,
    voids: a = !1
  } = t, {
    match: i
  } = t;
  if (i == null && (i = () => !0), !!n) {
    var o = [], f = v.path(e, n);
    for (var [s, u] of te.levels(e, f))
      if (i(s, u) && (o.push([s, u]), !a && fe.isElement(s) && v.isVoid(e, s)))
        break;
    r && o.reverse(), yield* o;
  }
}
var _y = ["text"], Zy = ["text"], $y = function(t) {
  var {
    marks: n,
    selection: r
  } = t;
  if (!r)
    return null;
  if (n)
    return n;
  if (z.isExpanded(r)) {
    var [a] = v.nodes(t, {
      match: se.isText
    });
    if (a) {
      var [i] = a, o = ln(i, _y);
      return o;
    } else
      return {};
  }
  var {
    anchor: f
  } = r, {
    path: s
  } = f, [u] = v.leaf(t, s);
  if (f.offset === 0) {
    var c = v.previous(t, {
      at: s,
      match: se.isText
    }), d = v.above(t, {
      match: (m) => fe.isElement(m) && v.isVoid(t, m) && t.markableVoid(m)
    });
    if (!d) {
      var g = v.above(t, {
        match: (m) => fe.isElement(m) && v.isBlock(t, m)
      });
      if (c && g) {
        var [p, h] = c, [, l] = g;
        j.isAncestor(l, h) && (u = p);
      }
    }
  }
  var w = ln(u, Zy);
  return w;
}, Vy = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: r = "lowest",
    voids: a = !1
  } = n, {
    match: i,
    at: o = t.selection
  } = n;
  if (o) {
    var f = v.after(t, o, {
      voids: a
    });
    if (f) {
      var [, s] = v.last(t, []), u = [f.path, s];
      if (j.isPath(o) && o.length === 0)
        throw new Error("Cannot get the next node from the root node!");
      if (i == null)
        if (j.isPath(o)) {
          var [c] = v.parent(t, o);
          i = (g) => c.children.includes(g);
        } else
          i = () => !0;
      var [d] = v.nodes(t, {
        at: u,
        match: i,
        mode: r,
        voids: a
      });
      return d;
    }
  }
}, Ky = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = v.path(t, n, r), i = te.get(t, a);
  return [i, a];
};
function* qy(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: n = e.selection,
    mode: r = "all",
    universal: a = !1,
    reverse: i = !1,
    voids: o = !1,
    ignoreNonSelectable: f = !1
  } = t, {
    match: s
  } = t;
  if (s || (s = () => !0), !!n) {
    var u, c;
    if (R3.isSpan(n))
      u = n[0], c = n[1];
    else {
      var d = v.path(e, n, {
        edge: "start"
      }), g = v.path(e, n, {
        edge: "end"
      });
      u = i ? g : d, c = i ? d : g;
    }
    var p = te.nodes(e, {
      reverse: i,
      from: u,
      to: c,
      pass: (C) => {
        var [M] = C;
        return fe.isElement(M) ? !!(!o && (v.isVoid(e, M) || v.isElementReadOnly(e, M)) || f && !v.isSelectable(e, M)) : !1;
      }
    }), h = [], l;
    for (var [w, m] of p)
      if (!(f && fe.isElement(w) && !v.isSelectable(e, w))) {
        var y = l && j.compare(m, l[1]) === 0;
        if (!(r === "highest" && y)) {
          if (!s(w, m)) {
            if (a && !y && se.isText(w))
              return;
            continue;
          }
          if (r === "lowest" && y) {
            l = [w, m];
            continue;
          }
          var b = r === "lowest" ? l : [w, m];
          b && (a ? h.push(b) : yield b), l = [w, m];
        }
      }
    r === "lowest" && l && (a ? h.push(l) : yield l), a && (yield* h);
  }
}
var Xy = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    force: r = !1,
    operation: a
  } = n, i = (c) => po.get(c) || [], o = (c) => ho.get(c) || /* @__PURE__ */ new Set(), f = (c) => {
    var d = i(c).pop(), g = d.join(",");
    return o(c).delete(g), d;
  };
  if (v.isNormalizing(t)) {
    if (r) {
      var s = Array.from(te.nodes(t), (c) => {
        var [, d] = c;
        return d;
      }), u = new Set(s.map((c) => c.join(",")));
      po.set(t, s), ho.set(t, u);
    }
    i(t).length !== 0 && v.withoutNormalizing(t, () => {
      for (var c of i(t))
        if (te.has(t, c)) {
          var d = v.node(t, c), [g, p] = d;
          fe.isElement(g) && g.children.length === 0 && t.normalizeNode(d, {
            operation: a
          });
        }
      for (var h = i(t), l = h.length, w = 0; h.length !== 0; ) {
        if (!t.shouldNormalize({
          dirtyPaths: h,
          iteration: w,
          initialDirtyPathsLength: l,
          operation: a
        }))
          return;
        var m = f(t);
        if (te.has(t, m)) {
          var y = v.node(t, m);
          t.normalizeNode(y, {
            operation: a
          });
        }
        w++, h = i(t);
      }
    });
  }
}, eb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, a = v.path(t, n, r), i = j.parent(a), o = v.node(t, i);
  return o;
}, tb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = r, i = {
    current: n,
    affinity: a,
    unref() {
      var {
        current: f
      } = i, s = v.pathRefs(t);
      return s.delete(i), i.current = null, f;
    }
  }, o = v.pathRefs(t);
  return o.add(i), i;
}, nb = (e) => {
  var t = Hl.get(e);
  return t || (t = /* @__PURE__ */ new Set(), Hl.set(e, t)), t;
}, rb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    depth: a,
    edge: i
  } = r;
  if (j.isPath(n)) {
    if (i === "start") {
      var [, o] = te.first(t, n);
      n = o;
    } else if (i === "end") {
      var [, f] = te.last(t, n);
      n = f;
    }
  }
  return z.isRange(n) && (i === "start" ? n = z.start(n) : i === "end" ? n = z.end(n) : n = j.common(n.anchor.path, n.focus.path)), be.isPoint(n) && (n = n.path), a != null && (n = n.slice(0, a)), n;
}, ab = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = r, i = {
    current: n,
    affinity: a,
    unref() {
      var {
        current: f
      } = i, s = v.pointRefs(t);
      return s.delete(i), i.current = null, f;
    }
  }, o = v.pointRefs(t);
  return o.add(i), i;
}, ib = (e) => {
  var t = Ql.get(e);
  return t || (t = /* @__PURE__ */ new Set(), Ql.set(e, t)), t;
}, ob = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    edge: a = "start"
  } = r;
  if (j.isPath(n)) {
    var i;
    if (a === "end") {
      var [, o] = te.last(t, n);
      i = o;
    } else {
      var [, f] = te.first(t, n);
      i = f;
    }
    var s = te.get(t, i);
    if (!se.isText(s))
      throw new Error("Cannot get the ".concat(a, " point in the node at path [").concat(n, "] because it has no ").concat(a, " text node."));
    return {
      path: i,
      offset: a === "end" ? s.text.length : 0
    };
  }
  if (z.isRange(n)) {
    var [u, c] = z.edges(n);
    return a === "start" ? u : c;
  }
  return n;
};
function* fb(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    at: n = e.selection,
    unit: r = "offset",
    reverse: a = !1,
    voids: i = !1,
    ignoreNonSelectable: o = !1
  } = t;
  if (!n)
    return;
  var f = v.range(e, n), [s, u] = z.edges(f), c = a ? u : s, d = !1, g = "", p = 0, h = 0, l = 0;
  for (var [w, m] of v.nodes(e, {
    at: n,
    reverse: a,
    voids: i,
    ignoreNonSelectable: o
  })) {
    if (fe.isElement(w)) {
      if (!i && (e.isVoid(w) || e.isElementReadOnly(w))) {
        yield v.start(e, m);
        continue;
      }
      if (e.isInline(w))
        continue;
      if (v.hasInlines(e, w)) {
        var y = j.isAncestor(m, u.path) ? u : v.end(e, m), b = j.isAncestor(m, s.path) ? s : v.start(e, m);
        g = v.string(e, {
          anchor: b,
          focus: y
        }, {
          voids: i
        }), d = !0;
      }
    }
    if (se.isText(w)) {
      var C = j.equals(m, c.path);
      for (C ? (h = a ? c.offset : w.text.length - c.offset, l = c.offset) : (h = w.text.length, l = a ? h : 0), (C || d || r === "offset") && (yield {
        path: m,
        offset: l
      }, d = !1); ; ) {
        if (p === 0) {
          if (g === "")
            break;
          p = M(g, r, a), g = $s(g, p, a)[1];
        }
        if (l = a ? l - p : l + p, h = h - p, h < 0) {
          p = -h;
          break;
        }
        p = 0, yield {
          path: m,
          offset: l
        };
      }
    }
  }
  function M(S, I, N) {
    return I === "character" ? Zs(S, N) : I === "word" ? Q3(S, N) : I === "line" || I === "block" ? S.length : 1;
  }
}
var ub = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    mode: r = "lowest",
    voids: a = !1
  } = n, {
    match: i,
    at: o = t.selection
  } = n;
  if (o) {
    var f = v.before(t, o, {
      voids: a
    });
    if (f) {
      var [, s] = v.first(t, []), u = [f.path, s];
      if (j.isPath(o) && o.length === 0)
        throw new Error("Cannot get the previous node from the root node!");
      if (i == null)
        if (j.isPath(o)) {
          var [c] = v.parent(t, o);
          i = (g) => c.children.includes(g);
        } else
          i = () => !0;
      var [d] = v.nodes(t, {
        reverse: !0,
        at: u,
        match: i,
        mode: r,
        voids: a
      });
      return d;
    }
  }
}, sb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    affinity: a = "forward"
  } = r, i = {
    current: n,
    affinity: a,
    unref() {
      var {
        current: f
      } = i, s = v.rangeRefs(t);
      return s.delete(i), i.current = null, f;
    }
  }, o = v.rangeRefs(t);
  return o.add(i), i;
}, cb = (e) => {
  var t = Jl.get(e);
  return t || (t = /* @__PURE__ */ new Set(), Jl.set(e, t)), t;
}, lb = (e, t, n) => {
  if (z.isRange(t) && !n)
    return t;
  var r = v.start(e, t), a = v.end(e, n || t);
  return {
    anchor: r,
    focus: a
  };
};
function hd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function db(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? hd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : hd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var gb = (e, t) => {
  var {
    selection: n
  } = e;
  if (n) {
    var r = (c, d) => {
      if (!se.isText(c))
        return !1;
      var [g, p] = v.parent(e, d);
      return !e.isVoid(g) || e.markableVoid(g);
    }, a = z.isExpanded(n), i = !1;
    if (!a) {
      var [o, f] = v.node(e, n);
      if (o && r(o, f)) {
        var [s] = v.parent(e, f);
        i = s && e.markableVoid(s);
      }
    }
    if (a || i)
      H.unsetNodes(e, t, {
        match: r,
        split: !0,
        voids: !0
      });
    else {
      var u = db({}, v.marks(e) || {});
      delete u[t], e.marks = u, Sa.get(e) || e.onChange();
    }
  }
}, pb = (e, t) => {
  tg.set(e, t);
}, hb = (e, t) => v.point(e, t, {
  edge: "start"
}), vb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: a = !1
  } = r, i = v.range(t, n), [o, f] = z.edges(i), s = "";
  for (var [u, c] of v.nodes(t, {
    at: i,
    match: se.isText,
    voids: a
  })) {
    var d = u.text;
    j.equals(c, f.path) && (d = d.slice(0, f.offset)), j.equals(c, o.path) && (d = d.slice(o.offset)), s += d;
  }
  return s;
}, mb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    voids: a = !1
  } = r, [i, o] = z.edges(n);
  if (i.offset !== 0 || o.offset !== 0 || z.isCollapsed(n) || j.hasPrevious(o.path))
    return n;
  var f = v.above(t, {
    at: o,
    match: (h) => fe.isElement(h) && v.isBlock(t, h),
    voids: a
  }), s = f ? f[1] : [], u = v.start(t, i), c = {
    anchor: u,
    focus: o
  }, d = !0;
  for (var [g, p] of v.nodes(t, {
    at: c,
    match: se.isText,
    reverse: !0,
    voids: a
  })) {
    if (d) {
      d = !1;
      continue;
    }
    if (g.text !== "" || j.isBefore(p, s)) {
      o = {
        path: p,
        offset: g.text.length
      };
      break;
    }
  }
  return {
    anchor: i,
    focus: o
  };
}, wb = (e, t) => {
  var n = v.isNormalizing(e);
  v.setNormalizing(e, !1);
  try {
    t();
  } finally {
    v.setNormalizing(e, n);
  }
  v.normalize(e);
}, yb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var r, a, {
      reverse: i = !1,
      unit: o = "character",
      distance: f = 1,
      voids: s = !1
    } = n, {
      at: u = t.selection,
      hanging: c = !1
    } = n;
    if (u) {
      var d = !1;
      if (z.isRange(u) && z.isCollapsed(u) && (d = !0, u = u.anchor), be.isPoint(u)) {
        var g = v.void(t, {
          at: u,
          mode: "highest"
        });
        if (!s && g) {
          var [, p] = g;
          u = p;
        } else {
          var h = {
            unit: o,
            distance: f
          }, l = i ? v.before(t, u, h) || v.start(t, []) : v.after(t, u, h) || v.end(t, []);
          u = {
            anchor: u,
            focus: l
          }, c = !0;
        }
      }
      if (j.isPath(u)) {
        H.removeNodes(t, {
          at: u,
          voids: s
        });
        return;
      }
      if (!z.isCollapsed(u)) {
        if (!c) {
          var [, w] = z.edges(u), m = v.end(t, []);
          be.equals(w, m) || (u = v.unhangRange(t, u, {
            voids: s
          }));
        }
        var [y, b] = z.edges(u), C = v.above(t, {
          match: (he) => fe.isElement(he) && v.isBlock(t, he),
          at: y,
          voids: s
        }), M = v.above(t, {
          match: (he) => fe.isElement(he) && v.isBlock(t, he),
          at: b,
          voids: s
        }), S = C && M && !j.equals(C[1], M[1]), I = j.equals(y.path, b.path), N = s ? null : (r = v.void(t, {
          at: y,
          mode: "highest"
        })) !== null && r !== void 0 ? r : v.elementReadOnly(t, {
          at: y,
          mode: "highest"
        }), O = s ? null : (a = v.void(t, {
          at: b,
          mode: "highest"
        })) !== null && a !== void 0 ? a : v.elementReadOnly(t, {
          at: b,
          mode: "highest"
        });
        if (N) {
          var F = v.before(t, y);
          F && C && j.isAncestor(C[1], F.path) && (y = F);
        }
        if (O) {
          var Q = v.after(t, b);
          Q && M && j.isAncestor(M[1], Q.path) && (b = Q);
        }
        var T = [], x;
        for (var A of v.nodes(t, {
          at: u,
          voids: s
        })) {
          var [B, J] = A;
          x && j.compare(J, x) === 0 || (!s && fe.isElement(B) && (v.isVoid(t, B) || v.isElementReadOnly(t, B)) || !j.isCommon(J, y.path) && !j.isCommon(J, b.path)) && (T.push(A), x = J);
        }
        var $ = Array.from(T, (he) => {
          var [, We] = he;
          return v.pathRef(t, We);
        }), q = v.pointRef(t, y), K = v.pointRef(t, b), P = "";
        if (!I && !N) {
          var R = q.current, [W] = v.leaf(t, R), {
            path: X
          } = R, {
            offset: D
          } = y, U = W.text.slice(D);
          U.length > 0 && (t.apply({
            type: "remove_text",
            path: X,
            offset: D,
            text: U
          }), P = U);
        }
        if ($.reverse().map((he) => he.unref()).filter((he) => he !== null).forEach((he) => H.removeNodes(t, {
          at: he,
          voids: s
        })), !O) {
          var k = K.current, [Y] = v.leaf(t, k), {
            path: V
          } = k, Z = I ? y.offset : 0, re = Y.text.slice(Z, b.offset);
          re.length > 0 && (t.apply({
            type: "remove_text",
            path: V,
            offset: Z,
            text: re
          }), P = re);
        }
        !I && S && K.current && q.current && H.mergeNodes(t, {
          at: K.current,
          hanging: !0,
          voids: s
        }), d && i && o === "character" && P.length > 1 && P.match(/[\u0E00-\u0E7F]+/) && H.insertText(t, P.slice(0, P.length - f));
        var ce = q.unref(), _ = K.unref(), Le = i ? ce || _ : _ || ce;
        n.at == null && Le && H.select(t, Le);
      }
    }
  });
}, bb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  v.withoutNormalizing(t, () => {
    var {
      hanging: a = !1,
      voids: i = !1
    } = r, {
      at: o = _s(t)
    } = r;
    if (n.length) {
      if (z.isRange(o))
        if (a || (o = v.unhangRange(t, o, {
          voids: i
        })), z.isCollapsed(o))
          o = o.anchor;
        else {
          var [, f] = z.edges(o);
          if (!i && v.void(t, {
            at: f
          }))
            return;
          var s = v.pointRef(t, f);
          H.delete(t, {
            at: o
          }), o = s.unref();
        }
      else
        j.isPath(o) && (o = v.start(t, o));
      if (!(!i && v.void(t, {
        at: o
      }))) {
        var u = v.above(t, {
          at: o,
          match: (D) => fe.isElement(D) && v.isInline(t, D),
          mode: "highest",
          voids: i
        });
        if (u) {
          var [, c] = u;
          if (v.isEnd(t, o, c)) {
            var d = v.after(t, c);
            o = d;
          } else if (v.isStart(t, o, c)) {
            var g = v.before(t, c);
            o = g;
          }
        }
        var p = v.above(t, {
          match: (D) => fe.isElement(D) && v.isBlock(t, D),
          at: o,
          voids: i
        }), [, h] = p, l = v.isStart(t, o, h), w = v.isEnd(t, o, h), m = l && w, y = !l || l && w, b = !w, [, C] = te.first({
          children: n
        }, []), [, M] = te.last({
          children: n
        }, []), S = [], I = (D) => {
          var [U, k] = D, Y = k.length === 0;
          return Y ? !1 : m ? !0 : !(y && j.isAncestor(k, C) && fe.isElement(U) && !t.isVoid(U) && !t.isInline(U) || b && j.isAncestor(k, M) && fe.isElement(U) && !t.isVoid(U) && !t.isInline(U));
        };
        for (var N of te.nodes({
          children: n
        }, {
          pass: I
        }))
          I(N) && S.push(N);
        var O = [], F = [], Q = [], T = !0, x = !1;
        for (var [A] of S)
          fe.isElement(A) && !t.isInline(A) ? (T = !1, x = !0, F.push(A)) : T ? O.push(A) : Q.push(A);
        var [B] = v.nodes(t, {
          at: o,
          match: (D) => se.isText(D) || v.isInline(t, D),
          mode: "highest",
          voids: i
        }), [, J] = B, $ = v.isStart(t, o, J), q = v.isEnd(t, o, J), K = v.pathRef(t, w && !Q.length ? j.next(h) : h), P = v.pathRef(t, q ? j.next(J) : J);
        H.splitNodes(t, {
          at: o,
          match: (D) => x ? fe.isElement(D) && v.isBlock(t, D) : se.isText(D) || v.isInline(t, D),
          mode: x ? "lowest" : "highest",
          always: x && (!l || O.length > 0) && (!w || Q.length > 0),
          voids: i
        });
        var R = v.pathRef(t, !$ || $ && q ? j.next(J) : J);
        if (H.insertNodes(t, O, {
          at: R.current,
          match: (D) => se.isText(D) || v.isInline(t, D),
          mode: "highest",
          voids: i
        }), m && !O.length && F.length && !Q.length && H.delete(t, {
          at: h,
          voids: i
        }), H.insertNodes(t, F, {
          at: K.current,
          match: (D) => fe.isElement(D) && v.isBlock(t, D),
          mode: "lowest",
          voids: i
        }), H.insertNodes(t, Q, {
          at: P.current,
          match: (D) => se.isText(D) || v.isInline(t, D),
          mode: "highest",
          voids: i
        }), !r.at) {
          var W;
          if (Q.length > 0 && P.current ? W = j.previous(P.current) : F.length > 0 && K.current ? W = j.previous(K.current) : R.current && (W = j.previous(R.current)), W) {
            var X = v.end(t, W);
            H.select(t, X);
          }
        }
        R.unref(), K.unref(), P.unref();
      }
    }
  });
}, Cb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    edge: r = "anchor"
  } = n, {
    selection: a
  } = t;
  if (a) {
    if (r === "anchor")
      H.select(t, a.anchor);
    else if (r === "focus")
      H.select(t, a.focus);
    else if (r === "start") {
      var [i] = z.edges(a);
      H.select(t, i);
    } else if (r === "end") {
      var [, o] = z.edges(a);
      H.select(t, o);
    }
  } else
    return;
}, Mb = (e) => {
  var {
    selection: t
  } = e;
  t && e.apply({
    type: "set_selection",
    properties: t,
    newProperties: null
  });
}, Db = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
    selection: r
  } = t, {
    distance: a = 1,
    unit: i = "character",
    reverse: o = !1
  } = n, {
    edge: f = null
  } = n;
  if (r) {
    f === "start" && (f = z.isBackward(r) ? "focus" : "anchor"), f === "end" && (f = z.isBackward(r) ? "anchor" : "focus");
    var {
      anchor: s,
      focus: u
    } = r, c = {
      distance: a,
      unit: i,
      ignoreNonSelectable: !0
    }, d = {};
    if (f == null || f === "anchor") {
      var g = o ? v.before(t, s, c) : v.after(t, s, c);
      g && (d.anchor = g);
    }
    if (f == null || f === "focus") {
      var p = o ? v.before(t, u, c) : v.after(t, u, c);
      p && (d.focus = p);
    }
    H.setSelection(t, d);
  }
}, Lb = (e, t) => {
  var {
    selection: n
  } = e;
  if (t = v.range(e, t), n) {
    H.setSelection(e, t);
    return;
  }
  if (!z.isRange(t))
    throw new Error("When setting the selection and the current selection is `null` you must provide at least an `anchor` and `focus`, but you passed: ".concat(qe.stringify(t)));
  e.apply({
    type: "set_selection",
    properties: n,
    newProperties: t
  });
};
function vd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function md(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? vd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Ab = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
    selection: a
  } = t, {
    edge: i = "both"
  } = r;
  if (a) {
    i === "start" && (i = z.isBackward(a) ? "focus" : "anchor"), i === "end" && (i = z.isBackward(a) ? "anchor" : "focus");
    var {
      anchor: o,
      focus: f
    } = a, s = i === "anchor" ? o : f;
    H.setSelection(t, {
      [i === "anchor" ? "anchor" : "focus"]: md(md({}, s), n)
    });
  }
}, Eb = (e, t) => {
  var {
    selection: n
  } = e, r = {}, a = {};
  if (n) {
    for (var i in t)
      (i === "anchor" && t.anchor != null && !be.equals(t.anchor, n.anchor) || i === "focus" && t.focus != null && !be.equals(t.focus, n.focus) || i !== "anchor" && i !== "focus" && t[i] !== n[i]) && (r[i] = n[i], a[i] = t[i]);
    Object.keys(r).length > 0 && e.apply({
      type: "set_selection",
      properties: r,
      newProperties: a
    });
  }
}, jb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  v.withoutNormalizing(t, () => {
    var {
      hanging: a = !1,
      voids: i = !1,
      mode: o = "lowest"
    } = r, {
      at: f,
      match: s,
      select: u
    } = r;
    if (te.isNode(n) && (n = [n]), n.length !== 0) {
      var [c] = n;
      if (f || (f = _s(t), u = !0), u == null && (u = !1), z.isRange(f))
        if (a || (f = v.unhangRange(t, f, {
          voids: i
        })), z.isCollapsed(f))
          f = f.anchor;
        else {
          var [, d] = z.edges(f), g = v.pointRef(t, d);
          H.delete(t, {
            at: f
          }), f = g.unref();
        }
      if (be.isPoint(f)) {
        s == null && (se.isText(c) ? s = (I) => se.isText(I) : t.isInline(c) ? s = (I) => se.isText(I) || v.isInline(t, I) : s = (I) => fe.isElement(I) && v.isBlock(t, I));
        var [p] = v.nodes(t, {
          at: f.path,
          match: s,
          mode: o,
          voids: i
        });
        if (p) {
          var [, h] = p, l = v.pathRef(t, h), w = v.isEnd(t, f, h);
          H.splitNodes(t, {
            at: f,
            match: s,
            mode: o,
            voids: i
          });
          var m = l.unref();
          f = w ? j.next(m) : m;
        } else
          return;
      }
      var y = j.parent(f), b = f[f.length - 1];
      if (!(!i && v.void(t, {
        at: y
      }))) {
        for (var C of n) {
          var M = y.concat(b);
          b++, t.apply({
            type: "insert_node",
            path: M,
            node: C
          }), f = j.next(f);
        }
        if (f = j.previous(f), u) {
          var S = v.end(t, f);
          S && H.select(t, S);
        }
      }
    }
  });
}, Ib = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var {
      at: r = t.selection,
      mode: a = "lowest",
      voids: i = !1
    } = n, {
      match: o
    } = n;
    if (o == null && (o = j.isPath(r) ? fa(t, r) : (C) => fe.isElement(C) && v.isBlock(t, C)), !!r) {
      var f = v.nodes(t, {
        at: r,
        match: o,
        mode: a,
        voids: i
      }), s = Array.from(f, (C) => {
        var [, M] = C;
        return v.pathRef(t, M);
      });
      for (var u of s) {
        var c = u.unref();
        if (c.length < 2)
          throw new Error("Cannot lift node at a path [".concat(c, "] because it has a depth of less than `2`."));
        var d = v.node(t, j.parent(c)), [g, p] = d, h = c[c.length - 1], {
          length: l
        } = g.children;
        if (l === 1) {
          var w = j.next(p);
          H.moveNodes(t, {
            at: c,
            to: w,
            voids: i
          }), H.removeNodes(t, {
            at: p,
            voids: i
          });
        } else if (h === 0)
          H.moveNodes(t, {
            at: c,
            to: p,
            voids: i
          });
        else if (h === l - 1) {
          var m = j.next(p);
          H.moveNodes(t, {
            at: c,
            to: m,
            voids: i
          });
        } else {
          var y = j.next(c), b = j.next(p);
          H.splitNodes(t, {
            at: y,
            voids: i
          }), H.moveNodes(t, {
            at: c,
            to: b,
            voids: i
          });
        }
      }
    }
  });
}, Sb = ["text"], xb = ["children"], rg = (e, t) => {
  if (fe.isElement(t)) {
    var n = t;
    return v.isVoid(e, t) ? !0 : n.children.length === 1 ? rg(e, n.children[0]) : !1;
  } else
    return !v.isEditor(t);
}, Tb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var {
      match: r,
      at: a = t.selection
    } = n, {
      hanging: i = !1,
      voids: o = !1,
      mode: f = "lowest"
    } = n;
    if (a) {
      if (r == null)
        if (j.isPath(a)) {
          var [s] = v.parent(t, a);
          r = (F) => s.children.includes(F);
        } else
          r = (F) => fe.isElement(F) && v.isBlock(t, F);
      if (!i && z.isRange(a) && (a = v.unhangRange(t, a, {
        voids: o
      })), z.isRange(a))
        if (z.isCollapsed(a))
          a = a.anchor;
        else {
          var [, u] = z.edges(a), c = v.pointRef(t, u);
          H.delete(t, {
            at: a
          }), a = c.unref(), n.at == null && H.select(t, a);
        }
      var [d] = v.nodes(t, {
        at: a,
        match: r,
        voids: o,
        mode: f
      }), g = v.previous(t, {
        at: a,
        match: r,
        voids: o,
        mode: f
      });
      if (!(!d || !g)) {
        var [p, h] = d, [l, w] = g;
        if (!(h.length === 0 || w.length === 0)) {
          var m = j.next(w), y = j.common(h, w), b = j.isSibling(h, w), C = Array.from(v.levels(t, {
            at: h
          }), (F) => {
            var [Q] = F;
            return Q;
          }).slice(y.length).slice(0, -1), M = v.above(t, {
            at: h,
            mode: "highest",
            match: (F) => C.includes(F) && rg(t, F)
          }), S = M && v.pathRef(t, M[1]), I, N;
          if (se.isText(p) && se.isText(l)) {
            var O = ln(p, Sb);
            N = l.text.length, I = O;
          } else if (fe.isElement(p) && fe.isElement(l)) {
            var O = ln(p, xb);
            N = l.children.length, I = O;
          } else
            throw new Error("Cannot merge the node at path [".concat(h, "] with the previous sibling because it is not the same kind: ").concat(qe.stringify(p), " ").concat(qe.stringify(l)));
          b || H.moveNodes(t, {
            at: h,
            to: m,
            voids: o
          }), S && H.removeNodes(t, {
            at: S.current,
            voids: o
          }), fe.isElement(l) && v.isEmpty(t, l) || se.isText(l) && l.text === "" && w[w.length - 1] !== 0 ? H.removeNodes(t, {
            at: w,
            voids: o
          }) : t.apply({
            type: "merge_node",
            path: m,
            position: N,
            properties: I
          }), S && S.unref();
        }
      }
    }
  });
}, Nb = (e, t) => {
  v.withoutNormalizing(e, () => {
    var {
      to: n,
      at: r = e.selection,
      mode: a = "lowest",
      voids: i = !1
    } = t, {
      match: o
    } = t;
    if (r) {
      o == null && (o = j.isPath(r) ? fa(e, r) : (p) => fe.isElement(p) && v.isBlock(e, p));
      var f = v.pathRef(e, n), s = v.nodes(e, {
        at: r,
        match: o,
        mode: a,
        voids: i
      }), u = Array.from(s, (p) => {
        var [, h] = p;
        return v.pathRef(e, h);
      });
      for (var c of u) {
        var d = c.unref(), g = f.current;
        d.length !== 0 && e.apply({
          type: "move_node",
          path: d,
          newPath: g
        }), f.current && j.isSibling(g, d) && j.isAfter(g, d) && (f.current = j.next(f.current));
      }
      f.unref();
    }
  });
}, kb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var {
      hanging: r = !1,
      voids: a = !1,
      mode: i = "lowest"
    } = n, {
      at: o = t.selection,
      match: f
    } = n;
    if (o) {
      f == null && (f = j.isPath(o) ? fa(t, o) : (p) => fe.isElement(p) && v.isBlock(t, p)), !r && z.isRange(o) && (o = v.unhangRange(t, o, {
        voids: a
      }));
      var s = v.nodes(t, {
        at: o,
        match: f,
        mode: i,
        voids: a
      }), u = Array.from(s, (p) => {
        var [, h] = p;
        return v.pathRef(t, h);
      });
      for (var c of u) {
        var d = c.unref();
        if (d) {
          var [g] = v.node(t, d);
          t.apply({
            type: "remove_node",
            path: d,
            node: g
          });
        }
      }
    }
  });
}, Bb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  v.withoutNormalizing(t, () => {
    var {
      match: a,
      at: i = t.selection,
      compare: o,
      merge: f
    } = r, {
      hanging: s = !1,
      mode: u = "lowest",
      split: c = !1,
      voids: d = !1
    } = r;
    if (i) {
      if (a == null && (a = j.isPath(i) ? fa(t, i) : (N) => fe.isElement(N) && v.isBlock(t, N)), !s && z.isRange(i) && (i = v.unhangRange(t, i, {
        voids: d
      })), c && z.isRange(i)) {
        if (z.isCollapsed(i) && v.leaf(t, i.anchor)[0].text.length > 0)
          return;
        var g = v.rangeRef(t, i, {
          affinity: "inward"
        }), [p, h] = z.edges(i), l = u === "lowest" ? "lowest" : "highest", w = v.isEnd(t, h, h.path);
        H.splitNodes(t, {
          at: h,
          match: a,
          mode: l,
          voids: d,
          always: !w
        });
        var m = v.isStart(t, p, p.path);
        H.splitNodes(t, {
          at: p,
          match: a,
          mode: l,
          voids: d,
          always: !m
        }), i = g.unref(), r.at == null && H.select(t, i);
      }
      o || (o = (N, O) => N !== O);
      for (var [y, b] of v.nodes(t, {
        at: i,
        match: a,
        mode: u,
        voids: d
      })) {
        var C = {}, M = {};
        if (b.length !== 0) {
          var S = !1;
          for (var I in n)
            I === "children" || I === "text" || o(n[I], y[I]) && (S = !0, y.hasOwnProperty(I) && (C[I] = y[I]), f ? n[I] != null && (M[I] = f(y[I], n[I])) : n[I] != null && (M[I] = n[I]));
          S && t.apply({
            type: "set_node",
            path: b,
            properties: C,
            newProperties: M
          });
        }
      }
    }
  });
}, Ob = (e, t) => {
  if (z.isCollapsed(t))
    return t.anchor;
  var [, n] = z.edges(t), r = v.pointRef(e, n);
  return H.delete(e, {
    at: t
  }), r.unref();
}, Pb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var {
      mode: r = "lowest",
      voids: a = !1
    } = n, {
      match: i,
      at: o = t.selection,
      height: f = 0,
      always: s = !1
    } = n;
    if (i == null && (i = (K) => fe.isElement(K) && v.isBlock(t, K)), z.isRange(o) && (o = Ob(t, o)), j.isPath(o)) {
      var u = o, c = v.point(t, u), [d] = v.parent(t, u);
      i = (K) => K === d, f = c.path.length - u.length + 1, o = c, s = !0;
    }
    if (o) {
      var g = v.pointRef(t, o, {
        affinity: "backward"
      }), p;
      try {
        var [h] = v.nodes(t, {
          at: o,
          match: i,
          mode: r,
          voids: a
        });
        if (!h)
          return;
        var l = v.void(t, {
          at: o,
          mode: "highest"
        }), w = 0;
        if (!a && l) {
          var [m, y] = l;
          if (fe.isElement(m) && t.isInline(m)) {
            var b = v.after(t, y);
            if (!b) {
              var C = {
                text: ""
              }, M = j.next(y);
              H.insertNodes(t, C, {
                at: M,
                voids: a
              }), b = v.point(t, M);
            }
            o = b, s = !0;
          }
          var S = o.path.length - y.length;
          f = S + 1, s = !0;
        }
        p = v.pointRef(t, o);
        var I = o.path.length - f, [, N] = h, O = o.path.slice(0, I), F = f === 0 ? o.offset : o.path[I] + w;
        for (var [Q, T] of v.levels(t, {
          at: O,
          reverse: !0,
          voids: a
        })) {
          var x = !1;
          if (T.length < N.length || T.length === 0 || !a && fe.isElement(Q) && v.isVoid(t, Q))
            break;
          var A = g.current, B = v.isEnd(t, A, T);
          if (s || !g || !v.isEdge(t, A, T)) {
            x = !0;
            var J = te.extractProps(Q);
            t.apply({
              type: "split_node",
              path: T,
              position: F,
              properties: J
            });
          }
          F = T[T.length - 1] + (x || B ? 1 : 0);
        }
        if (n.at == null) {
          var $ = p.current || v.end(t, []);
          H.select(t, $);
        }
      } finally {
        var q;
        g.unref(), (q = p) === null || q === void 0 || q.unref();
      }
    }
  });
}, zb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  Array.isArray(n) || (n = [n]);
  var a = {};
  for (var i of n)
    a[i] = null;
  H.setNodes(t, a, r);
}, Rb = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  v.withoutNormalizing(t, () => {
    var {
      mode: r = "lowest",
      split: a = !1,
      voids: i = !1
    } = n, {
      at: o = t.selection,
      match: f
    } = n;
    if (o) {
      f == null && (f = j.isPath(o) ? fa(t, o) : (p) => fe.isElement(p) && v.isBlock(t, p)), j.isPath(o) && (o = v.range(t, o));
      var s = z.isRange(o) ? v.rangeRef(t, o) : null, u = v.nodes(t, {
        at: o,
        match: f,
        mode: r,
        voids: i
      }), c = Array.from(
        u,
        (p) => {
          var [, h] = p;
          return v.pathRef(t, h);
        }
        // unwrapNode will call liftNode which does not support splitting the node when nested.
        // If we do not reverse the order and call it from top to the bottom, it will remove all blocks
        // that wrap target node. So we reverse the order.
      ).reverse(), d = function(h) {
        var l = h.unref(), [w] = v.node(t, l), m = v.range(t, l);
        a && s && (m = z.intersection(s.current, m)), H.liftNodes(t, {
          at: m,
          match: (y) => fe.isAncestor(w) && w.children.includes(y),
          voids: i
        });
      };
      for (var g of c)
        d(g);
      s && s.unref();
    }
  });
};
function wd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function yd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? wd(Object(n), !0).forEach(function(r) {
      dt(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var Fb = function(t, n) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  v.withoutNormalizing(t, () => {
    var {
      mode: a = "lowest",
      split: i = !1,
      voids: o = !1
    } = r, {
      match: f,
      at: s = t.selection
    } = r;
    if (s) {
      if (f == null && (j.isPath(s) ? f = fa(t, s) : t.isInline(n) ? f = (m) => fe.isElement(m) && v.isInline(t, m) || se.isText(m) : f = (m) => fe.isElement(m) && v.isBlock(t, m)), i && z.isRange(s)) {
        var [u, c] = z.edges(s), d = v.rangeRef(t, s, {
          affinity: "inward"
        });
        H.splitNodes(t, {
          at: c,
          match: f,
          voids: o
        }), H.splitNodes(t, {
          at: u,
          match: f,
          voids: o
        }), s = d.unref(), r.at == null && H.select(t, s);
      }
      var g = Array.from(v.nodes(t, {
        at: s,
        match: t.isInline(n) ? (m) => fe.isElement(m) && v.isBlock(t, m) : (m) => v.isEditor(m),
        mode: "lowest",
        voids: o
      }));
      for (var [, p] of g) {
        var h = z.isRange(s) ? z.intersection(s, v.range(t, p)) : s;
        if (h) {
          var l = Array.from(v.nodes(t, {
            at: h,
            match: f,
            mode: a,
            voids: o
          }));
          if (l.length > 0) {
            var w = function() {
              var [m] = l, y = l[l.length - 1], [, b] = m, [, C] = y;
              if (b.length === 0 && C.length === 0)
                return "continue";
              var M = j.equals(b, C) ? j.parent(b) : j.common(b, C), S = v.range(t, b, C), I = v.node(t, M), [N] = I, O = M.length + 1, F = j.next(C.slice(0, O)), Q = yd(yd({}, n), {}, {
                children: []
              });
              H.insertNodes(t, Q, {
                at: F,
                voids: o
              }), H.moveNodes(t, {
                at: S,
                match: (T) => fe.isAncestor(N) && N.children.includes(T),
                to: F.concat(0),
                voids: o
              });
            }();
            if (w === "continue")
              continue;
          }
        }
      }
    }
  });
}, Ub = () => {
  var e = {
    children: [],
    operations: [],
    selection: null,
    marks: null,
    isElementReadOnly: () => !1,
    isInline: () => !1,
    isSelectable: () => !0,
    isVoid: () => !1,
    markableVoid: () => !1,
    onChange: () => {
    },
    // Core
    apply: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ly(e, ...r);
    },
    // Editor
    addMark: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return my(e, ...r);
    },
    deleteBackward: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return by(e, ...r);
    },
    deleteForward: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Cy(e, ...r);
    },
    deleteFragment: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return My(e, ...r);
    },
    getFragment: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return gy(e, ...r);
    },
    insertBreak: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ky(e, ...r);
    },
    insertSoftBreak: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Oy(e, ...r);
    },
    insertFragment: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return bb(e, ...r);
    },
    insertNode: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return By(e, ...r);
    },
    insertText: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return zy(e, ...r);
    },
    normalizeNode: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return py(e, ...r);
    },
    removeMark: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return gb(e, ...r);
    },
    getDirtyPaths: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return dy(e, ...r);
    },
    shouldNormalize: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return hy(e, ...r);
    },
    // Editor interface
    above: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return vy(e, ...r);
    },
    after: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return wy(e, ...r);
    },
    before: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return yy(e, ...r);
    },
    collapse: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Cb(e, ...r);
    },
    delete: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return yb(e, ...r);
    },
    deselect: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Mb(e, ...r);
    },
    edges: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Dy(e, ...r);
    },
    elementReadOnly: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ly(e, ...r);
    },
    end: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ay(e, ...r);
    },
    first: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ey(e, ...r);
    },
    fragment: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return jy(e, ...r);
    },
    getMarks: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return $y(e, ...r);
    },
    hasBlocks: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Sy(e, ...r);
    },
    hasInlines: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return xy(e, ...r);
    },
    hasPath: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ty(e, ...r);
    },
    hasTexts: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ny(e, ...r);
    },
    insertNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return jb(e, ...r);
    },
    isBlock: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ry(e, ...r);
    },
    isEdge: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Fy(e, ...r);
    },
    isEmpty: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Uy(e, ...r);
    },
    isEnd: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Yy(e, ...r);
    },
    isNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Gy(e, ...r);
    },
    isStart: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Hy(e, ...r);
    },
    last: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Qy(e, ...r);
    },
    leaf: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Jy(e, ...r);
    },
    levels: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Wy(e, ...r);
    },
    liftNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ib(e, ...r);
    },
    mergeNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Tb(e, ...r);
    },
    move: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Db(e, ...r);
    },
    moveNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Nb(e, ...r);
    },
    next: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Vy(e, ...r);
    },
    node: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ky(e, ...r);
    },
    nodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return qy(e, ...r);
    },
    normalize: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Xy(e, ...r);
    },
    parent: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return eb(e, ...r);
    },
    path: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return rb(e, ...r);
    },
    pathRef: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return tb(e, ...r);
    },
    pathRefs: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return nb(e, ...r);
    },
    point: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ob(e, ...r);
    },
    pointRef: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ab(e, ...r);
    },
    pointRefs: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ib(e, ...r);
    },
    positions: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return fb(e, ...r);
    },
    previous: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return ub(e, ...r);
    },
    range: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return lb(e, ...r);
    },
    rangeRef: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return sb(e, ...r);
    },
    rangeRefs: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return cb(e, ...r);
    },
    removeNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return kb(e, ...r);
    },
    select: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Lb(e, ...r);
    },
    setNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Bb(e, ...r);
    },
    setNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return pb(e, ...r);
    },
    setPoint: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Ab(e, ...r);
    },
    setSelection: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Eb(e, ...r);
    },
    splitNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Pb(e, ...r);
    },
    start: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return hb(e, ...r);
    },
    string: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return vb(e, ...r);
    },
    unhangRange: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return mb(e, ...r);
    },
    unsetNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return zb(e, ...r);
    },
    unwrapNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Rb(e, ...r);
    },
    void: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Iy(e, ...r);
    },
    withoutNormalizing: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return wb(e, ...r);
    },
    wrapNodes: function() {
      for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
        r[a] = arguments[a];
      return Fb(e, ...r);
    }
  };
  return e;
}, Kn = [], Yb = function() {
  return Kn.some(function(e) {
    return e.activeTargets.length > 0;
  });
}, Gb = function() {
  return Kn.some(function(e) {
    return e.skippedTargets.length > 0;
  });
}, bd = "ResizeObserver loop completed with undelivered notifications.", Hb = function() {
  var e;
  typeof ErrorEvent == "function" ? e = new ErrorEvent("error", {
    message: bd
  }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = bd), window.dispatchEvent(e);
}, Ha;
(function(e) {
  e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Ha || (Ha = {}));
var qn = function(e) {
  return Object.freeze(e);
}, Qb = function() {
  function e(t, n) {
    this.inlineSize = t, this.blockSize = n, qn(this);
  }
  return e;
}(), ag = function() {
  function e(t, n, r, a) {
    return this.x = t, this.y = n, this.width = r, this.height = a, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, qn(this);
  }
  return e.prototype.toJSON = function() {
    var t = this, n = t.x, r = t.y, a = t.top, i = t.right, o = t.bottom, f = t.left, s = t.width, u = t.height;
    return { x: n, y: r, top: a, right: i, bottom: o, left: f, width: s, height: u };
  }, e.fromRect = function(t) {
    return new e(t.x, t.y, t.width, t.height);
  }, e;
}(), Vs = function(e) {
  return e instanceof SVGElement && "getBBox" in e;
}, ig = function(e) {
  if (Vs(e)) {
    var t = e.getBBox(), n = t.width, r = t.height;
    return !n && !r;
  }
  var a = e, i = a.offsetWidth, o = a.offsetHeight;
  return !(i || o || e.getClientRects().length);
}, Cd = function(e) {
  var t;
  if (e instanceof Element)
    return !0;
  var n = (t = e == null ? void 0 : e.ownerDocument) === null || t === void 0 ? void 0 : t.defaultView;
  return !!(n && e instanceof n.Element);
}, Jb = function(e) {
  switch (e.tagName) {
    case "INPUT":
      if (e.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, xa = typeof window < "u" ? window : {}, ji = /* @__PURE__ */ new WeakMap(), Md = /auto|scroll/, Wb = /^tb|vertical/, _b = /msie|trident/i.test(xa.navigator && xa.navigator.userAgent), Zt = function(e) {
  return parseFloat(e || "0");
}, Pr = function(e, t, n) {
  return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new Qb((n ? t : e) || 0, (n ? e : t) || 0);
}, Dd = qn({
  devicePixelContentBoxSize: Pr(),
  borderBoxSize: Pr(),
  contentBoxSize: Pr(),
  contentRect: new ag(0, 0, 0, 0)
}), og = function(e, t) {
  if (t === void 0 && (t = !1), ji.has(e) && !t)
    return ji.get(e);
  if (ig(e))
    return ji.set(e, Dd), Dd;
  var n = getComputedStyle(e), r = Vs(e) && e.ownerSVGElement && e.getBBox(), a = !_b && n.boxSizing === "border-box", i = Wb.test(n.writingMode || ""), o = !r && Md.test(n.overflowY || ""), f = !r && Md.test(n.overflowX || ""), s = r ? 0 : Zt(n.paddingTop), u = r ? 0 : Zt(n.paddingRight), c = r ? 0 : Zt(n.paddingBottom), d = r ? 0 : Zt(n.paddingLeft), g = r ? 0 : Zt(n.borderTopWidth), p = r ? 0 : Zt(n.borderRightWidth), h = r ? 0 : Zt(n.borderBottomWidth), l = r ? 0 : Zt(n.borderLeftWidth), w = d + u, m = s + c, y = l + p, b = g + h, C = f ? e.offsetHeight - b - e.clientHeight : 0, M = o ? e.offsetWidth - y - e.clientWidth : 0, S = a ? w + y : 0, I = a ? m + b : 0, N = r ? r.width : Zt(n.width) - S - M, O = r ? r.height : Zt(n.height) - I - C, F = N + w + M + y, Q = O + m + C + b, T = qn({
    devicePixelContentBoxSize: Pr(Math.round(N * devicePixelRatio), Math.round(O * devicePixelRatio), i),
    borderBoxSize: Pr(F, Q, i),
    contentBoxSize: Pr(N, O, i),
    contentRect: new ag(d, s, N, O)
  });
  return ji.set(e, T), T;
}, fg = function(e, t, n) {
  var r = og(e, n), a = r.borderBoxSize, i = r.contentBoxSize, o = r.devicePixelContentBoxSize;
  switch (t) {
    case Ha.DEVICE_PIXEL_CONTENT_BOX:
      return o;
    case Ha.BORDER_BOX:
      return a;
    default:
      return i;
  }
}, Zb = function() {
  function e(t) {
    var n = og(t);
    this.target = t, this.contentRect = n.contentRect, this.borderBoxSize = qn([n.borderBoxSize]), this.contentBoxSize = qn([n.contentBoxSize]), this.devicePixelContentBoxSize = qn([n.devicePixelContentBoxSize]);
  }
  return e;
}(), ug = function(e) {
  if (ig(e))
    return 1 / 0;
  for (var t = 0, n = e.parentNode; n; )
    t += 1, n = n.parentNode;
  return t;
}, $b = function() {
  var e = 1 / 0, t = [];
  Kn.forEach(function(o) {
    if (o.activeTargets.length !== 0) {
      var f = [];
      o.activeTargets.forEach(function(u) {
        var c = new Zb(u.target), d = ug(u.target);
        f.push(c), u.lastReportedSize = fg(u.target, u.observedBox), d < e && (e = d);
      }), t.push(function() {
        o.callback.call(o.observer, f, o.observer);
      }), o.activeTargets.splice(0, o.activeTargets.length);
    }
  });
  for (var n = 0, r = t; n < r.length; n++) {
    var a = r[n];
    a();
  }
  return e;
}, Ld = function(e) {
  Kn.forEach(function(n) {
    n.activeTargets.splice(0, n.activeTargets.length), n.skippedTargets.splice(0, n.skippedTargets.length), n.observationTargets.forEach(function(a) {
      a.isActive() && (ug(a.target) > e ? n.activeTargets.push(a) : n.skippedTargets.push(a));
    });
  });
}, Vb = function() {
  var e = 0;
  for (Ld(e); Yb(); )
    e = $b(), Ld(e);
  return Gb() && Hb(), e > 0;
}, Nf, sg = [], Kb = function() {
  return sg.splice(0).forEach(function(e) {
    return e();
  });
}, qb = function(e) {
  if (!Nf) {
    var t = 0, n = document.createTextNode(""), r = { characterData: !0 };
    new MutationObserver(function() {
      return Kb();
    }).observe(n, r), Nf = function() {
      n.textContent = "".concat(t ? t-- : t++);
    };
  }
  sg.push(e), Nf();
}, Xb = function(e) {
  qb(function() {
    requestAnimationFrame(e);
  });
}, Zi = 0, eC = function() {
  return !!Zi;
}, tC = 250, nC = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Ad = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Ed = function(e) {
  return e === void 0 && (e = 0), Date.now() + e;
}, kf = !1, rC = function() {
  function e() {
    var t = this;
    this.stopped = !0, this.listener = function() {
      return t.schedule();
    };
  }
  return e.prototype.run = function(t) {
    var n = this;
    if (t === void 0 && (t = tC), !kf) {
      kf = !0;
      var r = Ed(t);
      Xb(function() {
        var a = !1;
        try {
          a = Vb();
        } finally {
          if (kf = !1, t = r - Ed(), !eC())
            return;
          a ? n.run(1e3) : t > 0 ? n.run(t) : n.start();
        }
      });
    }
  }, e.prototype.schedule = function() {
    this.stop(), this.run();
  }, e.prototype.observe = function() {
    var t = this, n = function() {
      return t.observer && t.observer.observe(document.body, nC);
    };
    document.body ? n() : xa.addEventListener("DOMContentLoaded", n);
  }, e.prototype.start = function() {
    var t = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Ad.forEach(function(n) {
      return xa.addEventListener(n, t.listener, !0);
    }));
  }, e.prototype.stop = function() {
    var t = this;
    this.stopped || (this.observer && this.observer.disconnect(), Ad.forEach(function(n) {
      return xa.removeEventListener(n, t.listener, !0);
    }), this.stopped = !0);
  }, e;
}(), Ou = new rC(), jd = function(e) {
  !Zi && e > 0 && Ou.start(), Zi += e, !Zi && Ou.stop();
}, aC = function(e) {
  return !Vs(e) && !Jb(e) && getComputedStyle(e).display === "inline";
}, iC = function() {
  function e(t, n) {
    this.target = t, this.observedBox = n || Ha.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return e.prototype.isActive = function() {
    var t = fg(this.target, this.observedBox, !0);
    return aC(this.target) && (this.lastReportedSize = t), this.lastReportedSize.inlineSize !== t.inlineSize || this.lastReportedSize.blockSize !== t.blockSize;
  }, e;
}(), oC = function() {
  function e(t, n) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = t, this.callback = n;
  }
  return e;
}(), Ii = /* @__PURE__ */ new WeakMap(), Id = function(e, t) {
  for (var n = 0; n < e.length; n += 1)
    if (e[n].target === t)
      return n;
  return -1;
}, Si = function() {
  function e() {
  }
  return e.connect = function(t, n) {
    var r = new oC(t, n);
    Ii.set(t, r);
  }, e.observe = function(t, n, r) {
    var a = Ii.get(t), i = a.observationTargets.length === 0;
    Id(a.observationTargets, n) < 0 && (i && Kn.push(a), a.observationTargets.push(new iC(n, r && r.box)), jd(1), Ou.schedule());
  }, e.unobserve = function(t, n) {
    var r = Ii.get(t), a = Id(r.observationTargets, n), i = r.observationTargets.length === 1;
    a >= 0 && (i && Kn.splice(Kn.indexOf(r), 1), r.observationTargets.splice(a, 1), jd(-1));
  }, e.disconnect = function(t) {
    var n = this, r = Ii.get(t);
    r.observationTargets.slice().forEach(function(a) {
      return n.unobserve(t, a.target);
    }), r.activeTargets.splice(0, r.activeTargets.length);
  }, e;
}(), fC = function() {
  function e(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof t != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    Si.connect(this, t);
  }
  return e.prototype.observe = function(t, n) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Cd(t))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Si.observe(this, t, n);
  }, e.prototype.unobserve = function(t) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Cd(t))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Si.unobserve(this, t);
  }, e.prototype.disconnect = function() {
    Si.disconnect(this);
  }, e.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, e;
}(), gn = {};
Object.defineProperty(gn, "__esModule", {
  value: !0
});
var uC = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), Bf = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, sC = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: uC ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, cg = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var xi = 1; xi < 20; xi++)
  cg["f" + xi] = 111 + xi;
function Yo(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(o) {
    return lg(o, t);
  }), a = function(f) {
    return r.some(function(s) {
      return dg(s, f);
    });
  }, i = n == null ? a : a(n);
  return i;
}
function cC(e, t) {
  return Yo(e, t);
}
function lC(e, t) {
  return Yo(e, { byKey: !0 }, t);
}
function lg(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var a = e.split("+"), i = a.length;
  for (var o in Bf)
    r[Bf[o]] = !1;
  var f = !0, s = !1, u = void 0;
  try {
    for (var c = a[Symbol.iterator](), d; !(f = (d = c.next()).done); f = !0) {
      var g = d.value, p = g.endsWith("?") && g.length > 1;
      p && (g = g.slice(0, -1));
      var h = Ks(g), l = Bf[h];
      (i === 1 || !l) && (n ? r.key = h : r.which = gg(g)), l && (r[l] = p ? null : !0);
    }
  } catch (w) {
    s = !0, u = w;
  } finally {
    try {
      !f && c.return && c.return();
    } finally {
      if (s)
        throw u;
    }
  }
  return r;
}
function dg(e, t) {
  for (var n in e) {
    var r = e[n], a = void 0;
    if (r != null && (n === "key" && t.key != null ? a = t.key.toLowerCase() : n === "which" ? a = r === 91 && t.which === 93 ? 91 : t.which : a = t[n], !(a == null && r === !1) && a !== r))
      return !1;
  }
  return !0;
}
function gg(e) {
  e = Ks(e);
  var t = cg[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function Ks(e) {
  return e = e.toLowerCase(), e = sC[e] || e, e;
}
gn.default = Yo;
var Of = gn.isHotkey = Yo;
gn.isCodeHotkey = cC;
gn.isKeyHotkey = lC;
gn.parseHotkey = lg;
gn.compareHotkey = dg;
gn.toKeyCode = gg;
gn.toKeyName = Ks;
function Go(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function dC(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function _r(e, t) {
  if (e == null)
    return {};
  var n = dC(e, t), r, a;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (a = 0; a < i.length; a++)
      r = i[a], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
var qs = /* @__PURE__ */ tn(null), On = () => {
  var e = Ve(qs);
  if (!e)
    throw new Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
  return e;
}, pg = parseInt(ae.version.split(".")[0], 10), gC = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Sd = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), vt = typeof navigator < "u" && /Android/.test(navigator.userAgent), Ta = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), ja = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), pC = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), hg = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), hC = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), vC = vt && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), mC = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), wC = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), yC = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), $i = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", wn = (!hC || !vC) && !pC && // globalThis is undefined in older browsers
typeof globalThis < "u" && globalThis.InputEvent && // @ts-ignore The `getTargetRanges` property isn't recognized.
typeof globalThis.InputEvent.prototype.getTargetRanges == "function", Xs = /* @__PURE__ */ new WeakMap(), ec = /* @__PURE__ */ new WeakMap(), vg = /* @__PURE__ */ new WeakMap(), Vi = /* @__PURE__ */ new WeakMap(), Pu = /* @__PURE__ */ new WeakMap(), Qa = /* @__PURE__ */ new WeakMap(), Xn = /* @__PURE__ */ new WeakMap(), zu = /* @__PURE__ */ new WeakMap(), Ho = /* @__PURE__ */ new WeakMap(), Ru = /* @__PURE__ */ new WeakMap(), _n = /* @__PURE__ */ new WeakMap(), Zn = /* @__PURE__ */ new WeakMap(), Na = /* @__PURE__ */ new WeakMap(), Fu = /* @__PURE__ */ new WeakMap(), tc = /* @__PURE__ */ new WeakMap(), Yt = /* @__PURE__ */ new WeakMap(), un = /* @__PURE__ */ new WeakMap(), pt = /* @__PURE__ */ new WeakMap(), En = /* @__PURE__ */ new WeakMap(), jn = /* @__PURE__ */ new WeakMap(), mg = /* @__PURE__ */ new WeakMap(), Zr = Symbol("placeholder"), wg = Symbol("mark-placeholder"), bC = globalThis.Text, nc = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, CC = (e) => Tn(e) && e.nodeType === 8, Nt = (e) => Tn(e) && e.nodeType === 1, Tn = (e) => {
  var t = nc(e);
  return !!t && e instanceof t.Node;
}, Uu = (e) => {
  var t = e && e.anchorNode && nc(e.anchorNode);
  return !!t && e instanceof t.Selection;
}, yg = (e) => Tn(e) && e.nodeType === 3, MC = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, DC = (e) => {
  var [t, n] = e;
  if (Nt(t) && t.childNodes.length) {
    var r = n === t.childNodes.length, a = r ? n - 1 : n;
    for ([t, a] = bg(t, a, r ? "backward" : "forward"), r = a < n; Nt(t) && t.childNodes.length; ) {
      var i = r ? t.childNodes.length - 1 : 0;
      t = AC(t, i, r ? "backward" : "forward");
    }
    n = r && t.textContent != null ? t.textContent.length : 0;
  }
  return [t, n];
}, LC = (e) => {
  for (var t = e && e.parentNode; t; ) {
    if (t.toString() === "[object ShadowRoot]")
      return !0;
    t = t.parentNode;
  }
  return !1;
}, bg = (e, t, n) => {
  for (var {
    childNodes: r
  } = e, a = r[t], i = t, o = !1, f = !1; (CC(a) || Nt(a) && a.childNodes.length === 0 || Nt(a) && a.getAttribute("contenteditable") === "false") && !(o && f); ) {
    if (i >= r.length) {
      o = !0, i = t - 1, n = "backward";
      continue;
    }
    if (i < 0) {
      f = !0, i = t + 1, n = "forward";
      continue;
    }
    a = r[i], t = i, i += n === "forward" ? 1 : -1;
  }
  return [a, t];
}, AC = (e, t, n) => {
  var [r] = bg(e, t, n);
  return r;
}, Cg = (e) => {
  var t = "";
  if (yg(e) && e.nodeValue)
    return e.nodeValue;
  if (Nt(e)) {
    for (var n of Array.from(e.childNodes))
      t += Cg(n);
    var r = getComputedStyle(e).getPropertyValue("display");
    (r === "block" || r === "list" || e.tagName === "BR") && (t += `
`);
  }
  return t;
}, EC = /data-slate-fragment="(.+?)"/m, jC = (e) => {
  var t = e.getData("text/html"), [, n] = t.match(EC) || [];
  return n;
}, rc = (e, t, n) => {
  var {
    target: r
  } = t;
  if (Nt(r) && r.matches('[contentEditable="false"]'))
    return !1;
  var {
    document: a
  } = G.getWindow(e);
  if (a.contains(r))
    return G.hasDOMNode(e, r, {
      editable: !0
    });
  var i = n.find((o) => {
    var {
      addedNodes: f,
      removedNodes: s
    } = o;
    for (var u of f)
      if (u === r || u.contains(r))
        return !0;
    for (var c of s)
      if (c === r || c.contains(r))
        return !0;
  });
  return !i || i === t ? !1 : rc(e, i, n);
}, IC = 0;
class SC {
  constructor() {
    this.id = "".concat(IC++);
  }
}
var G = {
  androidPendingDiffs: (e) => pt.get(e),
  androidScheduleFlush: (e) => {
    var t;
    (t = tc.get(e)) === null || t === void 0 || t();
  },
  blur: (e) => {
    var t = G.toDOMNode(e, e), n = G.findDocumentOrShadowRoot(e);
    _n.set(e, !1), n.activeElement === t && t.blur();
  },
  deselect: (e) => {
    var {
      selection: t
    } = e, n = G.findDocumentOrShadowRoot(e), r = n.getSelection();
    r && r.rangeCount > 0 && r.removeAllRanges(), t && H.deselect(e);
  },
  findDocumentOrShadowRoot: (e) => {
    var t = G.toDOMNode(e, e), n = t.getRootNode();
    return (n instanceof Document || n instanceof ShadowRoot) && n.getSelection != null ? n : t.ownerDocument;
  },
  findEventRange: (e, t) => {
    "nativeEvent" in t && (t = t.nativeEvent);
    var {
      clientX: n,
      clientY: r,
      target: a
    } = t;
    if (n == null || r == null)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var i = G.toSlateNode(e, t.target), o = G.findPath(e, i);
    if (fe.isElement(i) && v.isVoid(e, i)) {
      var f = a.getBoundingClientRect(), s = e.isInline(i) ? n - f.left < f.left + f.width - n : r - f.top < f.top + f.height - r, u = v.point(e, o, {
        edge: s ? "start" : "end"
      }), c = s ? v.before(e, u) : v.after(e, u);
      if (c) {
        var d = v.range(e, c);
        return d;
      }
    }
    var g, {
      document: p
    } = G.getWindow(e);
    if (p.caretRangeFromPoint)
      g = p.caretRangeFromPoint(n, r);
    else {
      var h = p.caretPositionFromPoint(n, r);
      h && (g = p.createRange(), g.setStart(h.offsetNode, h.offset), g.setEnd(h.offsetNode, h.offset));
    }
    if (!g)
      throw new Error("Cannot resolve a Slate range from a DOM event: ".concat(t));
    var l = G.toSlateRange(e, g, {
      exactMatch: !1,
      suppressThrow: !1
    });
    return l;
  },
  findKey: (e, t) => {
    var n = zu.get(t);
    return n || (n = new SC(), zu.set(t, n)), n;
  },
  findPath: (e, t) => {
    for (var n = [], r = t; ; ) {
      var a = ec.get(r);
      if (a == null) {
        if (v.isEditor(r))
          return n;
        break;
      }
      var i = Xs.get(r);
      if (i == null)
        break;
      n.unshift(i), r = a;
    }
    throw new Error("Unable to find the path for Slate node: ".concat(qe.stringify(t)));
  },
  focus: (e) => {
    var t = G.toDOMNode(e, e), n = G.findDocumentOrShadowRoot(e);
    _n.set(e, !0), n.activeElement !== t && t.focus({
      preventScroll: !0
    });
  },
  getWindow: (e) => {
    var t = vg.get(e);
    if (!t)
      throw new Error("Unable to find a host window element for this editor");
    return t;
  },
  hasDOMNode: function(t, n) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, {
      editable: a = !1
    } = r, i = G.toDOMNode(t, t), o;
    try {
      o = Nt(n) ? n : n.parentElement;
    } catch (f) {
      if (!f.message.includes('Permission denied to access property "nodeType"'))
        throw f;
    }
    return o ? o.closest("[data-slate-editor]") === i && (!a || o.isContentEditable ? !0 : typeof o.isContentEditable == "boolean" && // isContentEditable exists only on HTMLElement, and on other nodes it will be undefined
    // this is the core logic that lets you know you got the right editor.selection instead of null when editor is contenteditable="false"(readOnly)
    o.closest('[contenteditable="false"]') === i || !!o.getAttribute("data-slate-zero-width")) : !1;
  },
  hasEditableTarget: (e, t) => Tn(t) && G.hasDOMNode(e, t, {
    editable: !0
  }),
  hasRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t;
    return v.hasPath(e, n.path) && v.hasPath(e, r.path);
  },
  hasSelectableTarget: (e, t) => G.hasEditableTarget(e, t) || G.isTargetInsideNonReadonlyVoid(e, t),
  hasTarget: (e, t) => Tn(t) && G.hasDOMNode(e, t),
  insertData: (e, t) => {
    e.insertData(t);
  },
  insertFragmentData: (e, t) => e.insertFragmentData(t),
  insertTextData: (e, t) => e.insertTextData(t),
  isComposing: (e) => !!Zn.get(e),
  isFocused: (e) => !!_n.get(e),
  isReadOnly: (e) => !!Ru.get(e),
  isTargetInsideNonReadonlyVoid: (e, t) => {
    if (Ru.get(e))
      return !1;
    var n = G.hasTarget(e, t) && G.toSlateNode(e, t);
    return fe.isElement(n) && v.isVoid(e, n);
  },
  setFragmentData: (e, t, n) => e.setFragmentData(t, n),
  toDOMNode: (e, t) => {
    var n = Ho.get(e), r = v.isEditor(t) ? Vi.get(e) : n == null ? void 0 : n.get(G.findKey(e, t));
    if (!r)
      throw new Error("Cannot resolve a DOM node from Slate node: ".concat(qe.stringify(t)));
    return r;
  },
  toDOMPoint: (e, t) => {
    var [n] = v.node(e, t.path), r = G.toDOMNode(e, n), a;
    v.void(e, {
      at: t
    }) && (t = {
      path: t.path,
      offset: 0
    });
    for (var i = "[data-slate-string], [data-slate-zero-width]", o = Array.from(r.querySelectorAll(i)), f = 0, s = 0; s < o.length; s++) {
      var u = o[s], c = u.childNodes[0];
      if (!(c == null || c.textContent == null)) {
        var {
          length: d
        } = c.textContent, g = u.getAttribute("data-slate-length"), p = g == null ? d : parseInt(g, 10), h = f + p, l = o[s + 1];
        if (t.offset === h && l !== null && l !== void 0 && l.hasAttribute("data-slate-mark-placeholder")) {
          var w, m = l.childNodes[0];
          a = [
            // COMPAT: If we don't explicity set the dom point to be on the actual
            // dom text element, chrome will put the selection behind the actual dom
            // text element, causing domRange.getBoundingClientRect() calls on a collapsed
            // selection to return incorrect zero values (https://bugs.chromium.org/p/chromium/issues/detail?id=435438)
            // which will cause issues when scrolling to it.
            m instanceof bC ? m : l,
            (w = l.textContent) !== null && w !== void 0 && w.startsWith("\uFEFF") ? 1 : 0
          ];
          break;
        }
        if (t.offset <= h) {
          var y = Math.min(d, Math.max(0, t.offset - f));
          a = [c, y];
          break;
        }
        f = h;
      }
    }
    if (!a)
      throw new Error("Cannot resolve a DOM point from Slate point: ".concat(qe.stringify(t)));
    return a;
  },
  toDOMRange: (e, t) => {
    var {
      anchor: n,
      focus: r
    } = t, a = z.isBackward(t), i = G.toDOMPoint(e, n), o = z.isCollapsed(t) ? i : G.toDOMPoint(e, r), f = G.getWindow(e), s = f.document.createRange(), [u, c] = a ? o : i, [d, g] = a ? i : o, p = Nt(u) ? u : u.parentElement, h = !!p.getAttribute("data-slate-zero-width"), l = Nt(d) ? d : d.parentElement, w = !!l.getAttribute("data-slate-zero-width");
    return s.setStart(u, h ? 1 : c), s.setEnd(d, w ? 1 : g), s;
  },
  toSlateNode: (e, t) => {
    var n = Nt(t) ? t : t.parentElement;
    n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
    var r = n ? Qa.get(n) : null;
    if (!r)
      throw new Error("Cannot resolve a Slate node from DOM node: ".concat(n));
    return r;
  },
  toSlatePoint: (e, t, n) => {
    var {
      exactMatch: r,
      suppressThrow: a
    } = n, [i, o] = r ? t : DC(t), f = i.parentNode, s = null, u = 0;
    if (f) {
      var c, d, g = G.toDOMNode(e, e), p = f.closest('[data-slate-void="true"]'), h = p && g.contains(p) ? p : null, l = f.closest("[data-slate-leaf]"), w = null;
      if (l) {
        if (s = l.closest('[data-slate-node="text"]'), s) {
          var m = G.getWindow(e), y = m.document.createRange();
          y.setStart(s, 0), y.setEnd(i, o);
          var b = y.cloneContents(), C = [...Array.prototype.slice.call(b.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(b.querySelectorAll("[contenteditable=false]"))];
          C.forEach((A) => {
            if (vt && !r && A.hasAttribute("data-slate-zero-width") && A.textContent.length > 0 && A.textContext !== "\uFEFF") {
              A.textContent.startsWith("\uFEFF") && (A.textContent = A.textContent.slice(1));
              return;
            }
            A.parentNode.removeChild(A);
          }), u = b.textContent.length, w = s;
        }
      } else if (h) {
        for (var M = h.querySelectorAll("[data-slate-leaf]"), S = 0; S < M.length; S++) {
          var I = M[S];
          if (G.hasDOMNode(e, I)) {
            l = I;
            break;
          }
        }
        l ? (s = l.closest('[data-slate-node="text"]'), w = l, u = w.textContent.length, w.querySelectorAll("[data-slate-zero-width]").forEach((A) => {
          u -= A.textContent.length;
        })) : u = 1;
      }
      w && u === w.textContent.length && // COMPAT: Android IMEs might remove the zero width space while composing,
      // and we don't add it for line-breaks.
      vt && w.getAttribute("data-slate-zero-width") === "z" && (c = w.textContent) !== null && c !== void 0 && c.startsWith("\uFEFF") && (f.hasAttribute("data-slate-zero-width") || Ta && (d = w.textContent) !== null && d !== void 0 && d.endsWith(`

`)) && u--;
    }
    if (vt && !s && !r) {
      var N = f.hasAttribute("data-slate-node") ? f : f.closest("[data-slate-node]");
      if (N && G.hasDOMNode(e, N, {
        editable: !0
      })) {
        var O = G.toSlateNode(e, N), {
          path: F,
          offset: Q
        } = v.start(e, G.findPath(e, O));
        return N.querySelector("[data-slate-leaf]") || (Q = o), {
          path: F,
          offset: Q
        };
      }
    }
    if (!s) {
      if (a)
        return null;
      throw new Error("Cannot resolve a Slate point from DOM point: ".concat(t));
    }
    var T = G.toSlateNode(e, s), x = G.findPath(e, T);
    return {
      path: x,
      offset: u
    };
  },
  toSlateRange: (e, t, n) => {
    var {
      exactMatch: r,
      suppressThrow: a
    } = n, i = Uu(t) ? t.anchorNode : t.startContainer, o, f, s, u, c;
    if (i)
      if (Uu(t)) {
        if (Ta && t.rangeCount > 1) {
          s = t.focusNode;
          var d = t.getRangeAt(0), g = t.getRangeAt(t.rangeCount - 1);
          if (s instanceof HTMLTableRowElement && d.startContainer instanceof HTMLTableRowElement && g.startContainer instanceof HTMLTableRowElement) {
            let M = function(S) {
              return S.childElementCount > 0 ? M(S.children[0]) : S;
            };
            var p = d.startContainer, h = g.startContainer, l = M(p.children[d.startOffset]), w = M(h.children[g.startOffset]);
            u = 0, w.childNodes.length > 0 ? o = w.childNodes[0] : o = w, l.childNodes.length > 0 ? s = l.childNodes[0] : s = l, w instanceof HTMLElement ? f = w.innerHTML.length : f = 0;
          } else
            d.startContainer === s ? (o = g.endContainer, f = g.endOffset, u = d.startOffset) : (o = d.startContainer, f = d.endOffset, u = g.startOffset);
        } else
          o = t.anchorNode, f = t.anchorOffset, s = t.focusNode, u = t.focusOffset;
        hg && LC(o) || Ta ? c = t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : c = t.isCollapsed;
      } else
        o = t.startContainer, f = t.startOffset, s = t.endContainer, u = t.endOffset, c = t.collapsed;
    if (o == null || s == null || f == null || u == null)
      throw new Error("Cannot resolve a Slate range from DOM range: ".concat(t));
    if ("getAttribute" in s && s.getAttribute("contenteditable") === "false" && s.getAttribute("data-slate-void") !== "true") {
      var m;
      s = o, u = ((m = o.textContent) === null || m === void 0 ? void 0 : m.length) || 0;
    }
    var y = G.toSlatePoint(e, [o, f], {
      exactMatch: r,
      suppressThrow: a
    });
    if (!y)
      return null;
    var b = c ? y : G.toSlatePoint(e, [s, u], {
      exactMatch: r,
      suppressThrow: a
    });
    if (!b)
      return null;
    var C = {
      anchor: y,
      focus: b
    };
    return z.isExpanded(C) && z.isForward(C) && Nt(s) && v.void(e, {
      at: C.focus,
      mode: "highest"
    }) && (C = v.unhangRange(e, C, {
      voids: !0
    })), C;
  }
};
function xC(e, t) {
  var {
    path: n,
    diff: r
  } = t;
  if (!v.hasPath(e, n))
    return !1;
  var a = te.get(e, n);
  if (!se.isText(a))
    return !1;
  if (r.start !== a.text.length || r.text.length === 0)
    return a.text.slice(r.start, r.start + r.text.length) === r.text;
  var i = j.next(n);
  if (!v.hasPath(e, i))
    return !1;
  var o = te.get(e, i);
  return se.isText(o) && o.text.startsWith(r.text);
}
function Mg(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return n.reduce((a, i) => a.slice(0, i.start) + i.text + a.slice(i.end), e);
}
function TC(e, t) {
  for (var n = Math.min(e.length, t.length), r = 0; r < n; r++)
    if (e.charAt(r) !== t.charAt(r))
      return r;
  return n;
}
function NC(e, t, n) {
  for (var r = Math.min(e.length, t.length, n), a = 0; a < r; a++)
    if (e.charAt(e.length - a - 1) !== t.charAt(t.length - a - 1))
      return a;
  return r;
}
function Dg(e, t) {
  var {
    start: n,
    end: r,
    text: a
  } = t, i = e.slice(n, r), o = TC(i, a), f = Math.min(i.length - o, a.length - o), s = NC(i, a, f), u = {
    start: n + o,
    end: r - s,
    text: a.slice(o, a.length - s)
  };
  return u.start === u.end && u.text.length === 0 ? null : u;
}
function kC(e, t, n) {
  var r = Math.min(t.start, n.start), a = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), i = Mg(e, t, n), o = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - a), f = i.slice(r, o), s = Math.max(t.end, n.end - t.text.length + (t.end - t.start));
  return Dg(e, {
    start: r,
    end: s,
    text: f
  });
}
function BC(e) {
  var {
    path: t,
    diff: n
  } = e;
  return {
    anchor: {
      path: t,
      offset: n.start
    },
    focus: {
      path: t,
      offset: n.end
    }
  };
}
function Yu(e, t) {
  var {
    path: n,
    offset: r
  } = t;
  if (!v.hasPath(e, n))
    return null;
  var a = te.get(e, n);
  if (!se.isText(a))
    return null;
  var i = v.above(e, {
    match: (f) => fe.isElement(f) && v.isBlock(e, f),
    at: n
  });
  if (!i)
    return null;
  for (; r > a.text.length; ) {
    var o = v.next(e, {
      at: n,
      match: se.isText
    });
    if (!o || !j.isDescendant(o[1], i[1]))
      return null;
    r -= a.text.length, a = o[0], n = o[1];
  }
  return {
    path: n,
    offset: r
  };
}
function xd(e, t) {
  var n = Yu(e, t.anchor);
  if (!n)
    return null;
  if (z.isCollapsed(t))
    return {
      anchor: n,
      focus: n
    };
  var r = Yu(e, t.focus);
  return r ? {
    anchor: n,
    focus: r
  } : null;
}
function Gu(e, t, n) {
  var r = pt.get(e), a = r == null ? void 0 : r.find((c) => {
    var {
      path: d
    } = c;
    return j.equals(d, t.path);
  });
  if (!a || t.offset <= a.diff.start)
    return be.transform(t, n, {
      affinity: "backward"
    });
  var {
    diff: i
  } = a;
  if (t.offset <= i.start + i.text.length) {
    var o = {
      path: t.path,
      offset: i.start
    }, f = be.transform(o, n, {
      affinity: "backward"
    });
    return f ? {
      path: f.path,
      offset: f.offset + t.offset - i.start
    } : null;
  }
  var s = {
    path: t.path,
    offset: t.offset - i.text.length + i.end - i.start
  }, u = be.transform(s, n, {
    affinity: "backward"
  });
  return u ? n.type === "split_node" && j.equals(n.path, t.path) && s.offset < n.position && i.start < n.position ? u : {
    path: u.path,
    offset: u.offset + i.text.length - i.end + i.start
  } : null;
}
function Td(e, t, n) {
  var r = Gu(e, t.anchor, n);
  if (!r)
    return null;
  if (z.isCollapsed(t))
    return {
      anchor: r,
      focus: r
    };
  var a = Gu(e, t.focus, n);
  return a ? {
    anchor: r,
    focus: a
  } : null;
}
function OC(e, t) {
  var {
    path: n,
    diff: r,
    id: a
  } = e;
  switch (t.type) {
    case "insert_text":
      return !j.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
        diff: {
          start: t.text.length + r.start,
          end: t.text.length + r.end,
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end + t.text.length,
          text: r.text
        },
        id: a,
        path: n
      };
    case "remove_text":
      return !j.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
        diff: {
          start: r.start - t.text.length,
          end: r.end - t.text.length,
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start,
          end: r.end - t.text.length,
          text: r.text
        },
        id: a,
        path: n
      };
    case "split_node":
      return !j.equals(t.path, n) || t.position >= r.end ? {
        diff: r,
        id: a,
        path: j.transform(n, t, {
          affinity: "backward"
        })
      } : t.position > r.start ? {
        diff: {
          start: r.start,
          end: Math.min(t.position, r.end),
          text: r.text
        },
        id: a,
        path: n
      } : {
        diff: {
          start: r.start - t.position,
          end: r.end - t.position,
          text: r.text
        },
        id: a,
        path: j.transform(n, t, {
          affinity: "forward"
        })
      };
    case "merge_node":
      return j.equals(t.path, n) ? {
        diff: {
          start: r.start + t.position,
          end: r.end + t.position,
          text: r.text
        },
        id: a,
        path: j.transform(n, t)
      } : {
        diff: r,
        id: a,
        path: j.transform(n, t)
      };
  }
  var i = j.transform(n, t);
  return i ? {
    diff: r,
    path: i,
    id: a
  } : null;
}
function Nd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ti(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Nd(Object(n), !0).forEach(function(r) {
      Go(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Nd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var PC = 25, zC = 200, RC = function() {
}, FC = (e) => (e == null ? void 0 : e.constructor.name) === "DataTransfer";
function UC(e) {
  var {
    editor: t,
    scheduleOnDOMSelectionChange: n,
    onDOMSelectionChange: r
  } = e, a = !1, i = null, o = null, f = null, s = 0, u = !1, c = () => {
    var T = jn.get(t);
    if (jn.delete(t), T) {
      var {
        selection: x
      } = t, A = xd(t, T);
      A && (!x || !z.equals(A, x)) && H.select(t, A);
    }
  }, d = () => {
    var T = En.get(t);
    if (En.delete(t), !!T) {
      if (T.at) {
        var x = be.isPoint(T.at) ? Yu(t, T.at) : xd(t, T.at);
        if (!x)
          return;
        var A = v.range(t, x);
        (!t.selection || !z.equals(t.selection, A)) && H.select(t, x);
      }
      T.run();
    }
  }, g = () => {
    if (o && (clearTimeout(o), o = null), f && (clearTimeout(f), f = null), !C() && !b()) {
      c();
      return;
    }
    a || (a = !0, setTimeout(() => a = !1)), b() && (a = "action");
    var T = t.selection && v.rangeRef(t, t.selection, {
      affinity: "forward"
    });
    un.set(t, t.marks), RC("flush", En.get(t), pt.get(t));
    for (var x = C(), A; A = (B = pt.get(t)) === null || B === void 0 ? void 0 : B[0]; ) {
      var B, J, $ = Yt.get(t);
      $ !== void 0 && (Yt.delete(t), t.marks = $), $ && u === !1 && (u = null);
      var q = BC(A);
      (!t.selection || !z.equals(t.selection, q)) && H.select(t, q), A.diff.text ? v.insertText(t, A.diff.text) : v.deleteFragment(t), pt.set(t, (J = pt.get(t)) === null || J === void 0 ? void 0 : J.filter((R) => {
        var {
          id: W
        } = R;
        return W !== A.id;
      })), xC(t, A) || (x = !1, En.delete(t), un.delete(t), a = "action", jn.delete(t), n.cancel(), r.cancel(), T == null || T.unref());
    }
    var K = T == null ? void 0 : T.unref();
    if (K && !jn.get(t) && (!t.selection || !z.equals(K, t.selection)) && H.select(t, K), b()) {
      d();
      return;
    }
    x && n(), n.flush(), r.flush(), c();
    var P = un.get(t);
    un.delete(t), P !== void 0 && (t.marks = P, t.onChange());
  }, p = (T) => {
    i && clearTimeout(i), i = setTimeout(() => {
      Zn.set(t, !1), g();
    }, PC);
  }, h = (T) => {
    Zn.set(t, !0), i && (clearTimeout(i), i = null);
  }, l = function() {
    var x = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1, A = Pu.get(t);
    if (A) {
      if (C() || x) {
        A.style.display = "none";
        return;
      }
      A.style.removeProperty("display");
    }
  }, w = (T, x) => {
    var A, B = (A = pt.get(t)) !== null && A !== void 0 ? A : [];
    pt.set(t, B);
    var J = te.leaf(t, T), $ = B.findIndex((P) => j.equals(P.path, T));
    if ($ < 0) {
      var q = Dg(J.text, x);
      q && B.push({
        path: T,
        diff: x,
        id: s++
      }), l();
      return;
    }
    var K = kC(J.text, B[$].diff, x);
    if (!K) {
      B.splice($, 1), l();
      return;
    }
    B[$] = Ti(Ti({}, B[$]), {}, {
      diff: K
    });
  }, m = function(x) {
    var {
      at: A
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    u = !1, jn.delete(t), n.cancel(), r.cancel(), b() && g(), En.set(t, {
      at: A,
      run: x
    }), f = setTimeout(g);
  }, y = (T) => {
    var x;
    o && (clearTimeout(o), o = null);
    var {
      inputType: A
    } = T, B = null, J = T.dataTransfer || T.data || void 0;
    u !== !1 && A !== "insertText" && A !== "insertCompositionText" && (u = !1);
    var [$] = T.getTargetRanges();
    $ && (B = G.toSlateRange(t, $, {
      exactMatch: !1,
      suppressThrow: !0
    }));
    var q = G.getWindow(t), K = q.getSelection();
    if (!B && K && ($ = K, B = G.toSlateRange(t, K, {
      exactMatch: !1,
      suppressThrow: !0
    })), B = (x = B) !== null && x !== void 0 ? x : t.selection, !!B) {
      var P = !0;
      if (A.startsWith("delete")) {
        if (z.isExpanded(B)) {
          var [R, W] = z.edges(B), X = te.leaf(t, R.path);
          if (X.text.length === R.offset && W.offset === 0) {
            var D = v.next(t, {
              at: R.path,
              match: se.isText
            });
            D && j.equals(D[1], W.path) && (B = {
              anchor: W,
              focus: W
            });
          }
        }
        var U = A.endsWith("Backward") ? "backward" : "forward", [k, Y] = z.edges(B), [V, Z] = v.leaf(t, k.path), re = {
          text: "",
          start: k.offset,
          end: Y.offset
        }, ce = pt.get(t), _ = ce == null ? void 0 : ce.find((Mt) => j.equals(Mt.path, Z)), Le = _ ? [_.diff, re] : [re], he = Mg(V.text, ...Le);
        if (he.length === 0 && (P = !1), z.isExpanded(B)) {
          if (P && j.equals(B.anchor.path, B.focus.path)) {
            var We = {
              path: B.anchor.path,
              offset: k.offset
            }, Ke = v.range(t, We, We);
            return I(Ke), w(B.anchor.path, {
              text: "",
              end: Y.offset,
              start: k.offset
            });
          }
          return m(() => v.deleteFragment(t, {
            direction: U
          }), {
            at: B
          });
        }
      }
      switch (A) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag":
          return m(() => v.deleteFragment(t), {
            at: B
          });
        case "deleteContent":
        case "deleteContentForward": {
          var {
            anchor: Ue
          } = B;
          if (P && z.isCollapsed(B)) {
            var bt = te.leaf(t, Ue.path);
            if (Ue.offset < bt.text.length)
              return w(Ue.path, {
                text: "",
                start: Ue.offset,
                end: Ue.offset + 1
              });
          }
          return m(() => v.deleteForward(t), {
            at: B
          });
        }
        case "deleteContentBackward": {
          var ne, {
            anchor: de
          } = B, je = Uu($) ? $.isCollapsed : !!((ne = $) !== null && ne !== void 0 && ne.collapsed);
          return P && je && z.isCollapsed(B) && de.offset > 0 ? w(de.path, {
            text: "",
            start: de.offset - 1,
            end: de.offset
          }) : m(() => v.deleteBackward(t), {
            at: B
          });
        }
        case "deleteEntireSoftLine":
          return m(() => {
            v.deleteBackward(t, {
              unit: "line"
            }), v.deleteForward(t, {
              unit: "line"
            });
          }, {
            at: B
          });
        case "deleteHardLineBackward":
          return m(() => v.deleteBackward(t, {
            unit: "block"
          }), {
            at: B
          });
        case "deleteSoftLineBackward":
          return m(() => v.deleteBackward(t, {
            unit: "line"
          }), {
            at: B
          });
        case "deleteHardLineForward":
          return m(() => v.deleteForward(t, {
            unit: "block"
          }), {
            at: B
          });
        case "deleteSoftLineForward":
          return m(() => v.deleteForward(t, {
            unit: "line"
          }), {
            at: B
          });
        case "deleteWordBackward":
          return m(() => v.deleteBackward(t, {
            unit: "word"
          }), {
            at: B
          });
        case "deleteWordForward":
          return m(() => v.deleteForward(t, {
            unit: "word"
          }), {
            at: B
          });
        case "insertLineBreak":
          return m(() => v.insertSoftBreak(t), {
            at: B
          });
        case "insertParagraph":
          return m(() => v.insertBreak(t), {
            at: B
          });
        case "insertCompositionText":
        case "deleteCompositionText":
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          if (FC(J))
            return m(() => G.insertData(t, J), {
              at: B
            });
          var ve = J ?? "";
          if (Yt.get(t) && (ve = ve.replace("\uFEFF", "")), A === "insertText" && /.*\n.*\n$/.test(ve) && (ve = ve.slice(0, -1)), ve.includes(`
`))
            return m(() => {
              var Mt = ve.split(`
`);
              Mt.forEach((Fn, bi) => {
                Fn && v.insertText(t, Fn), bi !== Mt.length - 1 && v.insertSoftBreak(t);
              });
            }, {
              at: B
            });
          if (j.equals(B.anchor.path, B.focus.path)) {
            var [Ye, Ze] = z.edges(B), Ae = {
              start: Ye.offset,
              end: Ze.offset,
              text: ve
            };
            if (ve && u && A === "insertCompositionText") {
              var Ct = u.start + u.text.search(/\S|$/), yr = Ae.start + Ae.text.search(/\S|$/);
              yr === Ct + 1 && Ae.end === u.start + u.text.length ? (Ae.start -= 1, u = null, F()) : u = !1;
            } else
              A === "insertText" ? u === null ? u = Ae : u && z.isCollapsed(B) && u.end + u.text.length === Ye.offset ? u = Ti(Ti({}, u), {}, {
                text: u.text + ve
              }) : u = !1 : u = !1;
            if (P) {
              w(Ye.path, Ae);
              return;
            }
          }
          return m(() => v.insertText(t, ve), {
            at: B
          });
        }
      }
    }
  }, b = () => !!En.get(t), C = () => {
    var T;
    return !!((T = pt.get(t)) !== null && T !== void 0 && T.length);
  }, M = () => b() || C(), S = () => a, I = (T) => {
    jn.set(t, T), o && (clearTimeout(o), o = null);
    var {
      selection: x
    } = t;
    if (T) {
      var A = !x || !j.equals(x.anchor.path, T.anchor.path), B = !x || !j.equals(x.anchor.path.slice(0, -1), T.anchor.path.slice(0, -1));
      (A && u || B) && (u = !1), (A || C()) && (o = setTimeout(g, zC));
    }
  }, N = () => {
    (b() || !C()) && g();
  }, O = (T) => {
    C() || (l(!0), setTimeout(l));
  }, F = () => {
    b() || (f = setTimeout(g));
  }, Q = (T) => {
    if (!(C() || b()) && T.some((A) => rc(t, A, T))) {
      var x;
      (x = mg.get(t)) === null || x === void 0 || x();
    }
  };
  return {
    flush: g,
    scheduleFlush: F,
    hasPendingDiffs: C,
    hasPendingAction: b,
    hasPendingChanges: M,
    isFlushing: S,
    handleUserSelect: I,
    handleCompositionEnd: p,
    handleCompositionStart: h,
    handleDOMBeforeInput: y,
    handleKeyDown: O,
    handleDomMutations: Q,
    handleInput: N
  };
}
function YC() {
  var e = Ce(!1);
  return le(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e.current;
}
var Ja = $i ? ri : le;
function GC(e, t, n) {
  var [r] = ie(() => new MutationObserver(t));
  Ja(() => {
    r.takeRecords();
  }), le(() => {
    if (!e.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    return r.observe(e.current, n), () => r.disconnect();
  }, [r, e, n]);
}
var HC = ["node"];
function kd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function QC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? kd(Object(n), !0).forEach(function(r) {
      Go(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var JC = {
  subtree: !0,
  childList: !0,
  characterData: !0
}, WC = vt ? (e) => {
  var {
    node: t
  } = e, n = _r(e, HC);
  if (!vt)
    return null;
  var r = On(), a = YC(), [i] = ie(() => UC(QC({
    editor: r
  }, n)));
  return GC(t, i.handleDomMutations, JC), tc.set(r, i.scheduleFlush), a && i.flush(), i;
} : () => null, _C = ["anchor", "focus"], ZC = ["anchor", "focus"], $C = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), Lg = (e, t) => {
  var n = _r(e, _C), r = _r(t, ZC);
  return e[Zr] === t[Zr] && $C(n, r);
}, VC = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], a = t[n];
    if (!z.equals(r, a) || !Lg(r, a))
      return !1;
  }
  return !0;
}, KC = (e, t) => {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++) {
    var r = e[n], a = t[n];
    if (r.anchor.offset !== a.anchor.offset || r.focus.offset !== a.focus.offset || !Lg(r, a))
      return !1;
  }
  return !0;
}, qC = (e) => {
  var {
    isLast: t,
    leaf: n,
    parent: r,
    text: a
  } = e, i = On(), o = G.findPath(i, a), f = j.parent(o), s = n[wg] === !0;
  return i.isVoid(r) ? /* @__PURE__ */ ae.createElement(Pf, {
    length: te.string(r).length
  }) : n.text === "" && r.children[r.children.length - 1] === a && !i.isInline(r) && v.string(i, f) === "" ? /* @__PURE__ */ ae.createElement(Pf, {
    isLineBreak: !0,
    isMarkPlaceholder: s
  }) : n.text === "" ? /* @__PURE__ */ ae.createElement(Pf, {
    isMarkPlaceholder: s
  }) : t && n.text.slice(-1) === `
` ? /* @__PURE__ */ ae.createElement(Bd, {
    isTrailing: !0,
    text: n.text
  }) : /* @__PURE__ */ ae.createElement(Bd, {
    text: n.text
  });
}, Bd = (e) => {
  var {
    text: t,
    isTrailing: n = !1
  } = e, r = Ce(null), a = () => "".concat(t ?? "").concat(n ? `
` : ""), [i] = ie(a);
  return Ja(() => {
    var o = a();
    r.current && r.current.textContent !== o && (r.current.textContent = o);
  }), /* @__PURE__ */ ae.createElement(XC, {
    ref: r
  }, i);
}, XC = /* @__PURE__ */ vs(/* @__PURE__ */ fr((e, t) => /* @__PURE__ */ ae.createElement("span", {
  "data-slate-string": !0,
  ref: t
}, e.children))), Pf = (e) => {
  var {
    length: t = 0,
    isLineBreak: n = !1,
    isMarkPlaceholder: r = !1
  } = e, a = {
    "data-slate-zero-width": n ? "n" : "z",
    "data-slate-length": t
  };
  return r && (a["data-slate-mark-placeholder"] = !0), /* @__PURE__ */ ae.createElement("span", Object.assign({}, a), !vt || !n ? "\uFEFF" : null, n ? /* @__PURE__ */ ae.createElement("br", null) : null);
};
function eM(e, t) {
  e.current && (e.current.disconnect(), t && (e.current = null));
}
function Od(e) {
  e.current && (clearTimeout(e.current), e.current = null);
}
var tM = (e) => {
  var {
    leaf: t,
    isLast: n,
    text: r,
    parent: a,
    renderPlaceholder: i,
    renderLeaf: o = (y) => /* @__PURE__ */ ae.createElement(rM, Object.assign({}, y))
  } = e, f = On(), s = Ce(null), u = Ce(null), [c, d] = ie(!1), g = Ce(null), p = pe((y) => {
    if (eM(s, y == null), y == null) {
      var b;
      Pu.delete(f), (b = t.onPlaceholderResize) === null || b === void 0 || b.call(t, null);
    } else {
      if (Pu.set(f, y), !s.current) {
        var C = window.ResizeObserver || fC;
        s.current = new C(() => {
          var M;
          (M = t.onPlaceholderResize) === null || M === void 0 || M.call(t, y);
        });
      }
      s.current.observe(y), u.current = y;
    }
  }, [u, t, f]), h = /* @__PURE__ */ ae.createElement(qC, {
    isLast: n,
    leaf: t,
    parent: a,
    text: r
  }), l = t[Zr];
  if (le(() => (l ? g.current || (g.current = setTimeout(() => {
    d(!0), g.current = null;
  }, 300)) : (Od(g), d(!1)), () => Od(g)), [l, d]), l && c) {
    var w = {
      children: t.placeholder,
      attributes: {
        "data-slate-placeholder": !0,
        style: {
          position: "absolute",
          top: 0,
          pointerEvents: "none",
          width: "100%",
          maxWidth: "100%",
          display: "block",
          opacity: "0.333",
          userSelect: "none",
          textDecoration: "none",
          // Fixes https://github.com/udecode/plate/issues/2315
          WebkitUserModify: ja ? "inherit" : void 0
        },
        contentEditable: !1,
        ref: p
      }
    };
    h = /* @__PURE__ */ ae.createElement(ae.Fragment, null, i(w), h);
  }
  var m = {
    "data-slate-leaf": !0
  };
  return o({
    attributes: m,
    children: h,
    leaf: t,
    text: r
  });
}, nM = /* @__PURE__ */ ae.memo(tM, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && se.equals(t.leaf, e.leaf) && t.leaf[Zr] === e.leaf[Zr]), rM = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return /* @__PURE__ */ ae.createElement("span", Object.assign({}, t), n);
}, aM = (e) => {
  for (var {
    decorations: t,
    isLast: n,
    parent: r,
    renderPlaceholder: a,
    renderLeaf: i,
    text: o
  } = e, f = On(), s = Ce(null), u = se.decorations(o, t), c = G.findKey(f, o), d = [], g = 0; g < u.length; g++) {
    var p = u[g];
    d.push(/* @__PURE__ */ ae.createElement(nM, {
      isLast: n && g === u.length - 1,
      key: "".concat(c.id, "-").concat(g),
      renderPlaceholder: a,
      leaf: p,
      text: o,
      parent: r,
      renderLeaf: i
    }));
  }
  var h = pe((l) => {
    var w = Ho.get(f);
    l ? (w == null || w.set(c, l), Xn.set(o, l), Qa.set(l, o)) : (w == null || w.delete(c), Xn.delete(o), s.current && Qa.delete(s.current)), s.current = l;
  }, [s, f, c, o]);
  return /* @__PURE__ */ ae.createElement("span", {
    "data-slate-node": "text",
    ref: h
  }, d);
}, Ag = /* @__PURE__ */ ae.memo(aM, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && KC(t.decorations, e.decorations)), iM = (e) => {
  var {
    decorations: t,
    element: n,
    renderElement: r = (y) => /* @__PURE__ */ ae.createElement(fM, Object.assign({}, y)),
    renderPlaceholder: a,
    renderLeaf: i,
    selection: o
  } = e, f = On(), s = Tg(), u = f.isInline(n), c = G.findKey(f, n), d = pe((y) => {
    var b = Ho.get(f);
    y ? (b == null || b.set(c, y), Xn.set(n, y), Qa.set(y, n)) : (b == null || b.delete(c), Xn.delete(n));
  }, [f, c, n]), g = Sg({
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: a,
    renderLeaf: i,
    selection: o
  }), p = {
    "data-slate-node": "element",
    ref: d
  };
  if (u && (p["data-slate-inline"] = !0), !u && v.hasInlines(f, n)) {
    var h = te.string(n), l = _1(h);
    l === "rtl" && (p.dir = l);
  }
  if (v.isVoid(f, n)) {
    p["data-slate-void"] = !0, !s && u && (p.contentEditable = !1);
    var w = u ? "span" : "div", [[m]] = te.texts(n);
    g = /* @__PURE__ */ ae.createElement(w, {
      "data-slate-spacer": !0,
      style: {
        height: "0",
        color: "transparent",
        outline: "none",
        position: "absolute"
      }
    }, /* @__PURE__ */ ae.createElement(Ag, {
      renderPlaceholder: a,
      decorations: [],
      isLast: !1,
      parent: n,
      text: m
    })), Xs.set(m, 0), ec.set(m, n);
  }
  return r({
    attributes: p,
    children: g,
    element: n
  });
}, oM = /* @__PURE__ */ ae.memo(iM, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && VC(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && z.equals(e.selection, t.selection))), fM = (e) => {
  var {
    attributes: t,
    children: n,
    element: r
  } = e, a = On(), i = a.isInline(r) ? "span" : "div";
  return /* @__PURE__ */ ae.createElement(i, Object.assign({}, t, {
    style: {
      position: "relative"
    }
  }), n);
}, Eg = /* @__PURE__ */ tn(() => []), uM = () => Ve(Eg), jg = /* @__PURE__ */ tn(!1), Ig = () => Ve(jg), Sg = (e) => {
  for (var {
    decorations: t,
    node: n,
    renderElement: r,
    renderPlaceholder: a,
    renderLeaf: i,
    selection: o
  } = e, f = uM(), s = On(), u = G.findPath(s, n), c = [], d = fe.isElement(n) && !s.isInline(n) && v.hasInlines(s, n), g = 0; g < n.children.length; g++) {
    var p = u.concat(g), h = n.children[g], l = G.findKey(s, h), w = v.range(s, p), m = o && z.intersection(w, o), y = f([h, p]);
    for (var b of t) {
      var C = z.intersection(b, w);
      C && y.push(C);
    }
    fe.isElement(h) ? c.push(/* @__PURE__ */ ae.createElement(jg.Provider, {
      key: "provider-".concat(l.id),
      value: !!m
    }, /* @__PURE__ */ ae.createElement(oM, {
      decorations: y,
      element: h,
      key: l.id,
      renderElement: r,
      renderPlaceholder: a,
      renderLeaf: i,
      selection: m
    }))) : c.push(/* @__PURE__ */ ae.createElement(Ag, {
      decorations: y,
      key: l.id,
      isLast: d && g === n.children.length - 1,
      parent: n,
      renderPlaceholder: a,
      renderLeaf: i,
      text: h
    })), Xs.set(h, g), ec.set(h, n);
  }
  return c;
}, xg = /* @__PURE__ */ tn(!1), Tg = () => Ve(xg), Ng = /* @__PURE__ */ tn(null), yt = () => {
  var e = Ve(Ng);
  if (!e)
    throw new Error("The `useSlate` hook must be used inside the <Slate> component's context.");
  var {
    editor: t
  } = e;
  return t;
};
function sM() {
  var e = On(), t = Ce(!1), n = Ce(0), r = pe(() => {
    if (!t.current) {
      t.current = !0;
      var a = G.getWindow(e);
      a.cancelAnimationFrame(n.current), n.current = a.requestAnimationFrame(() => {
        t.current = !1;
      });
    }
  }, [e]);
  return le(() => () => cancelAnimationFrame(n.current), []), {
    receivedUserInput: t,
    onUserInput: r
  };
}
var cM = 3, lM = {
  bold: "mod+b",
  compose: ["down", "left", "right", "up", "backspace", "enter"],
  moveBackward: "left",
  moveForward: "right",
  moveWordBackward: "ctrl+left",
  moveWordForward: "ctrl+right",
  deleteBackward: "shift?+backspace",
  deleteForward: "shift?+delete",
  extendBackward: "shift+left",
  extendForward: "shift+right",
  italic: "mod+i",
  insertSoftBreak: "shift+enter",
  splitBlock: "enter",
  undo: "mod+z"
}, dM = {
  moveLineBackward: "opt+up",
  moveLineForward: "opt+down",
  moveWordBackward: "opt+left",
  moveWordForward: "opt+right",
  deleteBackward: ["ctrl+backspace", "ctrl+h"],
  deleteForward: ["ctrl+delete", "ctrl+d"],
  deleteLineBackward: "cmd+shift?+backspace",
  deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
  deleteWordBackward: "opt+shift?+backspace",
  deleteWordForward: "opt+shift?+delete",
  extendLineBackward: "opt+shift+up",
  extendLineForward: "opt+shift+down",
  redo: "cmd+shift+z",
  transposeCharacter: "ctrl+t"
}, gM = {
  deleteWordBackward: "ctrl+shift?+backspace",
  deleteWordForward: "ctrl+shift?+delete",
  redo: ["ctrl+y", "ctrl+shift+z"]
}, Oe = (e) => {
  var t = lM[e], n = dM[e], r = gM[e], a = t && Of(t), i = n && Of(n), o = r && Of(r);
  return (f) => !!(a && a(f) || Sd && i && i(f) || !Sd && o && o(f));
}, Ge = {
  isBold: Oe("bold"),
  isCompose: Oe("compose"),
  isMoveBackward: Oe("moveBackward"),
  isMoveForward: Oe("moveForward"),
  isDeleteBackward: Oe("deleteBackward"),
  isDeleteForward: Oe("deleteForward"),
  isDeleteLineBackward: Oe("deleteLineBackward"),
  isDeleteLineForward: Oe("deleteLineForward"),
  isDeleteWordBackward: Oe("deleteWordBackward"),
  isDeleteWordForward: Oe("deleteWordForward"),
  isExtendBackward: Oe("extendBackward"),
  isExtendForward: Oe("extendForward"),
  isExtendLineBackward: Oe("extendLineBackward"),
  isExtendLineForward: Oe("extendLineForward"),
  isItalic: Oe("italic"),
  isMoveLineBackward: Oe("moveLineBackward"),
  isMoveLineForward: Oe("moveLineForward"),
  isMoveWordBackward: Oe("moveWordBackward"),
  isMoveWordForward: Oe("moveWordForward"),
  isRedo: Oe("redo"),
  isSoftBreak: Oe("insertSoftBreak"),
  isSplitBlock: Oe("splitBlock"),
  isTransposeCharacter: Oe("transposeCharacter"),
  isUndo: Oe("undo")
}, pM = (e, t) => {
  var n = [], r = () => {
    n = [];
  }, a = (o) => {
    if (t.current) {
      var f = o.filter((s) => rc(e, s, o));
      n.push(...f);
    }
  };
  function i() {
    n.length > 0 && (n.reverse().forEach((o) => {
      o.type !== "characterData" && (o.removedNodes.forEach((f) => {
        o.target.insertBefore(f, o.nextSibling);
      }), o.addedNodes.forEach((f) => {
        o.target.removeChild(f);
      }));
    }), r());
  }
  return {
    registerMutations: a,
    restoreDOM: i,
    clear: r
  };
}, hM = {
  subtree: !0,
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0
};
class kg extends f1 {
  constructor() {
    super(...arguments), this.context = null, this.manager = null, this.mutationObserver = null;
  }
  observe() {
    var t, {
      node: n
    } = this.props;
    if (!n.current)
      throw new Error("Failed to attach MutationObserver, `node` is undefined");
    (t = this.mutationObserver) === null || t === void 0 || t.observe(n.current, hM);
  }
  componentDidMount() {
    var {
      receivedUserInput: t
    } = this.props, n = this.context;
    this.manager = pM(n, t), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
  }
  getSnapshotBeforeUpdate() {
    var t, n, r, a = (t = this.mutationObserver) === null || t === void 0 ? void 0 : t.takeRecords();
    if (a != null && a.length) {
      var i;
      (i = this.manager) === null || i === void 0 || i.registerMutations(a);
    }
    return (n = this.mutationObserver) === null || n === void 0 || n.disconnect(), (r = this.manager) === null || r === void 0 || r.restoreDOM(), null;
  }
  componentDidUpdate() {
    var t;
    (t = this.manager) === null || t === void 0 || t.clear(), this.observe();
  }
  componentWillUnmount() {
    var t;
    (t = this.mutationObserver) === null || t === void 0 || t.disconnect();
  }
  render() {
    return this.props.children;
  }
}
kg.contextType = qs;
var vM = vt ? kg : (e) => {
  var {
    children: t
  } = e;
  return /* @__PURE__ */ ae.createElement(ae.Fragment, null, t);
}, mM = ["autoFocus", "decorate", "onDOMBeforeInput", "placeholder", "readOnly", "renderElement", "renderLeaf", "renderPlaceholder", "scrollSelectionIntoView", "style", "as", "disableDefaultStyles"], wM = ["text"];
function Pd(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Lr(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Pd(Object(n), !0).forEach(function(r) {
      Go(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Pd(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var yM = (e) => /* @__PURE__ */ ae.createElement(ae.Fragment, null, Sg(e)), bM = (e) => {
  var t = pe((D) => /* @__PURE__ */ ae.createElement(CM, Object.assign({}, D)), []), {
    autoFocus: n,
    decorate: r = MM,
    onDOMBeforeInput: a,
    placeholder: i,
    readOnly: o = !1,
    renderElement: f,
    renderLeaf: s,
    renderPlaceholder: u = t,
    scrollSelectionIntoView: c = DM,
    style: d = {},
    as: g = "div",
    disableDefaultStyles: p = !1
  } = e, h = _r(e, mM), l = yt(), [w, m] = ie(!1), y = Ce(null), b = Ce([]), [C, M] = ie(), {
    onUserInput: S,
    receivedUserInput: I
  } = sM(), [, N] = Nv((D) => D + 1, 0);
  mg.set(l, N), Ru.set(l, o);
  var O = Lt(() => ({
    isDraggingInternally: !1,
    isUpdatingSelection: !1,
    latestElement: null,
    hasMarkPlaceholder: !1
  }), []);
  le(() => {
    y.current && n && y.current.focus();
  }, [n]);
  var F = Ce(), Q = Lt(() => s3(() => {
    var D = F.current;
    if ((vt || !G.isComposing(l)) && (!O.isUpdatingSelection || D != null && D.isFlushing()) && !O.isDraggingInternally) {
      var U = G.findDocumentOrShadowRoot(l), {
        activeElement: k
      } = U, Y = G.toDOMNode(l, l), V = U.getSelection();
      if (k === Y ? (O.latestElement = k, _n.set(l, !0)) : _n.delete(l), !V)
        return H.deselect(l);
      var {
        anchorNode: Z,
        focusNode: re
      } = V, ce = G.hasEditableTarget(l, Z) || G.isTargetInsideNonReadonlyVoid(l, Z), _ = G.hasEditableTarget(l, re) || G.isTargetInsideNonReadonlyVoid(l, re);
      if (ce && _) {
        var Le = G.toSlateRange(l, V, {
          exactMatch: !1,
          suppressThrow: !0
        });
        Le && (!G.isComposing(l) && !(D != null && D.hasPendingChanges()) && !(D != null && D.isFlushing()) ? H.select(l, Le) : D == null || D.handleUserSelect(Le));
      }
      o && (!ce || !_) && H.deselect(l);
    }
  }, 100), [l, o, O]), T = Lt(() => r3(Q, 0), [Q]);
  F.current = WC({
    node: y,
    onDOMSelectionChange: Q,
    scheduleOnDOMSelectionChange: T
  }), Ja(() => {
    var D, U, k;
    y.current && (k = nc(y.current)) ? (vg.set(l, k), Vi.set(l, y.current), Xn.set(l, y.current), Qa.set(y.current, l)) : Xn.delete(l);
    var {
      selection: Y
    } = l, V = G.findDocumentOrShadowRoot(l), Z = V.getSelection();
    if (!(!Z || !G.isFocused(l) || (D = F.current) !== null && D !== void 0 && D.hasPendingAction())) {
      var re = (he) => {
        var We = Z.type !== "None";
        if (!(!Y && !We)) {
          var Ke = Z.focusNode, Ue;
          if (Ta && Z.rangeCount > 1) {
            var bt = Z.getRangeAt(0), ne = Z.getRangeAt(Z.rangeCount - 1);
            bt.startContainer === Ke ? Ue = ne.endContainer : Ue = bt.startContainer;
          } else
            Ue = Z.anchorNode;
          var de = Vi.get(l), je = !1;
          if (de.contains(Ue) && de.contains(Ke) && (je = !0), We && je && Y && !he) {
            var ve = G.toSlateRange(l, Z, {
              exactMatch: !0,
              // domSelection is not necessarily a valid Slate range
              // (e.g. when clicking on contentEditable:false element)
              suppressThrow: !0
            });
            if (ve && z.equals(ve, Y)) {
              var Ye, Ze;
              if (!O.hasMarkPlaceholder || (Ye = Ue) !== null && Ye !== void 0 && (Ze = Ye.parentElement) !== null && Ze !== void 0 && Ze.hasAttribute("data-slate-mark-placeholder"))
                return;
            }
          }
          if (Y && !G.hasRange(l, Y)) {
            l.selection = G.toSlateRange(l, Z, {
              exactMatch: !1,
              suppressThrow: !0
            });
            return;
          }
          O.isUpdatingSelection = !0;
          var Ae = Y && G.toDOMRange(l, Y);
          return Ae ? (G.isComposing(l) && !vt ? Z.collapseToEnd() : z.isBackward(Y) ? Z.setBaseAndExtent(Ae.endContainer, Ae.endOffset, Ae.startContainer, Ae.startOffset) : Z.setBaseAndExtent(Ae.startContainer, Ae.startOffset, Ae.endContainer, Ae.endOffset), c(l, Ae)) : Z.removeAllRanges(), Ae;
        }
      };
      Z.rangeCount <= 1 && re();
      var ce = ((U = F.current) === null || U === void 0 ? void 0 : U.isFlushing()) === "action";
      if (!vt || !ce) {
        setTimeout(() => {
          O.isUpdatingSelection = !1;
        });
        return;
      }
      var _ = null, Le = requestAnimationFrame(() => {
        if (ce) {
          var he = (We) => {
            try {
              var Ke = G.toDOMNode(l, l);
              Ke.focus(), re(We);
            } catch {
            }
          };
          he(), _ = setTimeout(() => {
            he(!0), O.isUpdatingSelection = !1;
          });
        }
      });
      return () => {
        cancelAnimationFrame(Le), _ && clearTimeout(_);
      };
    }
  });
  var x = pe((D) => {
    if (S(), !o && G.hasEditableTarget(l, D.target) && !LM(D, a)) {
      var U;
      if (F.current)
        return F.current.handleDOMBeforeInput(D);
      T.flush(), Q.flush();
      var {
        selection: k
      } = l, {
        inputType: Y
      } = D, V = D.dataTransfer || D.data || void 0, Z = Y === "insertCompositionText" || Y === "deleteCompositionText";
      if (Z && G.isComposing(l))
        return;
      var re = !1;
      if (Y === "insertText" && k && z.isCollapsed(k) && // Only use native character insertion for single characters a-z or space for now.
      // Long-press events (hold a + press 4 = ä) to choose a special character otherwise
      // causes duplicate inserts.
      D.data && D.data.length === 1 && /[a-z ]/i.test(D.data) && // Chrome has issues correctly editing the start of nodes: https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
      // When there is an inline element, e.g. a link, and you select
      // right after it (the start of the next node).
      k.anchor.offset !== 0) {
        var ce, _;
        re = !0, l.marks && (re = !1);
        var {
          anchor: Le
        } = k, [he, We] = G.toDOMPoint(l, Le), Ke = (ce = he.parentElement) === null || ce === void 0 ? void 0 : ce.closest("a"), Ue = G.getWindow(l);
        if (re && Ke && G.hasDOMNode(l, Ke)) {
          var bt, ne = Ue == null ? void 0 : Ue.document.createTreeWalker(Ke, NodeFilter.SHOW_TEXT).lastChild();
          ne === he && ((bt = ne.textContent) === null || bt === void 0 ? void 0 : bt.length) === We && (re = !1);
        }
        if (re && he.parentElement && (Ue == null || (_ = Ue.getComputedStyle(he.parentElement)) === null || _ === void 0 ? void 0 : _.whiteSpace) === "pre") {
          var de = v.above(l, {
            at: Le.path,
            match: (Ct) => fe.isElement(Ct) && v.isBlock(l, Ct)
          });
          de && te.string(de[0]).includes("	") && (re = !1);
        }
      }
      if (!Y.startsWith("delete") || Y.startsWith("deleteBy")) {
        var [je] = D.getTargetRanges();
        if (je) {
          var ve = G.toSlateRange(l, je, {
            exactMatch: !1,
            suppressThrow: !1
          });
          if (!k || !z.equals(k, ve)) {
            re = !1;
            var Ye = !Z && l.selection && v.rangeRef(l, l.selection);
            H.select(l, ve), Ye && Na.set(l, Ye);
          }
        }
      }
      if (Z)
        return;
      if (re || D.preventDefault(), k && z.isExpanded(k) && Y.startsWith("delete")) {
        var Ze = Y.endsWith("Backward") ? "backward" : "forward";
        v.deleteFragment(l, {
          direction: Ze
        });
        return;
      }
      switch (Y) {
        case "deleteByComposition":
        case "deleteByCut":
        case "deleteByDrag": {
          v.deleteFragment(l);
          break;
        }
        case "deleteContent":
        case "deleteContentForward": {
          v.deleteForward(l);
          break;
        }
        case "deleteContentBackward": {
          v.deleteBackward(l);
          break;
        }
        case "deleteEntireSoftLine": {
          v.deleteBackward(l, {
            unit: "line"
          }), v.deleteForward(l, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineBackward": {
          v.deleteBackward(l, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineBackward": {
          v.deleteBackward(l, {
            unit: "line"
          });
          break;
        }
        case "deleteHardLineForward": {
          v.deleteForward(l, {
            unit: "block"
          });
          break;
        }
        case "deleteSoftLineForward": {
          v.deleteForward(l, {
            unit: "line"
          });
          break;
        }
        case "deleteWordBackward": {
          v.deleteBackward(l, {
            unit: "word"
          });
          break;
        }
        case "deleteWordForward": {
          v.deleteForward(l, {
            unit: "word"
          });
          break;
        }
        case "insertLineBreak":
          v.insertSoftBreak(l);
          break;
        case "insertParagraph": {
          v.insertBreak(l);
          break;
        }
        case "insertFromComposition":
        case "insertFromDrop":
        case "insertFromPaste":
        case "insertFromYank":
        case "insertReplacementText":
        case "insertText": {
          Y === "insertFromComposition" && G.isComposing(l) && (m(!1), Zn.set(l, !1)), (V == null ? void 0 : V.constructor.name) === "DataTransfer" ? G.insertData(l, V) : typeof V == "string" && (re ? b.current.push(() => v.insertText(l, V)) : v.insertText(l, V));
          break;
        }
      }
      var Ae = (U = Na.get(l)) === null || U === void 0 ? void 0 : U.unref();
      Na.delete(l), Ae && (!l.selection || !z.equals(l.selection, Ae)) && H.select(l, Ae);
    }
  }, [l, Q, S, a, o, T]), A = pe((D) => {
    D == null ? (Q.cancel(), T.cancel(), Vi.delete(l), Xn.delete(l), y.current && wn && y.current.removeEventListener("beforeinput", x)) : wn && D.addEventListener("beforeinput", x), y.current = D;
  }, [Q, T, l, x]);
  Ja(() => {
    var D = G.getWindow(l);
    return D.document.addEventListener("selectionchange", T), () => {
      D.document.removeEventListener("selectionchange", T);
    };
  }, [T]);
  var B = r([l, []]), J = i && l.children.length === 1 && Array.from(te.texts(l)).length === 1 && te.string(l) === "" && !w, $ = pe((D) => {
    if (D && J) {
      var U;
      M((U = D.getBoundingClientRect()) === null || U === void 0 ? void 0 : U.height);
    } else
      M(void 0);
  }, [J]);
  if (J) {
    var q = v.start(l, []);
    B.push({
      [Zr]: !0,
      placeholder: i,
      onPlaceholderResize: $,
      anchor: q,
      focus: q
    });
  }
  var {
    marks: K
  } = l;
  if (O.hasMarkPlaceholder = !1, l.selection && z.isCollapsed(l.selection) && K) {
    var {
      anchor: P
    } = l.selection, R = te.leaf(l, P.path), W = _r(R, wM);
    if (!se.equals(R, K, {
      loose: !0
    })) {
      O.hasMarkPlaceholder = !0;
      var X = Object.fromEntries(Object.keys(W).map((D) => [D, null]));
      B.push(Lr(Lr(Lr({
        [wg]: !0
      }, X), K), {}, {
        anchor: P,
        focus: P
      }));
    }
  }
  return le(() => {
    setTimeout(() => {
      var {
        selection: D
      } = l;
      if (D) {
        var {
          anchor: U
        } = D, k = te.leaf(l, U.path);
        if (K && !se.equals(k, K, {
          loose: !0
        })) {
          Yt.set(l, K);
          return;
        }
      }
      Yt.delete(l);
    });
  }), /* @__PURE__ */ ae.createElement(xg.Provider, {
    value: o
  }, /* @__PURE__ */ ae.createElement(Eg.Provider, {
    value: r
  }, /* @__PURE__ */ ae.createElement(vM, {
    node: y,
    receivedUserInput: I
  }, /* @__PURE__ */ ae.createElement(g, Object.assign({
    role: o ? void 0 : "textbox",
    "aria-multiline": o ? void 0 : !0
  }, h, {
    // COMPAT: Certain browsers don't support the `beforeinput` event, so we'd
    // have to use hacks to make these replacement-based features work.
    // For SSR situations HAS_BEFORE_INPUT_SUPPORT is false and results in prop
    // mismatch warning app moves to browser. Pass-through consumer props when
    // not CAN_USE_DOM (SSR) and default to falsy value
    spellCheck: wn || !$i ? h.spellCheck : !1,
    autoCorrect: wn || !$i ? h.autoCorrect : "false",
    autoCapitalize: wn || !$i ? h.autoCapitalize : "false",
    "data-slate-editor": !0,
    "data-slate-node": "value",
    // explicitly set this
    contentEditable: !o,
    // in some cases, a decoration needs access to the range / selection to decorate a text node,
    // then you will select the whole text node when you select part the of text
    // this magic zIndex="-1" will fix it
    zindex: -1,
    suppressContentEditableWarning: !0,
    ref: A,
    style: Lr(Lr({}, p ? {} : Lr({
      // Allow positioning relative to the editable element.
      position: "relative",
      // Preserve adjacent whitespace and new lines.
      whiteSpace: "pre-wrap",
      // Allow words to break if they are too long.
      wordWrap: "break-word"
    }, C ? {
      minHeight: C
    } : {})), d),
    onBeforeInput: pe((D) => {
      if (!wn && !o && !ut(D, h.onBeforeInput) && G.hasSelectableTarget(l, D.target) && (D.preventDefault(), !G.isComposing(l))) {
        var U = D.data;
        v.insertText(l, U);
      }
    }, [h.onBeforeInput, l, o]),
    onInput: pe((D) => {
      if (!ut(D, h.onInput)) {
        if (F.current) {
          F.current.handleInput();
          return;
        }
        for (var U of b.current)
          U();
        b.current = [];
      }
    }, [h.onInput]),
    onBlur: pe((D) => {
      if (!(o || O.isUpdatingSelection || !G.hasSelectableTarget(l, D.target) || ut(D, h.onBlur))) {
        var U = G.findDocumentOrShadowRoot(l);
        if (O.latestElement !== U.activeElement) {
          var {
            relatedTarget: k
          } = D, Y = G.toDOMNode(l, l);
          if (k !== Y && !(Nt(k) && k.hasAttribute("data-slate-spacer"))) {
            if (k != null && Tn(k) && G.hasDOMNode(l, k)) {
              var V = G.toSlateNode(l, k);
              if (fe.isElement(V) && !l.isVoid(V))
                return;
            }
            if (ja) {
              var Z = U.getSelection();
              Z == null || Z.removeAllRanges();
            }
            _n.delete(l);
          }
        }
      }
    }, [o, O.isUpdatingSelection, O.latestElement, l, h.onBlur]),
    onClick: pe((D) => {
      if (G.hasTarget(l, D.target) && !ut(D, h.onClick) && Tn(D.target)) {
        var U = G.toSlateNode(l, D.target), k = G.findPath(l, U);
        if (!v.hasPath(l, k) || te.get(l, k) !== U)
          return;
        if (D.detail === cM && k.length >= 1) {
          var Y = k;
          if (!(fe.isElement(U) && v.isBlock(l, U))) {
            var V, Z = v.above(l, {
              match: (Ke) => fe.isElement(Ke) && v.isBlock(l, Ke),
              at: k
            });
            Y = (V = Z == null ? void 0 : Z[1]) !== null && V !== void 0 ? V : k.slice(0, 1);
          }
          var re = v.range(l, Y);
          H.select(l, re);
          return;
        }
        if (o)
          return;
        var ce = v.start(l, k), _ = v.end(l, k), Le = v.void(l, {
          at: ce
        }), he = v.void(l, {
          at: _
        });
        if (Le && he && j.equals(Le[1], he[1])) {
          var We = v.range(l, ce);
          H.select(l, We);
        }
      }
    }, [l, h.onClick, o]),
    onCompositionEnd: pe((D) => {
      if (G.hasSelectableTarget(l, D.target)) {
        var U;
        if (G.isComposing(l) && (m(!1), Zn.set(l, !1)), (U = F.current) === null || U === void 0 || U.handleCompositionEnd(D), ut(D, h.onCompositionEnd) || vt)
          return;
        if (!ja && !mC && !gC && !yC && !wC && D.data) {
          var k = Yt.get(l);
          Yt.delete(l), k !== void 0 && (un.set(l, l.marks), l.marks = k), v.insertText(l, D.data);
          var Y = un.get(l);
          un.delete(l), Y !== void 0 && (l.marks = Y);
        }
      }
    }, [h.onCompositionEnd, l]),
    onCompositionUpdate: pe((D) => {
      G.hasSelectableTarget(l, D.target) && !ut(D, h.onCompositionUpdate) && (G.isComposing(l) || (m(!0), Zn.set(l, !0)));
    }, [h.onCompositionUpdate, l]),
    onCompositionStart: pe((D) => {
      if (G.hasSelectableTarget(l, D.target)) {
        var U;
        if ((U = F.current) === null || U === void 0 || U.handleCompositionStart(D), ut(D, h.onCompositionStart) || vt)
          return;
        m(!0);
        var {
          selection: k
        } = l;
        if (k) {
          if (z.isExpanded(k)) {
            v.deleteFragment(l);
            return;
          }
          var Y = v.above(l, {
            match: (re) => fe.isElement(re) && v.isInline(l, re),
            mode: "highest"
          });
          if (Y) {
            var [, V] = Y;
            if (v.isEnd(l, k.anchor, V)) {
              var Z = v.after(l, V);
              H.setSelection(l, {
                anchor: Z,
                focus: Z
              });
            }
          }
        }
      }
    }, [h.onCompositionStart, l]),
    onCopy: pe((D) => {
      G.hasSelectableTarget(l, D.target) && !ut(D, h.onCopy) && !zd(D) && (D.preventDefault(), G.setFragmentData(l, D.clipboardData, "copy"));
    }, [h.onCopy, l]),
    onCut: pe((D) => {
      if (!o && G.hasSelectableTarget(l, D.target) && !ut(D, h.onCut) && !zd(D)) {
        D.preventDefault(), G.setFragmentData(l, D.clipboardData, "cut");
        var {
          selection: U
        } = l;
        if (U)
          if (z.isExpanded(U))
            v.deleteFragment(l);
          else {
            var k = te.parent(l, U.anchor.path);
            v.isVoid(l, k) && H.delete(l);
          }
      }
    }, [o, l, h.onCut]),
    onDragOver: pe((D) => {
      if (G.hasTarget(l, D.target) && !ut(D, h.onDragOver)) {
        var U = G.toSlateNode(l, D.target);
        fe.isElement(U) && v.isVoid(l, U) && D.preventDefault();
      }
    }, [h.onDragOver, l]),
    onDragStart: pe((D) => {
      if (!o && G.hasTarget(l, D.target) && !ut(D, h.onDragStart)) {
        var U = G.toSlateNode(l, D.target), k = G.findPath(l, U), Y = fe.isElement(U) && v.isVoid(l, U) || v.void(l, {
          at: k,
          voids: !0
        });
        if (Y) {
          var V = v.range(l, k);
          H.select(l, V);
        }
        O.isDraggingInternally = !0, G.setFragmentData(l, D.dataTransfer, "drag");
      }
    }, [o, l, h.onDragStart, O]),
    onDrop: pe((D) => {
      if (!o && G.hasTarget(l, D.target) && !ut(D, h.onDrop)) {
        D.preventDefault();
        var U = l.selection, k = G.findEventRange(l, D), Y = D.dataTransfer;
        H.select(l, k), O.isDraggingInternally && U && !z.equals(U, k) && !v.void(l, {
          at: k,
          voids: !0
        }) && H.delete(l, {
          at: U
        }), G.insertData(l, Y), G.isFocused(l) || G.focus(l);
      }
      O.isDraggingInternally = !1;
    }, [o, l, h.onDrop, O]),
    onDragEnd: pe((D) => {
      !o && O.isDraggingInternally && h.onDragEnd && G.hasTarget(l, D.target) && h.onDragEnd(D), O.isDraggingInternally = !1;
    }, [o, O, h, l]),
    onFocus: pe((D) => {
      if (!o && !O.isUpdatingSelection && G.hasEditableTarget(l, D.target) && !ut(D, h.onFocus)) {
        var U = G.toDOMNode(l, l), k = G.findDocumentOrShadowRoot(l);
        if (O.latestElement = k.activeElement, Ta && D.target !== U) {
          U.focus();
          return;
        }
        _n.set(l, !0);
      }
    }, [o, O, l, h.onFocus]),
    onKeyDown: pe((D) => {
      if (!o && G.hasEditableTarget(l, D.target)) {
        var U;
        (U = F.current) === null || U === void 0 || U.handleKeyDown(D);
        var {
          nativeEvent: k
        } = D;
        if (G.isComposing(l) && k.isComposing === !1 && (Zn.set(l, !1), m(!1)), ut(D, h.onKeyDown) || G.isComposing(l))
          return;
        var {
          selection: Y
        } = l, V = l.children[Y !== null ? Y.focus.path[0] : 0], Z = _1(te.string(V)) === "rtl";
        if (Ge.isRedo(k)) {
          D.preventDefault();
          var re = l;
          typeof re.redo == "function" && re.redo();
          return;
        }
        if (Ge.isUndo(k)) {
          D.preventDefault();
          var ce = l;
          typeof ce.undo == "function" && ce.undo();
          return;
        }
        if (Ge.isMoveLineBackward(k)) {
          D.preventDefault(), H.move(l, {
            unit: "line",
            reverse: !0
          });
          return;
        }
        if (Ge.isMoveLineForward(k)) {
          D.preventDefault(), H.move(l, {
            unit: "line"
          });
          return;
        }
        if (Ge.isExtendLineBackward(k)) {
          D.preventDefault(), H.move(l, {
            unit: "line",
            edge: "focus",
            reverse: !0
          });
          return;
        }
        if (Ge.isExtendLineForward(k)) {
          D.preventDefault(), H.move(l, {
            unit: "line",
            edge: "focus"
          });
          return;
        }
        if (Ge.isMoveBackward(k)) {
          D.preventDefault(), Y && z.isCollapsed(Y) ? H.move(l, {
            reverse: !Z
          }) : H.collapse(l, {
            edge: "start"
          });
          return;
        }
        if (Ge.isMoveForward(k)) {
          D.preventDefault(), Y && z.isCollapsed(Y) ? H.move(l, {
            reverse: Z
          }) : H.collapse(l, {
            edge: "end"
          });
          return;
        }
        if (Ge.isMoveWordBackward(k)) {
          D.preventDefault(), Y && z.isExpanded(Y) && H.collapse(l, {
            edge: "focus"
          }), H.move(l, {
            unit: "word",
            reverse: !Z
          });
          return;
        }
        if (Ge.isMoveWordForward(k)) {
          D.preventDefault(), Y && z.isExpanded(Y) && H.collapse(l, {
            edge: "focus"
          }), H.move(l, {
            unit: "word",
            reverse: Z
          });
          return;
        }
        if (wn) {
          if ((hg || ja) && Y && (Ge.isDeleteBackward(k) || Ge.isDeleteForward(k)) && z.isCollapsed(Y)) {
            var _ = te.parent(l, Y.anchor.path);
            if (fe.isElement(_) && v.isVoid(l, _) && (v.isInline(l, _) || v.isBlock(l, _))) {
              D.preventDefault(), v.deleteBackward(l, {
                unit: "block"
              });
              return;
            }
          }
        } else {
          if (Ge.isBold(k) || Ge.isItalic(k) || Ge.isTransposeCharacter(k)) {
            D.preventDefault();
            return;
          }
          if (Ge.isSoftBreak(k)) {
            D.preventDefault(), v.insertSoftBreak(l);
            return;
          }
          if (Ge.isSplitBlock(k)) {
            D.preventDefault(), v.insertBreak(l);
            return;
          }
          if (Ge.isDeleteBackward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "backward"
            }) : v.deleteBackward(l);
            return;
          }
          if (Ge.isDeleteForward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "forward"
            }) : v.deleteForward(l);
            return;
          }
          if (Ge.isDeleteLineBackward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "backward"
            }) : v.deleteBackward(l, {
              unit: "line"
            });
            return;
          }
          if (Ge.isDeleteLineForward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "forward"
            }) : v.deleteForward(l, {
              unit: "line"
            });
            return;
          }
          if (Ge.isDeleteWordBackward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "backward"
            }) : v.deleteBackward(l, {
              unit: "word"
            });
            return;
          }
          if (Ge.isDeleteWordForward(k)) {
            D.preventDefault(), Y && z.isExpanded(Y) ? v.deleteFragment(l, {
              direction: "forward"
            }) : v.deleteForward(l, {
              unit: "word"
            });
            return;
          }
        }
      }
    }, [o, l, h.onKeyDown]),
    onPaste: pe((D) => {
      !o && G.hasEditableTarget(l, D.target) && !ut(D, h.onPaste) && (!wn || MC(D.nativeEvent) || ja) && (D.preventDefault(), G.insertData(l, D.clipboardData));
    }, [o, l, h.onPaste])
  }), /* @__PURE__ */ ae.createElement(yM, {
    decorations: B,
    node: l,
    renderElement: f,
    renderPlaceholder: u,
    renderLeaf: s,
    selection: l.selection
  })))));
}, CM = (e) => {
  var {
    attributes: t,
    children: n
  } = e;
  return (
    // COMPAT: Artificially add a line-break to the end on the placeholder element
    // to prevent Android IMEs to pick up its content in autocorrect and to auto-capitalize the first letter
    /* @__PURE__ */ ae.createElement("span", Object.assign({}, t), n, vt && /* @__PURE__ */ ae.createElement("br", null))
  );
}, MM = () => [], DM = (e, t) => {
  if (t.getBoundingClientRect && (!e.selection || e.selection && z.isCollapsed(e.selection))) {
    var n = t.startContainer.parentElement;
    n.getBoundingClientRect = t.getBoundingClientRect.bind(t), d3(n, {
      scrollMode: "if-needed"
    }), delete n.getBoundingClientRect;
  }
}, ut = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? (e.isDefaultPrevented() || e.isPropagationStopped());
}, zd = (e) => Tn(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement), LM = (e, t) => {
  if (!t)
    return !1;
  var n = t(e);
  return n ?? e.defaultPrevented;
}, Bg = /* @__PURE__ */ tn(!1), Og = () => Ve(Bg), AM = /* @__PURE__ */ tn({});
function EM(e) {
  var t = Ce([]).current, n = Ce({
    editor: e
  }).current, r = pe((i) => {
    n.editor = i, t.forEach((o) => o(i));
  }, [t, n]), a = Lt(() => ({
    getSlate: () => n.editor,
    addEventListener: (i) => (t.push(i), () => {
      t.splice(t.indexOf(i), 1);
    })
  }), [t, n]);
  return {
    selectorContext: a,
    onChange: r
  };
}
var jM = ["editor", "children", "onChange", "initialValue"], IM = (e) => {
  var {
    editor: t,
    children: n,
    onChange: r,
    initialValue: a
  } = e, i = _r(e, jM), [o, f] = ae.useState(() => {
    if (!te.isNodeList(a))
      throw new Error("[Slate] initialValue is invalid! Expected a list of elements but got: ".concat(qe.stringify(a)));
    if (!v.isEditor(t))
      throw new Error("[Slate] editor is invalid! You passed: ".concat(qe.stringify(t)));
    return t.children = a, Object.assign(t, i), {
      v: 0,
      editor: t
    };
  }), {
    selectorContext: s,
    onChange: u
  } = EM(t), c = pe(() => {
    r && r(t.children), f((p) => ({
      v: p.v + 1,
      editor: t
    })), u(t);
  }, [t, u, r]);
  le(() => (Fu.set(t, c), () => {
    Fu.set(t, () => {
    });
  }), [t, c]);
  var [d, g] = ie(G.isFocused(t));
  return le(() => {
    g(G.isFocused(t));
  }, [t]), Ja(() => {
    var p = () => g(G.isFocused(t));
    return pg >= 17 ? (document.addEventListener("focusin", p), document.addEventListener("focusout", p), () => {
      document.removeEventListener("focusin", p), document.removeEventListener("focusout", p);
    }) : (document.addEventListener("focus", p, !0), document.addEventListener("blur", p, !0), () => {
      document.removeEventListener("focus", p, !0), document.removeEventListener("blur", p, !0);
    });
  }, []), /* @__PURE__ */ ae.createElement(AM.Provider, {
    value: s
  }, /* @__PURE__ */ ae.createElement(Ng.Provider, {
    value: o
  }, /* @__PURE__ */ ae.createElement(qs.Provider, {
    value: o.editor
  }, /* @__PURE__ */ ae.createElement(Bg.Provider, {
    value: d
  }, n))));
}, Rd = (e, t) => {
  var n = (t.top + t.bottom) / 2;
  return e.top <= n && e.bottom >= n;
}, Fd = (e, t, n) => {
  var r = G.toDOMRange(e, t).getBoundingClientRect(), a = G.toDOMRange(e, n).getBoundingClientRect();
  return Rd(r, a) && Rd(a, r);
}, SM = (e, t) => {
  var n = v.range(e, z.end(t)), r = Array.from(v.positions(e, {
    at: t
  })), a = 0, i = r.length, o = Math.floor(i / 2);
  if (Fd(e, v.range(e, r[a]), n))
    return v.range(e, r[a], n);
  if (r.length < 2)
    return v.range(e, r[r.length - 1], n);
  for (; o !== r.length && o !== a; )
    Fd(e, v.range(e, r[o]), n) ? i = o : a = o, o = Math.floor((a + i) / 2);
  return v.range(e, r[i], n);
};
function Ud(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Yd(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ud(Object(n), !0).forEach(function(r) {
      Go(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ud(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var xM = function(t) {
  var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", r = t, {
    apply: a,
    onChange: i,
    deleteBackward: o,
    addMark: f,
    removeMark: s
  } = r;
  return Ho.set(r, /* @__PURE__ */ new WeakMap()), r.addMark = (u, c) => {
    var d, g;
    (d = tc.get(r)) === null || d === void 0 || d(), !Yt.get(r) && (g = pt.get(r)) !== null && g !== void 0 && g.length && Yt.set(r, null), un.delete(r), f(u, c);
  }, r.removeMark = (u) => {
    var c;
    !Yt.get(r) && (c = pt.get(r)) !== null && c !== void 0 && c.length && Yt.set(r, null), un.delete(r), s(u);
  }, r.deleteBackward = (u) => {
    if (u !== "line")
      return o(u);
    if (r.selection && z.isCollapsed(r.selection)) {
      var c = v.above(r, {
        match: (h) => fe.isElement(h) && v.isBlock(r, h),
        at: r.selection
      });
      if (c) {
        var [, d] = c, g = v.range(r, d, r.selection.anchor), p = SM(r, g);
        z.isCollapsed(p) || H.delete(r, {
          at: p
        });
      }
    }
  }, r.apply = (u) => {
    var c = [], d = pt.get(r);
    if (d != null && d.length) {
      var g = d.map((S) => OC(S, u)).filter(Boolean);
      pt.set(r, g);
    }
    var p = jn.get(r);
    p && jn.set(r, Td(r, p, u));
    var h = En.get(r);
    if (h != null && h.at) {
      var l = be.isPoint(h == null ? void 0 : h.at) ? Gu(r, h.at, u) : Td(r, h.at, u);
      En.set(r, l ? Yd(Yd({}, h), {}, {
        at: l
      }) : null);
    }
    switch (u.type) {
      case "insert_text":
      case "remove_text":
      case "set_node":
      case "split_node": {
        c.push(...Ni(r, u.path));
        break;
      }
      case "set_selection": {
        var w;
        (w = Na.get(r)) === null || w === void 0 || w.unref(), Na.delete(r);
        break;
      }
      case "insert_node":
      case "remove_node": {
        c.push(...Ni(r, j.parent(u.path)));
        break;
      }
      case "merge_node": {
        var m = j.previous(u.path);
        c.push(...Ni(r, m));
        break;
      }
      case "move_node": {
        var y = j.common(j.parent(u.path), j.parent(u.newPath));
        c.push(...Ni(r, y));
        break;
      }
    }
    a(u);
    for (var [b, C] of c) {
      var [M] = v.node(r, b);
      zu.set(M, C);
    }
  }, r.setFragmentData = (u) => {
    var {
      selection: c
    } = r;
    if (c) {
      var [d, g] = z.edges(c), p = v.void(r, {
        at: d.path
      }), h = v.void(r, {
        at: g.path
      });
      if (!(z.isCollapsed(c) && !p)) {
        var l = G.toDOMRange(r, c), w = l.cloneContents(), m = w.childNodes[0];
        if (w.childNodes.forEach((F) => {
          F.textContent && F.textContent.trim() !== "" && (m = F);
        }), h) {
          var [y] = h, b = l.cloneRange(), C = G.toDOMNode(r, y);
          b.setEndAfter(C), w = b.cloneContents();
        }
        if (p && (m = w.querySelector("[data-slate-spacer]")), Array.from(w.querySelectorAll("[data-slate-zero-width]")).forEach((F) => {
          var Q = F.getAttribute("data-slate-zero-width") === "n";
          F.textContent = Q ? `
` : "";
        }), yg(m)) {
          var M = m.ownerDocument.createElement("span");
          M.style.whiteSpace = "pre", M.appendChild(m), w.appendChild(M), m = M;
        }
        var S = r.getFragment(), I = JSON.stringify(S), N = window.btoa(encodeURIComponent(I));
        m.setAttribute("data-slate-fragment", N), u.setData("application/".concat(n), N);
        var O = w.ownerDocument.createElement("div");
        return O.appendChild(w), O.setAttribute("hidden", "true"), w.ownerDocument.body.appendChild(O), u.setData("text/html", O.innerHTML), u.setData("text/plain", Cg(O)), w.ownerDocument.body.removeChild(O), u;
      }
    }
  }, r.insertData = (u) => {
    r.insertFragmentData(u) || r.insertTextData(u);
  }, r.insertFragmentData = (u) => {
    var c = u.getData("application/".concat(n)) || jC(u);
    if (c) {
      var d = decodeURIComponent(window.atob(c)), g = JSON.parse(d);
      return r.insertFragment(g), !0;
    }
    return !1;
  }, r.insertTextData = (u) => {
    var c = u.getData("text/plain");
    if (c) {
      var d = c.split(/\r\n|\r|\n/), g = !1;
      for (var p of d)
        g && H.splitNodes(r, {
          always: !0
        }), r.insertText(p), g = !0;
      return !0;
    }
    return !1;
  }, r.onChange = (u) => {
    var c = pg < 18 ? ws.unstable_batchedUpdates : (d) => d();
    c(() => {
      var d = Fu.get(r);
      d && d(), i(u);
    });
  }, r;
}, Ni = (e, t) => {
  var n = [];
  for (var [r, a] of v.levels(e, {
    at: t
  })) {
    var i = G.findKey(e, r);
    n.push([a, i]);
  }
  return n;
};
const vo = "align", Wa = "type", TM = "paragraph", NM = "heading-one", kM = "heading-two", Pg = "list-item", ac = "numbered-list", BM = "block-quote", ic = "bulleted-list", ka = "mention", Ba = "emoji", zg = "left", Rg = "center", Fg = "right", Ug = "justify", Hu = "bold", Qu = "italic", Gd = "underline", Hd = "code", Ju = "strikethrough", Qd = "subscript", Jd = "superscript", Oa = "fontSize", zr = "fontFamily", Pa = "fontColor", Yg = "link", Gg = "button", Ki = "variable", qi = "media", oc = ({
  children: e,
  leaf: t
}) => (Hu in t && t[Hu] && (e = /* @__PURE__ */ E("strong", { children: e })), Hd in t && t[Hd] && (e = /* @__PURE__ */ E("code", { children: e })), Qu in t && t[Qu] && (e = /* @__PURE__ */ E("em", { children: e })), Gd in t && t[Gd] && (e = /* @__PURE__ */ E("u", { children: e })), Ju in t && t[Ju] && (e = /* @__PURE__ */ E("s", { children: e })), Qd in t && t[Qd] && (e = /* @__PURE__ */ E("sub", { children: e })), Jd in t && t[Jd] && (e = /* @__PURE__ */ E("sup", { children: e })), zr in t && t[zr] && (e = /* @__PURE__ */ E("span", { style: { fontFamily: t[zr] }, children: e })), Oa in t && t[Oa] && (e = /* @__PURE__ */ E("span", { style: { fontSize: `${t[Oa]}px` }, children: e })), Pa in t && t[Pa] && (e = /* @__PURE__ */ E("span", { style: { color: t[Pa] }, children: e })), e), OM = ({ attributes: e, children: t, leaf: n }) => /* @__PURE__ */ E("span", { ...e, children: /* @__PURE__ */ E(oc, { leaf: n, children: t }) }), fc = "-";
function PM(e) {
  const t = RM(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  function a(o) {
    const f = o.split(fc);
    return f[0] === "" && f.length !== 1 && f.shift(), Hg(f, t) || zM(o);
  }
  function i(o, f) {
    const s = n[o] || [];
    return f && r[o] ? [...s, ...r[o]] : s;
  }
  return {
    getClassGroupId: a,
    getConflictingClassGroupIds: i
  };
}
function Hg(e, t) {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), a = r ? Hg(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length === 0)
    return;
  const i = e.join(fc);
  return (o = t.validators.find(({
    validator: f
  }) => f(i))) == null ? void 0 : o.classGroupId;
}
const Wd = /^\[(.+)\]$/;
function zM(e) {
  if (Wd.test(e)) {
    const t = Wd.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function RM(e) {
  const {
    theme: t,
    prefix: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return UM(Object.entries(e.classGroups), n).forEach(([i, o]) => {
    Wu(o, r, i, t);
  }), r;
}
function Wu(e, t, n, r) {
  e.forEach((a) => {
    if (typeof a == "string") {
      const i = a === "" ? t : _d(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (FM(a)) {
        Wu(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(([i, o]) => {
      Wu(o, _d(t, i), n, r);
    });
  });
}
function _d(e, t) {
  let n = e;
  return t.split(fc).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function FM(e) {
  return e.isThemeGetter;
}
function UM(e, t) {
  return t ? e.map(([n, r]) => {
    const a = r.map((i) => typeof i == "string" ? t + i : typeof i == "object" ? Object.fromEntries(Object.entries(i).map(([o, f]) => [t + o, f])) : i);
    return [n, a];
  }) : e;
}
function YM(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function a(i, o) {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get(i) {
      let o = n.get(i);
      if (o !== void 0)
        return o;
      if ((o = r.get(i)) !== void 0)
        return a(i, o), o;
    },
    set(i, o) {
      n.has(i) ? n.set(i, o) : a(i, o);
    }
  };
}
const Qg = "!";
function GM(e) {
  const t = e.separator, n = t.length === 1, r = t[0], a = t.length;
  return function(o) {
    const f = [];
    let s = 0, u = 0, c;
    for (let l = 0; l < o.length; l++) {
      let w = o[l];
      if (s === 0) {
        if (w === r && (n || o.slice(l, l + a) === t)) {
          f.push(o.slice(u, l)), u = l + a;
          continue;
        }
        if (w === "/") {
          c = l;
          continue;
        }
      }
      w === "[" ? s++ : w === "]" && s--;
    }
    const d = f.length === 0 ? o : o.substring(u), g = d.startsWith(Qg), p = g ? d.substring(1) : d, h = c && c > u ? c - u : void 0;
    return {
      modifiers: f,
      hasImportantModifier: g,
      baseClassName: p,
      maybePostfixModifierPosition: h
    };
  };
}
function HM(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let n = [];
  return e.forEach((r) => {
    r[0] === "[" ? (t.push(...n.sort(), r), n = []) : n.push(r);
  }), t.push(...n.sort()), t;
}
function QM(e) {
  return {
    cache: YM(e.cacheSize),
    splitModifiers: GM(e),
    ...PM(e)
  };
}
const JM = /\s+/;
function WM(e, t) {
  const {
    splitModifiers: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: a
  } = t, i = /* @__PURE__ */ new Set();
  return e.trim().split(JM).map((o) => {
    const {
      modifiers: f,
      hasImportantModifier: s,
      baseClassName: u,
      maybePostfixModifierPosition: c
    } = n(o);
    let d = r(c ? u.substring(0, c) : u), g = !!c;
    if (!d) {
      if (!c)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (d = r(u), !d)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      g = !1;
    }
    const p = HM(f).join(":");
    return {
      isTailwindClass: !0,
      modifierId: s ? p + Qg : p,
      classGroupId: d,
      originalClassName: o,
      hasPostfixModifier: g
    };
  }).reverse().filter((o) => {
    if (!o.isTailwindClass)
      return !0;
    const {
      modifierId: f,
      classGroupId: s,
      hasPostfixModifier: u
    } = o, c = f + s;
    return i.has(c) ? !1 : (i.add(c), a(s, u).forEach((d) => i.add(f + d)), !0);
  }).reverse().map((o) => o.originalClassName).join(" ");
}
function _M() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Jg(t)) && (r && (r += " "), r += n);
  return r;
}
function Jg(e) {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Jg(e[r])) && (n && (n += " "), n += t);
  return n;
}
function ZM(e, ...t) {
  let n, r, a, i = o;
  function o(s) {
    const u = t.reduce((c, d) => d(c), e());
    return n = QM(u), r = n.cache.get, a = n.cache.set, i = f, f(s);
  }
  function f(s) {
    const u = r(s);
    if (u)
      return u;
    const c = WM(s, n);
    return a(s, c), c;
  }
  return function() {
    return i(_M.apply(null, arguments));
  };
}
function Ne(e) {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}
const Wg = /^\[(?:([a-z-]+):)?(.+)\]$/i, $M = /^\d+\/\d+$/, VM = /* @__PURE__ */ new Set(["px", "full", "screen"]), KM = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, qM = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, XM = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, e6 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function zt(e) {
  return $n(e) || VM.has(e) || $M.test(e);
}
function yn(e) {
  return ua(e, "length", u6);
}
function $n(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ki(e) {
  return ua(e, "number", $n);
}
function ba(e) {
  return !!e && Number.isInteger(Number(e));
}
function t6(e) {
  return e.endsWith("%") && $n(e.slice(0, -1));
}
function ye(e) {
  return Wg.test(e);
}
function bn(e) {
  return KM.test(e);
}
const n6 = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function r6(e) {
  return ua(e, n6, _g);
}
function a6(e) {
  return ua(e, "position", _g);
}
const i6 = /* @__PURE__ */ new Set(["image", "url"]);
function o6(e) {
  return ua(e, i6, c6);
}
function f6(e) {
  return ua(e, "", s6);
}
function Ca() {
  return !0;
}
function ua(e, t, n) {
  const r = Wg.exec(e);
  return r ? r[1] ? typeof t == "string" ? r[1] === t : t.has(r[1]) : n(r[2]) : !1;
}
function u6(e) {
  return qM.test(e);
}
function _g() {
  return !1;
}
function s6(e) {
  return XM.test(e);
}
function c6(e) {
  return e6.test(e);
}
function l6() {
  const e = Ne("colors"), t = Ne("spacing"), n = Ne("blur"), r = Ne("brightness"), a = Ne("borderColor"), i = Ne("borderRadius"), o = Ne("borderSpacing"), f = Ne("borderWidth"), s = Ne("contrast"), u = Ne("grayscale"), c = Ne("hueRotate"), d = Ne("invert"), g = Ne("gap"), p = Ne("gradientColorStops"), h = Ne("gradientColorStopPositions"), l = Ne("inset"), w = Ne("margin"), m = Ne("opacity"), y = Ne("padding"), b = Ne("saturate"), C = Ne("scale"), M = Ne("sepia"), S = Ne("skew"), I = Ne("space"), N = Ne("translate"), O = () => ["auto", "contain", "none"], F = () => ["auto", "hidden", "clip", "visible", "scroll"], Q = () => ["auto", ye, t], T = () => [ye, t], x = () => ["", zt, yn], A = () => ["auto", $n, ye], B = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], J = () => ["solid", "dashed", "dotted", "double", "none"], $ = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"], q = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], K = () => ["", "0", ye], P = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], R = () => [$n, ki], W = () => [$n, ye];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Ca],
      spacing: [zt, yn],
      blur: ["none", "", bn, ye],
      brightness: R(),
      borderColor: [e],
      borderRadius: ["none", "", "full", bn, ye],
      borderSpacing: T(),
      borderWidth: x(),
      contrast: R(),
      grayscale: K(),
      hueRotate: W(),
      invert: K(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [t6, yn],
      inset: Q(),
      margin: Q(),
      opacity: R(),
      padding: T(),
      saturate: R(),
      scale: R(),
      sepia: K(),
      skew: W(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", ye]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [bn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": P()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": P()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...B(), ye]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: F()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": F()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": F()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: O()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": O()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": O()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [l]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [l]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [l]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [l]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [l]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [l]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [l]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [l]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [l]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", ba, ye]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: Q()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", ye]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: K()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: K()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", ba, ye]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Ca]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", ba, ye]
        }, ye]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": A()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": A()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Ca]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [ba, ye]
        }, ye]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": A()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": A()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", ye]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", ye]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...q()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...q(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...q(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [y]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [y]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [y]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [y]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [y]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [y]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [y]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [y]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [y]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [w]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [w]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [w]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [w]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [w]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [w]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [w]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [w]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [w]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [I]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [I]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", ye, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", ye, zt]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [bn]
        }, bn, ye]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [ye, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", zt, ye]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [ye, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", bn, yn]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ki]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ca]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", ye]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", $n, ki]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", zt, ye]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", ye]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", ye]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [m]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [m]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...J(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", zt, yn]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", zt, ye]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", ye]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", ye]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [m]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...B(), a6]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", r6]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, o6]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [h]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [h]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [h]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [p]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [p]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [p]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [f]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [f]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [f]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [f]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [f]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [f]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [f]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [f]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [f]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [m]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...J(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [f]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [f]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [m]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: J()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...J()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [zt, ye]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [zt, yn]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: x()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [m]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [zt, yn]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", bn, f6]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Ca]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [m]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": $()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": $()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", bn, ye]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [d]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [M]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [d]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [m]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [M]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", ye]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: W()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", ye]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: W()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", ye]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [C]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [C]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [C]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [ba, ye]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [N]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [N]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [S]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [S]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", ye]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", ye]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", ye]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [zt, yn, ki]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const uc = /* @__PURE__ */ ZM(l6);
function Zg(e) {
  return $g(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function fi(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function d6(e) {
  var t;
  return (t = ($g(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function $g(e) {
  return e instanceof Node || e instanceof fi(e).Node;
}
function it(e) {
  return e instanceof Element || e instanceof fi(e).Element;
}
function $r(e) {
  return e instanceof HTMLElement || e instanceof fi(e).HTMLElement;
}
function _u(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof fi(e).ShadowRoot;
}
function g6(e) {
  return ["html", "body", "#document"].includes(Zg(e));
}
function p6(e) {
  return fi(e).getComputedStyle(e);
}
function h6(e) {
  if (Zg(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    _u(e) && e.host || // Fallback.
    d6(e)
  );
  return _u(t) ? t.host : t;
}
function Jn(e) {
  let t = e.activeElement;
  for (; ((n = t) == null || (r = n.shadowRoot) == null ? void 0 : r.activeElement) != null; ) {
    var n, r;
    t = t.shadowRoot.activeElement;
  }
  return t;
}
function $e(e, t) {
  if (!e || !t)
    return !1;
  const n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && _u(n)) {
    let r = t;
    for (; r; ) {
      if (e === r)
        return !0;
      r = r.parentNode || r.host;
    }
  }
  return !1;
}
function Vg() {
  const e = navigator.userAgentData;
  return e != null && e.platform ? e.platform : navigator.platform;
}
function v6() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: n,
      version: r
    } = t;
    return n + "/" + r;
  }).join(" ") : navigator.userAgent;
}
function m6(e) {
  if (e.mozInputSource === 0 && e.isTrusted)
    return !0;
  const t = /Android/i;
  return (t.test(Vg()) || t.test(v6())) && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function w6(e) {
  return e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType !== "mouse" || // iOS VoiceOver returns 0.333• for width/height.
  e.width < 1 && e.height < 1 && e.pressure === 0 && e.detail === 0;
}
function y6() {
  return /apple/i.test(navigator.vendor);
}
function mo(e, t) {
  const n = ["mouse", "pen"];
  return t || n.push("", void 0), n.includes(e);
}
function b6(e) {
  return "nativeEvent" in e;
}
function C6(e) {
  return e.matches("html,body");
}
function ot(e) {
  return (e == null ? void 0 : e.ownerDocument) || document;
}
function Xi(e, t) {
  if (t == null)
    return !1;
  if ("composedPath" in e)
    return e.composedPath().includes(t);
  const n = e;
  return n.target != null && t.contains(n.target);
}
function sc(e) {
  return "composedPath" in e ? e.composedPath()[0] : e.target;
}
const M6 = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
function Kg(e) {
  return $r(e) && e.matches(M6);
}
function zf(e) {
  e.preventDefault(), e.stopPropagation();
}
const Vr = Math.min, wo = Math.max, D6 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, L6 = {
  start: "end",
  end: "start"
};
function Zu(e, t, n) {
  return wo(e, Vr(t, n));
}
function sa(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function dn(e) {
  return e.split("-")[0];
}
function ui(e) {
  return e.split("-")[1];
}
function qg(e) {
  return e === "x" ? "y" : "x";
}
function cc(e) {
  return e === "y" ? "height" : "width";
}
function si(e) {
  return ["top", "bottom"].includes(dn(e)) ? "y" : "x";
}
function lc(e) {
  return qg(si(e));
}
function A6(e, t, n) {
  n === void 0 && (n = !1);
  const r = ui(e), a = lc(e), i = cc(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = yo(o)), [o, yo(o)];
}
function E6(e) {
  const t = yo(e);
  return [$u(e), t, $u(t)];
}
function $u(e) {
  return e.replace(/start|end/g, (t) => L6[t]);
}
function j6(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function I6(e, t, n, r) {
  const a = ui(e);
  let i = j6(dn(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map($u)))), i;
}
function yo(e) {
  return e.replace(/left|right|bottom|top/g, (t) => D6[t]);
}
function S6(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function dc(e) {
  return typeof e != "number" ? S6(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Kr(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: a
  } = e;
  return {
    width: r,
    height: a,
    top: n,
    left: t,
    right: t + r,
    bottom: n + a,
    x: t,
    y: n
  };
}
function Zd(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = si(t), o = lc(t), f = cc(o), s = dn(t), u = i === "y", c = r.x + r.width / 2 - a.width / 2, d = r.y + r.height / 2 - a.height / 2, g = r[f] / 2 - a[f] / 2;
  let p;
  switch (s) {
    case "top":
      p = {
        x: c,
        y: r.y - a.height
      };
      break;
    case "bottom":
      p = {
        x: c,
        y: r.y + r.height
      };
      break;
    case "right":
      p = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: r.x - a.width,
        y: d
      };
      break;
    default:
      p = {
        x: r.x,
        y: r.y
      };
  }
  switch (ui(t)) {
    case "start":
      p[o] -= g * (n && u ? -1 : 1);
      break;
    case "end":
      p[o] += g * (n && u ? -1 : 1);
      break;
  }
  return p;
}
const x6 = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, f = i.filter(Boolean), s = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: c,
    y: d
  } = Zd(u, r, s), g = r, p = {}, h = 0;
  for (let l = 0; l < f.length; l++) {
    const {
      name: w,
      fn: m
    } = f[l], {
      x: y,
      y: b,
      data: C,
      reset: M
    } = await m({
      x: c,
      y: d,
      initialPlacement: r,
      placement: g,
      strategy: a,
      middlewareData: p,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = y ?? c, d = b ?? d, p = {
      ...p,
      [w]: {
        ...p[w],
        ...C
      }
    }, M && h <= 50 && (h++, typeof M == "object" && (M.placement && (g = M.placement), M.rects && (u = M.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: a
    }) : M.rects), {
      x: c,
      y: d
    } = Zd(u, g, s)), l = -1);
  }
  return {
    x: c,
    y: d,
    placement: g,
    strategy: a,
    middlewareData: p
  };
};
async function Xg(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: f,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: d = "floating",
    altBoundary: g = !1,
    padding: p = 0
  } = sa(t, e), h = dc(p), w = f[g ? d === "floating" ? "reference" : "floating" : d], m = Kr(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(f.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: s
  })), y = d === "floating" ? {
    x: r,
    y: a,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, b = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(f.floating)), C = await (i.isElement == null ? void 0 : i.isElement(b)) ? await (i.getScale == null ? void 0 : i.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, M = Kr(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: f,
    rect: y,
    offsetParent: b,
    strategy: s
  }) : y);
  return {
    top: (m.top - M.top + h.top) / C.y,
    bottom: (M.bottom - m.bottom + h.bottom) / C.y,
    left: (m.left - M.left + h.left) / C.x,
    right: (M.right - m.right + h.right) / C.x
  };
}
const T6 = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: o,
      elements: f,
      middlewareData: s
    } = t, {
      element: u,
      padding: c = 0
    } = sa(e, t) || {};
    if (u == null)
      return {};
    const d = dc(c), g = {
      x: n,
      y: r
    }, p = lc(a), h = cc(p), l = await o.getDimensions(u), w = p === "y", m = w ? "top" : "left", y = w ? "bottom" : "right", b = w ? "clientHeight" : "clientWidth", C = i.reference[h] + i.reference[p] - g[p] - i.floating[h], M = g[p] - i.reference[p], S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(u));
    let I = S ? S[b] : 0;
    (!I || !await (o.isElement == null ? void 0 : o.isElement(S))) && (I = f.floating[b] || i.floating[h]);
    const N = C / 2 - M / 2, O = I / 2 - l[h] / 2 - 1, F = Vr(d[m], O), Q = Vr(d[y], O), T = F, x = I - l[h] - Q, A = I / 2 - l[h] / 2 + N, B = Zu(T, A, x), J = !s.arrow && ui(a) != null && A !== B && i.reference[h] / 2 - (A < T ? F : Q) - l[h] / 2 < 0, $ = J ? A < T ? A - T : A - x : 0;
    return {
      [p]: g[p] + $,
      data: {
        [p]: B,
        centerOffset: A - B - $,
        ...J && {
          alignmentOffset: $
        }
      },
      reset: J
    };
  }
}), N6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: a,
        middlewareData: i,
        rects: o,
        initialPlacement: f,
        platform: s,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: d = !0,
        fallbackPlacements: g,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: l = !0,
        ...w
      } = sa(e, t);
      if ((n = i.arrow) != null && n.alignmentOffset)
        return {};
      const m = dn(a), y = dn(f) === f, b = await (s.isRTL == null ? void 0 : s.isRTL(u.floating)), C = g || (y || !l ? [yo(f)] : E6(f));
      !g && h !== "none" && C.push(...I6(f, l, h, b));
      const M = [f, ...C], S = await Xg(t, w), I = [];
      let N = ((r = i.flip) == null ? void 0 : r.overflows) || [];
      if (c && I.push(S[m]), d) {
        const T = A6(a, o, b);
        I.push(S[T[0]], S[T[1]]);
      }
      if (N = [...N, {
        placement: a,
        overflows: I
      }], !I.every((T) => T <= 0)) {
        var O, F;
        const T = (((O = i.flip) == null ? void 0 : O.index) || 0) + 1, x = M[T];
        if (x)
          return {
            data: {
              index: T,
              overflows: N
            },
            reset: {
              placement: x
            }
          };
        let A = (F = N.filter((B) => B.overflows[0] <= 0).sort((B, J) => B.overflows[1] - J.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!A)
          switch (p) {
            case "bestFit": {
              var Q;
              const B = (Q = N.map((J) => [J.placement, J.overflows.filter(($) => $ > 0).reduce(($, q) => $ + q, 0)]).sort((J, $) => J[1] - $[1])[0]) == null ? void 0 : Q[0];
              B && (A = B);
              break;
            }
            case "initialPlacement":
              A = f;
              break;
          }
        if (a !== A)
          return {
            reset: {
              placement: A
            }
          };
      }
      return {};
    }
  };
};
function ep(e) {
  const t = Vr(...e.map((i) => i.left)), n = Vr(...e.map((i) => i.top)), r = wo(...e.map((i) => i.right)), a = wo(...e.map((i) => i.bottom));
  return {
    x: t,
    y: n,
    width: r - t,
    height: a - n
  };
}
function k6(e) {
  const t = e.slice().sort((a, i) => a.y - i.y), n = [];
  let r = null;
  for (let a = 0; a < t.length; a++) {
    const i = t[a];
    !r || i.y - r.y > r.height / 2 ? n.push([i]) : n[n.length - 1].push(i), r = i;
  }
  return n.map((a) => Kr(ep(a)));
}
const B6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "inline",
    options: e,
    async fn(t) {
      const {
        placement: n,
        elements: r,
        rects: a,
        platform: i,
        strategy: o
      } = t, {
        padding: f = 2,
        x: s,
        y: u
      } = sa(e, t), c = Array.from(await (i.getClientRects == null ? void 0 : i.getClientRects(r.reference)) || []), d = k6(c), g = Kr(ep(c)), p = dc(f);
      function h() {
        if (d.length === 2 && d[0].left > d[1].right && s != null && u != null)
          return d.find((w) => s > w.left - p.left && s < w.right + p.right && u > w.top - p.top && u < w.bottom + p.bottom) || g;
        if (d.length >= 2) {
          if (si(n) === "y") {
            const F = d[0], Q = d[d.length - 1], T = dn(n) === "top", x = F.top, A = Q.bottom, B = T ? F.left : Q.left, J = T ? F.right : Q.right, $ = J - B, q = A - x;
            return {
              top: x,
              bottom: A,
              left: B,
              right: J,
              width: $,
              height: q,
              x: B,
              y: x
            };
          }
          const w = dn(n) === "left", m = wo(...d.map((F) => F.right)), y = Vr(...d.map((F) => F.left)), b = d.filter((F) => w ? F.left === y : F.right === m), C = b[0].top, M = b[b.length - 1].bottom, S = y, I = m, N = I - S, O = M - C;
          return {
            top: C,
            bottom: M,
            left: S,
            right: I,
            width: N,
            height: O,
            x: S,
            y: C
          };
        }
        return g;
      }
      const l = await i.getElementRects({
        reference: {
          getBoundingClientRect: h
        },
        floating: r.floating,
        strategy: o
      });
      return a.reference.x !== l.reference.x || a.reference.y !== l.reference.y || a.reference.width !== l.reference.width || a.reference.height !== l.reference.height ? {
        reset: {
          rects: l
        }
      } : {};
    }
  };
};
async function O6(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = dn(n), f = ui(n), s = si(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, c = i && s ? -1 : 1, d = sa(t, e);
  let {
    mainAxis: g,
    crossAxis: p,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...d
  };
  return f && typeof h == "number" && (p = f === "end" ? h * -1 : h), s ? {
    x: p * c,
    y: g * u
  } : {
    x: g * u,
    y: p * c
  };
}
const P6 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: a,
        y: i,
        placement: o,
        middlewareData: f
      } = t, s = await O6(t, e);
      return o === ((n = f.offset) == null ? void 0 : n.placement) && (r = f.arrow) != null && r.alignmentOffset ? {} : {
        x: a + s.x,
        y: i + s.y,
        data: {
          ...s,
          placement: o
        }
      };
    }
  };
}, z6 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: f = {
          fn: (w) => {
            let {
              x: m,
              y
            } = w;
            return {
              x: m,
              y
            };
          }
        },
        ...s
      } = sa(e, t), u = {
        x: n,
        y: r
      }, c = await Xg(t, s), d = si(dn(a)), g = qg(d);
      let p = u[g], h = u[d];
      if (i) {
        const w = g === "y" ? "top" : "left", m = g === "y" ? "bottom" : "right", y = p + c[w], b = p - c[m];
        p = Zu(y, p, b);
      }
      if (o) {
        const w = d === "y" ? "top" : "left", m = d === "y" ? "bottom" : "right", y = h + c[w], b = h - c[m];
        h = Zu(y, h, b);
      }
      const l = f.fn({
        ...t,
        [g]: p,
        [d]: h
      });
      return {
        ...l,
        data: {
          x: l.x - n,
          y: l.y - r
        }
      };
    }
  };
}, Vu = Math.min, Rr = Math.max, bo = Math.round, Bi = Math.floor, Nn = (e) => ({
  x: e,
  y: e
});
function ca(e) {
  return tp(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function At(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function pn(e) {
  var t;
  return (t = (tp(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function tp(e) {
  return e instanceof Node || e instanceof At(e).Node;
}
function Xt(e) {
  return e instanceof Element || e instanceof At(e).Element;
}
function en(e) {
  return e instanceof HTMLElement || e instanceof At(e).HTMLElement;
}
function $d(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof At(e).ShadowRoot;
}
function ci(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Jt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function R6(e) {
  return ["table", "td", "th"].includes(ca(e));
}
function gc(e) {
  const t = pc(), n = Jt(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function F6(e) {
  let t = kn(e);
  for (; en(t) && !qr(t); ) {
    if (gc(t))
      return t;
    t = kn(t);
  }
  return null;
}
function pc() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function qr(e) {
  return ["html", "body", "#document"].includes(ca(e));
}
function Jt(e) {
  return At(e).getComputedStyle(e);
}
function Qo(e) {
  return Xt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function kn(e) {
  if (ca(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    $d(e) && e.host || // Fallback.
    pn(e)
  );
  return $d(t) ? t.host : t;
}
function np(e) {
  const t = kn(e);
  return qr(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : en(t) && ci(t) ? t : np(t);
}
function xn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const a = np(e), i = a === ((r = e.ownerDocument) == null ? void 0 : r.body), o = At(a);
  return i ? t.concat(o, o.visualViewport || [], ci(a) ? a : [], o.frameElement && n ? xn(o.frameElement) : []) : t.concat(a, xn(a, [], n));
}
function rp(e) {
  const t = Jt(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = en(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, f = bo(n) !== i || bo(r) !== o;
  return f && (n = i, r = o), {
    width: n,
    height: r,
    $: f
  };
}
function hc(e) {
  return Xt(e) ? e : e.contextElement;
}
function Fr(e) {
  const t = hc(e);
  if (!en(t))
    return Nn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = rp(t);
  let o = (i ? bo(n.width) : n.width) / r, f = (i ? bo(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!f || !Number.isFinite(f)) && (f = 1), {
    x: o,
    y: f
  };
}
const U6 = /* @__PURE__ */ Nn(0);
function ap(e) {
  const t = At(e);
  return !pc() || !t.visualViewport ? U6 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Y6(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== At(e) ? !1 : t;
}
function ir(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = hc(e);
  let o = Nn(1);
  t && (r ? Xt(r) && (o = Fr(r)) : o = Fr(e));
  const f = Y6(i, n, r) ? ap(i) : Nn(0);
  let s = (a.left + f.x) / o.x, u = (a.top + f.y) / o.y, c = a.width / o.x, d = a.height / o.y;
  if (i) {
    const g = At(i), p = r && Xt(r) ? At(r) : r;
    let h = g, l = h.frameElement;
    for (; l && r && p !== h; ) {
      const w = Fr(l), m = l.getBoundingClientRect(), y = Jt(l), b = m.left + (l.clientLeft + parseFloat(y.paddingLeft)) * w.x, C = m.top + (l.clientTop + parseFloat(y.paddingTop)) * w.y;
      s *= w.x, u *= w.y, c *= w.x, d *= w.y, s += b, u += C, h = At(l), l = h.frameElement;
    }
  }
  return Kr({
    width: c,
    height: d,
    x: s,
    y: u
  });
}
const G6 = [":popover-open", ":modal"];
function vc(e) {
  return G6.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function H6(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: a
  } = e;
  const i = a === "fixed", o = pn(r), f = t ? vc(t.floating) : !1;
  if (r === o || f && i)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = Nn(1);
  const c = Nn(0), d = en(r);
  if ((d || !d && !i) && ((ca(r) !== "body" || ci(o)) && (s = Qo(r)), en(r))) {
    const g = ir(r);
    u = Fr(r), c.x = g.x + r.clientLeft, c.y = g.y + r.clientTop;
  }
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - s.scrollLeft * u.x + c.x,
    y: n.y * u.y - s.scrollTop * u.y + c.y
  };
}
function Q6(e) {
  return Array.from(e.getClientRects());
}
function ip(e) {
  return ir(pn(e)).left + Qo(e).scrollLeft;
}
function J6(e) {
  const t = pn(e), n = Qo(e), r = e.ownerDocument.body, a = Rr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = Rr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + ip(e);
  const f = -n.scrollTop;
  return Jt(r).direction === "rtl" && (o += Rr(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: f
  };
}
function W6(e, t) {
  const n = At(e), r = pn(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, f = 0, s = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = pc();
    (!u || u && t === "fixed") && (f = a.offsetLeft, s = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: f,
    y: s
  };
}
function _6(e, t) {
  const n = ir(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = en(e) ? Fr(e) : Nn(1), o = e.clientWidth * i.x, f = e.clientHeight * i.y, s = a * i.x, u = r * i.y;
  return {
    width: o,
    height: f,
    x: s,
    y: u
  };
}
function Vd(e, t, n) {
  let r;
  if (t === "viewport")
    r = W6(e, n);
  else if (t === "document")
    r = J6(pn(e));
  else if (Xt(t))
    r = _6(t, n);
  else {
    const a = ap(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return Kr(r);
}
function op(e, t) {
  const n = kn(e);
  return n === t || !Xt(n) || qr(n) ? !1 : Jt(n).position === "fixed" || op(n, t);
}
function Z6(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = xn(e, [], !1).filter((f) => Xt(f) && ca(f) !== "body"), a = null;
  const i = Jt(e).position === "fixed";
  let o = i ? kn(e) : e;
  for (; Xt(o) && !qr(o); ) {
    const f = Jt(o), s = gc(o);
    !s && f.position === "fixed" && (a = null), (i ? !s && !a : !s && f.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || ci(o) && !s && op(e, o)) ? r = r.filter((c) => c !== o) : a = f, o = kn(o);
  }
  return t.set(e, r), r;
}
function $6(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? vc(t) ? [] : Z6(t, this._c) : [].concat(n), r], f = o[0], s = o.reduce((u, c) => {
    const d = Vd(t, c, a);
    return u.top = Rr(d.top, u.top), u.right = Vu(d.right, u.right), u.bottom = Vu(d.bottom, u.bottom), u.left = Rr(d.left, u.left), u;
  }, Vd(t, f, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function V6(e) {
  const {
    width: t,
    height: n
  } = rp(e);
  return {
    width: t,
    height: n
  };
}
function K6(e, t, n) {
  const r = en(t), a = pn(t), i = n === "fixed", o = ir(e, !0, i, t);
  let f = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = Nn(0);
  if (r || !r && !i)
    if ((ca(t) !== "body" || ci(a)) && (f = Qo(t)), r) {
      const d = ir(t, !0, i, t);
      s.x = d.x + t.clientLeft, s.y = d.y + t.clientTop;
    } else
      a && (s.x = ip(a));
  const u = o.left + f.scrollLeft - s.x, c = o.top + f.scrollTop - s.y;
  return {
    x: u,
    y: c,
    width: o.width,
    height: o.height
  };
}
function Rf(e) {
  return Jt(e).position === "static";
}
function Kd(e, t) {
  return !en(e) || Jt(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function fp(e, t) {
  const n = At(e);
  if (vc(e))
    return n;
  if (!en(e)) {
    let a = kn(e);
    for (; a && !qr(a); ) {
      if (Xt(a) && !Rf(a))
        return a;
      a = kn(a);
    }
    return n;
  }
  let r = Kd(e, t);
  for (; r && R6(r) && Rf(r); )
    r = Kd(r, t);
  return r && qr(r) && Rf(r) && !gc(r) ? n : r || F6(e) || n;
}
const q6 = async function(e) {
  const t = this.getOffsetParent || fp, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: K6(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function X6(e) {
  return Jt(e).direction === "rtl";
}
const eD = {
  convertOffsetParentRelativeRectToViewportRelativeRect: H6,
  getDocumentElement: pn,
  getClippingRect: $6,
  getOffsetParent: fp,
  getElementRects: q6,
  getClientRects: Q6,
  getDimensions: V6,
  getScale: Fr,
  isElement: Xt,
  isRTL: X6
};
function tD(e, t) {
  let n = null, r;
  const a = pn(e);
  function i() {
    var f;
    clearTimeout(r), (f = n) == null || f.disconnect(), n = null;
  }
  function o(f, s) {
    f === void 0 && (f = !1), s === void 0 && (s = 1), i();
    const {
      left: u,
      top: c,
      width: d,
      height: g
    } = e.getBoundingClientRect();
    if (f || t(), !d || !g)
      return;
    const p = Bi(c), h = Bi(a.clientWidth - (u + d)), l = Bi(a.clientHeight - (c + g)), w = Bi(u), y = {
      rootMargin: -p + "px " + -h + "px " + -l + "px " + -w + "px",
      threshold: Rr(0, Vu(1, s)) || 1
    };
    let b = !0;
    function C(M) {
      const S = M[0].intersectionRatio;
      if (S !== s) {
        if (!b)
          return o();
        S ? o(!1, S) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...y,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, y);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function mc(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: f = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = r, u = hc(e), c = a || i ? [...u ? xn(u) : [], ...xn(t)] : [];
  c.forEach((m) => {
    a && m.addEventListener("scroll", n, {
      passive: !0
    }), i && m.addEventListener("resize", n);
  });
  const d = u && f ? tD(u, n) : null;
  let g = -1, p = null;
  o && (p = new ResizeObserver((m) => {
    let [y] = m;
    y && y.target === u && p && (p.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      var b;
      (b = p) == null || b.observe(t);
    })), n();
  }), u && !s && p.observe(u), p.observe(t));
  let h, l = s ? ir(e) : null;
  s && w();
  function w() {
    const m = ir(e);
    l && (m.x !== l.x || m.y !== l.y || m.width !== l.width || m.height !== l.height) && n(), l = m, h = requestAnimationFrame(w);
  }
  return n(), () => {
    var m;
    c.forEach((y) => {
      a && y.removeEventListener("scroll", n), i && y.removeEventListener("resize", n);
    }), d == null || d(), (m = p) == null || m.disconnect(), p = null, s && cancelAnimationFrame(h);
  };
}
const nD = P6, rD = z6, aD = N6, qd = T6, iD = B6, oD = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: eD,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return x6(e, t, {
    ...a,
    platform: i
  });
};
var eo = typeof document < "u" ? ri : le;
function Co(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Co(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !Co(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function up(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Xd(e, t) {
  const n = up(e);
  return Math.round(t * n) / n;
}
function e0(e) {
  const t = L.useRef(e);
  return eo(() => {
    t.current = e;
  }), t;
}
function fD(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: f = !0,
    whileElementsMounted: s,
    open: u
  } = e, [c, d] = L.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, p] = L.useState(r);
  Co(g, r) || p(r);
  const [h, l] = L.useState(null), [w, m] = L.useState(null), y = L.useCallback(($) => {
    $ !== S.current && (S.current = $, l($));
  }, []), b = L.useCallback(($) => {
    $ !== I.current && (I.current = $, m($));
  }, []), C = i || h, M = o || w, S = L.useRef(null), I = L.useRef(null), N = L.useRef(c), O = s != null, F = e0(s), Q = e0(a), T = L.useCallback(() => {
    if (!S.current || !I.current)
      return;
    const $ = {
      placement: t,
      strategy: n,
      middleware: g
    };
    Q.current && ($.platform = Q.current), oD(S.current, I.current, $).then((q) => {
      const K = {
        ...q,
        isPositioned: !0
      };
      x.current && !Co(N.current, K) && (N.current = K, kv.flushSync(() => {
        d(K);
      }));
    });
  }, [g, t, n, Q]);
  eo(() => {
    u === !1 && N.current.isPositioned && (N.current.isPositioned = !1, d(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [u]);
  const x = L.useRef(!1);
  eo(() => (x.current = !0, () => {
    x.current = !1;
  }), []), eo(() => {
    if (C && (S.current = C), M && (I.current = M), C && M) {
      if (F.current)
        return F.current(C, M, T);
      T();
    }
  }, [C, M, T, F, O]);
  const A = L.useMemo(() => ({
    reference: S,
    floating: I,
    setReference: y,
    setFloating: b
  }), [y, b]), B = L.useMemo(() => ({
    reference: C,
    floating: M
  }), [C, M]), J = L.useMemo(() => {
    const $ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!B.floating)
      return $;
    const q = Xd(B.floating, c.x), K = Xd(B.floating, c.y);
    return f ? {
      ...$,
      transform: "translate(" + q + "px, " + K + "px)",
      ...up(B.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: q,
      top: K
    };
  }, [n, f, B.floating, c.x, c.y]);
  return L.useMemo(() => ({
    ...c,
    update: T,
    refs: A,
    elements: B,
    floatingStyles: J
  }), [c, T, A, B, J]);
}
const uD = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? qd({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? qd({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
}, sD = (e, t) => ({
  ...nD(e),
  options: [e, t]
}), Jo = (e, t) => ({
  ...rD(e),
  options: [e, t]
}), Wo = (e, t) => ({
  ...aD(e),
  options: [e, t]
}), sp = (e, t) => ({
  ...iD(e),
  options: [e, t]
}), cD = (e, t) => ({
  ...uD(e),
  options: [e, t]
});
/*!
* tabbable 6.2.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var lD = ["input:not([inert])", "select:not([inert])", "textarea:not([inert])", "a[href]:not([inert])", "button:not([inert])", "[tabindex]:not(slot):not([inert])", "audio[controls]:not([inert])", "video[controls]:not([inert])", '[contenteditable]:not([contenteditable="false"]):not([inert])', "details>summary:first-of-type:not([inert])", "details:not([inert])"], Ku = /* @__PURE__ */ lD.join(","), cp = typeof Element > "u", _a = cp ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Mo = !cp && Element.prototype.getRootNode ? function(e) {
  var t;
  return e == null || (t = e.getRootNode) === null || t === void 0 ? void 0 : t.call(e);
} : function(e) {
  return e == null ? void 0 : e.ownerDocument;
}, Do = function e(t, n) {
  var r;
  n === void 0 && (n = !0);
  var a = t == null || (r = t.getAttribute) === null || r === void 0 ? void 0 : r.call(t, "inert"), i = a === "" || a === "true", o = i || n && t && e(t.parentNode);
  return o;
}, dD = function(t) {
  var n, r = t == null || (n = t.getAttribute) === null || n === void 0 ? void 0 : n.call(t, "contenteditable");
  return r === "" || r === "true";
}, gD = function(t, n, r) {
  if (Do(t))
    return [];
  var a = Array.prototype.slice.apply(t.querySelectorAll(Ku));
  return n && _a.call(t, Ku) && a.unshift(t), a = a.filter(r), a;
}, pD = function e(t, n, r) {
  for (var a = [], i = Array.from(t); i.length; ) {
    var o = i.shift();
    if (!Do(o, !1))
      if (o.tagName === "SLOT") {
        var f = o.assignedElements(), s = f.length ? f : o.children, u = e(s, !0, r);
        r.flatten ? a.push.apply(a, u) : a.push({
          scopeParent: o,
          candidates: u
        });
      } else {
        var c = _a.call(o, Ku);
        c && r.filter(o) && (n || !t.includes(o)) && a.push(o);
        var d = o.shadowRoot || // check for an undisclosed shadow
        typeof r.getShadowRoot == "function" && r.getShadowRoot(o), g = !Do(d, !1) && (!r.shadowRootFilter || r.shadowRootFilter(o));
        if (d && g) {
          var p = e(d === !0 ? o.children : d.children, !0, r);
          r.flatten ? a.push.apply(a, p) : a.push({
            scopeParent: o,
            candidates: p
          });
        } else
          i.unshift.apply(i, o.children);
      }
  }
  return a;
}, lp = function(t) {
  return !isNaN(parseInt(t.getAttribute("tabindex"), 10));
}, dp = function(t) {
  if (!t)
    throw new Error("No node provided");
  return t.tabIndex < 0 && (/^(AUDIO|VIDEO|DETAILS)$/.test(t.tagName) || dD(t)) && !lp(t) ? 0 : t.tabIndex;
}, hD = function(t, n) {
  var r = dp(t);
  return r < 0 && n && !lp(t) ? 0 : r;
}, vD = function(t, n) {
  return t.tabIndex === n.tabIndex ? t.documentOrder - n.documentOrder : t.tabIndex - n.tabIndex;
}, gp = function(t) {
  return t.tagName === "INPUT";
}, mD = function(t) {
  return gp(t) && t.type === "hidden";
}, wD = function(t) {
  var n = t.tagName === "DETAILS" && Array.prototype.slice.apply(t.children).some(function(r) {
    return r.tagName === "SUMMARY";
  });
  return n;
}, yD = function(t, n) {
  for (var r = 0; r < t.length; r++)
    if (t[r].checked && t[r].form === n)
      return t[r];
}, bD = function(t) {
  if (!t.name)
    return !0;
  var n = t.form || Mo(t), r = function(f) {
    return n.querySelectorAll('input[type="radio"][name="' + f + '"]');
  }, a;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    a = r(window.CSS.escape(t.name));
  else
    try {
      a = r(t.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var i = yD(a, t.form);
  return !i || i === t;
}, CD = function(t) {
  return gp(t) && t.type === "radio";
}, MD = function(t) {
  return CD(t) && !bD(t);
}, DD = function(t) {
  var n, r = t && Mo(t), a = (n = r) === null || n === void 0 ? void 0 : n.host, i = !1;
  if (r && r !== t) {
    var o, f, s;
    for (i = !!((o = a) !== null && o !== void 0 && (f = o.ownerDocument) !== null && f !== void 0 && f.contains(a) || t != null && (s = t.ownerDocument) !== null && s !== void 0 && s.contains(t)); !i && a; ) {
      var u, c, d;
      r = Mo(a), a = (u = r) === null || u === void 0 ? void 0 : u.host, i = !!((c = a) !== null && c !== void 0 && (d = c.ownerDocument) !== null && d !== void 0 && d.contains(a));
    }
  }
  return i;
}, t0 = function(t) {
  var n = t.getBoundingClientRect(), r = n.width, a = n.height;
  return r === 0 && a === 0;
}, LD = function(t, n) {
  var r = n.displayCheck, a = n.getShadowRoot;
  if (getComputedStyle(t).visibility === "hidden")
    return !0;
  var i = _a.call(t, "details>summary:first-of-type"), o = i ? t.parentElement : t;
  if (_a.call(o, "details:not([open]) *"))
    return !0;
  if (!r || r === "full" || r === "legacy-full") {
    if (typeof a == "function") {
      for (var f = t; t; ) {
        var s = t.parentElement, u = Mo(t);
        if (s && !s.shadowRoot && a(s) === !0)
          return t0(t);
        t.assignedSlot ? t = t.assignedSlot : !s && u !== t.ownerDocument ? t = u.host : t = s;
      }
      t = f;
    }
    if (DD(t))
      return !t.getClientRects().length;
    if (r !== "legacy-full")
      return !0;
  } else if (r === "non-zero-area")
    return t0(t);
  return !1;
}, AD = function(t) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(t.tagName))
    for (var n = t.parentElement; n; ) {
      if (n.tagName === "FIELDSET" && n.disabled) {
        for (var r = 0; r < n.children.length; r++) {
          var a = n.children.item(r);
          if (a.tagName === "LEGEND")
            return _a.call(n, "fieldset[disabled] *") ? !0 : !a.contains(t);
        }
        return !0;
      }
      n = n.parentElement;
    }
  return !1;
}, ED = function(t, n) {
  return !(n.disabled || // we must do an inert look up to filter out any elements inside an inert ancestor
  //  because we're limited in the type of selectors we can use in JSDom (see related
  //  note related to `candidateSelectors`)
  Do(n) || mD(n) || LD(n, t) || // For a details element with a summary, the summary element gets the focus
  wD(n) || AD(n));
}, n0 = function(t, n) {
  return !(MD(n) || dp(n) < 0 || !ED(t, n));
}, jD = function(t) {
  var n = parseInt(t.getAttribute("tabindex"), 10);
  return !!(isNaN(n) || n >= 0);
}, ID = function e(t) {
  var n = [], r = [];
  return t.forEach(function(a, i) {
    var o = !!a.scopeParent, f = o ? a.scopeParent : a, s = hD(f, o), u = o ? e(a.candidates) : f;
    s === 0 ? o ? n.push.apply(n, u) : n.push(f) : r.push({
      documentOrder: i,
      tabIndex: s,
      item: a,
      isScope: o,
      content: u
    });
  }), r.sort(vD).reduce(function(a, i) {
    return i.isScope ? a.push.apply(a, i.content) : a.push(i.content), a;
  }, []).concat(n);
}, wc = function(t, n) {
  n = n || {};
  var r;
  return n.getShadowRoot ? r = pD([t], n.includeContainer, {
    filter: n0.bind(null, n),
    flatten: !1,
    getShadowRoot: n.getShadowRoot,
    shadowRootFilter: jD
  }) : r = gD(t, n.includeContainer, n0.bind(null, n)), ID(r);
};
function ix(e) {
  return L.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  }, e);
}
let r0 = 0;
function Hn(e, t) {
  t === void 0 && (t = {});
  const {
    preventScroll: n = !1,
    cancelPrevious: r = !0,
    sync: a = !1
  } = t;
  r && cancelAnimationFrame(r0);
  const i = () => e == null ? void 0 : e.focus({
    preventScroll: n
  });
  a ? i() : r0 = requestAnimationFrame(i);
}
var nt = typeof document < "u" ? ri : le;
function Za() {
  return Za = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Za.apply(this, arguments);
}
let Ff = !1, SD = 0;
const a0 = () => "floating-ui-" + SD++;
function xD() {
  const [e, t] = L.useState(() => Ff ? a0() : void 0);
  return nt(() => {
    e == null && t(a0());
  }, []), L.useEffect(() => {
    Ff || (Ff = !0);
  }, []), e;
}
const TD = L[/* @__PURE__ */ "useId".toString()], li = TD || xD;
function ND() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, n) {
      var r;
      (r = e.get(t)) == null || r.forEach((a) => a(n));
    },
    on(t, n) {
      e.set(t, [...e.get(t) || [], n]);
    },
    off(t, n) {
      var r;
      e.set(t, ((r = e.get(t)) == null ? void 0 : r.filter((a) => a !== n)) || []);
    }
  };
}
const pp = /* @__PURE__ */ L.createContext(null), kD = /* @__PURE__ */ L.createContext(null), _o = () => {
  var e;
  return ((e = L.useContext(pp)) == null ? void 0 : e.id) || null;
}, di = () => L.useContext(kD);
function hp(e) {
  const t = li(), n = di(), r = _o(), a = e || r;
  return nt(() => {
    const i = {
      id: t,
      parentId: a
    };
    return n == null || n.addNode(i), () => {
      n == null || n.removeNode(i);
    };
  }, [n, t, a]), t;
}
function vp(e) {
  let {
    children: t,
    id: n
  } = e;
  const r = _o();
  return /* @__PURE__ */ L.createElement(pp.Provider, {
    value: L.useMemo(() => ({
      id: n,
      parentId: r
    }), [n, r])
  }, t);
}
function or(e) {
  return "data-floating-ui-" + e;
}
function sn(e) {
  const t = Ce(e);
  return nt(() => {
    t.current = e;
  }), t;
}
const i0 = /* @__PURE__ */ or("safe-polygon");
function Uf(e, t, n) {
  return n && !mo(n) ? 0 : typeof e == "number" ? e : e == null ? void 0 : e[t];
}
function BD(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: a,
    events: i,
    elements: {
      domReference: o,
      floating: f
    },
    refs: s
  } = e, {
    enabled: u = !0,
    delay: c = 0,
    handleClose: d = null,
    mouseOnly: g = !1,
    restMs: p = 0,
    move: h = !0
  } = t, l = di(), w = _o(), m = sn(d), y = sn(c), b = L.useRef(), C = L.useRef(), M = L.useRef(), S = L.useRef(), I = L.useRef(!0), N = L.useRef(!1), O = L.useRef(() => {
  }), F = L.useCallback(() => {
    var A;
    const B = (A = a.current.openEvent) == null ? void 0 : A.type;
    return (B == null ? void 0 : B.includes("mouse")) && B !== "mousedown";
  }, [a]);
  L.useEffect(() => {
    if (!u)
      return;
    function A() {
      clearTimeout(C.current), clearTimeout(S.current), I.current = !0;
    }
    return i.on("dismiss", A), () => {
      i.off("dismiss", A);
    };
  }, [u, i]), L.useEffect(() => {
    if (!u || !m.current || !n)
      return;
    function A(J) {
      F() && r(!1, J);
    }
    const B = ot(f).documentElement;
    return B.addEventListener("mouseleave", A), () => {
      B.removeEventListener("mouseleave", A);
    };
  }, [f, n, r, u, m, a, F]);
  const Q = L.useCallback(function(A, B) {
    B === void 0 && (B = !0);
    const J = Uf(y.current, "close", b.current);
    J && !M.current ? (clearTimeout(C.current), C.current = setTimeout(() => r(!1, A), J)) : B && (clearTimeout(C.current), r(!1, A));
  }, [y, r]), T = L.useCallback(() => {
    O.current(), M.current = void 0;
  }, []), x = L.useCallback(() => {
    if (N.current) {
      const A = ot(s.floating.current).body;
      A.style.pointerEvents = "", A.removeAttribute(i0), N.current = !1;
    }
  }, [s]);
  return L.useEffect(() => {
    if (!u)
      return;
    function A() {
      return a.current.openEvent ? ["click", "mousedown"].includes(a.current.openEvent.type) : !1;
    }
    function B(q) {
      if (clearTimeout(C.current), I.current = !1, g && !mo(b.current) || p > 0 && Uf(y.current, "open") === 0)
        return;
      const K = Uf(y.current, "open", b.current);
      K ? C.current = setTimeout(() => {
        r(!0, q);
      }, K) : r(!0, q);
    }
    function J(q) {
      if (A())
        return;
      O.current();
      const K = ot(f);
      if (clearTimeout(S.current), m.current) {
        n || clearTimeout(C.current), M.current = m.current({
          ...e,
          tree: l,
          x: q.clientX,
          y: q.clientY,
          onClose() {
            x(), T(), Q(q);
          }
        });
        const R = M.current;
        K.addEventListener("mousemove", R), O.current = () => {
          K.removeEventListener("mousemove", R);
        };
        return;
      }
      (b.current === "touch" ? !$e(f, q.relatedTarget) : !0) && Q(q);
    }
    function $(q) {
      A() || m.current == null || m.current({
        ...e,
        tree: l,
        x: q.clientX,
        y: q.clientY,
        onClose() {
          x(), T(), Q(q);
        }
      })(q);
    }
    if (it(o)) {
      const q = o;
      return n && q.addEventListener("mouseleave", $), f == null || f.addEventListener("mouseleave", $), h && q.addEventListener("mousemove", B, {
        once: !0
      }), q.addEventListener("mouseenter", B), q.addEventListener("mouseleave", J), () => {
        n && q.removeEventListener("mouseleave", $), f == null || f.removeEventListener("mouseleave", $), h && q.removeEventListener("mousemove", B), q.removeEventListener("mouseenter", B), q.removeEventListener("mouseleave", J);
      };
    }
  }, [o, f, u, e, g, p, h, Q, T, x, r, n, l, y, m, a]), nt(() => {
    var A;
    if (u && n && (A = m.current) != null && A.__options.blockPointerEvents && F()) {
      const $ = ot(f).body;
      if ($.setAttribute(i0, ""), $.style.pointerEvents = "none", N.current = !0, it(o) && f) {
        var B, J;
        const q = o, K = l == null || (B = l.nodesRef.current.find((P) => P.id === w)) == null || (J = B.context) == null ? void 0 : J.elements.floating;
        return K && (K.style.pointerEvents = ""), q.style.pointerEvents = "auto", f.style.pointerEvents = "auto", () => {
          q.style.pointerEvents = "", f.style.pointerEvents = "";
        };
      }
    }
  }, [u, n, w, f, o, l, m, a, F]), nt(() => {
    n || (b.current = void 0, T(), x());
  }, [n, T, x]), L.useEffect(() => () => {
    T(), clearTimeout(C.current), clearTimeout(S.current), x();
  }, [u, o, T, x]), L.useMemo(() => {
    if (!u)
      return {};
    function A(B) {
      b.current = B.pointerType;
    }
    return {
      reference: {
        onPointerDown: A,
        onPointerEnter: A,
        onMouseMove(B) {
          n || p === 0 || (clearTimeout(S.current), S.current = setTimeout(() => {
            I.current || r(!0, B.nativeEvent);
          }, p));
        }
      },
      floating: {
        onMouseEnter() {
          clearTimeout(C.current);
        },
        onMouseLeave(B) {
          i.emit("dismiss", {
            type: "mouseLeave",
            data: {
              returnFocus: !1
            }
          }), Q(B.nativeEvent, !1);
        }
      }
    };
  }, [i, u, p, n, r, Q]);
}
function OD(e, t) {
  var n;
  let r = [], a = (n = e.find((i) => i.id === t)) == null ? void 0 : n.parentId;
  for (; a; ) {
    const i = e.find((o) => o.id === a);
    a = i == null ? void 0 : i.parentId, i && (r = r.concat(i));
  }
  return r;
}
function Ur(e, t) {
  let n = e.filter((a) => {
    var i;
    return a.parentId === t && ((i = a.context) == null ? void 0 : i.open);
  }), r = n;
  for (; r.length; )
    r = e.filter((a) => {
      var i;
      return (i = r) == null ? void 0 : i.some((o) => {
        var f;
        return a.parentId === o.id && ((f = a.context) == null ? void 0 : f.open);
      });
    }), n = n.concat(r);
  return n;
}
let Ar = /* @__PURE__ */ new WeakMap(), Oi = /* @__PURE__ */ new WeakSet(), Pi = {}, Yf = 0;
const PD = () => typeof HTMLElement < "u" && "inert" in HTMLElement.prototype, mp = (e) => e && (e.host || mp(e.parentNode)), zD = (e, t) => t.map((n) => {
  if (e.contains(n))
    return n;
  const r = mp(n);
  return e.contains(r) ? r : null;
}).filter((n) => n != null);
function RD(e, t, n, r) {
  const a = "data-floating-ui-inert", i = r ? "inert" : n ? "aria-hidden" : null, o = zD(t, e), f = /* @__PURE__ */ new Set(), s = new Set(o), u = [];
  Pi[a] || (Pi[a] = /* @__PURE__ */ new WeakMap());
  const c = Pi[a];
  o.forEach(d), g(t), f.clear();
  function d(p) {
    !p || f.has(p) || (f.add(p), p.parentNode && d(p.parentNode));
  }
  function g(p) {
    !p || s.has(p) || Array.prototype.forEach.call(p.children, (h) => {
      if (f.has(h))
        g(h);
      else {
        const l = i ? h.getAttribute(i) : null, w = l !== null && l !== "false", m = (Ar.get(h) || 0) + 1, y = (c.get(h) || 0) + 1;
        Ar.set(h, m), c.set(h, y), u.push(h), m === 1 && w && Oi.add(h), y === 1 && h.setAttribute(a, ""), !w && i && h.setAttribute(i, "true");
      }
    });
  }
  return Yf++, () => {
    u.forEach((p) => {
      const h = (Ar.get(p) || 0) - 1, l = (c.get(p) || 0) - 1;
      Ar.set(p, h), c.set(p, l), h || (!Oi.has(p) && i && p.removeAttribute(i), Oi.delete(p)), l || p.removeAttribute(a);
    }), Yf--, Yf || (Ar = /* @__PURE__ */ new WeakMap(), Ar = /* @__PURE__ */ new WeakMap(), Oi = /* @__PURE__ */ new WeakSet(), Pi = {});
  };
}
function o0(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = ot(e[0]).body;
  return RD(e.concat(Array.from(r.querySelectorAll("[aria-live]"))), r, t, n);
}
const yc = () => ({
  getShadowRoot: !0,
  displayCheck: (
    // JSDOM does not support the `tabbable` library. To solve this we can
    // check if `ResizeObserver` is a real function (not polyfilled), which
    // determines if the current environment is JSDOM-like.
    typeof ResizeObserver == "function" && ResizeObserver.toString().includes("[native code]") ? "full" : "none"
  )
});
function wp(e, t) {
  const n = wc(e, yc());
  t === "prev" && n.reverse();
  const r = n.indexOf(Jn(ot(e)));
  return n.slice(r + 1)[0];
}
function yp() {
  return wp(document.body, "next");
}
function bp() {
  return wp(document.body, "prev");
}
function za(e, t) {
  const n = t || e.currentTarget, r = e.relatedTarget;
  return !r || !$e(n, r);
}
function FD(e) {
  wc(e, yc()).forEach((n) => {
    n.dataset.tabindex = n.getAttribute("tabindex") || "", n.setAttribute("tabindex", "-1");
  });
}
function UD(e) {
  e.querySelectorAll("[data-tabindex]").forEach((n) => {
    const r = n.dataset.tabindex;
    delete n.dataset.tabindex, r ? n.setAttribute("tabindex", r) : n.removeAttribute("tabindex");
  });
}
const bc = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "fixed",
  whiteSpace: "nowrap",
  width: "1px",
  top: 0,
  left: 0
};
let YD;
function f0(e) {
  e.key === "Tab" && (e.target, clearTimeout(YD));
}
const Lo = /* @__PURE__ */ L.forwardRef(function(t, n) {
  const [r, a] = L.useState();
  nt(() => (y6() && a("button"), document.addEventListener("keydown", f0), () => {
    document.removeEventListener("keydown", f0);
  }), []);
  const i = {
    ref: n,
    tabIndex: 0,
    // Role is only for VoiceOver
    role: r,
    "aria-hidden": r ? void 0 : !0,
    [or("focus-guard")]: "",
    style: bc
  };
  return /* @__PURE__ */ L.createElement("span", Za({}, t, i));
}), Cp = /* @__PURE__ */ L.createContext(null);
function GD(e) {
  let {
    id: t,
    root: n
  } = e === void 0 ? {} : e;
  const [r, a] = L.useState(null), i = li(), o = Dp(), f = L.useMemo(() => ({
    id: t,
    root: n,
    portalContext: o,
    uniqueId: i
  }), [t, n, o, i]), s = L.useRef();
  return nt(() => () => {
    r == null || r.remove();
  }, [r, f]), nt(() => {
    if (s.current === f)
      return;
    s.current = f;
    const {
      id: u,
      root: c,
      portalContext: d,
      uniqueId: g
    } = f, p = u ? document.getElementById(u) : null, h = or("portal");
    if (p) {
      const l = document.createElement("div");
      l.id = g, l.setAttribute(h, ""), p.appendChild(l), a(l);
    } else {
      let l = c || (d == null ? void 0 : d.portalNode);
      l && !it(l) && (l = l.current), l = l || document.body;
      let w = null;
      u && (w = document.createElement("div"), w.id = u, l.appendChild(w));
      const m = document.createElement("div");
      m.id = g, m.setAttribute(h, ""), l = w || l, l.appendChild(m), a(m);
    }
  }, [f]), r;
}
function Mp(e) {
  let {
    children: t,
    id: n,
    root: r = null,
    preserveTabOrder: a = !0
  } = e;
  const i = GD({
    id: n,
    root: r
  }), [o, f] = L.useState(null), s = L.useRef(null), u = L.useRef(null), c = L.useRef(null), d = L.useRef(null), g = (
    // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!o && // Guards are only for non-modal focus management.
    !o.modal && // Don't render if unmount is transitioning.
    o.open && a && !!(r || i)
  );
  return L.useEffect(() => {
    if (!i || !a || o != null && o.modal)
      return;
    function p(h) {
      i && za(h) && (h.type === "focusin" ? UD : FD)(i);
    }
    return i.addEventListener("focusin", p, !0), i.addEventListener("focusout", p, !0), () => {
      i.removeEventListener("focusin", p, !0), i.removeEventListener("focusout", p, !0);
    };
  }, [i, a, o == null ? void 0 : o.modal]), /* @__PURE__ */ L.createElement(Cp.Provider, {
    value: L.useMemo(() => ({
      preserveTabOrder: a,
      beforeOutsideRef: s,
      afterOutsideRef: u,
      beforeInsideRef: c,
      afterInsideRef: d,
      portalNode: i,
      setFocusManagerState: f
    }), [a, i])
  }, g && i && /* @__PURE__ */ L.createElement(Lo, {
    "data-type": "outside",
    ref: s,
    onFocus: (p) => {
      if (za(p, i)) {
        var h;
        (h = c.current) == null || h.focus();
      } else {
        const l = bp() || (o == null ? void 0 : o.refs.domReference.current);
        l == null || l.focus();
      }
    }
  }), g && i && /* @__PURE__ */ L.createElement("span", {
    "aria-owns": i.id,
    style: bc
  }), i && /* @__PURE__ */ Bv(t, i), g && i && /* @__PURE__ */ L.createElement(Lo, {
    "data-type": "outside",
    ref: u,
    onFocus: (p) => {
      if (za(p, i)) {
        var h;
        (h = d.current) == null || h.focus();
      } else {
        const l = yp() || (o == null ? void 0 : o.refs.domReference.current);
        l == null || l.focus(), o != null && o.closeOnFocusOut && (o == null || o.onOpenChange(!1, p.nativeEvent));
      }
    }
  }));
}
const Dp = () => L.useContext(Cp), HD = /* @__PURE__ */ L.forwardRef(function(t, n) {
  return /* @__PURE__ */ L.createElement("button", Za({}, t, {
    type: "button",
    ref: n,
    tabIndex: -1,
    style: bc
  }));
});
function QD(e) {
  const {
    context: t,
    children: n,
    disabled: r = !1,
    order: a = ["content"],
    guards: i = !0,
    initialFocus: o = 0,
    returnFocus: f = !0,
    modal: s = !0,
    visuallyHiddenDismiss: u = !1,
    closeOnFocusOut: c = !0
  } = e, {
    open: d,
    refs: g,
    nodeId: p,
    onOpenChange: h,
    events: l,
    dataRef: w,
    elements: {
      domReference: m,
      floating: y
    }
  } = t, b = PD() ? i : !0, C = sn(a), M = sn(o), S = sn(f), I = di(), N = Dp(), O = typeof o == "number" && o < 0, F = L.useRef(null), Q = L.useRef(null), T = L.useRef(!1), x = L.useRef(null), A = L.useRef(!1), B = N != null, J = m && m.getAttribute("role") === "combobox" && Kg(m) && O, $ = L.useCallback(function(R) {
    return R === void 0 && (R = y), R ? wc(R, yc()) : [];
  }, [y]), q = L.useCallback((R) => {
    const W = $(R);
    return C.current.map((X) => m && X === "reference" ? m : y && X === "floating" ? y : W).filter(Boolean).flat();
  }, [m, y, C, $]);
  L.useEffect(() => {
    if (r || !s)
      return;
    function R(X) {
      if (X.key === "Tab") {
        $e(y, Jn(ot(y))) && $().length === 0 && !J && zf(X);
        const D = q(), U = sc(X);
        C.current[0] === "reference" && U === m && (zf(X), X.shiftKey ? Hn(D[D.length - 1]) : Hn(D[1])), C.current[1] === "floating" && U === y && X.shiftKey && (zf(X), Hn(D[0]));
      }
    }
    const W = ot(y);
    return W.addEventListener("keydown", R), () => {
      W.removeEventListener("keydown", R);
    };
  }, [r, m, y, s, C, g, J, $, q]), L.useEffect(() => {
    if (r || !c)
      return;
    function R() {
      A.current = !0, setTimeout(() => {
        A.current = !1;
      });
    }
    function W(X) {
      const D = X.relatedTarget;
      queueMicrotask(() => {
        const U = !($e(m, D) || $e(y, D) || $e(D, y) || $e(N == null ? void 0 : N.portalNode, D) || D != null && D.hasAttribute(or("focus-guard")) || I && (Ur(I.nodesRef.current, p).find((k) => {
          var Y, V;
          return $e((Y = k.context) == null ? void 0 : Y.elements.floating, D) || $e((V = k.context) == null ? void 0 : V.elements.domReference, D);
        }) || OD(I.nodesRef.current, p).find((k) => {
          var Y, V;
          return ((Y = k.context) == null ? void 0 : Y.elements.floating) === D || ((V = k.context) == null ? void 0 : V.elements.domReference) === D;
        })));
        D && U && !A.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
        D !== x.current && (T.current = !0, h(!1, X));
      });
    }
    if (y && $r(m))
      return m.addEventListener("focusout", W), m.addEventListener("pointerdown", R), !s && y.addEventListener("focusout", W), () => {
        m.removeEventListener("focusout", W), m.removeEventListener("pointerdown", R), !s && y.removeEventListener("focusout", W);
      };
  }, [r, m, y, s, p, I, N, h, c]), L.useEffect(() => {
    var R;
    if (r)
      return;
    const W = Array.from((N == null || (R = N.portalNode) == null ? void 0 : R.querySelectorAll("[" + or("portal") + "]")) || []);
    if (y) {
      const X = [y, ...W, F.current, Q.current, C.current.includes("reference") || J ? m : null].filter((U) => U != null), D = s ? o0(X, b, !b) : o0(X);
      return () => {
        D();
      };
    }
  }, [r, m, y, s, C, N, J, b]), nt(() => {
    if (r || !y)
      return;
    const R = ot(y), W = Jn(R);
    queueMicrotask(() => {
      const X = q(y), D = M.current, U = (typeof D == "number" ? X[D] : D.current) || y, k = $e(y, W);
      !O && !k && d && Hn(U, {
        preventScroll: U === y
      });
    });
  }, [r, d, y, O, q, M]), nt(() => {
    if (r || !y)
      return;
    let R = !1;
    const W = ot(y), X = Jn(W), D = w.current;
    x.current = X;
    function U(k) {
      if (k.type === "escapeKey" && g.domReference.current && (x.current = g.domReference.current), ["referencePress", "escapeKey"].includes(k.type))
        return;
      const Y = k.data.returnFocus;
      typeof Y == "object" ? (T.current = !1, R = Y.preventScroll) : T.current = !Y;
    }
    return l.on("dismiss", U), () => {
      l.off("dismiss", U);
      const k = Jn(W);
      ($e(y, k) || I && Ur(I.nodesRef.current, p).some((V) => {
        var Z;
        return $e((Z = V.context) == null ? void 0 : Z.elements.floating, k);
      }) || D.openEvent && ["click", "mousedown"].includes(D.openEvent.type)) && g.domReference.current && (x.current = g.domReference.current), // eslint-disable-next-line react-hooks/exhaustive-deps
      S.current && $r(x.current) && !T.current && Hn(x.current, {
        // When dismissing nested floating elements, by the time the rAF has
        // executed, the menus will all have been unmounted. When they try
        // to get focused, the calls get ignored — leaving the root
        // reference focused as desired.
        cancelPrevious: !1,
        preventScroll: R
      });
    };
  }, [r, y, S, w, g, l, I, p]), nt(() => {
    if (!(r || !N))
      return N.setFocusManagerState({
        modal: s,
        closeOnFocusOut: c,
        open: d,
        onOpenChange: h,
        refs: g
      }), () => {
        N.setFocusManagerState(null);
      };
  }, [r, N, s, d, h, g, c]), nt(() => {
    if (!r && y && typeof MutationObserver == "function" && !O) {
      const R = () => {
        const X = y.getAttribute("tabindex");
        C.current.includes("floating") || Jn(ot(y)) !== g.domReference.current && $().length === 0 ? X !== "0" && y.setAttribute("tabindex", "0") : X !== "-1" && y.setAttribute("tabindex", "-1");
      };
      R();
      const W = new MutationObserver(R);
      return W.observe(y, {
        childList: !0,
        subtree: !0,
        attributes: !0
      }), () => {
        W.disconnect();
      };
    }
  }, [r, y, g, C, $, O]);
  function K(R) {
    return r || !u || !s ? null : /* @__PURE__ */ L.createElement(HD, {
      ref: R === "start" ? F : Q,
      onClick: (W) => h(!1, W.nativeEvent)
    }, typeof u == "string" ? u : "Dismiss");
  }
  const P = !r && b && !J && (B || s);
  return /* @__PURE__ */ L.createElement(L.Fragment, null, P && /* @__PURE__ */ L.createElement(Lo, {
    "data-type": "inside",
    ref: N == null ? void 0 : N.beforeInsideRef,
    onFocus: (R) => {
      if (s) {
        const X = q();
        Hn(a[0] === "reference" ? X[0] : X[X.length - 1]);
      } else if (N != null && N.preserveTabOrder && N.portalNode)
        if (T.current = !1, za(R, N.portalNode)) {
          const X = yp() || m;
          X == null || X.focus();
        } else {
          var W;
          (W = N.beforeOutsideRef.current) == null || W.focus();
        }
    }
  }), !J && K("start"), n, K("end"), P && /* @__PURE__ */ L.createElement(Lo, {
    "data-type": "inside",
    ref: N == null ? void 0 : N.afterInsideRef,
    onFocus: (R) => {
      if (s)
        Hn(q()[0]);
      else if (N != null && N.preserveTabOrder && N.portalNode)
        if (c && (T.current = !0), za(R, N.portalNode)) {
          const X = bp() || m;
          X == null || X.focus();
        } else {
          var W;
          (W = N.afterOutsideRef.current) == null || W.focus();
        }
    }
  }));
}
const Gf = /* @__PURE__ */ new Set(), ox = /* @__PURE__ */ L.forwardRef(function(t, n) {
  let {
    lockScroll: r = !1,
    ...a
  } = t;
  const i = li();
  return nt(() => {
    if (!r)
      return;
    Gf.add(i);
    const o = /iP(hone|ad|od)|iOS/.test(Vg()), f = document.body.style, u = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft ? "paddingLeft" : "paddingRight", c = window.innerWidth - document.documentElement.clientWidth, d = f.left ? parseFloat(f.left) : window.pageXOffset, g = f.top ? parseFloat(f.top) : window.pageYOffset;
    if (f.overflow = "hidden", c && (f[u] = c + "px"), o) {
      var p, h;
      const l = ((p = window.visualViewport) == null ? void 0 : p.offsetLeft) || 0, w = ((h = window.visualViewport) == null ? void 0 : h.offsetTop) || 0;
      Object.assign(f, {
        position: "fixed",
        top: -(g - Math.floor(w)) + "px",
        left: -(d - Math.floor(l)) + "px",
        right: "0"
      });
    }
    return () => {
      Gf.delete(i), Gf.size === 0 && (Object.assign(f, {
        overflow: "",
        [u]: ""
      }), o && (Object.assign(f, {
        position: "",
        top: "",
        left: "",
        right: ""
      }), window.scrollTo(d, g)));
    };
  }, [i, r]), /* @__PURE__ */ L.createElement("div", Za({
    ref: n
  }, a, {
    style: {
      position: "fixed",
      overflow: "auto",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...a.style
    }
  }));
});
function u0(e) {
  return $r(e.target) && e.target.tagName === "BUTTON";
}
function s0(e) {
  return Kg(e);
}
function fx(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: a,
    elements: {
      domReference: i
    }
  } = e, {
    enabled: o = !0,
    event: f = "click",
    toggle: s = !0,
    ignoreMouse: u = !1,
    keyboardHandlers: c = !0
  } = t, d = L.useRef(), g = L.useRef(!1);
  return L.useMemo(() => o ? {
    reference: {
      onPointerDown(p) {
        d.current = p.pointerType;
      },
      onMouseDown(p) {
        p.button === 0 && (mo(d.current, !0) && u || f !== "click" && (n && s && (!a.current.openEvent || a.current.openEvent.type === "mousedown") ? r(!1, p.nativeEvent) : (p.preventDefault(), r(!0, p.nativeEvent))));
      },
      onClick(p) {
        if (f === "mousedown" && d.current) {
          d.current = void 0;
          return;
        }
        mo(d.current, !0) && u || (n && s && (!a.current.openEvent || a.current.openEvent.type === "click") ? r(!1, p.nativeEvent) : r(!0, p.nativeEvent));
      },
      onKeyDown(p) {
        d.current = void 0, !(p.defaultPrevented || !c || u0(p)) && (p.key === " " && !s0(i) && (p.preventDefault(), g.current = !0), p.key === "Enter" && r(!(n && s), p.nativeEvent));
      },
      onKeyUp(p) {
        p.defaultPrevented || !c || u0(p) || s0(i) || p.key === " " && g.current && (g.current = !1, r(!(n && s), p.nativeEvent));
      }
    }
  } : {}, [o, a, f, u, c, i, s, n, r]);
}
const JD = L[/* @__PURE__ */ "useInsertionEffect".toString()], WD = JD || ((e) => e());
function to(e) {
  const t = L.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return WD(() => {
    t.current = e;
  }), L.useCallback(function() {
    for (var n = arguments.length, r = new Array(n), a = 0; a < n; a++)
      r[a] = arguments[a];
    return t.current == null ? void 0 : t.current(...r);
  }, []);
}
const _D = {
  pointerdown: "onPointerDown",
  mousedown: "onMouseDown",
  click: "onClick"
}, ZD = {
  pointerdown: "onPointerDownCapture",
  mousedown: "onMouseDownCapture",
  click: "onClickCapture"
}, $D = (e) => {
  var t, n;
  return {
    escapeKeyBubbles: typeof e == "boolean" ? e : (t = e == null ? void 0 : e.escapeKey) != null ? t : !1,
    outsidePressBubbles: typeof e == "boolean" ? e : (n = e == null ? void 0 : e.outsidePress) != null ? n : !0
  };
};
function Cc(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    events: a,
    nodeId: i,
    elements: {
      reference: o,
      domReference: f,
      floating: s
    },
    dataRef: u
  } = e, {
    enabled: c = !0,
    escapeKey: d = !0,
    outsidePress: g = !0,
    outsidePressEvent: p = "pointerdown",
    referencePress: h = !1,
    referencePressEvent: l = "pointerdown",
    ancestorScroll: w = !1,
    bubbles: m
  } = t, y = di(), b = _o() != null, C = to(typeof g == "function" ? g : () => !1), M = typeof g == "function" ? C : g, S = L.useRef(!1), {
    escapeKeyBubbles: I,
    outsidePressBubbles: N
  } = $D(m), O = to((Q) => {
    if (!n || !c || !d || Q.key !== "Escape")
      return;
    const T = y ? Ur(y.nodesRef.current, i) : [];
    if (!I && (Q.stopPropagation(), T.length > 0)) {
      let x = !0;
      if (T.forEach((A) => {
        var B;
        if ((B = A.context) != null && B.open && !A.context.dataRef.current.__escapeKeyBubbles) {
          x = !1;
          return;
        }
      }), !x)
        return;
    }
    a.emit("dismiss", {
      type: "escapeKey",
      data: {
        returnFocus: {
          preventScroll: !1
        }
      }
    }), r(!1, b6(Q) ? Q.nativeEvent : Q);
  }), F = to((Q) => {
    const T = S.current;
    if (S.current = !1, T || typeof M == "function" && !M(Q))
      return;
    const x = sc(Q), A = "[" + or("inert") + "]", B = ot(s).querySelectorAll(A);
    let J = it(x) ? x : null;
    for (; J && !g6(J); ) {
      const K = h6(J);
      if (K === ot(s).body || !it(K))
        break;
      J = K;
    }
    if (B.length && it(x) && !C6(x) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
    !$e(x, s) && // If the target root element contains none of the markers, then the
    // element was injected after the floating element rendered.
    Array.from(B).every((K) => !$e(J, K)))
      return;
    if ($r(x) && s) {
      const K = x.clientWidth > 0 && x.scrollWidth > x.clientWidth, P = x.clientHeight > 0 && x.scrollHeight > x.clientHeight;
      let R = P && Q.offsetX > x.clientWidth;
      if (P && p6(x).direction === "rtl" && (R = Q.offsetX <= x.offsetWidth - x.clientWidth), R || K && Q.offsetY > x.clientHeight)
        return;
    }
    const $ = y && Ur(y.nodesRef.current, i).some((K) => {
      var P;
      return Xi(Q, (P = K.context) == null ? void 0 : P.elements.floating);
    });
    if (Xi(Q, s) || Xi(Q, f) || $)
      return;
    const q = y ? Ur(y.nodesRef.current, i) : [];
    if (q.length > 0) {
      let K = !0;
      if (q.forEach((P) => {
        var R;
        if ((R = P.context) != null && R.open && !P.context.dataRef.current.__outsidePressBubbles) {
          K = !1;
          return;
        }
      }), !K)
        return;
    }
    a.emit("dismiss", {
      type: "outsidePress",
      data: {
        returnFocus: b ? {
          preventScroll: !0
        } : m6(Q) || w6(Q)
      }
    }), r(!1, Q);
  });
  return L.useEffect(() => {
    if (!n || !c)
      return;
    u.current.__escapeKeyBubbles = I, u.current.__outsidePressBubbles = N;
    function Q(A) {
      r(!1, A);
    }
    const T = ot(s);
    d && T.addEventListener("keydown", O), M && T.addEventListener(p, F);
    let x = [];
    return w && (it(f) && (x = xn(f)), it(s) && (x = x.concat(xn(s))), !it(o) && o && o.contextElement && (x = x.concat(xn(o.contextElement)))), x = x.filter((A) => {
      var B;
      return A !== ((B = T.defaultView) == null ? void 0 : B.visualViewport);
    }), x.forEach((A) => {
      A.addEventListener("scroll", Q, {
        passive: !0
      });
    }), () => {
      d && T.removeEventListener("keydown", O), M && T.removeEventListener(p, F), x.forEach((A) => {
        A.removeEventListener("scroll", Q);
      });
    };
  }, [u, s, f, o, d, M, p, n, r, w, c, I, N, O, F]), L.useEffect(() => {
    S.current = !1;
  }, [M, p]), L.useMemo(() => c ? {
    reference: {
      onKeyDown: O,
      [_D[l]]: (Q) => {
        h && (a.emit("dismiss", {
          type: "referencePress",
          data: {
            returnFocus: !1
          }
        }), r(!1, Q.nativeEvent));
      }
    },
    floating: {
      onKeyDown: O,
      [ZD[p]]: () => {
        S.current = !0;
      }
    }
  } : {}, [c, a, h, p, l, r, O]);
}
let qu;
process.env.NODE_ENV !== "production" && (qu = /* @__PURE__ */ new Set());
function Zo(e) {
  var t;
  e === void 0 && (e = {});
  const {
    open: n = !1,
    onOpenChange: r,
    nodeId: a
  } = e;
  if (process.env.NODE_ENV !== "production") {
    var i;
    const I = "Floating UI: Cannot pass a virtual element to the `elements.reference` option, as it must be a real DOM element. Use `refs.setPositionReference` instead.";
    if ((i = e.elements) != null && i.reference && !it(e.elements.reference)) {
      var o;
      if (!((o = qu) != null && o.has(I))) {
        var f;
        (f = qu) == null || f.add(I), console.error(I);
      }
    }
  }
  const [s, u] = L.useState(null), c = ((t = e.elements) == null ? void 0 : t.reference) || s, d = fD(e), g = di(), p = to((I, N) => {
    I && (l.current.openEvent = N), r == null || r(I, N);
  }), h = L.useRef(null), l = L.useRef({}), w = L.useState(() => ND())[0], m = li(), y = L.useCallback((I) => {
    const N = it(I) ? {
      getBoundingClientRect: () => I.getBoundingClientRect(),
      contextElement: I
    } : I;
    d.refs.setReference(N);
  }, [d.refs]), b = L.useCallback((I) => {
    (it(I) || I === null) && (h.current = I, u(I)), (it(d.refs.reference.current) || d.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    I !== null && !it(I)) && d.refs.setReference(I);
  }, [d.refs]), C = L.useMemo(() => ({
    ...d.refs,
    setReference: b,
    setPositionReference: y,
    domReference: h
  }), [d.refs, b, y]), M = L.useMemo(() => ({
    ...d.elements,
    domReference: c
  }), [d.elements, c]), S = L.useMemo(() => ({
    ...d,
    refs: C,
    elements: M,
    dataRef: l,
    nodeId: a,
    floatingId: m,
    events: w,
    open: n,
    onOpenChange: p
  }), [d, a, m, w, n, p, C, M]);
  return nt(() => {
    const I = g == null ? void 0 : g.nodesRef.current.find((N) => N.id === a);
    I && (I.context = S);
  }), L.useMemo(() => ({
    ...d,
    context: S,
    refs: C,
    elements: M
  }), [d, C, M, S]);
}
function VD(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    onOpenChange: r,
    dataRef: a,
    events: i,
    refs: o,
    elements: {
      floating: f,
      domReference: s
    }
  } = e, {
    enabled: u = !0,
    keyboardOnly: c = !0
  } = t, d = L.useRef(""), g = L.useRef(!1), p = L.useRef();
  return L.useEffect(() => {
    if (!u)
      return;
    const l = ot(f).defaultView || window;
    function w() {
      !n && $r(s) && s === Jn(ot(s)) && (g.current = !0);
    }
    return l.addEventListener("blur", w), () => {
      l.removeEventListener("blur", w);
    };
  }, [f, s, n, u]), L.useEffect(() => {
    if (!u)
      return;
    function h(l) {
      (l.type === "referencePress" || l.type === "escapeKey") && (g.current = !0);
    }
    return i.on("dismiss", h), () => {
      i.off("dismiss", h);
    };
  }, [i, u]), L.useEffect(() => () => {
    clearTimeout(p.current);
  }, []), L.useMemo(() => u ? {
    reference: {
      onPointerDown(h) {
        let {
          pointerType: l
        } = h;
        d.current = l, g.current = !!(l && c);
      },
      onMouseLeave() {
        g.current = !1;
      },
      onFocus(h) {
        var l;
        g.current || h.type === "focus" && ((l = a.current.openEvent) == null ? void 0 : l.type) === "mousedown" && Xi(a.current.openEvent, s) || r(!0, h.nativeEvent);
      },
      onBlur(h) {
        g.current = !1;
        const l = h.relatedTarget, w = it(l) && l.hasAttribute(or("focus-guard")) && l.getAttribute("data-type") === "outside";
        p.current = setTimeout(() => {
          $e(o.floating.current, l) || $e(s, l) || w || r(!1, h.nativeEvent);
        });
      }
    }
  } : {}, [u, c, s, o, a, r]);
}
function Hf(e, t, n) {
  const r = /* @__PURE__ */ new Map();
  return {
    ...n === "floating" && {
      tabIndex: -1
    },
    ...e,
    ...t.map((a) => a ? a[n] : null).concat(e).reduce((a, i) => (i && Object.entries(i).forEach((o) => {
      let [f, s] = o;
      if (f.indexOf("on") === 0) {
        if (r.has(f) || r.set(f, []), typeof s == "function") {
          var u;
          (u = r.get(f)) == null || u.push(s), a[f] = function() {
            for (var c, d = arguments.length, g = new Array(d), p = 0; p < d; p++)
              g[p] = arguments[p];
            return (c = r.get(f)) == null ? void 0 : c.map((h) => h(...g)).find((h) => h !== void 0);
          };
        }
      } else
        a[f] = s;
    }), a), {})
  };
}
function Mc(e) {
  e === void 0 && (e = []);
  const t = e, n = L.useCallback(
    (i) => Hf(i, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), r = L.useCallback(
    (i) => Hf(i, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), a = L.useCallback(
    (i) => Hf(i, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((i) => i == null ? void 0 : i.item)
  );
  return L.useMemo(() => ({
    getReferenceProps: n,
    getFloatingProps: r,
    getItemProps: a
  }), [n, r, a]);
}
function KD(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    floatingId: r
  } = e, {
    enabled: a = !0,
    role: i = "dialog"
  } = t, o = li();
  return L.useMemo(() => {
    const f = {
      id: r,
      role: i
    };
    return a ? i === "tooltip" ? {
      reference: {
        "aria-describedby": n ? r : void 0
      },
      floating: f
    } : {
      reference: {
        "aria-expanded": n ? "true" : "false",
        "aria-haspopup": i === "alertdialog" ? "dialog" : i,
        "aria-controls": n ? r : void 0,
        ...i === "listbox" && {
          role: "combobox"
        },
        ...i === "menu" && {
          id: o
        }
      },
      floating: {
        ...f,
        ...i === "menu" && {
          "aria-labelledby": o
        }
      }
    } : {};
  }, [a, i, n, r, o]);
}
const c0 = (e) => e.replace(/[A-Z]+(?![a-z])|[A-Z]/g, (t, n) => (n ? "-" : "") + t.toLowerCase());
function Er(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function qD(e, t) {
  const [n, r] = L.useState(e);
  return e && !n && r(!0), L.useEffect(() => {
    if (!e) {
      const a = setTimeout(() => r(!1), t);
      return () => clearTimeout(a);
    }
  }, [e, t]), n;
}
function XD(e, t) {
  t === void 0 && (t = {});
  const {
    open: n,
    elements: {
      floating: r
    }
  } = e, {
    duration: a = 250
  } = t, o = (typeof a == "number" ? a : a.close) || 0, [f, s] = L.useState(!1), [u, c] = L.useState("unmounted"), d = qD(n, o);
  return nt(() => {
    f && !d && c("unmounted");
  }, [f, d]), nt(() => {
    if (r)
      if (n) {
        c("initial");
        const g = requestAnimationFrame(() => {
          c("open");
        });
        return () => {
          cancelAnimationFrame(g);
        };
      } else
        s(!0), c("close");
  }, [n, r]), {
    isMounted: d,
    status: u
  };
}
function eL(e, t) {
  t === void 0 && (t = {});
  const {
    initial: n = {
      opacity: 0
    },
    open: r,
    close: a,
    common: i,
    duration: o = 250
  } = t, f = e.placement, s = f.split("-")[0], u = L.useMemo(() => ({
    side: s,
    placement: f
  }), [s, f]), c = typeof o == "number", d = (c ? o : o.open) || 0, g = (c ? o : o.close) || 0, [p, h] = L.useState(() => ({
    ...Er(i, u),
    ...Er(n, u)
  })), {
    isMounted: l,
    status: w
  } = XD(e, {
    duration: o
  }), m = sn(n), y = sn(r), b = sn(a), C = sn(i);
  return nt(() => {
    const M = Er(m.current, u), S = Er(b.current, u), I = Er(C.current, u), N = Er(y.current, u) || Object.keys(M).reduce((O, F) => (O[F] = "", O), {});
    if (w === "initial" && h((O) => ({
      transitionProperty: O.transitionProperty,
      ...I,
      ...M
    })), w === "open" && h({
      transitionProperty: Object.keys(N).map(c0).join(","),
      transitionDuration: d + "ms",
      ...I,
      ...N
    }), w === "close") {
      const O = S || M;
      h({
        transitionProperty: Object.keys(O).map(c0).join(","),
        transitionDuration: g + "ms",
        ...I,
        ...O
      });
    }
  }, [g, b, m, y, C, d, w, u]), {
    isMounted: l,
    styles: p
  };
}
function l0(e, t) {
  const [n, r] = e;
  let a = !1;
  const i = t.length;
  for (let o = 0, f = i - 1; o < i; f = o++) {
    const [s, u] = t[o] || [0, 0], [c, d] = t[f] || [0, 0];
    u >= r != d >= r && n <= (c - s) * (r - u) / (d - u) + s && (a = !a);
  }
  return a;
}
function tL(e, t) {
  return e[0] >= t.x && e[0] <= t.x + t.width && e[1] >= t.y && e[1] <= t.y + t.height;
}
function nL(e) {
  e === void 0 && (e = {});
  const {
    buffer: t = 0.5,
    blockPointerEvents: n = !1,
    requireIntent: r = !0
  } = e;
  let a, i = !1, o = null, f = null, s = performance.now();
  function u(d, g) {
    const p = performance.now(), h = p - s;
    if (o === null || f === null || h === 0)
      return o = d, f = g, s = p, null;
    const l = d - o, w = g - f, y = Math.sqrt(l * l + w * w) / h;
    return o = d, f = g, s = p, y;
  }
  const c = (d) => {
    let {
      x: g,
      y: p,
      placement: h,
      elements: l,
      onClose: w,
      nodeId: m,
      tree: y
    } = d;
    return function(C) {
      function M() {
        clearTimeout(a), w();
      }
      if (clearTimeout(a), !l.domReference || !l.floating || h == null || g == null || p == null)
        return;
      const {
        clientX: S,
        clientY: I
      } = C, N = [S, I], O = sc(C), F = C.type === "mouseleave", Q = $e(l.floating, O), T = $e(l.domReference, O), x = l.domReference.getBoundingClientRect(), A = l.floating.getBoundingClientRect(), B = h.split("-")[0], J = g > A.right - A.width / 2, $ = p > A.bottom - A.height / 2, q = tL(N, x), K = A.width > x.width, P = A.height > x.height, R = (K ? x : A).left, W = (K ? x : A).right, X = (P ? x : A).top, D = (P ? x : A).bottom;
      if (Q && (i = !0, !F))
        return;
      if (T && (i = !1), T && !F) {
        i = !0;
        return;
      }
      if (F && it(C.relatedTarget) && $e(l.floating, C.relatedTarget) || y && Ur(y.nodesRef.current, m).some((Y) => {
        let {
          context: V
        } = Y;
        return V == null ? void 0 : V.open;
      }))
        return;
      if (B === "top" && p >= x.bottom - 1 || B === "bottom" && p <= x.top + 1 || B === "left" && g >= x.right - 1 || B === "right" && g <= x.left + 1)
        return M();
      let U = [];
      switch (B) {
        case "top":
          U = [[R, x.top + 1], [R, A.bottom - 1], [W, A.bottom - 1], [W, x.top + 1]];
          break;
        case "bottom":
          U = [[R, A.top + 1], [R, x.bottom - 1], [W, x.bottom - 1], [W, A.top + 1]];
          break;
        case "left":
          U = [[A.right - 1, D], [A.right - 1, X], [x.left + 1, X], [x.left + 1, D]];
          break;
        case "right":
          U = [[x.right - 1, D], [x.right - 1, X], [A.left + 1, X], [A.left + 1, D]];
          break;
      }
      function k(Y) {
        let [V, Z] = Y;
        switch (B) {
          case "top": {
            const re = [K ? V + t / 2 : J ? V + t * 4 : V - t * 4, Z + t + 1], ce = [K ? V - t / 2 : J ? V + t * 4 : V - t * 4, Z + t + 1], _ = [[A.left, J || K ? A.bottom - t : A.top], [A.right, J ? K ? A.bottom - t : A.top : A.bottom - t]];
            return [re, ce, ..._];
          }
          case "bottom": {
            const re = [K ? V + t / 2 : J ? V + t * 4 : V - t * 4, Z - t], ce = [K ? V - t / 2 : J ? V + t * 4 : V - t * 4, Z - t], _ = [[A.left, J || K ? A.top + t : A.bottom], [A.right, J ? K ? A.top + t : A.bottom : A.top + t]];
            return [re, ce, ..._];
          }
          case "left": {
            const re = [V + t + 1, P ? Z + t / 2 : $ ? Z + t * 4 : Z - t * 4], ce = [V + t + 1, P ? Z - t / 2 : $ ? Z + t * 4 : Z - t * 4];
            return [...[[$ || P ? A.right - t : A.left, A.top], [$ ? P ? A.right - t : A.left : A.right - t, A.bottom]], re, ce];
          }
          case "right": {
            const re = [V - t, P ? Z + t / 2 : $ ? Z + t * 4 : Z - t * 4], ce = [V - t, P ? Z - t / 2 : $ ? Z + t * 4 : Z - t * 4], _ = [[$ || P ? A.left + t : A.right, A.top], [$ ? P ? A.left + t : A.right : A.left + t, A.bottom]];
            return [re, ce, ..._];
          }
        }
      }
      if (!l0([S, I], U)) {
        if (i && !q)
          return M();
        if (!F && r) {
          const Y = u(C.clientX, C.clientY);
          if (Y !== null && Y < 0.1)
            return M();
        }
        l0([S, I], k([g, p])) ? !i && r && (a = window.setTimeout(M, 40)) : M();
      }
    };
  };
  return c.__options = {
    blockPointerEvents: n
  }, c;
}
const rL = fr(
  ({ middlewareData: e, placement: t, update: n }, r) => {
    const { arrow: a } = e, { x: i, y: o } = a ?? {};
    if (ri(() => {
      a && n();
    }), !a)
      return null;
    const f = {
      top: "bottom",
      right: "left",
      bottom: "top",
      left: "right"
    }[t.split("-")[0]] || "", s = {
      left: i != null ? `${i}px` : "",
      top: o != null ? `${o}px` : "",
      right: "",
      bottom: "",
      [f]: "-5px"
    };
    return /* @__PURE__ */ E(
      "div",
      {
        ref: r,
        className: `absolute bg-white w-2 h-2 rotate-45 ${{
          top: "border-t border-l",
          right: "border-t border-r",
          bottom: "border-b border-r",
          left: "border-b border-l"
        }[f]} border-purple-100`,
        style: s
      }
    );
  }
), Wt = ({
  children: e,
  content: t,
  placement: n = "bottom",
  blockPointerEvents: r = !1,
  withArrow: a = !0,
  className: i = "",
  alwaysOpen: o = !1
}) => {
  const f = Ce(null), [s, u] = ie(!1), c = s || o, d = hp(), { x: g, y: p, refs: h, strategy: l, context: w, middlewareData: m, placement: y, update: b } = Zo({
    nodeId: d,
    open: c,
    onOpenChange: u,
    placement: n,
    middleware: [
      sD(5),
      Wo(),
      Jo({ padding: 5 }),
      cD({ element: f })
    ],
    whileElementsMounted: mc
  }), { getReferenceProps: C, getFloatingProps: M } = Mc([
    BD(w, {
      // how long the cursor should be at rest before displaying the tooltip
      restMs: 300,
      // when hovering/leaving the element, how long to wait before opening/closing the tooltip
      delay: { open: 500, close: 150 },
      handleClose: nL({
        // when set to true, users are unable to select/interact with content inside of tooltip
        blockPointerEvents: r
      })
    }),
    VD(w),
    KD(w, { role: "tooltip" }),
    Cc(w, {
      ancestorScroll: !0
    })
  ]);
  if (!t)
    return e;
  const S = {
    position: l,
    top: p ?? 0,
    left: g ?? 0,
    zIndex: 69
  };
  return /* @__PURE__ */ ue(Ua, { children: [
    /* @__PURE__ */ E(
      "div",
      {
        ref: h.setReference,
        ...C(),
        className: i,
        children: e
      }
    ),
    /* @__PURE__ */ E(vp, { id: d, children: c && /* @__PURE__ */ E(Mp, { children: /* @__PURE__ */ ue(
      "div",
      {
        ref: h.setFloating,
        style: S,
        ...M(),
        className: "bg-white border border-purple-100 px-2 py-1 rounded text-purple-800 text-xs",
        children: [
          t,
          a && /* @__PURE__ */ E(
            rL,
            {
              middlewareData: m,
              placement: y,
              update: b,
              ref: f
            }
          )
        ]
      }
    ) }) })
  ] });
}, aL = ({ src: e, alt: t, size: n, ...r }) => /* @__PURE__ */ E(
  "img",
  {
    width: n,
    height: n,
    src: e,
    alt: t,
    referrerPolicy: "no-referrer",
    className: "rounded-full",
    ...r
  }
), iL = (e) => {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    t = Math.imul(31, t) + e.charCodeAt(n) | 0;
  return t;
}, d0 = [
  "#FD9E9E",
  "#FE8786",
  "#FE6F6F",
  "#FF5858",
  "#FEDF70",
  "#FED74D",
  "#FFD02B",
  "#FFC908",
  "#84C3FE",
  "#68B6FE",
  "#4CA9FF",
  "#309CFF",
  "#84EBFE",
  "#68E5FE",
  "#4CE0FF",
  "#30DAFF",
  "#79E1C6",
  "#54D8B7",
  "#30D0A9",
  "#0CC79A",
  "#C9D2FA",
  "#A8B4F6",
  "#838CF1",
  "#6466E9",
  "#C0C6EB",
  "#AEB6E6",
  "#9CA6E0",
  "#8695E0"
], oL = (e, t) => Math.abs(iL(e)) % t, fL = (e) => d0[oL(e, d0.length)], Lp = (e) => /* @__PURE__ */ L.createElement("svg", { width: 15, height: 13, viewBox: "0 0 15 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 4.75016C5 6.03883 6.11929 7.0835 7.5 7.0835C8.88071 7.0835 10 6.03883 10 4.75016C10 3.4615 8.88071 2.41683 7.5 2.41683C6.11929 2.41683 5 3.4615 5 4.75016ZM6.25 4.75016C6.25 5.3945 6.80964 5.91683 7.5 5.91683C8.19036 5.91683 8.75 5.3945 8.75 4.75016C8.75 4.10583 8.19036 3.5835 7.5 3.5835C6.80964 3.5835 6.25 4.10583 6.25 4.75016Z", fill: "#727684" }), /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.5 0.0834961C11.297 0.0834961 14.375 2.95634 14.375 6.50016C14.375 10.044 11.297 12.9168 7.5 12.9168C3.70304 12.9168 0.625 10.044 0.625 6.50016C0.625 2.95634 3.70304 0.0834961 7.5 0.0834961ZM13.125 6.50016C13.125 7.71945 12.6797 8.84166 11.9325 9.73282C10.9047 8.47702 9.28358 7.66683 7.4597 7.66683C5.65948 7.66683 4.05678 8.45613 3.02719 9.68417C2.30435 8.80098 1.875 7.69737 1.875 6.50016C1.875 3.60067 4.3934 1.25016 7.5 1.25016C10.6066 1.25016 13.125 3.60067 13.125 6.50016ZM7.5 11.7502C8.8439 11.7502 10.0777 11.3103 11.0452 10.5764C10.254 9.52254 8.94309 8.8335 7.4597 8.8335C5.99472 8.8335 4.69792 9.50554 3.90389 10.5373C4.87883 11.2947 6.13242 11.7502 7.5 11.7502Z", fill: "#727684" })), uL = (e) => {
  var r;
  const t = e.trim().split(" ");
  let n = ((r = t[0][0]) == null ? void 0 : r.toUpperCase()) || "";
  return t.length > 1 && (n += t[t.length - 1][0].toUpperCase()), n;
}, sL = ({
  name: e,
  className: t = "",
  colorSeed: n,
  ...r
}) => /* @__PURE__ */ E(
  "div",
  {
    className: `flex items-center justify-center rounded-full ${t}`,
    style: n ? {
      backgroundColor: fL(n)
    } : void 0,
    ...r,
    children: uL(e)
  }
), Ap = ({
  src: e,
  name: t,
  fancyBorder: n,
  size: r,
  alt: a,
  className: i,
  colorSeed: o,
  ...f
}) => /* @__PURE__ */ E(
  "div",
  {
    className: `flex w-fit justify-center items-center rounded-full  ${// current user gets a special border
    n ? `bg-flywheel-gradient ${n}` : ""}`,
    children: e ? /* @__PURE__ */ E(
      aL,
      {
        size: r,
        src: e,
        alt: a,
        className: i,
        ...f
      }
    ) : t ? /* @__PURE__ */ E(
      sL,
      {
        name: t,
        className: i,
        colorSeed: o,
        ...f
      }
    ) : /* @__PURE__ */ E(Lp, { className: uc(i, "fill-gray-400") })
  }
), Ep = ({
  id: e,
  name: t,
  email: n
}) => /* @__PURE__ */ ue("div", { className: "flex items-center w-fit", children: [
  /* @__PURE__ */ E(
    Ap,
    {
      alt: `${t}-profile-avatar`,
      size: 56,
      name: t,
      className: "w-6 h-6 text-white text-xs",
      colorSeed: e
    }
  ),
  /* @__PURE__ */ ue("div", { className: "ml-2", children: [
    /* @__PURE__ */ E("div", { className: "font-medium text-xs", children: t }),
    n && /* @__PURE__ */ E("div", { className: "text-[10px]", children: n })
  ] })
] }), cL = ({
  attributes: e,
  children: t,
  element: n
}) => {
  const r = Ig(), a = Og(), i = {
    padding: "3px 3px 2px",
    margin: "0 1px",
    verticalAlign: "baseline",
    display: "inline-block",
    borderRadius: "4px",
    fontSize: "0.9em"
  }, { userId: o, name: f, email: s } = n;
  return /* @__PURE__ */ E(
    "span",
    {
      ...e,
      contentEditable: !1,
      style: i,
      className: uc(
        "bg-indigo-50",
        r && a && "shadow-[0_0_0_2px] shadow-indigo-100"
      ),
      children: /* @__PURE__ */ ue(
        Wt,
        {
          content: /* @__PURE__ */ E(Ep, { id: o, name: f, email: s }),
          placement: "top",
          children: [
            /* @__PURE__ */ ue(oc, { leaf: n.children[0], children: [
              "@",
              f
            ] }),
            t
          ]
        }
      )
    }
  );
}, lr = fr(
  ({ active: e, onMouseDown: t, ...n }, r) => /* @__PURE__ */ E(
    "button",
    {
      ...n,
      ref: r,
      className: `${e ? "opacity-100 bg-slate-200" : "opacity-60 bg-transparent"} p-0 w-7 h-7 rounded-sm flex justify-center items-center`,
      onMouseDown: (a) => {
        a.preventDefault(), t == null || t(a);
      }
    }
  )
), lL = (e) => /* @__PURE__ */ L.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("rect", { width: 20, height: 20, rx: 3, fill: "#EFF2FE" }), /* @__PURE__ */ L.createElement("path", { d: "M17.8125 3.75V5.9375C17.8125 6.18614 17.7137 6.4246 17.5379 6.60041C17.3621 6.77623 17.1236 6.875 16.875 6.875C16.6264 6.875 16.3879 6.77623 16.2121 6.60041C16.0363 6.4246 15.9375 6.18614 15.9375 5.9375V4.0625H14.0625C13.8139 4.0625 13.5754 3.96373 13.3996 3.78791C13.2238 3.6121 13.125 3.37364 13.125 3.125C13.125 2.87636 13.2238 2.6379 13.3996 2.46209C13.5754 2.28627 13.8139 2.1875 14.0625 2.1875H16.25C16.6644 2.1875 17.0618 2.35212 17.3549 2.64515C17.6479 2.93817 17.8125 3.3356 17.8125 3.75ZM16.875 13.125C16.6264 13.125 16.3879 13.2238 16.2121 13.3996C16.0363 13.5754 15.9375 13.8139 15.9375 14.0625V15.9375H14.0625C13.8139 15.9375 13.5754 16.0363 13.3996 16.2121C13.2238 16.3879 13.125 16.6264 13.125 16.875C13.125 17.1236 13.2238 17.3621 13.3996 17.5379C13.5754 17.7137 13.8139 17.8125 14.0625 17.8125H16.25C16.6644 17.8125 17.0618 17.6479 17.3549 17.3549C17.6479 17.0618 17.8125 16.6644 17.8125 16.25V14.0625C17.8125 13.8139 17.7137 13.5754 17.5379 13.3996C17.3621 13.2238 17.1236 13.125 16.875 13.125ZM5.9375 15.9375H4.0625V14.0625C4.0625 13.8139 3.96373 13.5754 3.78791 13.3996C3.6121 13.2238 3.37364 13.125 3.125 13.125C2.87636 13.125 2.6379 13.2238 2.46209 13.3996C2.28627 13.5754 2.1875 13.8139 2.1875 14.0625V16.25C2.1875 16.6644 2.35212 17.0618 2.64515 17.3549C2.93817 17.6479 3.3356 17.8125 3.75 17.8125H5.9375C6.18614 17.8125 6.4246 17.7137 6.60041 17.5379C6.77623 17.3621 6.875 17.1236 6.875 16.875C6.875 16.6264 6.77623 16.3879 6.60041 16.2121C6.4246 16.0363 6.18614 15.9375 5.9375 15.9375ZM3.125 6.875C3.37364 6.875 3.6121 6.77623 3.78791 6.60041C3.96373 6.4246 4.0625 6.18614 4.0625 5.9375V4.0625H5.9375C6.18614 4.0625 6.4246 3.96373 6.60041 3.78791C6.77623 3.6121 6.875 3.37364 6.875 3.125C6.875 2.87636 6.77623 2.6379 6.60041 2.46209C6.4246 2.28627 6.18614 2.1875 5.9375 2.1875H3.75C3.3356 2.1875 2.93817 2.35212 2.64515 2.64515C2.35212 2.93817 2.1875 3.3356 2.1875 3.75V5.9375C2.1875 6.18614 2.28627 6.4246 2.46209 6.60041C2.6379 6.77623 2.87636 6.875 3.125 6.875ZM13.75 14.0625C13.6045 14.0626 13.461 14.0288 13.3309 13.9639C13.2007 13.8989 13.0874 13.8046 13 13.6883C12.6507 13.2222 12.1977 12.844 11.6769 12.5834C11.156 12.3229 10.5816 12.1872 9.99922 12.1872C9.41683 12.1872 8.84244 12.3229 8.32159 12.5834C7.80073 12.844 7.34771 13.2222 6.99844 13.6883C6.84725 13.8819 6.62608 14.0085 6.38252 14.0407C6.13896 14.073 5.89248 14.0083 5.69611 13.8607C5.49973 13.7131 5.36916 13.4942 5.33249 13.2513C5.29581 13.0084 5.35596 12.7607 5.5 12.5617C5.99725 11.8966 6.63539 11.3497 7.36875 10.9602C6.94727 10.4591 6.67763 9.84819 6.59156 9.19916C6.50548 8.55013 6.60655 7.89001 6.88286 7.29646C7.15918 6.70291 7.59926 6.20061 8.15133 5.84866C8.7034 5.4967 9.3445 5.30973 9.99922 5.30973C10.6539 5.30973 11.295 5.4967 11.8471 5.84866C12.3992 6.20061 12.8393 6.70291 13.1156 7.29646C13.3919 7.89001 13.493 8.55013 13.4069 9.19916C13.3208 9.84819 13.0512 10.4591 12.6297 10.9602C13.363 11.3497 14.0012 11.8966 14.4984 12.5617C14.603 12.7009 14.6668 12.8664 14.6826 13.0398C14.6985 13.2132 14.6657 13.3876 14.588 13.5434C14.5103 13.6992 14.3907 13.8303 14.2427 13.922C14.0947 14.0137 13.9241 14.0623 13.75 14.0625ZM10 10.3125C10.309 10.3125 10.6111 10.2209 10.8681 10.0492C11.125 9.87748 11.3253 9.63345 11.4436 9.34794C11.5618 9.06243 11.5928 8.74827 11.5325 8.44517C11.4722 8.14208 11.3234 7.86367 11.1049 7.64515C10.8863 7.42663 10.6079 7.27781 10.3048 7.21752C10.0017 7.15723 9.68757 7.18818 9.40206 7.30644C9.11655 7.4247 8.87252 7.62497 8.70083 7.88192C8.52914 8.13887 8.4375 8.44097 8.4375 8.75C8.4375 9.1644 8.60212 9.56183 8.89515 9.85485C9.18817 10.1479 9.5856 10.3125 10 10.3125Z" })), dL = (e) => /* @__PURE__ */ L.createElement("svg", { width: 14, height: 11, viewBox: "0 0 14 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M9.91659 7.25H11.0833V8.41667H9.91659V7.25Z", fill: "#727684" }), /* @__PURE__ */ L.createElement("path", { d: "M11.0833 4.91667H9.91659V6.08333H11.0833V4.91667Z", fill: "#727684" }), /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.58325 2.58333H13.4166V10.75H0.583252V0.25H7.58325V2.58333ZM4.66659 1.41667H6.41659V2.58333H4.66659V1.41667ZM6.41659 9.58333V8.41667H4.66659V9.58333H6.41659ZM6.41659 7.25V6.08333H4.66659V7.25H6.41659ZM6.41659 4.91667V3.75H4.66659V4.91667H6.41659ZM12.2499 9.58333V3.75H7.58325V4.91667H8.74992V6.08333H7.58325V7.25H8.74992V8.41667H7.58325V9.58333H12.2499ZM1.74992 9.58333V8.41667H3.49992V9.58333H1.74992ZM1.74992 7.25H3.49992V6.08333H1.74992V7.25ZM3.49992 4.91667V3.75H1.74992V4.91667H3.49992ZM1.74992 2.58333H3.49992V1.41667H1.74992V2.58333Z", fill: "#727684" })), gL = "_button_iiuif_1", pL = "_input_iiuif_15", hL = "_label_iiuif_24", ke = {
  button: gL,
  "button--primary": "_button--primary_iiuif_5 _button_iiuif_1",
  "button--disabled": "_button--disabled_iiuif_10 _button_iiuif_1",
  input: pL,
  "input--invalid": "_input--invalid_iiuif_19 _input_iiuif_15",
  label: hL,
  "label--invalid": "_label--invalid_iiuif_28 _label_iiuif_24",
  "select-dropdown": "_select-dropdown_iiuif_33",
  "select-option": "_select-option_iiuif_37",
  "select-value": "_select-value_iiuif_41",
  "select-value-active": "_select-value-active_iiuif_45 _select-value_iiuif_41"
}, jp = (e) => /* @__PURE__ */ L.createElement("svg", { width: 8, height: 11, viewBox: "0 0 8 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M7.98279 3.76586L7.03998 4.70867L4.21155 1.88025L1.38312 4.70867L0.440316 3.76586L4.21155 -0.00537109L7.98279 3.76586Z", fill: "#727684" }), /* @__PURE__ */ L.createElement("path", { d: "M7.98279 6.95682L7.03998 6.01401L4.21155 8.84244L1.38312 6.01401L0.440316 6.95682L4.21155 10.7281L7.98279 6.95682Z", fill: "#727684" }));
function Ip({
  placeholder: e = "Select",
  value: t,
  options: n,
  onChange: r
}) {
  var s;
  const [a, i] = ie(!1), o = ((s = n.find((u) => u.value === t)) == null ? void 0 : s.label) || e, f = (u) => {
    i(!1), r(u);
  };
  return le(() => {
    const u = () => i(!1);
    return qt(document, "mousedown", u), () => cn(document, "mousedown", u);
  }, []), /* @__PURE__ */ ue("div", { className: "relative text-sm whitespace-nowrap bg-white", children: [
    /* @__PURE__ */ ue(
      "div",
      {
        onMouseDown: (u) => {
          u.preventDefault(), u.stopPropagation(), i(!a);
        },
        className: t ? ke["select-value-active"] : ke["select-value"],
        children: [
          !t && /* @__PURE__ */ E(jp, { className: "mr-2" }),
          /* @__PURE__ */ E("div", { children: o })
        ]
      }
    ),
    a && /* @__PURE__ */ E(
      "div",
      {
        className: ke["select-dropdown"],
        onMouseDown: (u) => u.stopPropagation(),
        children: /* @__PURE__ */ E("ul", { className: "px-1", children: n.map(({ label: u, value: c }) => /* @__PURE__ */ E(
          "li",
          {
            onClick: () => f(c),
            className: ke["select-option"],
            children: /* @__PURE__ */ E("div", { children: u })
          },
          c == null ? void 0 : c.toString()
        )) })
      }
    )
  ] });
}
const dr = (e) => !v.isEditor(e) && fe.isElement(e), Sp = (e) => dr(e) && e.type === "variable", vL = (e) => {
  const [t] = v.nodes(e, {
    match: (n) => Sp(n)
  });
  return t ? t[0] : void 0;
}, mL = (e) => {
  H.removeNodes(e, {
    match: (t) => !v.isEditor(t) && Sp(t)
  });
}, wL = (e, t, n) => {
  const r = {
    type: "variable",
    interpolatedValue: t,
    defaultValue: n,
    // fancy mustache is/else statement
    // https://stackoverflow.com/questions/6027525/how-do-i-accomplish-an-if-else-in-mustache-js
    value: `{{#${t}}}{{${t}}}{{/${t}}}{{^${t}}}${n}{{/${t}}}`,
    children: [{ text: "" }]
  };
  H.insertNodes(e, r), H.move(e);
};
function yL(e) {
  const t = ae.createContext(void 0);
  function n() {
    const r = ae.useContext(t);
    if (r === void 0)
      throw new Error(
        `You are using the ${e} hook outside of its Provider, or the value passed to the Provider is undefined.`
      );
    return r;
  }
  return [n, t.Provider];
}
const [gr, bL] = yL("toolbarMenu"), CL = ({
  mediaHandler: e,
  maxHeight: t,
  maxWidth: n,
  children: r
}) => {
  const [a, i] = ie(null);
  return /* @__PURE__ */ E(
    bL,
    {
      value: {
        activeMenu: a,
        setActiveMenu: i,
        close: () => i(null),
        mediaHandler: e,
        maxHeight: t,
        maxWidth: n
      },
      children: r
    }
  );
}, xp = (e) => {
  const [t, n] = e.split("."), r = t === "contact" ? Lp : dL, a = Ya(`${t} ${Ya(n)}`);
  return /* @__PURE__ */ ue("span", { className: "inline-flex items-center", children: [
    /* @__PURE__ */ E(r, { className: "mr-2" }),
    a
  ] });
}, ML = [
  "contact.firstName",
  "contact.lastName",
  "contact.name",
  "contact.email",
  "contact.department",
  "account.name",
  "account.industry"
], DL = ML.map((e) => ({ label: xp(e), value: e })), LL = () => {
  const e = yt(), { activeMenu: t, setActiveMenu: n, close: r } = gr(), [a, i] = ie(), [o, f] = ie("");
  le(() => {
    const d = () => s();
    return qt(document, "mousedown", d), () => cn(document, "mousedown", d);
  }, []), le(() => {
    if (t === "VARIABLE") {
      const d = vL(e);
      if (!d)
        return;
      i(d.interpolatedValue), f(d.defaultValue);
    }
  }, [t]);
  const s = () => {
    i(void 0), f(""), r();
  };
  return /* @__PURE__ */ ue("div", { className: "relative", children: [
    /* @__PURE__ */ E(Wt, { content: "Insert personalization", placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        onMouseDown: (d) => {
          d.preventDefault(), d.stopPropagation(), n("VARIABLE");
        },
        children: /* @__PURE__ */ E(lL, {})
      }
    ) }),
    t === "VARIABLE" && /* @__PURE__ */ ue(
      "div",
      {
        onMouseDown: (d) => d.stopPropagation(),
        className: "absolute flex gap-4 flex-col bg-white z-10 p-2.5 border border-purple-100 rounded-md w-64 whitespace-nowrap",
        children: [
          /* @__PURE__ */ E("div", { className: "font-semibold", children: "Personalization" }),
          /* @__PURE__ */ ue("div", { className: "flex flex-col gap-2.5 text-sm", children: [
            /* @__PURE__ */ ue(
              "label",
              {
                htmlFor: "interpolatedValue",
                className: "flex items-center justify-between",
                children: [
                  /* @__PURE__ */ E("span", { children: "Property" }),
                  /* @__PURE__ */ E(
                    Ip,
                    {
                      value: a,
                      options: DL,
                      onChange: (d) => i(d),
                      placeholder: "Select property"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ ue(
              "label",
              {
                htmlFor: "defaultValue",
                className: "flex items-center justify-between",
                children: [
                  /* @__PURE__ */ E("p", { children: "Default value" }),
                  /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
                    "input",
                    {
                      className: "w-32 border border-purple-100 px-2 py-1 rounded-md",
                      placeholder: "Default value",
                      value: o,
                      onChange: (d) => f(d.target.value)
                    }
                  ) })
                ]
              }
            )
          ] }),
          /* @__PURE__ */ ue("div", { className: "flex gap-1 justify-end text-xs", children: [
            /* @__PURE__ */ E(
              "button",
              {
                className: "py-1 px-2 rounded-sm bg-purple-100 text-purple-900",
                onClick: (d) => {
                  d.preventDefault(), s(), G.focus(e);
                },
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ E(
              "button",
              {
                className: "py-1 px-2 rounded-sm bg-indigo-500 text-white",
                onClick: (d) => {
                  d.preventDefault(), mL(e), a && wL(e, a, o), s(), G.focus(e);
                },
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  ] });
}, AL = ({
  attributes: e,
  element: t,
  readOnly: n,
  children: r
}) => {
  const { interpolatedValue: a, value: i } = t, { setActiveMenu: o } = gr();
  return /* @__PURE__ */ ue(
    "span",
    {
      ...e,
      contentEditable: !1,
      className: n ? "" : "bg-purple-100 inline px-1.5 py-0.5 mx-1 rounded-md",
      onDoubleClick: (f) => {
        f.stopPropagation(), o("VARIABLE");
      },
      children: [
        /* @__PURE__ */ E(oc, { leaf: t.children[0], children: n ? i : xp(a) }),
        r
      ]
    }
  );
}, Dc = (e) => dr(e) && e.type === "media", Tp = (e) => {
  const [t] = v.nodes(e, {
    match: (n) => Dc(n)
  });
  return t ? t[0] : void 0;
}, EL = (e) => {
  H.removeNodes(e, {
    match: (t) => !v.isEditor(t) && Dc(t)
  });
}, g0 = (e, t, n, r, a, i) => {
  const o = {
    type: "media",
    mediaLink: t,
    mediaType: n,
    mediaAlt: r,
    extension: a,
    style: i,
    children: [{ text: "" }]
  };
  H.insertNodes(e, o), H.move(e);
}, p0 = (e, { height: t, width: n }) => {
  const r = Tp(e);
  r && e.setNodes(
    { style: { ...r.style, height: `${t}px`, width: `${n}px` } },
    { match: (a) => Dc(a) }
  );
};
var Lc = { exports: {} }, gi = {}, $o = { exports: {} }, Np = {}, Xu = { exports: {} }, zi = { exports: {} }, xe = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h0;
function jL() {
  if (h0)
    return xe;
  h0 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, l = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
  function b(M) {
    if (typeof M == "object" && M !== null) {
      var S = M.$$typeof;
      switch (S) {
        case t:
          switch (M = M.type, M) {
            case s:
            case u:
            case r:
            case i:
            case a:
            case d:
              return M;
            default:
              switch (M = M && M.$$typeof, M) {
                case f:
                case c:
                case h:
                case p:
                case o:
                  return M;
                default:
                  return S;
              }
          }
        case n:
          return S;
      }
    }
  }
  function C(M) {
    return b(M) === u;
  }
  return xe.AsyncMode = s, xe.ConcurrentMode = u, xe.ContextConsumer = f, xe.ContextProvider = o, xe.Element = t, xe.ForwardRef = c, xe.Fragment = r, xe.Lazy = h, xe.Memo = p, xe.Portal = n, xe.Profiler = i, xe.StrictMode = a, xe.Suspense = d, xe.isAsyncMode = function(M) {
    return C(M) || b(M) === s;
  }, xe.isConcurrentMode = C, xe.isContextConsumer = function(M) {
    return b(M) === f;
  }, xe.isContextProvider = function(M) {
    return b(M) === o;
  }, xe.isElement = function(M) {
    return typeof M == "object" && M !== null && M.$$typeof === t;
  }, xe.isForwardRef = function(M) {
    return b(M) === c;
  }, xe.isFragment = function(M) {
    return b(M) === r;
  }, xe.isLazy = function(M) {
    return b(M) === h;
  }, xe.isMemo = function(M) {
    return b(M) === p;
  }, xe.isPortal = function(M) {
    return b(M) === n;
  }, xe.isProfiler = function(M) {
    return b(M) === i;
  }, xe.isStrictMode = function(M) {
    return b(M) === a;
  }, xe.isSuspense = function(M) {
    return b(M) === d;
  }, xe.isValidElementType = function(M) {
    return typeof M == "string" || typeof M == "function" || M === r || M === u || M === i || M === a || M === d || M === g || typeof M == "object" && M !== null && (M.$$typeof === h || M.$$typeof === p || M.$$typeof === o || M.$$typeof === f || M.$$typeof === c || M.$$typeof === w || M.$$typeof === m || M.$$typeof === y || M.$$typeof === l);
  }, xe.typeOf = b, xe;
}
var Te = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var v0;
function IL() {
  return v0 || (v0 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, f = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, l = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, m = e ? Symbol.for("react.responder") : 60118, y = e ? Symbol.for("react.scope") : 60119;
    function b(_) {
      return typeof _ == "string" || typeof _ == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      _ === r || _ === u || _ === i || _ === a || _ === d || _ === g || typeof _ == "object" && _ !== null && (_.$$typeof === h || _.$$typeof === p || _.$$typeof === o || _.$$typeof === f || _.$$typeof === c || _.$$typeof === w || _.$$typeof === m || _.$$typeof === y || _.$$typeof === l);
    }
    function C(_) {
      if (typeof _ == "object" && _ !== null) {
        var Le = _.$$typeof;
        switch (Le) {
          case t:
            var he = _.type;
            switch (he) {
              case s:
              case u:
              case r:
              case i:
              case a:
              case d:
                return he;
              default:
                var We = he && he.$$typeof;
                switch (We) {
                  case f:
                  case c:
                  case h:
                  case p:
                  case o:
                    return We;
                  default:
                    return Le;
                }
            }
          case n:
            return Le;
        }
      }
    }
    var M = s, S = u, I = f, N = o, O = t, F = c, Q = r, T = h, x = p, A = n, B = i, J = a, $ = d, q = !1;
    function K(_) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), P(_) || C(_) === s;
    }
    function P(_) {
      return C(_) === u;
    }
    function R(_) {
      return C(_) === f;
    }
    function W(_) {
      return C(_) === o;
    }
    function X(_) {
      return typeof _ == "object" && _ !== null && _.$$typeof === t;
    }
    function D(_) {
      return C(_) === c;
    }
    function U(_) {
      return C(_) === r;
    }
    function k(_) {
      return C(_) === h;
    }
    function Y(_) {
      return C(_) === p;
    }
    function V(_) {
      return C(_) === n;
    }
    function Z(_) {
      return C(_) === i;
    }
    function re(_) {
      return C(_) === a;
    }
    function ce(_) {
      return C(_) === d;
    }
    Te.AsyncMode = M, Te.ConcurrentMode = S, Te.ContextConsumer = I, Te.ContextProvider = N, Te.Element = O, Te.ForwardRef = F, Te.Fragment = Q, Te.Lazy = T, Te.Memo = x, Te.Portal = A, Te.Profiler = B, Te.StrictMode = J, Te.Suspense = $, Te.isAsyncMode = K, Te.isConcurrentMode = P, Te.isContextConsumer = R, Te.isContextProvider = W, Te.isElement = X, Te.isForwardRef = D, Te.isFragment = U, Te.isLazy = k, Te.isMemo = Y, Te.isPortal = V, Te.isProfiler = Z, Te.isStrictMode = re, Te.isSuspense = ce, Te.isValidElementType = b, Te.typeOf = C;
  }()), Te;
}
var m0;
function kp() {
  return m0 || (m0 = 1, process.env.NODE_ENV === "production" ? zi.exports = jL() : zi.exports = IL()), zi.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Qf, w0;
function SL() {
  if (w0)
    return Qf;
  w0 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, f = 0; f < 10; f++)
        o["_" + String.fromCharCode(f)] = f;
      var s = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        u[c] = c;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Qf = a() ? Object.assign : function(i, o) {
    for (var f, s = r(i), u, c = 1; c < arguments.length; c++) {
      f = Object(arguments[c]);
      for (var d in f)
        t.call(f, d) && (s[d] = f[d]);
      if (e) {
        u = e(f);
        for (var g = 0; g < u.length; g++)
          n.call(f, u[g]) && (s[u[g]] = f[u[g]]);
      }
    }
    return s;
  }, Qf;
}
var Jf, y0;
function Ac() {
  if (y0)
    return Jf;
  y0 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Jf = e, Jf;
}
var Wf, b0;
function Bp() {
  return b0 || (b0 = 1, Wf = Function.call.bind(Object.prototype.hasOwnProperty)), Wf;
}
var _f, C0;
function xL() {
  if (C0)
    return _f;
  C0 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = Ac(), n = {}, r = Bp();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, f, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in i)
        if (r(i, c)) {
          var d;
          try {
            if (typeof i[c] != "function") {
              var g = Error(
                (s || "React class") + ": " + f + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            d = i[c](o, c, s, f, null, t);
          } catch (h) {
            d = h;
          }
          if (d && !(d instanceof Error) && e(
            (s || "React class") + ": type specification of " + f + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in n)) {
            n[d.message] = !0;
            var p = u ? u() : "";
            e(
              "Failed " + f + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, _f = a, _f;
}
var Zf, M0;
function TL() {
  if (M0)
    return Zf;
  M0 = 1;
  var e = kp(), t = SL(), n = Ac(), r = Bp(), a = xL(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(f) {
    var s = "Warning: " + f;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return Zf = function(f, s) {
    var u = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function d(P) {
      var R = P && (u && P[u] || P[c]);
      if (typeof R == "function")
        return R;
    }
    var g = "<<anonymous>>", p = {
      array: m("array"),
      bigint: m("bigint"),
      bool: m("boolean"),
      func: m("function"),
      number: m("number"),
      object: m("object"),
      string: m("string"),
      symbol: m("symbol"),
      any: y(),
      arrayOf: b,
      element: C(),
      elementType: M(),
      instanceOf: S,
      node: F(),
      objectOf: N,
      oneOf: I,
      oneOfType: O,
      shape: T,
      exact: x
    };
    function h(P, R) {
      return P === R ? P !== 0 || 1 / P === 1 / R : P !== P && R !== R;
    }
    function l(P, R) {
      this.message = P, this.data = R && typeof R == "object" ? R : {}, this.stack = "";
    }
    l.prototype = Error.prototype;
    function w(P) {
      if (process.env.NODE_ENV !== "production")
        var R = {}, W = 0;
      function X(U, k, Y, V, Z, re, ce) {
        if (V = V || g, re = re || Y, ce !== n) {
          if (s) {
            var _ = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw _.name = "Invariant Violation", _;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Le = V + ":" + Y;
            !R[Le] && // Avoid spamming the console because they are often not actionable except for lib authors
            W < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + re + "` prop on `" + V + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), R[Le] = !0, W++);
          }
        }
        return k[Y] == null ? U ? k[Y] === null ? new l("The " + Z + " `" + re + "` is marked as required " + ("in `" + V + "`, but its value is `null`.")) : new l("The " + Z + " `" + re + "` is marked as required in " + ("`" + V + "`, but its value is `undefined`.")) : null : P(k, Y, V, Z, re);
      }
      var D = X.bind(null, !1);
      return D.isRequired = X.bind(null, !0), D;
    }
    function m(P) {
      function R(W, X, D, U, k, Y) {
        var V = W[X], Z = J(V);
        if (Z !== P) {
          var re = $(V);
          return new l(
            "Invalid " + U + " `" + k + "` of type " + ("`" + re + "` supplied to `" + D + "`, expected ") + ("`" + P + "`."),
            { expectedType: P }
          );
        }
        return null;
      }
      return w(R);
    }
    function y() {
      return w(o);
    }
    function b(P) {
      function R(W, X, D, U, k) {
        if (typeof P != "function")
          return new l("Property `" + k + "` of component `" + D + "` has invalid PropType notation inside arrayOf.");
        var Y = W[X];
        if (!Array.isArray(Y)) {
          var V = J(Y);
          return new l("Invalid " + U + " `" + k + "` of type " + ("`" + V + "` supplied to `" + D + "`, expected an array."));
        }
        for (var Z = 0; Z < Y.length; Z++) {
          var re = P(Y, Z, D, U, k + "[" + Z + "]", n);
          if (re instanceof Error)
            return re;
        }
        return null;
      }
      return w(R);
    }
    function C() {
      function P(R, W, X, D, U) {
        var k = R[W];
        if (!f(k)) {
          var Y = J(k);
          return new l("Invalid " + D + " `" + U + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(P);
    }
    function M() {
      function P(R, W, X, D, U) {
        var k = R[W];
        if (!e.isValidElementType(k)) {
          var Y = J(k);
          return new l("Invalid " + D + " `" + U + "` of type " + ("`" + Y + "` supplied to `" + X + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(P);
    }
    function S(P) {
      function R(W, X, D, U, k) {
        if (!(W[X] instanceof P)) {
          var Y = P.name || g, V = K(W[X]);
          return new l("Invalid " + U + " `" + k + "` of type " + ("`" + V + "` supplied to `" + D + "`, expected ") + ("instance of `" + Y + "`."));
        }
        return null;
      }
      return w(R);
    }
    function I(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function R(W, X, D, U, k) {
        for (var Y = W[X], V = 0; V < P.length; V++)
          if (h(Y, P[V]))
            return null;
        var Z = JSON.stringify(P, function(ce, _) {
          var Le = $(_);
          return Le === "symbol" ? String(_) : _;
        });
        return new l("Invalid " + U + " `" + k + "` of value `" + String(Y) + "` " + ("supplied to `" + D + "`, expected one of " + Z + "."));
      }
      return w(R);
    }
    function N(P) {
      function R(W, X, D, U, k) {
        if (typeof P != "function")
          return new l("Property `" + k + "` of component `" + D + "` has invalid PropType notation inside objectOf.");
        var Y = W[X], V = J(Y);
        if (V !== "object")
          return new l("Invalid " + U + " `" + k + "` of type " + ("`" + V + "` supplied to `" + D + "`, expected an object."));
        for (var Z in Y)
          if (r(Y, Z)) {
            var re = P(Y, Z, D, U, k + "." + Z, n);
            if (re instanceof Error)
              return re;
          }
        return null;
      }
      return w(R);
    }
    function O(P) {
      if (!Array.isArray(P))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var R = 0; R < P.length; R++) {
        var W = P[R];
        if (typeof W != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(W) + " at index " + R + "."
          ), o;
      }
      function X(D, U, k, Y, V) {
        for (var Z = [], re = 0; re < P.length; re++) {
          var ce = P[re], _ = ce(D, U, k, Y, V, n);
          if (_ == null)
            return null;
          _.data && r(_.data, "expectedType") && Z.push(_.data.expectedType);
        }
        var Le = Z.length > 0 ? ", expected one of type [" + Z.join(", ") + "]" : "";
        return new l("Invalid " + Y + " `" + V + "` supplied to " + ("`" + k + "`" + Le + "."));
      }
      return w(X);
    }
    function F() {
      function P(R, W, X, D, U) {
        return A(R[W]) ? null : new l("Invalid " + D + " `" + U + "` supplied to " + ("`" + X + "`, expected a ReactNode."));
      }
      return w(P);
    }
    function Q(P, R, W, X, D) {
      return new l(
        (P || "React class") + ": " + R + " type `" + W + "." + X + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + D + "`."
      );
    }
    function T(P) {
      function R(W, X, D, U, k) {
        var Y = W[X], V = J(Y);
        if (V !== "object")
          return new l("Invalid " + U + " `" + k + "` of type `" + V + "` " + ("supplied to `" + D + "`, expected `object`."));
        for (var Z in P) {
          var re = P[Z];
          if (typeof re != "function")
            return Q(D, U, k, Z, $(re));
          var ce = re(Y, Z, D, U, k + "." + Z, n);
          if (ce)
            return ce;
        }
        return null;
      }
      return w(R);
    }
    function x(P) {
      function R(W, X, D, U, k) {
        var Y = W[X], V = J(Y);
        if (V !== "object")
          return new l("Invalid " + U + " `" + k + "` of type `" + V + "` " + ("supplied to `" + D + "`, expected `object`."));
        var Z = t({}, W[X], P);
        for (var re in Z) {
          var ce = P[re];
          if (r(P, re) && typeof ce != "function")
            return Q(D, U, k, re, $(ce));
          if (!ce)
            return new l(
              "Invalid " + U + " `" + k + "` key `" + re + "` supplied to `" + D + "`.\nBad object: " + JSON.stringify(W[X], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(P), null, "  ")
            );
          var _ = ce(Y, re, D, U, k + "." + re, n);
          if (_)
            return _;
        }
        return null;
      }
      return w(R);
    }
    function A(P) {
      switch (typeof P) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !P;
        case "object":
          if (Array.isArray(P))
            return P.every(A);
          if (P === null || f(P))
            return !0;
          var R = d(P);
          if (R) {
            var W = R.call(P), X;
            if (R !== P.entries) {
              for (; !(X = W.next()).done; )
                if (!A(X.value))
                  return !1;
            } else
              for (; !(X = W.next()).done; ) {
                var D = X.value;
                if (D && !A(D[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function B(P, R) {
      return P === "symbol" ? !0 : R ? R["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && R instanceof Symbol : !1;
    }
    function J(P) {
      var R = typeof P;
      return Array.isArray(P) ? "array" : P instanceof RegExp ? "object" : B(R, P) ? "symbol" : R;
    }
    function $(P) {
      if (typeof P > "u" || P === null)
        return "" + P;
      var R = J(P);
      if (R === "object") {
        if (P instanceof Date)
          return "date";
        if (P instanceof RegExp)
          return "regexp";
      }
      return R;
    }
    function q(P) {
      var R = $(P);
      switch (R) {
        case "array":
        case "object":
          return "an " + R;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + R;
        default:
          return R;
      }
    }
    function K(P) {
      return !P.constructor || !P.constructor.name ? g : P.constructor.name;
    }
    return p.checkPropTypes = a, p.resetWarningCache = a.resetWarningCache, p.PropTypes = p, p;
  }, Zf;
}
var $f, D0;
function NL() {
  if (D0)
    return $f;
  D0 = 1;
  var e = Ac();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, $f = function() {
    function r(o, f, s, u, c, d) {
      if (d !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, $f;
}
if (process.env.NODE_ENV !== "production") {
  var kL = kp(), BL = !0;
  Xu.exports = TL()(kL.isElement, BL);
} else
  Xu.exports = NL()();
var Vo = Xu.exports;
function Op(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = Op(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function L0() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = Op(e)) && (r && (r += " "), r += t);
  return r;
}
const OL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: L0,
  default: L0
}, Symbol.toStringTag, { value: "Module" })), PL = /* @__PURE__ */ Zm(OL);
var Qe = {}, an = {};
Object.defineProperty(an, "__esModule", {
  value: !0
});
an.dontSetMe = YL;
an.findInArray = zL;
an.int = UL;
an.isFunction = RL;
an.isNum = FL;
function zL(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (t.apply(t, [e[n], n, e]))
      return e[n];
}
function RL(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function FL(e) {
  return typeof e == "number" && !isNaN(e);
}
function UL(e) {
  return parseInt(e, 10);
}
function YL(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var pr = {};
Object.defineProperty(pr, "__esModule", {
  value: !0
});
pr.browserPrefixToKey = zp;
pr.browserPrefixToStyle = GL;
pr.default = void 0;
pr.getPrefix = Pp;
const Vf = ["Moz", "Webkit", "O", "ms"];
function Pp() {
  var e;
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u")
    return "";
  const n = (e = window.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!n || t in n)
    return "";
  for (let r = 0; r < Vf.length; r++)
    if (zp(t, Vf[r]) in n)
      return Vf[r];
  return "";
}
function zp(e, t) {
  return t ? "".concat(t).concat(HL(e)) : e;
}
function GL(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function HL(e) {
  let t = "", n = !0;
  for (let r = 0; r < e.length; r++)
    n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
  return t;
}
pr.default = Pp();
Object.defineProperty(Qe, "__esModule", {
  value: !0
});
Qe.addClassName = Up;
Qe.addEvent = WL;
Qe.addUserSelectStyles = rA;
Qe.createCSSTransform = XL;
Qe.createSVGTransform = eA;
Qe.getTouch = tA;
Qe.getTouchIdentifier = nA;
Qe.getTranslation = Ec;
Qe.innerHeight = VL;
Qe.innerWidth = KL;
Qe.matchesSelector = Fp;
Qe.matchesSelectorAndParentsTo = JL;
Qe.offsetXYFromParent = qL;
Qe.outerHeight = ZL;
Qe.outerWidth = $L;
Qe.removeClassName = Yp;
Qe.removeEvent = _L;
Qe.removeUserSelectStyles = aA;
var Et = an, A0 = QL(pr);
function Rp(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Rp = function(r) {
    return r ? n : t;
  })(e);
}
function QL(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Rp(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
let Ri = "";
function Fp(e, t) {
  return Ri || (Ri = (0, Et.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, Et.isFunction)(e[n]);
  })), (0, Et.isFunction)(e[Ri]) ? e[Ri](t) : !1;
}
function JL(e, t, n) {
  let r = e;
  do {
    if (Fp(r, t))
      return !0;
    if (r === n)
      return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function WL(e, t, n, r) {
  if (!e)
    return;
  const a = {
    capture: !0,
    ...r
  };
  e.addEventListener ? e.addEventListener(t, n, a) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
}
function _L(e, t, n, r) {
  if (!e)
    return;
  const a = {
    capture: !0,
    ...r
  };
  e.removeEventListener ? e.removeEventListener(t, n, a) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
}
function ZL(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, Et.int)(n.borderTopWidth), t += (0, Et.int)(n.borderBottomWidth), t;
}
function $L(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, Et.int)(n.borderLeftWidth), t += (0, Et.int)(n.borderRightWidth), t;
}
function VL(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, Et.int)(n.paddingTop), t -= (0, Et.int)(n.paddingBottom), t;
}
function KL(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, Et.int)(n.paddingLeft), t -= (0, Et.int)(n.paddingRight), t;
}
function qL(e, t, n) {
  const a = t === t.ownerDocument.body ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), i = (e.clientX + t.scrollLeft - a.left) / n, o = (e.clientY + t.scrollTop - a.top) / n;
  return {
    x: i,
    y: o
  };
}
function XL(e, t) {
  const n = Ec(e, t, "px");
  return {
    [(0, A0.browserPrefixToKey)("transform", A0.default)]: n
  };
}
function eA(e, t) {
  return Ec(e, t, "");
}
function Ec(e, t, n) {
  let {
    x: r,
    y: a
  } = e, i = "translate(".concat(r).concat(n, ",").concat(a).concat(n, ")");
  if (t) {
    const o = "".concat(typeof t.x == "string" ? t.x : t.x + n), f = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    i = "translate(".concat(o, ", ").concat(f, ")") + i;
  }
  return i;
}
function tA(e, t) {
  return e.targetTouches && (0, Et.findInArray)(e.targetTouches, (n) => t === n.identifier) || e.changedTouches && (0, Et.findInArray)(e.changedTouches, (n) => t === n.identifier);
}
function nA(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function rA(e) {
  if (!e)
    return;
  let t = e.getElementById("react-draggable-style-el");
  t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && Up(e.body, "react-draggable-transparent-selection");
}
function aA(e) {
  if (e)
    try {
      if (e.body && Yp(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        const t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function Up(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function Yp(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var on = {};
Object.defineProperty(on, "__esModule", {
  value: !0
});
on.canDragX = fA;
on.canDragY = uA;
on.createCoreData = cA;
on.createDraggableData = lA;
on.getBoundPosition = iA;
on.getControlPosition = sA;
on.snapToGrid = oA;
var Dt = an, Sr = Qe;
function iA(e, t, n) {
  if (!e.props.bounds)
    return [t, n];
  let {
    bounds: r
  } = e.props;
  r = typeof r == "string" ? r : dA(r);
  const a = jc(e);
  if (typeof r == "string") {
    const {
      ownerDocument: i
    } = a, o = i.defaultView;
    let f;
    if (r === "parent" ? f = a.parentNode : f = i.querySelector(r), !(f instanceof o.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    const s = f, u = o.getComputedStyle(a), c = o.getComputedStyle(s);
    r = {
      left: -a.offsetLeft + (0, Dt.int)(c.paddingLeft) + (0, Dt.int)(u.marginLeft),
      top: -a.offsetTop + (0, Dt.int)(c.paddingTop) + (0, Dt.int)(u.marginTop),
      right: (0, Sr.innerWidth)(s) - (0, Sr.outerWidth)(a) - a.offsetLeft + (0, Dt.int)(c.paddingRight) - (0, Dt.int)(u.marginRight),
      bottom: (0, Sr.innerHeight)(s) - (0, Sr.outerHeight)(a) - a.offsetTop + (0, Dt.int)(c.paddingBottom) - (0, Dt.int)(u.marginBottom)
    };
  }
  return (0, Dt.isNum)(r.right) && (t = Math.min(t, r.right)), (0, Dt.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, Dt.isNum)(r.left) && (t = Math.max(t, r.left)), (0, Dt.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
}
function oA(e, t, n) {
  const r = Math.round(t / e[0]) * e[0], a = Math.round(n / e[1]) * e[1];
  return [r, a];
}
function fA(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function uA(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function sA(e, t, n) {
  const r = typeof t == "number" ? (0, Sr.getTouch)(e, t) : null;
  if (typeof t == "number" && !r)
    return null;
  const a = jc(n), i = n.props.offsetParent || a.offsetParent || a.ownerDocument.body;
  return (0, Sr.offsetXYFromParent)(r || e, i, n.props.scale);
}
function cA(e, t, n) {
  const r = !(0, Dt.isNum)(e.lastX), a = jc(e);
  return r ? {
    node: a,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: a,
    deltaX: t - e.lastX,
    deltaY: n - e.lastY,
    lastX: e.lastX,
    lastY: e.lastY,
    x: t,
    y: n
  };
}
function lA(e, t) {
  const n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function dA(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function jc(e) {
  const t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var Ko = {}, qo = {};
Object.defineProperty(qo, "__esModule", {
  value: !0
});
qo.default = gA;
function gA() {
}
Object.defineProperty(Ko, "__esModule", {
  value: !0
});
Ko.default = void 0;
var Kf = hA(ae), gt = Ic(Vo), pA = Ic(ws), at = Qe, Cn = on, qf = an, Ma = Ic(qo);
function Ic(e) {
  return e && e.__esModule ? e : { default: e };
}
function Gp(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Gp = function(r) {
    return r ? n : t;
  })(e);
}
function hA(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Gp(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
function st(e, t, n) {
  return t = vA(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function vA(e) {
  var t = mA(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function mA(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const Rt = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let Mn = Rt.mouse, Xo = class extends Kf.Component {
  constructor() {
    super(...arguments), st(this, "dragging", !1), st(this, "lastX", NaN), st(this, "lastY", NaN), st(this, "touchIdentifier", null), st(this, "mounted", !1), st(this, "handleDragStart", (t) => {
      if (this.props.onMouseDown(t), !this.props.allowAnyClick && typeof t.button == "number" && t.button !== 0)
        return !1;
      const n = this.findDOMNode();
      if (!n || !n.ownerDocument || !n.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: r
      } = n;
      if (this.props.disabled || !(t.target instanceof r.defaultView.Node) || this.props.handle && !(0, at.matchesSelectorAndParentsTo)(t.target, this.props.handle, n) || this.props.cancel && (0, at.matchesSelectorAndParentsTo)(t.target, this.props.cancel, n))
        return;
      t.type === "touchstart" && t.preventDefault();
      const a = (0, at.getTouchIdentifier)(t);
      this.touchIdentifier = a;
      const i = (0, Cn.getControlPosition)(t, a, this);
      if (i == null)
        return;
      const {
        x: o,
        y: f
      } = i, s = (0, Cn.createCoreData)(this, o, f);
      (0, Ma.default)("DraggableCore: handleDragStart: %j", s), (0, Ma.default)("calling", this.props.onStart), !(this.props.onStart(t, s) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, at.addUserSelectStyles)(r), this.dragging = !0, this.lastX = o, this.lastY = f, (0, at.addEvent)(r, Mn.move, this.handleDrag), (0, at.addEvent)(r, Mn.stop, this.handleDragStop));
    }), st(this, "handleDrag", (t) => {
      const n = (0, Cn.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: a
      } = n;
      if (Array.isArray(this.props.grid)) {
        let f = r - this.lastX, s = a - this.lastY;
        if ([f, s] = (0, Cn.snapToGrid)(this.props.grid, f, s), !f && !s)
          return;
        r = this.lastX + f, a = this.lastY + s;
      }
      const i = (0, Cn.createCoreData)(this, r, a);
      if ((0, Ma.default)("DraggableCore: handleDrag: %j", i), this.props.onDrag(t, i) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const s = document.createEvent("MouseEvents");
          s.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(s);
        }
        return;
      }
      this.lastX = r, this.lastY = a;
    }), st(this, "handleDragStop", (t) => {
      if (!this.dragging)
        return;
      const n = (0, Cn.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: a
      } = n;
      if (Array.isArray(this.props.grid)) {
        let s = r - this.lastX || 0, u = a - this.lastY || 0;
        [s, u] = (0, Cn.snapToGrid)(this.props.grid, s, u), r = this.lastX + s, a = this.lastY + u;
      }
      const i = (0, Cn.createCoreData)(this, r, a);
      if (this.props.onStop(t, i) === !1 || this.mounted === !1)
        return !1;
      const f = this.findDOMNode();
      f && this.props.enableUserSelectHack && (0, at.removeUserSelectStyles)(f.ownerDocument), (0, Ma.default)("DraggableCore: handleDragStop: %j", i), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, f && ((0, Ma.default)("DraggableCore: Removing handlers"), (0, at.removeEvent)(f.ownerDocument, Mn.move, this.handleDrag), (0, at.removeEvent)(f.ownerDocument, Mn.stop, this.handleDragStop));
    }), st(this, "onMouseDown", (t) => (Mn = Rt.mouse, this.handleDragStart(t))), st(this, "onMouseUp", (t) => (Mn = Rt.mouse, this.handleDragStop(t))), st(this, "onTouchStart", (t) => (Mn = Rt.touch, this.handleDragStart(t))), st(this, "onTouchEnd", (t) => (Mn = Rt.touch, this.handleDragStop(t)));
  }
  componentDidMount() {
    this.mounted = !0;
    const t = this.findDOMNode();
    t && (0, at.addEvent)(t, Rt.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const t = this.findDOMNode();
    if (t) {
      const {
        ownerDocument: n
      } = t;
      (0, at.removeEvent)(n, Rt.mouse.move, this.handleDrag), (0, at.removeEvent)(n, Rt.touch.move, this.handleDrag), (0, at.removeEvent)(n, Rt.mouse.stop, this.handleDragStop), (0, at.removeEvent)(n, Rt.touch.stop, this.handleDragStop), (0, at.removeEvent)(t, Rt.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, at.removeUserSelectStyles)(n);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var t, n;
    return (t = this.props) !== null && t !== void 0 && t.nodeRef ? (n = this.props) === null || n === void 0 || (n = n.nodeRef) === null || n === void 0 ? void 0 : n.current : pA.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ Kf.cloneElement(Kf.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
Ko.default = Xo;
st(Xo, "displayName", "DraggableCore");
st(Xo, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: gt.default.bool,
  children: gt.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: gt.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: gt.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, t) {
    if (e[t] && e[t].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: gt.default.arrayOf(gt.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: gt.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: gt.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: gt.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: gt.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: gt.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: gt.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: gt.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: gt.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: qf.dontSetMe,
  style: qf.dontSetMe,
  transform: qf.dontSetMe
});
st(Xo, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return s.default;
    }
  }), e.default = void 0;
  var t = g(ae), n = c(Vo), r = c(ws), a = c(PL), i = Qe, o = on, f = an, s = c(Ko), u = c(qo);
  function c(y) {
    return y && y.__esModule ? y : { default: y };
  }
  function d(y) {
    if (typeof WeakMap != "function")
      return null;
    var b = /* @__PURE__ */ new WeakMap(), C = /* @__PURE__ */ new WeakMap();
    return (d = function(M) {
      return M ? C : b;
    })(y);
  }
  function g(y, b) {
    if (!b && y && y.__esModule)
      return y;
    if (y === null || typeof y != "object" && typeof y != "function")
      return { default: y };
    var C = d(b);
    if (C && C.has(y))
      return C.get(y);
    var M = {}, S = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var I in y)
      if (I !== "default" && Object.prototype.hasOwnProperty.call(y, I)) {
        var N = S ? Object.getOwnPropertyDescriptor(y, I) : null;
        N && (N.get || N.set) ? Object.defineProperty(M, I, N) : M[I] = y[I];
      }
    return M.default = y, C && C.set(y, M), M;
  }
  function p() {
    return p = Object.assign ? Object.assign.bind() : function(y) {
      for (var b = 1; b < arguments.length; b++) {
        var C = arguments[b];
        for (var M in C)
          Object.prototype.hasOwnProperty.call(C, M) && (y[M] = C[M]);
      }
      return y;
    }, p.apply(this, arguments);
  }
  function h(y, b, C) {
    return b = l(b), b in y ? Object.defineProperty(y, b, { value: C, enumerable: !0, configurable: !0, writable: !0 }) : y[b] = C, y;
  }
  function l(y) {
    var b = w(y, "string");
    return typeof b == "symbol" ? b : String(b);
  }
  function w(y, b) {
    if (typeof y != "object" || y === null)
      return y;
    var C = y[Symbol.toPrimitive];
    if (C !== void 0) {
      var M = C.call(y, b || "default");
      if (typeof M != "object")
        return M;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (b === "string" ? String : Number)(y);
  }
  class m extends t.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(b, C) {
      let {
        position: M
      } = b, {
        prevPropsPosition: S
      } = C;
      return M && (!S || M.x !== S.x || M.y !== S.y) ? ((0, u.default)("Draggable: getDerivedStateFromProps %j", {
        position: M,
        prevPropsPosition: S
      }), {
        x: M.x,
        y: M.y,
        prevPropsPosition: {
          ...M
        }
      }) : null;
    }
    constructor(b) {
      super(b), h(this, "onDragStart", (C, M) => {
        if ((0, u.default)("Draggable: onDragStart: %j", M), this.props.onStart(C, (0, o.createDraggableData)(this, M)) === !1)
          return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), h(this, "onDrag", (C, M) => {
        if (!this.state.dragging)
          return !1;
        (0, u.default)("Draggable: onDrag: %j", M);
        const S = (0, o.createDraggableData)(this, M), I = {
          x: S.x,
          y: S.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: O,
            y: F
          } = I;
          I.x += this.state.slackX, I.y += this.state.slackY;
          const [Q, T] = (0, o.getBoundPosition)(this, I.x, I.y);
          I.x = Q, I.y = T, I.slackX = this.state.slackX + (O - I.x), I.slackY = this.state.slackY + (F - I.y), S.x = I.x, S.y = I.y, S.deltaX = I.x - this.state.x, S.deltaY = I.y - this.state.y;
        }
        if (this.props.onDrag(C, S) === !1)
          return !1;
        this.setState(I);
      }), h(this, "onDragStop", (C, M) => {
        if (!this.state.dragging || this.props.onStop(C, (0, o.createDraggableData)(this, M)) === !1)
          return !1;
        (0, u.default)("Draggable: onDragStop: %j", M);
        const I = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: O,
            y: F
          } = this.props.position;
          I.x = O, I.y = F;
        }
        this.setState(I);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: b.position ? b.position.x : b.defaultPosition.x,
        y: b.position ? b.position.y : b.defaultPosition.y,
        prevPropsPosition: {
          ...b.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, b.position && !(b.onDrag || b.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var b, C;
      return (b = (C = this.props) === null || C === void 0 || (C = C.nodeRef) === null || C === void 0 ? void 0 : C.current) !== null && b !== void 0 ? b : r.default.findDOMNode(this);
    }
    render() {
      const {
        axis: b,
        bounds: C,
        children: M,
        defaultPosition: S,
        defaultClassName: I,
        defaultClassNameDragging: N,
        defaultClassNameDragged: O,
        position: F,
        positionOffset: Q,
        scale: T,
        ...x
      } = this.props;
      let A = {}, B = null;
      const $ = !!!F || this.state.dragging, q = F || S, K = {
        // Set left if horizontal drag is enabled
        x: (0, o.canDragX)(this) && $ ? this.state.x : q.x,
        // Set top if vertical drag is enabled
        y: (0, o.canDragY)(this) && $ ? this.state.y : q.y
      };
      this.state.isElementSVG ? B = (0, i.createSVGTransform)(K, Q) : A = (0, i.createCSSTransform)(K, Q);
      const P = (0, a.default)(M.props.className || "", I, {
        [N]: this.state.dragging,
        [O]: this.state.dragged
      });
      return /* @__PURE__ */ t.createElement(s.default, p({}, x, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ t.cloneElement(t.Children.only(M), {
        className: P,
        style: {
          ...M.props.style,
          ...A
        },
        transform: B
      }));
    }
  }
  e.default = m, h(m, "displayName", "Draggable"), h(m, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...s.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: n.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: n.default.oneOfType([n.default.shape({
      left: n.default.number,
      right: n.default.number,
      top: n.default.number,
      bottom: n.default.number
    }), n.default.string, n.default.oneOf([!1])]),
    defaultClassName: n.default.string,
    defaultClassNameDragging: n.default.string,
    defaultClassNameDragged: n.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    positionOffset: n.default.shape({
      x: n.default.oneOfType([n.default.number, n.default.string]),
      y: n.default.oneOfType([n.default.number, n.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: f.dontSetMe,
    style: f.dontSetMe,
    transform: f.dontSetMe
  }), h(m, "defaultProps", {
    ...s.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(Np);
const {
  default: Hp,
  DraggableCore: wA
} = Np;
$o.exports = Hp;
$o.exports.default = Hp;
$o.exports.DraggableCore = wA;
var yA = $o.exports, Sc = {};
Sc.__esModule = !0;
Sc.cloneElement = AA;
var bA = CA(ae);
function CA(e) {
  return e && e.__esModule ? e : { default: e };
}
function E0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function j0(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? E0(Object(n), !0).forEach(function(r) {
      MA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : E0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function MA(e, t, n) {
  return t = DA(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function DA(e) {
  var t = LA(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function LA(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function AA(e, t) {
  return t.style && e.props.style && (t.style = j0(j0({}, e.props.style), t.style)), t.className && e.props.className && (t.className = e.props.className + " " + t.className), /* @__PURE__ */ bA.default.cloneElement(e, t);
}
var pi = {};
pi.__esModule = !0;
pi.resizableProps = void 0;
var me = EA(Vo);
function EA(e) {
  return e && e.__esModule ? e : { default: e };
}
var jA = {
  /*
  * Restricts resizing to a particular axis (default: 'both')
  * 'both' - allows resizing by width or height
  * 'x' - only allows the width to be changed
  * 'y' - only allows the height to be changed
  * 'none' - disables resizing altogether
  * */
  axis: me.default.oneOf(["both", "x", "y", "none"]),
  className: me.default.string,
  /*
  * Require that one and only one child be present.
  * */
  children: me.default.element.isRequired,
  /*
  * These will be passed wholesale to react-draggable's DraggableCore
  * */
  draggableOpts: me.default.shape({
    allowAnyClick: me.default.bool,
    cancel: me.default.string,
    children: me.default.node,
    disabled: me.default.bool,
    enableUserSelectHack: me.default.bool,
    offsetParent: me.default.node,
    grid: me.default.arrayOf(me.default.number),
    handle: me.default.string,
    nodeRef: me.default.object,
    onStart: me.default.func,
    onDrag: me.default.func,
    onStop: me.default.func,
    onMouseDown: me.default.func,
    scale: me.default.number
  }),
  /*
  * Initial height
  * */
  height: function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    var a = n[0];
    if (a.axis === "both" || a.axis === "y") {
      var i;
      return (i = me.default.number).isRequired.apply(i, n);
    }
    return me.default.number.apply(me.default, n);
  },
  /*
  * Customize cursor resize handle
  * */
  handle: me.default.oneOfType([me.default.node, me.default.func]),
  /*
  * If you change this, be sure to update your css
  * */
  handleSize: me.default.arrayOf(me.default.number),
  lockAspectRatio: me.default.bool,
  /*
  * Max X & Y measure
  * */
  maxConstraints: me.default.arrayOf(me.default.number),
  /*
  * Min X & Y measure
  * */
  minConstraints: me.default.arrayOf(me.default.number),
  /*
  * Called on stop resize event
  * */
  onResizeStop: me.default.func,
  /*
  * Called on start resize event
  * */
  onResizeStart: me.default.func,
  /*
  * Called on resize event
  * */
  onResize: me.default.func,
  /*
  * Defines which resize handles should be rendered (default: 'se')
  * 's' - South handle (bottom-center)
  * 'w' - West handle (left-center)
  * 'e' - East handle (right-center)
  * 'n' - North handle (top-center)
  * 'sw' - Southwest handle (bottom-left)
  * 'nw' - Northwest handle (top-left)
  * 'se' - Southeast handle (bottom-right)
  * 'ne' - Northeast handle (top-center)
  * */
  resizeHandles: me.default.arrayOf(me.default.oneOf(["s", "w", "e", "n", "sw", "nw", "se", "ne"])),
  /*
  * If `transform: scale(n)` is set on the parent, this should be set to `n`.
  * */
  transformScale: me.default.number,
  /*
   * Initial width
   */
  width: function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++)
      n[r] = arguments[r];
    var a = n[0];
    if (a.axis === "both" || a.axis === "x") {
      var i;
      return (i = me.default.number).isRequired.apply(i, n);
    }
    return me.default.number.apply(me.default, n);
  }
};
pi.resizableProps = jA;
gi.__esModule = !0;
gi.default = void 0;
var Da = NA(ae), IA = yA, SA = Sc, xA = pi, TA = ["children", "className", "draggableOpts", "width", "height", "handle", "handleSize", "lockAspectRatio", "axis", "minConstraints", "maxConstraints", "onResize", "onResizeStop", "onResizeStart", "resizeHandles", "transformScale"];
function Qp(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Qp = function(a) {
    return a ? n : t;
  })(e);
}
function NA(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Qp(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
function es() {
  return es = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, es.apply(this, arguments);
}
function kA(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function I0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Xf(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? I0(Object(n), !0).forEach(function(r) {
      BA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : I0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function BA(e, t, n) {
  return t = OA(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function OA(e) {
  var t = PA(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function PA(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function zA(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ts(e, t);
}
function ts(e, t) {
  return ts = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, ts(e, t);
}
var xc = /* @__PURE__ */ function(e) {
  zA(t, e);
  function t() {
    for (var r, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)) || this, r.handleRefs = {}, r.lastHandleRect = null, r.slack = null, r;
  }
  var n = t.prototype;
  return n.componentWillUnmount = function() {
    this.resetData();
  }, n.resetData = function() {
    this.lastHandleRect = this.slack = null;
  }, n.runConstraints = function(a, i) {
    var o = this.props, f = o.minConstraints, s = o.maxConstraints, u = o.lockAspectRatio;
    if (!f && !s && !u)
      return [a, i];
    if (u) {
      var c = this.props.width / this.props.height, d = a - this.props.width, g = i - this.props.height;
      Math.abs(d) > Math.abs(g * c) ? i = a / c : a = i * c;
    }
    var p = a, h = i, l = this.slack || [0, 0], w = l[0], m = l[1];
    return a += w, i += m, f && (a = Math.max(f[0], a), i = Math.max(f[1], i)), s && (a = Math.min(s[0], a), i = Math.min(s[1], i)), this.slack = [w + (p - a), m + (h - i)], [a, i];
  }, n.resizeHandler = function(a, i) {
    var o = this;
    return function(f, s) {
      var u = s.node, c = s.deltaX, d = s.deltaY;
      a === "onResizeStart" && o.resetData();
      var g = (o.props.axis === "both" || o.props.axis === "x") && i !== "n" && i !== "s", p = (o.props.axis === "both" || o.props.axis === "y") && i !== "e" && i !== "w";
      if (!(!g && !p)) {
        var h = i[0], l = i[i.length - 1], w = u.getBoundingClientRect();
        if (o.lastHandleRect != null) {
          if (l === "w") {
            var m = w.left - o.lastHandleRect.left;
            c += m;
          }
          if (h === "n") {
            var y = w.top - o.lastHandleRect.top;
            d += y;
          }
        }
        o.lastHandleRect = w, l === "w" && (c = -c), h === "n" && (d = -d);
        var b = o.props.width + (g ? c / o.props.transformScale : 0), C = o.props.height + (p ? d / o.props.transformScale : 0), M = o.runConstraints(b, C);
        b = M[0], C = M[1];
        var S = b !== o.props.width || C !== o.props.height, I = typeof o.props[a] == "function" ? o.props[a] : null, N = a === "onResize" && !S;
        I && !N && (f.persist == null || f.persist(), I(f, {
          node: u,
          size: {
            width: b,
            height: C
          },
          handle: i
        })), a === "onResizeStop" && o.resetData();
      }
    };
  }, n.renderResizeHandle = function(a, i) {
    var o = this.props.handle;
    if (!o)
      return /* @__PURE__ */ Da.createElement("span", {
        className: "react-resizable-handle react-resizable-handle-" + a,
        ref: i
      });
    if (typeof o == "function")
      return o(a, i);
    var f = typeof o.type == "string", s = Xf({
      ref: i
    }, f ? {} : {
      handleAxis: a
    });
    return /* @__PURE__ */ Da.cloneElement(o, s);
  }, n.render = function() {
    var a = this, i = this.props, o = i.children, f = i.className, s = i.draggableOpts;
    i.width, i.height, i.handle, i.handleSize, i.lockAspectRatio, i.axis, i.minConstraints, i.maxConstraints, i.onResize, i.onResizeStop, i.onResizeStart;
    var u = i.resizeHandles;
    i.transformScale;
    var c = kA(i, TA);
    return (0, SA.cloneElement)(o, Xf(Xf({}, c), {}, {
      className: (f ? f + " " : "") + "react-resizable",
      children: [].concat(o.props.children, u.map(function(d) {
        var g, p = (g = a.handleRefs[d]) != null ? g : a.handleRefs[d] = /* @__PURE__ */ Da.createRef();
        return /* @__PURE__ */ Da.createElement(IA.DraggableCore, es({}, s, {
          nodeRef: p,
          key: "resizableHandle-" + d,
          onStop: a.resizeHandler("onResizeStop", d),
          onStart: a.resizeHandler("onResizeStart", d),
          onDrag: a.resizeHandler("onResize", d)
        }), a.renderResizeHandle(d, p));
      }))
    }));
  }, t;
}(Da.Component);
gi.default = xc;
xc.propTypes = xA.resizableProps;
xc.defaultProps = {
  axis: "both",
  handleSize: [20, 20],
  lockAspectRatio: !1,
  minConstraints: [20, 20],
  maxConstraints: [1 / 0, 1 / 0],
  resizeHandles: ["se"],
  transformScale: 1
};
var ef = {};
ef.__esModule = !0;
ef.default = void 0;
var eu = GA(ae), RA = Jp(Vo), FA = Jp(gi), UA = pi, YA = ["handle", "handleSize", "onResize", "onResizeStart", "onResizeStop", "draggableOpts", "minConstraints", "maxConstraints", "lockAspectRatio", "axis", "width", "height", "resizeHandles", "style", "transformScale"];
function Jp(e) {
  return e && e.__esModule ? e : { default: e };
}
function Wp(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (Wp = function(a) {
    return a ? n : t;
  })(e);
}
function GA(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = Wp(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var i in e)
    if (i !== "default" && Object.prototype.hasOwnProperty.call(e, i)) {
      var o = a ? Object.getOwnPropertyDescriptor(e, i) : null;
      o && (o.get || o.set) ? Object.defineProperty(r, i, o) : r[i] = e[i];
    }
  return r.default = e, n && n.set(e, r), r;
}
function ns() {
  return ns = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ns.apply(this, arguments);
}
function S0(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Ao(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? S0(Object(n), !0).forEach(function(r) {
      HA(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S0(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function HA(e, t, n) {
  return t = QA(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function QA(e) {
  var t = JA(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function JA(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function WA(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function _A(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, rs(e, t);
}
function rs(e, t) {
  return rs = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, rs(e, t);
}
var _p = /* @__PURE__ */ function(e) {
  _A(t, e);
  function t() {
    for (var r, a = arguments.length, i = new Array(a), o = 0; o < a; o++)
      i[o] = arguments[o];
    return r = e.call.apply(e, [this].concat(i)) || this, r.state = {
      width: r.props.width,
      height: r.props.height,
      propsWidth: r.props.width,
      propsHeight: r.props.height
    }, r.onResize = function(f, s) {
      var u = s.size;
      r.props.onResize ? (f.persist == null || f.persist(), r.setState(u, function() {
        return r.props.onResize && r.props.onResize(f, s);
      })) : r.setState(u);
    }, r;
  }
  t.getDerivedStateFromProps = function(a, i) {
    return i.propsWidth !== a.width || i.propsHeight !== a.height ? {
      width: a.width,
      height: a.height,
      propsWidth: a.width,
      propsHeight: a.height
    } : null;
  };
  var n = t.prototype;
  return n.render = function() {
    var a = this.props, i = a.handle, o = a.handleSize;
    a.onResize;
    var f = a.onResizeStart, s = a.onResizeStop, u = a.draggableOpts, c = a.minConstraints, d = a.maxConstraints, g = a.lockAspectRatio, p = a.axis;
    a.width, a.height;
    var h = a.resizeHandles, l = a.style, w = a.transformScale, m = WA(a, YA);
    return /* @__PURE__ */ eu.createElement(FA.default, {
      axis: p,
      draggableOpts: u,
      handle: i,
      handleSize: o,
      height: this.state.height,
      lockAspectRatio: g,
      maxConstraints: d,
      minConstraints: c,
      onResizeStart: f,
      onResize: this.onResize,
      onResizeStop: s,
      resizeHandles: h,
      transformScale: w,
      width: this.state.width
    }, /* @__PURE__ */ eu.createElement("div", ns({}, m, {
      style: Ao(Ao({}, l), {}, {
        width: this.state.width + "px",
        height: this.state.height + "px"
      })
    })));
  }, t;
}(eu.Component);
ef.default = _p;
_p.propTypes = Ao(Ao({}, UA.resizableProps), {}, {
  children: RA.default.element
});
Lc.exports = function() {
  throw new Error("Don't instantiate Resizable directly! Use require('react-resizable').Resizable");
};
var ZA = Lc.exports.Resizable = gi.default;
Lc.exports.ResizableBox = ef.default;
const $A = ({
  attributes: e,
  element: t,
  readOnly: n,
  children: r
}) => {
  var w, m;
  const { setActiveMenu: a, maxHeight: i, maxWidth: o } = gr(), f = yt(), { height: s, width: u } = t.style || {};
  let c = 0, d = 0;
  typeof s == "number" ? c = s : typeof s == "string" && (c = parseInt(s)), typeof u == "number" ? d = u : typeof u == "string" && (d = parseInt(u));
  const [g, p] = ie(c), [h, l] = ie(d);
  return le(() => {
    let y = c, b = d;
    const C = b / y;
    o && b > o && (b = o, y = Math.round(b / C)), i && y > i && (y = i, b = Math.round(i * C)), p(y), l(b), p0(f, { height: y, width: b });
  }, [c, d, i, o, f]), /* @__PURE__ */ ue(
    "span",
    {
      ...e,
      style: {
        ...t.style,
        display: "inline-block"
      },
      children: [
        /* @__PURE__ */ E(
          VA,
          {
            height: g,
            width: h,
            lockAspectRatio: !0,
            onResizeStop: (y, b) => p0(f, b.size),
            onDoubleClick: (y) => {
              y.preventDefault(), y.stopPropagation(), n || a("MEDIA");
            },
            disabled: n,
            children: t.mediaType === "video" ? /* @__PURE__ */ E("video", { controls: !0, children: /* @__PURE__ */ E(
              "source",
              {
                src: t.mediaLink,
                type: `video/${t.extension}`,
                style: { borderRadius: (w = t.style) == null ? void 0 : w.borderRadius }
              }
            ) }) : /* @__PURE__ */ E(
              "img",
              {
                src: t.mediaLink,
                alt: "",
                style: { borderRadius: (m = t.style) == null ? void 0 : m.borderRadius }
              }
            )
          }
        ),
        r
      ]
    }
  );
}, VA = ({
  children: e,
  onDoubleClick: t,
  disabled: n,
  ...r
}) => {
  const [a, i] = ie({
    height: r.height || 0,
    width: r.width || 0
  });
  le(() => {
    i({ height: r.height || 0, width: r.width || 0 });
  }, [r.height, r.width]);
  const { height: o, width: f } = a, s = /* @__PURE__ */ E(
    "span",
    {
      onDoubleClick: t,
      contentEditable: !1,
      style: {
        height: `${o}px`,
        width: `${f}px`,
        display: "inline-block"
      },
      children: e
    }
  );
  return n ? s : /* @__PURE__ */ E(
    ZA,
    {
      ...r,
      height: o,
      width: f,
      onResize: (u, c) => i(c.size),
      onResizeStop: r.onResizeStop,
      children: s
    }
  );
}, KA = ({
  attributes: e,
  element: { emoji: t },
  children: n
}) => {
  const r = Ig(), a = yt(), i = Ce();
  return le(() => {
    var f;
    const o = (f = a.selection) == null ? void 0 : f.focus;
    if (r) {
      const s = i.current, u = s && o ? be.isBefore(o, s) : !1;
      H.move(a, { reverse: u });
    }
    i.current = o;
  }, [r, a, i]), /* @__PURE__ */ ue("span", { ...e, contentEditable: !1, children: [
    t,
    n
  ] });
}, jr = () => /* @__PURE__ */ E(
  "span",
  {
    contentEditable: !1,
    style: {
      fontSize: "0"
    },
    children: String.fromCodePoint(160)
  }
), qA = (e) => {
  const { attributes: t, children: n, element: r } = e, a = { textAlign: vo in r ? r[vo] : void 0 }, i = Tg(), { setActiveMenu: o } = gr();
  switch (r[Wa]) {
    case BM:
      return /* @__PURE__ */ E("blockquote", { style: a, ...t, children: n });
    case ic:
      return /* @__PURE__ */ E(
        "ul",
        {
          style: {
            ...a,
            // tailwind :(
            listStyleType: "disc",
            listStylePosition: "inside"
          },
          ...t,
          children: n
        }
      );
    case NM:
      return /* @__PURE__ */ E("h1", { style: a, ...t, children: n });
    case kM:
      return /* @__PURE__ */ E("h2", { style: a, ...t, children: n });
    case Pg:
      return /* @__PURE__ */ E("li", { style: a, ...t, children: n });
    case ac:
      return /* @__PURE__ */ E(
        "ol",
        {
          style: {
            ...a,
            // tailwind :(
            listStyleType: "decimal",
            listStylePosition: "inside"
          },
          ...t,
          children: n
        }
      );
    case Yg:
      return /* @__PURE__ */ ue(
        "a",
        {
          style: { textDecoration: "underline", ...a },
          href: r.url,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: e.onLinkClick,
          onDoubleClick: (f) => {
            i || (f.stopPropagation(), o("LINK"));
          },
          ...t,
          children: [
            /* @__PURE__ */ E(jr, {}),
            n,
            /* @__PURE__ */ E(jr, {})
          ]
        }
      );
    case Gg:
      return (
        /*
          Note that this is not a true button, but a span with button-like CSS.
          True buttons are display:inline-block, but Chrome and Safari
          have a bad bug with display:inline-block inside contenteditable:
          - https://bugs.webkit.org/show_bug.cgi?id=105898
          - https://bugs.chromium.org/p/chromium/issues/detail?id=1088403
          Worse, one cannot override the display property: https://github.com/w3c/csswg-drafts/issues/3226
          The only current workaround is to emulate the appearance of a display:inline button using CSS.
        */
        /* @__PURE__ */ ue(
          "a",
          {
            ...t,
            onClick: e.onLinkClick,
            onDoubleClick: (f) => {
              i || (f.stopPropagation(), o("BUTTON"));
            },
            href: r.url,
            target: "_blank",
            rel: "noopener noreferrer",
            role: "button",
            style: {
              margin: "0 0.1em",
              cursor: i ? "pointer" : "text",
              display: "inline-block",
              whiteSpace: "nowrap",
              ...r.style
            },
            children: [
              /* @__PURE__ */ E(jr, {}),
              n,
              /* @__PURE__ */ E(jr, {})
            ]
          }
        )
      );
    case ka:
      return /* @__PURE__ */ E(cL, { ...e, element: r, children: n });
    case Ki:
      return /* @__PURE__ */ E(AL, { ...e, element: r, readOnly: i, children: n });
    case qi:
      return /* @__PURE__ */ E($A, { ...e, element: r, readOnly: i, children: n });
    case Ba:
      return /* @__PURE__ */ ue(KA, { ...e, element: r, children: [
        /* @__PURE__ */ E(jr, {}),
        n,
        /* @__PURE__ */ E(jr, {})
      ] });
    default:
      return /* @__PURE__ */ E("p", { style: a, ...t, children: n });
  }
}, Zp = (e, t) => {
  const n = v.marks(e);
  return n ? n[t] === !0 : !1;
}, no = (e, t) => {
  Zp(e, t) ? v.removeMark(e, t) : v.addMark(e, t, !0);
}, XA = [ac, ic], e9 = [zg, Rg, Fg, Ug], t9 = (e) => dr(e) && XA.includes(e[Wa]), n9 = (e) => e9.includes(e), $p = (e, t) => {
  const { selection: n } = e;
  if (!n)
    return !1;
  const r = v.unhangRange(e, n), a = n9(t) ? vo : Wa, [i] = Array.from(
    v.nodes(e, {
      at: r,
      match: (o) => dr(o) && o[a] === t
    })
  );
  return !!i;
}, Fi = fr(
  ({ format: e, icon: t, ...n }, r) => {
    const a = yt(), i = $p(a, e);
    return /* @__PURE__ */ E(Wt, { content: Ya(e), placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        ...n,
        ref: r,
        active: i,
        onMouseDown: () => {
          H.setNodes(a, {
            [vo]: i ? void 0 : e
          });
        },
        children: /* @__PURE__ */ E(t, {})
      }
    ) });
  }
);
var r9 = f9, a9 = /^(?:\w+:)?\/\/(\S+)$/, i9 = /^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/, o9 = /^[^\s\.]+\.\S{2,}$/;
function f9(e) {
  if (typeof e != "string")
    return !1;
  var t = e.match(a9);
  if (!t)
    return !1;
  var n = t[1];
  return n ? !!(i9.test(n) || o9.test(n)) : !1;
}
const as = /* @__PURE__ */ No(r9), u9 = ["link", "button"], Tc = (e) => dr(e) && u9.includes(e.type), s9 = (e) => {
  const [t] = v.nodes(e, {
    match: (n) => Tc(n)
  });
  return t ? t[0] : void 0;
}, Vp = (e) => {
  const [t] = v.nodes(e, {
    match: (n) => dr(n) && n.type === "link"
  });
  return !!t;
}, Kp = (e) => {
  const [t] = v.nodes(e, {
    match: (n) => dr(n) && n.type === "button"
  });
  return !!t;
}, c9 = (e) => {
  H.unwrapNodes(e, {
    match: (t) => !v.isEditor(t) && Tc(t)
  });
}, l9 = (e) => {
  H.removeNodes(e, {
    match: (t) => !v.isEditor(t) && Tc(t)
  });
}, is = (e, t, n, r = !1, a) => {
  let i = !1;
  (Kp(e) || Vp(e)) && (l9(e), i = !0);
  const { selection: f } = e, s = f && z.isCollapsed(f), u = f ? v.string(e, f) : "", c = n !== u;
  let d = {
    type: "link",
    url: t,
    children: (
      // Creating a new link or editing an existing link
      s || i || c ? [{ text: n || t }] : []
    )
  };
  r && (d = { ...d, type: "button", style: a }), s || i || c ? H.insertNodes(e, d, { hanging: !0 }) : (H.wrapNodes(e, d, { split: !0 }), H.collapse(e, { edge: "end" }));
}, d9 = (e, t, n, r = !1, a) => {
  e.selection && is(e, t, n || t, r, a);
}, g9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 640 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z" })), p9 = (e) => /* @__PURE__ */ L.createElement("svg", { width: 30, height: 20, viewBox: "0 0 30 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("rect", { width: 30, height: 20, rx: 10 }), /* @__PURE__ */ L.createElement("circle", { cx: 20, cy: 10, r: 7, fill: "white" })), h9 = (e) => /* @__PURE__ */ L.createElement("svg", { width: 30, height: 20, viewBox: "0 0 30 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ L.createElement("rect", { width: 30, height: 20, rx: 10 }), /* @__PURE__ */ L.createElement("circle", { cx: 10, cy: 10, r: 7, fill: "white" })), v9 = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M15.6396 7.02527H12.0181V5.02527H19.0181V12.0253H17.0181V8.47528L12.1042 13.3892L10.6899 11.975L15.6396 7.02527Z" }), /* @__PURE__ */ L.createElement("path", { d: "M10.9819 6.97473H4.98193V18.9747H16.9819V12.9747H14.9819V16.9747H6.98193V8.97473H10.9819V6.97473Z" }));
function la() {
  return (la = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }).apply(this, arguments);
}
function tf(e, t) {
  if (e == null)
    return {};
  var n, r, a = {}, i = Object.keys(e);
  for (r = 0; r < i.length; r++)
    t.indexOf(n = i[r]) >= 0 || (a[n] = e[n]);
  return a;
}
function $a(e) {
  var t = Ce(e), n = Ce(function(r) {
    t.current && t.current(r);
  });
  return t.current = e, n.current;
}
var Va = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 1), e > n ? n : e < t ? t : e;
}, Ra = function(e) {
  return "touches" in e;
}, os = function(e) {
  return e && e.ownerDocument.defaultView || self;
}, x0 = function(e, t, n) {
  var r = e.getBoundingClientRect(), a = Ra(t) ? function(i, o) {
    for (var f = 0; f < i.length; f++)
      if (i[f].identifier === o)
        return i[f];
    return i[0];
  }(t.touches, n) : t;
  return { left: Va((a.pageX - (r.left + os(e).pageXOffset)) / r.width), top: Va((a.pageY - (r.top + os(e).pageYOffset)) / r.height) };
}, T0 = function(e) {
  !Ra(e) && e.preventDefault();
}, qp = ae.memo(function(e) {
  var t = e.onMove, n = e.onKey, r = tf(e, ["onMove", "onKey"]), a = Ce(null), i = $a(t), o = $a(n), f = Ce(null), s = Ce(!1), u = Lt(function() {
    var p = function(w) {
      T0(w), (Ra(w) ? w.touches.length > 0 : w.buttons > 0) && a.current ? i(x0(a.current, w, f.current)) : l(!1);
    }, h = function() {
      return l(!1);
    };
    function l(w) {
      var m = s.current, y = os(a.current), b = w ? y.addEventListener : y.removeEventListener;
      b(m ? "touchmove" : "mousemove", p), b(m ? "touchend" : "mouseup", h);
    }
    return [function(w) {
      var m = w.nativeEvent, y = a.current;
      if (y && (T0(m), !function(C, M) {
        return M && !Ra(C);
      }(m, s.current) && y)) {
        if (Ra(m)) {
          s.current = !0;
          var b = m.changedTouches || [];
          b.length && (f.current = b[0].identifier);
        }
        y.focus(), i(x0(y, m, f.current)), l(!0);
      }
    }, function(w) {
      var m = w.which || w.keyCode;
      m < 37 || m > 40 || (w.preventDefault(), o({ left: m === 39 ? 0.05 : m === 37 ? -0.05 : 0, top: m === 40 ? 0.05 : m === 38 ? -0.05 : 0 }));
    }, l];
  }, [o, i]), c = u[0], d = u[1], g = u[2];
  return le(function() {
    return g;
  }, [g]), ae.createElement("div", la({}, r, { onTouchStart: c, onMouseDown: c, className: "react-colorful__interactive", ref: a, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), Nc = function(e) {
  return e.filter(Boolean).join(" ");
}, Xp = function(e) {
  var t = e.color, n = e.left, r = e.top, a = r === void 0 ? 0.5 : r, i = Nc(["react-colorful__pointer", e.className]);
  return ae.createElement("div", { className: i, style: { top: 100 * a + "%", left: 100 * n + "%" } }, ae.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: t } }));
}, rt = function(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = Math.pow(10, t)), Math.round(n * e) / n;
}, m9 = function(e) {
  return M9(fs(e));
}, fs = function(e) {
  return e[0] === "#" && (e = e.substring(1)), e.length < 6 ? { r: parseInt(e[0] + e[0], 16), g: parseInt(e[1] + e[1], 16), b: parseInt(e[2] + e[2], 16), a: e.length === 4 ? rt(parseInt(e[3] + e[3], 16) / 255, 2) : 1 } : { r: parseInt(e.substring(0, 2), 16), g: parseInt(e.substring(2, 4), 16), b: parseInt(e.substring(4, 6), 16), a: e.length === 8 ? rt(parseInt(e.substring(6, 8), 16) / 255, 2) : 1 };
}, w9 = function(e) {
  return C9(b9(e));
}, y9 = function(e) {
  var t = e.s, n = e.v, r = e.a, a = (200 - t) * n / 100;
  return { h: rt(e.h), s: rt(a > 0 && a < 200 ? t * n / 100 / (a <= 100 ? a : 200 - a) * 100 : 0), l: rt(a / 2), a: rt(r, 2) };
}, us = function(e) {
  var t = y9(e);
  return "hsl(" + t.h + ", " + t.s + "%, " + t.l + "%)";
}, b9 = function(e) {
  var t = e.h, n = e.s, r = e.v, a = e.a;
  t = t / 360 * 6, n /= 100, r /= 100;
  var i = Math.floor(t), o = r * (1 - n), f = r * (1 - (t - i) * n), s = r * (1 - (1 - t + i) * n), u = i % 6;
  return { r: rt(255 * [r, f, o, o, s, r][u]), g: rt(255 * [s, r, r, f, o, o][u]), b: rt(255 * [o, o, s, r, r, f][u]), a: rt(a, 2) };
}, Ui = function(e) {
  var t = e.toString(16);
  return t.length < 2 ? "0" + t : t;
}, C9 = function(e) {
  var t = e.r, n = e.g, r = e.b, a = e.a, i = a < 1 ? Ui(rt(255 * a)) : "";
  return "#" + Ui(t) + Ui(n) + Ui(r) + i;
}, M9 = function(e) {
  var t = e.r, n = e.g, r = e.b, a = e.a, i = Math.max(t, n, r), o = i - Math.min(t, n, r), f = o ? i === t ? (n - r) / o : i === n ? 2 + (r - t) / o : 4 + (t - n) / o : 0;
  return { h: rt(60 * (f < 0 ? f + 6 : f)), s: rt(i ? o / i * 100 : 0), v: rt(i / 255 * 100), a };
}, D9 = ae.memo(function(e) {
  var t = e.hue, n = e.onChange, r = Nc(["react-colorful__hue", e.className]);
  return ae.createElement("div", { className: r }, ae.createElement(qp, { onMove: function(a) {
    n({ h: 360 * a.left });
  }, onKey: function(a) {
    n({ h: Va(t + 360 * a.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": rt(t), "aria-valuemax": "360", "aria-valuemin": "0" }, ae.createElement(Xp, { className: "react-colorful__hue-pointer", left: t / 360, color: us({ h: t, s: 100, v: 100, a: 1 }) })));
}), L9 = ae.memo(function(e) {
  var t = e.hsva, n = e.onChange, r = { backgroundColor: us({ h: t.h, s: 100, v: 100, a: 1 }) };
  return ae.createElement("div", { className: "react-colorful__saturation", style: r }, ae.createElement(qp, { onMove: function(a) {
    n({ s: 100 * a.left, v: 100 - 100 * a.top });
  }, onKey: function(a) {
    n({ s: Va(t.s + 100 * a.left, 0, 100), v: Va(t.v - 100 * a.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + rt(t.s) + "%, Brightness " + rt(t.v) + "%" }, ae.createElement(Xp, { className: "react-colorful__saturation-pointer", top: 1 - t.v / 100, left: t.s / 100, color: us(t) })));
}), eh = function(e, t) {
  if (e === t)
    return !0;
  for (var n in e)
    if (e[n] !== t[n])
      return !1;
  return !0;
}, A9 = function(e, t) {
  return e.toLowerCase() === t.toLowerCase() || eh(fs(e), fs(t));
};
function E9(e, t, n) {
  var r = $a(n), a = ie(function() {
    return e.toHsva(t);
  }), i = a[0], o = a[1], f = Ce({ color: t, hsva: i });
  le(function() {
    if (!e.equal(t, f.current.color)) {
      var u = e.toHsva(t);
      f.current = { hsva: u, color: t }, o(u);
    }
  }, [t, e]), le(function() {
    var u;
    eh(i, f.current.hsva) || e.equal(u = e.fromHsva(i), f.current.color) || (f.current = { hsva: i, color: u }, r(u));
  }, [i, e, r]);
  var s = pe(function(u) {
    o(function(c) {
      return Object.assign({}, c, u);
    });
  }, []);
  return [i, s];
}
var j9 = typeof window < "u" ? ri : le, I9 = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, N0 = /* @__PURE__ */ new Map(), S9 = function(e) {
  j9(function() {
    var t = e.current ? e.current.ownerDocument : document;
    if (t !== void 0 && !N0.has(t)) {
      var n = t.createElement("style");
      n.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, N0.set(t, n);
      var r = I9();
      r && n.setAttribute("nonce", r), t.head.appendChild(n);
    }
  }, []);
}, x9 = function(e) {
  var t = e.className, n = e.colorModel, r = e.color, a = r === void 0 ? n.defaultColor : r, i = e.onChange, o = tf(e, ["className", "colorModel", "color", "onChange"]), f = Ce(null);
  S9(f);
  var s = E9(n, a, i), u = s[0], c = s[1], d = Nc(["react-colorful", t]);
  return ae.createElement("div", la({}, o, { ref: f, className: d }), ae.createElement(L9, { hsva: u, onChange: c }), ae.createElement(D9, { hue: u.h, onChange: c, className: "react-colorful__last-control" }));
}, T9 = { defaultColor: "000", toHsva: m9, fromHsva: function(e) {
  return w9({ h: e.h, s: e.s, v: e.v, a: 1 });
}, equal: A9 }, N9 = function(e) {
  return ae.createElement(x9, la({}, e, { colorModel: T9 }));
}, k9 = /^#?([0-9A-F]{3,8})$/i, B9 = function(e) {
  var t = e.color, n = t === void 0 ? "" : t, r = e.onChange, a = e.onBlur, i = e.escape, o = e.validate, f = e.format, s = e.process, u = tf(e, ["color", "onChange", "onBlur", "escape", "validate", "format", "process"]), c = ie(function() {
    return i(n);
  }), d = c[0], g = c[1], p = $a(r), h = $a(a), l = pe(function(m) {
    var y = i(m.target.value);
    g(y), o(y) && p(s ? s(y) : y);
  }, [i, s, o, p]), w = pe(function(m) {
    o(m.target.value) || g(i(n)), h(m);
  }, [n, i, o, h]);
  return le(function() {
    g(i(n));
  }, [n, i]), ae.createElement("input", la({}, u, { value: f ? f(d) : d, spellCheck: "false", onChange: l, onBlur: w }));
}, k0 = function(e) {
  return "#" + e;
}, O9 = function(e) {
  var t = e.prefixed, n = e.alpha, r = tf(e, ["prefixed", "alpha"]), a = pe(function(o) {
    return o.replace(/([^0-9A-F]+)/gi, "").substring(0, n ? 8 : 6);
  }, [n]), i = pe(function(o) {
    return function(f, s) {
      var u = k9.exec(f), c = u ? u[1].length : 0;
      return c === 3 || c === 6 || !!s && c === 4 || !!s && c === 8;
    }(o, n);
  }, [n]);
  return ae.createElement(B9, la({}, r, { escape: a, format: t ? k0 : void 0, process: k0, validate: i }));
};
const Dn = (e, t, n, r, a, i, o, f, s, u) => ({
  50: e,
  100: t,
  200: n,
  300: r,
  400: a,
  500: i,
  600: o,
  700: f,
  800: s,
  900: u
}), B0 = "#000000", ss = {
  red: Dn(
    "#FBE4E3",
    "#FCCDCC",
    "#FD9E9E",
    "#FE8786",
    "#FE6F6F",
    "#FF5858",
    "#EC3D3D",
    "#DA2323",
    "#C70808",
    "#9E0202"
  ),
  yellow: Dn(
    "#FDF4D8",
    "#FDEDB5",
    "#FEDF70",
    "#FED74D",
    "#FFD02B",
    "#FFC908",
    "#F7B405",
    "#F0A003",
    "#E88B00",
    "#D68000"
  ),
  blue: Dn(
    "#D8E9FD",
    "#BCDCFD",
    "#84C3FE",
    "#68B6FE",
    "#4CA9FF",
    "#309CFF",
    "#2388E4",
    "#1773C9",
    "#0A5FAE",
    "#024480"
  ),
  sky: Dn(
    "#D8FBFD",
    "#BCF6FD",
    "#84EBFE",
    "#68E5FE",
    "#4CE0FF",
    "#30DAFF",
    "#20C8ED",
    "#10B7DB",
    "#00A5C9",
    "#06829D"
  ),
  green: Dn(
    "#E5FBF1",
    "#C1F2E3",
    "#79E1C6",
    "#54D8B7",
    "#30D0A9",
    "#0CC79A",
    "#18AB7E",
    "#258F63",
    "#317347",
    "#124B25"
  ),
  indigo: Dn(
    "#EFF2FE",
    "#E1E7FD",
    "#C9D2FA",
    "#A8B4F6",
    "#838CF1",
    "#6466E9",
    "#4E46DC",
    "#4138C2",
    "#36309D",
    "#302E7C"
  ),
  purple: Dn(
    "#F8F9FD",
    "#E1E5F7",
    "#C0C6EB",
    "#AEB6E6",
    "#9CA6E0",
    "#8695E0",
    "#6F7DC4",
    "#5866A7",
    "#414E8B",
    "#172564"
  ),
  gray: Dn(
    "#F7F7FA",
    "#E8E8EA",
    "#C2C4C6",
    "#9397A1",
    "#727684",
    "#565A67",
    "#383A41",
    "#2D2E32",
    "#1C1D20",
    // Note, grayDark is also simply black
    B0
  ),
  white: "#FFFFFF",
  // also define black as its own color outside of the darkest gray
  black: B0
}, ro = ({
  color: e,
  setColor: t,
  onClose: n
}) => {
  const [r, a] = ie(!1), [i, o] = ie(!1), f = () => {
    a(!1), o(!1), n == null || n();
  }, s = (u, c = !0) => {
    t(u), c && f();
  };
  return le(() => (qt(document, "mousedown", f), () => cn(document, "mousedown", f)), []), /* @__PURE__ */ ue(
    "div",
    {
      onClick: (u) => u.stopPropagation(),
      onMouseDown: (u) => u.stopPropagation(),
      children: [
        /* @__PURE__ */ E(Wt, { content: "Select color", placement: "top", children: /* @__PURE__ */ ue(
          "button",
          {
            className: "flex items-center h-7",
            onClick: () => a(!r),
            children: [
              /* @__PURE__ */ E(jp, { className: "mr-2" }),
              /* @__PURE__ */ E(Yi, { color: e })
            ]
          }
        ) }),
        /* @__PURE__ */ E("div", { className: "relative", children: r ? /* @__PURE__ */ E("div", { className: "absolute bg-white z-10 rounded-md border border-purple-100", children: i ? /* @__PURE__ */ ue("div", { onMouseDown: (u) => u.stopPropagation(), className: "w-fit", children: [
          /* @__PURE__ */ E(
            N9,
            {
              onChange: (u) => s(u, !1),
              color: e
            }
          ),
          /* @__PURE__ */ E(
            O9,
            {
              color: e,
              onChange: (u) => s(u, !1),
              className: "w-full"
            }
          )
        ] }) : /* @__PURE__ */ ue(
          "div",
          {
            className: "w-fit p-2",
            onMouseDown: (u) => u.stopPropagation(),
            children: [
              Object.values(ss).map((u, c) => {
                if (typeof u != "string")
                  return /* @__PURE__ */ E("div", { className: "flex", children: Object.values(u).map((d) => /* @__PURE__ */ E(
                    Yi,
                    {
                      color: d,
                      onClick: s
                    },
                    d
                  )) }, c);
              }),
              /* @__PURE__ */ ue("div", { className: "flex", children: [
                /* @__PURE__ */ E(Yi, { color: "white", onClick: s }),
                /* @__PURE__ */ E(Yi, { color: "black", onClick: s }),
                /* @__PURE__ */ E(
                  "button",
                  {
                    onClick: () => o(!0),
                    className: "text-purple-700 text-xxs bg-purple-50 hover:bg-purple-100 border border-purple-200 px-2 py-0.5 rounded-md",
                    children: "Custom"
                  }
                )
              ] })
            ]
          }
        ) }) : null })
      ]
    }
  );
}, Yi = ({
  color: e,
  onClick: t
}) => /* @__PURE__ */ E(
  "div",
  {
    onClick: () => t == null ? void 0 : t(e),
    className: "h-4 w-4 mr-0.5 mb-0.5 rounded-full border border-gray-200 cursor-pointer hover:border-gray-400",
    style: { background: e }
  }
), O0 = "Add", P0 = "Edit", z0 = ({ isButton: e = !1 }) => {
  const t = yt(), { activeMenu: n, setActiveMenu: r, close: a } = gr(), i = e ? Kp(t) : Vp(t), o = e ? n === "BUTTON" : n === "LINK", [f, s] = ie(""), [u, c] = ie(""), [d, g] = ie({});
  le(() => {
    const C = () => p();
    return qt(document, "mousedown", C), () => {
      cn(document, "mousedown", C);
    };
  }, []);
  const p = () => {
    s(""), c(""), a();
  };
  le(() => {
    if ((n === "BUTTON" || n === "LINK") && t.selection) {
      const C = s9(t), M = v.string(t, t.selection);
      if (C) {
        b.current = P0;
        let S;
        try {
          S = te.string(te.leaf(C, [0])), s(S), c(C.url);
        } catch {
          s(M);
        }
      } else
        b.current = O0, s(M);
    }
  }, [n]);
  const h = as(u), l = !h && u.length > 0, w = (C) => {
    C.preventDefault(), h && d9(t, u, f, e, d), p(), G.focus(t);
  }, m = (C) => {
    C.preventDefault(), p(), G.focus(t);
  }, y = (C) => {
    C.preventDefault(), c9(t), p(), G.focus(t);
  }, b = Ce(O0);
  return /* @__PURE__ */ ue("div", { className: "relative", children: [
    /* @__PURE__ */ E(
      Wt,
      {
        content: `Insert ${e ? "button" : "link"}`,
        placement: "top",
        children: /* @__PURE__ */ E(
          lr,
          {
            active: i,
            onMouseDown: (C) => {
              C.preventDefault(), C.stopPropagation(), r(n === "BUTTON" && e || n === "LINK" && !e ? null : e ? "BUTTON" : "LINK");
            },
            children: e ? /* @__PURE__ */ E(v9, {}) : /* @__PURE__ */ E(g9, {})
          }
        )
      }
    ),
    o && /* @__PURE__ */ ue(
      "div",
      {
        onMouseDown: (C) => C.stopPropagation(),
        className: "absolute flex gap-4 flex-col bg-white z-10 p-2.5 border border-purple-100 rounded-md w-72 text-gray-500",
        children: [
          /* @__PURE__ */ ue("div", { className: "font-medium", children: [
            b.current,
            " ",
            e ? "button" : "link"
          ] }),
          /* @__PURE__ */ ue("div", { className: "flex flex-col gap-2.5", children: [
            /* @__PURE__ */ ue("label", { htmlFor: "text", className: ke.label, children: [
              /* @__PURE__ */ E("span", { children: "Text" }),
              /* @__PURE__ */ E(
                "input",
                {
                  placeholder: u,
                  className: ke.input,
                  name: "text",
                  value: f,
                  onChange: (C) => s(C.target.value)
                }
              )
            ] }),
            /* @__PURE__ */ ue(
              "label",
              {
                htmlFor: "link",
                className: l ? ke["label--invalid"] : ke.label,
                children: [
                  /* @__PURE__ */ E("span", { children: l ? "Invalid link" : "Link" }),
                  /* @__PURE__ */ E(
                    "input",
                    {
                      className: l ? ke["input--invalid"] : ke.input,
                      placeholder: "https://",
                      value: u,
                      onChange: (C) => c(C.target.value)
                    }
                  )
                ]
              }
            ),
            e && /* @__PURE__ */ E(
              P9,
              {
                style: d,
                setStyle: g,
                text: f
              }
            )
          ] }),
          /* @__PURE__ */ ue("div", { className: "flex gap-1 justify-end", children: [
            b.current === P0 && /* @__PURE__ */ E("button", { className: ke.button, onClick: y, children: "Remove" }),
            /* @__PURE__ */ E("button", { className: ke.button, onClick: m, children: "Cancel" }),
            /* @__PURE__ */ E(
              "button",
              {
                className: h ? ke["button--primary"] : ke["button--disabled"],
                onClick: w,
                children: "Save"
              }
            )
          ] })
        ]
      }
    )
  ] });
}, P9 = ({
  style: e,
  setStyle: t,
  text: n
}) => {
  const [r, a] = ie(e.background || ss.indigo[500]), [i, o] = ie(e.color || ss.white), [f, s] = ie(e.borderRadius || "5px"), [u, c] = ie(
    e.paddingLeft || "6px"
  ), [d, g] = ie(
    e.paddingTop || "2px"
  ), [p, h] = ie(
    e.borderStyle === "solid"
  ), [l, w] = ie(e.borderColor || "black"), [m, y] = ie(e.borderWidth || "1px");
  return le(
    () => t({
      background: r,
      color: i,
      borderRadius: f,
      paddingTop: d,
      paddingBottom: d,
      paddingLeft: u,
      paddingRight: u,
      borderStyle: p ? "solid" : "none",
      borderColor: l,
      borderWidth: m
    }),
    [
      r,
      i,
      f,
      u,
      d,
      p,
      l,
      m
    ]
  ), /* @__PURE__ */ ue(Ua, { children: [
    /* @__PURE__ */ ue("div", { className: ke.label, children: [
      /* @__PURE__ */ E("span", { children: "Button color" }),
      /* @__PURE__ */ E(ro, { color: String(r), setColor: a })
    ] }),
    /* @__PURE__ */ ue("div", { className: ke.label, children: [
      /* @__PURE__ */ E("span", { children: "Text color" }),
      /* @__PURE__ */ E(
        ro,
        {
          color: String(i),
          setColor: o
        }
      )
    ] }),
    /* @__PURE__ */ ue("label", { className: ke.label, children: [
      /* @__PURE__ */ E("span", { children: "Corner radius" }),
      /* @__PURE__ */ E(
        "input",
        {
          className: ke.input + " w-10",
          placeholder: "5px",
          value: f,
          onChange: (b) => s(b.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ ue("div", { className: ke.label, children: [
      /* @__PURE__ */ E("span", { children: "Padding" }),
      /* @__PURE__ */ ue("div", { children: [
        /* @__PURE__ */ E("span", { children: "X:" }),
        /* @__PURE__ */ E(
          "input",
          {
            className: ke.input + " w-10 mr-1",
            placeholder: "6px",
            value: u,
            onChange: (b) => c(b.target.value)
          }
        ),
        /* @__PURE__ */ E("span", { children: "Y:" }),
        /* @__PURE__ */ E(
          "input",
          {
            className: ke.input + " w-10",
            placeholder: "2px",
            value: d,
            onChange: (b) => g(b.target.value)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ue("div", { className: ke.label, children: [
      /* @__PURE__ */ E("span", { children: "Border" }),
      /* @__PURE__ */ E("button", { onClick: () => h(!p), children: p ? /* @__PURE__ */ E(p9, { className: "fill-indigo-500" }) : /* @__PURE__ */ E(h9, { className: "fill-gray-200" }) })
    ] }),
    p && /* @__PURE__ */ ue(Ua, { children: [
      /* @__PURE__ */ ue("div", { className: ke.label, children: [
        /* @__PURE__ */ E("span", { children: "Border color" }),
        /* @__PURE__ */ E(
          ro,
          {
            color: String(l),
            setColor: w
          }
        )
      ] }),
      /* @__PURE__ */ ue("label", { className: ke.label, children: [
        /* @__PURE__ */ E("span", { children: "Border thickness" }),
        /* @__PURE__ */ E(
          "input",
          {
            className: ke.input + " w-10",
            placeholder: "5px",
            value: m,
            onChange: (b) => y(b.target.value)
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ ue("div", { children: [
      /* @__PURE__ */ E("p", { className: "text-xs font-bold mb-1", children: "Preview" }),
      /* @__PURE__ */ E("button", { style: e, children: n || "Button text" })
    ] })
  ] });
}, R0 = fr(
  ({ format: e, icon: t, ...n }, r) => {
    const a = yt(), i = $p(a, e);
    return /* @__PURE__ */ E(Wt, { content: Ya(e), placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        ...n,
        ref: r,
        active: i,
        onMouseDown: () => {
          if (H.unwrapNodes(a, {
            match: t9,
            split: !0
          }), H.setNodes(a, {
            [Wa]: i ? TM : Pg
          }), !i) {
            const o = { [Wa]: e, children: [] };
            H.wrapNodes(a, o);
          }
        },
        children: /* @__PURE__ */ E(t, {})
      }
    ) });
  }
), tu = fr(
  ({ format: e, icon: t, ...n }, r) => {
    const a = yt();
    return /* @__PURE__ */ E(Wt, { content: Ya(e), placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        ...n,
        ref: r,
        active: Zp(a, e),
        onMouseDown: (i) => {
          i.preventDefault(), no(a, e);
        },
        children: /* @__PURE__ */ E(t, {})
      }
    ) });
  }
), z9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M352 64c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32H128c-17.7 0-32 14.3-32 32s14.3 32 32 32H320c17.7 0 32-14.3 32-32z" })), R9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M448 64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64S14.3 96 32 96H416c17.7 0 32-14.3 32-32zm0 256c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32zM0 192c0 17.7 14.3 32 32 32H416c17.7 0 32-14.3 32-32s-14.3-32-32-32H32c-17.7 0-32 14.3-32 32zM448 448c0-17.7-14.3-32-32-32H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H416c17.7 0 32-14.3 32-32z" })), F9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M288 64c0 17.7-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32H256c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H256c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" })), U9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M448 64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zm0 256c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32zM0 192c0-17.7 14.3-32 32-32H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32zM448 448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H416c17.7 0 32 14.3 32 32z" })), Y9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 384 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M0 64C0 46.3 14.3 32 32 32H80 96 224c70.7 0 128 57.3 128 128c0 31.3-11.3 60.1-30 82.3c37.1 22.4 62 63.1 62 109.7c0 70.7-57.3 128-128 128H96 80 32c-17.7 0-32-14.3-32-32s14.3-32 32-32H48V256 96H32C14.3 96 0 81.7 0 64zM224 224c35.3 0 64-28.7 64-64s-28.7-64-64-64H112V224H224zM112 288V416H256c35.3 0 64-28.7 64-64s-28.7-64-64-64H224 112z" })), G9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 384 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M128 64c0-17.7 14.3-32 32-32H352c17.7 0 32 14.3 32 32s-14.3 32-32 32H293.3L160 416h64c17.7 0 32 14.3 32 32s-14.3 32-32 32H32c-17.7 0-32-14.3-32-32s14.3-32 32-32H90.7L224 96H160c-17.7 0-32-14.3-32-32z" })), H9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z" })), Q9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M24 56c0-13.3 10.7-24 24-24H80c13.3 0 24 10.7 24 24V176h16c13.3 0 24 10.7 24 24s-10.7 24-24 24H40c-13.3 0-24-10.7-24-24s10.7-24 24-24H56V80H48C34.7 80 24 69.3 24 56zM86.7 341.2c-6.5-7.4-18.3-6.9-24 1.2L51.5 357.9c-7.7 10.8-22.7 13.3-33.5 5.6s-13.3-22.7-5.6-33.5l11.1-15.6c23.7-33.2 72.3-35.6 99.2-4.9c21.3 24.4 20.8 60.9-1.1 84.7L86.8 432H120c13.3 0 24 10.7 24 24s-10.7 24-24 24H32c-9.5 0-18.2-5.6-22-14.4s-2.1-18.9 4.3-25.9l72-78c5.3-5.8 5.4-14.6 .3-20.5zM224 64H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32zm0 160H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H224c-17.7 0-32-14.3-32-32s14.3-32 32-32z" })), J9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 512 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M161.3 144c3.2-17.2 14-30.1 33.7-38.6c21.1-9 51.8-12.3 88.6-6.5c11.9 1.9 48.8 9.1 60.1 12c17.1 4.5 34.6-5.6 39.2-22.7s-5.6-34.6-22.7-39.2c-14.3-3.8-53.6-11.4-66.6-13.4c-44.7-7-88.3-4.2-123.7 10.9c-36.5 15.6-64.4 44.8-71.8 87.3c-.1 .6-.2 1.1-.2 1.7c-2.8 23.9 .5 45.6 10.1 64.6c4.5 9 10.2 16.9 16.7 23.9H32c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H270.1c-.1 0-.3-.1-.4-.1l-1.1-.3c-36-10.8-65.2-19.6-85.2-33.1c-9.3-6.3-15-12.6-18.2-19.1c-3.1-6.1-5.2-14.6-3.8-27.4zM348.9 337.2c2.7 6.5 4.4 15.8 1.9 30.1c-3 17.6-13.8 30.8-33.9 39.4c-21.1 9-51.7 12.3-88.5 6.5c-18-2.9-49.1-13.5-74.4-22.1c-5.6-1.9-11-3.7-15.9-5.4c-16.8-5.6-34.9 3.5-40.5 20.3s3.5 34.9 20.3 40.5c3.6 1.2 7.9 2.7 12.7 4.3l0 0 0 0c24.9 8.5 63.6 21.7 87.6 25.6l0 0 .2 0c44.7 7 88.3 4.2 123.7-10.9c36.5-15.6 64.4-44.8 71.8-87.3c3.6-21 2.7-40.4-3.1-58.1H335.1c7 5.6 11.4 11.2 13.9 17.2z" })), kc = [8, 9, 10, 11, 12, 14, 16, 18, 24, 30, 36, 48, 60, 72, 96], W9 = (e) => kc.find((t) => t > e) || 96, _9 = (e) => [...kc].reverse().find((t) => t < e) || 8, Z9 = ({
  defaultFontSize: e = 16
}) => {
  const t = yt(), n = v.marks(t), r = n && n[Oa], a = (u) => {
    v.addMark(t, Oa, u), G.focus(t);
  }, [i, o] = ie(
    String(r || e)
  );
  le(() => {
    o(String(r || e));
  }, [r, e]);
  const [f, s] = ie(!1);
  return le(() => {
    const u = () => s(!1);
    return qt(document, "mousedown", u), () => cn(document, "mousedown", u);
  }, []), /* @__PURE__ */ ue(
    "div",
    {
      onKeyDown: (u) => {
        u.preventDefault(), u.stopPropagation();
      },
      children: [
        /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
          "input",
          {
            type: "text",
            className: "p-0.5 text-center border border-purple-100 outline-none rounded-md w-10 h-7",
            value: i,
            onChange: (u) => o(u.target.value),
            onClick: () => s(!f),
            onMouseDown: (u) => u.stopPropagation(),
            onKeyDown: (u) => {
              const { key: c } = u;
              c === "Enter" && (s(!1), a(parseInt(i))), c === "ArrowUp" && (u.preventDefault(), o(String(_9(parseInt(i) - 1))), s(!0)), c === "ArrowDown" && (u.preventDefault(), o(String(W9(parseInt(i) + 1))), s(!0)), c === "Escape" && s(!1);
            }
          }
        ) }),
        /* @__PURE__ */ E("div", { className: "relative", children: f && /* @__PURE__ */ E("ul", { className: "absolute z-10 bg-white w-10 border border-purple-100", children: kc.map((u) => /* @__PURE__ */ E(
          "li",
          {
            className: `text-center ${parseInt(i) === u ? "bg-purple-200" : ""} `,
            onMouseDown: () => {
              s(!1), a(u);
            },
            children: u
          },
          u
        )) }) })
      ]
    }
  );
}, $9 = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 16, width: 14, viewBox: "0 0 448 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M254 52.8C249.3 40.3 237.3 32 224 32s-25.3 8.3-30 20.8L57.8 416H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32h-1.8l18-48H303.8l18 48H320c-17.7 0-32 14.3-32 32s14.3 32 32 32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H390.2L254 52.8zM279.8 304H168.2L224 155.1 279.8 304z" })), V9 = [
  { label: "(inherit)", value: "" },
  { label: "Arial", value: "Arial, sans-serif" },
  { label: "Veranda", value: "Veranda, sans-serif" },
  { label: "Tahoma", value: "Tahoma, sans-serif" },
  { label: "Trebuchet MS", value: '"Trebuchet MS", sans-serif' },
  { label: "Times New Roman", value: '"Times New Roman", serif' },
  { label: "Georgia", value: "Georgia, serif" },
  { label: "Garamond", value: "Garamond, serif" },
  { label: "Courier New", value: '"Courier New", monospace' },
  { label: "Brush Script MT", value: "Brush Script MT, cursive" }
], K9 = V9.map(({ label: e, value: t }) => ({
  value: t,
  label: /* @__PURE__ */ E("span", { style: { fontFamily: t }, children: e })
})), q9 = () => {
  const [e, t] = ie(), n = yt(), r = v.marks(n), a = r && r[zr] || void 0;
  return le(() => {
    t(a);
  }, [a]), /* @__PURE__ */ E(Wt, { content: "Select font", placement: "top", children: /* @__PURE__ */ E(
    Ip,
    {
      value: e,
      onChange: (i) => {
        i ? v.addMark(n, zr, i) : v.removeMark(n, zr), G.focus(n);
      },
      options: K9,
      placeholder: /* @__PURE__ */ E("div", { className: "flex items-center h-5", children: /* @__PURE__ */ E($9, {}) })
    }
  ) });
}, X9 = () => {
  const e = yt(), t = v.marks(e), n = t && t[Pa] || "#172564";
  return /* @__PURE__ */ E(
    ro,
    {
      color: n,
      setColor: (a) => {
        v.addMark(e, Pa, a);
      },
      onClose: () => G.focus(e)
    }
  );
}, eE = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5C3 3.34315 4.34315 2 6 2H14C17.866 2 21 5.13401 21 9V19C21 20.6569 19.6569 22 18 22H6C4.34315 22 3 20.6569 3 19V5ZM13 4H6C5.44772 4 5 4.44772 5 5V19C5 19.5523 5.44772 20 6 20H18C18.5523 20 19 19.5523 19 19V9H13V4ZM18.584 7C17.9413 5.52906 16.6113 4.4271 15 4.10002V7H18.584Z" })), tE = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M14.8285 11.9481L16.2427 10.5339L12 6.29122L7.7574 10.5339L9.17161 11.9481L11 10.1196V17.6568H13V10.1196L14.8285 11.9481Z" }), /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7782 4.22183C15.4824 -0.0739415 8.51759 -0.0739422 4.22183 4.22183C-0.0739415 8.51759 -0.0739422 15.4824 4.22183 19.7782C8.51759 24.0739 15.4824 24.0739 19.7782 19.7782C24.0739 15.4824 24.0739 8.51759 19.7782 4.22183ZM18.364 5.63604C14.8492 2.12132 9.15076 2.12132 5.63604 5.63604C2.12132 9.15076 2.12132 14.8492 5.63604 18.364C9.15076 21.8787 14.8492 21.8787 18.364 18.364C21.8787 14.8492 21.8787 9.15076 18.364 5.63604Z" })), nE = (e) => /* @__PURE__ */ L.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 384 512", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" })), rE = (e) => /* @__PURE__ */ L.createElement("svg", { width: "800px", height: "800px", viewBox: "-7.5 0 24 24", "xmlns:dc": "http://purl.org/dc/elements/1.1/", "xmlns:cc": "http://creativecommons.org/ns#", "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#", xmlns: "http://www.w3.org/2000/svg", id: "svg4355", ...e }, /* @__PURE__ */ L.createElement("metadata", { id: "metadata4360" }, /* @__PURE__ */ L.createElement("rdf:RDF", null, /* @__PURE__ */ L.createElement("cc:Work", null, /* @__PURE__ */ L.createElement("dc:format", null, "image/svg+xml"), /* @__PURE__ */ L.createElement("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }), /* @__PURE__ */ L.createElement("dc:title", null), /* @__PURE__ */ L.createElement("dc:date", null, "2021"), /* @__PURE__ */ L.createElement("dc:creator", null, /* @__PURE__ */ L.createElement("cc:Agent", null, /* @__PURE__ */ L.createElement("dc:title", null, "Timothée Giet"))), /* @__PURE__ */ L.createElement("cc:license", { "rdf:resource": "http://creativecommons.org/licenses/by-sa/4.0/" })), /* @__PURE__ */ L.createElement("cc:License", { "rdf:about": "http://creativecommons.org/licenses/by-sa/4.0/" }, /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#Reproduction" }), /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#Distribution" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#Notice" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#Attribution" }), /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#DerivativeWorks" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#ShareAlike" })))), /* @__PURE__ */ L.createElement("path", { id: "rect819", d: "M3 3c-1.108 0-2 .892-2 2v4c0 1.108.892 2 2 2h3c1.108 0 2-.892 2-2V5c0-1.108-.892-2-2-2zm0 1h3c.554 0 1 .446 1 1v4c0 .554-.446 1-1 1H3c-.554 0-1-.446-1-1V5c0-.554.446-1 1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect819-3", d: "M3 13c-1.108 0-2 .892-2 2v4c0 1.108.892 2 2 2h3c1.108 0 2-.892 2-2v-4c0-1.108-.892-2-2-2zm0 1h3c.554 0 1 .446 1 1v4c0 .554-.446 1-1 1H3c-.554 0-1-.446-1-1v-4c0-.554.446-1 1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect839", d: "M4.5 8c-.554 0-1 .446-1 1v3h2V9c0-.554-.446-1-1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect839-6", d: "M3.5 12v3c0 .554.446 1 1 1s1-.446 1-1v-3z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} })), aE = (e) => /* @__PURE__ */ L.createElement("svg", { width: "800px", height: "800px", viewBox: "-7.5 0 24 24", "xmlns:dc": "http://purl.org/dc/elements/1.1/", "xmlns:cc": "http://creativecommons.org/ns#", "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#", xmlns: "http://www.w3.org/2000/svg", id: "svg4355", ...e }, /* @__PURE__ */ L.createElement("metadata", { id: "metadata4360" }, /* @__PURE__ */ L.createElement("rdf:RDF", null, /* @__PURE__ */ L.createElement("cc:Work", null, /* @__PURE__ */ L.createElement("dc:format", null, "image/svg+xml"), /* @__PURE__ */ L.createElement("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }), /* @__PURE__ */ L.createElement("dc:title", null), /* @__PURE__ */ L.createElement("dc:date", null, "2021"), /* @__PURE__ */ L.createElement("dc:creator", null, /* @__PURE__ */ L.createElement("cc:Agent", null, /* @__PURE__ */ L.createElement("dc:title", null, "Timothée Giet"))), /* @__PURE__ */ L.createElement("cc:license", { "rdf:resource": "http://creativecommons.org/licenses/by-sa/4.0/" })), /* @__PURE__ */ L.createElement("cc:License", { "rdf:about": "http://creativecommons.org/licenses/by-sa/4.0/" }, /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#Reproduction" }), /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#Distribution" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#Notice" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#Attribution" }), /* @__PURE__ */ L.createElement("cc:permits", { "rdf:resource": "http://creativecommons.org/ns#DerivativeWorks" }), /* @__PURE__ */ L.createElement("cc:requires", { "rdf:resource": "http://creativecommons.org/ns#ShareAlike" })))), /* @__PURE__ */ L.createElement("path", { id: "rect819", d: "M3 0C1.892 0 1 .892 1 2v4c0 1.108.892 2 2 2h3c1.108 0 2-.892 2-2V2c0-1.108-.892-2-2-2zm0 1h3c.554 0 1 .446 1 1v4c0 .554-.446 1-1 1H3c-.554 0-1-.446-1-1V2c0-.554.446-1 1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect819-3", d: "M3 16c-1.108 0-2 .892-2 2v4c0 1.108.892 2 2 2h3c1.108 0 2-.892 2-2v-4c0-1.108-.892-2-2-2zm0 1h3c.554 0 1 .446 1 1v4c0 .554-.446 1-1 1H3c-.554 0-1-.446-1-1v-4c0-.554.446-1 1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect839", d: "M4.5 5c-.554 0-1 .446-1 1v3h2V6c0-.554-.446-1-1-1z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} }), /* @__PURE__ */ L.createElement("path", { id: "rect839-6", d: "M3.5 15v3c0 .554.446 1 1 1s1-.446 1-1v-3z", style: {
  opacity: 1,
  vectorEffect: "none",
  fill: "#373737",
  fillOpacity: 1,
  stroke: "none",
  strokeWidth: 4,
  strokeLinecap: "square",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeDasharray: "none",
  strokeDashoffset: 3.20000005,
  strokeOpacity: 0.55063291
} })), th = [
  "apng",
  "avif",
  "bmp",
  "gif",
  "jpg",
  "jpeg",
  "jpe",
  "jif",
  "jfif",
  "png",
  "svg",
  "webp"
], nh = [
  "mp4",
  "webm",
  "ogg",
  "avi",
  "mov",
  "flv",
  "wmv"
], ao = (e) => {
  var n;
  const t = (n = e.split(".").pop()) == null ? void 0 : n.toLowerCase();
  if (t && (th.includes(t) || nh.includes(t)))
    return t;
}, nu = (e) => {
  const t = ao(e);
  if (!t || th.includes(t))
    return "image";
  if (nh.includes(t))
    return "video";
}, iE = async (e, t, n) => {
  const a = await (await fetch(e)).blob(), i = {
    type: `${t}/${n}`
  };
  return new File([a], `flywheel-engagement-media.${n}`, i);
}, oE = () => {
  const e = yt(), {
    activeMenu: t,
    setActiveMenu: n,
    close: r,
    mediaHandler: a,
    maxHeight: i,
    maxWidth: o
  } = gr(), [f, s] = ie(""), [u, c] = ie(""), [d, g] = ie(!0), [p, h] = ie(""), l = (ne) => {
    h(ne), ne && O(!1);
  }, [w, m] = ie(), [y, b] = ie(), [C, M] = ie("engagement-media"), [S, I] = ie(), [N, O] = ie(!1), [F, Q] = ie({}), [T, x] = ie(), [A, B] = ie(), [J, $] = ie(), [q, K] = ie(""), [P, R] = ie(1), [W, X] = ie(!0), [D, U] = ie(!1), k = W ? rE : aE, Y = (ne) => {
    s(ne), g(!0), K(ne), m(ne ? nu(ne) : void 0), b(ao(ne)), I(void 0);
  };
  le(() => re(), [q]), le(() => {
    Q({
      height: `${A}px`,
      width: `${T}px`,
      borderRadius: J === void 0 ? void 0 : `${J}px`
    });
  }, [A, T, J]);
  const V = (ne) => {
    if (ne.target.files) {
      const de = ne.target.files[0];
      if (I(de), M(de.name), de) {
        const je = new FileReader();
        m(nu(de.name)), b(ao(de.name)), je.onload = (ve) => {
          ve.target && K(ve.target.result);
        }, je.readAsDataURL(de);
      }
    }
  }, Z = ({
    height: ne,
    width: de
  }) => {
    const je = de / ne;
    return o && de > o && (de = o, ne = Math.round(de / je)), i && ne > i && (ne = i, de = Math.round(je * ne)), { aspectRatio: je, height: ne, width: de };
  }, re = () => {
    if (D) {
      U(!1);
      return;
    }
    if (w === "image") {
      const ne = new Image();
      ne.onload = () => {
        const { naturalWidth: de, naturalHeight: je } = ne, { aspectRatio: ve, height: Ye, width: Ze } = Z({
          height: je,
          width: de
        });
        R(ve), x(Ze), B(Ye);
      }, ne.onerror = () => {
        g(!1), x(void 0), B(void 0), R(1);
      }, q && (ne.src = q);
    } else {
      const ne = document.getElementById("flywheel-rte-video-preview");
      ne && ne.addEventListener(
        "loadedmetadata",
        (de) => {
          const { videoWidth: je, videoHeight: ve } = ne, { aspectRatio: Ye, height: Ze, width: Ae } = Z({
            height: ve,
            width: je
          });
          x(Ae), B(Ze), R(Ye);
        },
        !1
      );
    }
  }, ce = (ne) => {
    o && ne > o && (ne = o), Number.isNaN(ne) ? (x(void 0), B(void 0)) : (x(ne), W && B(Math.round(ne / P)));
  }, _ = (ne) => {
    i && ne > i && (ne = i), B(ne), W && x(Math.round(ne * P));
  }, Le = () => {
    Y(""), m(void 0), b(void 0), B(void 0), x(void 0), $(void 0), M("flywheel-media"), I(void 0), Q({}), X(!0), R(1), O(!1), g(!0), l("");
  }, he = () => {
    Le(), r();
  };
  le(() => {
    const ne = () => he();
    return qt(document, "mousedown", ne), () => cn(document, "mousedown", ne);
  }, []), le(() => {
    if (t === "MEDIA") {
      const ne = Tp(e);
      if (!ne)
        return;
      Y(ne.mediaLink), c(ne.mediaLink), m(ne.mediaType), b(ne.extension), M(ne.mediaAlt);
      const {
        height: de,
        width: je,
        borderRadius: ve
      } = ne.style || {};
      U(!0);
      let Ye, Ze, Ae;
      if (typeof de == "number" ? Ye = de : typeof de == "string" && (Ye = parseInt(de)), typeof je == "number" ? Ze = je : typeof je == "string" && (Ze = parseInt(je)), typeof ve == "number" ? Ae = ve : typeof ve == "string" && (Ae = parseInt(ve)), Ye && Ze) {
        const {
          height: Ct,
          width: yr,
          aspectRatio: Mt
        } = Z({ height: Ye, width: Ze });
        B(Ct), x(yr), R(Mt), $(Ae);
      }
    }
  }, [t]);
  const We = () => {
    if (!T || !A)
      return {};
    const ne = T / A, de = 266, je = 250, ve = Math.round(de / ne);
    return ve < je ? {
      width: de,
      height: ve,
      borderRadius: J
    } : { width: je * ne, height: je, borderRadius: J };
  }, Ke = async (ne) => {
    const { assetUrl: de } = await (a == null ? void 0 : a(ne)) || {};
    if (de) {
      const je = nu(de), ve = ao(de);
      if (je && ve) {
        g0(e, de, je, C, ve, F), O(!1), he(), G.focus(e);
        return;
      }
    }
    l("Unable to upload media");
  }, Ue = async (ne) => {
    if (ne.preventDefault(), EL(e), O(!0), a || console.warn(
      "No mediaHandler provided to RichTextEditor. If the provided link becomes invalid, then this media file will no longer display"
    ), f && w && y)
      if (f === u || !a)
        g0(e, f, w, C, y, F), O(!1), he(), G.focus(e);
      else {
        const de = await iE(f, w, y);
        a ? Ke(de) : l("No media handler provided");
      }
    else
      S ? a ? Ke(S) : l("No media handler provided") : (l("Invalid media"), O(!1));
  }, bt = (ne) => {
    ne.preventDefault(), he(), G.focus(e);
  };
  return /* @__PURE__ */ ue("div", { className: "relative", children: [
    /* @__PURE__ */ E(Wt, { content: "Insert media", placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        onMouseDown: (ne) => {
          ne.preventDefault(), ne.stopPropagation(), n("MEDIA");
        },
        children: /* @__PURE__ */ E(eE, {})
      }
    ) }),
    t === "MEDIA" && /* @__PURE__ */ ue(
      "div",
      {
        onMouseDown: (ne) => ne.stopPropagation(),
        className: "absolute flex gap-4 flex-col bg-white z-10 p-2.5 border border-purple-100 rounded-md w-72 whitespace-nowrap",
        children: [
          /* @__PURE__ */ E("div", { className: "font-semibold", children: "Insert Media" }),
          /* @__PURE__ */ ue("div", { className: "flex flex-col gap-2.5 text-sm", children: [
            /* @__PURE__ */ ue(
              "label",
              {
                htmlFor: "mediaLink",
                className: "flex items-center justify-between",
                children: [
                  /* @__PURE__ */ E("p", { className: "mr-1", children: "Media link: " }),
                  /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
                    "input",
                    {
                      className: `w-32 border border-purple-100 px-2 py-1 rounded-md ${d ? "" : "border-red-300 outline-red-300"}`,
                      placeholder: "Paste link",
                      value: f || "",
                      onChange: (ne) => Y(ne.target.value)
                    }
                  ) })
                ]
              }
            ),
            !q && /* @__PURE__ */ ue(Ua, { children: [
              /* @__PURE__ */ E("p", { className: "text-center text-xxs", children: "Or" }),
              /* @__PURE__ */ ue(
                "label",
                {
                  htmlFor: "mediaLink",
                  className: "flex items-center justify-between",
                  children: [
                    /* @__PURE__ */ ue("p", { className: "border border-dashed border-blue-300 h-24 pt-8 w-40 rounded-lg items-center justify-center text-center m-auto cursor-pointer", children: [
                      /* @__PURE__ */ E(tE, { className: "m-auto" }),
                      "Upload from computer"
                    ] }),
                    /* @__PURE__ */ E("div", { children: /* @__PURE__ */ E(
                      "input",
                      {
                        id: "mediaLink",
                        type: "file",
                        accept: "image/*,video/*",
                        className: "hidden",
                        placeholder: "Upload image or video",
                        onChange: V
                      }
                    ) })
                  ]
                }
              )
            ] }),
            /* @__PURE__ */ E("div", { children: q && /* @__PURE__ */ ue(Ua, { children: [
              /* @__PURE__ */ E("p", { className: "text-xs font-bold mb-1", children: "Preview" }),
              d && /* @__PURE__ */ ue("div", { className: "relative", children: [
                w === "image" ? /* @__PURE__ */ E(
                  "img",
                  {
                    src: q,
                    style: We(),
                    alt: ""
                  }
                ) : /* @__PURE__ */ ue(
                  "video",
                  {
                    ...We(),
                    controls: !0,
                    id: "flywheel-rte-video-preview",
                    children: [
                      /* @__PURE__ */ E("source", { src: q, type: `video/${y}` }),
                      "Your browser does not support the video tag."
                    ]
                  }
                ),
                /* @__PURE__ */ E(
                  nE,
                  {
                    className: "border border-gray-200 fill-gray-200 absolute top-1 right-1 cursor-pointer rounded-full h-3 w-3 z-10",
                    onClick: Le
                  }
                )
              ] })
            ] }) }),
            /* @__PURE__ */ ue("div", { className: "flex items-center", children: [
              /* @__PURE__ */ E(
                k,
                {
                  className: "h-5 w-5 cursor-pointer fill-purple-900",
                  onClick: () => X(!W)
                }
              ),
              /* @__PURE__ */ ue("div", { className: "w-full", children: [
                /* @__PURE__ */ ue(
                  "label",
                  {
                    htmlFor: "width",
                    className: "flex items-center justify-between w-full",
                    children: [
                      /* @__PURE__ */ E("p", { children: "Width(px):" }),
                      /* @__PURE__ */ E(
                        "input",
                        {
                          className: "border border-purple-100 rounded-md h-6 px-1 w-16 placeholder:text-gray-300 placeholder:font-medium outline-none focus-visible:border-indigo-500 text-purple-900",
                          type: "number",
                          value: T || "",
                          placeholder: "0",
                          onChange: (ne) => ce(parseInt(ne.target.value))
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ ue(
                  "label",
                  {
                    htmlFor: "height",
                    className: "flex items-center justify-between w-full",
                    children: [
                      /* @__PURE__ */ E("p", { children: "Height(px):" }),
                      /* @__PURE__ */ E(
                        "input",
                        {
                          className: "border border-purple-100 rounded-md h-6 px-1 w-16 placeholder:text-gray-300 placeholder:font-medium outline-none focus-visible:border-indigo-500 text-purple-900",
                          type: "number",
                          value: A || "",
                          placeholder: "0",
                          onChange: (ne) => _(parseInt(ne.target.value))
                        }
                      )
                    ]
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ ue(
              "label",
              {
                htmlFor: "radius",
                className: "flex items-center justify-between w-full",
                children: [
                  /* @__PURE__ */ E("p", { children: "Border radius(px):" }),
                  /* @__PURE__ */ E(
                    "input",
                    {
                      className: "border border-purple-100 rounded-md h-6 px-1 w-16 placeholder:text-gray-300 placeholder:font-medium outline-none focus-visible:border-indigo-500 text-purple-900",
                      type: "number",
                      value: J || "",
                      placeholder: "0",
                      onChange: (ne) => ne.target.value === void 0 ? $(void 0) : $(parseInt(ne.target.value))
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ E(
              "button",
              {
                className: "text-indigo-500 text-xxs m-auto",
                onClick: re,
                children: "Reset dimensions"
              }
            ),
            p && /* @__PURE__ */ E("p", { className: "text-xs text-red-300", children: p })
          ] }),
          /* @__PURE__ */ ue("div", { className: "flex gap-1 justify-end text-xs", children: [
            /* @__PURE__ */ E(
              "button",
              {
                className: "py-1 px-2 rounded-sm bg-purple-100 text-purple-900",
                onClick: bt,
                children: "Cancel"
              }
            ),
            /* @__PURE__ */ E(
              "button",
              {
                className: "py-1 px-2 rounded-sm bg-indigo-500 text-white",
                onClick: N ? void 0 : Ue,
                children: N ? "Saving..." : "Save"
              }
            )
          ] })
        ]
      }
    )
  ] });
};
function cs(e) {
  return [].concat(e);
}
function Bc(e) {
  return e.startsWith(":");
}
function rh(e) {
  return nf(e) && (e === "*" || e.length > 1 && ":>~.+*".includes(e.slice(0, 1)) || fh(e));
}
function ah(e, t) {
  return (nf(t) || typeof t == "number") && !oh(e) && !Bc(e) && !ih(e);
}
function ih(e) {
  return e.startsWith("@media");
}
function fE(e) {
  return e === ".";
}
function oh(e) {
  return e === "--";
}
function nf(e) {
  return e + "" === e;
}
function fh(e) {
  return nf(e) && (e.startsWith("&") || Bc(e));
}
function Eo(e, t = "") {
  return e.filter(Boolean).join(t);
}
function uh(e, t) {
  let n = 0;
  if (t.length === 0)
    return n.toString();
  for (let r = 0; r < t.length; r++) {
    const a = t.charCodeAt(r);
    n = (n << 5) - n + a, n = n & n;
  }
  return `${e ?? "cl"}_${n.toString(36)}`;
}
function uE(e, t) {
  return e === "content" ? `"${t}"` : t;
}
function sE(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function F0(e, t) {
  return `${e}:${t}`;
}
function cE(e) {
  return e ? `.${e}` : "";
}
function lE(e, t) {
  return e ? `${e}
${t}` : t;
}
var sh = class ch {
  constructor(t, n, r, a) {
    this.sheet = t, this.property = n, this.value = r, this.selector = a, this.property = n, this.value = r, this.joined = F0(n, r);
    const i = this.selector.preconditions.concat(
      this.selector.postconditions
    );
    this.hash = this.selector.hasConditions ? this.selector.scopeClassName : uh(this.sheet.name, this.joined), this.key = Eo([this.joined, i, this.hash]);
  }
  toString() {
    let t = ls(this.selector.preconditions, {
      right: this.hash
    });
    return t = ls(this.selector.postconditions, {
      left: t
    }), `${t} {${ch.genRule(this.property, this.value)}}`;
  }
  static genRule(t, n) {
    const r = sE(t);
    return F0(
      r,
      uE(t, n)
    ) + ";";
  }
};
function ls(e, { left: t = "", right: n = "" } = {}) {
  const r = e.reduce((a, i) => Bc(i) ? a + i : fh(i) ? a + i.slice(1) : Eo([a, i], " "), t);
  return Eo([r, cE(n)], " ");
}
var dE = class io {
  constructor(t, n = null, {
    preconditions: r,
    postconditions: a
  } = {}) {
    this.sheet = t, this.preconditions = [], this.scopeClassName = null, this.scopeName = null, this.postconditions = [], this.preconditions = r ? cs(r) : [], this.postconditions = a ? cs(a) : [], this.setScope(n);
  }
  setScope(t) {
    return t ? (this.scopeClassName || (this.scopeName = t, this.scopeClassName = uh(
      this.sheet.name,
      // adding the count guarantees uniqueness across style.create calls
      t + this.sheet.count
    )), this) : this;
  }
  get hasConditions() {
    return this.preconditions.length > 0 || this.postconditions.length > 0;
  }
  addScope(t) {
    return new io(this.sheet, t, {
      preconditions: this.preconditions,
      postconditions: this.postconditions
    });
  }
  addPrecondition(t) {
    return new io(this.sheet, this.scopeClassName, {
      postconditions: this.postconditions,
      preconditions: this.preconditions.concat(t)
    });
  }
  addPostcondition(t) {
    return new io(this.sheet, this.scopeClassName, {
      preconditions: this.preconditions,
      postconditions: this.postconditions.concat(t)
    });
  }
  createRule(t, n) {
    return new sh(this.sheet, t, n, this);
  }
}, gE = class {
  constructor(e, t) {
    this.name = e, this.rootNode = t, this.storedStyles = {}, this.storedClasses = {}, this.style = "", this.count = 0, this.id = `flairup-${e}`, this.styleTag = this.createStyleTag();
  }
  getStyle() {
    return this.style;
  }
  append(e) {
    this.style = lE(this.style, e);
  }
  apply() {
    this.count++, this.styleTag && (this.styleTag.innerHTML = this.style);
  }
  isApplied() {
    return !!this.styleTag;
  }
  createStyleTag() {
    if (typeof document > "u" || this.isApplied() || // Explicitly disallow mounting to the DOM
    this.rootNode === null)
      return this.styleTag;
    const e = document.createElement("style");
    return e.type = "text/css", e.id = this.id, (this.rootNode ?? document.head).appendChild(e), e;
  }
  addRule(e) {
    const t = this.storedClasses[e.key];
    return nf(t) ? t : (this.storedClasses[e.key] = e.hash, this.storedStyles[e.hash] = [e.property, e.value], this.append(e.toString()), e.hash);
  }
};
function Oc(e, t) {
  for (const n in e)
    t(n.trim(), e[n]);
}
function Ee(...e) {
  const t = e.reduce((n, r) => (r instanceof Set ? n.push(...r) : typeof r == "string" ? n.push(r) : Array.isArray(r) ? n.push(Ee(...r)) : typeof r == "object" && Object.entries(r).forEach(([a, i]) => {
    i && n.push(a);
  }), n), []);
  return Eo(t, " ").trim();
}
function pE(e, t) {
  const n = new gE(e, t);
  return {
    create: r,
    getStyle: n.getStyle.bind(n),
    isApplied: n.isApplied.bind(n)
  };
  function r(a) {
    const i = {};
    return lh(n, a, new dE(n)).forEach(
      ([f, s, u]) => {
        rf(n, s, u).forEach(
          (c) => {
            o(f, c);
          }
        );
      }
    ), n.apply(), i;
    function o(f, s) {
      i[f] = i[f] ?? /* @__PURE__ */ new Set(), i[f].add(s);
    }
  }
}
function lh(e, t, n) {
  const r = [];
  return Oc(t, (a, i) => {
    if (rh(a))
      return lh(
        e,
        i,
        n.addPrecondition(a)
      ).forEach((o) => r.push(o));
    r.push([a, t[a], n.addScope(a)]);
  }), r;
}
function rf(e, t, n) {
  const r = /* @__PURE__ */ new Set();
  return Oc(t, (a, i) => {
    let o = [];
    if (rh(a))
      o = rf(
        e,
        i,
        n.addPostcondition(a)
      );
    else if (fE(a))
      o = cs(i);
    else if (ih(a))
      o = vE(e, i, a, n);
    else if (oh(a))
      o = hE(e, i, n);
    else if (ah(a, i)) {
      const f = n.createRule(a, i);
      e.addRule(f), r.add(f.hash);
    }
    return dh(o, r);
  }), r;
}
function dh(e, t) {
  return e.forEach((n) => t.add(n)), t;
}
function hE(e, t, n) {
  const r = /* @__PURE__ */ new Set(), a = [];
  if (Oc(t, (i, o) => {
    if (ah(i, o)) {
      a.push(sh.genRule(i, o));
      return;
    }
    const f = rf(e, o ?? {}, n);
    dh(f, r);
  }), !n.scopeClassName)
    return r;
  if (a.length) {
    const i = a.join(" ");
    e.append(
      `${ls(n.preconditions, {
        right: n.scopeClassName
      })} {${i}}`
    );
  }
  return r.add(n.scopeClassName), r;
}
function vE(e, t, n, r) {
  e.append(n + " {");
  const a = rf(e, t, r);
  return e.append("}"), a;
}
function He() {
  return He = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, He.apply(this, arguments);
}
function mE(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, ds(e, t);
}
function ds(e, t) {
  return ds = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, a) {
    return r.__proto__ = a, r;
  }, ds(e, t);
}
function gh(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), a, i;
  for (i = 0; i < r.length; i++)
    a = r[i], !(t.indexOf(a) >= 0) && (n[a] = e[a]);
  return n;
}
function wE(e, t) {
  if (e) {
    if (typeof e == "string")
      return U0(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return U0(e, t);
  }
}
function U0(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function yE(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = wE(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var De;
(function(e) {
  e.hiddenOnSearch = "epr-hidden-on-search", e.searchActive = "epr-search-active", e.hidden = "epr-hidden", e.visible = "epr-visible", e.active = "epr-active", e.emoji = "epr-emoji", e.category = "epr-emoji-category", e.label = "epr-emoji-category-label", e.categoryContent = "epr-emoji-category-content", e.emojiHasVariations = "epr-emoji-has-variations", e.scrollBody = "epr-body", e.emojiList = "epr-emoji-list", e.external = "__EmojiPicker__", e.emojiPicker = "EmojiPickerReact", e.open = "epr-open", e.vertical = "epr-vertical", e.horizontal = "epr-horizontal", e.variationPicker = "epr-emoji-variation-picker", e.darkTheme = "epr-dark-theme", e.autoTheme = "epr-auto-theme";
})(De || (De = {}));
function ft() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return t.map(function(r) {
    return "." + r;
  }).join("");
}
var Fe = /* @__PURE__ */ pE("epr", null), oo = {
  display: "none",
  opacity: "0",
  pointerEvents: "none",
  visibility: "hidden",
  overflow: "hidden"
}, Pc = /* @__PURE__ */ Fe.create({
  hidden: /* @__PURE__ */ He({
    ".": De.hidden
  }, oo)
}), bE = /* @__PURE__ */ vs(function() {
  return ee("style", {
    suppressHydrationWarning: !0,
    dangerouslySetInnerHTML: {
      __html: Fe.getStyle()
    }
  });
}), hr = /* @__PURE__ */ Fe.create({
  ".epr-main": {
    ":has(input:not(:placeholder-shown))": {
      categoryBtn: {
        ":hover": {
          opacity: "1",
          backgroundPositionY: "var(--epr-category-navigation-button-size)"
        }
      },
      hiddenOnSearch: /* @__PURE__ */ He({
        ".": De.hiddenOnSearch
      }, oo)
    },
    ":has(input(:placeholder-shown))": {
      visibleOnSearchOnly: oo
    }
  },
  hiddenOnReactions: {
    transition: "all 0.5s ease-in-out"
  },
  ".epr-reactions": {
    hiddenOnReactions: {
      height: "0px",
      width: "0px",
      opacity: "0",
      pointerEvents: "none",
      overflow: "hidden"
    }
  },
  ".EmojiPickerReact:not(.epr-search-active)": {
    categoryBtn: {
      ":hover": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      },
      // @ts-ignore
      "&.epr-active": {
        opacity: "1",
        backgroundPositionY: "var(--epr-category-navigation-button-size)"
      }
    },
    visibleOnSearchOnly: /* @__PURE__ */ He({
      ".": "epr-visible-on-search-only"
    }, oo)
  }
});
function Bn(e, t) {
  var n, r;
  return {
    ".epr-dark-theme": (n = {}, n[e] = t, n),
    ".epr-auto-theme": (r = {}, r[e] = {
      "@media (prefers-color-scheme: dark)": t
    }, r)
  };
}
function ph(e, t) {
  var n, r, a = (n = e.customEmojis) != null ? n : [], i = (r = t.customEmojis) != null ? r : [];
  return e.open === t.open && e.emojiVersion === t.emojiVersion && e.reactionsDefaultOpen === t.reactionsDefaultOpen && e.searchPlaceHolder === t.searchPlaceHolder && e.searchPlaceholder === t.searchPlaceholder && e.defaultSkinTone === t.defaultSkinTone && e.skinTonesDisabled === t.skinTonesDisabled && e.autoFocusSearch === t.autoFocusSearch && e.emojiStyle === t.emojiStyle && e.theme === t.theme && e.suggestedEmojisMode === t.suggestedEmojisMode && e.lazyLoadEmojis === t.lazyLoadEmojis && e.className === t.className && e.height === t.height && e.width === t.width && e.style === t.style && e.searchDisabled === t.searchDisabled && e.skinTonePickerLocation === t.skinTonePickerLocation && a.length === i.length;
}
var CE = [
  "1f44d",
  "2764-fe0f",
  "1f603",
  "1f622",
  "1f64f",
  "1f44e",
  "1f621"
  // 😡
], Xr;
(function(e) {
  e.RECENT = "recent", e.FREQUENT = "frequent";
})(Xr || (Xr = {}));
var mt;
(function(e) {
  e.NATIVE = "native", e.APPLE = "apple", e.TWITTER = "twitter", e.GOOGLE = "google", e.FACEBOOK = "facebook";
})(mt || (mt = {}));
var Ka;
(function(e) {
  e.DARK = "dark", e.LIGHT = "light", e.AUTO = "auto";
})(Ka || (Ka = {}));
var Ft;
(function(e) {
  e.NEUTRAL = "neutral", e.LIGHT = "1f3fb", e.MEDIUM_LIGHT = "1f3fc", e.MEDIUM = "1f3fd", e.MEDIUM_DARK = "1f3fe", e.DARK = "1f3ff";
})(Ft || (Ft = {}));
var Me;
(function(e) {
  e.SUGGESTED = "suggested", e.CUSTOM = "custom", e.SMILEYS_PEOPLE = "smileys_people", e.ANIMALS_NATURE = "animals_nature", e.FOOD_DRINK = "food_drink", e.TRAVEL_PLACES = "travel_places", e.ACTIVITIES = "activities", e.OBJECTS = "objects", e.SYMBOLS = "symbols", e.FLAGS = "flags";
})(Me || (Me = {}));
var ea;
(function(e) {
  e.SEARCH = "SEARCH", e.PREVIEW = "PREVIEW";
})(ea || (ea = {}));
var Tt, ME = [Me.SUGGESTED, Me.CUSTOM, Me.SMILEYS_PEOPLE, Me.ANIMALS_NATURE, Me.FOOD_DRINK, Me.TRAVEL_PLACES, Me.ACTIVITIES, Me.OBJECTS, Me.SYMBOLS, Me.FLAGS], DE = {
  name: "Recently Used",
  category: Me.SUGGESTED
}, hh = (Tt = {}, Tt[Me.SUGGESTED] = {
  category: Me.SUGGESTED,
  name: "Frequently Used"
}, Tt[Me.CUSTOM] = {
  category: Me.CUSTOM,
  name: "Custom Emojis"
}, Tt[Me.SMILEYS_PEOPLE] = {
  category: Me.SMILEYS_PEOPLE,
  name: "Smileys & People"
}, Tt[Me.ANIMALS_NATURE] = {
  category: Me.ANIMALS_NATURE,
  name: "Animals & Nature"
}, Tt[Me.FOOD_DRINK] = {
  category: Me.FOOD_DRINK,
  name: "Food & Drink"
}, Tt[Me.TRAVEL_PLACES] = {
  category: Me.TRAVEL_PLACES,
  name: "Travel & Places"
}, Tt[Me.ACTIVITIES] = {
  category: Me.ACTIVITIES,
  name: "Activities"
}, Tt[Me.OBJECTS] = {
  category: Me.OBJECTS,
  name: "Objects"
}, Tt[Me.SYMBOLS] = {
  category: Me.SYMBOLS,
  name: "Symbols"
}, Tt[Me.FLAGS] = {
  category: Me.FLAGS,
  name: "Flags"
}, Tt);
function vh(e) {
  return ME.map(function(t) {
    return He({}, hh[t], e && e[t] && e[t]);
  });
}
function zc(e) {
  return e.category;
}
function mh(e) {
  return e.name;
}
function LE(e, t) {
  var n;
  e === void 0 && (e = []), t === void 0 && (t = {});
  var r = {};
  t.suggestionMode === Xr.RECENT && (r[Me.SUGGESTED] = DE);
  var a = vh(r);
  return (n = e) != null && n.length ? e.map(function(i) {
    return typeof i == "string" ? Y0(i, r[i]) : He({}, Y0(i.category, r[i.category]), i);
  }) : a;
}
function Y0(e, t) {
  return t === void 0 && (t = {}), Object.assign(hh[e], t);
}
var AE = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/", EE = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/", jE = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/", IE = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function SE(e) {
  switch (e) {
    case mt.TWITTER:
      return jE;
    case mt.GOOGLE:
      return IE;
    case mt.FACEBOOK:
      return EE;
    case mt.APPLE:
    default:
      return AE;
  }
}
var xE = [], TE = [
  {
    n: [
      "grinning",
      "grinning face"
    ],
    u: "1f600",
    a: "1.0"
  },
  {
    n: [
      "smiley",
      "smiling face with open mouth"
    ],
    u: "1f603",
    a: "0.6"
  },
  {
    n: [
      "smile",
      "smiling face with open mouth and smiling eyes"
    ],
    u: "1f604",
    a: "0.6"
  },
  {
    n: [
      "grin",
      "grinning face with smiling eyes"
    ],
    u: "1f601",
    a: "0.6"
  },
  {
    n: [
      "laughing",
      "satisfied",
      "smiling face with open mouth and tightly-closed eyes"
    ],
    u: "1f606",
    a: "0.6"
  },
  {
    n: [
      "sweat smile",
      "smiling face with open mouth and cold sweat"
    ],
    u: "1f605",
    a: "0.6"
  },
  {
    n: [
      "rolling on the floor laughing"
    ],
    u: "1f923",
    a: "3.0"
  },
  {
    n: [
      "joy",
      "face with tears of joy"
    ],
    u: "1f602",
    a: "0.6"
  },
  {
    n: [
      "slightly smiling face"
    ],
    u: "1f642",
    a: "1.0"
  },
  {
    n: [
      "upside-down face",
      "upside down face"
    ],
    u: "1f643",
    a: "1.0"
  },
  {
    n: [
      "melting face"
    ],
    u: "1fae0",
    a: "14.0"
  },
  {
    n: [
      "wink",
      "winking face"
    ],
    u: "1f609",
    a: "0.6"
  },
  {
    n: [
      "blush",
      "smiling face with smiling eyes"
    ],
    u: "1f60a",
    a: "0.6"
  },
  {
    n: [
      "innocent",
      "smiling face with halo"
    ],
    u: "1f607",
    a: "1.0"
  },
  {
    n: [
      "smiling face with 3 hearts",
      "smiling face with smiling eyes and three hearts"
    ],
    u: "1f970",
    a: "11.0"
  },
  {
    n: [
      "heart eyes",
      "smiling face with heart-shaped eyes"
    ],
    u: "1f60d",
    a: "0.6"
  },
  {
    n: [
      "star-struck",
      "grinning face with star eyes"
    ],
    u: "1f929",
    a: "5.0"
  },
  {
    n: [
      "kissing heart",
      "face throwing a kiss"
    ],
    u: "1f618",
    a: "0.6"
  },
  {
    n: [
      "kissing",
      "kissing face"
    ],
    u: "1f617",
    a: "1.0"
  },
  {
    n: [
      "relaxed",
      "white smiling face"
    ],
    u: "263a-fe0f",
    a: "0.6"
  },
  {
    n: [
      "kissing closed eyes",
      "kissing face with closed eyes"
    ],
    u: "1f61a",
    a: "0.6"
  },
  {
    n: [
      "kissing smiling eyes",
      "kissing face with smiling eyes"
    ],
    u: "1f619",
    a: "1.0"
  },
  {
    n: [
      "smiling face with tear"
    ],
    u: "1f972",
    a: "13.0"
  },
  {
    n: [
      "yum",
      "face savouring delicious food"
    ],
    u: "1f60b",
    a: "0.6"
  },
  {
    n: [
      "stuck out tongue",
      "face with stuck-out tongue"
    ],
    u: "1f61b",
    a: "1.0"
  },
  {
    n: [
      "stuck out tongue winking eye",
      "face with stuck-out tongue and winking eye"
    ],
    u: "1f61c",
    a: "0.6"
  },
  {
    n: [
      "zany face",
      "grinning face with one large and one small eye"
    ],
    u: "1f92a",
    a: "5.0"
  },
  {
    n: [
      "stuck out tongue closed eyes",
      "face with stuck-out tongue and tightly-closed eyes"
    ],
    u: "1f61d",
    a: "0.6"
  },
  {
    n: [
      "money-mouth face",
      "money mouth face"
    ],
    u: "1f911",
    a: "1.0"
  },
  {
    n: [
      "hugging face"
    ],
    u: "1f917",
    a: "1.0"
  },
  {
    n: [
      "face with hand over mouth",
      "smiling face with smiling eyes and hand covering mouth"
    ],
    u: "1f92d",
    a: "5.0"
  },
  {
    n: [
      "face with open eyes and hand over mouth"
    ],
    u: "1fae2",
    a: "14.0"
  },
  {
    n: [
      "face with peeking eye"
    ],
    u: "1fae3",
    a: "14.0"
  },
  {
    n: [
      "shushing face",
      "face with finger covering closed lips"
    ],
    u: "1f92b",
    a: "5.0"
  },
  {
    n: [
      "thinking face"
    ],
    u: "1f914",
    a: "1.0"
  },
  {
    n: [
      "saluting face"
    ],
    u: "1fae1",
    a: "14.0"
  },
  {
    n: [
      "zipper-mouth face",
      "zipper mouth face"
    ],
    u: "1f910",
    a: "1.0"
  },
  {
    n: [
      "face with raised eyebrow",
      "face with one eyebrow raised"
    ],
    u: "1f928",
    a: "5.0"
  },
  {
    n: [
      "neutral face"
    ],
    u: "1f610",
    a: "0.7"
  },
  {
    n: [
      "expressionless",
      "expressionless face"
    ],
    u: "1f611",
    a: "1.0"
  },
  {
    n: [
      "no mouth",
      "face without mouth"
    ],
    u: "1f636",
    a: "1.0"
  },
  {
    n: [
      "dotted line face"
    ],
    u: "1fae5",
    a: "14.0"
  },
  {
    n: [
      "face in clouds"
    ],
    u: "1f636-200d-1f32b-fe0f",
    a: "13.1"
  },
  {
    n: [
      "smirk",
      "smirking face"
    ],
    u: "1f60f",
    a: "0.6"
  },
  {
    n: [
      "unamused",
      "unamused face"
    ],
    u: "1f612",
    a: "0.6"
  },
  {
    n: [
      "face with rolling eyes"
    ],
    u: "1f644",
    a: "1.0"
  },
  {
    n: [
      "grimacing",
      "grimacing face"
    ],
    u: "1f62c",
    a: "1.0"
  },
  {
    n: [
      "face exhaling"
    ],
    u: "1f62e-200d-1f4a8",
    a: "13.1"
  },
  {
    n: [
      "lying face"
    ],
    u: "1f925",
    a: "3.0"
  },
  {
    n: [
      "relieved",
      "relieved face"
    ],
    u: "1f60c",
    a: "0.6"
  },
  {
    n: [
      "pensive",
      "pensive face"
    ],
    u: "1f614",
    a: "0.6"
  },
  {
    n: [
      "sleepy",
      "sleepy face"
    ],
    u: "1f62a",
    a: "0.6"
  },
  {
    n: [
      "drooling face"
    ],
    u: "1f924",
    a: "3.0"
  },
  {
    n: [
      "sleeping",
      "sleeping face"
    ],
    u: "1f634",
    a: "1.0"
  },
  {
    n: [
      "mask",
      "face with medical mask"
    ],
    u: "1f637",
    a: "0.6"
  },
  {
    n: [
      "face with thermometer"
    ],
    u: "1f912",
    a: "1.0"
  },
  {
    n: [
      "face with head-bandage",
      "face with head bandage"
    ],
    u: "1f915",
    a: "1.0"
  },
  {
    n: [
      "nauseated face"
    ],
    u: "1f922",
    a: "3.0"
  },
  {
    n: [
      "face vomiting",
      "face with open mouth vomiting"
    ],
    u: "1f92e",
    a: "5.0"
  },
  {
    n: [
      "sneezing face"
    ],
    u: "1f927",
    a: "3.0"
  },
  {
    n: [
      "hot face",
      "overheated face"
    ],
    u: "1f975",
    a: "11.0"
  },
  {
    n: [
      "cold face",
      "freezing face"
    ],
    u: "1f976",
    a: "11.0"
  },
  {
    n: [
      "woozy face",
      "face with uneven eyes and wavy mouth"
    ],
    u: "1f974",
    a: "11.0"
  },
  {
    n: [
      "dizzy face"
    ],
    u: "1f635",
    a: "0.6"
  },
  {
    n: [
      "face with spiral eyes"
    ],
    u: "1f635-200d-1f4ab",
    a: "13.1"
  },
  {
    n: [
      "exploding head",
      "shocked face with exploding head"
    ],
    u: "1f92f",
    a: "5.0"
  },
  {
    n: [
      "face with cowboy hat"
    ],
    u: "1f920",
    a: "3.0"
  },
  {
    n: [
      "partying face",
      "face with party horn and party hat"
    ],
    u: "1f973",
    a: "11.0"
  },
  {
    n: [
      "disguised face"
    ],
    u: "1f978",
    a: "13.0"
  },
  {
    n: [
      "sunglasses",
      "smiling face with sunglasses"
    ],
    u: "1f60e",
    a: "1.0"
  },
  {
    n: [
      "nerd face"
    ],
    u: "1f913",
    a: "1.0"
  },
  {
    n: [
      "face with monocle"
    ],
    u: "1f9d0",
    a: "5.0"
  },
  {
    n: [
      "confused",
      "confused face"
    ],
    u: "1f615",
    a: "1.0"
  },
  {
    n: [
      "face with diagonal mouth"
    ],
    u: "1fae4",
    a: "14.0"
  },
  {
    n: [
      "worried",
      "worried face"
    ],
    u: "1f61f",
    a: "1.0"
  },
  {
    n: [
      "slightly frowning face"
    ],
    u: "1f641",
    a: "1.0"
  },
  {
    n: [
      "frowning face",
      "white frowning face"
    ],
    u: "2639-fe0f",
    a: "0.7"
  },
  {
    n: [
      "open mouth",
      "face with open mouth"
    ],
    u: "1f62e",
    a: "1.0"
  },
  {
    n: [
      "hushed",
      "hushed face"
    ],
    u: "1f62f",
    a: "1.0"
  },
  {
    n: [
      "astonished",
      "astonished face"
    ],
    u: "1f632",
    a: "0.6"
  },
  {
    n: [
      "flushed",
      "flushed face"
    ],
    u: "1f633",
    a: "0.6"
  },
  {
    n: [
      "pleading face",
      "face with pleading eyes"
    ],
    u: "1f97a",
    a: "11.0"
  },
  {
    n: [
      "face holding back tears"
    ],
    u: "1f979",
    a: "14.0"
  },
  {
    n: [
      "frowning",
      "frowning face with open mouth"
    ],
    u: "1f626",
    a: "1.0"
  },
  {
    n: [
      "anguished",
      "anguished face"
    ],
    u: "1f627",
    a: "1.0"
  },
  {
    n: [
      "fearful",
      "fearful face"
    ],
    u: "1f628",
    a: "0.6"
  },
  {
    n: [
      "cold sweat",
      "face with open mouth and cold sweat"
    ],
    u: "1f630",
    a: "0.6"
  },
  {
    n: [
      "disappointed relieved",
      "disappointed but relieved face"
    ],
    u: "1f625",
    a: "0.6"
  },
  {
    n: [
      "cry",
      "crying face"
    ],
    u: "1f622",
    a: "0.6"
  },
  {
    n: [
      "sob",
      "loudly crying face"
    ],
    u: "1f62d",
    a: "0.6"
  },
  {
    n: [
      "scream",
      "face screaming in fear"
    ],
    u: "1f631",
    a: "0.6"
  },
  {
    n: [
      "confounded",
      "confounded face"
    ],
    u: "1f616",
    a: "0.6"
  },
  {
    n: [
      "persevere",
      "persevering face"
    ],
    u: "1f623",
    a: "0.6"
  },
  {
    n: [
      "disappointed",
      "disappointed face"
    ],
    u: "1f61e",
    a: "0.6"
  },
  {
    n: [
      "sweat",
      "face with cold sweat"
    ],
    u: "1f613",
    a: "0.6"
  },
  {
    n: [
      "weary",
      "weary face"
    ],
    u: "1f629",
    a: "0.6"
  },
  {
    n: [
      "tired face"
    ],
    u: "1f62b",
    a: "0.6"
  },
  {
    n: [
      "yawning face"
    ],
    u: "1f971",
    a: "12.0"
  },
  {
    n: [
      "triumph",
      "face with look of triumph"
    ],
    u: "1f624",
    a: "0.6"
  },
  {
    n: [
      "rage",
      "pouting face"
    ],
    u: "1f621",
    a: "0.6"
  },
  {
    n: [
      "angry",
      "angry face"
    ],
    u: "1f620",
    a: "0.6"
  },
  {
    n: [
      "face with symbols on mouth",
      "serious face with symbols covering mouth"
    ],
    u: "1f92c",
    a: "5.0"
  },
  {
    n: [
      "smiling imp",
      "smiling face with horns"
    ],
    u: "1f608",
    a: "1.0"
  },
  {
    n: [
      "imp"
    ],
    u: "1f47f",
    a: "0.6"
  },
  {
    n: [
      "skull"
    ],
    u: "1f480",
    a: "0.6"
  },
  {
    n: [
      "skull and crossbones"
    ],
    u: "2620-fe0f",
    a: "1.0"
  },
  {
    n: [
      "poop",
      "shit",
      "hankey",
      "pile of poo"
    ],
    u: "1f4a9",
    a: "0.6"
  },
  {
    n: [
      "clown face"
    ],
    u: "1f921",
    a: "3.0"
  },
  {
    n: [
      "japanese ogre"
    ],
    u: "1f479",
    a: "0.6"
  },
  {
    n: [
      "japanese goblin"
    ],
    u: "1f47a",
    a: "0.6"
  },
  {
    n: [
      "ghost"
    ],
    u: "1f47b",
    a: "0.6"
  },
  {
    n: [
      "alien",
      "extraterrestrial alien"
    ],
    u: "1f47d",
    a: "0.6"
  },
  {
    n: [
      "alien monster",
      "space invader"
    ],
    u: "1f47e",
    a: "0.6"
  },
  {
    n: [
      "robot face"
    ],
    u: "1f916",
    a: "1.0"
  },
  {
    n: [
      "smiley cat",
      "smiling cat face with open mouth"
    ],
    u: "1f63a",
    a: "0.6"
  },
  {
    n: [
      "smile cat",
      "grinning cat face with smiling eyes"
    ],
    u: "1f638",
    a: "0.6"
  },
  {
    n: [
      "joy cat",
      "cat face with tears of joy"
    ],
    u: "1f639",
    a: "0.6"
  },
  {
    n: [
      "heart eyes cat",
      "smiling cat face with heart-shaped eyes"
    ],
    u: "1f63b",
    a: "0.6"
  },
  {
    n: [
      "smirk cat",
      "cat face with wry smile"
    ],
    u: "1f63c",
    a: "0.6"
  },
  {
    n: [
      "kissing cat",
      "kissing cat face with closed eyes"
    ],
    u: "1f63d",
    a: "0.6"
  },
  {
    n: [
      "scream cat",
      "weary cat face"
    ],
    u: "1f640",
    a: "0.6"
  },
  {
    n: [
      "crying cat face"
    ],
    u: "1f63f",
    a: "0.6"
  },
  {
    n: [
      "pouting cat",
      "pouting cat face"
    ],
    u: "1f63e",
    a: "0.6"
  },
  {
    n: [
      "see no evil",
      "see-no-evil monkey"
    ],
    u: "1f648",
    a: "0.6"
  },
  {
    n: [
      "hear no evil",
      "hear-no-evil monkey"
    ],
    u: "1f649",
    a: "0.6"
  },
  {
    n: [
      "speak no evil",
      "speak-no-evil monkey"
    ],
    u: "1f64a",
    a: "0.6"
  },
  {
    n: [
      "kiss",
      "kiss mark"
    ],
    u: "1f48b",
    a: "0.6"
  },
  {
    n: [
      "love letter"
    ],
    u: "1f48c",
    a: "0.6"
  },
  {
    n: [
      "cupid",
      "heart with arrow"
    ],
    u: "1f498",
    a: "0.6"
  },
  {
    n: [
      "gift heart",
      "heart with ribbon"
    ],
    u: "1f49d",
    a: "0.6"
  },
  {
    n: [
      "sparkling heart"
    ],
    u: "1f496",
    a: "0.6"
  },
  {
    n: [
      "heartpulse",
      "growing heart"
    ],
    u: "1f497",
    a: "0.6"
  },
  {
    n: [
      "heartbeat",
      "beating heart"
    ],
    u: "1f493",
    a: "0.6"
  },
  {
    n: [
      "revolving hearts"
    ],
    u: "1f49e",
    a: "0.6"
  },
  {
    n: [
      "two hearts"
    ],
    u: "1f495",
    a: "0.6"
  },
  {
    n: [
      "heart decoration"
    ],
    u: "1f49f",
    a: "0.6"
  },
  {
    n: [
      "heart exclamation",
      "heavy heart exclamation mark ornament"
    ],
    u: "2763-fe0f",
    a: "1.0"
  },
  {
    n: [
      "broken heart"
    ],
    u: "1f494",
    a: "0.6"
  },
  {
    n: [
      "heart on fire"
    ],
    u: "2764-fe0f-200d-1f525",
    a: "13.1"
  },
  {
    n: [
      "mending heart"
    ],
    u: "2764-fe0f-200d-1fa79",
    a: "13.1"
  },
  {
    n: [
      "heart",
      "heavy black heart"
    ],
    u: "2764-fe0f",
    a: "0.6"
  },
  {
    n: [
      "orange heart"
    ],
    u: "1f9e1",
    a: "5.0"
  },
  {
    n: [
      "yellow heart"
    ],
    u: "1f49b",
    a: "0.6"
  },
  {
    n: [
      "green heart"
    ],
    u: "1f49a",
    a: "0.6"
  },
  {
    n: [
      "blue heart"
    ],
    u: "1f499",
    a: "0.6"
  },
  {
    n: [
      "purple heart"
    ],
    u: "1f49c",
    a: "0.6"
  },
  {
    n: [
      "brown heart"
    ],
    u: "1f90e",
    a: "12.0"
  },
  {
    n: [
      "black heart"
    ],
    u: "1f5a4",
    a: "3.0"
  },
  {
    n: [
      "white heart"
    ],
    u: "1f90d",
    a: "12.0"
  },
  {
    n: [
      "100",
      "hundred points symbol"
    ],
    u: "1f4af",
    a: "0.6"
  },
  {
    n: [
      "anger",
      "anger symbol"
    ],
    u: "1f4a2",
    a: "0.6"
  },
  {
    n: [
      "boom",
      "collision",
      "collision symbol"
    ],
    u: "1f4a5",
    a: "0.6"
  },
  {
    n: [
      "dizzy",
      "dizzy symbol"
    ],
    u: "1f4ab",
    a: "0.6"
  },
  {
    n: [
      "sweat drops",
      "splashing sweat symbol"
    ],
    u: "1f4a6",
    a: "0.6"
  },
  {
    n: [
      "dash",
      "dash symbol"
    ],
    u: "1f4a8",
    a: "0.6"
  },
  {
    n: [
      "hole"
    ],
    u: "1f573-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bomb"
    ],
    u: "1f4a3",
    a: "0.6"
  },
  {
    n: [
      "speech balloon"
    ],
    u: "1f4ac",
    a: "0.6"
  },
  {
    n: [
      "eye in speech bubble",
      "eye-in-speech-bubble"
    ],
    u: "1f441-fe0f-200d-1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "left speech bubble"
    ],
    u: "1f5e8-fe0f",
    a: "2.0"
  },
  {
    n: [
      "right anger bubble"
    ],
    u: "1f5ef-fe0f",
    a: "0.7"
  },
  {
    n: [
      "thought balloon"
    ],
    u: "1f4ad",
    a: "1.0"
  },
  {
    n: [
      "zzz",
      "sleeping symbol"
    ],
    u: "1f4a4",
    a: "0.6"
  },
  {
    n: [
      "wave",
      "waving hand sign"
    ],
    u: "1f44b",
    v: [
      "1f44b-1f3fb",
      "1f44b-1f3fc",
      "1f44b-1f3fd",
      "1f44b-1f3fe",
      "1f44b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised back of hand"
    ],
    u: "1f91a",
    v: [
      "1f91a-1f3fb",
      "1f91a-1f3fc",
      "1f91a-1f3fd",
      "1f91a-1f3fe",
      "1f91a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with fingers splayed",
      "raised hand with fingers splayed"
    ],
    u: "1f590-fe0f",
    v: [
      "1f590-1f3fb",
      "1f590-1f3fc",
      "1f590-1f3fd",
      "1f590-1f3fe",
      "1f590-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "hand",
      "raised hand"
    ],
    u: "270b",
    v: [
      "270b-1f3fb",
      "270b-1f3fc",
      "270b-1f3fd",
      "270b-1f3fe",
      "270b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "spock-hand",
      "raised hand with part between middle and ring fingers"
    ],
    u: "1f596",
    v: [
      "1f596-1f3fb",
      "1f596-1f3fc",
      "1f596-1f3fd",
      "1f596-1f3fe",
      "1f596-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "rightwards hand"
    ],
    u: "1faf1",
    v: [
      "1faf1-1f3fb",
      "1faf1-1f3fc",
      "1faf1-1f3fd",
      "1faf1-1f3fe",
      "1faf1-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "leftwards hand"
    ],
    u: "1faf2",
    v: [
      "1faf2-1f3fb",
      "1faf2-1f3fc",
      "1faf2-1f3fd",
      "1faf2-1f3fe",
      "1faf2-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm down hand"
    ],
    u: "1faf3",
    v: [
      "1faf3-1f3fb",
      "1faf3-1f3fc",
      "1faf3-1f3fd",
      "1faf3-1f3fe",
      "1faf3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "palm up hand"
    ],
    u: "1faf4",
    v: [
      "1faf4-1f3fb",
      "1faf4-1f3fc",
      "1faf4-1f3fd",
      "1faf4-1f3fe",
      "1faf4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "ok hand",
      "ok hand sign"
    ],
    u: "1f44c",
    v: [
      "1f44c-1f3fb",
      "1f44c-1f3fc",
      "1f44c-1f3fd",
      "1f44c-1f3fe",
      "1f44c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "pinched fingers"
    ],
    u: "1f90c",
    v: [
      "1f90c-1f3fb",
      "1f90c-1f3fc",
      "1f90c-1f3fd",
      "1f90c-1f3fe",
      "1f90c-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "pinching hand"
    ],
    u: "1f90f",
    v: [
      "1f90f-1f3fb",
      "1f90f-1f3fc",
      "1f90f-1f3fd",
      "1f90f-1f3fe",
      "1f90f-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "v",
      "victory hand"
    ],
    u: "270c-fe0f",
    v: [
      "270c-1f3fb",
      "270c-1f3fc",
      "270c-1f3fd",
      "270c-1f3fe",
      "270c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "crossed fingers",
      "hand with index and middle fingers crossed"
    ],
    u: "1f91e",
    v: [
      "1f91e-1f3fb",
      "1f91e-1f3fc",
      "1f91e-1f3fd",
      "1f91e-1f3fe",
      "1f91e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "hand with index finger and thumb crossed"
    ],
    u: "1faf0",
    v: [
      "1faf0-1f3fb",
      "1faf0-1f3fc",
      "1faf0-1f3fd",
      "1faf0-1f3fe",
      "1faf0-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "i love you hand sign"
    ],
    u: "1f91f",
    v: [
      "1f91f-1f3fb",
      "1f91f-1f3fc",
      "1f91f-1f3fd",
      "1f91f-1f3fe",
      "1f91f-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "the horns",
      "sign of the horns"
    ],
    u: "1f918",
    v: [
      "1f918-1f3fb",
      "1f918-1f3fc",
      "1f918-1f3fd",
      "1f918-1f3fe",
      "1f918-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "call me hand"
    ],
    u: "1f919",
    v: [
      "1f919-1f3fb",
      "1f919-1f3fc",
      "1f919-1f3fd",
      "1f919-1f3fe",
      "1f919-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "point left",
      "white left pointing backhand index"
    ],
    u: "1f448",
    v: [
      "1f448-1f3fb",
      "1f448-1f3fc",
      "1f448-1f3fd",
      "1f448-1f3fe",
      "1f448-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point right",
      "white right pointing backhand index"
    ],
    u: "1f449",
    v: [
      "1f449-1f3fb",
      "1f449-1f3fc",
      "1f449-1f3fd",
      "1f449-1f3fe",
      "1f449-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up 2",
      "white up pointing backhand index"
    ],
    u: "1f446",
    v: [
      "1f446-1f3fb",
      "1f446-1f3fc",
      "1f446-1f3fd",
      "1f446-1f3fe",
      "1f446-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "middle finger",
      "reversed hand with middle finger extended"
    ],
    u: "1f595",
    v: [
      "1f595-1f3fb",
      "1f595-1f3fc",
      "1f595-1f3fd",
      "1f595-1f3fe",
      "1f595-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "point down",
      "white down pointing backhand index"
    ],
    u: "1f447",
    v: [
      "1f447-1f3fb",
      "1f447-1f3fc",
      "1f447-1f3fd",
      "1f447-1f3fe",
      "1f447-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "point up",
      "white up pointing index"
    ],
    u: "261d-fe0f",
    v: [
      "261d-1f3fb",
      "261d-1f3fc",
      "261d-1f3fd",
      "261d-1f3fe",
      "261d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "index pointing at the viewer"
    ],
    u: "1faf5",
    v: [
      "1faf5-1f3fb",
      "1faf5-1f3fc",
      "1faf5-1f3fd",
      "1faf5-1f3fe",
      "1faf5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "+1",
      "thumbsup",
      "thumbs up sign"
    ],
    u: "1f44d",
    v: [
      "1f44d-1f3fb",
      "1f44d-1f3fc",
      "1f44d-1f3fd",
      "1f44d-1f3fe",
      "1f44d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "-1",
      "thumbsdown",
      "thumbs down sign"
    ],
    u: "1f44e",
    v: [
      "1f44e-1f3fb",
      "1f44e-1f3fc",
      "1f44e-1f3fd",
      "1f44e-1f3fe",
      "1f44e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "fist",
      "raised fist"
    ],
    u: "270a",
    v: [
      "270a-1f3fb",
      "270a-1f3fc",
      "270a-1f3fd",
      "270a-1f3fe",
      "270a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "punch",
      "facepunch",
      "fisted hand sign"
    ],
    u: "1f44a",
    v: [
      "1f44a-1f3fb",
      "1f44a-1f3fc",
      "1f44a-1f3fd",
      "1f44a-1f3fe",
      "1f44a-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "left-facing fist"
    ],
    u: "1f91b",
    v: [
      "1f91b-1f3fb",
      "1f91b-1f3fc",
      "1f91b-1f3fd",
      "1f91b-1f3fe",
      "1f91b-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "right-facing fist"
    ],
    u: "1f91c",
    v: [
      "1f91c-1f3fb",
      "1f91c-1f3fc",
      "1f91c-1f3fd",
      "1f91c-1f3fe",
      "1f91c-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "clap",
      "clapping hands sign"
    ],
    u: "1f44f",
    v: [
      "1f44f-1f3fb",
      "1f44f-1f3fc",
      "1f44f-1f3fd",
      "1f44f-1f3fe",
      "1f44f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "raised hands",
      "person raising both hands in celebration"
    ],
    u: "1f64c",
    v: [
      "1f64c-1f3fb",
      "1f64c-1f3fc",
      "1f64c-1f3fd",
      "1f64c-1f3fe",
      "1f64c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "heart hands"
    ],
    u: "1faf6",
    v: [
      "1faf6-1f3fb",
      "1faf6-1f3fc",
      "1faf6-1f3fd",
      "1faf6-1f3fe",
      "1faf6-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "open hands",
      "open hands sign"
    ],
    u: "1f450",
    v: [
      "1f450-1f3fb",
      "1f450-1f3fc",
      "1f450-1f3fd",
      "1f450-1f3fe",
      "1f450-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "palms up together"
    ],
    u: "1f932",
    v: [
      "1f932-1f3fb",
      "1f932-1f3fc",
      "1f932-1f3fd",
      "1f932-1f3fe",
      "1f932-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "handshake"
    ],
    u: "1f91d",
    v: [
      "1f91d-1f3fb",
      "1f91d-1f3fc",
      "1f91d-1f3fd",
      "1f91d-1f3fe",
      "1f91d-1f3ff",
      "1faf1-1f3fb-200d-1faf2-1f3fc",
      "1faf1-1f3fb-200d-1faf2-1f3fd",
      "1faf1-1f3fb-200d-1faf2-1f3fe",
      "1faf1-1f3fb-200d-1faf2-1f3ff",
      "1faf1-1f3fc-200d-1faf2-1f3fb",
      "1faf1-1f3fc-200d-1faf2-1f3fd",
      "1faf1-1f3fc-200d-1faf2-1f3fe",
      "1faf1-1f3fc-200d-1faf2-1f3ff",
      "1faf1-1f3fd-200d-1faf2-1f3fb",
      "1faf1-1f3fd-200d-1faf2-1f3fc",
      "1faf1-1f3fd-200d-1faf2-1f3fe",
      "1faf1-1f3fd-200d-1faf2-1f3ff",
      "1faf1-1f3fe-200d-1faf2-1f3fb",
      "1faf1-1f3fe-200d-1faf2-1f3fc",
      "1faf1-1f3fe-200d-1faf2-1f3fd",
      "1faf1-1f3fe-200d-1faf2-1f3ff",
      "1faf1-1f3ff-200d-1faf2-1f3fb",
      "1faf1-1f3ff-200d-1faf2-1f3fc",
      "1faf1-1f3ff-200d-1faf2-1f3fd",
      "1faf1-1f3ff-200d-1faf2-1f3fe"
    ],
    a: "3.0"
  },
  {
    n: [
      "pray",
      "person with folded hands"
    ],
    u: "1f64f",
    v: [
      "1f64f-1f3fb",
      "1f64f-1f3fc",
      "1f64f-1f3fd",
      "1f64f-1f3fe",
      "1f64f-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "writing hand"
    ],
    u: "270d-fe0f",
    v: [
      "270d-1f3fb",
      "270d-1f3fc",
      "270d-1f3fd",
      "270d-1f3fe",
      "270d-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "nail care",
      "nail polish"
    ],
    u: "1f485",
    v: [
      "1f485-1f3fb",
      "1f485-1f3fc",
      "1f485-1f3fd",
      "1f485-1f3fe",
      "1f485-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "selfie"
    ],
    u: "1f933",
    v: [
      "1f933-1f3fb",
      "1f933-1f3fc",
      "1f933-1f3fd",
      "1f933-1f3fe",
      "1f933-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "muscle",
      "flexed biceps"
    ],
    u: "1f4aa",
    v: [
      "1f4aa-1f3fb",
      "1f4aa-1f3fc",
      "1f4aa-1f3fd",
      "1f4aa-1f3fe",
      "1f4aa-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mechanical arm"
    ],
    u: "1f9be",
    a: "12.0"
  },
  {
    n: [
      "mechanical leg"
    ],
    u: "1f9bf",
    a: "12.0"
  },
  {
    n: [
      "leg"
    ],
    u: "1f9b5",
    v: [
      "1f9b5-1f3fb",
      "1f9b5-1f3fc",
      "1f9b5-1f3fd",
      "1f9b5-1f3fe",
      "1f9b5-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "foot"
    ],
    u: "1f9b6",
    v: [
      "1f9b6-1f3fb",
      "1f9b6-1f3fc",
      "1f9b6-1f3fd",
      "1f9b6-1f3fe",
      "1f9b6-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "ear"
    ],
    u: "1f442",
    v: [
      "1f442-1f3fb",
      "1f442-1f3fc",
      "1f442-1f3fd",
      "1f442-1f3fe",
      "1f442-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "ear with hearing aid"
    ],
    u: "1f9bb",
    v: [
      "1f9bb-1f3fb",
      "1f9bb-1f3fc",
      "1f9bb-1f3fd",
      "1f9bb-1f3fe",
      "1f9bb-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "nose"
    ],
    u: "1f443",
    v: [
      "1f443-1f3fb",
      "1f443-1f3fc",
      "1f443-1f3fd",
      "1f443-1f3fe",
      "1f443-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "brain"
    ],
    u: "1f9e0",
    a: "5.0"
  },
  {
    n: [
      "anatomical heart"
    ],
    u: "1fac0",
    a: "13.0"
  },
  {
    n: [
      "lungs"
    ],
    u: "1fac1",
    a: "13.0"
  },
  {
    n: [
      "tooth"
    ],
    u: "1f9b7",
    a: "11.0"
  },
  {
    n: [
      "bone"
    ],
    u: "1f9b4",
    a: "11.0"
  },
  {
    n: [
      "eyes"
    ],
    u: "1f440",
    a: "0.6"
  },
  {
    n: [
      "eye"
    ],
    u: "1f441-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tongue"
    ],
    u: "1f445",
    a: "0.6"
  },
  {
    n: [
      "lips",
      "mouth"
    ],
    u: "1f444",
    a: "0.6"
  },
  {
    n: [
      "biting lip"
    ],
    u: "1fae6",
    a: "14.0"
  },
  {
    n: [
      "baby"
    ],
    u: "1f476",
    v: [
      "1f476-1f3fb",
      "1f476-1f3fc",
      "1f476-1f3fd",
      "1f476-1f3fe",
      "1f476-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "child"
    ],
    u: "1f9d2",
    v: [
      "1f9d2-1f3fb",
      "1f9d2-1f3fc",
      "1f9d2-1f3fd",
      "1f9d2-1f3fe",
      "1f9d2-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "boy"
    ],
    u: "1f466",
    v: [
      "1f466-1f3fb",
      "1f466-1f3fc",
      "1f466-1f3fd",
      "1f466-1f3fe",
      "1f466-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "girl"
    ],
    u: "1f467",
    v: [
      "1f467-1f3fb",
      "1f467-1f3fc",
      "1f467-1f3fd",
      "1f467-1f3fe",
      "1f467-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "adult"
    ],
    u: "1f9d1",
    v: [
      "1f9d1-1f3fb",
      "1f9d1-1f3fc",
      "1f9d1-1f3fd",
      "1f9d1-1f3fe",
      "1f9d1-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "person with blond hair"
    ],
    u: "1f471",
    v: [
      "1f471-1f3fb",
      "1f471-1f3fc",
      "1f471-1f3fd",
      "1f471-1f3fe",
      "1f471-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man"
    ],
    u: "1f468",
    v: [
      "1f468-1f3fb",
      "1f468-1f3fc",
      "1f468-1f3fd",
      "1f468-1f3fe",
      "1f468-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "bearded person"
    ],
    u: "1f9d4",
    v: [
      "1f9d4-1f3fb",
      "1f9d4-1f3fc",
      "1f9d4-1f3fd",
      "1f9d4-1f3fe",
      "1f9d4-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man: beard",
      "man with beard"
    ],
    u: "1f9d4-200d-2642-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2642-fe0f",
      "1f9d4-1f3fc-200d-2642-fe0f",
      "1f9d4-1f3fd-200d-2642-fe0f",
      "1f9d4-1f3fe-200d-2642-fe0f",
      "1f9d4-1f3ff-200d-2642-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "woman: beard",
      "woman with beard"
    ],
    u: "1f9d4-200d-2640-fe0f",
    v: [
      "1f9d4-1f3fb-200d-2640-fe0f",
      "1f9d4-1f3fc-200d-2640-fe0f",
      "1f9d4-1f3fd-200d-2640-fe0f",
      "1f9d4-1f3fe-200d-2640-fe0f",
      "1f9d4-1f3ff-200d-2640-fe0f"
    ],
    a: "13.1"
  },
  {
    n: [
      "man: red hair",
      "red haired man"
    ],
    u: "1f468-200d-1f9b0",
    v: [
      "1f468-1f3fb-200d-1f9b0",
      "1f468-1f3fc-200d-1f9b0",
      "1f468-1f3fd-200d-1f9b0",
      "1f468-1f3fe-200d-1f9b0",
      "1f468-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: curly hair",
      "curly haired man"
    ],
    u: "1f468-200d-1f9b1",
    v: [
      "1f468-1f3fb-200d-1f9b1",
      "1f468-1f3fc-200d-1f9b1",
      "1f468-1f3fd-200d-1f9b1",
      "1f468-1f3fe-200d-1f9b1",
      "1f468-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "man: white hair",
      "white haired man"
    ],
    u: "1f468-200d-1f9b3",
    v: [
      "1f468-1f3fb-200d-1f9b3",
      "1f468-1f3fc-200d-1f9b3",
      "1f468-1f3fd-200d-1f9b3",
      "1f468-1f3fe-200d-1f9b3",
      "1f468-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald man",
      "man: bald"
    ],
    u: "1f468-200d-1f9b2",
    v: [
      "1f468-1f3fb-200d-1f9b2",
      "1f468-1f3fc-200d-1f9b2",
      "1f468-1f3fd-200d-1f9b2",
      "1f468-1f3fe-200d-1f9b2",
      "1f468-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman"
    ],
    u: "1f469",
    v: [
      "1f469-1f3fb",
      "1f469-1f3fc",
      "1f469-1f3fd",
      "1f469-1f3fe",
      "1f469-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman: red hair",
      "red haired woman"
    ],
    u: "1f469-200d-1f9b0",
    v: [
      "1f469-1f3fb-200d-1f9b0",
      "1f469-1f3fc-200d-1f9b0",
      "1f469-1f3fd-200d-1f9b0",
      "1f469-1f3fe-200d-1f9b0",
      "1f469-1f3ff-200d-1f9b0"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: red hair",
      "red haired person"
    ],
    u: "1f9d1-200d-1f9b0",
    v: [
      "1f9d1-1f3fb-200d-1f9b0",
      "1f9d1-1f3fc-200d-1f9b0",
      "1f9d1-1f3fd-200d-1f9b0",
      "1f9d1-1f3fe-200d-1f9b0",
      "1f9d1-1f3ff-200d-1f9b0"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: curly hair",
      "curly haired woman"
    ],
    u: "1f469-200d-1f9b1",
    v: [
      "1f469-1f3fb-200d-1f9b1",
      "1f469-1f3fc-200d-1f9b1",
      "1f469-1f3fd-200d-1f9b1",
      "1f469-1f3fe-200d-1f9b1",
      "1f469-1f3ff-200d-1f9b1"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: curly hair",
      "curly haired person"
    ],
    u: "1f9d1-200d-1f9b1",
    v: [
      "1f9d1-1f3fb-200d-1f9b1",
      "1f9d1-1f3fc-200d-1f9b1",
      "1f9d1-1f3fd-200d-1f9b1",
      "1f9d1-1f3fe-200d-1f9b1",
      "1f9d1-1f3ff-200d-1f9b1"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: white hair",
      "white haired woman"
    ],
    u: "1f469-200d-1f9b3",
    v: [
      "1f469-1f3fb-200d-1f9b3",
      "1f469-1f3fc-200d-1f9b3",
      "1f469-1f3fd-200d-1f9b3",
      "1f469-1f3fe-200d-1f9b3",
      "1f469-1f3ff-200d-1f9b3"
    ],
    a: "11.0"
  },
  {
    n: [
      "person: white hair",
      "white haired person"
    ],
    u: "1f9d1-200d-1f9b3",
    v: [
      "1f9d1-1f3fb-200d-1f9b3",
      "1f9d1-1f3fc-200d-1f9b3",
      "1f9d1-1f3fd-200d-1f9b3",
      "1f9d1-1f3fe-200d-1f9b3",
      "1f9d1-1f3ff-200d-1f9b3"
    ],
    a: "12.1"
  },
  {
    n: [
      "bald woman",
      "woman: bald"
    ],
    u: "1f469-200d-1f9b2",
    v: [
      "1f469-1f3fb-200d-1f9b2",
      "1f469-1f3fc-200d-1f9b2",
      "1f469-1f3fd-200d-1f9b2",
      "1f469-1f3fe-200d-1f9b2",
      "1f469-1f3ff-200d-1f9b2"
    ],
    a: "11.0"
  },
  {
    n: [
      "bald person",
      "person: bald"
    ],
    u: "1f9d1-200d-1f9b2",
    v: [
      "1f9d1-1f3fb-200d-1f9b2",
      "1f9d1-1f3fc-200d-1f9b2",
      "1f9d1-1f3fd-200d-1f9b2",
      "1f9d1-1f3fe-200d-1f9b2",
      "1f9d1-1f3ff-200d-1f9b2"
    ],
    a: "12.1"
  },
  {
    n: [
      "woman: blond hair",
      "blond-haired-woman"
    ],
    u: "1f471-200d-2640-fe0f",
    v: [
      "1f471-1f3fb-200d-2640-fe0f",
      "1f471-1f3fc-200d-2640-fe0f",
      "1f471-1f3fd-200d-2640-fe0f",
      "1f471-1f3fe-200d-2640-fe0f",
      "1f471-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man: blond hair",
      "blond-haired-man"
    ],
    u: "1f471-200d-2642-fe0f",
    v: [
      "1f471-1f3fb-200d-2642-fe0f",
      "1f471-1f3fc-200d-2642-fe0f",
      "1f471-1f3fd-200d-2642-fe0f",
      "1f471-1f3fe-200d-2642-fe0f",
      "1f471-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "older adult"
    ],
    u: "1f9d3",
    v: [
      "1f9d3-1f3fb",
      "1f9d3-1f3fc",
      "1f9d3-1f3fd",
      "1f9d3-1f3fe",
      "1f9d3-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "older man"
    ],
    u: "1f474",
    v: [
      "1f474-1f3fb",
      "1f474-1f3fc",
      "1f474-1f3fd",
      "1f474-1f3fe",
      "1f474-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "older woman"
    ],
    u: "1f475",
    v: [
      "1f475-1f3fb",
      "1f475-1f3fc",
      "1f475-1f3fd",
      "1f475-1f3fe",
      "1f475-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person frowning"
    ],
    u: "1f64d",
    v: [
      "1f64d-1f3fb",
      "1f64d-1f3fc",
      "1f64d-1f3fd",
      "1f64d-1f3fe",
      "1f64d-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man frowning",
      "man-frowning"
    ],
    u: "1f64d-200d-2642-fe0f",
    v: [
      "1f64d-1f3fb-200d-2642-fe0f",
      "1f64d-1f3fc-200d-2642-fe0f",
      "1f64d-1f3fd-200d-2642-fe0f",
      "1f64d-1f3fe-200d-2642-fe0f",
      "1f64d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman frowning",
      "woman-frowning"
    ],
    u: "1f64d-200d-2640-fe0f",
    v: [
      "1f64d-1f3fb-200d-2640-fe0f",
      "1f64d-1f3fc-200d-2640-fe0f",
      "1f64d-1f3fd-200d-2640-fe0f",
      "1f64d-1f3fe-200d-2640-fe0f",
      "1f64d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with pouting face"
    ],
    u: "1f64e",
    v: [
      "1f64e-1f3fb",
      "1f64e-1f3fc",
      "1f64e-1f3fd",
      "1f64e-1f3fe",
      "1f64e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man pouting",
      "man-pouting"
    ],
    u: "1f64e-200d-2642-fe0f",
    v: [
      "1f64e-1f3fb-200d-2642-fe0f",
      "1f64e-1f3fc-200d-2642-fe0f",
      "1f64e-1f3fd-200d-2642-fe0f",
      "1f64e-1f3fe-200d-2642-fe0f",
      "1f64e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pouting",
      "woman-pouting"
    ],
    u: "1f64e-200d-2640-fe0f",
    v: [
      "1f64e-1f3fb-200d-2640-fe0f",
      "1f64e-1f3fc-200d-2640-fe0f",
      "1f64e-1f3fd-200d-2640-fe0f",
      "1f64e-1f3fe-200d-2640-fe0f",
      "1f64e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "no good",
      "face with no good gesture"
    ],
    u: "1f645",
    v: [
      "1f645-1f3fb",
      "1f645-1f3fc",
      "1f645-1f3fd",
      "1f645-1f3fe",
      "1f645-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing no",
      "man-gesturing-no"
    ],
    u: "1f645-200d-2642-fe0f",
    v: [
      "1f645-1f3fb-200d-2642-fe0f",
      "1f645-1f3fc-200d-2642-fe0f",
      "1f645-1f3fd-200d-2642-fe0f",
      "1f645-1f3fe-200d-2642-fe0f",
      "1f645-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing no",
      "woman-gesturing-no"
    ],
    u: "1f645-200d-2640-fe0f",
    v: [
      "1f645-1f3fb-200d-2640-fe0f",
      "1f645-1f3fc-200d-2640-fe0f",
      "1f645-1f3fd-200d-2640-fe0f",
      "1f645-1f3fe-200d-2640-fe0f",
      "1f645-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ok woman",
      "face with ok gesture"
    ],
    u: "1f646",
    v: [
      "1f646-1f3fb",
      "1f646-1f3fc",
      "1f646-1f3fd",
      "1f646-1f3fe",
      "1f646-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man gesturing ok",
      "man-gesturing-ok"
    ],
    u: "1f646-200d-2642-fe0f",
    v: [
      "1f646-1f3fb-200d-2642-fe0f",
      "1f646-1f3fc-200d-2642-fe0f",
      "1f646-1f3fd-200d-2642-fe0f",
      "1f646-1f3fe-200d-2642-fe0f",
      "1f646-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman gesturing ok",
      "woman-gesturing-ok"
    ],
    u: "1f646-200d-2640-fe0f",
    v: [
      "1f646-1f3fb-200d-2640-fe0f",
      "1f646-1f3fc-200d-2640-fe0f",
      "1f646-1f3fd-200d-2640-fe0f",
      "1f646-1f3fe-200d-2640-fe0f",
      "1f646-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "information desk person"
    ],
    u: "1f481",
    v: [
      "1f481-1f3fb",
      "1f481-1f3fc",
      "1f481-1f3fd",
      "1f481-1f3fe",
      "1f481-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man tipping hand",
      "man-tipping-hand"
    ],
    u: "1f481-200d-2642-fe0f",
    v: [
      "1f481-1f3fb-200d-2642-fe0f",
      "1f481-1f3fc-200d-2642-fe0f",
      "1f481-1f3fd-200d-2642-fe0f",
      "1f481-1f3fe-200d-2642-fe0f",
      "1f481-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman tipping hand",
      "woman-tipping-hand"
    ],
    u: "1f481-200d-2640-fe0f",
    v: [
      "1f481-1f3fb-200d-2640-fe0f",
      "1f481-1f3fc-200d-2640-fe0f",
      "1f481-1f3fd-200d-2640-fe0f",
      "1f481-1f3fe-200d-2640-fe0f",
      "1f481-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "raising hand",
      "happy person raising one hand"
    ],
    u: "1f64b",
    v: [
      "1f64b-1f3fb",
      "1f64b-1f3fc",
      "1f64b-1f3fd",
      "1f64b-1f3fe",
      "1f64b-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man raising hand",
      "man-raising-hand"
    ],
    u: "1f64b-200d-2642-fe0f",
    v: [
      "1f64b-1f3fb-200d-2642-fe0f",
      "1f64b-1f3fc-200d-2642-fe0f",
      "1f64b-1f3fd-200d-2642-fe0f",
      "1f64b-1f3fe-200d-2642-fe0f",
      "1f64b-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman raising hand",
      "woman-raising-hand"
    ],
    u: "1f64b-200d-2640-fe0f",
    v: [
      "1f64b-1f3fb-200d-2640-fe0f",
      "1f64b-1f3fc-200d-2640-fe0f",
      "1f64b-1f3fd-200d-2640-fe0f",
      "1f64b-1f3fe-200d-2640-fe0f",
      "1f64b-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "deaf person"
    ],
    u: "1f9cf",
    v: [
      "1f9cf-1f3fb",
      "1f9cf-1f3fc",
      "1f9cf-1f3fd",
      "1f9cf-1f3fe",
      "1f9cf-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf man"
    ],
    u: "1f9cf-200d-2642-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2642-fe0f",
      "1f9cf-1f3fc-200d-2642-fe0f",
      "1f9cf-1f3fd-200d-2642-fe0f",
      "1f9cf-1f3fe-200d-2642-fe0f",
      "1f9cf-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "deaf woman"
    ],
    u: "1f9cf-200d-2640-fe0f",
    v: [
      "1f9cf-1f3fb-200d-2640-fe0f",
      "1f9cf-1f3fc-200d-2640-fe0f",
      "1f9cf-1f3fd-200d-2640-fe0f",
      "1f9cf-1f3fe-200d-2640-fe0f",
      "1f9cf-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "bow",
      "person bowing deeply"
    ],
    u: "1f647",
    v: [
      "1f647-1f3fb",
      "1f647-1f3fc",
      "1f647-1f3fd",
      "1f647-1f3fe",
      "1f647-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man bowing",
      "man-bowing"
    ],
    u: "1f647-200d-2642-fe0f",
    v: [
      "1f647-1f3fb-200d-2642-fe0f",
      "1f647-1f3fc-200d-2642-fe0f",
      "1f647-1f3fd-200d-2642-fe0f",
      "1f647-1f3fe-200d-2642-fe0f",
      "1f647-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bowing",
      "woman-bowing"
    ],
    u: "1f647-200d-2640-fe0f",
    v: [
      "1f647-1f3fb-200d-2640-fe0f",
      "1f647-1f3fc-200d-2640-fe0f",
      "1f647-1f3fd-200d-2640-fe0f",
      "1f647-1f3fe-200d-2640-fe0f",
      "1f647-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "face palm"
    ],
    u: "1f926",
    v: [
      "1f926-1f3fb",
      "1f926-1f3fc",
      "1f926-1f3fd",
      "1f926-1f3fe",
      "1f926-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man facepalming",
      "man-facepalming"
    ],
    u: "1f926-200d-2642-fe0f",
    v: [
      "1f926-1f3fb-200d-2642-fe0f",
      "1f926-1f3fc-200d-2642-fe0f",
      "1f926-1f3fd-200d-2642-fe0f",
      "1f926-1f3fe-200d-2642-fe0f",
      "1f926-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman facepalming",
      "woman-facepalming"
    ],
    u: "1f926-200d-2640-fe0f",
    v: [
      "1f926-1f3fb-200d-2640-fe0f",
      "1f926-1f3fc-200d-2640-fe0f",
      "1f926-1f3fd-200d-2640-fe0f",
      "1f926-1f3fe-200d-2640-fe0f",
      "1f926-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "shrug"
    ],
    u: "1f937",
    v: [
      "1f937-1f3fb",
      "1f937-1f3fc",
      "1f937-1f3fd",
      "1f937-1f3fe",
      "1f937-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man shrugging",
      "man-shrugging"
    ],
    u: "1f937-200d-2642-fe0f",
    v: [
      "1f937-1f3fb-200d-2642-fe0f",
      "1f937-1f3fc-200d-2642-fe0f",
      "1f937-1f3fd-200d-2642-fe0f",
      "1f937-1f3fe-200d-2642-fe0f",
      "1f937-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman shrugging",
      "woman-shrugging"
    ],
    u: "1f937-200d-2640-fe0f",
    v: [
      "1f937-1f3fb-200d-2640-fe0f",
      "1f937-1f3fc-200d-2640-fe0f",
      "1f937-1f3fd-200d-2640-fe0f",
      "1f937-1f3fe-200d-2640-fe0f",
      "1f937-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "health worker"
    ],
    u: "1f9d1-200d-2695-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2695-fe0f",
      "1f9d1-1f3fc-200d-2695-fe0f",
      "1f9d1-1f3fd-200d-2695-fe0f",
      "1f9d1-1f3fe-200d-2695-fe0f",
      "1f9d1-1f3ff-200d-2695-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "male-doctor",
      "man health worker"
    ],
    u: "1f468-200d-2695-fe0f",
    v: [
      "1f468-1f3fb-200d-2695-fe0f",
      "1f468-1f3fc-200d-2695-fe0f",
      "1f468-1f3fd-200d-2695-fe0f",
      "1f468-1f3fe-200d-2695-fe0f",
      "1f468-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "female-doctor",
      "woman health worker"
    ],
    u: "1f469-200d-2695-fe0f",
    v: [
      "1f469-1f3fb-200d-2695-fe0f",
      "1f469-1f3fc-200d-2695-fe0f",
      "1f469-1f3fd-200d-2695-fe0f",
      "1f469-1f3fe-200d-2695-fe0f",
      "1f469-1f3ff-200d-2695-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "student"
    ],
    u: "1f9d1-200d-1f393",
    v: [
      "1f9d1-1f3fb-200d-1f393",
      "1f9d1-1f3fc-200d-1f393",
      "1f9d1-1f3fd-200d-1f393",
      "1f9d1-1f3fe-200d-1f393",
      "1f9d1-1f3ff-200d-1f393"
    ],
    a: "12.1"
  },
  {
    n: [
      "man student",
      "male-student"
    ],
    u: "1f468-200d-1f393",
    v: [
      "1f468-1f3fb-200d-1f393",
      "1f468-1f3fc-200d-1f393",
      "1f468-1f3fd-200d-1f393",
      "1f468-1f3fe-200d-1f393",
      "1f468-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman student",
      "female-student"
    ],
    u: "1f469-200d-1f393",
    v: [
      "1f469-1f3fb-200d-1f393",
      "1f469-1f3fc-200d-1f393",
      "1f469-1f3fd-200d-1f393",
      "1f469-1f3fe-200d-1f393",
      "1f469-1f3ff-200d-1f393"
    ],
    a: "4.0"
  },
  {
    n: [
      "teacher"
    ],
    u: "1f9d1-200d-1f3eb",
    v: [
      "1f9d1-1f3fb-200d-1f3eb",
      "1f9d1-1f3fc-200d-1f3eb",
      "1f9d1-1f3fd-200d-1f3eb",
      "1f9d1-1f3fe-200d-1f3eb",
      "1f9d1-1f3ff-200d-1f3eb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man teacher",
      "male-teacher"
    ],
    u: "1f468-200d-1f3eb",
    v: [
      "1f468-1f3fb-200d-1f3eb",
      "1f468-1f3fc-200d-1f3eb",
      "1f468-1f3fd-200d-1f3eb",
      "1f468-1f3fe-200d-1f3eb",
      "1f468-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman teacher",
      "female-teacher"
    ],
    u: "1f469-200d-1f3eb",
    v: [
      "1f469-1f3fb-200d-1f3eb",
      "1f469-1f3fc-200d-1f3eb",
      "1f469-1f3fd-200d-1f3eb",
      "1f469-1f3fe-200d-1f3eb",
      "1f469-1f3ff-200d-1f3eb"
    ],
    a: "4.0"
  },
  {
    n: [
      "judge"
    ],
    u: "1f9d1-200d-2696-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2696-fe0f",
      "1f9d1-1f3fc-200d-2696-fe0f",
      "1f9d1-1f3fd-200d-2696-fe0f",
      "1f9d1-1f3fe-200d-2696-fe0f",
      "1f9d1-1f3ff-200d-2696-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man judge",
      "male-judge"
    ],
    u: "1f468-200d-2696-fe0f",
    v: [
      "1f468-1f3fb-200d-2696-fe0f",
      "1f468-1f3fc-200d-2696-fe0f",
      "1f468-1f3fd-200d-2696-fe0f",
      "1f468-1f3fe-200d-2696-fe0f",
      "1f468-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman judge",
      "female-judge"
    ],
    u: "1f469-200d-2696-fe0f",
    v: [
      "1f469-1f3fb-200d-2696-fe0f",
      "1f469-1f3fc-200d-2696-fe0f",
      "1f469-1f3fd-200d-2696-fe0f",
      "1f469-1f3fe-200d-2696-fe0f",
      "1f469-1f3ff-200d-2696-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "farmer"
    ],
    u: "1f9d1-200d-1f33e",
    v: [
      "1f9d1-1f3fb-200d-1f33e",
      "1f9d1-1f3fc-200d-1f33e",
      "1f9d1-1f3fd-200d-1f33e",
      "1f9d1-1f3fe-200d-1f33e",
      "1f9d1-1f3ff-200d-1f33e"
    ],
    a: "12.1"
  },
  {
    n: [
      "man farmer",
      "male-farmer"
    ],
    u: "1f468-200d-1f33e",
    v: [
      "1f468-1f3fb-200d-1f33e",
      "1f468-1f3fc-200d-1f33e",
      "1f468-1f3fd-200d-1f33e",
      "1f468-1f3fe-200d-1f33e",
      "1f468-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman farmer",
      "female-farmer"
    ],
    u: "1f469-200d-1f33e",
    v: [
      "1f469-1f3fb-200d-1f33e",
      "1f469-1f3fc-200d-1f33e",
      "1f469-1f3fd-200d-1f33e",
      "1f469-1f3fe-200d-1f33e",
      "1f469-1f3ff-200d-1f33e"
    ],
    a: "4.0"
  },
  {
    n: [
      "cook"
    ],
    u: "1f9d1-200d-1f373",
    v: [
      "1f9d1-1f3fb-200d-1f373",
      "1f9d1-1f3fc-200d-1f373",
      "1f9d1-1f3fd-200d-1f373",
      "1f9d1-1f3fe-200d-1f373",
      "1f9d1-1f3ff-200d-1f373"
    ],
    a: "12.1"
  },
  {
    n: [
      "man cook",
      "male-cook"
    ],
    u: "1f468-200d-1f373",
    v: [
      "1f468-1f3fb-200d-1f373",
      "1f468-1f3fc-200d-1f373",
      "1f468-1f3fd-200d-1f373",
      "1f468-1f3fe-200d-1f373",
      "1f468-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cook",
      "female-cook"
    ],
    u: "1f469-200d-1f373",
    v: [
      "1f469-1f3fb-200d-1f373",
      "1f469-1f3fc-200d-1f373",
      "1f469-1f3fd-200d-1f373",
      "1f469-1f3fe-200d-1f373",
      "1f469-1f3ff-200d-1f373"
    ],
    a: "4.0"
  },
  {
    n: [
      "mechanic"
    ],
    u: "1f9d1-200d-1f527",
    v: [
      "1f9d1-1f3fb-200d-1f527",
      "1f9d1-1f3fc-200d-1f527",
      "1f9d1-1f3fd-200d-1f527",
      "1f9d1-1f3fe-200d-1f527",
      "1f9d1-1f3ff-200d-1f527"
    ],
    a: "12.1"
  },
  {
    n: [
      "man mechanic",
      "male-mechanic"
    ],
    u: "1f468-200d-1f527",
    v: [
      "1f468-1f3fb-200d-1f527",
      "1f468-1f3fc-200d-1f527",
      "1f468-1f3fd-200d-1f527",
      "1f468-1f3fe-200d-1f527",
      "1f468-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mechanic",
      "female-mechanic"
    ],
    u: "1f469-200d-1f527",
    v: [
      "1f469-1f3fb-200d-1f527",
      "1f469-1f3fc-200d-1f527",
      "1f469-1f3fd-200d-1f527",
      "1f469-1f3fe-200d-1f527",
      "1f469-1f3ff-200d-1f527"
    ],
    a: "4.0"
  },
  {
    n: [
      "factory worker"
    ],
    u: "1f9d1-200d-1f3ed",
    v: [
      "1f9d1-1f3fb-200d-1f3ed",
      "1f9d1-1f3fc-200d-1f3ed",
      "1f9d1-1f3fd-200d-1f3ed",
      "1f9d1-1f3fe-200d-1f3ed",
      "1f9d1-1f3ff-200d-1f3ed"
    ],
    a: "12.1"
  },
  {
    n: [
      "man factory worker",
      "male-factory-worker"
    ],
    u: "1f468-200d-1f3ed",
    v: [
      "1f468-1f3fb-200d-1f3ed",
      "1f468-1f3fc-200d-1f3ed",
      "1f468-1f3fd-200d-1f3ed",
      "1f468-1f3fe-200d-1f3ed",
      "1f468-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman factory worker",
      "female-factory-worker"
    ],
    u: "1f469-200d-1f3ed",
    v: [
      "1f469-1f3fb-200d-1f3ed",
      "1f469-1f3fc-200d-1f3ed",
      "1f469-1f3fd-200d-1f3ed",
      "1f469-1f3fe-200d-1f3ed",
      "1f469-1f3ff-200d-1f3ed"
    ],
    a: "4.0"
  },
  {
    n: [
      "office worker"
    ],
    u: "1f9d1-200d-1f4bc",
    v: [
      "1f9d1-1f3fb-200d-1f4bc",
      "1f9d1-1f3fc-200d-1f4bc",
      "1f9d1-1f3fd-200d-1f4bc",
      "1f9d1-1f3fe-200d-1f4bc",
      "1f9d1-1f3ff-200d-1f4bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man office worker",
      "male-office-worker"
    ],
    u: "1f468-200d-1f4bc",
    v: [
      "1f468-1f3fb-200d-1f4bc",
      "1f468-1f3fc-200d-1f4bc",
      "1f468-1f3fd-200d-1f4bc",
      "1f468-1f3fe-200d-1f4bc",
      "1f468-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman office worker",
      "female-office-worker"
    ],
    u: "1f469-200d-1f4bc",
    v: [
      "1f469-1f3fb-200d-1f4bc",
      "1f469-1f3fc-200d-1f4bc",
      "1f469-1f3fd-200d-1f4bc",
      "1f469-1f3fe-200d-1f4bc",
      "1f469-1f3ff-200d-1f4bc"
    ],
    a: "4.0"
  },
  {
    n: [
      "scientist"
    ],
    u: "1f9d1-200d-1f52c",
    v: [
      "1f9d1-1f3fb-200d-1f52c",
      "1f9d1-1f3fc-200d-1f52c",
      "1f9d1-1f3fd-200d-1f52c",
      "1f9d1-1f3fe-200d-1f52c",
      "1f9d1-1f3ff-200d-1f52c"
    ],
    a: "12.1"
  },
  {
    n: [
      "man scientist",
      "male-scientist"
    ],
    u: "1f468-200d-1f52c",
    v: [
      "1f468-1f3fb-200d-1f52c",
      "1f468-1f3fc-200d-1f52c",
      "1f468-1f3fd-200d-1f52c",
      "1f468-1f3fe-200d-1f52c",
      "1f468-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman scientist",
      "female-scientist"
    ],
    u: "1f469-200d-1f52c",
    v: [
      "1f469-1f3fb-200d-1f52c",
      "1f469-1f3fc-200d-1f52c",
      "1f469-1f3fd-200d-1f52c",
      "1f469-1f3fe-200d-1f52c",
      "1f469-1f3ff-200d-1f52c"
    ],
    a: "4.0"
  },
  {
    n: [
      "technologist"
    ],
    u: "1f9d1-200d-1f4bb",
    v: [
      "1f9d1-1f3fb-200d-1f4bb",
      "1f9d1-1f3fc-200d-1f4bb",
      "1f9d1-1f3fd-200d-1f4bb",
      "1f9d1-1f3fe-200d-1f4bb",
      "1f9d1-1f3ff-200d-1f4bb"
    ],
    a: "12.1"
  },
  {
    n: [
      "man technologist",
      "male-technologist"
    ],
    u: "1f468-200d-1f4bb",
    v: [
      "1f468-1f3fb-200d-1f4bb",
      "1f468-1f3fc-200d-1f4bb",
      "1f468-1f3fd-200d-1f4bb",
      "1f468-1f3fe-200d-1f4bb",
      "1f468-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman technologist",
      "female-technologist"
    ],
    u: "1f469-200d-1f4bb",
    v: [
      "1f469-1f3fb-200d-1f4bb",
      "1f469-1f3fc-200d-1f4bb",
      "1f469-1f3fd-200d-1f4bb",
      "1f469-1f3fe-200d-1f4bb",
      "1f469-1f3ff-200d-1f4bb"
    ],
    a: "4.0"
  },
  {
    n: [
      "singer"
    ],
    u: "1f9d1-200d-1f3a4",
    v: [
      "1f9d1-1f3fb-200d-1f3a4",
      "1f9d1-1f3fc-200d-1f3a4",
      "1f9d1-1f3fd-200d-1f3a4",
      "1f9d1-1f3fe-200d-1f3a4",
      "1f9d1-1f3ff-200d-1f3a4"
    ],
    a: "12.1"
  },
  {
    n: [
      "man singer",
      "male-singer"
    ],
    u: "1f468-200d-1f3a4",
    v: [
      "1f468-1f3fb-200d-1f3a4",
      "1f468-1f3fc-200d-1f3a4",
      "1f468-1f3fd-200d-1f3a4",
      "1f468-1f3fe-200d-1f3a4",
      "1f468-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman singer",
      "female-singer"
    ],
    u: "1f469-200d-1f3a4",
    v: [
      "1f469-1f3fb-200d-1f3a4",
      "1f469-1f3fc-200d-1f3a4",
      "1f469-1f3fd-200d-1f3a4",
      "1f469-1f3fe-200d-1f3a4",
      "1f469-1f3ff-200d-1f3a4"
    ],
    a: "4.0"
  },
  {
    n: [
      "artist"
    ],
    u: "1f9d1-200d-1f3a8",
    v: [
      "1f9d1-1f3fb-200d-1f3a8",
      "1f9d1-1f3fc-200d-1f3a8",
      "1f9d1-1f3fd-200d-1f3a8",
      "1f9d1-1f3fe-200d-1f3a8",
      "1f9d1-1f3ff-200d-1f3a8"
    ],
    a: "12.1"
  },
  {
    n: [
      "man artist",
      "male-artist"
    ],
    u: "1f468-200d-1f3a8",
    v: [
      "1f468-1f3fb-200d-1f3a8",
      "1f468-1f3fc-200d-1f3a8",
      "1f468-1f3fd-200d-1f3a8",
      "1f468-1f3fe-200d-1f3a8",
      "1f468-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman artist",
      "female-artist"
    ],
    u: "1f469-200d-1f3a8",
    v: [
      "1f469-1f3fb-200d-1f3a8",
      "1f469-1f3fc-200d-1f3a8",
      "1f469-1f3fd-200d-1f3a8",
      "1f469-1f3fe-200d-1f3a8",
      "1f469-1f3ff-200d-1f3a8"
    ],
    a: "4.0"
  },
  {
    n: [
      "pilot"
    ],
    u: "1f9d1-200d-2708-fe0f",
    v: [
      "1f9d1-1f3fb-200d-2708-fe0f",
      "1f9d1-1f3fc-200d-2708-fe0f",
      "1f9d1-1f3fd-200d-2708-fe0f",
      "1f9d1-1f3fe-200d-2708-fe0f",
      "1f9d1-1f3ff-200d-2708-fe0f"
    ],
    a: "12.1"
  },
  {
    n: [
      "man pilot",
      "male-pilot"
    ],
    u: "1f468-200d-2708-fe0f",
    v: [
      "1f468-1f3fb-200d-2708-fe0f",
      "1f468-1f3fc-200d-2708-fe0f",
      "1f468-1f3fd-200d-2708-fe0f",
      "1f468-1f3fe-200d-2708-fe0f",
      "1f468-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman pilot",
      "female-pilot"
    ],
    u: "1f469-200d-2708-fe0f",
    v: [
      "1f469-1f3fb-200d-2708-fe0f",
      "1f469-1f3fc-200d-2708-fe0f",
      "1f469-1f3fd-200d-2708-fe0f",
      "1f469-1f3fe-200d-2708-fe0f",
      "1f469-1f3ff-200d-2708-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "astronaut"
    ],
    u: "1f9d1-200d-1f680",
    v: [
      "1f9d1-1f3fb-200d-1f680",
      "1f9d1-1f3fc-200d-1f680",
      "1f9d1-1f3fd-200d-1f680",
      "1f9d1-1f3fe-200d-1f680",
      "1f9d1-1f3ff-200d-1f680"
    ],
    a: "12.1"
  },
  {
    n: [
      "man astronaut",
      "male-astronaut"
    ],
    u: "1f468-200d-1f680",
    v: [
      "1f468-1f3fb-200d-1f680",
      "1f468-1f3fc-200d-1f680",
      "1f468-1f3fd-200d-1f680",
      "1f468-1f3fe-200d-1f680",
      "1f468-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman astronaut",
      "female-astronaut"
    ],
    u: "1f469-200d-1f680",
    v: [
      "1f469-1f3fb-200d-1f680",
      "1f469-1f3fc-200d-1f680",
      "1f469-1f3fd-200d-1f680",
      "1f469-1f3fe-200d-1f680",
      "1f469-1f3ff-200d-1f680"
    ],
    a: "4.0"
  },
  {
    n: [
      "firefighter"
    ],
    u: "1f9d1-200d-1f692",
    v: [
      "1f9d1-1f3fb-200d-1f692",
      "1f9d1-1f3fc-200d-1f692",
      "1f9d1-1f3fd-200d-1f692",
      "1f9d1-1f3fe-200d-1f692",
      "1f9d1-1f3ff-200d-1f692"
    ],
    a: "12.1"
  },
  {
    n: [
      "man firefighter",
      "male-firefighter"
    ],
    u: "1f468-200d-1f692",
    v: [
      "1f468-1f3fb-200d-1f692",
      "1f468-1f3fc-200d-1f692",
      "1f468-1f3fd-200d-1f692",
      "1f468-1f3fe-200d-1f692",
      "1f468-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman firefighter",
      "female-firefighter"
    ],
    u: "1f469-200d-1f692",
    v: [
      "1f469-1f3fb-200d-1f692",
      "1f469-1f3fc-200d-1f692",
      "1f469-1f3fd-200d-1f692",
      "1f469-1f3fe-200d-1f692",
      "1f469-1f3ff-200d-1f692"
    ],
    a: "4.0"
  },
  {
    n: [
      "cop",
      "police officer"
    ],
    u: "1f46e",
    v: [
      "1f46e-1f3fb",
      "1f46e-1f3fc",
      "1f46e-1f3fd",
      "1f46e-1f3fe",
      "1f46e-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man police officer",
      "male-police-officer"
    ],
    u: "1f46e-200d-2642-fe0f",
    v: [
      "1f46e-1f3fb-200d-2642-fe0f",
      "1f46e-1f3fc-200d-2642-fe0f",
      "1f46e-1f3fd-200d-2642-fe0f",
      "1f46e-1f3fe-200d-2642-fe0f",
      "1f46e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman police officer",
      "female-police-officer"
    ],
    u: "1f46e-200d-2640-fe0f",
    v: [
      "1f46e-1f3fb-200d-2640-fe0f",
      "1f46e-1f3fc-200d-2640-fe0f",
      "1f46e-1f3fd-200d-2640-fe0f",
      "1f46e-1f3fe-200d-2640-fe0f",
      "1f46e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "detective",
      "sleuth or spy"
    ],
    u: "1f575-fe0f",
    v: [
      "1f575-1f3fb",
      "1f575-1f3fc",
      "1f575-1f3fd",
      "1f575-1f3fe",
      "1f575-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man detective",
      "male-detective"
    ],
    u: "1f575-fe0f-200d-2642-fe0f",
    v: [
      "1f575-1f3fb-200d-2642-fe0f",
      "1f575-1f3fc-200d-2642-fe0f",
      "1f575-1f3fd-200d-2642-fe0f",
      "1f575-1f3fe-200d-2642-fe0f",
      "1f575-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman detective",
      "female-detective"
    ],
    u: "1f575-fe0f-200d-2640-fe0f",
    v: [
      "1f575-1f3fb-200d-2640-fe0f",
      "1f575-1f3fc-200d-2640-fe0f",
      "1f575-1f3fd-200d-2640-fe0f",
      "1f575-1f3fe-200d-2640-fe0f",
      "1f575-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "guardsman"
    ],
    u: "1f482",
    v: [
      "1f482-1f3fb",
      "1f482-1f3fc",
      "1f482-1f3fd",
      "1f482-1f3fe",
      "1f482-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man guard",
      "male-guard"
    ],
    u: "1f482-200d-2642-fe0f",
    v: [
      "1f482-1f3fb-200d-2642-fe0f",
      "1f482-1f3fc-200d-2642-fe0f",
      "1f482-1f3fd-200d-2642-fe0f",
      "1f482-1f3fe-200d-2642-fe0f",
      "1f482-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman guard",
      "female-guard"
    ],
    u: "1f482-200d-2640-fe0f",
    v: [
      "1f482-1f3fb-200d-2640-fe0f",
      "1f482-1f3fc-200d-2640-fe0f",
      "1f482-1f3fd-200d-2640-fe0f",
      "1f482-1f3fe-200d-2640-fe0f",
      "1f482-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "ninja"
    ],
    u: "1f977",
    v: [
      "1f977-1f3fb",
      "1f977-1f3fc",
      "1f977-1f3fd",
      "1f977-1f3fe",
      "1f977-1f3ff"
    ],
    a: "13.0"
  },
  {
    n: [
      "construction worker"
    ],
    u: "1f477",
    v: [
      "1f477-1f3fb",
      "1f477-1f3fc",
      "1f477-1f3fd",
      "1f477-1f3fe",
      "1f477-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man construction worker",
      "male-construction-worker"
    ],
    u: "1f477-200d-2642-fe0f",
    v: [
      "1f477-1f3fb-200d-2642-fe0f",
      "1f477-1f3fc-200d-2642-fe0f",
      "1f477-1f3fd-200d-2642-fe0f",
      "1f477-1f3fe-200d-2642-fe0f",
      "1f477-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman construction worker",
      "female-construction-worker"
    ],
    u: "1f477-200d-2640-fe0f",
    v: [
      "1f477-1f3fb-200d-2640-fe0f",
      "1f477-1f3fc-200d-2640-fe0f",
      "1f477-1f3fd-200d-2640-fe0f",
      "1f477-1f3fe-200d-2640-fe0f",
      "1f477-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with crown"
    ],
    u: "1fac5",
    v: [
      "1fac5-1f3fb",
      "1fac5-1f3fc",
      "1fac5-1f3fd",
      "1fac5-1f3fe",
      "1fac5-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "prince"
    ],
    u: "1f934",
    v: [
      "1f934-1f3fb",
      "1f934-1f3fc",
      "1f934-1f3fd",
      "1f934-1f3fe",
      "1f934-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "princess"
    ],
    u: "1f478",
    v: [
      "1f478-1f3fb",
      "1f478-1f3fc",
      "1f478-1f3fd",
      "1f478-1f3fe",
      "1f478-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with turban"
    ],
    u: "1f473",
    v: [
      "1f473-1f3fb",
      "1f473-1f3fc",
      "1f473-1f3fd",
      "1f473-1f3fe",
      "1f473-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man wearing turban",
      "man-wearing-turban"
    ],
    u: "1f473-200d-2642-fe0f",
    v: [
      "1f473-1f3fb-200d-2642-fe0f",
      "1f473-1f3fc-200d-2642-fe0f",
      "1f473-1f3fd-200d-2642-fe0f",
      "1f473-1f3fe-200d-2642-fe0f",
      "1f473-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman wearing turban",
      "woman-wearing-turban"
    ],
    u: "1f473-200d-2640-fe0f",
    v: [
      "1f473-1f3fb-200d-2640-fe0f",
      "1f473-1f3fc-200d-2640-fe0f",
      "1f473-1f3fd-200d-2640-fe0f",
      "1f473-1f3fe-200d-2640-fe0f",
      "1f473-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "man with gua pi mao"
    ],
    u: "1f472",
    v: [
      "1f472-1f3fb",
      "1f472-1f3fc",
      "1f472-1f3fd",
      "1f472-1f3fe",
      "1f472-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "person with headscarf"
    ],
    u: "1f9d5",
    v: [
      "1f9d5-1f3fb",
      "1f9d5-1f3fc",
      "1f9d5-1f3fd",
      "1f9d5-1f3fe",
      "1f9d5-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in tuxedo",
      "person in tuxedo"
    ],
    u: "1f935",
    v: [
      "1f935-1f3fb",
      "1f935-1f3fc",
      "1f935-1f3fd",
      "1f935-1f3fe",
      "1f935-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man in tuxedo"
    ],
    u: "1f935-200d-2642-fe0f",
    v: [
      "1f935-1f3fb-200d-2642-fe0f",
      "1f935-1f3fc-200d-2642-fe0f",
      "1f935-1f3fd-200d-2642-fe0f",
      "1f935-1f3fe-200d-2642-fe0f",
      "1f935-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman in tuxedo"
    ],
    u: "1f935-200d-2640-fe0f",
    v: [
      "1f935-1f3fb-200d-2640-fe0f",
      "1f935-1f3fc-200d-2640-fe0f",
      "1f935-1f3fd-200d-2640-fe0f",
      "1f935-1f3fe-200d-2640-fe0f",
      "1f935-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "bride with veil"
    ],
    u: "1f470",
    v: [
      "1f470-1f3fb",
      "1f470-1f3fc",
      "1f470-1f3fd",
      "1f470-1f3fe",
      "1f470-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man with veil"
    ],
    u: "1f470-200d-2642-fe0f",
    v: [
      "1f470-1f3fb-200d-2642-fe0f",
      "1f470-1f3fc-200d-2642-fe0f",
      "1f470-1f3fd-200d-2642-fe0f",
      "1f470-1f3fe-200d-2642-fe0f",
      "1f470-1f3ff-200d-2642-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "woman with veil"
    ],
    u: "1f470-200d-2640-fe0f",
    v: [
      "1f470-1f3fb-200d-2640-fe0f",
      "1f470-1f3fc-200d-2640-fe0f",
      "1f470-1f3fd-200d-2640-fe0f",
      "1f470-1f3fe-200d-2640-fe0f",
      "1f470-1f3ff-200d-2640-fe0f"
    ],
    a: "13.0"
  },
  {
    n: [
      "pregnant woman"
    ],
    u: "1f930",
    v: [
      "1f930-1f3fb",
      "1f930-1f3fc",
      "1f930-1f3fd",
      "1f930-1f3fe",
      "1f930-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "pregnant man"
    ],
    u: "1fac3",
    v: [
      "1fac3-1f3fb",
      "1fac3-1f3fc",
      "1fac3-1f3fd",
      "1fac3-1f3fe",
      "1fac3-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "pregnant person"
    ],
    u: "1fac4",
    v: [
      "1fac4-1f3fb",
      "1fac4-1f3fc",
      "1fac4-1f3fd",
      "1fac4-1f3fe",
      "1fac4-1f3ff"
    ],
    a: "14.0"
  },
  {
    n: [
      "breast-feeding"
    ],
    u: "1f931",
    v: [
      "1f931-1f3fb",
      "1f931-1f3fc",
      "1f931-1f3fd",
      "1f931-1f3fe",
      "1f931-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman feeding baby"
    ],
    u: "1f469-200d-1f37c",
    v: [
      "1f469-1f3fb-200d-1f37c",
      "1f469-1f3fc-200d-1f37c",
      "1f469-1f3fd-200d-1f37c",
      "1f469-1f3fe-200d-1f37c",
      "1f469-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "man feeding baby"
    ],
    u: "1f468-200d-1f37c",
    v: [
      "1f468-1f3fb-200d-1f37c",
      "1f468-1f3fc-200d-1f37c",
      "1f468-1f3fd-200d-1f37c",
      "1f468-1f3fe-200d-1f37c",
      "1f468-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "person feeding baby"
    ],
    u: "1f9d1-200d-1f37c",
    v: [
      "1f9d1-1f3fb-200d-1f37c",
      "1f9d1-1f3fc-200d-1f37c",
      "1f9d1-1f3fd-200d-1f37c",
      "1f9d1-1f3fe-200d-1f37c",
      "1f9d1-1f3ff-200d-1f37c"
    ],
    a: "13.0"
  },
  {
    n: [
      "angel",
      "baby angel"
    ],
    u: "1f47c",
    v: [
      "1f47c-1f3fb",
      "1f47c-1f3fc",
      "1f47c-1f3fd",
      "1f47c-1f3fe",
      "1f47c-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "santa",
      "father christmas"
    ],
    u: "1f385",
    v: [
      "1f385-1f3fb",
      "1f385-1f3fc",
      "1f385-1f3fd",
      "1f385-1f3fe",
      "1f385-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "mrs claus",
      "mother christmas"
    ],
    u: "1f936",
    v: [
      "1f936-1f3fb",
      "1f936-1f3fc",
      "1f936-1f3fd",
      "1f936-1f3fe",
      "1f936-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "mx claus"
    ],
    u: "1f9d1-200d-1f384",
    v: [
      "1f9d1-1f3fb-200d-1f384",
      "1f9d1-1f3fc-200d-1f384",
      "1f9d1-1f3fd-200d-1f384",
      "1f9d1-1f3fe-200d-1f384",
      "1f9d1-1f3ff-200d-1f384"
    ],
    a: "13.0"
  },
  {
    n: [
      "superhero"
    ],
    u: "1f9b8",
    v: [
      "1f9b8-1f3fb",
      "1f9b8-1f3fc",
      "1f9b8-1f3fd",
      "1f9b8-1f3fe",
      "1f9b8-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man superhero",
      "male superhero"
    ],
    u: "1f9b8-200d-2642-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2642-fe0f",
      "1f9b8-1f3fc-200d-2642-fe0f",
      "1f9b8-1f3fd-200d-2642-fe0f",
      "1f9b8-1f3fe-200d-2642-fe0f",
      "1f9b8-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman superhero",
      "female superhero"
    ],
    u: "1f9b8-200d-2640-fe0f",
    v: [
      "1f9b8-1f3fb-200d-2640-fe0f",
      "1f9b8-1f3fc-200d-2640-fe0f",
      "1f9b8-1f3fd-200d-2640-fe0f",
      "1f9b8-1f3fe-200d-2640-fe0f",
      "1f9b8-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "supervillain"
    ],
    u: "1f9b9",
    v: [
      "1f9b9-1f3fb",
      "1f9b9-1f3fc",
      "1f9b9-1f3fd",
      "1f9b9-1f3fe",
      "1f9b9-1f3ff"
    ],
    a: "11.0"
  },
  {
    n: [
      "man supervillain",
      "male supervillain"
    ],
    u: "1f9b9-200d-2642-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2642-fe0f",
      "1f9b9-1f3fc-200d-2642-fe0f",
      "1f9b9-1f3fd-200d-2642-fe0f",
      "1f9b9-1f3fe-200d-2642-fe0f",
      "1f9b9-1f3ff-200d-2642-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "woman supervillain",
      "female supervillain"
    ],
    u: "1f9b9-200d-2640-fe0f",
    v: [
      "1f9b9-1f3fb-200d-2640-fe0f",
      "1f9b9-1f3fc-200d-2640-fe0f",
      "1f9b9-1f3fd-200d-2640-fe0f",
      "1f9b9-1f3fe-200d-2640-fe0f",
      "1f9b9-1f3ff-200d-2640-fe0f"
    ],
    a: "11.0"
  },
  {
    n: [
      "mage"
    ],
    u: "1f9d9",
    v: [
      "1f9d9-1f3fb",
      "1f9d9-1f3fc",
      "1f9d9-1f3fd",
      "1f9d9-1f3fe",
      "1f9d9-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man mage",
      "male mage"
    ],
    u: "1f9d9-200d-2642-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2642-fe0f",
      "1f9d9-1f3fc-200d-2642-fe0f",
      "1f9d9-1f3fd-200d-2642-fe0f",
      "1f9d9-1f3fe-200d-2642-fe0f",
      "1f9d9-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman mage",
      "female mage"
    ],
    u: "1f9d9-200d-2640-fe0f",
    v: [
      "1f9d9-1f3fb-200d-2640-fe0f",
      "1f9d9-1f3fc-200d-2640-fe0f",
      "1f9d9-1f3fd-200d-2640-fe0f",
      "1f9d9-1f3fe-200d-2640-fe0f",
      "1f9d9-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fairy"
    ],
    u: "1f9da",
    v: [
      "1f9da-1f3fb",
      "1f9da-1f3fc",
      "1f9da-1f3fd",
      "1f9da-1f3fe",
      "1f9da-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man fairy",
      "male fairy"
    ],
    u: "1f9da-200d-2642-fe0f",
    v: [
      "1f9da-1f3fb-200d-2642-fe0f",
      "1f9da-1f3fc-200d-2642-fe0f",
      "1f9da-1f3fd-200d-2642-fe0f",
      "1f9da-1f3fe-200d-2642-fe0f",
      "1f9da-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman fairy",
      "female fairy"
    ],
    u: "1f9da-200d-2640-fe0f",
    v: [
      "1f9da-1f3fb-200d-2640-fe0f",
      "1f9da-1f3fc-200d-2640-fe0f",
      "1f9da-1f3fd-200d-2640-fe0f",
      "1f9da-1f3fe-200d-2640-fe0f",
      "1f9da-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "vampire"
    ],
    u: "1f9db",
    v: [
      "1f9db-1f3fb",
      "1f9db-1f3fc",
      "1f9db-1f3fd",
      "1f9db-1f3fe",
      "1f9db-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man vampire",
      "male vampire"
    ],
    u: "1f9db-200d-2642-fe0f",
    v: [
      "1f9db-1f3fb-200d-2642-fe0f",
      "1f9db-1f3fc-200d-2642-fe0f",
      "1f9db-1f3fd-200d-2642-fe0f",
      "1f9db-1f3fe-200d-2642-fe0f",
      "1f9db-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman vampire",
      "female vampire"
    ],
    u: "1f9db-200d-2640-fe0f",
    v: [
      "1f9db-1f3fb-200d-2640-fe0f",
      "1f9db-1f3fc-200d-2640-fe0f",
      "1f9db-1f3fd-200d-2640-fe0f",
      "1f9db-1f3fe-200d-2640-fe0f",
      "1f9db-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "merperson"
    ],
    u: "1f9dc",
    v: [
      "1f9dc-1f3fb",
      "1f9dc-1f3fc",
      "1f9dc-1f3fd",
      "1f9dc-1f3fe",
      "1f9dc-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "merman"
    ],
    u: "1f9dc-200d-2642-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2642-fe0f",
      "1f9dc-1f3fc-200d-2642-fe0f",
      "1f9dc-1f3fd-200d-2642-fe0f",
      "1f9dc-1f3fe-200d-2642-fe0f",
      "1f9dc-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "mermaid"
    ],
    u: "1f9dc-200d-2640-fe0f",
    v: [
      "1f9dc-1f3fb-200d-2640-fe0f",
      "1f9dc-1f3fc-200d-2640-fe0f",
      "1f9dc-1f3fd-200d-2640-fe0f",
      "1f9dc-1f3fe-200d-2640-fe0f",
      "1f9dc-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "elf"
    ],
    u: "1f9dd",
    v: [
      "1f9dd-1f3fb",
      "1f9dd-1f3fc",
      "1f9dd-1f3fd",
      "1f9dd-1f3fe",
      "1f9dd-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man elf",
      "male elf"
    ],
    u: "1f9dd-200d-2642-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2642-fe0f",
      "1f9dd-1f3fc-200d-2642-fe0f",
      "1f9dd-1f3fd-200d-2642-fe0f",
      "1f9dd-1f3fe-200d-2642-fe0f",
      "1f9dd-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman elf",
      "female elf"
    ],
    u: "1f9dd-200d-2640-fe0f",
    v: [
      "1f9dd-1f3fb-200d-2640-fe0f",
      "1f9dd-1f3fc-200d-2640-fe0f",
      "1f9dd-1f3fd-200d-2640-fe0f",
      "1f9dd-1f3fe-200d-2640-fe0f",
      "1f9dd-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "genie"
    ],
    u: "1f9de",
    a: "5.0"
  },
  {
    n: [
      "man genie",
      "male genie"
    ],
    u: "1f9de-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman genie",
      "female genie"
    ],
    u: "1f9de-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "zombie"
    ],
    u: "1f9df",
    a: "5.0"
  },
  {
    n: [
      "man zombie",
      "male zombie"
    ],
    u: "1f9df-200d-2642-fe0f",
    a: "5.0"
  },
  {
    n: [
      "woman zombie",
      "female zombie"
    ],
    u: "1f9df-200d-2640-fe0f",
    a: "5.0"
  },
  {
    n: [
      "troll"
    ],
    u: "1f9cc",
    a: "14.0"
  },
  {
    n: [
      "massage",
      "face massage"
    ],
    u: "1f486",
    v: [
      "1f486-1f3fb",
      "1f486-1f3fc",
      "1f486-1f3fd",
      "1f486-1f3fe",
      "1f486-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting massage",
      "man-getting-massage"
    ],
    u: "1f486-200d-2642-fe0f",
    v: [
      "1f486-1f3fb-200d-2642-fe0f",
      "1f486-1f3fc-200d-2642-fe0f",
      "1f486-1f3fd-200d-2642-fe0f",
      "1f486-1f3fe-200d-2642-fe0f",
      "1f486-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting massage",
      "woman-getting-massage"
    ],
    u: "1f486-200d-2640-fe0f",
    v: [
      "1f486-1f3fb-200d-2640-fe0f",
      "1f486-1f3fc-200d-2640-fe0f",
      "1f486-1f3fd-200d-2640-fe0f",
      "1f486-1f3fe-200d-2640-fe0f",
      "1f486-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "haircut"
    ],
    u: "1f487",
    v: [
      "1f487-1f3fb",
      "1f487-1f3fc",
      "1f487-1f3fd",
      "1f487-1f3fe",
      "1f487-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man getting haircut",
      "man-getting-haircut"
    ],
    u: "1f487-200d-2642-fe0f",
    v: [
      "1f487-1f3fb-200d-2642-fe0f",
      "1f487-1f3fc-200d-2642-fe0f",
      "1f487-1f3fd-200d-2642-fe0f",
      "1f487-1f3fe-200d-2642-fe0f",
      "1f487-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman getting haircut",
      "woman-getting-haircut"
    ],
    u: "1f487-200d-2640-fe0f",
    v: [
      "1f487-1f3fb-200d-2640-fe0f",
      "1f487-1f3fc-200d-2640-fe0f",
      "1f487-1f3fd-200d-2640-fe0f",
      "1f487-1f3fe-200d-2640-fe0f",
      "1f487-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "walking",
      "pedestrian"
    ],
    u: "1f6b6",
    v: [
      "1f6b6-1f3fb",
      "1f6b6-1f3fc",
      "1f6b6-1f3fd",
      "1f6b6-1f3fe",
      "1f6b6-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man walking",
      "man-walking"
    ],
    u: "1f6b6-200d-2642-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2642-fe0f",
      "1f6b6-1f3fc-200d-2642-fe0f",
      "1f6b6-1f3fd-200d-2642-fe0f",
      "1f6b6-1f3fe-200d-2642-fe0f",
      "1f6b6-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman walking",
      "woman-walking"
    ],
    u: "1f6b6-200d-2640-fe0f",
    v: [
      "1f6b6-1f3fb-200d-2640-fe0f",
      "1f6b6-1f3fc-200d-2640-fe0f",
      "1f6b6-1f3fd-200d-2640-fe0f",
      "1f6b6-1f3fe-200d-2640-fe0f",
      "1f6b6-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "standing person"
    ],
    u: "1f9cd",
    v: [
      "1f9cd-1f3fb",
      "1f9cd-1f3fc",
      "1f9cd-1f3fd",
      "1f9cd-1f3fe",
      "1f9cd-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man standing"
    ],
    u: "1f9cd-200d-2642-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2642-fe0f",
      "1f9cd-1f3fc-200d-2642-fe0f",
      "1f9cd-1f3fd-200d-2642-fe0f",
      "1f9cd-1f3fe-200d-2642-fe0f",
      "1f9cd-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman standing"
    ],
    u: "1f9cd-200d-2640-fe0f",
    v: [
      "1f9cd-1f3fb-200d-2640-fe0f",
      "1f9cd-1f3fc-200d-2640-fe0f",
      "1f9cd-1f3fd-200d-2640-fe0f",
      "1f9cd-1f3fe-200d-2640-fe0f",
      "1f9cd-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "kneeling person"
    ],
    u: "1f9ce",
    v: [
      "1f9ce-1f3fb",
      "1f9ce-1f3fc",
      "1f9ce-1f3fd",
      "1f9ce-1f3fe",
      "1f9ce-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "man kneeling"
    ],
    u: "1f9ce-200d-2642-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2642-fe0f",
      "1f9ce-1f3fc-200d-2642-fe0f",
      "1f9ce-1f3fd-200d-2642-fe0f",
      "1f9ce-1f3fe-200d-2642-fe0f",
      "1f9ce-1f3ff-200d-2642-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman kneeling"
    ],
    u: "1f9ce-200d-2640-fe0f",
    v: [
      "1f9ce-1f3fb-200d-2640-fe0f",
      "1f9ce-1f3fc-200d-2640-fe0f",
      "1f9ce-1f3fd-200d-2640-fe0f",
      "1f9ce-1f3fe-200d-2640-fe0f",
      "1f9ce-1f3ff-200d-2640-fe0f"
    ],
    a: "12.0"
  },
  {
    n: [
      "person with white cane",
      "person with probing cane"
    ],
    u: "1f9d1-200d-1f9af",
    v: [
      "1f9d1-1f3fb-200d-1f9af",
      "1f9d1-1f3fc-200d-1f9af",
      "1f9d1-1f3fd-200d-1f9af",
      "1f9d1-1f3fe-200d-1f9af",
      "1f9d1-1f3ff-200d-1f9af"
    ],
    a: "12.1"
  },
  {
    n: [
      "man with white cane",
      "man with probing cane"
    ],
    u: "1f468-200d-1f9af",
    v: [
      "1f468-1f3fb-200d-1f9af",
      "1f468-1f3fc-200d-1f9af",
      "1f468-1f3fd-200d-1f9af",
      "1f468-1f3fe-200d-1f9af",
      "1f468-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman with white cane",
      "woman with probing cane"
    ],
    u: "1f469-200d-1f9af",
    v: [
      "1f469-1f3fb-200d-1f9af",
      "1f469-1f3fc-200d-1f9af",
      "1f469-1f3fd-200d-1f9af",
      "1f469-1f3fe-200d-1f9af",
      "1f469-1f3ff-200d-1f9af"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in motorized wheelchair"
    ],
    u: "1f9d1-200d-1f9bc",
    v: [
      "1f9d1-1f3fb-200d-1f9bc",
      "1f9d1-1f3fc-200d-1f9bc",
      "1f9d1-1f3fd-200d-1f9bc",
      "1f9d1-1f3fe-200d-1f9bc",
      "1f9d1-1f3ff-200d-1f9bc"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in motorized wheelchair"
    ],
    u: "1f468-200d-1f9bc",
    v: [
      "1f468-1f3fb-200d-1f9bc",
      "1f468-1f3fc-200d-1f9bc",
      "1f468-1f3fd-200d-1f9bc",
      "1f468-1f3fe-200d-1f9bc",
      "1f468-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in motorized wheelchair"
    ],
    u: "1f469-200d-1f9bc",
    v: [
      "1f469-1f3fb-200d-1f9bc",
      "1f469-1f3fc-200d-1f9bc",
      "1f469-1f3fd-200d-1f9bc",
      "1f469-1f3fe-200d-1f9bc",
      "1f469-1f3ff-200d-1f9bc"
    ],
    a: "12.0"
  },
  {
    n: [
      "person in manual wheelchair"
    ],
    u: "1f9d1-200d-1f9bd",
    v: [
      "1f9d1-1f3fb-200d-1f9bd",
      "1f9d1-1f3fc-200d-1f9bd",
      "1f9d1-1f3fd-200d-1f9bd",
      "1f9d1-1f3fe-200d-1f9bd",
      "1f9d1-1f3ff-200d-1f9bd"
    ],
    a: "12.1"
  },
  {
    n: [
      "man in manual wheelchair"
    ],
    u: "1f468-200d-1f9bd",
    v: [
      "1f468-1f3fb-200d-1f9bd",
      "1f468-1f3fc-200d-1f9bd",
      "1f468-1f3fd-200d-1f9bd",
      "1f468-1f3fe-200d-1f9bd",
      "1f468-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "woman in manual wheelchair"
    ],
    u: "1f469-200d-1f9bd",
    v: [
      "1f469-1f3fb-200d-1f9bd",
      "1f469-1f3fc-200d-1f9bd",
      "1f469-1f3fd-200d-1f9bd",
      "1f469-1f3fe-200d-1f9bd",
      "1f469-1f3ff-200d-1f9bd"
    ],
    a: "12.0"
  },
  {
    n: [
      "runner",
      "running"
    ],
    u: "1f3c3",
    v: [
      "1f3c3-1f3fb",
      "1f3c3-1f3fc",
      "1f3c3-1f3fd",
      "1f3c3-1f3fe",
      "1f3c3-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man running",
      "man-running"
    ],
    u: "1f3c3-200d-2642-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2642-fe0f",
      "1f3c3-1f3fc-200d-2642-fe0f",
      "1f3c3-1f3fd-200d-2642-fe0f",
      "1f3c3-1f3fe-200d-2642-fe0f",
      "1f3c3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman running",
      "woman-running"
    ],
    u: "1f3c3-200d-2640-fe0f",
    v: [
      "1f3c3-1f3fb-200d-2640-fe0f",
      "1f3c3-1f3fc-200d-2640-fe0f",
      "1f3c3-1f3fd-200d-2640-fe0f",
      "1f3c3-1f3fe-200d-2640-fe0f",
      "1f3c3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "dancer"
    ],
    u: "1f483",
    v: [
      "1f483-1f3fb",
      "1f483-1f3fc",
      "1f483-1f3fd",
      "1f483-1f3fe",
      "1f483-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man dancing"
    ],
    u: "1f57a",
    v: [
      "1f57a-1f3fb",
      "1f57a-1f3fc",
      "1f57a-1f3fd",
      "1f57a-1f3fe",
      "1f57a-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "person in suit levitating",
      "man in business suit levitating"
    ],
    u: "1f574-fe0f",
    v: [
      "1f574-1f3fb",
      "1f574-1f3fc",
      "1f574-1f3fd",
      "1f574-1f3fe",
      "1f574-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "dancers",
      "woman with bunny ears"
    ],
    u: "1f46f",
    a: "0.6"
  },
  {
    n: [
      "men with bunny ears",
      "men-with-bunny-ears-partying",
      "man-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women with bunny ears",
      "women-with-bunny-ears-partying",
      "woman-with-bunny-ears-partying"
    ],
    u: "1f46f-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "person in steamy room"
    ],
    u: "1f9d6",
    v: [
      "1f9d6-1f3fb",
      "1f9d6-1f3fc",
      "1f9d6-1f3fd",
      "1f9d6-1f3fe",
      "1f9d6-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in steamy room"
    ],
    u: "1f9d6-200d-2642-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2642-fe0f",
      "1f9d6-1f3fc-200d-2642-fe0f",
      "1f9d6-1f3fd-200d-2642-fe0f",
      "1f9d6-1f3fe-200d-2642-fe0f",
      "1f9d6-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in steamy room"
    ],
    u: "1f9d6-200d-2640-fe0f",
    v: [
      "1f9d6-1f3fb-200d-2640-fe0f",
      "1f9d6-1f3fc-200d-2640-fe0f",
      "1f9d6-1f3fd-200d-2640-fe0f",
      "1f9d6-1f3fe-200d-2640-fe0f",
      "1f9d6-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "person climbing"
    ],
    u: "1f9d7",
    v: [
      "1f9d7-1f3fb",
      "1f9d7-1f3fc",
      "1f9d7-1f3fd",
      "1f9d7-1f3fe",
      "1f9d7-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man climbing"
    ],
    u: "1f9d7-200d-2642-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2642-fe0f",
      "1f9d7-1f3fc-200d-2642-fe0f",
      "1f9d7-1f3fd-200d-2642-fe0f",
      "1f9d7-1f3fe-200d-2642-fe0f",
      "1f9d7-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman climbing"
    ],
    u: "1f9d7-200d-2640-fe0f",
    v: [
      "1f9d7-1f3fb-200d-2640-fe0f",
      "1f9d7-1f3fc-200d-2640-fe0f",
      "1f9d7-1f3fd-200d-2640-fe0f",
      "1f9d7-1f3fe-200d-2640-fe0f",
      "1f9d7-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "fencer"
    ],
    u: "1f93a",
    a: "3.0"
  },
  {
    n: [
      "horse racing"
    ],
    u: "1f3c7",
    v: [
      "1f3c7-1f3fb",
      "1f3c7-1f3fc",
      "1f3c7-1f3fd",
      "1f3c7-1f3fe",
      "1f3c7-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "skier"
    ],
    u: "26f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowboarder"
    ],
    u: "1f3c2",
    v: [
      "1f3c2-1f3fb",
      "1f3c2-1f3fc",
      "1f3c2-1f3fd",
      "1f3c2-1f3fe",
      "1f3c2-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "golfer",
      "person golfing"
    ],
    u: "1f3cc-fe0f",
    v: [
      "1f3cc-1f3fb",
      "1f3cc-1f3fc",
      "1f3cc-1f3fd",
      "1f3cc-1f3fe",
      "1f3cc-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man golfing",
      "man-golfing"
    ],
    u: "1f3cc-fe0f-200d-2642-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2642-fe0f",
      "1f3cc-1f3fc-200d-2642-fe0f",
      "1f3cc-1f3fd-200d-2642-fe0f",
      "1f3cc-1f3fe-200d-2642-fe0f",
      "1f3cc-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman golfing",
      "woman-golfing"
    ],
    u: "1f3cc-fe0f-200d-2640-fe0f",
    v: [
      "1f3cc-1f3fb-200d-2640-fe0f",
      "1f3cc-1f3fc-200d-2640-fe0f",
      "1f3cc-1f3fd-200d-2640-fe0f",
      "1f3cc-1f3fe-200d-2640-fe0f",
      "1f3cc-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "surfer"
    ],
    u: "1f3c4",
    v: [
      "1f3c4-1f3fb",
      "1f3c4-1f3fc",
      "1f3c4-1f3fd",
      "1f3c4-1f3fe",
      "1f3c4-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man surfing",
      "man-surfing"
    ],
    u: "1f3c4-200d-2642-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2642-fe0f",
      "1f3c4-1f3fc-200d-2642-fe0f",
      "1f3c4-1f3fd-200d-2642-fe0f",
      "1f3c4-1f3fe-200d-2642-fe0f",
      "1f3c4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman surfing",
      "woman-surfing"
    ],
    u: "1f3c4-200d-2640-fe0f",
    v: [
      "1f3c4-1f3fb-200d-2640-fe0f",
      "1f3c4-1f3fc-200d-2640-fe0f",
      "1f3c4-1f3fd-200d-2640-fe0f",
      "1f3c4-1f3fe-200d-2640-fe0f",
      "1f3c4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "rowboat"
    ],
    u: "1f6a3",
    v: [
      "1f6a3-1f3fb",
      "1f6a3-1f3fc",
      "1f6a3-1f3fd",
      "1f6a3-1f3fe",
      "1f6a3-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man rowing boat",
      "man-rowing-boat"
    ],
    u: "1f6a3-200d-2642-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2642-fe0f",
      "1f6a3-1f3fc-200d-2642-fe0f",
      "1f6a3-1f3fd-200d-2642-fe0f",
      "1f6a3-1f3fe-200d-2642-fe0f",
      "1f6a3-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman rowing boat",
      "woman-rowing-boat"
    ],
    u: "1f6a3-200d-2640-fe0f",
    v: [
      "1f6a3-1f3fb-200d-2640-fe0f",
      "1f6a3-1f3fc-200d-2640-fe0f",
      "1f6a3-1f3fd-200d-2640-fe0f",
      "1f6a3-1f3fe-200d-2640-fe0f",
      "1f6a3-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "swimmer"
    ],
    u: "1f3ca",
    v: [
      "1f3ca-1f3fb",
      "1f3ca-1f3fc",
      "1f3ca-1f3fd",
      "1f3ca-1f3fe",
      "1f3ca-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "man swimming",
      "man-swimming"
    ],
    u: "1f3ca-200d-2642-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2642-fe0f",
      "1f3ca-1f3fc-200d-2642-fe0f",
      "1f3ca-1f3fd-200d-2642-fe0f",
      "1f3ca-1f3fe-200d-2642-fe0f",
      "1f3ca-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman swimming",
      "woman-swimming"
    ],
    u: "1f3ca-200d-2640-fe0f",
    v: [
      "1f3ca-1f3fb-200d-2640-fe0f",
      "1f3ca-1f3fc-200d-2640-fe0f",
      "1f3ca-1f3fd-200d-2640-fe0f",
      "1f3ca-1f3fe-200d-2640-fe0f",
      "1f3ca-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person with ball",
      "person bouncing ball"
    ],
    u: "26f9-fe0f",
    v: [
      "26f9-1f3fb",
      "26f9-1f3fc",
      "26f9-1f3fd",
      "26f9-1f3fe",
      "26f9-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man bouncing ball",
      "man-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2642-fe0f",
    v: [
      "26f9-1f3fb-200d-2642-fe0f",
      "26f9-1f3fc-200d-2642-fe0f",
      "26f9-1f3fd-200d-2642-fe0f",
      "26f9-1f3fe-200d-2642-fe0f",
      "26f9-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman bouncing ball",
      "woman-bouncing-ball"
    ],
    u: "26f9-fe0f-200d-2640-fe0f",
    v: [
      "26f9-1f3fb-200d-2640-fe0f",
      "26f9-1f3fc-200d-2640-fe0f",
      "26f9-1f3fd-200d-2640-fe0f",
      "26f9-1f3fe-200d-2640-fe0f",
      "26f9-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "weight lifter",
      "person lifting weights"
    ],
    u: "1f3cb-fe0f",
    v: [
      "1f3cb-1f3fb",
      "1f3cb-1f3fc",
      "1f3cb-1f3fd",
      "1f3cb-1f3fe",
      "1f3cb-1f3ff"
    ],
    a: "0.7"
  },
  {
    n: [
      "man lifting weights",
      "man-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2642-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2642-fe0f",
      "1f3cb-1f3fc-200d-2642-fe0f",
      "1f3cb-1f3fd-200d-2642-fe0f",
      "1f3cb-1f3fe-200d-2642-fe0f",
      "1f3cb-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman lifting weights",
      "woman-lifting-weights"
    ],
    u: "1f3cb-fe0f-200d-2640-fe0f",
    v: [
      "1f3cb-1f3fb-200d-2640-fe0f",
      "1f3cb-1f3fc-200d-2640-fe0f",
      "1f3cb-1f3fd-200d-2640-fe0f",
      "1f3cb-1f3fe-200d-2640-fe0f",
      "1f3cb-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "bicyclist"
    ],
    u: "1f6b4",
    v: [
      "1f6b4-1f3fb",
      "1f6b4-1f3fc",
      "1f6b4-1f3fd",
      "1f6b4-1f3fe",
      "1f6b4-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man biking",
      "man-biking"
    ],
    u: "1f6b4-200d-2642-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2642-fe0f",
      "1f6b4-1f3fc-200d-2642-fe0f",
      "1f6b4-1f3fd-200d-2642-fe0f",
      "1f6b4-1f3fe-200d-2642-fe0f",
      "1f6b4-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman biking",
      "woman-biking"
    ],
    u: "1f6b4-200d-2640-fe0f",
    v: [
      "1f6b4-1f3fb-200d-2640-fe0f",
      "1f6b4-1f3fc-200d-2640-fe0f",
      "1f6b4-1f3fd-200d-2640-fe0f",
      "1f6b4-1f3fe-200d-2640-fe0f",
      "1f6b4-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "mountain bicyclist"
    ],
    u: "1f6b5",
    v: [
      "1f6b5-1f3fb",
      "1f6b5-1f3fc",
      "1f6b5-1f3fd",
      "1f6b5-1f3fe",
      "1f6b5-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "man mountain biking",
      "man-mountain-biking"
    ],
    u: "1f6b5-200d-2642-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2642-fe0f",
      "1f6b5-1f3fc-200d-2642-fe0f",
      "1f6b5-1f3fd-200d-2642-fe0f",
      "1f6b5-1f3fe-200d-2642-fe0f",
      "1f6b5-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman mountain biking",
      "woman-mountain-biking"
    ],
    u: "1f6b5-200d-2640-fe0f",
    v: [
      "1f6b5-1f3fb-200d-2640-fe0f",
      "1f6b5-1f3fc-200d-2640-fe0f",
      "1f6b5-1f3fd-200d-2640-fe0f",
      "1f6b5-1f3fe-200d-2640-fe0f",
      "1f6b5-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person doing cartwheel"
    ],
    u: "1f938",
    v: [
      "1f938-1f3fb",
      "1f938-1f3fc",
      "1f938-1f3fd",
      "1f938-1f3fe",
      "1f938-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man cartwheeling",
      "man-cartwheeling"
    ],
    u: "1f938-200d-2642-fe0f",
    v: [
      "1f938-1f3fb-200d-2642-fe0f",
      "1f938-1f3fc-200d-2642-fe0f",
      "1f938-1f3fd-200d-2642-fe0f",
      "1f938-1f3fe-200d-2642-fe0f",
      "1f938-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman cartwheeling",
      "woman-cartwheeling"
    ],
    u: "1f938-200d-2640-fe0f",
    v: [
      "1f938-1f3fb-200d-2640-fe0f",
      "1f938-1f3fc-200d-2640-fe0f",
      "1f938-1f3fd-200d-2640-fe0f",
      "1f938-1f3fe-200d-2640-fe0f",
      "1f938-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "wrestlers"
    ],
    u: "1f93c",
    a: "3.0"
  },
  {
    n: [
      "men wrestling",
      "man-wrestling"
    ],
    u: "1f93c-200d-2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "women wrestling",
      "woman-wrestling"
    ],
    u: "1f93c-200d-2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "water polo"
    ],
    u: "1f93d",
    v: [
      "1f93d-1f3fb",
      "1f93d-1f3fc",
      "1f93d-1f3fd",
      "1f93d-1f3fe",
      "1f93d-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing water polo",
      "man-playing-water-polo"
    ],
    u: "1f93d-200d-2642-fe0f",
    v: [
      "1f93d-1f3fb-200d-2642-fe0f",
      "1f93d-1f3fc-200d-2642-fe0f",
      "1f93d-1f3fd-200d-2642-fe0f",
      "1f93d-1f3fe-200d-2642-fe0f",
      "1f93d-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing water polo",
      "woman-playing-water-polo"
    ],
    u: "1f93d-200d-2640-fe0f",
    v: [
      "1f93d-1f3fb-200d-2640-fe0f",
      "1f93d-1f3fc-200d-2640-fe0f",
      "1f93d-1f3fd-200d-2640-fe0f",
      "1f93d-1f3fe-200d-2640-fe0f",
      "1f93d-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "handball"
    ],
    u: "1f93e",
    v: [
      "1f93e-1f3fb",
      "1f93e-1f3fc",
      "1f93e-1f3fd",
      "1f93e-1f3fe",
      "1f93e-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man playing handball",
      "man-playing-handball"
    ],
    u: "1f93e-200d-2642-fe0f",
    v: [
      "1f93e-1f3fb-200d-2642-fe0f",
      "1f93e-1f3fc-200d-2642-fe0f",
      "1f93e-1f3fd-200d-2642-fe0f",
      "1f93e-1f3fe-200d-2642-fe0f",
      "1f93e-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman playing handball",
      "woman-playing-handball"
    ],
    u: "1f93e-200d-2640-fe0f",
    v: [
      "1f93e-1f3fb-200d-2640-fe0f",
      "1f93e-1f3fc-200d-2640-fe0f",
      "1f93e-1f3fd-200d-2640-fe0f",
      "1f93e-1f3fe-200d-2640-fe0f",
      "1f93e-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "juggling"
    ],
    u: "1f939",
    v: [
      "1f939-1f3fb",
      "1f939-1f3fc",
      "1f939-1f3fd",
      "1f939-1f3fe",
      "1f939-1f3ff"
    ],
    a: "3.0"
  },
  {
    n: [
      "man juggling",
      "man-juggling"
    ],
    u: "1f939-200d-2642-fe0f",
    v: [
      "1f939-1f3fb-200d-2642-fe0f",
      "1f939-1f3fc-200d-2642-fe0f",
      "1f939-1f3fd-200d-2642-fe0f",
      "1f939-1f3fe-200d-2642-fe0f",
      "1f939-1f3ff-200d-2642-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "woman juggling",
      "woman-juggling"
    ],
    u: "1f939-200d-2640-fe0f",
    v: [
      "1f939-1f3fb-200d-2640-fe0f",
      "1f939-1f3fc-200d-2640-fe0f",
      "1f939-1f3fd-200d-2640-fe0f",
      "1f939-1f3fe-200d-2640-fe0f",
      "1f939-1f3ff-200d-2640-fe0f"
    ],
    a: "4.0"
  },
  {
    n: [
      "person in lotus position"
    ],
    u: "1f9d8",
    v: [
      "1f9d8-1f3fb",
      "1f9d8-1f3fc",
      "1f9d8-1f3fd",
      "1f9d8-1f3fe",
      "1f9d8-1f3ff"
    ],
    a: "5.0"
  },
  {
    n: [
      "man in lotus position"
    ],
    u: "1f9d8-200d-2642-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2642-fe0f",
      "1f9d8-1f3fc-200d-2642-fe0f",
      "1f9d8-1f3fd-200d-2642-fe0f",
      "1f9d8-1f3fe-200d-2642-fe0f",
      "1f9d8-1f3ff-200d-2642-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "woman in lotus position"
    ],
    u: "1f9d8-200d-2640-fe0f",
    v: [
      "1f9d8-1f3fb-200d-2640-fe0f",
      "1f9d8-1f3fc-200d-2640-fe0f",
      "1f9d8-1f3fd-200d-2640-fe0f",
      "1f9d8-1f3fe-200d-2640-fe0f",
      "1f9d8-1f3ff-200d-2640-fe0f"
    ],
    a: "5.0"
  },
  {
    n: [
      "bath"
    ],
    u: "1f6c0",
    v: [
      "1f6c0-1f3fb",
      "1f6c0-1f3fc",
      "1f6c0-1f3fd",
      "1f6c0-1f3fe",
      "1f6c0-1f3ff"
    ],
    a: "0.6"
  },
  {
    n: [
      "sleeping accommodation"
    ],
    u: "1f6cc",
    v: [
      "1f6cc-1f3fb",
      "1f6cc-1f3fc",
      "1f6cc-1f3fd",
      "1f6cc-1f3fe",
      "1f6cc-1f3ff"
    ],
    a: "1.0"
  },
  {
    n: [
      "people holding hands"
    ],
    u: "1f9d1-200d-1f91d-200d-1f9d1",
    v: [
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
      "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
    ],
    a: "12.0"
  },
  {
    n: [
      "women holding hands",
      "two women holding hands"
    ],
    u: "1f46d",
    v: [
      "1f46d-1f3fb",
      "1f46d-1f3fc",
      "1f46d-1f3fd",
      "1f46d-1f3fe",
      "1f46d-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "couple",
      "man and woman holding hands",
      "woman and man holding hands"
    ],
    u: "1f46b",
    v: [
      "1f46b-1f3fb",
      "1f46b-1f3fc",
      "1f46b-1f3fd",
      "1f46b-1f3fe",
      "1f46b-1f3ff",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "men holding hands",
      "two men holding hands"
    ],
    u: "1f46c",
    v: [
      "1f46c-1f3fb",
      "1f46c-1f3fc",
      "1f46c-1f3fd",
      "1f46c-1f3fe",
      "1f46c-1f3ff",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
    ],
    a: "1.0"
  },
  {
    n: [
      "kiss",
      "couplekiss"
    ],
    u: "1f48f",
    v: [
      "1f48f-1f3fb",
      "1f48f-1f3fc",
      "1f48f-1f3fd",
      "1f48f-1f3fe",
      "1f48f-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-kiss-man",
      "kiss: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-kiss-man",
      "kiss: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-kiss-woman",
      "kiss: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "couple with heart"
    ],
    u: "1f491",
    v: [
      "1f491-1f3fb",
      "1f491-1f3fc",
      "1f491-1f3fd",
      "1f491-1f3fe",
      "1f491-1f3ff",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
      "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
      "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
    ],
    a: "0.6"
  },
  {
    n: [
      "woman-heart-man",
      "couple with heart: woman, man"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f468",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "man-heart-man",
      "couple with heart: man, man"
    ],
    u: "1f468-200d-2764-fe0f-200d-1f468",
    v: [
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
      "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "woman-heart-woman",
      "couple with heart: woman, woman"
    ],
    u: "1f469-200d-2764-fe0f-200d-1f469",
    v: [
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
      "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
    ],
    a: "2.0"
  },
  {
    n: [
      "family"
    ],
    u: "1f46a",
    a: "0.6"
  },
  {
    n: [
      "man-woman-boy",
      "family: man, woman, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl",
      "family: man, woman, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-boy",
      "family: man, woman, girl, boy"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-boy-boy",
      "family: man, woman, boy, boy"
    ],
    u: "1f468-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-woman-girl-girl",
      "family: man, woman, girl, girl"
    ],
    u: "1f468-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy",
      "family: man, man, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl",
      "family: man, man, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-boy",
      "family: man, man, girl, boy"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-boy-boy",
      "family: man, man, boy, boy"
    ],
    u: "1f468-200d-1f468-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "man-man-girl-girl",
      "family: man, man, girl, girl"
    ],
    u: "1f468-200d-1f468-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy",
      "family: woman, woman, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl",
      "family: woman, woman, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-boy",
      "family: woman, woman, girl, boy"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-boy-boy",
      "family: woman, woman, boy, boy"
    ],
    u: "1f469-200d-1f469-200d-1f466-200d-1f466",
    a: "2.0"
  },
  {
    n: [
      "woman-woman-girl-girl",
      "family: woman, woman, girl, girl"
    ],
    u: "1f469-200d-1f469-200d-1f467-200d-1f467",
    a: "2.0"
  },
  {
    n: [
      "man-boy",
      "family: man, boy"
    ],
    u: "1f468-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-boy-boy",
      "family: man, boy, boy"
    ],
    u: "1f468-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl",
      "family: man, girl"
    ],
    u: "1f468-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "man-girl-boy",
      "family: man, girl, boy"
    ],
    u: "1f468-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "man-girl-girl",
      "family: man, girl, girl"
    ],
    u: "1f468-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-boy",
      "family: woman, boy"
    ],
    u: "1f469-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-boy-boy",
      "family: woman, boy, boy"
    ],
    u: "1f469-200d-1f466-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl",
      "family: woman, girl"
    ],
    u: "1f469-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-boy",
      "family: woman, girl, boy"
    ],
    u: "1f469-200d-1f467-200d-1f466",
    a: "4.0"
  },
  {
    n: [
      "woman-girl-girl",
      "family: woman, girl, girl"
    ],
    u: "1f469-200d-1f467-200d-1f467",
    a: "4.0"
  },
  {
    n: [
      "speaking head",
      "speaking head in silhouette"
    ],
    u: "1f5e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bust in silhouette"
    ],
    u: "1f464",
    a: "0.6"
  },
  {
    n: [
      "busts in silhouette"
    ],
    u: "1f465",
    a: "1.0"
  },
  {
    n: [
      "people hugging"
    ],
    u: "1fac2",
    a: "13.0"
  },
  {
    n: [
      "footprints"
    ],
    u: "1f463",
    a: "0.6"
  }
], NE = [
  {
    n: [
      "monkey face"
    ],
    u: "1f435",
    a: "0.6"
  },
  {
    n: [
      "monkey"
    ],
    u: "1f412",
    a: "0.6"
  },
  {
    n: [
      "gorilla"
    ],
    u: "1f98d",
    a: "3.0"
  },
  {
    n: [
      "orangutan"
    ],
    u: "1f9a7",
    a: "12.0"
  },
  {
    n: [
      "dog",
      "dog face"
    ],
    u: "1f436",
    a: "0.6"
  },
  {
    n: [
      "dog",
      "dog2"
    ],
    u: "1f415",
    a: "0.7"
  },
  {
    n: [
      "guide dog"
    ],
    u: "1f9ae",
    a: "12.0"
  },
  {
    n: [
      "service dog"
    ],
    u: "1f415-200d-1f9ba",
    a: "12.0"
  },
  {
    n: [
      "poodle"
    ],
    u: "1f429",
    a: "0.6"
  },
  {
    n: [
      "wolf",
      "wolf face"
    ],
    u: "1f43a",
    a: "0.6"
  },
  {
    n: [
      "fox face"
    ],
    u: "1f98a",
    a: "3.0"
  },
  {
    n: [
      "raccoon"
    ],
    u: "1f99d",
    a: "11.0"
  },
  {
    n: [
      "cat",
      "cat face"
    ],
    u: "1f431",
    a: "0.6"
  },
  {
    n: [
      "cat",
      "cat2"
    ],
    u: "1f408",
    a: "0.7"
  },
  {
    n: [
      "black cat"
    ],
    u: "1f408-200d-2b1b",
    a: "13.0"
  },
  {
    n: [
      "lion face"
    ],
    u: "1f981",
    a: "1.0"
  },
  {
    n: [
      "tiger",
      "tiger face"
    ],
    u: "1f42f",
    a: "0.6"
  },
  {
    n: [
      "tiger",
      "tiger2"
    ],
    u: "1f405",
    a: "1.0"
  },
  {
    n: [
      "leopard"
    ],
    u: "1f406",
    a: "1.0"
  },
  {
    n: [
      "horse",
      "horse face"
    ],
    u: "1f434",
    a: "0.6"
  },
  {
    n: [
      "horse",
      "racehorse"
    ],
    u: "1f40e",
    a: "0.6"
  },
  {
    n: [
      "unicorn face"
    ],
    u: "1f984",
    a: "1.0"
  },
  {
    n: [
      "zebra face"
    ],
    u: "1f993",
    a: "5.0"
  },
  {
    n: [
      "deer"
    ],
    u: "1f98c",
    a: "3.0"
  },
  {
    n: [
      "bison"
    ],
    u: "1f9ac",
    a: "13.0"
  },
  {
    n: [
      "cow",
      "cow face"
    ],
    u: "1f42e",
    a: "0.6"
  },
  {
    n: [
      "ox"
    ],
    u: "1f402",
    a: "1.0"
  },
  {
    n: [
      "water buffalo"
    ],
    u: "1f403",
    a: "1.0"
  },
  {
    n: [
      "cow",
      "cow2"
    ],
    u: "1f404",
    a: "1.0"
  },
  {
    n: [
      "pig",
      "pig face"
    ],
    u: "1f437",
    a: "0.6"
  },
  {
    n: [
      "pig",
      "pig2"
    ],
    u: "1f416",
    a: "1.0"
  },
  {
    n: [
      "boar"
    ],
    u: "1f417",
    a: "0.6"
  },
  {
    n: [
      "pig nose"
    ],
    u: "1f43d",
    a: "0.6"
  },
  {
    n: [
      "ram"
    ],
    u: "1f40f",
    a: "1.0"
  },
  {
    n: [
      "sheep"
    ],
    u: "1f411",
    a: "0.6"
  },
  {
    n: [
      "goat"
    ],
    u: "1f410",
    a: "1.0"
  },
  {
    n: [
      "dromedary camel"
    ],
    u: "1f42a",
    a: "1.0"
  },
  {
    n: [
      "camel",
      "bactrian camel"
    ],
    u: "1f42b",
    a: "0.6"
  },
  {
    n: [
      "llama"
    ],
    u: "1f999",
    a: "11.0"
  },
  {
    n: [
      "giraffe face"
    ],
    u: "1f992",
    a: "5.0"
  },
  {
    n: [
      "elephant"
    ],
    u: "1f418",
    a: "0.6"
  },
  {
    n: [
      "mammoth"
    ],
    u: "1f9a3",
    a: "13.0"
  },
  {
    n: [
      "rhinoceros"
    ],
    u: "1f98f",
    a: "3.0"
  },
  {
    n: [
      "hippopotamus"
    ],
    u: "1f99b",
    a: "11.0"
  },
  {
    n: [
      "mouse",
      "mouse face"
    ],
    u: "1f42d",
    a: "0.6"
  },
  {
    n: [
      "mouse",
      "mouse2"
    ],
    u: "1f401",
    a: "1.0"
  },
  {
    n: [
      "rat"
    ],
    u: "1f400",
    a: "1.0"
  },
  {
    n: [
      "hamster",
      "hamster face"
    ],
    u: "1f439",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit face"
    ],
    u: "1f430",
    a: "0.6"
  },
  {
    n: [
      "rabbit",
      "rabbit2"
    ],
    u: "1f407",
    a: "1.0"
  },
  {
    n: [
      "chipmunk"
    ],
    u: "1f43f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beaver"
    ],
    u: "1f9ab",
    a: "13.0"
  },
  {
    n: [
      "hedgehog"
    ],
    u: "1f994",
    a: "5.0"
  },
  {
    n: [
      "bat"
    ],
    u: "1f987",
    a: "3.0"
  },
  {
    n: [
      "bear",
      "bear face"
    ],
    u: "1f43b",
    a: "0.6"
  },
  {
    n: [
      "polar bear"
    ],
    u: "1f43b-200d-2744-fe0f",
    a: "13.0"
  },
  {
    n: [
      "koala"
    ],
    u: "1f428",
    a: "0.6"
  },
  {
    n: [
      "panda face"
    ],
    u: "1f43c",
    a: "0.6"
  },
  {
    n: [
      "sloth"
    ],
    u: "1f9a5",
    a: "12.0"
  },
  {
    n: [
      "otter"
    ],
    u: "1f9a6",
    a: "12.0"
  },
  {
    n: [
      "skunk"
    ],
    u: "1f9a8",
    a: "12.0"
  },
  {
    n: [
      "kangaroo"
    ],
    u: "1f998",
    a: "11.0"
  },
  {
    n: [
      "badger"
    ],
    u: "1f9a1",
    a: "11.0"
  },
  {
    n: [
      "feet",
      "paw prints"
    ],
    u: "1f43e",
    a: "0.6"
  },
  {
    n: [
      "turkey"
    ],
    u: "1f983",
    a: "1.0"
  },
  {
    n: [
      "chicken"
    ],
    u: "1f414",
    a: "0.6"
  },
  {
    n: [
      "rooster"
    ],
    u: "1f413",
    a: "1.0"
  },
  {
    n: [
      "hatching chick"
    ],
    u: "1f423",
    a: "0.6"
  },
  {
    n: [
      "baby chick"
    ],
    u: "1f424",
    a: "0.6"
  },
  {
    n: [
      "hatched chick",
      "front-facing baby chick"
    ],
    u: "1f425",
    a: "0.6"
  },
  {
    n: [
      "bird"
    ],
    u: "1f426",
    a: "0.6"
  },
  {
    n: [
      "penguin"
    ],
    u: "1f427",
    a: "0.6"
  },
  {
    n: [
      "dove",
      "dove of peace"
    ],
    u: "1f54a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eagle"
    ],
    u: "1f985",
    a: "3.0"
  },
  {
    n: [
      "duck"
    ],
    u: "1f986",
    a: "3.0"
  },
  {
    n: [
      "swan"
    ],
    u: "1f9a2",
    a: "11.0"
  },
  {
    n: [
      "owl"
    ],
    u: "1f989",
    a: "3.0"
  },
  {
    n: [
      "dodo"
    ],
    u: "1f9a4",
    a: "13.0"
  },
  {
    n: [
      "feather"
    ],
    u: "1fab6",
    a: "13.0"
  },
  {
    n: [
      "flamingo"
    ],
    u: "1f9a9",
    a: "12.0"
  },
  {
    n: [
      "peacock"
    ],
    u: "1f99a",
    a: "11.0"
  },
  {
    n: [
      "parrot"
    ],
    u: "1f99c",
    a: "11.0"
  },
  {
    n: [
      "frog",
      "frog face"
    ],
    u: "1f438",
    a: "0.6"
  },
  {
    n: [
      "crocodile"
    ],
    u: "1f40a",
    a: "1.0"
  },
  {
    n: [
      "turtle"
    ],
    u: "1f422",
    a: "0.6"
  },
  {
    n: [
      "lizard"
    ],
    u: "1f98e",
    a: "3.0"
  },
  {
    n: [
      "snake"
    ],
    u: "1f40d",
    a: "0.6"
  },
  {
    n: [
      "dragon face"
    ],
    u: "1f432",
    a: "0.6"
  },
  {
    n: [
      "dragon"
    ],
    u: "1f409",
    a: "1.0"
  },
  {
    n: [
      "sauropod"
    ],
    u: "1f995",
    a: "5.0"
  },
  {
    n: [
      "t-rex"
    ],
    u: "1f996",
    a: "5.0"
  },
  {
    n: [
      "whale",
      "spouting whale"
    ],
    u: "1f433",
    a: "0.6"
  },
  {
    n: [
      "whale",
      "whale2"
    ],
    u: "1f40b",
    a: "1.0"
  },
  {
    n: [
      "dolphin",
      "flipper"
    ],
    u: "1f42c",
    a: "0.6"
  },
  {
    n: [
      "seal"
    ],
    u: "1f9ad",
    a: "13.0"
  },
  {
    n: [
      "fish"
    ],
    u: "1f41f",
    a: "0.6"
  },
  {
    n: [
      "tropical fish"
    ],
    u: "1f420",
    a: "0.6"
  },
  {
    n: [
      "blowfish"
    ],
    u: "1f421",
    a: "0.6"
  },
  {
    n: [
      "shark"
    ],
    u: "1f988",
    a: "3.0"
  },
  {
    n: [
      "octopus"
    ],
    u: "1f419",
    a: "0.6"
  },
  {
    n: [
      "shell",
      "spiral shell"
    ],
    u: "1f41a",
    a: "0.6"
  },
  {
    n: [
      "coral"
    ],
    u: "1fab8",
    a: "14.0"
  },
  {
    n: [
      "snail"
    ],
    u: "1f40c",
    a: "0.6"
  },
  {
    n: [
      "butterfly"
    ],
    u: "1f98b",
    a: "3.0"
  },
  {
    n: [
      "bug"
    ],
    u: "1f41b",
    a: "0.6"
  },
  {
    n: [
      "ant"
    ],
    u: "1f41c",
    a: "0.6"
  },
  {
    n: [
      "bee",
      "honeybee"
    ],
    u: "1f41d",
    a: "0.6"
  },
  {
    n: [
      "beetle"
    ],
    u: "1fab2",
    a: "13.0"
  },
  {
    n: [
      "ladybug",
      "lady beetle"
    ],
    u: "1f41e",
    a: "0.6"
  },
  {
    n: [
      "cricket"
    ],
    u: "1f997",
    a: "5.0"
  },
  {
    n: [
      "cockroach"
    ],
    u: "1fab3",
    a: "13.0"
  },
  {
    n: [
      "spider"
    ],
    u: "1f577-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spider web"
    ],
    u: "1f578-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scorpion"
    ],
    u: "1f982",
    a: "1.0"
  },
  {
    n: [
      "mosquito"
    ],
    u: "1f99f",
    a: "11.0"
  },
  {
    n: [
      "fly"
    ],
    u: "1fab0",
    a: "13.0"
  },
  {
    n: [
      "worm"
    ],
    u: "1fab1",
    a: "13.0"
  },
  {
    n: [
      "microbe"
    ],
    u: "1f9a0",
    a: "11.0"
  },
  {
    n: [
      "bouquet"
    ],
    u: "1f490",
    a: "0.6"
  },
  {
    n: [
      "cherry blossom"
    ],
    u: "1f338",
    a: "0.6"
  },
  {
    n: [
      "white flower"
    ],
    u: "1f4ae",
    a: "0.6"
  },
  {
    n: [
      "lotus"
    ],
    u: "1fab7",
    a: "14.0"
  },
  {
    n: [
      "rosette"
    ],
    u: "1f3f5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rose"
    ],
    u: "1f339",
    a: "0.6"
  },
  {
    n: [
      "wilted flower"
    ],
    u: "1f940",
    a: "3.0"
  },
  {
    n: [
      "hibiscus"
    ],
    u: "1f33a",
    a: "0.6"
  },
  {
    n: [
      "sunflower"
    ],
    u: "1f33b",
    a: "0.6"
  },
  {
    n: [
      "blossom"
    ],
    u: "1f33c",
    a: "0.6"
  },
  {
    n: [
      "tulip"
    ],
    u: "1f337",
    a: "0.6"
  },
  {
    n: [
      "seedling"
    ],
    u: "1f331",
    a: "0.6"
  },
  {
    n: [
      "potted plant"
    ],
    u: "1fab4",
    a: "13.0"
  },
  {
    n: [
      "evergreen tree"
    ],
    u: "1f332",
    a: "1.0"
  },
  {
    n: [
      "deciduous tree"
    ],
    u: "1f333",
    a: "1.0"
  },
  {
    n: [
      "palm tree"
    ],
    u: "1f334",
    a: "0.6"
  },
  {
    n: [
      "cactus"
    ],
    u: "1f335",
    a: "0.6"
  },
  {
    n: [
      "ear of rice"
    ],
    u: "1f33e",
    a: "0.6"
  },
  {
    n: [
      "herb"
    ],
    u: "1f33f",
    a: "0.6"
  },
  {
    n: [
      "shamrock"
    ],
    u: "2618-fe0f",
    a: "1.0"
  },
  {
    n: [
      "four leaf clover"
    ],
    u: "1f340",
    a: "0.6"
  },
  {
    n: [
      "maple leaf"
    ],
    u: "1f341",
    a: "0.6"
  },
  {
    n: [
      "fallen leaf"
    ],
    u: "1f342",
    a: "0.6"
  },
  {
    n: [
      "leaves",
      "leaf fluttering in wind"
    ],
    u: "1f343",
    a: "0.6"
  },
  {
    n: [
      "empty nest"
    ],
    u: "1fab9",
    a: "14.0"
  },
  {
    n: [
      "nest with eggs"
    ],
    u: "1faba",
    a: "14.0"
  }
], kE = [
  {
    n: [
      "grapes"
    ],
    u: "1f347",
    a: "0.6"
  },
  {
    n: [
      "melon"
    ],
    u: "1f348",
    a: "0.6"
  },
  {
    n: [
      "watermelon"
    ],
    u: "1f349",
    a: "0.6"
  },
  {
    n: [
      "tangerine"
    ],
    u: "1f34a",
    a: "0.6"
  },
  {
    n: [
      "lemon"
    ],
    u: "1f34b",
    a: "1.0"
  },
  {
    n: [
      "banana"
    ],
    u: "1f34c",
    a: "0.6"
  },
  {
    n: [
      "pineapple"
    ],
    u: "1f34d",
    a: "0.6"
  },
  {
    n: [
      "mango"
    ],
    u: "1f96d",
    a: "11.0"
  },
  {
    n: [
      "apple",
      "red apple"
    ],
    u: "1f34e",
    a: "0.6"
  },
  {
    n: [
      "green apple"
    ],
    u: "1f34f",
    a: "0.6"
  },
  {
    n: [
      "pear"
    ],
    u: "1f350",
    a: "1.0"
  },
  {
    n: [
      "peach"
    ],
    u: "1f351",
    a: "0.6"
  },
  {
    n: [
      "cherries"
    ],
    u: "1f352",
    a: "0.6"
  },
  {
    n: [
      "strawberry"
    ],
    u: "1f353",
    a: "0.6"
  },
  {
    n: [
      "blueberries"
    ],
    u: "1fad0",
    a: "13.0"
  },
  {
    n: [
      "kiwifruit"
    ],
    u: "1f95d",
    a: "3.0"
  },
  {
    n: [
      "tomato"
    ],
    u: "1f345",
    a: "0.6"
  },
  {
    n: [
      "olive"
    ],
    u: "1fad2",
    a: "13.0"
  },
  {
    n: [
      "coconut"
    ],
    u: "1f965",
    a: "5.0"
  },
  {
    n: [
      "avocado"
    ],
    u: "1f951",
    a: "3.0"
  },
  {
    n: [
      "eggplant",
      "aubergine"
    ],
    u: "1f346",
    a: "0.6"
  },
  {
    n: [
      "potato"
    ],
    u: "1f954",
    a: "3.0"
  },
  {
    n: [
      "carrot"
    ],
    u: "1f955",
    a: "3.0"
  },
  {
    n: [
      "corn",
      "ear of maize"
    ],
    u: "1f33d",
    a: "0.6"
  },
  {
    n: [
      "hot pepper"
    ],
    u: "1f336-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bell pepper"
    ],
    u: "1fad1",
    a: "13.0"
  },
  {
    n: [
      "cucumber"
    ],
    u: "1f952",
    a: "3.0"
  },
  {
    n: [
      "leafy green"
    ],
    u: "1f96c",
    a: "11.0"
  },
  {
    n: [
      "broccoli"
    ],
    u: "1f966",
    a: "5.0"
  },
  {
    n: [
      "garlic"
    ],
    u: "1f9c4",
    a: "12.0"
  },
  {
    n: [
      "onion"
    ],
    u: "1f9c5",
    a: "12.0"
  },
  {
    n: [
      "mushroom"
    ],
    u: "1f344",
    a: "0.6"
  },
  {
    n: [
      "peanuts"
    ],
    u: "1f95c",
    a: "3.0"
  },
  {
    n: [
      "beans"
    ],
    u: "1fad8",
    a: "14.0"
  },
  {
    n: [
      "chestnut"
    ],
    u: "1f330",
    a: "0.6"
  },
  {
    n: [
      "bread"
    ],
    u: "1f35e",
    a: "0.6"
  },
  {
    n: [
      "croissant"
    ],
    u: "1f950",
    a: "3.0"
  },
  {
    n: [
      "baguette bread"
    ],
    u: "1f956",
    a: "3.0"
  },
  {
    n: [
      "flatbread"
    ],
    u: "1fad3",
    a: "13.0"
  },
  {
    n: [
      "pretzel"
    ],
    u: "1f968",
    a: "5.0"
  },
  {
    n: [
      "bagel"
    ],
    u: "1f96f",
    a: "11.0"
  },
  {
    n: [
      "pancakes"
    ],
    u: "1f95e",
    a: "3.0"
  },
  {
    n: [
      "waffle"
    ],
    u: "1f9c7",
    a: "12.0"
  },
  {
    n: [
      "cheese wedge"
    ],
    u: "1f9c0",
    a: "1.0"
  },
  {
    n: [
      "meat on bone"
    ],
    u: "1f356",
    a: "0.6"
  },
  {
    n: [
      "poultry leg"
    ],
    u: "1f357",
    a: "0.6"
  },
  {
    n: [
      "cut of meat"
    ],
    u: "1f969",
    a: "5.0"
  },
  {
    n: [
      "bacon"
    ],
    u: "1f953",
    a: "3.0"
  },
  {
    n: [
      "hamburger"
    ],
    u: "1f354",
    a: "0.6"
  },
  {
    n: [
      "fries",
      "french fries"
    ],
    u: "1f35f",
    a: "0.6"
  },
  {
    n: [
      "pizza",
      "slice of pizza"
    ],
    u: "1f355",
    a: "0.6"
  },
  {
    n: [
      "hotdog",
      "hot dog"
    ],
    u: "1f32d",
    a: "1.0"
  },
  {
    n: [
      "sandwich"
    ],
    u: "1f96a",
    a: "5.0"
  },
  {
    n: [
      "taco"
    ],
    u: "1f32e",
    a: "1.0"
  },
  {
    n: [
      "burrito"
    ],
    u: "1f32f",
    a: "1.0"
  },
  {
    n: [
      "tamale"
    ],
    u: "1fad4",
    a: "13.0"
  },
  {
    n: [
      "stuffed flatbread"
    ],
    u: "1f959",
    a: "3.0"
  },
  {
    n: [
      "falafel"
    ],
    u: "1f9c6",
    a: "12.0"
  },
  {
    n: [
      "egg"
    ],
    u: "1f95a",
    a: "3.0"
  },
  {
    n: [
      "cooking",
      "fried egg"
    ],
    u: "1f373",
    a: "0.6"
  },
  {
    n: [
      "shallow pan of food"
    ],
    u: "1f958",
    a: "3.0"
  },
  {
    n: [
      "stew",
      "pot of food"
    ],
    u: "1f372",
    a: "0.6"
  },
  {
    n: [
      "fondue"
    ],
    u: "1fad5",
    a: "13.0"
  },
  {
    n: [
      "bowl with spoon"
    ],
    u: "1f963",
    a: "5.0"
  },
  {
    n: [
      "green salad"
    ],
    u: "1f957",
    a: "3.0"
  },
  {
    n: [
      "popcorn"
    ],
    u: "1f37f",
    a: "1.0"
  },
  {
    n: [
      "butter"
    ],
    u: "1f9c8",
    a: "12.0"
  },
  {
    n: [
      "salt",
      "salt shaker"
    ],
    u: "1f9c2",
    a: "11.0"
  },
  {
    n: [
      "canned food"
    ],
    u: "1f96b",
    a: "5.0"
  },
  {
    n: [
      "bento",
      "bento box"
    ],
    u: "1f371",
    a: "0.6"
  },
  {
    n: [
      "rice cracker"
    ],
    u: "1f358",
    a: "0.6"
  },
  {
    n: [
      "rice ball"
    ],
    u: "1f359",
    a: "0.6"
  },
  {
    n: [
      "rice",
      "cooked rice"
    ],
    u: "1f35a",
    a: "0.6"
  },
  {
    n: [
      "curry",
      "curry and rice"
    ],
    u: "1f35b",
    a: "0.6"
  },
  {
    n: [
      "ramen",
      "steaming bowl"
    ],
    u: "1f35c",
    a: "0.6"
  },
  {
    n: [
      "spaghetti"
    ],
    u: "1f35d",
    a: "0.6"
  },
  {
    n: [
      "sweet potato",
      "roasted sweet potato"
    ],
    u: "1f360",
    a: "0.6"
  },
  {
    n: [
      "oden"
    ],
    u: "1f362",
    a: "0.6"
  },
  {
    n: [
      "sushi"
    ],
    u: "1f363",
    a: "0.6"
  },
  {
    n: [
      "fried shrimp"
    ],
    u: "1f364",
    a: "0.6"
  },
  {
    n: [
      "fish cake",
      "fish cake with swirl design"
    ],
    u: "1f365",
    a: "0.6"
  },
  {
    n: [
      "moon cake"
    ],
    u: "1f96e",
    a: "11.0"
  },
  {
    n: [
      "dango"
    ],
    u: "1f361",
    a: "0.6"
  },
  {
    n: [
      "dumpling"
    ],
    u: "1f95f",
    a: "5.0"
  },
  {
    n: [
      "fortune cookie"
    ],
    u: "1f960",
    a: "5.0"
  },
  {
    n: [
      "takeout box"
    ],
    u: "1f961",
    a: "5.0"
  },
  {
    n: [
      "crab"
    ],
    u: "1f980",
    a: "1.0"
  },
  {
    n: [
      "lobster"
    ],
    u: "1f99e",
    a: "11.0"
  },
  {
    n: [
      "shrimp"
    ],
    u: "1f990",
    a: "3.0"
  },
  {
    n: [
      "squid"
    ],
    u: "1f991",
    a: "3.0"
  },
  {
    n: [
      "oyster"
    ],
    u: "1f9aa",
    a: "12.0"
  },
  {
    n: [
      "icecream",
      "soft ice cream"
    ],
    u: "1f366",
    a: "0.6"
  },
  {
    n: [
      "shaved ice"
    ],
    u: "1f367",
    a: "0.6"
  },
  {
    n: [
      "ice cream"
    ],
    u: "1f368",
    a: "0.6"
  },
  {
    n: [
      "doughnut"
    ],
    u: "1f369",
    a: "0.6"
  },
  {
    n: [
      "cookie"
    ],
    u: "1f36a",
    a: "0.6"
  },
  {
    n: [
      "birthday",
      "birthday cake"
    ],
    u: "1f382",
    a: "0.6"
  },
  {
    n: [
      "cake",
      "shortcake"
    ],
    u: "1f370",
    a: "0.6"
  },
  {
    n: [
      "cupcake"
    ],
    u: "1f9c1",
    a: "11.0"
  },
  {
    n: [
      "pie"
    ],
    u: "1f967",
    a: "5.0"
  },
  {
    n: [
      "chocolate bar"
    ],
    u: "1f36b",
    a: "0.6"
  },
  {
    n: [
      "candy"
    ],
    u: "1f36c",
    a: "0.6"
  },
  {
    n: [
      "lollipop"
    ],
    u: "1f36d",
    a: "0.6"
  },
  {
    n: [
      "custard"
    ],
    u: "1f36e",
    a: "0.6"
  },
  {
    n: [
      "honey pot"
    ],
    u: "1f36f",
    a: "0.6"
  },
  {
    n: [
      "baby bottle"
    ],
    u: "1f37c",
    a: "1.0"
  },
  {
    n: [
      "glass of milk"
    ],
    u: "1f95b",
    a: "3.0"
  },
  {
    n: [
      "coffee",
      "hot beverage"
    ],
    u: "2615",
    a: "0.6"
  },
  {
    n: [
      "teapot"
    ],
    u: "1fad6",
    a: "13.0"
  },
  {
    n: [
      "tea",
      "teacup without handle"
    ],
    u: "1f375",
    a: "0.6"
  },
  {
    n: [
      "sake",
      "sake bottle and cup"
    ],
    u: "1f376",
    a: "0.6"
  },
  {
    n: [
      "champagne",
      "bottle with popping cork"
    ],
    u: "1f37e",
    a: "1.0"
  },
  {
    n: [
      "wine glass"
    ],
    u: "1f377",
    a: "0.6"
  },
  {
    n: [
      "cocktail",
      "cocktail glass"
    ],
    u: "1f378",
    a: "0.6"
  },
  {
    n: [
      "tropical drink"
    ],
    u: "1f379",
    a: "0.6"
  },
  {
    n: [
      "beer",
      "beer mug"
    ],
    u: "1f37a",
    a: "0.6"
  },
  {
    n: [
      "beers",
      "clinking beer mugs"
    ],
    u: "1f37b",
    a: "0.6"
  },
  {
    n: [
      "clinking glasses"
    ],
    u: "1f942",
    a: "3.0"
  },
  {
    n: [
      "tumbler glass"
    ],
    u: "1f943",
    a: "3.0"
  },
  {
    n: [
      "pouring liquid"
    ],
    u: "1fad7",
    a: "14.0"
  },
  {
    n: [
      "cup with straw"
    ],
    u: "1f964",
    a: "5.0"
  },
  {
    n: [
      "bubble tea"
    ],
    u: "1f9cb",
    a: "13.0"
  },
  {
    n: [
      "beverage box"
    ],
    u: "1f9c3",
    a: "12.0"
  },
  {
    n: [
      "mate drink"
    ],
    u: "1f9c9",
    a: "12.0"
  },
  {
    n: [
      "ice cube"
    ],
    u: "1f9ca",
    a: "12.0"
  },
  {
    n: [
      "chopsticks"
    ],
    u: "1f962",
    a: "5.0"
  },
  {
    n: [
      "knife fork plate",
      "fork and knife with plate"
    ],
    u: "1f37d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fork and knife"
    ],
    u: "1f374",
    a: "0.6"
  },
  {
    n: [
      "spoon"
    ],
    u: "1f944",
    a: "3.0"
  },
  {
    n: [
      "hocho",
      "knife"
    ],
    u: "1f52a",
    a: "0.6"
  },
  {
    n: [
      "jar"
    ],
    u: "1fad9",
    a: "14.0"
  },
  {
    n: [
      "amphora"
    ],
    u: "1f3fa",
    a: "1.0"
  }
], BE = [
  {
    n: [
      "earth africa",
      "earth globe europe-africa"
    ],
    u: "1f30d",
    a: "0.7"
  },
  {
    n: [
      "earth americas",
      "earth globe americas"
    ],
    u: "1f30e",
    a: "0.7"
  },
  {
    n: [
      "earth asia",
      "earth globe asia-australia"
    ],
    u: "1f30f",
    a: "0.6"
  },
  {
    n: [
      "globe with meridians"
    ],
    u: "1f310",
    a: "1.0"
  },
  {
    n: [
      "world map"
    ],
    u: "1f5fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "japan",
      "silhouette of japan"
    ],
    u: "1f5fe",
    a: "0.6"
  },
  {
    n: [
      "compass"
    ],
    u: "1f9ed",
    a: "11.0"
  },
  {
    n: [
      "snow-capped mountain",
      "snow capped mountain"
    ],
    u: "1f3d4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mountain"
    ],
    u: "26f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "volcano"
    ],
    u: "1f30b",
    a: "0.6"
  },
  {
    n: [
      "mount fuji"
    ],
    u: "1f5fb",
    a: "0.6"
  },
  {
    n: [
      "camping"
    ],
    u: "1f3d5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "beach with umbrella"
    ],
    u: "1f3d6-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert"
    ],
    u: "1f3dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "desert island"
    ],
    u: "1f3dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "national park"
    ],
    u: "1f3de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stadium"
    ],
    u: "1f3df-fe0f",
    a: "0.7"
  },
  {
    n: [
      "classical building"
    ],
    u: "1f3db-fe0f",
    a: "0.7"
  },
  {
    n: [
      "building construction"
    ],
    u: "1f3d7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "brick",
      "bricks"
    ],
    u: "1f9f1",
    a: "11.0"
  },
  {
    n: [
      "rock"
    ],
    u: "1faa8",
    a: "13.0"
  },
  {
    n: [
      "wood"
    ],
    u: "1fab5",
    a: "13.0"
  },
  {
    n: [
      "hut"
    ],
    u: "1f6d6",
    a: "13.0"
  },
  {
    n: [
      "houses",
      "house buildings"
    ],
    u: "1f3d8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "derelict house",
      "derelict house building"
    ],
    u: "1f3da-fe0f",
    a: "0.7"
  },
  {
    n: [
      "house",
      "house building"
    ],
    u: "1f3e0",
    a: "0.6"
  },
  {
    n: [
      "house with garden"
    ],
    u: "1f3e1",
    a: "0.6"
  },
  {
    n: [
      "office",
      "office building"
    ],
    u: "1f3e2",
    a: "0.6"
  },
  {
    n: [
      "post office",
      "japanese post office"
    ],
    u: "1f3e3",
    a: "0.6"
  },
  {
    n: [
      "european post office"
    ],
    u: "1f3e4",
    a: "1.0"
  },
  {
    n: [
      "hospital"
    ],
    u: "1f3e5",
    a: "0.6"
  },
  {
    n: [
      "bank"
    ],
    u: "1f3e6",
    a: "0.6"
  },
  {
    n: [
      "hotel"
    ],
    u: "1f3e8",
    a: "0.6"
  },
  {
    n: [
      "love hotel"
    ],
    u: "1f3e9",
    a: "0.6"
  },
  {
    n: [
      "convenience store"
    ],
    u: "1f3ea",
    a: "0.6"
  },
  {
    n: [
      "school"
    ],
    u: "1f3eb",
    a: "0.6"
  },
  {
    n: [
      "department store"
    ],
    u: "1f3ec",
    a: "0.6"
  },
  {
    n: [
      "factory"
    ],
    u: "1f3ed",
    a: "0.6"
  },
  {
    n: [
      "japanese castle"
    ],
    u: "1f3ef",
    a: "0.6"
  },
  {
    n: [
      "european castle"
    ],
    u: "1f3f0",
    a: "0.6"
  },
  {
    n: [
      "wedding"
    ],
    u: "1f492",
    a: "0.6"
  },
  {
    n: [
      "tokyo tower"
    ],
    u: "1f5fc",
    a: "0.6"
  },
  {
    n: [
      "statue of liberty"
    ],
    u: "1f5fd",
    a: "0.6"
  },
  {
    n: [
      "church"
    ],
    u: "26ea",
    a: "0.6"
  },
  {
    n: [
      "mosque"
    ],
    u: "1f54c",
    a: "1.0"
  },
  {
    n: [
      "hindu temple"
    ],
    u: "1f6d5",
    a: "12.0"
  },
  {
    n: [
      "synagogue"
    ],
    u: "1f54d",
    a: "1.0"
  },
  {
    n: [
      "shinto shrine"
    ],
    u: "26e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "kaaba"
    ],
    u: "1f54b",
    a: "1.0"
  },
  {
    n: [
      "fountain"
    ],
    u: "26f2",
    a: "0.6"
  },
  {
    n: [
      "tent"
    ],
    u: "26fa",
    a: "0.6"
  },
  {
    n: [
      "foggy"
    ],
    u: "1f301",
    a: "0.6"
  },
  {
    n: [
      "night with stars"
    ],
    u: "1f303",
    a: "0.6"
  },
  {
    n: [
      "cityscape"
    ],
    u: "1f3d9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunrise over mountains"
    ],
    u: "1f304",
    a: "0.6"
  },
  {
    n: [
      "sunrise"
    ],
    u: "1f305",
    a: "0.6"
  },
  {
    n: [
      "city sunset",
      "cityscape at dusk"
    ],
    u: "1f306",
    a: "0.6"
  },
  {
    n: [
      "city sunrise",
      "sunset over buildings"
    ],
    u: "1f307",
    a: "0.6"
  },
  {
    n: [
      "bridge at night"
    ],
    u: "1f309",
    a: "0.6"
  },
  {
    n: [
      "hotsprings",
      "hot springs"
    ],
    u: "2668-fe0f",
    a: "0.6"
  },
  {
    n: [
      "carousel horse"
    ],
    u: "1f3a0",
    a: "0.6"
  },
  {
    n: [
      "playground slide"
    ],
    u: "1f6dd",
    a: "14.0"
  },
  {
    n: [
      "ferris wheel"
    ],
    u: "1f3a1",
    a: "0.6"
  },
  {
    n: [
      "roller coaster"
    ],
    u: "1f3a2",
    a: "0.6"
  },
  {
    n: [
      "barber",
      "barber pole"
    ],
    u: "1f488",
    a: "0.6"
  },
  {
    n: [
      "circus tent"
    ],
    u: "1f3aa",
    a: "0.6"
  },
  {
    n: [
      "steam locomotive"
    ],
    u: "1f682",
    a: "1.0"
  },
  {
    n: [
      "railway car"
    ],
    u: "1f683",
    a: "0.6"
  },
  {
    n: [
      "high-speed train",
      "bullettrain side"
    ],
    u: "1f684",
    a: "0.6"
  },
  {
    n: [
      "bullettrain front",
      "high-speed train with bullet nose"
    ],
    u: "1f685",
    a: "0.6"
  },
  {
    n: [
      "train",
      "train2"
    ],
    u: "1f686",
    a: "1.0"
  },
  {
    n: [
      "metro"
    ],
    u: "1f687",
    a: "0.6"
  },
  {
    n: [
      "light rail"
    ],
    u: "1f688",
    a: "1.0"
  },
  {
    n: [
      "station"
    ],
    u: "1f689",
    a: "0.6"
  },
  {
    n: [
      "tram"
    ],
    u: "1f68a",
    a: "1.0"
  },
  {
    n: [
      "monorail"
    ],
    u: "1f69d",
    a: "1.0"
  },
  {
    n: [
      "mountain railway"
    ],
    u: "1f69e",
    a: "1.0"
  },
  {
    n: [
      "train",
      "tram car"
    ],
    u: "1f68b",
    a: "1.0"
  },
  {
    n: [
      "bus"
    ],
    u: "1f68c",
    a: "0.6"
  },
  {
    n: [
      "oncoming bus"
    ],
    u: "1f68d",
    a: "0.7"
  },
  {
    n: [
      "trolleybus"
    ],
    u: "1f68e",
    a: "1.0"
  },
  {
    n: [
      "minibus"
    ],
    u: "1f690",
    a: "1.0"
  },
  {
    n: [
      "ambulance"
    ],
    u: "1f691",
    a: "0.6"
  },
  {
    n: [
      "fire engine"
    ],
    u: "1f692",
    a: "0.6"
  },
  {
    n: [
      "police car"
    ],
    u: "1f693",
    a: "0.6"
  },
  {
    n: [
      "oncoming police car"
    ],
    u: "1f694",
    a: "0.7"
  },
  {
    n: [
      "taxi"
    ],
    u: "1f695",
    a: "0.6"
  },
  {
    n: [
      "oncoming taxi"
    ],
    u: "1f696",
    a: "1.0"
  },
  {
    n: [
      "car",
      "red car",
      "automobile"
    ],
    u: "1f697",
    a: "0.6"
  },
  {
    n: [
      "oncoming automobile"
    ],
    u: "1f698",
    a: "0.7"
  },
  {
    n: [
      "blue car",
      "recreational vehicle"
    ],
    u: "1f699",
    a: "0.6"
  },
  {
    n: [
      "pickup truck"
    ],
    u: "1f6fb",
    a: "13.0"
  },
  {
    n: [
      "truck",
      "delivery truck"
    ],
    u: "1f69a",
    a: "0.6"
  },
  {
    n: [
      "articulated lorry"
    ],
    u: "1f69b",
    a: "1.0"
  },
  {
    n: [
      "tractor"
    ],
    u: "1f69c",
    a: "1.0"
  },
  {
    n: [
      "racing car"
    ],
    u: "1f3ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motorcycle",
      "racing motorcycle"
    ],
    u: "1f3cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor scooter"
    ],
    u: "1f6f5",
    a: "3.0"
  },
  {
    n: [
      "manual wheelchair"
    ],
    u: "1f9bd",
    a: "12.0"
  },
  {
    n: [
      "motorized wheelchair"
    ],
    u: "1f9bc",
    a: "12.0"
  },
  {
    n: [
      "auto rickshaw"
    ],
    u: "1f6fa",
    a: "12.0"
  },
  {
    n: [
      "bike",
      "bicycle"
    ],
    u: "1f6b2",
    a: "0.6"
  },
  {
    n: [
      "scooter"
    ],
    u: "1f6f4",
    a: "3.0"
  },
  {
    n: [
      "skateboard"
    ],
    u: "1f6f9",
    a: "11.0"
  },
  {
    n: [
      "roller skate"
    ],
    u: "1f6fc",
    a: "13.0"
  },
  {
    n: [
      "busstop",
      "bus stop"
    ],
    u: "1f68f",
    a: "0.6"
  },
  {
    n: [
      "motorway"
    ],
    u: "1f6e3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "railway track"
    ],
    u: "1f6e4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "oil drum"
    ],
    u: "1f6e2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fuelpump",
      "fuel pump"
    ],
    u: "26fd",
    a: "0.6"
  },
  {
    n: [
      "wheel"
    ],
    u: "1f6de",
    a: "14.0"
  },
  {
    n: [
      "rotating light",
      "police cars revolving light"
    ],
    u: "1f6a8",
    a: "0.6"
  },
  {
    n: [
      "traffic light",
      "horizontal traffic light"
    ],
    u: "1f6a5",
    a: "0.6"
  },
  {
    n: [
      "vertical traffic light"
    ],
    u: "1f6a6",
    a: "1.0"
  },
  {
    n: [
      "octagonal sign"
    ],
    u: "1f6d1",
    a: "3.0"
  },
  {
    n: [
      "construction",
      "construction sign"
    ],
    u: "1f6a7",
    a: "0.6"
  },
  {
    n: [
      "anchor"
    ],
    u: "2693",
    a: "0.6"
  },
  {
    n: [
      "ring buoy"
    ],
    u: "1f6df",
    a: "14.0"
  },
  {
    n: [
      "boat",
      "sailboat"
    ],
    u: "26f5",
    a: "0.6"
  },
  {
    n: [
      "canoe"
    ],
    u: "1f6f6",
    a: "3.0"
  },
  {
    n: [
      "speedboat"
    ],
    u: "1f6a4",
    a: "0.6"
  },
  {
    n: [
      "passenger ship"
    ],
    u: "1f6f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ferry"
    ],
    u: "26f4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "motor boat"
    ],
    u: "1f6e5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ship"
    ],
    u: "1f6a2",
    a: "0.6"
  },
  {
    n: [
      "airplane"
    ],
    u: "2708-fe0f",
    a: "0.6"
  },
  {
    n: [
      "small airplane"
    ],
    u: "1f6e9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "airplane departure"
    ],
    u: "1f6eb",
    a: "1.0"
  },
  {
    n: [
      "airplane arriving"
    ],
    u: "1f6ec",
    a: "1.0"
  },
  {
    n: [
      "parachute"
    ],
    u: "1fa82",
    a: "12.0"
  },
  {
    n: [
      "seat"
    ],
    u: "1f4ba",
    a: "0.6"
  },
  {
    n: [
      "helicopter"
    ],
    u: "1f681",
    a: "1.0"
  },
  {
    n: [
      "suspension railway"
    ],
    u: "1f69f",
    a: "1.0"
  },
  {
    n: [
      "mountain cableway"
    ],
    u: "1f6a0",
    a: "1.0"
  },
  {
    n: [
      "aerial tramway"
    ],
    u: "1f6a1",
    a: "1.0"
  },
  {
    n: [
      "satellite"
    ],
    u: "1f6f0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rocket"
    ],
    u: "1f680",
    a: "0.6"
  },
  {
    n: [
      "flying saucer"
    ],
    u: "1f6f8",
    a: "5.0"
  },
  {
    n: [
      "bellhop bell"
    ],
    u: "1f6ce-fe0f",
    a: "0.7"
  },
  {
    n: [
      "luggage"
    ],
    u: "1f9f3",
    a: "11.0"
  },
  {
    n: [
      "hourglass"
    ],
    u: "231b",
    a: "0.6"
  },
  {
    n: [
      "hourglass flowing sand",
      "hourglass with flowing sand"
    ],
    u: "23f3",
    a: "0.6"
  },
  {
    n: [
      "watch"
    ],
    u: "231a",
    a: "0.6"
  },
  {
    n: [
      "alarm clock"
    ],
    u: "23f0",
    a: "0.6"
  },
  {
    n: [
      "stopwatch"
    ],
    u: "23f1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "timer clock"
    ],
    u: "23f2-fe0f",
    a: "1.0"
  },
  {
    n: [
      "mantelpiece clock"
    ],
    u: "1f570-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clock12",
      "clock face twelve oclock"
    ],
    u: "1f55b",
    a: "0.6"
  },
  {
    n: [
      "clock1230",
      "clock face twelve-thirty"
    ],
    u: "1f567",
    a: "0.7"
  },
  {
    n: [
      "clock1",
      "clock face one oclock"
    ],
    u: "1f550",
    a: "0.6"
  },
  {
    n: [
      "clock130",
      "clock face one-thirty"
    ],
    u: "1f55c",
    a: "0.7"
  },
  {
    n: [
      "clock2",
      "clock face two oclock"
    ],
    u: "1f551",
    a: "0.6"
  },
  {
    n: [
      "clock230",
      "clock face two-thirty"
    ],
    u: "1f55d",
    a: "0.7"
  },
  {
    n: [
      "clock3",
      "clock face three oclock"
    ],
    u: "1f552",
    a: "0.6"
  },
  {
    n: [
      "clock330",
      "clock face three-thirty"
    ],
    u: "1f55e",
    a: "0.7"
  },
  {
    n: [
      "clock4",
      "clock face four oclock"
    ],
    u: "1f553",
    a: "0.6"
  },
  {
    n: [
      "clock430",
      "clock face four-thirty"
    ],
    u: "1f55f",
    a: "0.7"
  },
  {
    n: [
      "clock5",
      "clock face five oclock"
    ],
    u: "1f554",
    a: "0.6"
  },
  {
    n: [
      "clock530",
      "clock face five-thirty"
    ],
    u: "1f560",
    a: "0.7"
  },
  {
    n: [
      "clock6",
      "clock face six oclock"
    ],
    u: "1f555",
    a: "0.6"
  },
  {
    n: [
      "clock630",
      "clock face six-thirty"
    ],
    u: "1f561",
    a: "0.7"
  },
  {
    n: [
      "clock7",
      "clock face seven oclock"
    ],
    u: "1f556",
    a: "0.6"
  },
  {
    n: [
      "clock730",
      "clock face seven-thirty"
    ],
    u: "1f562",
    a: "0.7"
  },
  {
    n: [
      "clock8",
      "clock face eight oclock"
    ],
    u: "1f557",
    a: "0.6"
  },
  {
    n: [
      "clock830",
      "clock face eight-thirty"
    ],
    u: "1f563",
    a: "0.7"
  },
  {
    n: [
      "clock9",
      "clock face nine oclock"
    ],
    u: "1f558",
    a: "0.6"
  },
  {
    n: [
      "clock930",
      "clock face nine-thirty"
    ],
    u: "1f564",
    a: "0.7"
  },
  {
    n: [
      "clock10",
      "clock face ten oclock"
    ],
    u: "1f559",
    a: "0.6"
  },
  {
    n: [
      "clock1030",
      "clock face ten-thirty"
    ],
    u: "1f565",
    a: "0.7"
  },
  {
    n: [
      "clock11",
      "clock face eleven oclock"
    ],
    u: "1f55a",
    a: "0.6"
  },
  {
    n: [
      "clock1130",
      "clock face eleven-thirty"
    ],
    u: "1f566",
    a: "0.7"
  },
  {
    n: [
      "new moon",
      "new moon symbol"
    ],
    u: "1f311",
    a: "0.6"
  },
  {
    n: [
      "waxing crescent moon",
      "waxing crescent moon symbol"
    ],
    u: "1f312",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon",
      "first quarter moon symbol"
    ],
    u: "1f313",
    a: "0.6"
  },
  {
    n: [
      "moon",
      "waxing gibbous moon",
      "waxing gibbous moon symbol"
    ],
    u: "1f314",
    a: "0.6"
  },
  {
    n: [
      "full moon",
      "full moon symbol"
    ],
    u: "1f315",
    a: "0.6"
  },
  {
    n: [
      "waning gibbous moon",
      "waning gibbous moon symbol"
    ],
    u: "1f316",
    a: "1.0"
  },
  {
    n: [
      "last quarter moon",
      "last quarter moon symbol"
    ],
    u: "1f317",
    a: "1.0"
  },
  {
    n: [
      "waning crescent moon",
      "waning crescent moon symbol"
    ],
    u: "1f318",
    a: "1.0"
  },
  {
    n: [
      "crescent moon"
    ],
    u: "1f319",
    a: "0.6"
  },
  {
    n: [
      "new moon with face"
    ],
    u: "1f31a",
    a: "1.0"
  },
  {
    n: [
      "first quarter moon with face"
    ],
    u: "1f31b",
    a: "0.6"
  },
  {
    n: [
      "last quarter moon with face"
    ],
    u: "1f31c",
    a: "0.7"
  },
  {
    n: [
      "thermometer"
    ],
    u: "1f321-fe0f",
    a: "0.7"
  },
  {
    n: [
      "sunny",
      "black sun with rays"
    ],
    u: "2600-fe0f",
    a: "0.6"
  },
  {
    n: [
      "full moon with face"
    ],
    u: "1f31d",
    a: "1.0"
  },
  {
    n: [
      "sun with face"
    ],
    u: "1f31e",
    a: "1.0"
  },
  {
    n: [
      "ringed planet"
    ],
    u: "1fa90",
    a: "12.0"
  },
  {
    n: [
      "star",
      "white medium star"
    ],
    u: "2b50",
    a: "0.6"
  },
  {
    n: [
      "star2",
      "glowing star"
    ],
    u: "1f31f",
    a: "0.6"
  },
  {
    n: [
      "stars",
      "shooting star"
    ],
    u: "1f320",
    a: "0.6"
  },
  {
    n: [
      "milky way"
    ],
    u: "1f30c",
    a: "0.6"
  },
  {
    n: [
      "cloud"
    ],
    u: "2601-fe0f",
    a: "0.6"
  },
  {
    n: [
      "partly sunny",
      "sun behind cloud"
    ],
    u: "26c5",
    a: "0.6"
  },
  {
    n: [
      "thunder cloud and rain",
      "cloud with lightning and rain"
    ],
    u: "26c8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "mostly sunny",
      "sun small cloud",
      "sun behind small cloud"
    ],
    u: "1f324-fe0f",
    a: "0.7"
  },
  {
    n: [
      "barely sunny",
      "sun behind cloud",
      "sun behind large cloud"
    ],
    u: "1f325-fe0f",
    a: "0.7"
  },
  {
    n: [
      "partly sunny rain",
      "sun behind rain cloud"
    ],
    u: "1f326-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rain cloud",
      "cloud with rain"
    ],
    u: "1f327-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snow cloud",
      "cloud with snow"
    ],
    u: "1f328-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lightning",
      "lightning cloud",
      "cloud with lightning"
    ],
    u: "1f329-fe0f",
    a: "0.7"
  },
  {
    n: [
      "tornado",
      "tornado cloud"
    ],
    u: "1f32a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fog"
    ],
    u: "1f32b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wind face",
      "wind blowing face"
    ],
    u: "1f32c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "cyclone"
    ],
    u: "1f300",
    a: "0.6"
  },
  {
    n: [
      "rainbow"
    ],
    u: "1f308",
    a: "0.6"
  },
  {
    n: [
      "closed umbrella"
    ],
    u: "1f302",
    a: "0.6"
  },
  {
    n: [
      "umbrella"
    ],
    u: "2602-fe0f",
    a: "0.7"
  },
  {
    n: [
      "umbrella with rain drops"
    ],
    u: "2614",
    a: "0.6"
  },
  {
    n: [
      "umbrella on ground"
    ],
    u: "26f1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "zap",
      "high voltage sign"
    ],
    u: "26a1",
    a: "0.6"
  },
  {
    n: [
      "snowflake"
    ],
    u: "2744-fe0f",
    a: "0.6"
  },
  {
    n: [
      "snowman"
    ],
    u: "2603-fe0f",
    a: "0.7"
  },
  {
    n: [
      "snowman without snow"
    ],
    u: "26c4",
    a: "0.6"
  },
  {
    n: [
      "comet"
    ],
    u: "2604-fe0f",
    a: "1.0"
  },
  {
    n: [
      "fire"
    ],
    u: "1f525",
    a: "0.6"
  },
  {
    n: [
      "droplet"
    ],
    u: "1f4a7",
    a: "0.6"
  },
  {
    n: [
      "ocean",
      "water wave"
    ],
    u: "1f30a",
    a: "0.6"
  }
], OE = [
  {
    n: [
      "jack-o-lantern",
      "jack o lantern"
    ],
    u: "1f383",
    a: "0.6"
  },
  {
    n: [
      "christmas tree"
    ],
    u: "1f384",
    a: "0.6"
  },
  {
    n: [
      "fireworks"
    ],
    u: "1f386",
    a: "0.6"
  },
  {
    n: [
      "sparkler",
      "firework sparkler"
    ],
    u: "1f387",
    a: "0.6"
  },
  {
    n: [
      "firecracker"
    ],
    u: "1f9e8",
    a: "11.0"
  },
  {
    n: [
      "sparkles"
    ],
    u: "2728",
    a: "0.6"
  },
  {
    n: [
      "balloon"
    ],
    u: "1f388",
    a: "0.6"
  },
  {
    n: [
      "tada",
      "party popper"
    ],
    u: "1f389",
    a: "0.6"
  },
  {
    n: [
      "confetti ball"
    ],
    u: "1f38a",
    a: "0.6"
  },
  {
    n: [
      "tanabata tree"
    ],
    u: "1f38b",
    a: "0.6"
  },
  {
    n: [
      "bamboo",
      "pine decoration"
    ],
    u: "1f38d",
    a: "0.6"
  },
  {
    n: [
      "dolls",
      "japanese dolls"
    ],
    u: "1f38e",
    a: "0.6"
  },
  {
    n: [
      "flags",
      "carp streamer"
    ],
    u: "1f38f",
    a: "0.6"
  },
  {
    n: [
      "wind chime"
    ],
    u: "1f390",
    a: "0.6"
  },
  {
    n: [
      "rice scene",
      "moon viewing ceremony"
    ],
    u: "1f391",
    a: "0.6"
  },
  {
    n: [
      "red envelope",
      "red gift envelope"
    ],
    u: "1f9e7",
    a: "11.0"
  },
  {
    n: [
      "ribbon"
    ],
    u: "1f380",
    a: "0.6"
  },
  {
    n: [
      "gift",
      "wrapped present"
    ],
    u: "1f381",
    a: "0.6"
  },
  {
    n: [
      "reminder ribbon"
    ],
    u: "1f397-fe0f",
    a: "0.7"
  },
  {
    n: [
      "admission tickets"
    ],
    u: "1f39f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "ticket"
    ],
    u: "1f3ab",
    a: "0.6"
  },
  {
    n: [
      "medal",
      "military medal"
    ],
    u: "1f396-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trophy"
    ],
    u: "1f3c6",
    a: "0.6"
  },
  {
    n: [
      "sports medal"
    ],
    u: "1f3c5",
    a: "1.0"
  },
  {
    n: [
      "first place medal"
    ],
    u: "1f947",
    a: "3.0"
  },
  {
    n: [
      "second place medal"
    ],
    u: "1f948",
    a: "3.0"
  },
  {
    n: [
      "third place medal"
    ],
    u: "1f949",
    a: "3.0"
  },
  {
    n: [
      "soccer",
      "soccer ball"
    ],
    u: "26bd",
    a: "0.6"
  },
  {
    n: [
      "baseball"
    ],
    u: "26be",
    a: "0.6"
  },
  {
    n: [
      "softball"
    ],
    u: "1f94e",
    a: "11.0"
  },
  {
    n: [
      "basketball",
      "basketball and hoop"
    ],
    u: "1f3c0",
    a: "0.6"
  },
  {
    n: [
      "volleyball"
    ],
    u: "1f3d0",
    a: "1.0"
  },
  {
    n: [
      "football",
      "american football"
    ],
    u: "1f3c8",
    a: "0.6"
  },
  {
    n: [
      "rugby football"
    ],
    u: "1f3c9",
    a: "1.0"
  },
  {
    n: [
      "tennis",
      "tennis racquet and ball"
    ],
    u: "1f3be",
    a: "0.6"
  },
  {
    n: [
      "flying disc"
    ],
    u: "1f94f",
    a: "11.0"
  },
  {
    n: [
      "bowling"
    ],
    u: "1f3b3",
    a: "0.6"
  },
  {
    n: [
      "cricket bat and ball"
    ],
    u: "1f3cf",
    a: "1.0"
  },
  {
    n: [
      "field hockey stick and ball"
    ],
    u: "1f3d1",
    a: "1.0"
  },
  {
    n: [
      "ice hockey stick and puck"
    ],
    u: "1f3d2",
    a: "1.0"
  },
  {
    n: [
      "lacrosse",
      "lacrosse stick and ball"
    ],
    u: "1f94d",
    a: "11.0"
  },
  {
    n: [
      "table tennis paddle and ball"
    ],
    u: "1f3d3",
    a: "1.0"
  },
  {
    n: [
      "badminton racquet and shuttlecock"
    ],
    u: "1f3f8",
    a: "1.0"
  },
  {
    n: [
      "boxing glove"
    ],
    u: "1f94a",
    a: "3.0"
  },
  {
    n: [
      "martial arts uniform"
    ],
    u: "1f94b",
    a: "3.0"
  },
  {
    n: [
      "goal net"
    ],
    u: "1f945",
    a: "3.0"
  },
  {
    n: [
      "golf",
      "flag in hole"
    ],
    u: "26f3",
    a: "0.6"
  },
  {
    n: [
      "ice skate"
    ],
    u: "26f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "fishing pole and fish"
    ],
    u: "1f3a3",
    a: "0.6"
  },
  {
    n: [
      "diving mask"
    ],
    u: "1f93f",
    a: "12.0"
  },
  {
    n: [
      "running shirt with sash"
    ],
    u: "1f3bd",
    a: "0.6"
  },
  {
    n: [
      "ski",
      "ski and ski boot"
    ],
    u: "1f3bf",
    a: "0.6"
  },
  {
    n: [
      "sled"
    ],
    u: "1f6f7",
    a: "5.0"
  },
  {
    n: [
      "curling stone"
    ],
    u: "1f94c",
    a: "5.0"
  },
  {
    n: [
      "dart",
      "direct hit"
    ],
    u: "1f3af",
    a: "0.6"
  },
  {
    n: [
      "yo-yo"
    ],
    u: "1fa80",
    a: "12.0"
  },
  {
    n: [
      "kite"
    ],
    u: "1fa81",
    a: "12.0"
  },
  {
    n: [
      "8ball",
      "billiards"
    ],
    u: "1f3b1",
    a: "0.6"
  },
  {
    n: [
      "crystal ball"
    ],
    u: "1f52e",
    a: "0.6"
  },
  {
    n: [
      "magic wand"
    ],
    u: "1fa84",
    a: "13.0"
  },
  {
    n: [
      "nazar amulet"
    ],
    u: "1f9ff",
    a: "11.0"
  },
  {
    n: [
      "hamsa"
    ],
    u: "1faac",
    a: "14.0"
  },
  {
    n: [
      "video game"
    ],
    u: "1f3ae",
    a: "0.6"
  },
  {
    n: [
      "joystick"
    ],
    u: "1f579-fe0f",
    a: "0.7"
  },
  {
    n: [
      "slot machine"
    ],
    u: "1f3b0",
    a: "0.6"
  },
  {
    n: [
      "game die"
    ],
    u: "1f3b2",
    a: "0.6"
  },
  {
    n: [
      "jigsaw",
      "jigsaw puzzle piece"
    ],
    u: "1f9e9",
    a: "11.0"
  },
  {
    n: [
      "teddy bear"
    ],
    u: "1f9f8",
    a: "11.0"
  },
  {
    n: [
      "pinata"
    ],
    u: "1fa85",
    a: "13.0"
  },
  {
    n: [
      "mirror ball"
    ],
    u: "1faa9",
    a: "14.0"
  },
  {
    n: [
      "nesting dolls"
    ],
    u: "1fa86",
    a: "13.0"
  },
  {
    n: [
      "spades",
      "black spade suit"
    ],
    u: "2660-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hearts",
      "black heart suit"
    ],
    u: "2665-fe0f",
    a: "0.6"
  },
  {
    n: [
      "diamonds",
      "black diamond suit"
    ],
    u: "2666-fe0f",
    a: "0.6"
  },
  {
    n: [
      "clubs",
      "black club suit"
    ],
    u: "2663-fe0f",
    a: "0.6"
  },
  {
    n: [
      "chess pawn"
    ],
    u: "265f-fe0f",
    a: "11.0"
  },
  {
    n: [
      "black joker",
      "playing card black joker"
    ],
    u: "1f0cf",
    a: "0.6"
  },
  {
    n: [
      "mahjong",
      "mahjong tile red dragon"
    ],
    u: "1f004",
    a: "0.6"
  },
  {
    n: [
      "flower playing cards"
    ],
    u: "1f3b4",
    a: "0.6"
  },
  {
    n: [
      "performing arts"
    ],
    u: "1f3ad",
    a: "0.6"
  },
  {
    n: [
      "framed picture",
      "frame with picture"
    ],
    u: "1f5bc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "art",
      "artist palette"
    ],
    u: "1f3a8",
    a: "0.6"
  },
  {
    n: [
      "thread",
      "spool of thread"
    ],
    u: "1f9f5",
    a: "11.0"
  },
  {
    n: [
      "sewing needle"
    ],
    u: "1faa1",
    a: "13.0"
  },
  {
    n: [
      "yarn",
      "ball of yarn"
    ],
    u: "1f9f6",
    a: "11.0"
  },
  {
    n: [
      "knot"
    ],
    u: "1faa2",
    a: "13.0"
  }
], PE = [
  {
    n: [
      "eyeglasses"
    ],
    u: "1f453",
    a: "0.6"
  },
  {
    n: [
      "sunglasses",
      "dark sunglasses"
    ],
    u: "1f576-fe0f",
    a: "0.7"
  },
  {
    n: [
      "goggles"
    ],
    u: "1f97d",
    a: "11.0"
  },
  {
    n: [
      "lab coat"
    ],
    u: "1f97c",
    a: "11.0"
  },
  {
    n: [
      "safety vest"
    ],
    u: "1f9ba",
    a: "12.0"
  },
  {
    n: [
      "necktie"
    ],
    u: "1f454",
    a: "0.6"
  },
  {
    n: [
      "shirt",
      "tshirt",
      "t-shirt"
    ],
    u: "1f455",
    a: "0.6"
  },
  {
    n: [
      "jeans"
    ],
    u: "1f456",
    a: "0.6"
  },
  {
    n: [
      "scarf"
    ],
    u: "1f9e3",
    a: "5.0"
  },
  {
    n: [
      "gloves"
    ],
    u: "1f9e4",
    a: "5.0"
  },
  {
    n: [
      "coat"
    ],
    u: "1f9e5",
    a: "5.0"
  },
  {
    n: [
      "socks"
    ],
    u: "1f9e6",
    a: "5.0"
  },
  {
    n: [
      "dress"
    ],
    u: "1f457",
    a: "0.6"
  },
  {
    n: [
      "kimono"
    ],
    u: "1f458",
    a: "0.6"
  },
  {
    n: [
      "sari"
    ],
    u: "1f97b",
    a: "12.0"
  },
  {
    n: [
      "one-piece swimsuit"
    ],
    u: "1fa71",
    a: "12.0"
  },
  {
    n: [
      "briefs"
    ],
    u: "1fa72",
    a: "12.0"
  },
  {
    n: [
      "shorts"
    ],
    u: "1fa73",
    a: "12.0"
  },
  {
    n: [
      "bikini"
    ],
    u: "1f459",
    a: "0.6"
  },
  {
    n: [
      "womans clothes"
    ],
    u: "1f45a",
    a: "0.6"
  },
  {
    n: [
      "purse"
    ],
    u: "1f45b",
    a: "0.6"
  },
  {
    n: [
      "handbag"
    ],
    u: "1f45c",
    a: "0.6"
  },
  {
    n: [
      "pouch"
    ],
    u: "1f45d",
    a: "0.6"
  },
  {
    n: [
      "shopping bags"
    ],
    u: "1f6cd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "school satchel"
    ],
    u: "1f392",
    a: "0.6"
  },
  {
    n: [
      "thong sandal"
    ],
    u: "1fa74",
    a: "13.0"
  },
  {
    n: [
      "shoe",
      "mans shoe"
    ],
    u: "1f45e",
    a: "0.6"
  },
  {
    n: [
      "athletic shoe"
    ],
    u: "1f45f",
    a: "0.6"
  },
  {
    n: [
      "hiking boot"
    ],
    u: "1f97e",
    a: "11.0"
  },
  {
    n: [
      "flat shoe",
      "womans flat shoe"
    ],
    u: "1f97f",
    a: "11.0"
  },
  {
    n: [
      "high heel",
      "high-heeled shoe"
    ],
    u: "1f460",
    a: "0.6"
  },
  {
    n: [
      "sandal",
      "womans sandal"
    ],
    u: "1f461",
    a: "0.6"
  },
  {
    n: [
      "ballet shoes"
    ],
    u: "1fa70",
    a: "12.0"
  },
  {
    n: [
      "boot",
      "womans boots"
    ],
    u: "1f462",
    a: "0.6"
  },
  {
    n: [
      "crown"
    ],
    u: "1f451",
    a: "0.6"
  },
  {
    n: [
      "womans hat"
    ],
    u: "1f452",
    a: "0.6"
  },
  {
    n: [
      "tophat",
      "top hat"
    ],
    u: "1f3a9",
    a: "0.6"
  },
  {
    n: [
      "mortar board",
      "graduation cap"
    ],
    u: "1f393",
    a: "0.6"
  },
  {
    n: [
      "billed cap"
    ],
    u: "1f9e2",
    a: "5.0"
  },
  {
    n: [
      "military helmet"
    ],
    u: "1fa96",
    a: "13.0"
  },
  {
    n: [
      "rescue worker’s helmet",
      "helmet with white cross"
    ],
    u: "26d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "prayer beads"
    ],
    u: "1f4ff",
    a: "1.0"
  },
  {
    n: [
      "lipstick"
    ],
    u: "1f484",
    a: "0.6"
  },
  {
    n: [
      "ring"
    ],
    u: "1f48d",
    a: "0.6"
  },
  {
    n: [
      "gem",
      "gem stone"
    ],
    u: "1f48e",
    a: "0.6"
  },
  {
    n: [
      "mute",
      "speaker with cancellation stroke"
    ],
    u: "1f507",
    a: "1.0"
  },
  {
    n: [
      "speaker"
    ],
    u: "1f508",
    a: "0.7"
  },
  {
    n: [
      "sound",
      "speaker with one sound wave"
    ],
    u: "1f509",
    a: "1.0"
  },
  {
    n: [
      "loud sound",
      "speaker with three sound waves"
    ],
    u: "1f50a",
    a: "0.6"
  },
  {
    n: [
      "loudspeaker",
      "public address loudspeaker"
    ],
    u: "1f4e2",
    a: "0.6"
  },
  {
    n: [
      "mega",
      "cheering megaphone"
    ],
    u: "1f4e3",
    a: "0.6"
  },
  {
    n: [
      "postal horn"
    ],
    u: "1f4ef",
    a: "1.0"
  },
  {
    n: [
      "bell"
    ],
    u: "1f514",
    a: "0.6"
  },
  {
    n: [
      "no bell",
      "bell with cancellation stroke"
    ],
    u: "1f515",
    a: "1.0"
  },
  {
    n: [
      "musical score"
    ],
    u: "1f3bc",
    a: "0.6"
  },
  {
    n: [
      "musical note"
    ],
    u: "1f3b5",
    a: "0.6"
  },
  {
    n: [
      "notes",
      "multiple musical notes"
    ],
    u: "1f3b6",
    a: "0.6"
  },
  {
    n: [
      "studio microphone"
    ],
    u: "1f399-fe0f",
    a: "0.7"
  },
  {
    n: [
      "level slider"
    ],
    u: "1f39a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "control knobs"
    ],
    u: "1f39b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "microphone"
    ],
    u: "1f3a4",
    a: "0.6"
  },
  {
    n: [
      "headphone",
      "headphones"
    ],
    u: "1f3a7",
    a: "0.6"
  },
  {
    n: [
      "radio"
    ],
    u: "1f4fb",
    a: "0.6"
  },
  {
    n: [
      "saxophone"
    ],
    u: "1f3b7",
    a: "0.6"
  },
  {
    n: [
      "accordion"
    ],
    u: "1fa97",
    a: "13.0"
  },
  {
    n: [
      "guitar"
    ],
    u: "1f3b8",
    a: "0.6"
  },
  {
    n: [
      "musical keyboard"
    ],
    u: "1f3b9",
    a: "0.6"
  },
  {
    n: [
      "trumpet"
    ],
    u: "1f3ba",
    a: "0.6"
  },
  {
    n: [
      "violin"
    ],
    u: "1f3bb",
    a: "0.6"
  },
  {
    n: [
      "banjo"
    ],
    u: "1fa95",
    a: "12.0"
  },
  {
    n: [
      "drum with drumsticks"
    ],
    u: "1f941",
    a: "3.0"
  },
  {
    n: [
      "long drum"
    ],
    u: "1fa98",
    a: "13.0"
  },
  {
    n: [
      "iphone",
      "mobile phone"
    ],
    u: "1f4f1",
    a: "0.6"
  },
  {
    n: [
      "calling",
      "mobile phone with rightwards arrow at left"
    ],
    u: "1f4f2",
    a: "0.6"
  },
  {
    n: [
      "phone",
      "telephone",
      "black telephone"
    ],
    u: "260e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "telephone receiver"
    ],
    u: "1f4de",
    a: "0.6"
  },
  {
    n: [
      "pager"
    ],
    u: "1f4df",
    a: "0.6"
  },
  {
    n: [
      "fax",
      "fax machine"
    ],
    u: "1f4e0",
    a: "0.6"
  },
  {
    n: [
      "battery"
    ],
    u: "1f50b",
    a: "0.6"
  },
  {
    n: [
      "low battery"
    ],
    u: "1faab",
    a: "14.0"
  },
  {
    n: [
      "electric plug"
    ],
    u: "1f50c",
    a: "0.6"
  },
  {
    n: [
      "computer",
      "personal computer"
    ],
    u: "1f4bb",
    a: "0.6"
  },
  {
    n: [
      "desktop computer"
    ],
    u: "1f5a5-fe0f",
    a: "0.7"
  },
  {
    n: [
      "printer"
    ],
    u: "1f5a8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "keyboard"
    ],
    u: "2328-fe0f",
    a: "1.0"
  },
  {
    n: [
      "computer mouse",
      "three button mouse"
    ],
    u: "1f5b1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "trackball"
    ],
    u: "1f5b2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "minidisc"
    ],
    u: "1f4bd",
    a: "0.6"
  },
  {
    n: [
      "floppy disk"
    ],
    u: "1f4be",
    a: "0.6"
  },
  {
    n: [
      "cd",
      "optical disc"
    ],
    u: "1f4bf",
    a: "0.6"
  },
  {
    n: [
      "dvd"
    ],
    u: "1f4c0",
    a: "0.6"
  },
  {
    n: [
      "abacus"
    ],
    u: "1f9ee",
    a: "11.0"
  },
  {
    n: [
      "movie camera"
    ],
    u: "1f3a5",
    a: "0.6"
  },
  {
    n: [
      "film frames"
    ],
    u: "1f39e-fe0f",
    a: "0.7"
  },
  {
    n: [
      "film projector"
    ],
    u: "1f4fd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "clapper",
      "clapper board"
    ],
    u: "1f3ac",
    a: "0.6"
  },
  {
    n: [
      "tv",
      "television"
    ],
    u: "1f4fa",
    a: "0.6"
  },
  {
    n: [
      "camera"
    ],
    u: "1f4f7",
    a: "0.6"
  },
  {
    n: [
      "camera with flash"
    ],
    u: "1f4f8",
    a: "1.0"
  },
  {
    n: [
      "video camera"
    ],
    u: "1f4f9",
    a: "0.6"
  },
  {
    n: [
      "vhs",
      "videocassette"
    ],
    u: "1f4fc",
    a: "0.6"
  },
  {
    n: [
      "mag",
      "left-pointing magnifying glass"
    ],
    u: "1f50d",
    a: "0.6"
  },
  {
    n: [
      "mag right",
      "right-pointing magnifying glass"
    ],
    u: "1f50e",
    a: "0.6"
  },
  {
    n: [
      "candle"
    ],
    u: "1f56f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bulb",
      "electric light bulb"
    ],
    u: "1f4a1",
    a: "0.6"
  },
  {
    n: [
      "flashlight",
      "electric torch"
    ],
    u: "1f526",
    a: "0.6"
  },
  {
    n: [
      "lantern",
      "izakaya lantern"
    ],
    u: "1f3ee",
    a: "0.6"
  },
  {
    n: [
      "diya lamp"
    ],
    u: "1fa94",
    a: "12.0"
  },
  {
    n: [
      "notebook with decorative cover"
    ],
    u: "1f4d4",
    a: "0.6"
  },
  {
    n: [
      "closed book"
    ],
    u: "1f4d5",
    a: "0.6"
  },
  {
    n: [
      "book",
      "open book"
    ],
    u: "1f4d6",
    a: "0.6"
  },
  {
    n: [
      "green book"
    ],
    u: "1f4d7",
    a: "0.6"
  },
  {
    n: [
      "blue book"
    ],
    u: "1f4d8",
    a: "0.6"
  },
  {
    n: [
      "orange book"
    ],
    u: "1f4d9",
    a: "0.6"
  },
  {
    n: [
      "books"
    ],
    u: "1f4da",
    a: "0.6"
  },
  {
    n: [
      "notebook"
    ],
    u: "1f4d3",
    a: "0.6"
  },
  {
    n: [
      "ledger"
    ],
    u: "1f4d2",
    a: "0.6"
  },
  {
    n: [
      "page with curl"
    ],
    u: "1f4c3",
    a: "0.6"
  },
  {
    n: [
      "scroll"
    ],
    u: "1f4dc",
    a: "0.6"
  },
  {
    n: [
      "page facing up"
    ],
    u: "1f4c4",
    a: "0.6"
  },
  {
    n: [
      "newspaper"
    ],
    u: "1f4f0",
    a: "0.6"
  },
  {
    n: [
      "rolled-up newspaper",
      "rolled up newspaper"
    ],
    u: "1f5de-fe0f",
    a: "0.7"
  },
  {
    n: [
      "bookmark tabs"
    ],
    u: "1f4d1",
    a: "0.6"
  },
  {
    n: [
      "bookmark"
    ],
    u: "1f516",
    a: "0.6"
  },
  {
    n: [
      "label"
    ],
    u: "1f3f7-fe0f",
    a: "0.7"
  },
  {
    n: [
      "moneybag",
      "money bag"
    ],
    u: "1f4b0",
    a: "0.6"
  },
  {
    n: [
      "coin"
    ],
    u: "1fa99",
    a: "13.0"
  },
  {
    n: [
      "yen",
      "banknote with yen sign"
    ],
    u: "1f4b4",
    a: "0.6"
  },
  {
    n: [
      "dollar",
      "banknote with dollar sign"
    ],
    u: "1f4b5",
    a: "0.6"
  },
  {
    n: [
      "euro",
      "banknote with euro sign"
    ],
    u: "1f4b6",
    a: "1.0"
  },
  {
    n: [
      "pound",
      "banknote with pound sign"
    ],
    u: "1f4b7",
    a: "1.0"
  },
  {
    n: [
      "money with wings"
    ],
    u: "1f4b8",
    a: "0.6"
  },
  {
    n: [
      "credit card"
    ],
    u: "1f4b3",
    a: "0.6"
  },
  {
    n: [
      "receipt"
    ],
    u: "1f9fe",
    a: "11.0"
  },
  {
    n: [
      "chart",
      "chart with upwards trend and yen sign"
    ],
    u: "1f4b9",
    a: "0.6"
  },
  {
    n: [
      "email",
      "envelope"
    ],
    u: "2709-fe0f",
    a: "0.6"
  },
  {
    n: [
      "e-mail",
      "e-mail symbol"
    ],
    u: "1f4e7",
    a: "0.6"
  },
  {
    n: [
      "incoming envelope"
    ],
    u: "1f4e8",
    a: "0.6"
  },
  {
    n: [
      "envelope with arrow",
      "envelope with downwards arrow above"
    ],
    u: "1f4e9",
    a: "0.6"
  },
  {
    n: [
      "outbox tray"
    ],
    u: "1f4e4",
    a: "0.6"
  },
  {
    n: [
      "inbox tray"
    ],
    u: "1f4e5",
    a: "0.6"
  },
  {
    n: [
      "package"
    ],
    u: "1f4e6",
    a: "0.6"
  },
  {
    n: [
      "mailbox",
      "closed mailbox with raised flag"
    ],
    u: "1f4eb",
    a: "0.6"
  },
  {
    n: [
      "mailbox closed",
      "closed mailbox with lowered flag"
    ],
    u: "1f4ea",
    a: "0.6"
  },
  {
    n: [
      "mailbox with mail",
      "open mailbox with raised flag"
    ],
    u: "1f4ec",
    a: "0.7"
  },
  {
    n: [
      "mailbox with no mail",
      "open mailbox with lowered flag"
    ],
    u: "1f4ed",
    a: "0.7"
  },
  {
    n: [
      "postbox"
    ],
    u: "1f4ee",
    a: "0.6"
  },
  {
    n: [
      "ballot box with ballot"
    ],
    u: "1f5f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pencil",
      "pencil2"
    ],
    u: "270f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black nib"
    ],
    u: "2712-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fountain pen",
      "lower left fountain pen"
    ],
    u: "1f58b-fe0f",
    a: "0.7"
  },
  {
    n: [
      "pen",
      "lower left ballpoint pen"
    ],
    u: "1f58a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "paintbrush",
      "lower left paintbrush"
    ],
    u: "1f58c-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crayon",
      "lower left crayon"
    ],
    u: "1f58d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "memo",
      "pencil"
    ],
    u: "1f4dd",
    a: "0.6"
  },
  {
    n: [
      "briefcase"
    ],
    u: "1f4bc",
    a: "0.6"
  },
  {
    n: [
      "file folder"
    ],
    u: "1f4c1",
    a: "0.6"
  },
  {
    n: [
      "open file folder"
    ],
    u: "1f4c2",
    a: "0.6"
  },
  {
    n: [
      "card index dividers"
    ],
    u: "1f5c2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "date",
      "calendar"
    ],
    u: "1f4c5",
    a: "0.6"
  },
  {
    n: [
      "calendar",
      "tear-off calendar"
    ],
    u: "1f4c6",
    a: "0.6"
  },
  {
    n: [
      "spiral notepad",
      "spiral note pad"
    ],
    u: "1f5d2-fe0f",
    a: "0.7"
  },
  {
    n: [
      "spiral calendar",
      "spiral calendar pad"
    ],
    u: "1f5d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "card index"
    ],
    u: "1f4c7",
    a: "0.6"
  },
  {
    n: [
      "chart with upwards trend"
    ],
    u: "1f4c8",
    a: "0.6"
  },
  {
    n: [
      "chart with downwards trend"
    ],
    u: "1f4c9",
    a: "0.6"
  },
  {
    n: [
      "bar chart"
    ],
    u: "1f4ca",
    a: "0.6"
  },
  {
    n: [
      "clipboard"
    ],
    u: "1f4cb",
    a: "0.6"
  },
  {
    n: [
      "pushpin"
    ],
    u: "1f4cc",
    a: "0.6"
  },
  {
    n: [
      "round pushpin"
    ],
    u: "1f4cd",
    a: "0.6"
  },
  {
    n: [
      "paperclip"
    ],
    u: "1f4ce",
    a: "0.6"
  },
  {
    n: [
      "linked paperclips"
    ],
    u: "1f587-fe0f",
    a: "0.7"
  },
  {
    n: [
      "straight ruler"
    ],
    u: "1f4cf",
    a: "0.6"
  },
  {
    n: [
      "triangular ruler"
    ],
    u: "1f4d0",
    a: "0.6"
  },
  {
    n: [
      "scissors",
      "black scissors"
    ],
    u: "2702-fe0f",
    a: "0.6"
  },
  {
    n: [
      "card file box"
    ],
    u: "1f5c3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "file cabinet"
    ],
    u: "1f5c4-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wastebasket"
    ],
    u: "1f5d1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "lock"
    ],
    u: "1f512",
    a: "0.6"
  },
  {
    n: [
      "unlock",
      "open lock"
    ],
    u: "1f513",
    a: "0.6"
  },
  {
    n: [
      "lock with ink pen"
    ],
    u: "1f50f",
    a: "0.6"
  },
  {
    n: [
      "closed lock with key"
    ],
    u: "1f510",
    a: "0.6"
  },
  {
    n: [
      "key"
    ],
    u: "1f511",
    a: "0.6"
  },
  {
    n: [
      "old key"
    ],
    u: "1f5dd-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer"
    ],
    u: "1f528",
    a: "0.6"
  },
  {
    n: [
      "axe"
    ],
    u: "1fa93",
    a: "12.0"
  },
  {
    n: [
      "pick"
    ],
    u: "26cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hammer and pick"
    ],
    u: "2692-fe0f",
    a: "1.0"
  },
  {
    n: [
      "hammer and wrench"
    ],
    u: "1f6e0-fe0f",
    a: "0.7"
  },
  {
    n: [
      "dagger",
      "dagger knife"
    ],
    u: "1f5e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "crossed swords"
    ],
    u: "2694-fe0f",
    a: "1.0"
  },
  {
    n: [
      "gun",
      "pistol"
    ],
    u: "1f52b",
    a: "0.6"
  },
  {
    n: [
      "boomerang"
    ],
    u: "1fa83",
    a: "13.0"
  },
  {
    n: [
      "bow and arrow"
    ],
    u: "1f3f9",
    a: "1.0"
  },
  {
    n: [
      "shield"
    ],
    u: "1f6e1-fe0f",
    a: "0.7"
  },
  {
    n: [
      "carpentry saw"
    ],
    u: "1fa9a",
    a: "13.0"
  },
  {
    n: [
      "wrench"
    ],
    u: "1f527",
    a: "0.6"
  },
  {
    n: [
      "screwdriver"
    ],
    u: "1fa9b",
    a: "13.0"
  },
  {
    n: [
      "nut and bolt"
    ],
    u: "1f529",
    a: "0.6"
  },
  {
    n: [
      "gear"
    ],
    u: "2699-fe0f",
    a: "1.0"
  },
  {
    n: [
      "clamp",
      "compression"
    ],
    u: "1f5dc-fe0f",
    a: "0.7"
  },
  {
    n: [
      "scales",
      "balance scale"
    ],
    u: "2696-fe0f",
    a: "1.0"
  },
  {
    n: [
      "probing cane"
    ],
    u: "1f9af",
    a: "12.0"
  },
  {
    n: [
      "link",
      "link symbol"
    ],
    u: "1f517",
    a: "0.6"
  },
  {
    n: [
      "chains"
    ],
    u: "26d3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "hook"
    ],
    u: "1fa9d",
    a: "13.0"
  },
  {
    n: [
      "toolbox"
    ],
    u: "1f9f0",
    a: "11.0"
  },
  {
    n: [
      "magnet"
    ],
    u: "1f9f2",
    a: "11.0"
  },
  {
    n: [
      "ladder"
    ],
    u: "1fa9c",
    a: "13.0"
  },
  {
    n: [
      "alembic"
    ],
    u: "2697-fe0f",
    a: "1.0"
  },
  {
    n: [
      "test tube"
    ],
    u: "1f9ea",
    a: "11.0"
  },
  {
    n: [
      "petri dish"
    ],
    u: "1f9eb",
    a: "11.0"
  },
  {
    n: [
      "dna",
      "dna double helix"
    ],
    u: "1f9ec",
    a: "11.0"
  },
  {
    n: [
      "microscope"
    ],
    u: "1f52c",
    a: "1.0"
  },
  {
    n: [
      "telescope"
    ],
    u: "1f52d",
    a: "1.0"
  },
  {
    n: [
      "satellite antenna"
    ],
    u: "1f4e1",
    a: "0.6"
  },
  {
    n: [
      "syringe"
    ],
    u: "1f489",
    a: "0.6"
  },
  {
    n: [
      "drop of blood"
    ],
    u: "1fa78",
    a: "12.0"
  },
  {
    n: [
      "pill"
    ],
    u: "1f48a",
    a: "0.6"
  },
  {
    n: [
      "adhesive bandage"
    ],
    u: "1fa79",
    a: "12.0"
  },
  {
    n: [
      "crutch"
    ],
    u: "1fa7c",
    a: "14.0"
  },
  {
    n: [
      "stethoscope"
    ],
    u: "1fa7a",
    a: "12.0"
  },
  {
    n: [
      "x-ray"
    ],
    u: "1fa7b",
    a: "14.0"
  },
  {
    n: [
      "door"
    ],
    u: "1f6aa",
    a: "0.6"
  },
  {
    n: [
      "elevator"
    ],
    u: "1f6d7",
    a: "13.0"
  },
  {
    n: [
      "mirror"
    ],
    u: "1fa9e",
    a: "13.0"
  },
  {
    n: [
      "window"
    ],
    u: "1fa9f",
    a: "13.0"
  },
  {
    n: [
      "bed"
    ],
    u: "1f6cf-fe0f",
    a: "0.7"
  },
  {
    n: [
      "couch and lamp"
    ],
    u: "1f6cb-fe0f",
    a: "0.7"
  },
  {
    n: [
      "chair"
    ],
    u: "1fa91",
    a: "12.0"
  },
  {
    n: [
      "toilet"
    ],
    u: "1f6bd",
    a: "0.6"
  },
  {
    n: [
      "plunger"
    ],
    u: "1faa0",
    a: "13.0"
  },
  {
    n: [
      "shower"
    ],
    u: "1f6bf",
    a: "1.0"
  },
  {
    n: [
      "bathtub"
    ],
    u: "1f6c1",
    a: "1.0"
  },
  {
    n: [
      "mouse trap"
    ],
    u: "1faa4",
    a: "13.0"
  },
  {
    n: [
      "razor"
    ],
    u: "1fa92",
    a: "12.0"
  },
  {
    n: [
      "lotion bottle"
    ],
    u: "1f9f4",
    a: "11.0"
  },
  {
    n: [
      "safety pin"
    ],
    u: "1f9f7",
    a: "11.0"
  },
  {
    n: [
      "broom"
    ],
    u: "1f9f9",
    a: "11.0"
  },
  {
    n: [
      "basket"
    ],
    u: "1f9fa",
    a: "11.0"
  },
  {
    n: [
      "roll of paper"
    ],
    u: "1f9fb",
    a: "11.0"
  },
  {
    n: [
      "bucket"
    ],
    u: "1faa3",
    a: "13.0"
  },
  {
    n: [
      "soap",
      "bar of soap"
    ],
    u: "1f9fc",
    a: "11.0"
  },
  {
    n: [
      "bubbles"
    ],
    u: "1fae7",
    a: "14.0"
  },
  {
    n: [
      "toothbrush"
    ],
    u: "1faa5",
    a: "13.0"
  },
  {
    n: [
      "sponge"
    ],
    u: "1f9fd",
    a: "11.0"
  },
  {
    n: [
      "fire extinguisher"
    ],
    u: "1f9ef",
    a: "11.0"
  },
  {
    n: [
      "shopping trolley"
    ],
    u: "1f6d2",
    a: "3.0"
  },
  {
    n: [
      "smoking",
      "smoking symbol"
    ],
    u: "1f6ac",
    a: "0.6"
  },
  {
    n: [
      "coffin"
    ],
    u: "26b0-fe0f",
    a: "1.0"
  },
  {
    n: [
      "headstone"
    ],
    u: "1faa6",
    a: "13.0"
  },
  {
    n: [
      "funeral urn"
    ],
    u: "26b1-fe0f",
    a: "1.0"
  },
  {
    n: [
      "moyai"
    ],
    u: "1f5ff",
    a: "0.6"
  },
  {
    n: [
      "placard"
    ],
    u: "1faa7",
    a: "13.0"
  },
  {
    n: [
      "identification card"
    ],
    u: "1faaa",
    a: "14.0"
  }
], zE = [
  {
    n: [
      "atm",
      "automated teller machine"
    ],
    u: "1f3e7",
    a: "0.6"
  },
  {
    n: [
      "put litter in its place",
      "put litter in its place symbol"
    ],
    u: "1f6ae",
    a: "1.0"
  },
  {
    n: [
      "potable water",
      "potable water symbol"
    ],
    u: "1f6b0",
    a: "1.0"
  },
  {
    n: [
      "wheelchair",
      "wheelchair symbol"
    ],
    u: "267f",
    a: "0.6"
  },
  {
    n: [
      "mens",
      "mens symbol"
    ],
    u: "1f6b9",
    a: "0.6"
  },
  {
    n: [
      "womens",
      "womens symbol"
    ],
    u: "1f6ba",
    a: "0.6"
  },
  {
    n: [
      "restroom"
    ],
    u: "1f6bb",
    a: "0.6"
  },
  {
    n: [
      "baby symbol"
    ],
    u: "1f6bc",
    a: "0.6"
  },
  {
    n: [
      "wc",
      "water closet"
    ],
    u: "1f6be",
    a: "0.6"
  },
  {
    n: [
      "passport control"
    ],
    u: "1f6c2",
    a: "1.0"
  },
  {
    n: [
      "customs"
    ],
    u: "1f6c3",
    a: "1.0"
  },
  {
    n: [
      "baggage claim"
    ],
    u: "1f6c4",
    a: "1.0"
  },
  {
    n: [
      "left luggage"
    ],
    u: "1f6c5",
    a: "1.0"
  },
  {
    n: [
      "warning",
      "warning sign"
    ],
    u: "26a0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "children crossing"
    ],
    u: "1f6b8",
    a: "1.0"
  },
  {
    n: [
      "no entry"
    ],
    u: "26d4",
    a: "0.6"
  },
  {
    n: [
      "no entry sign"
    ],
    u: "1f6ab",
    a: "0.6"
  },
  {
    n: [
      "no bicycles"
    ],
    u: "1f6b3",
    a: "1.0"
  },
  {
    n: [
      "no smoking",
      "no smoking symbol"
    ],
    u: "1f6ad",
    a: "0.6"
  },
  {
    n: [
      "do not litter",
      "do not litter symbol"
    ],
    u: "1f6af",
    a: "1.0"
  },
  {
    n: [
      "non-potable water",
      "non-potable water symbol"
    ],
    u: "1f6b1",
    a: "1.0"
  },
  {
    n: [
      "no pedestrians"
    ],
    u: "1f6b7",
    a: "1.0"
  },
  {
    n: [
      "no mobile phones"
    ],
    u: "1f4f5",
    a: "1.0"
  },
  {
    n: [
      "underage",
      "no one under eighteen symbol"
    ],
    u: "1f51e",
    a: "0.6"
  },
  {
    n: [
      "radioactive",
      "radioactive sign"
    ],
    u: "2622-fe0f",
    a: "1.0"
  },
  {
    n: [
      "biohazard",
      "biohazard sign"
    ],
    u: "2623-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow up",
      "upwards black arrow"
    ],
    u: "2b06-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north east arrow",
      "arrow upper right"
    ],
    u: "2197-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right",
      "black rightwards arrow"
    ],
    u: "27a1-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south east arrow",
      "arrow lower right"
    ],
    u: "2198-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow down",
      "downwards black arrow"
    ],
    u: "2b07-fe0f",
    a: "0.6"
  },
  {
    n: [
      "south west arrow",
      "arrow lower left"
    ],
    u: "2199-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow left",
      "leftwards black arrow"
    ],
    u: "2b05-fe0f",
    a: "0.6"
  },
  {
    n: [
      "north west arrow",
      "arrow upper left"
    ],
    u: "2196-fe0f",
    a: "0.6"
  },
  {
    n: [
      "up down arrow",
      "arrow up down"
    ],
    u: "2195-fe0f",
    a: "0.6"
  },
  {
    n: [
      "left right arrow"
    ],
    u: "2194-fe0f",
    a: "0.6"
  },
  {
    n: [
      "leftwards arrow with hook"
    ],
    u: "21a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow right hook",
      "rightwards arrow with hook"
    ],
    u: "21aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading up",
      "arrow pointing rightwards then curving upwards"
    ],
    u: "2934-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrow heading down",
      "arrow pointing rightwards then curving downwards"
    ],
    u: "2935-fe0f",
    a: "0.6"
  },
  {
    n: [
      "arrows clockwise",
      "clockwise downwards and upwards open circle arrows"
    ],
    u: "1f503",
    a: "0.6"
  },
  {
    n: [
      "arrows counterclockwise",
      "anticlockwise downwards and upwards open circle arrows"
    ],
    u: "1f504",
    a: "1.0"
  },
  {
    n: [
      "back",
      "back with leftwards arrow above"
    ],
    u: "1f519",
    a: "0.6"
  },
  {
    n: [
      "end",
      "end with leftwards arrow above"
    ],
    u: "1f51a",
    a: "0.6"
  },
  {
    n: [
      "on",
      "on with exclamation mark with left right arrow above"
    ],
    u: "1f51b",
    a: "0.6"
  },
  {
    n: [
      "soon",
      "soon with rightwards arrow above"
    ],
    u: "1f51c",
    a: "0.6"
  },
  {
    n: [
      "top",
      "top with upwards arrow above"
    ],
    u: "1f51d",
    a: "0.6"
  },
  {
    n: [
      "place of worship"
    ],
    u: "1f6d0",
    a: "1.0"
  },
  {
    n: [
      "atom symbol"
    ],
    u: "269b-fe0f",
    a: "1.0"
  },
  {
    n: [
      "om",
      "om symbol"
    ],
    u: "1f549-fe0f",
    a: "0.7"
  },
  {
    n: [
      "star of david"
    ],
    u: "2721-fe0f",
    a: "0.7"
  },
  {
    n: [
      "wheel of dharma"
    ],
    u: "2638-fe0f",
    a: "0.7"
  },
  {
    n: [
      "yin yang"
    ],
    u: "262f-fe0f",
    a: "0.7"
  },
  {
    n: [
      "latin cross"
    ],
    u: "271d-fe0f",
    a: "0.7"
  },
  {
    n: [
      "orthodox cross"
    ],
    u: "2626-fe0f",
    a: "1.0"
  },
  {
    n: [
      "star and crescent"
    ],
    u: "262a-fe0f",
    a: "0.7"
  },
  {
    n: [
      "peace symbol"
    ],
    u: "262e-fe0f",
    a: "1.0"
  },
  {
    n: [
      "menorah with nine branches"
    ],
    u: "1f54e",
    a: "1.0"
  },
  {
    n: [
      "six pointed star",
      "six pointed star with middle dot"
    ],
    u: "1f52f",
    a: "0.6"
  },
  {
    n: [
      "aries"
    ],
    u: "2648",
    a: "0.6"
  },
  {
    n: [
      "taurus"
    ],
    u: "2649",
    a: "0.6"
  },
  {
    n: [
      "gemini"
    ],
    u: "264a",
    a: "0.6"
  },
  {
    n: [
      "cancer"
    ],
    u: "264b",
    a: "0.6"
  },
  {
    n: [
      "leo"
    ],
    u: "264c",
    a: "0.6"
  },
  {
    n: [
      "virgo"
    ],
    u: "264d",
    a: "0.6"
  },
  {
    n: [
      "libra"
    ],
    u: "264e",
    a: "0.6"
  },
  {
    n: [
      "scorpius"
    ],
    u: "264f",
    a: "0.6"
  },
  {
    n: [
      "sagittarius"
    ],
    u: "2650",
    a: "0.6"
  },
  {
    n: [
      "capricorn"
    ],
    u: "2651",
    a: "0.6"
  },
  {
    n: [
      "aquarius"
    ],
    u: "2652",
    a: "0.6"
  },
  {
    n: [
      "pisces"
    ],
    u: "2653",
    a: "0.6"
  },
  {
    n: [
      "ophiuchus"
    ],
    u: "26ce",
    a: "0.6"
  },
  {
    n: [
      "twisted rightwards arrows"
    ],
    u: "1f500",
    a: "1.0"
  },
  {
    n: [
      "repeat",
      "clockwise rightwards and leftwards open circle arrows"
    ],
    u: "1f501",
    a: "1.0"
  },
  {
    n: [
      "repeat one",
      "clockwise rightwards and leftwards open circle arrows with circled one overlay"
    ],
    u: "1f502",
    a: "1.0"
  },
  {
    n: [
      "arrow forward",
      "black right-pointing triangle"
    ],
    u: "25b6-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fast forward",
      "black right-pointing double triangle"
    ],
    u: "23e9",
    a: "0.6"
  },
  {
    n: [
      "next track button",
      "black right pointing double triangle with vertical bar"
    ],
    u: "23ed-fe0f",
    a: "0.7"
  },
  {
    n: [
      "play or pause button",
      "black right pointing triangle with double vertical bar"
    ],
    u: "23ef-fe0f",
    a: "1.0"
  },
  {
    n: [
      "arrow backward",
      "black left-pointing triangle"
    ],
    u: "25c0-fe0f",
    a: "0.6"
  },
  {
    n: [
      "rewind",
      "black left-pointing double triangle"
    ],
    u: "23ea",
    a: "0.6"
  },
  {
    n: [
      "last track button",
      "black left pointing double triangle with vertical bar"
    ],
    u: "23ee-fe0f",
    a: "0.7"
  },
  {
    n: [
      "arrow up small",
      "up-pointing small red triangle"
    ],
    u: "1f53c",
    a: "0.6"
  },
  {
    n: [
      "arrow double up",
      "black up-pointing double triangle"
    ],
    u: "23eb",
    a: "0.6"
  },
  {
    n: [
      "arrow down small",
      "down-pointing small red triangle"
    ],
    u: "1f53d",
    a: "0.6"
  },
  {
    n: [
      "arrow double down",
      "black down-pointing double triangle"
    ],
    u: "23ec",
    a: "0.6"
  },
  {
    n: [
      "pause button",
      "double vertical bar"
    ],
    u: "23f8-fe0f",
    a: "0.7"
  },
  {
    n: [
      "stop button",
      "black square for stop"
    ],
    u: "23f9-fe0f",
    a: "0.7"
  },
  {
    n: [
      "record button",
      "black circle for record"
    ],
    u: "23fa-fe0f",
    a: "0.7"
  },
  {
    n: [
      "eject",
      "eject button"
    ],
    u: "23cf-fe0f",
    a: "1.0"
  },
  {
    n: [
      "cinema"
    ],
    u: "1f3a6",
    a: "0.6"
  },
  {
    n: [
      "low brightness",
      "low brightness symbol"
    ],
    u: "1f505",
    a: "1.0"
  },
  {
    n: [
      "high brightness",
      "high brightness symbol"
    ],
    u: "1f506",
    a: "1.0"
  },
  {
    n: [
      "signal strength",
      "antenna with bars"
    ],
    u: "1f4f6",
    a: "0.6"
  },
  {
    n: [
      "vibration mode"
    ],
    u: "1f4f3",
    a: "0.6"
  },
  {
    n: [
      "mobile phone off"
    ],
    u: "1f4f4",
    a: "0.6"
  },
  {
    n: [
      "female sign"
    ],
    u: "2640-fe0f",
    a: "4.0"
  },
  {
    n: [
      "male sign"
    ],
    u: "2642-fe0f",
    a: "4.0"
  },
  {
    n: [
      "transgender symbol"
    ],
    u: "26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "heavy multiplication x"
    ],
    u: "2716-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy plus sign"
    ],
    u: "2795",
    a: "0.6"
  },
  {
    n: [
      "heavy minus sign"
    ],
    u: "2796",
    a: "0.6"
  },
  {
    n: [
      "heavy division sign"
    ],
    u: "2797",
    a: "0.6"
  },
  {
    n: [
      "heavy equals sign"
    ],
    u: "1f7f0",
    a: "14.0"
  },
  {
    n: [
      "infinity"
    ],
    u: "267e-fe0f",
    a: "11.0"
  },
  {
    n: [
      "bangbang",
      "double exclamation mark"
    ],
    u: "203c-fe0f",
    a: "0.6"
  },
  {
    n: [
      "interrobang",
      "exclamation question mark"
    ],
    u: "2049-fe0f",
    a: "0.6"
  },
  {
    n: [
      "question",
      "black question mark ornament"
    ],
    u: "2753",
    a: "0.6"
  },
  {
    n: [
      "grey question",
      "white question mark ornament"
    ],
    u: "2754",
    a: "0.6"
  },
  {
    n: [
      "grey exclamation",
      "white exclamation mark ornament"
    ],
    u: "2755",
    a: "0.6"
  },
  {
    n: [
      "exclamation",
      "heavy exclamation mark",
      "heavy exclamation mark symbol"
    ],
    u: "2757",
    a: "0.6"
  },
  {
    n: [
      "wavy dash"
    ],
    u: "3030-fe0f",
    a: "0.6"
  },
  {
    n: [
      "currency exchange"
    ],
    u: "1f4b1",
    a: "0.6"
  },
  {
    n: [
      "heavy dollar sign"
    ],
    u: "1f4b2",
    a: "0.6"
  },
  {
    n: [
      "medical symbol",
      "staff of aesculapius"
    ],
    u: "2695-fe0f",
    a: "4.0"
  },
  {
    n: [
      "recycle",
      "black universal recycling symbol"
    ],
    u: "267b-fe0f",
    a: "0.6"
  },
  {
    n: [
      "fleur-de-lis",
      "fleur de lis"
    ],
    u: "269c-fe0f",
    a: "1.0"
  },
  {
    n: [
      "trident",
      "trident emblem"
    ],
    u: "1f531",
    a: "0.6"
  },
  {
    n: [
      "name badge"
    ],
    u: "1f4db",
    a: "0.6"
  },
  {
    n: [
      "beginner",
      "japanese symbol for beginner"
    ],
    u: "1f530",
    a: "0.6"
  },
  {
    n: [
      "o",
      "heavy large circle"
    ],
    u: "2b55",
    a: "0.6"
  },
  {
    n: [
      "white check mark",
      "white heavy check mark"
    ],
    u: "2705",
    a: "0.6"
  },
  {
    n: [
      "ballot box with check"
    ],
    u: "2611-fe0f",
    a: "0.6"
  },
  {
    n: [
      "heavy check mark"
    ],
    u: "2714-fe0f",
    a: "0.6"
  },
  {
    n: [
      "x",
      "cross mark"
    ],
    u: "274c",
    a: "0.6"
  },
  {
    n: [
      "negative squared cross mark"
    ],
    u: "274e",
    a: "0.6"
  },
  {
    n: [
      "curly loop"
    ],
    u: "27b0",
    a: "0.6"
  },
  {
    n: [
      "loop",
      "double curly loop"
    ],
    u: "27bf",
    a: "1.0"
  },
  {
    n: [
      "part alternation mark"
    ],
    u: "303d-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight spoked asterisk"
    ],
    u: "2733-fe0f",
    a: "0.6"
  },
  {
    n: [
      "eight pointed black star"
    ],
    u: "2734-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sparkle"
    ],
    u: "2747-fe0f",
    a: "0.6"
  },
  {
    n: [
      "copyright",
      "copyright sign"
    ],
    u: "00a9-fe0f",
    a: "0.6"
  },
  {
    n: [
      "registered",
      "registered sign"
    ],
    u: "00ae-fe0f",
    a: "0.6"
  },
  {
    n: [
      "tm",
      "trade mark sign"
    ],
    u: "2122-fe0f",
    a: "0.6"
  },
  {
    n: [
      "hash",
      "hash key"
    ],
    u: "0023-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap: *",
      "keycap star"
    ],
    u: "002a-fe0f-20e3",
    a: "2.0"
  },
  {
    n: [
      "zero",
      "keycap 0"
    ],
    u: "0030-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "one",
      "keycap 1"
    ],
    u: "0031-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "two",
      "keycap 2"
    ],
    u: "0032-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "three",
      "keycap 3"
    ],
    u: "0033-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "four",
      "keycap 4"
    ],
    u: "0034-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "five",
      "keycap 5"
    ],
    u: "0035-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "six",
      "keycap 6"
    ],
    u: "0036-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "seven",
      "keycap 7"
    ],
    u: "0037-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "eight",
      "keycap 8"
    ],
    u: "0038-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "nine",
      "keycap 9"
    ],
    u: "0039-fe0f-20e3",
    a: "0.6"
  },
  {
    n: [
      "keycap ten"
    ],
    u: "1f51f",
    a: "0.6"
  },
  {
    n: [
      "capital abcd",
      "input symbol for latin capital letters"
    ],
    u: "1f520",
    a: "0.6"
  },
  {
    n: [
      "abcd",
      "input symbol for latin small letters"
    ],
    u: "1f521",
    a: "0.6"
  },
  {
    n: [
      "1234",
      "input symbol for numbers"
    ],
    u: "1f522",
    a: "0.6"
  },
  {
    n: [
      "symbols",
      "input symbol for symbols"
    ],
    u: "1f523",
    a: "0.6"
  },
  {
    n: [
      "abc",
      "input symbol for latin letters"
    ],
    u: "1f524",
    a: "0.6"
  },
  {
    n: [
      "a",
      "negative squared latin capital letter a"
    ],
    u: "1f170-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ab",
      "negative squared ab"
    ],
    u: "1f18e",
    a: "0.6"
  },
  {
    n: [
      "b",
      "negative squared latin capital letter b"
    ],
    u: "1f171-fe0f",
    a: "0.6"
  },
  {
    n: [
      "cl",
      "squared cl"
    ],
    u: "1f191",
    a: "0.6"
  },
  {
    n: [
      "cool",
      "squared cool"
    ],
    u: "1f192",
    a: "0.6"
  },
  {
    n: [
      "free",
      "squared free"
    ],
    u: "1f193",
    a: "0.6"
  },
  {
    n: [
      "information source"
    ],
    u: "2139-fe0f",
    a: "0.6"
  },
  {
    n: [
      "id",
      "squared id"
    ],
    u: "1f194",
    a: "0.6"
  },
  {
    n: [
      "m",
      "circled latin capital letter m"
    ],
    u: "24c2-fe0f",
    a: "0.6"
  },
  {
    n: [
      "new",
      "squared new"
    ],
    u: "1f195",
    a: "0.6"
  },
  {
    n: [
      "ng",
      "squared ng"
    ],
    u: "1f196",
    a: "0.6"
  },
  {
    n: [
      "o2",
      "negative squared latin capital letter o"
    ],
    u: "1f17e-fe0f",
    a: "0.6"
  },
  {
    n: [
      "ok",
      "squared ok"
    ],
    u: "1f197",
    a: "0.6"
  },
  {
    n: [
      "parking",
      "negative squared latin capital letter p"
    ],
    u: "1f17f-fe0f",
    a: "0.6"
  },
  {
    n: [
      "sos",
      "squared sos"
    ],
    u: "1f198",
    a: "0.6"
  },
  {
    n: [
      "up",
      "squared up with exclamation mark"
    ],
    u: "1f199",
    a: "0.6"
  },
  {
    n: [
      "vs",
      "squared vs"
    ],
    u: "1f19a",
    a: "0.6"
  },
  {
    n: [
      "koko",
      "squared katakana koko"
    ],
    u: "1f201",
    a: "0.6"
  },
  {
    n: [
      "sa",
      "squared katakana sa"
    ],
    u: "1f202-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6708",
      "squared cjk unified ideograph-6708"
    ],
    u: "1f237-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u6709",
      "squared cjk unified ideograph-6709"
    ],
    u: "1f236",
    a: "0.6"
  },
  {
    n: [
      "u6307",
      "squared cjk unified ideograph-6307"
    ],
    u: "1f22f",
    a: "0.6"
  },
  {
    n: [
      "ideograph advantage",
      "circled ideograph advantage"
    ],
    u: "1f250",
    a: "0.6"
  },
  {
    n: [
      "u5272",
      "squared cjk unified ideograph-5272"
    ],
    u: "1f239",
    a: "0.6"
  },
  {
    n: [
      "u7121",
      "squared cjk unified ideograph-7121"
    ],
    u: "1f21a",
    a: "0.6"
  },
  {
    n: [
      "u7981",
      "squared cjk unified ideograph-7981"
    ],
    u: "1f232",
    a: "0.6"
  },
  {
    n: [
      "accept",
      "circled ideograph accept"
    ],
    u: "1f251",
    a: "0.6"
  },
  {
    n: [
      "u7533",
      "squared cjk unified ideograph-7533"
    ],
    u: "1f238",
    a: "0.6"
  },
  {
    n: [
      "u5408",
      "squared cjk unified ideograph-5408"
    ],
    u: "1f234",
    a: "0.6"
  },
  {
    n: [
      "u7a7a",
      "squared cjk unified ideograph-7a7a"
    ],
    u: "1f233",
    a: "0.6"
  },
  {
    n: [
      "congratulations",
      "circled ideograph congratulation"
    ],
    u: "3297-fe0f",
    a: "0.6"
  },
  {
    n: [
      "secret",
      "circled ideograph secret"
    ],
    u: "3299-fe0f",
    a: "0.6"
  },
  {
    n: [
      "u55b6",
      "squared cjk unified ideograph-55b6"
    ],
    u: "1f23a",
    a: "0.6"
  },
  {
    n: [
      "u6e80",
      "squared cjk unified ideograph-6e80"
    ],
    u: "1f235",
    a: "0.6"
  },
  {
    n: [
      "red circle",
      "large red circle"
    ],
    u: "1f534",
    a: "0.6"
  },
  {
    n: [
      "large orange circle"
    ],
    u: "1f7e0",
    a: "12.0"
  },
  {
    n: [
      "large yellow circle"
    ],
    u: "1f7e1",
    a: "12.0"
  },
  {
    n: [
      "large green circle"
    ],
    u: "1f7e2",
    a: "12.0"
  },
  {
    n: [
      "large blue circle"
    ],
    u: "1f535",
    a: "0.6"
  },
  {
    n: [
      "large purple circle"
    ],
    u: "1f7e3",
    a: "12.0"
  },
  {
    n: [
      "large brown circle"
    ],
    u: "1f7e4",
    a: "12.0"
  },
  {
    n: [
      "black circle",
      "medium black circle"
    ],
    u: "26ab",
    a: "0.6"
  },
  {
    n: [
      "white circle",
      "medium white circle"
    ],
    u: "26aa",
    a: "0.6"
  },
  {
    n: [
      "large red square"
    ],
    u: "1f7e5",
    a: "12.0"
  },
  {
    n: [
      "large orange square"
    ],
    u: "1f7e7",
    a: "12.0"
  },
  {
    n: [
      "large yellow square"
    ],
    u: "1f7e8",
    a: "12.0"
  },
  {
    n: [
      "large green square"
    ],
    u: "1f7e9",
    a: "12.0"
  },
  {
    n: [
      "large blue square"
    ],
    u: "1f7e6",
    a: "12.0"
  },
  {
    n: [
      "large purple square"
    ],
    u: "1f7ea",
    a: "12.0"
  },
  {
    n: [
      "large brown square"
    ],
    u: "1f7eb",
    a: "12.0"
  },
  {
    n: [
      "black large square"
    ],
    u: "2b1b",
    a: "0.6"
  },
  {
    n: [
      "white large square"
    ],
    u: "2b1c",
    a: "0.6"
  },
  {
    n: [
      "black medium square"
    ],
    u: "25fc-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white medium square"
    ],
    u: "25fb-fe0f",
    a: "0.6"
  },
  {
    n: [
      "black medium small square"
    ],
    u: "25fe",
    a: "0.6"
  },
  {
    n: [
      "white medium small square"
    ],
    u: "25fd",
    a: "0.6"
  },
  {
    n: [
      "black small square"
    ],
    u: "25aa-fe0f",
    a: "0.6"
  },
  {
    n: [
      "white small square"
    ],
    u: "25ab-fe0f",
    a: "0.6"
  },
  {
    n: [
      "large orange diamond"
    ],
    u: "1f536",
    a: "0.6"
  },
  {
    n: [
      "large blue diamond"
    ],
    u: "1f537",
    a: "0.6"
  },
  {
    n: [
      "small orange diamond"
    ],
    u: "1f538",
    a: "0.6"
  },
  {
    n: [
      "small blue diamond"
    ],
    u: "1f539",
    a: "0.6"
  },
  {
    n: [
      "small red triangle",
      "up-pointing red triangle"
    ],
    u: "1f53a",
    a: "0.6"
  },
  {
    n: [
      "small red triangle down",
      "down-pointing red triangle"
    ],
    u: "1f53b",
    a: "0.6"
  },
  {
    n: [
      "diamond shape with a dot inside"
    ],
    u: "1f4a0",
    a: "0.6"
  },
  {
    n: [
      "radio button"
    ],
    u: "1f518",
    a: "0.6"
  },
  {
    n: [
      "white square button"
    ],
    u: "1f533",
    a: "0.6"
  },
  {
    n: [
      "black square button"
    ],
    u: "1f532",
    a: "0.6"
  }
], RE = [
  {
    n: [
      "chequered flag",
      "checkered flag"
    ],
    u: "1f3c1",
    a: "0.6"
  },
  {
    n: [
      "triangular flag on post"
    ],
    u: "1f6a9",
    a: "0.6"
  },
  {
    n: [
      "crossed flags"
    ],
    u: "1f38c",
    a: "0.6"
  },
  {
    n: [
      "waving black flag"
    ],
    u: "1f3f4",
    a: "1.0"
  },
  {
    n: [
      "white flag",
      "waving white flag"
    ],
    u: "1f3f3-fe0f",
    a: "0.7"
  },
  {
    n: [
      "rainbow flag",
      "rainbow-flag"
    ],
    u: "1f3f3-fe0f-200d-1f308",
    a: "4.0"
  },
  {
    n: [
      "transgender flag"
    ],
    u: "1f3f3-fe0f-200d-26a7-fe0f",
    a: "13.0"
  },
  {
    n: [
      "pirate flag"
    ],
    u: "1f3f4-200d-2620-fe0f",
    a: "11.0"
  },
  {
    n: [
      "flag-ac",
      "ascension island flag"
    ],
    u: "1f1e6-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ad",
      "andorra flag"
    ],
    u: "1f1e6-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ae",
      "united arab emirates flag"
    ],
    u: "1f1e6-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-af",
      "afghanistan flag"
    ],
    u: "1f1e6-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ag",
      "antigua & barbuda flag"
    ],
    u: "1f1e6-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ai",
      "anguilla flag"
    ],
    u: "1f1e6-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-al",
      "albania flag"
    ],
    u: "1f1e6-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-am",
      "armenia flag"
    ],
    u: "1f1e6-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-ao",
      "angola flag"
    ],
    u: "1f1e6-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-aq",
      "antarctica flag"
    ],
    u: "1f1e6-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ar",
      "argentina flag"
    ],
    u: "1f1e6-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-as",
      "american samoa flag"
    ],
    u: "1f1e6-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-at",
      "austria flag"
    ],
    u: "1f1e6-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-au",
      "australia flag"
    ],
    u: "1f1e6-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-aw",
      "aruba flag"
    ],
    u: "1f1e6-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ax",
      "åland islands flag"
    ],
    u: "1f1e6-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-az",
      "azerbaijan flag"
    ],
    u: "1f1e6-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ba",
      "bosnia & herzegovina flag"
    ],
    u: "1f1e7-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-bb",
      "barbados flag"
    ],
    u: "1f1e7-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-bd",
      "bangladesh flag"
    ],
    u: "1f1e7-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-be",
      "belgium flag"
    ],
    u: "1f1e7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-bf",
      "burkina faso flag"
    ],
    u: "1f1e7-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-bg",
      "bulgaria flag"
    ],
    u: "1f1e7-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-bh",
      "bahrain flag"
    ],
    u: "1f1e7-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-bi",
      "burundi flag"
    ],
    u: "1f1e7-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-bj",
      "benin flag"
    ],
    u: "1f1e7-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-bl",
      "st. barthélemy flag"
    ],
    u: "1f1e7-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-bm",
      "bermuda flag"
    ],
    u: "1f1e7-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-bn",
      "brunei flag"
    ],
    u: "1f1e7-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-bo",
      "bolivia flag"
    ],
    u: "1f1e7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-bq",
      "caribbean netherlands flag"
    ],
    u: "1f1e7-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-br",
      "brazil flag"
    ],
    u: "1f1e7-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-bs",
      "bahamas flag"
    ],
    u: "1f1e7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-bt",
      "bhutan flag"
    ],
    u: "1f1e7-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-bv",
      "bouvet island flag"
    ],
    u: "1f1e7-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-bw",
      "botswana flag"
    ],
    u: "1f1e7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-by",
      "belarus flag"
    ],
    u: "1f1e7-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-bz",
      "belize flag"
    ],
    u: "1f1e7-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ca",
      "canada flag"
    ],
    u: "1f1e8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-cc",
      "cocos (keeling) islands flag"
    ],
    u: "1f1e8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-cd",
      "congo - kinshasa flag"
    ],
    u: "1f1e8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-cf",
      "central african republic flag"
    ],
    u: "1f1e8-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-cg",
      "congo - brazzaville flag"
    ],
    u: "1f1e8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ch",
      "switzerland flag"
    ],
    u: "1f1e8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ci",
      "côte d’ivoire flag"
    ],
    u: "1f1e8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-ck",
      "cook islands flag"
    ],
    u: "1f1e8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-cl",
      "chile flag"
    ],
    u: "1f1e8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-cm",
      "cameroon flag"
    ],
    u: "1f1e8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "cn",
      "flag-cn",
      "china flag"
    ],
    u: "1f1e8-1f1f3",
    a: "0.6"
  },
  {
    n: [
      "flag-co",
      "colombia flag"
    ],
    u: "1f1e8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-cp",
      "clipperton island flag"
    ],
    u: "1f1e8-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-cr",
      "costa rica flag"
    ],
    u: "1f1e8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-cu",
      "cuba flag"
    ],
    u: "1f1e8-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-cv",
      "cape verde flag"
    ],
    u: "1f1e8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-cw",
      "curaçao flag"
    ],
    u: "1f1e8-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-cx",
      "christmas island flag"
    ],
    u: "1f1e8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-cy",
      "cyprus flag"
    ],
    u: "1f1e8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-cz",
      "czechia flag"
    ],
    u: "1f1e8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "de",
      "flag-de",
      "germany flag"
    ],
    u: "1f1e9-1f1ea",
    a: "0.6"
  },
  {
    n: [
      "flag-dg",
      "diego garcia flag"
    ],
    u: "1f1e9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-dj",
      "djibouti flag"
    ],
    u: "1f1e9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-dk",
      "denmark flag"
    ],
    u: "1f1e9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-dm",
      "dominica flag"
    ],
    u: "1f1e9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-do",
      "dominican republic flag"
    ],
    u: "1f1e9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-dz",
      "algeria flag"
    ],
    u: "1f1e9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ea",
      "ceuta & melilla flag"
    ],
    u: "1f1ea-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ec",
      "ecuador flag"
    ],
    u: "1f1ea-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ee",
      "estonia flag"
    ],
    u: "1f1ea-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-eg",
      "egypt flag"
    ],
    u: "1f1ea-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-eh",
      "western sahara flag"
    ],
    u: "1f1ea-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-er",
      "eritrea flag"
    ],
    u: "1f1ea-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "es",
      "flag-es",
      "spain flag"
    ],
    u: "1f1ea-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-et",
      "ethiopia flag"
    ],
    u: "1f1ea-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-eu",
      "european union flag"
    ],
    u: "1f1ea-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-fi",
      "finland flag"
    ],
    u: "1f1eb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-fj",
      "fiji flag"
    ],
    u: "1f1eb-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-fk",
      "falkland islands flag"
    ],
    u: "1f1eb-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-fm",
      "micronesia flag"
    ],
    u: "1f1eb-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-fo",
      "faroe islands flag"
    ],
    u: "1f1eb-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "fr",
      "flag-fr",
      "france flag"
    ],
    u: "1f1eb-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-ga",
      "gabon flag"
    ],
    u: "1f1ec-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "gb",
      "uk",
      "flag-gb",
      "united kingdom flag"
    ],
    u: "1f1ec-1f1e7",
    a: "0.6"
  },
  {
    n: [
      "flag-gd",
      "grenada flag"
    ],
    u: "1f1ec-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ge",
      "georgia flag"
    ],
    u: "1f1ec-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-gf",
      "french guiana flag"
    ],
    u: "1f1ec-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-gg",
      "guernsey flag"
    ],
    u: "1f1ec-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-gh",
      "ghana flag"
    ],
    u: "1f1ec-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-gi",
      "gibraltar flag"
    ],
    u: "1f1ec-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-gl",
      "greenland flag"
    ],
    u: "1f1ec-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-gm",
      "gambia flag"
    ],
    u: "1f1ec-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-gn",
      "guinea flag"
    ],
    u: "1f1ec-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-gp",
      "guadeloupe flag"
    ],
    u: "1f1ec-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-gq",
      "equatorial guinea flag"
    ],
    u: "1f1ec-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-gr",
      "greece flag"
    ],
    u: "1f1ec-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-gs",
      "south georgia & south sandwich islands flag"
    ],
    u: "1f1ec-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-gt",
      "guatemala flag"
    ],
    u: "1f1ec-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-gu",
      "guam flag"
    ],
    u: "1f1ec-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-gw",
      "guinea-bissau flag"
    ],
    u: "1f1ec-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-gy",
      "guyana flag"
    ],
    u: "1f1ec-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-hk",
      "hong kong sar china flag"
    ],
    u: "1f1ed-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-hm",
      "heard & mcdonald islands flag"
    ],
    u: "1f1ed-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-hn",
      "honduras flag"
    ],
    u: "1f1ed-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-hr",
      "croatia flag"
    ],
    u: "1f1ed-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ht",
      "haiti flag"
    ],
    u: "1f1ed-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-hu",
      "hungary flag"
    ],
    u: "1f1ed-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-ic",
      "canary islands flag"
    ],
    u: "1f1ee-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-id",
      "indonesia flag"
    ],
    u: "1f1ee-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-ie",
      "ireland flag"
    ],
    u: "1f1ee-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-il",
      "israel flag"
    ],
    u: "1f1ee-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-im",
      "isle of man flag"
    ],
    u: "1f1ee-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-in",
      "india flag"
    ],
    u: "1f1ee-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-io",
      "british indian ocean territory flag"
    ],
    u: "1f1ee-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-iq",
      "iraq flag"
    ],
    u: "1f1ee-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-ir",
      "iran flag"
    ],
    u: "1f1ee-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-is",
      "iceland flag"
    ],
    u: "1f1ee-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "it",
      "flag-it",
      "italy flag"
    ],
    u: "1f1ee-1f1f9",
    a: "0.6"
  },
  {
    n: [
      "flag-je",
      "jersey flag"
    ],
    u: "1f1ef-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-jm",
      "jamaica flag"
    ],
    u: "1f1ef-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-jo",
      "jordan flag"
    ],
    u: "1f1ef-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "jp",
      "flag-jp",
      "japan flag"
    ],
    u: "1f1ef-1f1f5",
    a: "0.6"
  },
  {
    n: [
      "flag-ke",
      "kenya flag"
    ],
    u: "1f1f0-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-kg",
      "kyrgyzstan flag"
    ],
    u: "1f1f0-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-kh",
      "cambodia flag"
    ],
    u: "1f1f0-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-ki",
      "kiribati flag"
    ],
    u: "1f1f0-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-km",
      "comoros flag"
    ],
    u: "1f1f0-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-kn",
      "st. kitts & nevis flag"
    ],
    u: "1f1f0-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-kp",
      "north korea flag"
    ],
    u: "1f1f0-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "kr",
      "flag-kr",
      "south korea flag"
    ],
    u: "1f1f0-1f1f7",
    a: "0.6"
  },
  {
    n: [
      "flag-kw",
      "kuwait flag"
    ],
    u: "1f1f0-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-ky",
      "cayman islands flag"
    ],
    u: "1f1f0-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-kz",
      "kazakhstan flag"
    ],
    u: "1f1f0-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-la",
      "laos flag"
    ],
    u: "1f1f1-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-lb",
      "lebanon flag"
    ],
    u: "1f1f1-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-lc",
      "st. lucia flag"
    ],
    u: "1f1f1-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-li",
      "liechtenstein flag"
    ],
    u: "1f1f1-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-lk",
      "sri lanka flag"
    ],
    u: "1f1f1-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-lr",
      "liberia flag"
    ],
    u: "1f1f1-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ls",
      "lesotho flag"
    ],
    u: "1f1f1-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-lt",
      "lithuania flag"
    ],
    u: "1f1f1-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-lu",
      "luxembourg flag"
    ],
    u: "1f1f1-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-lv",
      "latvia flag"
    ],
    u: "1f1f1-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-ly",
      "libya flag"
    ],
    u: "1f1f1-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-ma",
      "morocco flag"
    ],
    u: "1f1f2-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-mc",
      "monaco flag"
    ],
    u: "1f1f2-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-md",
      "moldova flag"
    ],
    u: "1f1f2-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-me",
      "montenegro flag"
    ],
    u: "1f1f2-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-mf",
      "st. martin flag"
    ],
    u: "1f1f2-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-mg",
      "madagascar flag"
    ],
    u: "1f1f2-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-mh",
      "marshall islands flag"
    ],
    u: "1f1f2-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-mk",
      "north macedonia flag"
    ],
    u: "1f1f2-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ml",
      "mali flag"
    ],
    u: "1f1f2-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-mm",
      "myanmar (burma) flag"
    ],
    u: "1f1f2-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-mn",
      "mongolia flag"
    ],
    u: "1f1f2-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-mo",
      "macao sar china flag"
    ],
    u: "1f1f2-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-mp",
      "northern mariana islands flag"
    ],
    u: "1f1f2-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-mq",
      "martinique flag"
    ],
    u: "1f1f2-1f1f6",
    a: "2.0"
  },
  {
    n: [
      "flag-mr",
      "mauritania flag"
    ],
    u: "1f1f2-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ms",
      "montserrat flag"
    ],
    u: "1f1f2-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-mt",
      "malta flag"
    ],
    u: "1f1f2-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-mu",
      "mauritius flag"
    ],
    u: "1f1f2-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-mv",
      "maldives flag"
    ],
    u: "1f1f2-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-mw",
      "malawi flag"
    ],
    u: "1f1f2-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-mx",
      "mexico flag"
    ],
    u: "1f1f2-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-my",
      "malaysia flag"
    ],
    u: "1f1f2-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-mz",
      "mozambique flag"
    ],
    u: "1f1f2-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-na",
      "namibia flag"
    ],
    u: "1f1f3-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-nc",
      "new caledonia flag"
    ],
    u: "1f1f3-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ne",
      "niger flag"
    ],
    u: "1f1f3-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-nf",
      "norfolk island flag"
    ],
    u: "1f1f3-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ng",
      "nigeria flag"
    ],
    u: "1f1f3-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ni",
      "nicaragua flag"
    ],
    u: "1f1f3-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-nl",
      "netherlands flag"
    ],
    u: "1f1f3-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-no",
      "norway flag"
    ],
    u: "1f1f3-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-np",
      "nepal flag"
    ],
    u: "1f1f3-1f1f5",
    a: "2.0"
  },
  {
    n: [
      "flag-nr",
      "nauru flag"
    ],
    u: "1f1f3-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-nu",
      "niue flag"
    ],
    u: "1f1f3-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-nz",
      "new zealand flag"
    ],
    u: "1f1f3-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-om",
      "oman flag"
    ],
    u: "1f1f4-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pa",
      "panama flag"
    ],
    u: "1f1f5-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-pe",
      "peru flag"
    ],
    u: "1f1f5-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-pf",
      "french polynesia flag"
    ],
    u: "1f1f5-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-pg",
      "papua new guinea flag"
    ],
    u: "1f1f5-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-ph",
      "philippines flag"
    ],
    u: "1f1f5-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-pk",
      "pakistan flag"
    ],
    u: "1f1f5-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-pl",
      "poland flag"
    ],
    u: "1f1f5-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-pm",
      "st. pierre & miquelon flag"
    ],
    u: "1f1f5-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-pn",
      "pitcairn islands flag"
    ],
    u: "1f1f5-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-pr",
      "puerto rico flag"
    ],
    u: "1f1f5-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ps",
      "palestinian territories flag"
    ],
    u: "1f1f5-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-pt",
      "portugal flag"
    ],
    u: "1f1f5-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-pw",
      "palau flag"
    ],
    u: "1f1f5-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-py",
      "paraguay flag"
    ],
    u: "1f1f5-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-qa",
      "qatar flag"
    ],
    u: "1f1f6-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-re",
      "réunion flag"
    ],
    u: "1f1f7-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-ro",
      "romania flag"
    ],
    u: "1f1f7-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-rs",
      "serbia flag"
    ],
    u: "1f1f7-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "ru",
      "flag-ru",
      "russia flag"
    ],
    u: "1f1f7-1f1fa",
    a: "0.6"
  },
  {
    n: [
      "flag-rw",
      "rwanda flag"
    ],
    u: "1f1f7-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-sa",
      "saudi arabia flag"
    ],
    u: "1f1f8-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-sb",
      "solomon islands flag"
    ],
    u: "1f1f8-1f1e7",
    a: "2.0"
  },
  {
    n: [
      "flag-sc",
      "seychelles flag"
    ],
    u: "1f1f8-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-sd",
      "sudan flag"
    ],
    u: "1f1f8-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-se",
      "sweden flag"
    ],
    u: "1f1f8-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-sg",
      "singapore flag"
    ],
    u: "1f1f8-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-sh",
      "st. helena flag"
    ],
    u: "1f1f8-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-si",
      "slovenia flag"
    ],
    u: "1f1f8-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-sj",
      "svalbard & jan mayen flag"
    ],
    u: "1f1f8-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-sk",
      "slovakia flag"
    ],
    u: "1f1f8-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-sl",
      "sierra leone flag"
    ],
    u: "1f1f8-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-sm",
      "san marino flag"
    ],
    u: "1f1f8-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-sn",
      "senegal flag"
    ],
    u: "1f1f8-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-so",
      "somalia flag"
    ],
    u: "1f1f8-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-sr",
      "suriname flag"
    ],
    u: "1f1f8-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-ss",
      "south sudan flag"
    ],
    u: "1f1f8-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-st",
      "são tomé & príncipe flag"
    ],
    u: "1f1f8-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-sv",
      "el salvador flag"
    ],
    u: "1f1f8-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-sx",
      "sint maarten flag"
    ],
    u: "1f1f8-1f1fd",
    a: "2.0"
  },
  {
    n: [
      "flag-sy",
      "syria flag"
    ],
    u: "1f1f8-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-sz",
      "eswatini flag"
    ],
    u: "1f1f8-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ta",
      "tristan da cunha flag"
    ],
    u: "1f1f9-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-tc",
      "turks & caicos islands flag"
    ],
    u: "1f1f9-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-td",
      "chad flag"
    ],
    u: "1f1f9-1f1e9",
    a: "2.0"
  },
  {
    n: [
      "flag-tf",
      "french southern territories flag"
    ],
    u: "1f1f9-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-tg",
      "togo flag"
    ],
    u: "1f1f9-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-th",
      "thailand flag"
    ],
    u: "1f1f9-1f1ed",
    a: "2.0"
  },
  {
    n: [
      "flag-tj",
      "tajikistan flag"
    ],
    u: "1f1f9-1f1ef",
    a: "2.0"
  },
  {
    n: [
      "flag-tk",
      "tokelau flag"
    ],
    u: "1f1f9-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-tl",
      "timor-leste flag"
    ],
    u: "1f1f9-1f1f1",
    a: "2.0"
  },
  {
    n: [
      "flag-tm",
      "turkmenistan flag"
    ],
    u: "1f1f9-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-tn",
      "tunisia flag"
    ],
    u: "1f1f9-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-to",
      "tonga flag"
    ],
    u: "1f1f9-1f1f4",
    a: "2.0"
  },
  {
    n: [
      "flag-tr",
      "turkey flag"
    ],
    u: "1f1f9-1f1f7",
    a: "2.0"
  },
  {
    n: [
      "flag-tt",
      "trinidad & tobago flag"
    ],
    u: "1f1f9-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-tv",
      "tuvalu flag"
    ],
    u: "1f1f9-1f1fb",
    a: "2.0"
  },
  {
    n: [
      "flag-tw",
      "taiwan flag"
    ],
    u: "1f1f9-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "flag-tz",
      "tanzania flag"
    ],
    u: "1f1f9-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-ua",
      "ukraine flag"
    ],
    u: "1f1fa-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-ug",
      "uganda flag"
    ],
    u: "1f1fa-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-um",
      "u.s. outlying islands flag"
    ],
    u: "1f1fa-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-un",
      "united nations flag"
    ],
    u: "1f1fa-1f1f3",
    a: "4.0"
  },
  {
    n: [
      "us",
      "flag-us",
      "united states flag"
    ],
    u: "1f1fa-1f1f8",
    a: "0.6"
  },
  {
    n: [
      "flag-uy",
      "uruguay flag"
    ],
    u: "1f1fa-1f1fe",
    a: "2.0"
  },
  {
    n: [
      "flag-uz",
      "uzbekistan flag"
    ],
    u: "1f1fa-1f1ff",
    a: "2.0"
  },
  {
    n: [
      "flag-va",
      "vatican city flag"
    ],
    u: "1f1fb-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-vc",
      "st. vincent & grenadines flag"
    ],
    u: "1f1fb-1f1e8",
    a: "2.0"
  },
  {
    n: [
      "flag-ve",
      "venezuela flag"
    ],
    u: "1f1fb-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-vg",
      "british virgin islands flag"
    ],
    u: "1f1fb-1f1ec",
    a: "2.0"
  },
  {
    n: [
      "flag-vi",
      "u.s. virgin islands flag"
    ],
    u: "1f1fb-1f1ee",
    a: "2.0"
  },
  {
    n: [
      "flag-vn",
      "vietnam flag"
    ],
    u: "1f1fb-1f1f3",
    a: "2.0"
  },
  {
    n: [
      "flag-vu",
      "vanuatu flag"
    ],
    u: "1f1fb-1f1fa",
    a: "2.0"
  },
  {
    n: [
      "flag-wf",
      "wallis & futuna flag"
    ],
    u: "1f1fc-1f1eb",
    a: "2.0"
  },
  {
    n: [
      "flag-ws",
      "samoa flag"
    ],
    u: "1f1fc-1f1f8",
    a: "2.0"
  },
  {
    n: [
      "flag-xk",
      "kosovo flag"
    ],
    u: "1f1fd-1f1f0",
    a: "2.0"
  },
  {
    n: [
      "flag-ye",
      "yemen flag"
    ],
    u: "1f1fe-1f1ea",
    a: "2.0"
  },
  {
    n: [
      "flag-yt",
      "mayotte flag"
    ],
    u: "1f1fe-1f1f9",
    a: "2.0"
  },
  {
    n: [
      "flag-za",
      "south africa flag"
    ],
    u: "1f1ff-1f1e6",
    a: "2.0"
  },
  {
    n: [
      "flag-zm",
      "zambia flag"
    ],
    u: "1f1ff-1f1f2",
    a: "2.0"
  },
  {
    n: [
      "flag-zw",
      "zimbabwe flag"
    ],
    u: "1f1ff-1f1fc",
    a: "2.0"
  },
  {
    n: [
      "england flag",
      "flag-england"
    ],
    u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
    a: "5.0"
  },
  {
    n: [
      "scotland flag",
      "flag-scotland"
    ],
    u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
    a: "5.0"
  },
  {
    n: [
      "wales flag",
      "flag-wales"
    ],
    u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
    a: "5.0"
  }
], qa = {
  custom: xE,
  smileys_people: TE,
  animals_nature: NE,
  food_drink: kE,
  travel_places: BE,
  activities: OE,
  objects: PE,
  symbols: zE,
  flags: RE
}, jo = [Ft.NEUTRAL, Ft.LIGHT, Ft.MEDIUM_LIGHT, Ft.MEDIUM, Ft.MEDIUM_DARK, Ft.DARK], FE = /* @__PURE__ */ Object.entries(Ft).reduce(function(e, t) {
  var n = t[0], r = t[1];
  return e[r] = n, e;
}, {}), UE = /* @__PURE__ */ jo.reduce(function(e, t) {
  var n;
  return Object.assign(e, (n = {}, n[t] = t, n));
}, {}), kt;
(function(e) {
  e.name = "n", e.unified = "u", e.variations = "v", e.added_in = "a", e.imgUrl = "imgUrl";
})(kt || (kt = {}));
var Fa = {};
setTimeout(function() {
  af.reduce(function(e, t) {
    return wh(t), e;
  }, Fa);
});
function wh(e) {
  var t = hi(e).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
  t.forEach(function(n) {
    var r;
    Fa[n] = (r = Fa[n]) != null ? r : {}, Fa[n][lt(e)] = e;
  });
}
function hi(e) {
  var t;
  return (t = e[kt.name]) != null ? t : [];
}
function YE(e) {
  return parseFloat(e[kt.added_in]);
}
function gs(e) {
  return e ? hi(e)[0] : "";
}
function Rc(e) {
  var t = e.split("-"), n = t.splice(1, 1), r = n[0];
  return UE[r] ? t.join("-") : e;
}
function lt(e, t) {
  var n, r = e[kt.unified];
  return !t || !da(e) ? r : (n = HE(e, t)) != null ? n : r;
}
function GE(e) {
  var t;
  return (t = qa == null ? void 0 : qa[e]) != null ? t : [];
}
function yh(e, t) {
  return "" + SE(t) + e + ".png";
}
function vi(e) {
  var t;
  return (t = e[kt.variations]) != null ? t : [];
}
function da(e) {
  return vi(e).length > 0;
}
function HE(e, t) {
  return t ? vi(e).find(function(n) {
    return n.includes(t);
  }) : lt(e);
}
function ta(e) {
  if (e) {
    if (Yr[e])
      return Yr[e];
    var t = Rc(e);
    return Yr[t];
  }
}
var af = /* @__PURE__ */ Object.values(qa).flat();
function QE(e) {
  qa[Me.CUSTOM].length = 0, e.forEach(function(t) {
    var n = JE(t);
    qa[Me.CUSTOM].push(n), !Yr[n[kt.unified]] && (af.push(n), Yr[n[kt.unified]] = n, wh(n));
  });
}
function JE(e) {
  var t;
  return t = {}, t[kt.name] = e.names.map(function(n) {
    return n.toLowerCase();
  }), t[kt.unified] = e.id.toLowerCase(), t[kt.added_in] = "0", t[kt.imgUrl] = e.imgUrl, t;
}
var Yr = {};
setTimeout(function() {
  af.reduce(function(e, t) {
    return e[lt(t)] = t, da(t) && vi(t).forEach(function(n) {
      e[n] = t;
    }), e;
  }, Yr);
});
function WE(e) {
  var t = e.split("-"), n = t[1];
  return jo.includes(n) ? n : null;
}
var _E = ["2640-fe0f", "2642-fe0f", "2695-fe0f"], Io = "Search", ZE = "No results found", bh = " found. Use up and down arrow keys to navigate.", $E = "1 result" + bh, VE = "%n results" + bh;
function G0(e) {
  var t, n;
  e === void 0 && (e = {});
  var r = Ch(), a = Object.assign(r.previewConfig, (t = e.previewConfig) != null ? t : {}), i = Object.assign(r, e), o = LE(e.categories, {
    suggestionMode: i.suggestedEmojisMode
  });
  QE((n = i.customEmojis) != null ? n : []);
  var f = i.searchDisabled ? ea.PREVIEW : i.skinTonePickerLocation;
  return He({}, i, {
    categories: o,
    previewConfig: a,
    skinTonePickerLocation: f
  });
}
function Ch() {
  return {
    autoFocusSearch: !0,
    categories: vh(),
    className: "",
    customEmojis: [],
    defaultSkinTone: Ft.NEUTRAL,
    emojiStyle: mt.APPLE,
    emojiVersion: null,
    getEmojiUrl: yh,
    height: 450,
    lazyLoadEmojis: !1,
    previewConfig: He({}, KE),
    searchDisabled: !1,
    searchPlaceHolder: Io,
    searchPlaceholder: Io,
    skinTonePickerLocation: ea.SEARCH,
    skinTonesDisabled: !1,
    style: {},
    suggestedEmojisMode: Xr.FREQUENT,
    theme: Ka.LIGHT,
    unicodeToHide: new Set(_E),
    width: 350,
    reactionsDefaultOpen: !1,
    reactions: CE,
    open: !0,
    allowExpandReactions: !0
  };
}
var KE = {
  defaultEmoji: "1f60a",
  defaultCaption: "What's your mood?",
  showPreview: !0
}, qE = ["children"], Mh = /* @__PURE__ */ tn(/* @__PURE__ */ Ch());
function XE(e) {
  var t = e.children, n = gh(e, qE), r = ej(n);
  return ee(Mh.Provider, {
    value: r
  }, t);
}
function ej(e) {
  var t, n = ie(function() {
    return G0(e);
  }), r = n[0], a = n[1];
  return le(function() {
    ph(r, e) || a(G0(e));
  }, [(t = e.customEmojis) == null ? void 0 : t.length, e.open, e.emojiVersion, e.reactionsDefaultOpen, e.searchPlaceHolder, e.searchPlaceholder, e.defaultSkinTone, e.skinTonesDisabled, e.autoFocusSearch, e.emojiStyle, e.theme, e.suggestedEmojisMode, e.lazyLoadEmojis, e.className, e.height, e.width, e.searchDisabled, e.skinTonePickerLocation, e.allowExpandReactions]), r;
}
function Je() {
  return Ve(Mh);
}
var Dh = /* @__PURE__ */ ae.createContext({});
function Lh() {
  var e = ae.useContext(Dh);
  return e;
}
function tj(e) {
  var t = ae.useRef({
    onEmojiClick: e.onEmojiClick || Gi,
    onReactionClick: e.onReactionClick || e.onEmojiClick,
    onSkinToneChange: e.onSkinToneChange || Gi
  });
  return ae.useEffect(function() {
    t.current.onEmojiClick = e.onEmojiClick || Gi, t.current.onReactionClick = e.onReactionClick || e.onEmojiClick;
  }, [e.onEmojiClick, e.onReactionClick]), ae.useEffect(function() {
    t.current.onSkinToneChange = e.onSkinToneChange || Gi;
  }, [e.onSkinToneChange]), t;
}
function Gi() {
}
var Xa;
(function(e) {
  e.REACTIONS = "reactions", e.PICKER = "picker";
})(Xa || (Xa = {}));
function nj() {
  var e, t = Je(), n = t.searchPlaceHolder, r = t.searchPlaceholder;
  return (e = [n, r].find(function(a) {
    return a !== Io;
  })) != null ? e : Io;
}
function rj() {
  var e = Je(), t = e.defaultSkinTone;
  return t;
}
function Ah() {
  var e = Je(), t = e.allowExpandReactions;
  return t;
}
function Eh() {
  var e = Je(), t = e.skinTonesDisabled;
  return t;
}
function vr() {
  var e = Je(), t = e.emojiStyle;
  return t;
}
function aj() {
  var e = Je(), t = e.autoFocusSearch;
  return t;
}
function jh() {
  var e = Je(), t = e.categories;
  return t;
}
function ij() {
  var e = Je(), t = e.customEmojis;
  return t;
}
function oj() {
  var e = Je(), t = e.open;
  return t;
}
function fj(e) {
  var t, n = Lh(), r = n.current, a = (t = e === Xa.REACTIONS ? r.onReactionClick : r.onEmojiClick) != null ? t : r.onEmojiClick;
  return a || function() {
  };
}
function uj() {
  var e = Lh(), t = e.current;
  return t.onSkinToneChange || function() {
  };
}
function Ih() {
  var e = Je(), t = e.previewConfig;
  return t;
}
function sj() {
  var e = Je(), t = e.theme;
  return t;
}
function cj() {
  var e = Je(), t = e.suggestedEmojisMode;
  return t;
}
function lj() {
  var e = Je(), t = e.lazyLoadEmojis;
  return t;
}
function dj() {
  var e = Je(), t = e.className;
  return t;
}
function gj() {
  var e = Je(), t = e.height, n = e.width, r = e.style;
  return He({
    height: H0(t),
    width: H0(n)
  }, r);
}
function pj() {
  var e = Je(), t = e.reactionsDefaultOpen;
  return t;
}
function hj() {
  var e = Je(), t = e.emojiVersion;
  return t;
}
function Sh() {
  var e = Je(), t = e.searchDisabled;
  return t;
}
function xh() {
  var e = Je(), t = e.skinTonePickerLocation;
  return t;
}
function vj() {
  var e = Je(), t = e.unicodeToHide;
  return t;
}
function mj() {
  var e = Je(), t = e.reactions;
  return t;
}
function ga() {
  var e = Je(), t = e.getEmojiUrl;
  return t;
}
function H0(e) {
  return typeof e == "number" ? e + "px" : e;
}
function wj(e) {
  var t = e > 0, n = e > 1;
  return t ? n ? VE.replace("%n", e.toString()) : $E : ZE;
}
function Q0(e, t) {
  t === void 0 && (t = 0);
  var n = ie(e), r = n[0], a = n[1], i = Ce(null);
  function o(f) {
    return new Promise(function(s) {
      var u;
      i.current && clearTimeout(i.current), i.current = (u = window) == null ? void 0 : u.setTimeout(function() {
        a(f), s(f);
      }, t);
    });
  }
  return [r, o];
}
function yj() {
  var e = vj();
  return function(t) {
    return e.has(t);
  };
}
function Th() {
  var e = Ce({}), t = hj();
  return Lt(function() {
    var n = parseFloat("" + t);
    return !t || Number.isNaN(n) ? e.current : af.reduce(function(r, a) {
      return Cj(a, n) && (r[lt(a)] = !0), r;
    }, e.current);
  }, [t]);
}
function bj() {
  var e = Th(), t = yj();
  return function(r) {
    var a = Rc(lt(r));
    return !!(e[a] || t(a));
  };
}
function Cj(e, t) {
  return YE(e) > t;
}
function Mj(e) {
  le(function() {
    e(!0);
  }, [e]);
}
function Dj(e) {
  var t = e.children, n = Th(), r = rj(), a = pj(), i = Ce(Fa), o = Ce(!1), f = Ce(!1), s = Ce(n), u = Q0(Date.now(), 200), c = Q0("", 100), d = ie(!1), g = ie(r), p = ie(null), h = ie(/* @__PURE__ */ new Set()), l = ie(null), w = ie(a), m = ie(!1), y = m[0], b = m[1];
  return Mj(b), ee(Ot.Provider, {
    value: {
      activeCategoryState: p,
      activeSkinTone: g,
      disallowClickRef: o,
      disallowMouseRef: f,
      disallowedEmojisRef: s,
      emojiVariationPickerState: l,
      emojisThatFailedToLoadState: h,
      filterRef: i,
      isPastInitialLoad: y,
      searchTerm: c,
      skinToneFanOpenState: d,
      suggestedUpdateState: u,
      reactionsModeState: w
    }
  }, t);
}
var Ot = /* @__PURE__ */ tn({
  activeCategoryState: [null, function() {
  }],
  activeSkinTone: [Ft.NEUTRAL, function() {
  }],
  disallowClickRef: {
    current: !1
  },
  disallowMouseRef: {
    current: !1
  },
  disallowedEmojisRef: {
    current: {}
  },
  emojiVariationPickerState: [null, function() {
  }],
  emojisThatFailedToLoadState: [/* @__PURE__ */ new Set(), function() {
  }],
  filterRef: {
    current: {}
  },
  isPastInitialLoad: !0,
  searchTerm: ["", function() {
    return new Promise(function() {
    });
  }],
  skinToneFanOpenState: [!1, function() {
  }],
  suggestedUpdateState: [/* @__PURE__ */ Date.now(), function() {
  }],
  reactionsModeState: [!1, function() {
  }]
});
function Fc() {
  var e = Ve(Ot), t = e.filterRef;
  return t;
}
function Lj() {
  var e = Ve(Ot), t = e.disallowClickRef;
  return t;
}
function Uc() {
  var e = Ve(Ot), t = e.disallowMouseRef;
  return t;
}
function of() {
  var e = Ve(Ot), t = e.reactionsModeState;
  return t;
}
function ff() {
  var e = Ve(Ot), t = e.searchTerm;
  return t;
}
function Yc() {
  var e = Ve(Ot), t = e.activeSkinTone;
  return t;
}
function Nh() {
  var e = Ve(Ot), t = e.emojisThatFailedToLoadState;
  return t;
}
function Aj() {
  var e = Ve(Ot), t = e.isPastInitialLoad;
  return t;
}
function pa() {
  var e = Ve(Ot), t = e.emojiVariationPickerState;
  return t;
}
function mi() {
  var e = Ve(Ot), t = e.skinToneFanOpenState;
  return t;
}
function kh() {
  var e = Ve(Ot), t = e.suggestedUpdateState, n = t[0], r = t[1];
  return [n, function() {
    r(Date.now());
  }];
}
function uf() {
  var e = ff(), t = e[0];
  return !!t;
}
function xt(e) {
  e && requestAnimationFrame(function() {
    e.focus();
  });
}
function Bh(e) {
  if (e) {
    var t = e.previousElementSibling;
    xt(t);
  }
}
function Oh(e) {
  if (e) {
    var t = e.nextElementSibling;
    xt(t);
  }
}
function Ph(e) {
  if (e) {
    var t = e.firstElementChild;
    xt(t);
  }
}
function ei() {
  return document.activeElement;
}
function Ej(e) {
  var t = e.children, n = Ce(null), r = Ce(null), a = Ce(null), i = Ce(null), o = Ce(null), f = Ce(null), s = Ce(null), u = Ce(null);
  return ee(zh.Provider, {
    value: {
      AnchoredEmojiRef: r,
      BodyRef: a,
      CategoryNavigationRef: f,
      PickerMainRef: n,
      SearchInputRef: i,
      SkinTonePickerRef: o,
      VariationPickerRef: s,
      ReactionsRef: u
    }
  }, t);
}
var zh = /* @__PURE__ */ tn({
  AnchoredEmojiRef: /* @__PURE__ */ vn(),
  BodyRef: /* @__PURE__ */ vn(),
  CategoryNavigationRef: /* @__PURE__ */ vn(),
  PickerMainRef: /* @__PURE__ */ vn(),
  SearchInputRef: /* @__PURE__ */ vn(),
  SkinTonePickerRef: /* @__PURE__ */ vn(),
  VariationPickerRef: /* @__PURE__ */ vn(),
  ReactionsRef: /* @__PURE__ */ vn()
});
function Pn() {
  return Ve(zh);
}
function wi() {
  return Pn().PickerMainRef;
}
function sf() {
  return Pn().AnchoredEmojiRef;
}
function Rh() {
  var e = sf();
  return function(t) {
    t === null && e.current !== null && xt(e.current), e.current = t;
  };
}
function Pt() {
  return Pn().BodyRef;
}
function jj() {
  return Pn().ReactionsRef;
}
function zn() {
  return Pn().SearchInputRef;
}
function Gc() {
  return Pn().SkinTonePickerRef;
}
function Hc() {
  return Pn().CategoryNavigationRef;
}
function Ij() {
  return Pn().VariationPickerRef;
}
function Fh(e, t) {
  t === void 0 && (t = 0);
  var n = ev(e);
  n && requestAnimationFrame(function() {
    n.scrollTop = t;
  });
}
function Sj(e, t) {
  var n = ev(e);
  n && requestAnimationFrame(function() {
    n.scrollTop = n.scrollTop + t;
  });
}
function xj() {
  var e = Pt();
  return pe(function(t) {
    requestAnimationFrame(function() {
      e.current && (e.current.scrollTop = t);
    });
  }, [e]);
}
function cf(e) {
  if (!(!e || !bI(e)) && !e.closest(ft(De.variationPicker))) {
    var t = nv(e), n = tv(e);
    Sj(t, -($c(Rn(e)) - n));
  }
}
function lf(e) {
  var t = Xc(e);
  xt(t), cf(t);
}
function Tj(e) {
  var t = Xc(e);
  xt(t), t == null || t.click();
}
function Nj(e) {
  xt(ov(e));
}
function kj(e) {
  if (e) {
    var t = fv(e);
    if (!t)
      return lf(gf(e));
    xt(t), cf(t);
  }
}
function Bj(e) {
  if (e) {
    var t = qc(e);
    if (!t)
      return Nj(df(e));
    xt(t), cf(t);
  }
}
function Oj(e, t) {
  if (e) {
    var n = zj(e);
    if (!n)
      return t();
    xt(n), cf(n);
  }
}
function Pj(e) {
  if (e) {
    var t = Rj(e);
    return xt(t);
  }
}
function zj(e) {
  if (!e)
    return null;
  var t = uv(e), n = Rn(t), r = Vh(t, e), a = Kh(t, e), i = $h(t, e);
  if (a === 0) {
    var o = df(n);
    return o ? qh(
      na(o),
      -1,
      // last row
      i,
      r
    ) : null;
  }
  return pI(na(t), a, i, r);
}
function Rj(e) {
  if (!e)
    return null;
  var t = uv(e), n = Rn(t), r = Vh(t, e), a = Kh(t, e), i = $h(t, e);
  if (!lI(t, e)) {
    var o = gf(n);
    return o ? qh(na(o), 0, i, r) : null;
  }
  var f = gI(na(t), a, i, r);
  return f;
}
function mr() {
  var e = pa(), t = e[0], n = e[1], r = mi(), a = r[0], i = r[1], o = pe(function() {
    t && n(null), a && i(!1);
  }, [t, a, n, i]);
  return o;
}
function Uh() {
  var e = pa(), t = e[0], n = mi(), r = n[0];
  return function() {
    return !!t || r;
  };
}
function Fj() {
  var e = Uc();
  return function() {
    e.current = !0;
  };
}
function Yh() {
  var e = Uc();
  return function() {
    e.current = !1;
  };
}
function Gh() {
  var e = Uc();
  return function() {
    return e.current;
  };
}
function Uj() {
  var e = Pt(), t = Yh(), n = Gh();
  le(function() {
    var r = e.current;
    r == null || r.addEventListener("mousemove", a, {
      passive: !0
    });
    function a() {
      n() && t();
    }
    return function() {
      r == null || r.removeEventListener("mousemove", a);
    };
  }, [e, t, n]);
}
function wr() {
  var e = zn();
  return pe(function() {
    xt(e.current);
  }, [e]);
}
function Yj() {
  var e = Gc();
  return pe(function() {
    e.current && Ph(e.current);
  }, [e]);
}
function Hh() {
  var e = Hc();
  return pe(function() {
    e.current && Ph(e.current);
  }, [e]);
}
function Gj() {
  var e = Fc();
  return function t(n) {
    if (typeof n == "function")
      return t(n(e.current));
    e.current = n;
  };
}
function Qh() {
  var e = Qc(), t = zn(), n = wr();
  return function() {
    t.current && (t.current.value = ""), e(""), n();
  };
}
function Hj() {
  var e = zn(), t = Qc();
  return function(r) {
    e.current ? (e.current.value = "" + e.current.value + r, t(ps(e.current.value))) : t(ps(r));
  };
}
function Qj() {
  var e = zn(), t = Fc(), n = Gj(), r = Qc(), a = ff(), i = a[0], o = Vj(t.current, i);
  return {
    onChange: f,
    searchTerm: i,
    SearchInputRef: e,
    statusSearchResults: o
  };
  function f(s) {
    var u = t.current, c = s.toLowerCase();
    if (u != null && u[c] || c.length <= 1)
      return r(c);
    var d = $j(c, u);
    if (!d)
      return r(c);
    n(function(g) {
      var p;
      return Object.assign(g, (p = {}, p[c] = Jj(d, c), p));
    }), r(c);
  }
}
function Qc() {
  var e = ff(), t = e[1], n = wi();
  return function(a) {
    requestAnimationFrame(function() {
      t(a && (a == null ? void 0 : a.toLowerCase())).then(function() {
        Fh(n.current, 0);
      });
    });
  };
}
function Jj(e, t) {
  var n = {};
  for (var r in e) {
    var a = e[r];
    Wj(a, t) && (n[r] = a);
  }
  return n;
}
function Wj(e, t) {
  return hi(e).some(function(n) {
    return n.includes(t);
  });
}
function _j() {
  var e = Fc(), t = e.current, n = ff(), r = n[0];
  return function(a) {
    return Zj(a, t, r);
  };
}
function Zj(e, t, n) {
  var r;
  return !t || !n ? !1 : !((r = t[n]) != null && r[e]);
}
function $j(e, t) {
  if (!t)
    return null;
  if (t[e])
    return t[e];
  var n = Object.keys(t).sort(function(r, a) {
    return a.length - r.length;
  }).find(function(r) {
    return e.includes(r);
  });
  return n ? t[n] : null;
}
function ps(e) {
  return !e || typeof e != "string" ? "" : e.trim().toLowerCase();
}
function Vj(e, t) {
  var n;
  if (!(e != null && e[t]))
    return "";
  var r = ((n = Object.entries(e == null ? void 0 : e[t])) == null ? void 0 : n.length) || 0;
  return wj(r);
}
function Jh() {
  var e = Rh(), t = pa(), n = t[1];
  return function(a) {
    var i = Zc(a), o = i[0];
    o && (e(a), n(o));
  };
}
function Jc() {
  var e = xh();
  return e === ea.SEARCH;
}
function Wh() {
  var e = xh();
  return e === ea.PREVIEW;
}
var _e;
(function(e) {
  e.ArrowDown = "ArrowDown", e.ArrowUp = "ArrowUp", e.ArrowLeft = "ArrowLeft", e.ArrowRight = "ArrowRight", e.Escape = "Escape", e.Enter = "Enter", e.Space = " ";
})(_e || (_e = {}));
function Kj() {
  qj(), Xj(), eI(), tI(), nI();
}
function qj() {
  var e = wi(), t = Qh(), n = xj(), r = zn(), a = wr(), i = Uh(), o = Fj(), f = mr(), s = Lt(function() {
    return function(c) {
      var d = c.key;
      switch (o(), d) {
        case _e.Escape:
          if (c.preventDefault(), i()) {
            f();
            return;
          }
          t(), n(0), a();
          break;
      }
    };
  }, [n, t, f, a, i, o]);
  le(function() {
    var u = e.current;
    if (u)
      return u.addEventListener("keydown", s), function() {
        u.removeEventListener("keydown", s);
      };
  }, [e, r, n, s]);
}
function Xj() {
  var e = Yj(), t = wi(), n = Pt(), r = zn(), a = mi(), i = a[1], o = _h(), f = Jc(), s = Lt(function() {
    return function(c) {
      var d = c.key;
      switch (d) {
        case _e.ArrowRight:
          if (!f)
            return;
          c.preventDefault(), i(!0), e();
          break;
        case _e.ArrowDown:
          c.preventDefault(), o();
          break;
        case _e.Enter:
          c.preventDefault(), Tj(n.current);
          break;
      }
    };
  }, [e, o, i, n, f]);
  le(function() {
    var u = r.current;
    if (u)
      return u.addEventListener("keydown", s), function() {
        u.removeEventListener("keydown", s);
      };
  }, [t, r, s]);
}
function eI() {
  var e = Gc(), t = wr(), n = zn(), r = _h(), a = mi(), i = a[0], o = a[1], f = Wh(), s = Jc(), u = Wc(), c = Lt(function() {
    return (
      // eslint-disable-next-line complexity
      function(g) {
        var p = g.key;
        if (s)
          switch (p) {
            case _e.ArrowLeft:
              if (g.preventDefault(), !i)
                return t();
              J0(t);
              break;
            case _e.ArrowRight:
              if (g.preventDefault(), !i)
                return t();
              W0();
              break;
            case _e.ArrowDown:
              g.preventDefault(), i && o(!1), r();
              break;
            default:
              u(g);
              break;
          }
        if (f)
          switch (p) {
            case _e.ArrowUp:
              if (g.preventDefault(), !i)
                return t();
              J0(t);
              break;
            case _e.ArrowDown:
              if (g.preventDefault(), !i)
                return t();
              W0();
              break;
            default:
              u(g);
              break;
          }
      }
    );
  }, [i, t, o, r, u, f, s]);
  le(function() {
    var d = e.current;
    if (d)
      return d.addEventListener("keydown", c), function() {
        d.removeEventListener("keydown", c);
      };
  }, [e, n, i, c]);
}
function tI() {
  var e = wr(), t = Hc(), n = Pt(), r = Wc(), a = Lt(function() {
    return function(o) {
      var f = o.key;
      switch (f) {
        case _e.ArrowUp:
          o.preventDefault(), e();
          break;
        case _e.ArrowRight:
          o.preventDefault(), Oh(ei());
          break;
        case _e.ArrowLeft:
          o.preventDefault(), Bh(ei());
          break;
        case _e.ArrowDown:
          o.preventDefault(), lf(n.current);
          break;
        default:
          r(o);
          break;
      }
    };
  }, [n, e, r]);
  le(function() {
    var i = t.current;
    if (i)
      return i.addEventListener("keydown", a), function() {
        i.removeEventListener("keydown", a);
      };
  }, [t, n, a]);
}
function nI() {
  var e = Pt(), t = rI(), n = Jh(), r = Uh(), a = mr(), i = Wc(), o = Lt(function() {
    return (
      // eslint-disable-next-line complexity
      function(s) {
        var u = s.key, c = Gt(ei());
        switch (u) {
          case _e.ArrowRight:
            s.preventDefault(), kj(c);
            break;
          case _e.ArrowLeft:
            s.preventDefault(), Bj(c);
            break;
          case _e.ArrowDown:
            if (s.preventDefault(), r()) {
              a();
              break;
            }
            Pj(c);
            break;
          case _e.ArrowUp:
            if (s.preventDefault(), r()) {
              a();
              break;
            }
            Oj(c, t);
            break;
          case _e.Space:
            s.preventDefault(), n(s.target);
            break;
          default:
            i(s);
            break;
        }
      }
    );
  }, [t, i, n, r, a]);
  le(function() {
    var f = e.current;
    if (f)
      return f.addEventListener("keydown", o), function() {
        f.removeEventListener("keydown", o);
      };
  }, [e, o]);
}
function _h() {
  var e = Hh(), t = uf(), n = Pt();
  return pe(function() {
    return t ? lf(n.current) : e();
  }, [n, e, t]);
}
function rI() {
  var e = wr(), t = Hh(), n = uf();
  return pe(function() {
    return n ? e() : t();
  }, [e, n, t]);
}
function J0(e) {
  var t = ei();
  t && (vI(t) || e(), Oh(t));
}
function W0() {
  var e = ei();
  e && Bh(e);
}
function Wc() {
  var e = Hj(), t = wr(), n = Sh(), r = mr();
  return function(i) {
    var o = i.key;
    aI(i) || n || o.match(/(^[a-zA-Z0-9]$){1}/) && (i.preventDefault(), r(), t(), e(o));
  };
}
function aI(e) {
  var t = e.metaKey, n = e.ctrlKey, r = e.altKey;
  return t || n || r;
}
function iI(e, t, n) {
  if (t && n !== mt.NATIVE) {
    var r = lt(t);
    _0.has(r) || (vi(t).forEach(function(a) {
      var i = e(a, n);
      oI(i);
    }), _0.add(r));
  }
}
var _0 = /* @__PURE__ */ new Set();
function oI(e) {
  var t = new Image();
  t.src = e;
}
function fI() {
  var e = Pt(), t = vr(), n = ga();
  le(function() {
    if (t === mt.NATIVE)
      return;
    var r = e.current;
    return r == null || r.addEventListener("focusin", a), function() {
      r == null || r.removeEventListener("focusin", a);
    };
    function a(i) {
      var o = Gt(i.target);
      if (o) {
        var f = Zc(o), s = f[0];
        s && da(s) && iI(n, s, t);
      }
    }
  }, [e, t, n]);
}
var uI = ["width", "height"], Zh = 40;
function sI(e) {
  var t = e.children;
  return ee(Dj, null, ee(cI, null, t));
}
function cI(e) {
  var t, n = e.children, r = of(), a = r[0], i = sj(), o = uf(), f = wi(), s = dj(), u = gj();
  Kj(), fI();
  var c = u || {}, d = c.width, g = c.height, p = gh(c, uI);
  return ee("aside", {
    className: Ee(La.main, La.baseVariables, i === Ka.DARK && La.darkTheme, i === Ka.AUTO && La.autoThemeDark, (t = {}, t[De.searchActive] = o, t), a && La.reactionsMenu, s),
    ref: f,
    style: He({}, p, !a && {
      height: g,
      width: d
    })
  }, n);
}
var Z0 = {
  "--epr-emoji-variation-picker-bg-color": "var(--epr-dark-emoji-variation-picker-bg-color)",
  "--epr-hover-bg-color-reduced-opacity": "var(--epr-dark-hover-bg-color-reduced-opacity)",
  "--epr-highlight-color": "var(--epr-dark-highlight-color)",
  "--epr-text-color": "var(--epr-dark-text-color)",
  "--epr-hover-bg-color": "var(--epr-dark-hover-bg-color)",
  "--epr-focus-bg-color": "var(--epr-dark-focus-bg-color)",
  "--epr-search-input-bg-color": "var(--epr-dark-search-input-bg-color)",
  "--epr-category-label-bg-color": "var(--epr-dark-category-label-bg-color)",
  "--epr-picker-border-color": "var(--epr-dark-picker-border-color)",
  "--epr-bg-color": "var(--epr-dark-bg-color)",
  "--epr-reactions-bg-color": "var(--epr-dark-reactions-bg-color)",
  "--epr-search-input-bg-color-active": "var(--epr-dark-search-input-bg-color-active)",
  "--epr-emoji-variation-indicator-color": "var(--epr-dark-emoji-variation-indicator-color)",
  "--epr-category-icon-active-color": "var(--epr-dark-category-icon-active-color)",
  "--epr-skin-tone-picker-menu-color": "var(--epr-dark-skin-tone-picker-menu-color)"
}, La = /* @__PURE__ */ Fe.create({
  main: {
    ".": ["epr-main", De.emojiPicker],
    position: "relative",
    display: "flex",
    flexDirection: "column",
    borderWidth: "1px",
    borderStyle: "solid",
    borderRadius: "var(--epr-picker-border-radius)",
    borderColor: "var(--epr-picker-border-color)",
    backgroundColor: "var(--epr-bg-color)",
    overflow: "hidden",
    transition: "all 0.3s ease-in-out, background-color 0.1s ease-in-out",
    // @ts-expect-error - need to work on this
    "*": {
      boxSizing: "border-box",
      fontFamily: "sans-serif"
    }
  },
  baseVariables: {
    "--": {
      "--epr-highlight-color": "#007aeb",
      "--epr-hover-bg-color": "#f1f8ff",
      "--epr-hover-bg-color-reduced-opacity": "#f1f8ff80",
      "--epr-focus-bg-color": "#e0f0ff",
      "--epr-text-color": "#858585",
      "--epr-search-input-bg-color": "#f6f6f6",
      "--epr-picker-border-color": "#e7e7e7",
      "--epr-bg-color": "#fff",
      "--epr-reactions-bg-color": "#ffffff90",
      "--epr-category-icon-active-color": "#6aa8de",
      "--epr-skin-tone-picker-menu-color": "#ffffff95",
      "--epr-horizontal-padding": "10px",
      "--epr-picker-border-radius": "8px",
      /* Header */
      "--epr-search-border-color": "var(--epr-highlight-color)",
      "--epr-header-padding": "15px var(--epr-horizontal-padding)",
      /* Skin Tone Picker */
      "--epr-active-skin-tone-indicator-border-color": "var(--epr-highlight-color)",
      "--epr-active-skin-hover-color": "var(--epr-hover-bg-color)",
      /* Search */
      "--epr-search-input-bg-color-active": "var(--epr-search-input-bg-color)",
      "--epr-search-input-padding": "0 30px",
      "--epr-search-input-border-radius": "8px",
      "--epr-search-input-height": "40px",
      "--epr-search-input-text-color": "var(--epr-text-color)",
      "--epr-search-input-placeholder-color": "var(--epr-text-color)",
      "--epr-search-bar-inner-padding": "var(--epr-horizontal-padding)",
      /*  Category Navigation */
      "--epr-category-navigation-button-size": "30px",
      /* Variation Picker */
      "--epr-emoji-variation-picker-height": "45px",
      "--epr-emoji-variation-picker-bg-color": "var(--epr-bg-color)",
      /*  Preview */
      "--epr-preview-height": "70px",
      "--epr-preview-text-size": "14px",
      "--epr-preview-text-padding": "0 var(--epr-horizontal-padding)",
      "--epr-preview-border-color": "var(--epr-picker-border-color)",
      "--epr-preview-text-color": "var(--epr-text-color)",
      /* Category */
      "--epr-category-padding": "0 var(--epr-horizontal-padding)",
      /*  Category Label */
      "--epr-category-label-bg-color": "#ffffffe6",
      "--epr-category-label-text-color": "var(--epr-text-color)",
      "--epr-category-label-padding": "0 var(--epr-horizontal-padding)",
      "--epr-category-label-height": Zh + "px",
      /*  Emoji */
      "--epr-emoji-size": "30px",
      "--epr-emoji-padding": "5px",
      "--epr-emoji-fullsize": "calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)",
      "--epr-emoji-hover-color": "var(--epr-hover-bg-color)",
      "--epr-emoji-variation-indicator-color": "var(--epr-picker-border-color)",
      "--epr-emoji-variation-indicator-color-hover": "var(--epr-text-color)",
      /* Z-Index */
      "--epr-header-overlay-z-index": "3",
      "--epr-emoji-variations-indictator-z-index": "1",
      "--epr-category-label-z-index": "2",
      "--epr-skin-variation-picker-z-index": "5",
      "--epr-preview-z-index": "6",
      /* Dark Theme Variables */
      "--epr-dark": "#000",
      "--epr-dark-emoji-variation-picker-bg-color": "var(--epr-dark)",
      "--epr-dark-highlight-color": "#c0c0c0",
      "--epr-dark-text-color": "var(--epr-highlight-color)",
      "--epr-dark-hover-bg-color": "#363636f6",
      "--epr-dark-hover-bg-color-reduced-opacity": "#36363680",
      "--epr-dark-focus-bg-color": "#474747",
      "--epr-dark-search-input-bg-color": "#333333",
      "--epr-dark-category-label-bg-color": "#222222e6",
      "--epr-dark-picker-border-color": "#151617",
      "--epr-dark-bg-color": "#222222",
      "--epr-dark-reactions-bg-color": "#22222290",
      "--epr-dark-search-input-bg-color-active": "var(--epr-dark)",
      "--epr-dark-emoji-variation-indicator-color": "#444",
      "--epr-dark-category-icon-active-color": "#3271b7",
      "--epr-dark-skin-tone-picker-menu-color": "#22222295"
    }
  },
  autoThemeDark: {
    ".": De.autoTheme,
    "@media (prefers-color-scheme: dark)": {
      "--": Z0
    }
  },
  darkTheme: {
    ".": De.darkTheme,
    "--": Z0
  },
  reactionsMenu: {
    ".": "epr-reactions",
    height: "50px",
    display: "inline-flex",
    backgroundColor: "var(--epr-reactions-bg-color)",
    // @ts-expect-error - need to work on this
    backdropFilter: "blur(8px)",
    "--": {
      "--epr-picker-border-radius": "50px"
    }
  }
});
function $h(e, t) {
  if (!e || !t)
    return 0;
  var n = e.getBoundingClientRect().width, r = t.getBoundingClientRect().width;
  return Math.floor(n / r);
}
function Vh(e, t) {
  if (!e || !t)
    return 0;
  var n = t.getBoundingClientRect().width, r = t.getBoundingClientRect().left, a = e.getBoundingClientRect().left;
  return Math.floor((r - a) / n);
}
function Kh(e, t) {
  if (!e || !t)
    return 0;
  var n = t.getBoundingClientRect().height, r = t.getBoundingClientRect().top, a = e.getBoundingClientRect().top;
  return Math.round((r - a) / n);
}
function lI(e, t) {
  if (!e || !t)
    return !1;
  var n = t.getBoundingClientRect().height, r = t.getBoundingClientRect().top, a = e.getBoundingClientRect().top, i = e.getBoundingClientRect().height;
  return Math.round(r - a + n) < i;
}
function _c(e, t, n) {
  if (t === -1) {
    var r = Math.floor((e.length - 1) / n), a = r * n, i = e.length - 1;
    return e.slice(a, i + 1);
  }
  return e.slice(t * n, (t + 1) * n);
}
function dI(e, t, n) {
  var r = t + 1;
  return r * n > e.length ? [] : _c(e, r, n);
}
function qh(e, t, n, r) {
  var a = _c(e, t, n);
  return a[r] || a[a.length - 1] || null;
}
function gI(e, t, n, r) {
  var a = dI(e, t, n);
  return a[r] || a[a.length - 1] || null;
}
function pI(e, t, n, r) {
  var a = _c(e, t - 1, n);
  return a[r] || a[a.length - 1] || null;
}
function hI(e, t, n) {
  if (n === void 0 && (n = 0), !e || !t.length)
    return null;
  var r = e.getBoundingClientRect().top, a = e.getBoundingClientRect().bottom, i = r + mI(e), o = t.find(function(f) {
    var s = f.getBoundingClientRect().top, u = f.getBoundingClientRect().bottom, c = f.clientHeight * n, d = s + c, g = u - c;
    return d < i ? !1 : d >= r && d <= a || g >= r && g <= a;
  });
  return o || null;
}
function vI(e) {
  return !!e.nextElementSibling;
}
function mI(e) {
  for (var t = Array.from(e.querySelectorAll(ft(De.label))), n = 0, r = t; n < r.length; n++) {
    var a = r[n], i = a.getBoundingClientRect().height;
    if (i > 0)
      return i;
  }
  return Zh;
}
var So = "button" + /* @__PURE__ */ ft(De.emoji), wI = /* @__PURE__ */ [So, ft(De.visible), ":not(" + ft(De.hidden) + ")"].join("");
function Gt(e) {
  var t;
  return (t = e == null ? void 0 : e.closest(So)) != null ? t : null;
}
function Zc(e) {
  var t = rv(e), n = Vc(e);
  if (!t)
    return [];
  var r = ta(n ?? t);
  return r ? [r, n] : [];
}
function yI(e) {
  var t;
  return !!(e != null && e.matches(So) || !(e == null || (t = e.parentElement) == null) && t.matches(So));
}
function $0(e) {
  var t;
  return (t = e == null ? void 0 : e.clientHeight) != null ? t : 0;
}
function Xh(e) {
  if (!e)
    return 0;
  var t = Gt(e), n = Rn(t), r = $c(n);
  return V0(t) + V0(n) + r;
}
function $c(e) {
  var t, n;
  if (!e)
    return 0;
  var r = e.querySelector(ft(De.categoryContent));
  return ((t = e == null ? void 0 : e.clientHeight) != null ? t : 0) - ((n = r == null ? void 0 : r.clientHeight) != null ? n : 0);
}
function bI(e) {
  return e ? tv(e) < $c(Rn(e)) : !1;
}
function ev(e) {
  return e ? e.matches(ft(De.scrollBody)) ? e : e.querySelector(ft(De.scrollBody)) : null;
}
function tv(e) {
  var t, n;
  return e ? Xh(e) - ((t = (n = nv(e)) == null ? void 0 : n.scrollTop) != null ? t : 0) : 0;
}
function nv(e) {
  var t;
  return e && (t = e.closest(ft(De.scrollBody))) != null ? t : null;
}
function CI(e) {
  var t = Gt(e), n = Rn(t);
  return K0(t) + K0(n);
}
function V0(e) {
  var t;
  return (t = e == null ? void 0 : e.offsetTop) != null ? t : 0;
}
function K0(e) {
  var t;
  return (t = e == null ? void 0 : e.offsetLeft) != null ? t : 0;
}
function Vc(e) {
  var t;
  return (t = MI(Gt(e), "unified")) != null ? t : null;
}
function rv(e) {
  var t = Vc(e);
  return t ? Rc(t) : null;
}
function av(e) {
  return e ? {
    unified: Vc(e),
    originalUnified: rv(e)
  } : {
    unified: null,
    originalUnified: null
  };
}
function MI(e, t) {
  var n;
  return (n = DI(e)[t]) != null ? n : null;
}
function DI(e) {
  var t;
  return (t = e == null ? void 0 : e.dataset) != null ? t : {};
}
function Kc(e) {
  return e.classList.contains(De.visible);
}
function iv(e) {
  return e ? e.classList.contains(De.hidden) : !0;
}
function na(e) {
  return e ? Array.from(e.querySelectorAll(wI)) : [];
}
function ov(e) {
  if (!e)
    return null;
  var t = na(e), n = t.slice(-1), r = n[0];
  return r ? Kc(r) ? r : qc(r) : null;
}
function fv(e) {
  var t = e.nextElementSibling;
  return t ? Kc(t) ? t : fv(t) : Xc(gf(e));
}
function qc(e) {
  var t = e.previousElementSibling;
  return t ? Kc(t) ? t : qc(t) : ov(df(e));
}
function Xc(e) {
  if (!e)
    return null;
  var t = na(e);
  return hI(e, t, 0.1);
}
function df(e) {
  var t = Rn(e);
  if (!t)
    return null;
  var n = t.previousElementSibling;
  return n ? iv(n) ? df(n) : n : null;
}
function gf(e) {
  var t = Rn(e);
  if (!t)
    return null;
  var n = t.nextElementSibling;
  return n ? iv(n) ? gf(n) : n : null;
}
function Rn(e) {
  return e ? e.closest(ft(De.category)) : null;
}
function uv(e) {
  return e ? e.closest(ft(De.categoryContent)) : null;
}
function sv(e) {
  return e.split("-").map(function(t) {
    return String.fromCodePoint(parseInt(t, 16));
  }).join("");
}
var cv = "epr_suggested";
function lv(e) {
  try {
    var t, n, r;
    if (!((t = window) != null && t.localStorage))
      return [];
    var a = JSON.parse((n = (r = window) == null ? void 0 : r.localStorage.getItem(cv)) != null ? n : "[]");
    return e === Xr.FREQUENT ? a.sort(function(i, o) {
      return o.count - i.count;
    }) : a;
  } catch {
    return [];
  }
}
function LI(e, t) {
  var n = lv(), r = lt(e, t), a = lt(e), i = n.find(function(s) {
    var u = s.unified;
    return u === r;
  }), o;
  i ? o = [i].concat(n.filter(function(s) {
    return s !== i;
  })) : (i = {
    unified: r,
    original: a,
    count: 0
  }, o = [i].concat(n)), i.count++, o.length = Math.min(o.length, 14);
  try {
    var f;
    (f = window) == null || f.localStorage.setItem(cv, JSON.stringify(o));
  } catch {
  }
}
function AI(e) {
  return e.category === Me.CUSTOM;
}
function dv(e) {
  return e.imgUrl !== void 0;
}
function gv(e, t) {
  var n = Ce(), r = Jh(), a = Lj(), i = pa(), o = i[1], f = mr(), s = Yc(), u = s[0], c = fj(t), d = kh(), g = d[1], p = ga(), h = vr(), l = pe(function(b) {
    if (!a.current) {
      f();
      var C = q0(b), M = C[0], S = C[1];
      if (!(!M || !S)) {
        var I = WE(S) || u;
        g(), LI(M, I), c(EI(M, I, h, p), b);
      }
    }
  }, [u, f, a, c, g, p, h]), w = pe(function(b) {
    var C;
    n.current && clearTimeout(n.current);
    var M = q0(b), S = M[0];
    !S || !da(S) || (n.current = (C = window) == null ? void 0 : C.setTimeout(function() {
      a.current = !0, n.current = void 0, f(), r(b.target), o(S);
    }, 500));
  }, [a, f, r, o]), m = pe(function() {
    n.current ? (clearTimeout(n.current), n.current = void 0) : a.current && requestAnimationFrame(function() {
      a.current = !1;
    });
  }, [a]);
  le(function() {
    if (e.current) {
      var y = e.current;
      return y.addEventListener("click", l, {
        passive: !0
      }), y.addEventListener("mousedown", w, {
        passive: !0
      }), y.addEventListener("mouseup", m, {
        passive: !0
      }), function() {
        y == null || y.removeEventListener("click", l), y == null || y.removeEventListener("mousedown", w), y == null || y.removeEventListener("mouseup", m);
      };
    }
  }, [e, l, w, m]);
}
function q0(e) {
  var t = e == null ? void 0 : e.target;
  return yI(t) ? Zc(t) : [];
}
function EI(e, t, n, r) {
  var a = hi(e);
  if (dv(e)) {
    var i = lt(e);
    return {
      activeSkinTone: t,
      emoji: i,
      getImageUrl: function() {
        return e.imgUrl;
      },
      imageUrl: e.imgUrl,
      isCustom: !0,
      names: a,
      unified: i,
      unifiedWithoutSkinTone: i
    };
  }
  var o = lt(e, t);
  return {
    activeSkinTone: t,
    emoji: sv(o),
    getImageUrl: function(s) {
      return s === void 0 && (s = n ?? mt.APPLE), r(o, s);
    },
    imageUrl: r(o, n ?? mt.APPLE),
    isCustom: !1,
    names: a,
    unified: o,
    unifiedWithoutSkinTone: lt(e)
  };
}
function yi(e) {
  return ee("button", Object.assign({
    type: "button"
  }, e, {
    className: Ee(jI.button, e.className)
  }), e.children);
}
var jI = /* @__PURE__ */ Fe.create({
  button: {
    ".": "epr-btn",
    cursor: "pointer",
    border: "0",
    background: "none",
    outline: "none"
  }
});
function II(e) {
  var t, n = e.emojiNames, r = e.unified, a = e.hidden, i = e.hiddenOnSearch, o = e.showVariations, f = o === void 0 ? !0 : o, s = e.hasVariations, u = e.children, c = e.className, d = e.noBackground, g = d === void 0 ? !1 : d;
  return ee(yi, {
    className: Ee(ru.emoji, a && Pc.hidden, i && hr.hiddenOnSearch, (t = {}, t[De.visible] = !a && !i, t), !!(s && f) && ru.hasVariations, g && ru.noBackground, c),
    "data-unified": r,
    "aria-label": SI(n),
    "data-full-name": n
  }, u);
}
function SI(e) {
  var t;
  return e[0].match("flag-") && (t = e[1]) != null ? t : e[0];
}
var ru = /* @__PURE__ */ Fe.create({
  emoji: {
    ".": De.emoji,
    position: "relative",
    width: "var(--epr-emoji-fullsize)",
    height: "var(--epr-emoji-fullsize)",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    borderRadius: "8px",
    overflow: "hidden",
    transition: "background-color 0.2s",
    ":hover": {
      backgroundColor: "var(--epr-emoji-hover-color)"
    },
    ":focus": {
      backgroundColor: "var(--epr-focus-bg-color)"
    }
  },
  noBackground: {
    background: "none",
    ":hover": {
      backgroundColor: "transparent",
      background: "none"
    },
    ":focus": {
      backgroundColor: "transparent",
      background: "none"
    }
  },
  hasVariations: {
    ".": De.emojiHasVariations,
    ":after": {
      content: "",
      display: "block",
      width: "0",
      height: "0",
      right: "0px",
      bottom: "1px",
      position: "absolute",
      borderLeft: "4px solid transparent",
      borderRight: "4px solid transparent",
      transform: "rotate(135deg)",
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color)",
      zIndex: "var(--epr-emoji-variations-indictator-z-index)"
    },
    ":hover:after": {
      borderBottom: "4px solid var(--epr-emoji-variation-indicator-color-hover)"
    }
  }
}), xo = /* @__PURE__ */ Fe.create({
  external: {
    ".": De.external,
    fontSize: "0"
  },
  common: {
    alignSelf: "center",
    justifySelf: "center",
    display: "block"
  }
});
function X0(e) {
  var t = e.emojiName, n = e.style, r = e.lazyLoad, a = r === void 0 ? !1 : r, i = e.imgUrl, o = e.onError, f = e.className;
  return ee("img", {
    src: i,
    alt: t,
    className: Ee(xI.emojiImag, xo.external, xo.common, f),
    loading: a ? "lazy" : "eager",
    onError: o,
    style: n
  });
}
var xI = /* @__PURE__ */ Fe.create({
  emojiImag: {
    ".": "epr-emoji-img",
    maxWidth: "var(--epr-emoji-fullsize)",
    maxHeight: "var(--epr-emoji-fullsize)",
    minWidth: "var(--epr-emoji-fullsize)",
    minHeight: "var(--epr-emoji-fullsize)",
    padding: "var(--epr-emoji-padding)"
  }
});
function TI(e) {
  var t = e.unified, n = e.style, r = e.className;
  return ee("span", {
    className: Ee(NI.nativeEmoji, xo.common, xo.external, r),
    "data-unified": t,
    style: n
  }, sv(t));
}
var NI = /* @__PURE__ */ Fe.create({
  nativeEmoji: {
    ".": "epr-emoji-native",
    fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
    position: "relative",
    lineHeight: "100%",
    fontSize: "var(--epr-emoji-size)",
    textAlign: "center",
    alignSelf: "center",
    justifySelf: "center",
    letterSpacing: "0",
    padding: "var(--epr-emoji-padding)"
  }
});
function hs(e) {
  var t = e.emoji, n = e.unified, r = e.emojiStyle, a = e.size, i = e.lazyLoad, o = e.getEmojiUrl, f = o === void 0 ? yh : o, s = e.className, u = Nh(), c = u[1], d = {};
  a && (d.width = d.height = d.fontSize = a + "px");
  var g = t || ta(n);
  if (!g)
    return null;
  if (dv(g))
    return ee(X0, {
      style: d,
      emojiName: n,
      emojiStyle: mt.NATIVE,
      lazyLoad: i,
      imgUrl: g.imgUrl,
      onError: p,
      className: s
    });
  return ee(ms, null, r === mt.NATIVE ? ee(TI, {
    unified: n,
    style: d,
    className: s
  }) : ee(X0, {
    style: d,
    emojiName: gs(g),
    emojiStyle: r,
    lazyLoad: i,
    imgUrl: f(n, r),
    onError: p,
    className: s
  }));
  function p() {
    c(function(h) {
      return new Set(h).add(n);
    });
  }
}
function pf(e) {
  var t = e.emoji, n = e.unified, r = e.hidden, a = e.hiddenOnSearch, i = e.emojiStyle, o = e.showVariations, f = o === void 0 ? !0 : o, s = e.size, u = e.lazyLoad, c = e.getEmojiUrl, d = e.className, g = e.noBackground, p = g === void 0 ? !1 : g, h = da(t);
  return ee(II, {
    hasVariations: h,
    showVariations: f,
    hidden: r,
    hiddenOnSearch: a,
    emojiNames: hi(t),
    unified: n,
    noBackground: p
  }, ee(hs, {
    unified: n,
    emoji: t,
    size: s,
    emojiStyle: i,
    lazyLoad: u,
    getEmojiUrl: c,
    className: d
  }));
}
var kI = "data:image/svg+xml;base64,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";
function BI() {
  var e = of(), t = e[1];
  return ee(yi, {
    "aria-label": "Show all Emojis",
    title: "Show all Emojis",
    tabIndex: 0,
    className: Ee(OI.plusSign),
    onClick: function() {
      return t(!1);
    }
  });
}
var OI = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  plusSign: {
    fontSize: "20px",
    padding: "17px",
    color: "var(--epr-text-color)",
    borderRadius: "50%",
    textAlign: "center",
    lineHeight: "100%",
    width: "20px",
    height: "20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    transition: "background-color 0.2s ease-in-out",
    ":after": {
      content: "",
      minWidth: "20px",
      minHeight: "20px",
      backgroundImage: "url(" + kI + ")",
      backgroundColor: "transparent",
      backgroundRepeat: "no-repeat",
      backgroundSize: "20px",
      backgroundPositionY: "0"
    },
    ":hover": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      // @ts-ignore
      ":after": {
        backgroundPositionY: "-20px"
      }
    },
    ":focus": {
      color: "var(--epr-highlight-color)",
      backgroundColor: "var(--epr-hover-bg-color-reduced-opacity)",
      // @ts-ignore
      ":after": {
        backgroundPositionY: "-40px"
      }
    }
  }
}, /* @__PURE__ */ Bn("plusSign", {
  ":after": {
    backgroundPositionY: "-40px"
  },
  ":hover:after": {
    backgroundPositionY: "-60px"
  }
})));
function PI() {
  var e = of(), t = e[0], n = jj(), r = mj();
  gv(n, Xa.REACTIONS);
  var a = vr(), i = Ah();
  return t ? ee("ul", {
    className: Ee(e1.list, !t && Pc.hidden),
    ref: n
  }, r.map(function(o) {
    return ee("li", {
      key: o
    }, ee(pf, {
      emoji: ta(o),
      emojiStyle: a,
      unified: o,
      showVariations: !1,
      className: Ee(e1.emojiButton),
      noBackground: !0
    }));
  }), i ? ee("li", null, ee(BI, null)) : null) : null;
}
var e1 = /* @__PURE__ */ Fe.create({
  list: {
    listStyle: "none",
    margin: "0",
    padding: "0 5px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%"
  },
  emojiButton: {
    ":hover": {
      transform: "scale(1.2)"
    },
    ":focus": {
      transform: "scale(1.2)"
    },
    ":active": {
      transform: "scale(1.1)"
    },
    transition: "transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)"
  }
});
function zI(e) {
  var t = mr();
  le(function() {
    var n = e.current;
    if (!n)
      return;
    n.addEventListener("scroll", r, {
      passive: !0
    });
    function r() {
      t();
    }
    return function() {
      n == null || n.removeEventListener("scroll", r);
    };
  }, [e, t]);
}
function RI() {
  var e = Nh(), t = e[0], n = _j();
  return function(r) {
    var a = lt(r), i = t.has(a), o = n(a);
    return {
      failedToLoad: i,
      filteredOut: o,
      hidden: i || o
    };
  };
}
function pv(e) {
  var t = e.categoryConfig, n = e.children, r = e.hidden, a = e.hiddenOnSearch, i = zc(t), o = mh(t);
  return ee("li", {
    className: Ee(au.category, r && Pc.hidden, a && hr.hiddenOnSearch),
    "data-name": i,
    "aria-label": o
  }, ee("h2", {
    className: Ee(au.label)
  }, o), ee("div", {
    className: Ee(au.categoryContent)
  }, n));
}
var au = /* @__PURE__ */ Fe.create({
  category: {
    ".": De.category,
    ":not(:has(.epr-visible))": {
      display: "none"
    }
  },
  categoryContent: {
    ".": De.categoryContent,
    display: "grid",
    gridGap: "0",
    gridTemplateColumns: "repeat(auto-fill, var(--epr-emoji-fullsize))",
    justifyContent: "space-between",
    margin: "var(--epr-category-padding)",
    position: "relative"
  },
  label: {
    ".": De.label,
    alignItems: "center",
    // @ts-expect-error - backdropFilter is a valid CSS property
    backdropFilter: "blur(3px)",
    backgroundColor: "var(--epr-category-label-bg-color)",
    color: "var(--epr-category-label-text-color)",
    display: "flex",
    fontSize: "16px",
    fontWeight: "bold",
    height: "var(--epr-category-label-height)",
    margin: "0",
    padding: "var(--epr-category-label-padding)",
    position: "sticky",
    textTransform: "capitalize",
    top: "0",
    width: "100%",
    zIndex: "var(--epr-category-label-z-index)"
  }
}), iu = !1;
function FI() {
  var e = ie(iu), t = e[0], n = e[1];
  return le(function() {
    n(!0), iu = !0;
  }, []), t || iu;
}
function UI(e) {
  var t = e.categoryConfig, n = kh(), r = n[0], a = FI(), i = cj(), o = ga(), f = Lt(
    function() {
      var u;
      return (u = lv(i)) != null ? u : [];
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, i]
  ), s = vr();
  return a ? ee(pv, {
    categoryConfig: t,
    hiddenOnSearch: !0,
    hidden: f.length === 0
  }, f.map(function(u) {
    var c = ta(u.original);
    return c ? ee(pf, {
      showVariations: !1,
      unified: u.unified,
      emojiStyle: s,
      emoji: c,
      key: u.unified,
      getEmojiUrl: o
    }) : null;
  })) : null;
}
function YI() {
  var e = jh(), t = Ce(0);
  return ee("ul", {
    className: Ee(HI.emojiList)
  }, e.map(function(n) {
    var r = zc(n);
    return r === Me.SUGGESTED ? ee(UI, {
      key: r,
      categoryConfig: n
    }) : ee(GI, {
      key: r,
      category: r,
      categoryConfig: n,
      renderdCategoriesCountRef: t
    });
  }));
}
function GI(e) {
  var t = e.category, n = e.categoryConfig, r = e.renderdCategoriesCountRef, a = RI(), i = lj(), o = vr(), f = Aj(), s = Yc(), u = s[0], c = bj(), d = ga(), g = !Eh(), p = !f && r.current > 0 ? [] : GE(t);
  p.length > 0 && r.current++;
  var h = 0, l = p.map(function(w) {
    var m = lt(w, u), y = a(w), b = y.failedToLoad, C = y.filteredOut, M = y.hidden, S = c(w);
    return (M || S) && h++, S ? null : ee(pf, {
      showVariations: g,
      key: m,
      emoji: w,
      unified: m,
      hidden: b,
      hiddenOnSearch: C,
      emojiStyle: o,
      lazyLoad: i,
      getEmojiUrl: d
    });
  });
  return ee(pv, {
    categoryConfig: n,
    // Indicates that there are no visible emojis
    // Hence, the category should be hidden
    hidden: h === l.length
  }, l);
}
var HI = /* @__PURE__ */ Fe.create({
  emojiList: {
    ".": De.emojiList,
    listStyle: "none",
    margin: "0",
    padding: "0"
  }
}), QI = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=", Gr;
(function(e) {
  e[e.Up = 0] = "Up", e[e.Down = 1] = "Down";
})(Gr || (Gr = {}));
function JI() {
  var e = sf(), t = Ij(), n = pa(), r = n[0], a = vr(), i = _I(t), o = i.getTop, f = i.getMenuDirection, s = Rh(), u = WI(t), c = ga(), d = Gt(e.current), g = !!(r && d && da(r) && d.classList.contains(De.emojiHasVariations));
  le(function() {
    g && lf(t.current);
  }, [t, g, e]);
  var p, h;
  return !g && e.current ? s(null) : (p = o(), h = u()), ee("div", {
    ref: t,
    className: Ee(Hi.variationPicker, f() === Gr.Down && Hi.pointingUp, g && Hi.visible),
    style: {
      top: p
    }
  }, g && r ? [lt(r)].concat(vi(r)).slice(0, 6).map(function(l) {
    return ee(pf, {
      key: l,
      emoji: r,
      unified: l,
      emojiStyle: a,
      showVariations: !1,
      getEmojiUrl: c
    });
  }) : null, ee("div", {
    className: Ee(Hi.pointer),
    style: h
  }));
}
function WI(e) {
  var t = sf();
  return function() {
    var r = {};
    if (!e.current)
      return r;
    if (t.current) {
      var a = Gt(t.current), i = CI(a);
      if (!a)
        return r;
      r.left = i + (a == null ? void 0 : a.clientWidth) / 2;
    }
    return r;
  };
}
function _I(e) {
  var t = sf(), n = Pt(), r = Gr.Up;
  return {
    getMenuDirection: a,
    getTop: i
  };
  function a() {
    return r;
  }
  function i() {
    r = Gr.Up;
    var o = 0;
    if (!e.current)
      return 0;
    var f = $0(e.current);
    if (t.current) {
      var s, u = n.current, c = Gt(t.current), d = $0(c);
      o = Xh(c);
      var g = (s = u == null ? void 0 : u.scrollTop) != null ? s : 0;
      g > o - f && (r = Gr.Down, o += d + f);
    }
    return o - f;
  }
}
var Hi = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  variationPicker: {
    ".": De.variationPicker,
    position: "absolute",
    right: "15px",
    left: "15px",
    padding: "5px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
    borderRadius: "3px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    opacity: "0",
    visibility: "hidden",
    pointerEvents: "none",
    top: "-100%",
    border: "1px solid var(--epr-picker-border-color)",
    height: "var(--epr-emoji-variation-picker-height)",
    zIndex: "var(--epr-skin-variation-picker-z-index)",
    background: "var(--epr-emoji-variation-picker-bg-color)",
    transform: "scale(0.9)",
    transition: "transform 0.1s ease-out, opacity 0.2s ease-out"
  },
  visible: {
    opacity: "1",
    visibility: "visible",
    pointerEvents: "all",
    transform: "scale(1)"
  },
  pointingUp: {
    ".": "pointing-up",
    transformOrigin: "center 0%",
    transform: "scale(0.9)"
  },
  ".pointing-up": {
    pointer: {
      top: "0",
      transform: "rotate(180deg) translateY(100%) translateX(18px)"
    }
  },
  pointer: {
    ".": "epr-emoji-pointer",
    content: "",
    position: "absolute",
    width: "25px",
    height: "15px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "50px 15px",
    top: "100%",
    transform: "translateX(-18px)",
    backgroundImage: "url(" + QI + ")"
  }
}, /* @__PURE__ */ Bn("pointer", {
  backgroundPosition: "-25px 0"
})));
function ZI() {
  var e = Pt();
  return zI(e), gv(e, Xa.PICKER), Uj(), ee("div", {
    className: Ee($I.body, hr.hiddenOnReactions),
    ref: e
  }, ee(JI, null), ee(YI, null));
}
var $I = /* @__PURE__ */ Fe.create({
  body: {
    ".": De.scrollBody,
    flex: "1",
    overflowY: "scroll",
    overflowX: "hidden",
    position: "relative"
  }
});
function VI(e, t) {
  if (!e || !t)
    return 0;
  var n = e.getBoundingClientRect(), r = t.getBoundingClientRect();
  return r.height - (n.y - r.y);
}
function KI(e, t) {
  var n = Pt(), r = Gh(), a = Yh();
  le(function() {
    if (!e)
      return;
    var i = n.current;
    i == null || i.addEventListener("keydown", s, {
      passive: !0
    }), i == null || i.addEventListener("mouseover", u, !0), i == null || i.addEventListener("focus", o, !0), i == null || i.addEventListener("mouseout", f, {
      passive: !0
    }), i == null || i.addEventListener("blur", f, !0);
    function o(c) {
      var d = Gt(c.target);
      if (!d)
        return f();
      var g = av(d), p = g.unified, h = g.originalUnified;
      if (!p || !h)
        return f();
      t({
        unified: p,
        originalUnified: h
      });
    }
    function f(c) {
      if (c) {
        var d = c.relatedTarget;
        if (!Gt(d))
          return t(null);
      }
      t(null);
    }
    function s(c) {
      c.key === "Escape" && t(null);
    }
    function u(c) {
      if (!r()) {
        var d = Gt(c.target);
        if (d) {
          var g = VI(d, i), p = d.getBoundingClientRect().height;
          if (g < p)
            return qI(d, t);
          xt(d);
        }
      }
    }
    return function() {
      i == null || i.removeEventListener("mouseover", u), i == null || i.removeEventListener("mouseout", f), i == null || i.removeEventListener("focus", o, !0), i == null || i.removeEventListener("blur", f, !0), i == null || i.removeEventListener("keydown", s);
    };
  }, [n, e, t, r, a]);
}
function qI(e, t) {
  var n, r = av(e), a = r.unified, i = r.originalUnified;
  !a || !i || ((n = document.activeElement) == null || n.blur == null || n.blur(), t({
    unified: a,
    originalUnified: i
  }));
}
var Qi, ti;
(function(e) {
  e.ROW = "FlexRow", e.COLUMN = "FlexColumn";
})(ti || (ti = {}));
function hv(e) {
  var t = e.children, n = e.className, r = e.style, a = r === void 0 ? {} : r, i = e.direction, o = i === void 0 ? ti.ROW : i;
  return ee("div", {
    style: He({}, a),
    className: Ee(t1.flex, n, t1[o])
  }, t);
}
var t1 = /* @__PURE__ */ Fe.create((Qi = {
  flex: {
    display: "flex"
  }
}, Qi[ti.ROW] = {
  flexDirection: "row"
}, Qi[ti.COLUMN] = {
  flexDirection: "column"
}, Qi));
function XI(e) {
  var t = e.className, n = e.style, r = n === void 0 ? {} : n;
  return ee("div", {
    style: He({
      flex: 1
    }, r),
    className: Ee(t)
  });
}
function eS(e) {
  var t = e.children, n = e.className, r = e.style;
  return ee("div", {
    style: He({}, r, {
      position: "absolute"
    }),
    className: n
  }, t);
}
function hf(e) {
  var t = e.children, n = e.className, r = e.style;
  return ee("div", {
    style: He({}, r, {
      position: "relative"
    }),
    className: n
  }, t);
}
function tS(e) {
  var t = e.isOpen, n = e.onClick, r = e.isActive, a = e.skinToneVariation, i = e.style;
  return ee(yi, {
    style: i,
    onClick: n,
    className: Ee("epr-tone-" + a, ou.tone, !t && ou.closedTone, r && ou.active),
    tabIndex: t ? 0 : -1,
    "aria-pressed": r,
    "aria-label": "Skin tone " + FE[a]
  });
}
var ou = /* @__PURE__ */ Fe.create({
  closedTone: {
    opacity: "0",
    zIndex: "0"
  },
  active: {
    ".": "epr-active",
    zIndex: "1",
    opacity: "1"
  },
  tone: {
    ".": "epr-tone",
    ":hover": {
      boxShadow: "0 0 0 3px var(--epr-active-skin-hover-color)"
    },
    ":focus": {
      boxShadow: "0 0 0 3px var(--epr-focus-bg-color)"
    },
    // @ts-ignore
    "&.epr-tone-neutral": {
      backgroundColor: "#ffd225"
    },
    "&.epr-tone-1f3fb": {
      backgroundColor: "#ffdfbd"
    },
    "&.epr-tone-1f3fc": {
      backgroundColor: "#e9c197"
    },
    "&.epr-tone-1f3fd": {
      backgroundColor: "#c88e62"
    },
    "&.epr-tone-1f3fe": {
      backgroundColor: "#a86637"
    },
    "&.epr-tone-1f3ff": {
      backgroundColor: "#60463a"
    }
  }
}), Ia = 28;
function nS() {
  return ee(hf, {
    style: {
      height: Ia
    }
  }, ee(eS, {
    style: {
      bottom: 0,
      right: 0
    }
  }, ee(vv, {
    direction: ni.VERTICAL
  })));
}
function vv(e) {
  var t = e.direction, n = t === void 0 ? ni.HORIZONTAL : t, r = Gc(), a = Eh(), i = mi(), o = i[0], f = i[1], s = Yc(), u = s[0], c = s[1], d = uj(), g = mr(), p = wr();
  if (a)
    return null;
  var h = Ia * jo.length + "px", l = o ? h : Ia + "px", w = n === ni.VERTICAL;
  return ee(hf, {
    className: Ee(Aa.skinTones, w && Aa.vertical, o && Aa.open, w && o && Aa.verticalShadow),
    style: w ? {
      flexBasis: l,
      height: l
    } : {
      flexBasis: l
    }
  }, ee("div", {
    className: Ee(Aa.select),
    ref: r
  }, jo.map(function(m, y) {
    var b = m === u;
    return ee(tS, {
      key: m,
      skinToneVariation: m,
      isOpen: o,
      style: {
        transform: Ee(w ? "translateY(-" + y * (o ? Ia : 0) + "px)" : "translateX(-" + y * (o ? Ia : 0) + "px)", o && b && "scale(1.3)")
      },
      isActive: b,
      onClick: function() {
        o ? (c(m), d(m), p()) : f(!0), g();
      }
    });
  })));
}
var ni;
(function(e) {
  e.VERTICAL = "epr-vertical", e.HORIZONTAL = "epr-horizontal";
})(ni || (ni = {}));
var Aa = /* @__PURE__ */ Fe.create({
  skinTones: {
    ".": "epr-skin-tones",
    "--": {
      "--epr-skin-tone-size": "15px"
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    transition: "all 0.3s ease-in-out",
    padding: "10px 0"
  },
  vertical: {
    padding: "9px",
    alignItems: "flex-end",
    flexDirection: "column",
    borderRadius: "6px",
    border: "1px solid var(--epr-bg-color)"
  },
  verticalShadow: {
    boxShadow: "0px 0 7px var(--epr-picker-border-color)"
  },
  open: {
    // @ts-ignore
    backdropFilter: "blur(5px)",
    background: "var(--epr-skin-tone-picker-menu-color)",
    // @ts-ignore
    ".epr-active:after": {
      content: "",
      position: "absolute",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      borderRadius: "5px",
      border: "1px solid var(--epr-active-skin-tone-indicator-border-color)"
    }
  },
  select: {
    ".": "epr-skin-tone-select",
    position: "relative",
    width: "var(--epr-skin-tone-size)",
    height: "var(--epr-skin-tone-size)",
    // @ts-ignore
    "> button": {
      width: "var(--epr-skin-tone-size)",
      display: "block",
      cursor: "pointer",
      borderRadius: "4px",
      height: "var(--epr-skin-tone-size)",
      position: "absolute",
      right: "0",
      transition: "transform 0.3s ease-in-out, opacity 0.35s ease-in-out",
      zIndex: "0",
      boxShadow: "0 0 0 0px var(--epr-active-skin-hover-color)"
    }
  }
});
function rS() {
  var e = Ih(), t = Wh();
  return e.showPreview ? ee(hv, {
    className: Ee(fo.preview, hr.hiddenOnReactions)
  }, ee(aS, null), ee(XI, null), t ? ee(nS, null) : null) : null;
}
function aS() {
  var e, t = Ih(), n = ie(null), r = n[0], a = n[1], i = vr(), o = pa(), f = o[0], s = ga();
  KI(t.showPreview, a);
  var u = ta((e = r == null ? void 0 : r.unified) != null ? e : r == null ? void 0 : r.originalUnified), c = u != null && r != null;
  return ee(d, null);
  function d() {
    var g = f ?? ta(t.defaultEmoji);
    if (!g)
      return null;
    var p = f ? gs(f) : t.defaultCaption;
    return ee(ms, null, ee("div", null, c ? ee(hs, {
      unified: r == null ? void 0 : r.unified,
      emoji: u,
      emojiStyle: i,
      size: 45,
      getEmojiUrl: s,
      className: Ee(fo.emoji)
    }) : g ? ee(hs, {
      unified: lt(g),
      emoji: g,
      emojiStyle: i,
      size: 45,
      getEmojiUrl: s,
      className: Ee(fo.emoji)
    }) : null), ee("div", {
      className: Ee(fo.label)
    }, c ? gs(u) : p));
  }
}
var fo = /* @__PURE__ */ Fe.create({
  preview: {
    alignItems: "center",
    borderTop: "1px solid var(--epr-preview-border-color)",
    height: "var(--epr-preview-height)",
    padding: "0 var(--epr-horizontal-padding)",
    position: "relative",
    zIndex: "var(--epr-preview-z-index)"
  },
  label: {
    color: "var(--epr-preview-text-color)",
    fontSize: "var(--epr-preview-text-size)",
    padding: "var(--epr-preview-text-padding)",
    textTransform: "capitalize"
  },
  emoji: {
    padding: "0"
  }
});
function iS(e) {
  var t;
  return (t = e == null ? void 0 : e.getAttribute("data-name")) != null ? t : null;
}
function oS(e) {
  var t = Pt();
  le(function() {
    var n = /* @__PURE__ */ new Map(), r = t.current, a = new IntersectionObserver(function(i) {
      if (r) {
        for (var o = yE(i), f; !(f = o()).done; ) {
          var s = f.value, u = iS(s.target);
          n.set(u, s.intersectionRatio);
        }
        var c = Array.from(n), d = c[c.length - 1];
        if (d[1] == 1)
          return e(d[0]);
        for (var g = 0, p = c; g < p.length; g++) {
          var h = p[g], l = h[0], w = h[1];
          if (w) {
            e(l);
            break;
          }
        }
      }
    }, {
      threshold: [0, 1]
    });
    r == null || r.querySelectorAll(ft(De.category)).forEach(function(i) {
      a.observe(i);
    });
  }, [t, e]);
}
function fS() {
  var e = Pt(), t = wi();
  return function(r) {
    var a;
    if (e.current) {
      var i = (a = e.current) == null ? void 0 : a.querySelector('[data-name="' + r + '"]');
      if (i) {
        var o = i.offsetTop || 0;
        Fh(t.current, o);
      }
    }
  };
}
function uS() {
  var e = ij();
  return e ? e.length === 0 : !1;
}
var sS = "data:image/svg+xml;base64,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";
function cS(e) {
  var t, n = e.isActiveCategory, r = e.category, a = e.allowNavigation, i = e.categoryConfig, o = e.onClick;
  return ee(yi, {
    tabIndex: a ? 0 : -1,
    className: Ee(dS.catBtn, hr.categoryBtn, "epr-icn-" + r, (t = {}, t[De.active] = n, t)),
    onClick: o,
    "aria-label": mh(i),
    "aria-selected": n,
    role: "tab",
    "aria-controls": "epr-category-nav-id"
  });
}
var n1 = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 3)"
}, lS = {
  backgroundPositionY: "calc(var(--epr-category-navigation-button-size) * 2)"
}, r1 = {
  ":not(.epr-search-active)": {
    catBtn: {
      ":hover": n1,
      "&.epr-active": n1
    }
  }
}, dS = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  catBtn: {
    ".": "epr-cat-btn",
    display: "inline-block",
    transition: "opacity 0.2s ease-in-out",
    position: "relative",
    height: "var(--epr-category-navigation-button-size)",
    width: "var(--epr-category-navigation-button-size)",
    backgroundSize: "calc(var(--epr-category-navigation-button-size) * 10)",
    outline: "none",
    backgroundPosition: "0 0",
    backgroundImage: "url(" + sS + ")",
    ":focus:before": {
      content: "",
      position: "absolute",
      top: "-2px",
      left: "-2px",
      right: "-2px",
      bottom: "-2px",
      border: "2px solid var(--epr-category-icon-active-color)",
      borderRadius: "50%"
    },
    // @ts-ignore
    "&.epr-icn-suggested": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -8)"
    },
    "&.epr-icn-custom": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -9)"
    },
    "&.epr-icn-activities": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -4)"
    },
    "&.epr-icn-animals_nature": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -1)"
    },
    "&.epr-icn-flags": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -7)"
    },
    "&.epr-icn-food_drink": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -2)"
    },
    "&.epr-icn-objects": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -5)"
    },
    "&.epr-icn-smileys_people": {
      backgroundPositionX: "0px"
    },
    "&.epr-icn-symbols": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -6)"
    },
    "&.epr-icn-travel_places": {
      backgroundPositionX: "calc(var(--epr-category-navigation-button-size) * -3)"
    }
  }
}, /* @__PURE__ */ Bn("catBtn", lS), {
  ".epr-dark-theme": /* @__PURE__ */ He({}, r1),
  ".epr-auto-theme": /* @__PURE__ */ He({}, r1)
}));
function gS() {
  var e = ie(null), t = e[0], n = e[1], r = fS();
  oS(n);
  var a = uf(), i = jh(), o = Hc(), f = uS();
  return ee("div", {
    className: Ee(pS.nav),
    role: "tablist",
    "aria-label": "Category navigation",
    id: "epr-category-nav-id",
    ref: o
  }, i.map(function(s) {
    var u = zc(s), c = u === t;
    if (AI(s) && f)
      return null;
    var d = !a && !c;
    return ee(cS, {
      key: u,
      category: u,
      isActiveCategory: c,
      allowNavigation: d,
      categoryConfig: s,
      onClick: function() {
        n(u), r(u);
      }
    });
  }));
}
var pS = /* @__PURE__ */ Fe.create({
  nav: {
    ".": "epr-category-nav",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    padding: "var(--epr-header-padding)"
  },
  ".epr-search-active": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  },
  ".epr-main:has(input:not(:placeholder-shown))": {
    nav: {
      opacity: "0.3",
      cursor: "default",
      pointerEvents: "none"
    }
  }
}), mv = "data:image/svg+xml;base64,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";
function hS() {
  var e = Qh();
  return ee(yi, {
    className: Ee(a1.btnClearSearch, hr.visibleOnSearchOnly),
    onClick: e,
    "aria-label": "Clear",
    title: "Clear"
  }, ee("div", {
    className: Ee(a1.icnClearnSearch)
  }));
}
var vS = {
  ":hover": {
    "> .epr-icn-clear-search": {
      backgroundPositionY: "-60px"
    }
  }
}, a1 = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + mv + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ Bn("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ Bn("btnClearSearch", vS))), fu = /* @__PURE__ */ ft(De.emojiPicker) + " " + /* @__PURE__ */ ft(De.emojiList), wv = /* @__PURE__ */ ["button", ft(De.emoji)].join(""), mS = /* @__PURE__ */ ft(De.category);
function wS(e) {
  var t = e.value;
  if (!t)
    return null;
  var n = yS(t);
  return ee("style", null, `
    ` + fu + " " + wv + ` {
      display: none;
    }


    ` + fu + " " + n + ` {
      display: flex;
    }

    ` + fu + " " + mS + ":not(:has(" + n + `)) {
      display: none;
    }
  `);
}
function yS(e) {
  return [wv, '[data-full-name*="', ps(e), '"]'].join("");
}
var bS = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+";
function CS() {
  return ee("div", {
    className: Ee(MS.icnSearch)
  });
}
var MS = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  icnSearch: {
    ".": "epr-icn-search",
    content: "",
    position: "absolute",
    top: "50%",
    left: "var(--epr-search-bar-inner-padding)",
    transform: "translateY(-50%)",
    width: "20px",
    height: "20px",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "0 0",
    backgroundSize: "20px",
    backgroundImage: "url(" + bS + ")"
  }
}, /* @__PURE__ */ Bn("icnSearch", {
  backgroundPositionY: "-20px"
})));
function DS() {
  var e = Sh(), t = Jc();
  return e ? null : ee(hv, {
    className: Ee(uo.overlay)
  }, ee(LS, null), t ? ee(vv, null) : null);
}
function LS() {
  var e = ie(0), t = e[0], n = e[1], r = mr(), a = zn(), i = nj(), o = aj(), f = Qj(), s = f.statusSearchResults, u = f.searchTerm, c = f.onChange, d = a == null ? void 0 : a.current, g = d == null ? void 0 : d.value;
  return ee(hf, {
    className: Ee(uo.searchContainer)
  }, ee(wS, {
    value: g
  }), ee("input", {
    // eslint-disable-next-line jsx-a11y/no-autofocus
    autoFocus: o,
    "aria-label": "Type to search for an emoji",
    onFocus: r,
    className: Ee(uo.search),
    type: "text",
    "aria-controls": "epr-search-id",
    placeholder: i,
    onChange: function(h) {
      n(t + 1), setTimeout(function() {
        var l, w;
        c((l = h == null || (w = h.target) == null ? void 0 : w.value) != null ? l : g);
      });
    },
    ref: a
  }), u ? ee("div", {
    role: "status",
    className: Ee("epr-status-search-results", uo.visuallyHidden),
    "aria-live": "polite",
    id: "epr-search-id",
    "aria-atomic": "true"
  }, s) : null, ee(CS, null), ee(hS, null));
}
var uo = /* @__PURE__ */ Fe.create(/* @__PURE__ */ He({
  overlay: {
    padding: "var(--epr-header-padding)",
    zIndex: "var(--epr-header-overlay-z-index)"
  },
  searchContainer: {
    ".": "epr-search-container",
    flex: "1",
    display: "block",
    minWidth: "0"
  },
  visuallyHidden: {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    overflow: "hidden",
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px"
  },
  search: {
    outline: "none",
    transition: "all 0.2s ease-in-out",
    color: "var(--epr-search-input-text-color)",
    borderRadius: "var(--epr-search-input-border-radius)",
    padding: "var(--epr-search-input-padding)",
    height: "var(--epr-search-input-height)",
    backgroundColor: "var(--epr-search-input-bg-color)",
    border: "1px solid var(--epr-search-input-bg-color)",
    width: "100%",
    ":focus": {
      backgroundColor: "var(--epr-search-input-bg-color-active)",
      border: "1px solid var(--epr-search-border-color)"
    },
    "::placeholder": {
      color: "var(--epr-search-input-placeholder-color)"
    }
  },
  btnClearSearch: {
    ".": "epr-btn-clear-search",
    position: "absolute",
    right: "var(--epr-search-bar-inner-padding)",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    top: "50%",
    transform: "translateY(-50%)",
    padding: "0",
    borderRadius: "50%",
    ":hover": {
      background: "var(--epr-hover-bg-color)"
    },
    ":focus": {
      background: "var(--epr-hover-bg-color)"
    }
  },
  icnClearnSearch: {
    ".": "epr-icn-clear-search",
    backgroundColor: "transparent",
    backgroundRepeat: "no-repeat",
    backgroundSize: "20px",
    height: "20px",
    width: "20px",
    backgroundImage: "url(" + mv + ")",
    ":hover": {
      backgroundPositionY: "-20px"
    },
    ":focus": {
      backgroundPositionY: "-20px"
    }
  }
}, /* @__PURE__ */ Bn("icnClearnSearch", {
  backgroundPositionY: "-40px"
}), /* @__PURE__ */ Bn("btnClearSearch", {
  ":hover > .epr-icn-clear-search": {
    backgroundPositionY: "-60px"
  }
})));
function AS() {
  return ee(hf, {
    className: Ee("epr-header", hr.hiddenOnReactions)
  }, ee(DS, null), ee(gS, null));
}
function ES(e) {
  return ee(Ej, null, ee(bE, null), ee(XE, Object.assign({}, e), ee(jS, null)));
}
function jS() {
  var e = of(), t = e[0], n = Ah(), r = ie(!t), a = r[0], i = r[1], o = oj();
  return le(function() {
    t && !n || a || i(!0);
  }, [a, n, t]), o ? ee(sI, null, ee(PI, null), ee(IS, {
    renderAll: a
  })) : null;
}
function IS(e) {
  var t = e.renderAll;
  return t ? ee(ms, null, ee(AS, null), ee(ZI, null), ee(rS, null)) : null;
}
var SS = /* @__PURE__ */ vs(ES, ph), xS = /* @__PURE__ */ function(e) {
  mE(t, e);
  function t(r) {
    var a;
    return a = e.call(this, r) || this, a.state = {
      hasError: !1
    }, a;
  }
  t.getDerivedStateFromError = function() {
    return {
      hasError: !0
    };
  };
  var n = t.prototype;
  return n.componentDidCatch = function(a, i) {
    console.error("Emoji Picker React failed to render:", a, i);
  }, n.render = function() {
    return this.state.hasError ? null : this.props.children;
  }, t;
}(f1);
function TS(e) {
  var t = tj({
    onEmojiClick: e.onEmojiClick,
    onReactionClick: e.onReactionClick,
    onSkinToneChange: e.onSkinToneChange
  });
  return ee(xS, null, ee(Dh.Provider, {
    value: t
  }, ee(SS, Object.assign({}, e))));
}
const NS = (e) => /* @__PURE__ */ L.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ...e }, /* @__PURE__ */ L.createElement("path", { d: "M16 13H14C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13H8C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13Z" }), /* @__PURE__ */ L.createElement("path", { d: "M10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44771 8.44772 9 9 9C9.55228 9 10 9.44771 10 10Z" }), /* @__PURE__ */ L.createElement("path", { d: "M15 11C15.5523 11 16 10.5523 16 10C16 9.44771 15.5523 9 15 9C14.4477 9 14 9.44771 14 10C14 10.5523 14.4477 11 15 11Z" }), /* @__PURE__ */ L.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z" })), kS = () => {
  const { activeMenu: e, setActiveMenu: t, close: n } = gr(), r = yt(), a = e === "EMOJI", i = () => {
    t(a ? null : "EMOJI");
  }, o = hp(), { context: f, refs: s } = Zo({
    nodeId: o,
    open: a,
    onOpenChange: i,
    placement: "bottom",
    middleware: [Wo({ padding: 5 }), Jo({ padding: 5 })]
  });
  return /* @__PURE__ */ ue("div", { className: "relative", ref: s.setReference, children: [
    /* @__PURE__ */ E(Wt, { content: "Insert emoji", placement: "top", children: /* @__PURE__ */ E(
      lr,
      {
        onMouseDown: (u) => {
          u.preventDefault(), u.stopPropagation(), t("EMOJI");
        },
        children: /* @__PURE__ */ E(NS, {})
      }
    ) }),
    /* @__PURE__ */ E(vp, { id: o, children: a ? /* @__PURE__ */ E(QD, { context: f, children: /* @__PURE__ */ E(
      "div",
      {
        className: "z-10 w-[400px]",
        onMouseDown: (u) => u.stopPropagation(),
        ref: f.refs.setFloating,
        style: f.floatingStyles,
        children: /* @__PURE__ */ E(
          TS,
          {
            onEmojiClick: ({ emoji: u }) => {
              H.insertNodes(r, {
                type: Ba,
                emoji: u,
                children: [{ text: "" }]
              }), H.move(r), n(), G.focus(r);
            },
            width: "100%",
            previewConfig: { showPreview: !1 },
            suggestedEmojisMode: Xr.RECENT,
            emojiStyle: mt.NATIVE
          }
        )
      }
    ) }) : null })
  ] });
}, yv = () => /* @__PURE__ */ ue("div", { className: "flex gap-1", children: [
  /* @__PURE__ */ E(q9, {}),
  /* @__PURE__ */ E(Z9, {}),
  /* @__PURE__ */ E(X9, {}),
  /* @__PURE__ */ E(tu, { format: Hu, icon: Y9 }),
  /* @__PURE__ */ E(tu, { format: Qu, icon: G9 }),
  /* @__PURE__ */ E(tu, { format: Ju, icon: J9 }),
  /* @__PURE__ */ E(z0, {}),
  /* @__PURE__ */ E(R0, { format: ac, icon: Q9 }),
  /* @__PURE__ */ E(R0, { format: ic, icon: H9 }),
  /* @__PURE__ */ E(Fi, { format: zg, icon: F9 }),
  /* @__PURE__ */ E(Fi, { format: Rg, icon: z9 }),
  /* @__PURE__ */ E(Fi, { format: Fg, icon: U9 }),
  /* @__PURE__ */ E(Fi, { format: Ug, icon: R9 }),
  /* @__PURE__ */ E(z0, { isButton: !0 }),
  /* @__PURE__ */ E(LL, {}),
  /* @__PURE__ */ E(oE, {}),
  /* @__PURE__ */ E(kS, {})
] }), BS = fr(({ className: e, ...t }, n) => /* @__PURE__ */ E(
  "div",
  {
    ...t,
    ref: n,
    className: e,
    style: {
      paddingBottom: "10px",
      marginBottom: "5px",
      borderBottom: "2px solid #eee",
      display: "flex",
      gap: "4px"
    },
    "data-slate-toolbar": "true",
    children: /* @__PURE__ */ E(yv, {})
  }
)), OS = () => {
  const e = yt(), t = Og(), [n, r] = ie(!1), { refs: a, floatingStyles: i, context: o } = Zo({
    placement: "top",
    open: n,
    onOpenChange: r,
    middleware: [sp(), Wo(), Jo()],
    whileElementsMounted: mc
  }), f = Cc(o), { getFloatingProps: s } = Mc([f]), { isMounted: u, styles: c } = eL(o);
  return le(() => {
    function d(p) {
      var h;
      (h = a.floating.current) != null && h.contains(p.target) || nr(() => {
        const { selection: l } = e;
        if (!l || !t || z.isCollapsed(l) || v.string(e, l) === "") {
          r(!1);
          return;
        } else {
          const w = window.getSelection(), m = w == null ? void 0 : w.getRangeAt(0);
          m && (a.setReference({
            getBoundingClientRect: () => m.getBoundingClientRect(),
            getClientRects: () => m.getClientRects()
          }), r(!0));
        }
      });
    }
    function g(p) {
      var h, l;
      (h = a.floating.current) != null && h.contains(p.target) || (l = window.getSelection()) != null && l.isCollapsed && r(!1);
    }
    return qt(window, "mouseup", d), qt(window, "mousedown", g), () => {
      cn(window, "mouseup", d), cn(window, "mousedown", g);
    };
  }, [a, e, t]), u ? /* @__PURE__ */ E(
    "div",
    {
      ref: a.setFloating,
      style: {
        ...i,
        ...c,
        background: "rgba(255, 255, 255, 0.5)",
        backdropFilter: "blur(12px)",
        padding: "4px",
        zIndex: "1",
        borderRadius: "4px"
      },
      ...s(),
      children: /* @__PURE__ */ E(yv, {})
    }
  ) : null;
};
var PS = {
  /**
   * Check if a value is a `History` object.
   */
  isHistory(e) {
    return et(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || Sn.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || Sn.isOperationList(e.undos[0].operations));
  }
}, uu = /* @__PURE__ */ new WeakMap(), su = /* @__PURE__ */ new WeakMap(), xr = {
  /**
   * Check if a value is a `HistoryEditor` object.
   */
  isHistoryEditor(e) {
    return PS.isHistory(e.history) && v.isEditor(e);
  },
  /**
   * Get the merge flag's current value.
   */
  isMerging(e) {
    return su.get(e);
  },
  /**
   * Get the saving flag's current value.
   */
  isSaving(e) {
    return uu.get(e);
  },
  /**
   * Redo to the previous saved state.
   */
  redo(e) {
    e.redo();
  },
  /**
   * Undo to the previous saved state.
   */
  undo(e) {
    e.undo();
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without merging any of
   * the new operations into previous save point in the history.
   */
  withoutMerging(e, t) {
    var n = xr.isMerging(e);
    su.set(e, !1), t(), su.set(e, n);
  },
  /**
   * Apply a series of changes inside a synchronous `fn`, without saving any of
   * their operations into the history.
   */
  withoutSaving(e, t) {
    var n = xr.isSaving(e);
    uu.set(e, !1), t(), uu.set(e, n);
  }
}, zS = (e) => {
  var t = e, {
    apply: n
  } = t;
  return t.history = {
    undos: [],
    redos: []
  }, t.redo = () => {
    var {
      history: r
    } = t, {
      redos: a
    } = r;
    if (a.length > 0) {
      var i = a[a.length - 1];
      i.selectionBefore && H.setSelection(t, i.selectionBefore), xr.withoutSaving(t, () => {
        v.withoutNormalizing(t, () => {
          for (var o of i.operations)
            t.apply(o);
        });
      }), r.redos.pop(), t.writeHistory("undos", i);
    }
  }, t.undo = () => {
    var {
      history: r
    } = t, {
      undos: a
    } = r;
    if (a.length > 0) {
      var i = a[a.length - 1];
      xr.withoutSaving(t, () => {
        v.withoutNormalizing(t, () => {
          var o = i.operations.map(Sn.inverse).reverse();
          for (var f of o)
            t.apply(f);
          i.selectionBefore && H.setSelection(t, i.selectionBefore);
        });
      }), t.writeHistory("redos", i), r.undos.pop();
    }
  }, t.apply = (r) => {
    var {
      operations: a,
      history: i
    } = t, {
      undos: o
    } = i, f = o[o.length - 1], s = f && f.operations[f.operations.length - 1], u = xr.isSaving(t), c = xr.isMerging(t);
    if (u == null && (u = FS(r)), u) {
      if (c == null && (f == null ? c = !1 : a.length !== 0 ? c = !0 : c = RS(r, s)), f && c)
        f.operations.push(r);
      else {
        var d = {
          operations: [r],
          selectionBefore: t.selection
        };
        t.writeHistory("undos", d);
      }
      for (; o.length > 100; )
        o.shift();
      i.redos = [];
    }
    n(r);
  }, t.writeHistory = (r, a) => {
    t.history[r].push(a);
  }, t;
}, RS = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && j.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && j.equals(e.path, t.path)), FS = (e, t) => e.type !== "set_selection";
const US = (e) => !!e.type, YS = (e) => {
  const t = GS(zS(xM(Ub())));
  return e && (t.children = e), t.descendants = ({
    type: n
  }) => {
    let r = Array.from(te.descendants(t));
    return n && (r = r.filter(
      ([a]) => US(a) && a.type === n
    )), r.map(([a]) => a);
  }, t;
}, GS = (e) => {
  const { isInline: t, isVoid: n, markableVoid: r, insertText: a, insertData: i } = e;
  return e.isInline = (o) => [Yg, Gg, ka, Ki, qi, Ba].includes(o.type) || t(o), e.insertText = (o) => {
    o && as(o) ? is(e, o) : a(o);
  }, e.insertData = (o) => {
    const f = o.getData("text/plain");
    f && as(f) ? is(e, f) : i(o);
  }, e.isVoid = (o) => [ka, Ki, qi, Ba].includes(o.type) ? !0 : n(o), e.markableVoid = (o) => [ka, Ki, qi, Ba].includes(o.type) || r(o), e;
}, HS = (e) => {
  const t = Lt(
    () => e || YS(),
    [e]
  ), n = pe(() => {
    H.delete(t, {
      at: {
        anchor: v.start(t, []),
        focus: v.end(t, [])
      }
    });
  }, [t]);
  return [t, { clear: n, setValue: (i) => {
    t.children = i, t.onChange();
  }, getValue: () => t.children }];
}, i1 = (e, { name: t, userId: n, email: r }) => {
  const a = {
    type: ka,
    name: t,
    userId: n,
    email: r,
    children: [{ text: "" }]
  };
  H.insertNodes(e, a), H.move(e);
}, QS = ({
  editor: e,
  options: t
}) => {
  const [n, r] = ie(!1), { refs: a, context: i } = Zo({
    placement: "bottom",
    open: n,
    onOpenChange: r,
    middleware: [sp(), Wo(), Jo()],
    whileElementsMounted: mc
  }), [o, f] = ie(), [s, u] = ie(0), [c, d] = ie(""), g = t.filter(({ name: w }) => w.toLowerCase().startsWith(c.toLowerCase())).sort(({ name: w }, { name: m }) => w < m ? 0 : 1).slice(0, 10);
  le(() => {
    if (o && g.length > 0) {
      const w = G.toDOMRange(e, o);
      a.setReference({
        getBoundingClientRect: () => w.getBoundingClientRect(),
        getClientRects: () => w.getClientRects()
      }), r(!0);
    } else
      r(!1);
  }, [g.length, e, s, c, o, a]);
  const p = pe(
    (w) => {
      if (o && g.length > 0)
        switch (w.key) {
          case "ArrowDown": {
            w.preventDefault();
            const m = s >= g.length - 1 ? 0 : s + 1;
            u(m);
            break;
          }
          case "ArrowUp": {
            w.preventDefault();
            const m = s <= 0 ? g.length - 1 : s - 1;
            u(m);
            break;
          }
          case "Tab":
          case "Enter":
            w.preventDefault(), H.select(e, o), i1(e, g[s]), f(null);
            break;
          case "Escape":
            w.preventDefault(), f(null);
            break;
        }
    },
    [g, e, s, o]
  );
  return {
    onEditorChange: () => {
      const { selection: w } = e;
      if (w && z.isCollapsed(w)) {
        const [m] = z.edges(w), y = v.before(e, m, { unit: "word" }), b = y && v.before(e, y), C = b && v.range(e, b, m), M = C && v.string(e, C), S = M && M.match(/^@(\w+)$/), I = v.after(e, m), N = v.range(e, m, I), F = v.string(e, N).match(/^(\s|$)/);
        if (S && F) {
          f(C), d(S[1]), u(0);
          return;
        }
      }
      f(null);
    },
    onEditorKeyDown: p,
    onMentionClick: (w) => {
      o && H.select(e, o), i1(e, w), f(null);
    },
    showMentions: n,
    currentIndex: s,
    filteredOptions: g,
    context: i
  };
}, JS = "min-w-[160px] w-fit bg-white outline outline-1 top-px outline-purple-100 rounded-md z-10 mt-px text-sm overflow-y-auto p-1 max-h-[356px]", WS = (e) => uc(
  "hover:bg-indigo-50/50 transition-colors hover:cursor-pointer rounded-[5px] text-purple-900 px-2 flex items-center h-8 grow",
  e && "bg-indigo-50 hover:cursor-default hover:bg-indigo-50"
), _S = ({
  filteredOptions: e,
  currentIndex: t,
  onMentionClick: n,
  context: r
}) => {
  const a = Cc(r), { getFloatingProps: i } = Mc([a]);
  return /* @__PURE__ */ E(Mp, { children: /* @__PURE__ */ E(
    "div",
    {
      className: JS,
      ref: r.refs.setFloating,
      style: r.floatingStyles,
      ...i(),
      children: e.map((o, f) => {
        const { userId: s, name: u, email: c } = o;
        return /* @__PURE__ */ E(
          Wt,
          {
            content: /* @__PURE__ */ E(Ep, { id: s, name: u, email: c }),
            placement: "right",
            children: /* @__PURE__ */ ue(
              "div",
              {
                className: WS(t === f),
                onClick: () => n(o),
                ...i,
                children: [
                  /* @__PURE__ */ E(
                    Ap,
                    {
                      alt: `${u}-profile-avatar`,
                      size: 28,
                      name: u,
                      className: "w-4 h-4 mr-2 text-white text-[8px]",
                      colorSeed: s
                    }
                  ),
                  u
                ]
              },
              s
            )
          },
          s
        );
      })
    }
  ) });
};
var hn = {};
Object.defineProperty(hn, "__esModule", {
  value: !0
});
var ZS = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), cu = {
  alt: "altKey",
  control: "ctrlKey",
  meta: "metaKey",
  shift: "shiftKey"
}, bv = {
  add: "+",
  break: "pause",
  cmd: "meta",
  command: "meta",
  ctl: "control",
  ctrl: "control",
  del: "delete",
  down: "arrowdown",
  esc: "escape",
  ins: "insert",
  left: "arrowleft",
  mod: ZS ? "meta" : "control",
  opt: "alt",
  option: "alt",
  return: "enter",
  right: "arrowright",
  space: " ",
  spacebar: " ",
  up: "arrowup",
  win: "meta",
  windows: "meta"
}, el = {
  backspace: 8,
  tab: 9,
  enter: 13,
  shift: 16,
  control: 17,
  alt: 18,
  pause: 19,
  capslock: 20,
  escape: 27,
  " ": 32,
  pageup: 33,
  pagedown: 34,
  end: 35,
  home: 36,
  arrowleft: 37,
  arrowup: 38,
  arrowright: 39,
  arrowdown: 40,
  insert: 45,
  delete: 46,
  meta: 91,
  numlock: 144,
  scrolllock: 145,
  ";": 186,
  "=": 187,
  ",": 188,
  "-": 189,
  ".": 190,
  "/": 191,
  "`": 192,
  "[": 219,
  "\\": 220,
  "]": 221,
  "'": 222
};
for (var Ji = 1; Ji < 20; Ji++)
  el["f" + Ji] = 111 + Ji;
function vf(e, t, n) {
  t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
  var r = e.map(function(o) {
    return Cv(o, t);
  }), a = function(f) {
    return r.some(function(s) {
      return Mv(s, f);
    });
  }, i = n == null ? a : a(n);
  return i;
}
function $S(e, t) {
  return vf(e, t);
}
function VS(e, t) {
  return vf(e, { byKey: !0 }, t);
}
function Cv(e, t) {
  var n = t && t.byKey, r = {};
  e = e.replace("++", "+add");
  var a = e.split("+"), i = a.length;
  for (var o in cu)
    r[cu[o]] = !1;
  var f = !0, s = !1, u = void 0;
  try {
    for (var c = a[Symbol.iterator](), d; !(f = (d = c.next()).done); f = !0) {
      var g = d.value, p = g.endsWith("?") && g.length > 1;
      p && (g = g.slice(0, -1));
      var h = tl(g), l = cu[h];
      if (g.length > 1 && !l && !bv[g] && !el[h])
        throw new TypeError('Unknown modifier: "' + g + '"');
      (i === 1 || !l) && (n ? r.key = h : r.which = Dv(g)), l && (r[l] = p ? null : !0);
    }
  } catch (w) {
    s = !0, u = w;
  } finally {
    try {
      !f && c.return && c.return();
    } finally {
      if (s)
        throw u;
    }
  }
  return r;
}
function Mv(e, t) {
  for (var n in e) {
    var r = e[n], a = void 0;
    if (r != null && (n === "key" && t.key != null ? a = t.key.toLowerCase() : n === "which" ? a = r === 91 && t.which === 93 ? 91 : t.which : a = t[n], !(a == null && r === !1) && a !== r))
      return !1;
  }
  return !0;
}
function Dv(e) {
  e = tl(e);
  var t = el[e] || e.toUpperCase().charCodeAt(0);
  return t;
}
function tl(e) {
  return e = e.toLowerCase(), e = bv[e] || e, e;
}
hn.default = vf;
hn.isHotkey = vf;
hn.isCodeHotkey = $S;
var o1 = hn.isKeyHotkey = VS;
hn.parseHotkey = Cv;
hn.compareHotkey = Mv;
hn.toKeyCode = Dv;
hn.toKeyName = tl;
const KS = [
  {
    type: "paragraph",
    children: [
      {
        text: ""
      }
    ]
  }
], sx = ({
  initialValue: e = KS,
  readOnly: t,
  placeholder: n,
  onChange: r,
  floatingToolbar: a,
  style: i,
  editor: o,
  onBlur: f,
  onLinkClick: s,
  mentionOptions: u = [],
  autoFocus: c,
  mediaHandler: d,
  maxHeight: g,
  maxWidth: p
}) => {
  const h = pe((N) => /* @__PURE__ */ E(qA, { ...N, onLinkClick: s }), []), l = pe(
    (N) => /* @__PURE__ */ E(OM, { ...N }),
    []
  ), [w] = HS(o), {
    onEditorChange: m,
    onEditorKeyDown: y,
    currentIndex: b,
    onMentionClick: C,
    filteredOptions: M,
    showMentions: S,
    context: I
  } = QS({
    editor: w,
    options: u
  });
  return /* @__PURE__ */ E(
    IM,
    {
      editor: w,
      initialValue: e,
      onChange: (N) => {
        w.operations.some(
          (F) => F.type !== "set_selection"
        ) && (r == null || r(N)), m(N);
      },
      children: /* @__PURE__ */ ue(
        CL,
        {
          mediaHandler: d,
          maxHeight: g,
          maxWidth: p,
          children: [
            !t && (a ? /* @__PURE__ */ E(OS, {}) : /* @__PURE__ */ E(BS, { className: "mt-2" })),
            /* @__PURE__ */ E(
              bM,
              {
                className: "p-1 caret-purple-900 focus:outline-indigo-400 focus-visible:outline-indigo-400",
                renderElement: h,
                renderLeaf: l,
                placeholder: n,
                renderPlaceholder: ({ children: N, attributes: O }) => {
                  const F = { ...O.style };
                  return delete F.top, /* @__PURE__ */ E(
                    "span",
                    {
                      ...O,
                      className: "text-gray-400",
                      style: { ...F, opacity: 0.8 },
                      children: N
                    }
                  );
                },
                spellCheck: !0,
                autoFocus: c,
                readOnly: t,
                style: { ...i, minHeight: "48px" },
                onBlur: f,
                onKeyDown: (N) => {
                  y(N);
                  const { selection: O } = w;
                  if (O && z.isCollapsed(O)) {
                    const { nativeEvent: F } = N;
                    if (o1("left", F)) {
                      N.preventDefault(), H.move(w, { unit: "offset", reverse: !0 });
                      return;
                    }
                    if (o1("right", F)) {
                      N.preventDefault(), H.move(w, { unit: "offset" });
                      return;
                    }
                  }
                },
                onDOMBeforeInput: (N) => {
                  switch (N.inputType) {
                    case "formatBold":
                      return N.preventDefault(), no(w, "bold");
                    case "formatItalic":
                      return N.preventDefault(), no(w, "italic");
                    case "formatUnderline":
                      return N.preventDefault(), no(w, "underline");
                  }
                }
              }
            ),
            S && /* @__PURE__ */ E(
              _S,
              {
                currentIndex: b,
                onMentionClick: C,
                filteredOptions: M,
                context: I
              }
            )
          ]
        }
      )
    }
  );
};
function qS(e, t) {
  let n;
  return (...r) => {
    n || (e(r), n = setTimeout(() => n = void 0, t));
  };
}
const cx = ({
  targetId: e,
  engagementElement: t,
  placement: n,
  offsetX: r = 0,
  offsetY: a = 0
}) => {
  const [i, o] = ie({}), f = JSON.stringify(i);
  return le(() => {
    const s = () => {
      if (!e)
        return o({ top: a, left: r });
      const c = document.getElementById(e);
      if (c && t) {
        const d = c.getBoundingClientRect(), g = t.getBoundingClientRect();
        let p = 0, h = 0;
        switch (n) {
          case "top-start":
          case "top":
          case "top-end":
            p = d.top - g.height;
            break;
          case "left-start":
          case "right-start":
            p = d.top;
            break;
          case "left":
          case "right":
            p = d.top + Math.floor((d.height - g.height) / 2);
            break;
          case "left-end":
          case "right-end":
            p = d.top + (d.height - g.height);
            break;
          case "bottom-start":
          case "bottom":
          case "bottom-end":
            p = d.top + d.height;
            break;
        }
        switch (n) {
          case "left-start":
          case "left":
          case "left-end":
            h = d.left - g.width;
            break;
          case "top-start":
          case "bottom-start":
            h = d.left;
            break;
          case "top":
          case "bottom":
            h = d.left + Math.floor((d.width - g.width) / 2);
            break;
          case "top-end":
          case "bottom-end":
            h = d.left + (d.width - g.width);
            break;
          case "right-start":
          case "right":
          case "right-end":
            h = d.left + d.width;
            break;
        }
        p += a, h += r, o({
          top: p,
          left: h
        });
      }
    };
    s();
    const u = qS(s, 10);
    return document.addEventListener("scroll", u, !0), () => window.removeEventListener("scroll", u, !0);
  }, [
    t,
    n,
    r,
    a,
    e,
    f
  ]), i;
}, lx = [
  "top-left",
  "top",
  "top-right",
  "left",
  "center",
  "right",
  "bottom-left",
  "bottom",
  "bottom-right"
], dx = ({
  engagementElement: e,
  containerElement: t,
  modalPlacement: n = "center",
  offsetX: r = 0,
  offsetY: a = 0,
  type: i
}) => {
  const [o, f] = ie({}), s = JSON.stringify(o), {
    height: u = window.innerHeight,
    width: c = window.innerWidth
  } = (t == null ? void 0 : t.getBoundingClientRect()) || {}, { height: d = 0, width: g = 0 } = (e == null ? void 0 : e.getBoundingClientRect()) || {};
  return le(() => {
    const h = (() => {
      const l = a, w = a + Math.floor(u / 2) - Math.floor(d / 2), m = a + u - d, y = r, b = r + Math.floor(c / 2) - Math.floor(g / 2), C = r + c - g;
      switch (n) {
        case "top-left":
          return {
            top: l,
            left: y
          };
        case "top":
          return {
            top: l,
            left: b
          };
        case "top-right":
          return {
            top: l,
            left: C
          };
        case "left":
          return {
            top: w,
            left: y
          };
        case "center":
          return {
            top: w,
            left: b
          };
        case "right":
          return {
            top: w,
            left: C
          };
        case "bottom-left":
          return {
            top: m,
            left: y
          };
        case "bottom":
          return {
            top: m,
            left: b
          };
        case "bottom-right":
          return {
            top: m,
            left: C
          };
        default:
          return {
            top: w,
            left: b
          };
      }
    })();
    f(h);
  }, [
    t,
    u,
    c,
    e,
    d,
    g,
    n,
    r,
    a,
    s,
    i
  ]), o;
};
export {
  ro as A,
  aL as B,
  Hr as C,
  Ap as D,
  Ep as E,
  P2 as F,
  fL as G,
  qS as H,
  lx as I,
  sx as R,
  nE as S,
  Wt as T,
  Ie as _,
  qt as a,
  nr as b,
  Pe as c,
  Mp as d,
  ox as e,
  QD as f,
  No as g,
  Zo as h,
  rx as i,
  fx as j,
  KD as k,
  Cc as l,
  Mc as m,
  cx as n,
  dx as o,
  Zv as p,
  An as q,
  Se as r,
  nx as s,
  oe as t,
  ix as u,
  Ut as v,
  K4 as w,
  ax as x,
  YS as y,
  HS as z
};
